import {
  Facebook,
  HiristLogo2,
  Instagram,
  LinkedIn,
} from '@jobseeker/lotus/assets/images';

import {
  aiMl,
  backendDevelopment,
  cyberSecurity,
  dataAnalyticsAndBI,
  dataEngineering,
  devopsSre,
  emergingTechnologies,
  frontendDevelopment,
  fullStack,
  mobileApplication,
  platformEngineeringSreOracle,
  qualityAssurance,
} from '@jobseeker/lotus/assets/icons';
export const ABS_URL: string = process.env.ABS_URL || '';
export const s3Url: string =
  process.env.S3URL || 'https://staticlogo.hirist.com';
export const categoryOptions = [
  {id: 1, name: 'Category', alias: 'Category'},
  {id: 15, name: 'AI/ML', alias: 'AI/ML'},
  {id: 8, name: 'Data Analytics & BI', alias: 'Data Analytics & BI'},
  {id: 16, name: 'Data Engineering', alias: 'Data Engineering'},
  {id: 2, name: 'Backend Development', alias: 'Backend Development'},
  {id: 3, name: 'Frontend Development', alias: 'Frontend Development'},
  {id: 17, name: 'Full Stack', alias: 'Full Stack'},
  {id: 6, name: 'Mobile Applications', alias: 'Mobile Applications'},
  {id: 10, name: 'Emerging Technologies', alias: 'Emerging Technologies'},
  {id: 9, name: 'DevOps / SRE', alias: 'DevOps / SRE'},
  {id: 18, name: 'CyberSecurity', alias: 'CyberSecurity'},
  {id: 12, name: 'Quality Assurance', alias: 'Quality Assurance'},
  {
    id: 7,
    name: 'Platform Engineering / SAP/ Oracle',
    alias: 'Platform Engineering / SAP/ Oracle',
  },
  {id: 13, name: 'Product Management', alias: 'Product Management'},
  {
    id: 14,
    name: 'Business Analysis and Project Management',
    alias: 'Business Analysis and Project Management',
  },
  {id: 11, name: 'UI & Design', alias: 'UI & Design'},
  {id: 5, name: 'Semiconductor/VLSI/EDA', alias: 'Semiconductor/VLSI/EDA'},
  {id: 4, name: 'Others', alias: 'Others'},
];

export const methodOptions = [
  {id: 1, name: 'Method'},
  {id: 2, name: 'Online'},
  {id: 3, name: 'Blended'},
  {id: 4, name: 'Classroom'},
];

export const experienceOptions = [
  {id: 1, name: 'Any Exp. Level', minExp: 0, maxExp: 30},
  {id: 2, name: '0 - 1 yrs', minExp: 0, maxExp: 1},
  {id: 3, name: '2 - 3 yrs', minExp: 2, maxExp: 3},
  {id: 4, name: '4 - 6 yrs', minExp: 4, maxExp: 6},
  {id: 5, name: '7 - 10 yrs', minExp: 7, maxExp: 10},
  {id: 6, name: '11 - 15 yrs', minExp: 11, maxExp: 15},
  {id: 7, name: '16 - 20 yrs', minExp: 16, maxExp: 20},
  {id: 8, name: '21 - 25 yrs', minExp: 21, maxExp: 25},
  {id: 9, name: '26+ yrs', minExp: 26, maxExp: 30},
];

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

export const CompanyJobsLinkageUrlMapping: any = {
  Product: 'product-jobs',
  'E-Commerce': 'ecommerce-jobs',
  'Fintech/EdTech': 'fintech-edtech-jobs',
};

export const categories = [
  {
    id: 14,
    name: 'AI/ML',
    alias: 'AI/ML',
    icon: aiMl,
    tags: [
      {
        id: 898,
        name: 'Artificial Intelligence',
        alias: 'Artificial Intelligence Jobs',
      },
      {id: 203, name: 'Machine Learning', alias: 'Machine Learning Jobs'},
      {id: 357, name: 'NLP', alias: 'NLP Jobs'},
      {id: 135480, name: 'Generative AI', alias: 'Generative AI Jobs'},
      {
        id: 2916,
        name: 'Predictive Modeling',
        alias: 'Predictive Modeling Jobs',
      },
      {
        id: 198854,
        name: 'Query Segmentation',
        alias: 'Query Segmentation Jobs',
      },
      {id: 198855, name: 'AI Interface', alias: 'AI Interface Jobs'},
      {id: 131480, name: 'LLM', alias: 'LLM Jobs'},
      {id: 2512, name: 'Deep Learning', alias: 'Deep Learning Jobs'},
      {id: 133648, name: 'MLOps', alias: 'MLOps Jobs'},
      {
        id: 198856,
        name: 'Security Architect - AI',
        alias: 'Security Architect - AI Jobs',
      },
      {
        id: 198845,
        name: 'Cloud Architect - ML/AI',
        alias: 'Cloud Architect - ML/AI Jobs',
      },
      {id: 2023, name: 'Data Scientist', alias: 'Data Scientist Jobs'},
      {id: 2174, name: 'Data Modeling', alias: 'Data Modeling Jobs'},
    ],
  },
  {
    id: 7,
    name: 'Data Analytics & BI',
    alias: 'Data Analytics & BI',
    icon: dataAnalyticsAndBI,
    tags: [
      {id: 109, name: 'Analytics', alias: 'Analytics Jobs'},
      {id: 2183, name: 'Data Science', alias: 'Data Science Jobs'},
      {id: 783, name: 'Data Mining', alias: 'Data Mining Jobs'},
      {id: 600, name: 'Tableau', alias: 'Tableau Jobs'},
      {id: 2574, name: 'Power BI', alias: 'Power BI Jobs'},
      {
        id: 15663,
        name: 'Quantitative Analytics',
        alias: 'Quantitative Analytics Jobs',
      },
      {id: 2758, name: 'Data Visualization', alias: 'Data Visualization Jobs'},
      {id: 17730, name: 'Data Analyst', alias: 'Data Analyst Jobs'},
    ],
  },
  {
    id: 15,
    name: 'Data Engineering',
    alias: 'Data Engineering',
    icon: dataEngineering,
    tags: [
      {id: 170423, name: 'Data Engineering', alias: 'Data Engineering Jobs'},
      {id: 111, name: 'Big Data', alias: 'Big Data Jobs'},
      {id: 112, name: 'Hadoop', alias: 'Hadoop Jobs'},
      {id: 801, name: 'Hive', alias: 'Hive Jobs'},
      {id: 4606, name: 'BigQuery', alias: 'BigQuery Jobs'},
      {id: 362, name: 'ETL', alias: 'ETL Jobs'},
    ],
  },
  {
    id: 1,
    name: 'Backend Development',
    alias: 'Backend Development',
    icon: backendDevelopment,
    tags: [
      {id: 9, name: 'Python', alias: 'Python Jobs'},
      {id: 5, name: 'Java', alias: 'Java Jobs'},
      {id: 1756, name: 'GoLang', alias: 'GoLang Jobs'},
      {id: 989, name: 'R', alias: 'R Jobs'},
      {id: 50, name: 'Django', alias: 'Django Jobs'},
      {id: 434, name: 'NodeJs', alias: 'NodeJs Jobs'},
      {id: 46, name: 'Spring', alias: 'Spring Jobs'},
      {id: 47, name: 'Hibernate', alias: 'Hibernate Jobs'},
    ],
  },
  {
    id: 2,
    name: 'Frontend Development',
    alias: 'Frontend Development',
    icon: frontendDevelopment,
    tags: [
      {id: 2043, name: 'ReactJS', alias: 'ReactJS Jobs'},
      {id: 1372, name: 'AngularJS', alias: 'AngularJS Jobs'},
      {id: 26, name: 'Javascript', alias: 'Javascript Jobs'},
      {id: 61, name: 'JQuery', alias: 'JQuery Jobs'},
      {id: 1616, name: 'Bootstrap', alias: 'Bootstrap Jobs'},
      {id: 49, name: 'UI', alias: 'UI Jobs'},
      {id: 2, name: 'UX', alias: 'UX Jobs'},
    ],
  },
  {
    id: 16,
    name: 'Full Stack',
    alias: 'Full Stack',
    icon: fullStack,
    tags: [
      {id: 1612, name: 'Full Stack', alias: 'Full Stack Jobs'},
      {id: 2696, name: 'MERN Stack', alias: 'MERN Stack Jobs'},
      {id: 81, name: 'LAMP', alias: 'LAMP Jobs'},
      {id: 1900, name: 'MEAN', alias: 'MEAN Jobs'},
      {id: 434, name: 'Node.JS', alias: 'Node.JS Jobs'},
      {id: 2043, name: 'React.js', alias: 'React.js Jobs'},
      {id: 2594, name: 'RESTful API', alias: 'RESTful API Jobs'},
    ],
  },
  {
    id: 5,
    name: 'Mobile Applications',
    alias: 'Mobile Applications',
    icon: mobileApplication,
    tags: [
      {id: 63, name: 'iOS', alias: 'iOS Jobs'},
      {id: 56, name: 'Android', alias: 'Android Jobs'},
      {id: 2458, name: 'React Native', alias: 'React Native Jobs'},
      {id: 2258, name: 'Ionic', alias: 'Ionic Jobs'},
      {id: 68, name: 'Phonegap', alias: 'Phonegap Jobs'},
      {id: 1411, name: 'Xamarin', alias: 'Xamarin Jobs'},
      {id: 1006, name: 'OpenGL', alias: 'OpenGL Jobs'},
    ],
  },
  {
    id: 9,
    name: 'Emerging Technologies',
    alias: 'Emerging Technologies',
    icon: emergingTechnologies,
    tags: [
      {id: 2240, name: 'Blockchain', alias: 'Blockchain Jobs'},
      {id: 2633, name: 'Cryptocurrency', alias: 'Cryptocurrency Jobs'},
      {id: 2211, name: 'Augmented Reality', alias: 'Augmented Reality Jobs'},
      {id: 2672, name: 'Virtual Reality', alias: 'Virtual Reality Jobs'},
      {id: 1641, name: 'iOT', alias: 'iOT Jobs'},
    ],
  },
  {
    id: 8,
    name: 'DevOps/SRE',
    alias: 'DevOps / SRE',
    icon: devopsSre,
    tags: [
      {id: 2564, name: 'Site Reliability', alias: 'Site Reliability Jobs'},
      {id: 58, name: 'AWS', alias: 'AWS Jobs'},
      {id: 1239, name: 'AZURE', alias: 'AZURE Jobs'},
      {id: 2266, name: 'Cloud Architect', alias: 'Cloud Architect Jobs'},
      {id: 2631, name: 'Docker', alias: 'Docker Jobs'},
      {id: 2021, name: 'Puppet', alias: 'Puppet Jobs'},
      {id: 1551, name: 'Jenkins', alias: 'Jenkins Jobs'},
      {id: 2020, name: 'Chef', alias: 'Chef Jobs'},
      {id: 2661, name: 'Kubernetes', alias: 'Kubernetes Jobs'},
      {
        id: 3830,
        name: 'Google Cloud Platform',
        alias: 'Google Cloud Platform Jobs',
      },
    ],
  },
  {
    id: 17,
    name: 'CyberSecurity',
    alias: 'CyberSecurity',
    icon: cyberSecurity,
    tags: [
      {id: 2639, name: 'Cyber Security', alias: 'Cyber Security Jobs'},
      {id: 2584, name: 'Cloud Security', alias: 'Cloud Security Jobs'},
      {id: 2514, name: 'CISSP', alias: 'CISSP Jobs'},
      {id: 2630, name: 'CISM', alias: 'CISM Jobs'},
      {
        id: 1851,
        name: 'Information Security',
        alias: 'Information Security Jobs',
      },
      {id: 2623, name: 'Data Security', alias: 'Data Security Jobs'},
      {
        id: 3424,
        name: 'IT Security Strategy',
        alias: 'IT Security Strategy Jobs',
      },
      {id: 2610, name: 'Network Security', alias: 'Network Security Jobs'},
      {id: 1103, name: 'Firewall', alias: 'Firewall Jobs'},
      {id: 452, name: 'IAM', alias: 'IAM Jobs'},
      {id: 1174, name: 'Sailpoint', alias: 'Sailpoint Jobs'},
    ],
  },
  {
    id: 11,
    name: 'Quality Assurance',
    alias: 'Quality Assurance',
    icon: qualityAssurance,
    tags: [
      {
        id: 2489,
        name: 'Performance Testing',
        alias: 'Performance Testing Jobs',
      },
      {
        id: 2842,
        name: 'Application Testing',
        alias: 'Application Testing Jobs',
      },
      {id: 38, name: 'White Box Testing', alias: 'White Box Testing Jobs'},
      {id: 2484, name: 'Security Testing', alias: 'Security Testing Jobs'},
      {id: 2917, name: 'Load Testing', alias: 'Load Testing Jobs'},
      {id: 2056, name: 'Mobile Testing', alias: 'Mobile Testing Jobs'},
      {
        id: 9402,
        name: 'Automation Testing Tools',
        alias: 'Automation Testing Tools Jobs',
      },
      {id: 353, name: 'Selenium', alias: 'Selenium Jobs'},
      {id: 2202, name: 'Test Architect', alias: 'Test Architect Jobs'},
    ],
  },
  {
    id: 6,
    name: 'Platform Engineering/SAP/Oracle',
    alias: 'Platform Engineering / SAP/ Oracle',
    icon: platformEngineeringSreOracle,
    tags: [
      {id: 455, name: 'Pega', alias: 'Pega Jobs'},
      {id: 2234, name: 'RPA', alias: 'RPA Jobs'},
      {id: 178, name: 'ERP', alias: 'ERP Jobs'},
      {id: 195, name: 'SAP FICO', alias: 'SAP FICO Jobs'},
      {id: 446, name: 'CRM', alias: 'CRM Jobs'},
      {id: 2632, name: 'SAP Implementation', alias: 'SAP Implementation Jobs'},
      {
        id: 2905,
        name: 'Techno-Functional Consultant',
        alias: 'Techno-Functional Consultant Jobs',
      },
      {id: 51, name: 'Salesforce', alias: 'Salesforce Jobs'},
      {id: 58309, name: 'Integration Tools', alias: 'Integration Tools Jobs'},
      {id: 268, name: 'Sharepoint', alias: 'Sharepoint Jobs'},
      {id: 6588, name: 'PowerApps', alias: 'PowerApps Jobs'},
      {id: 334, name: 'Oracle Apps', alias: 'Oracle Apps Jobs'},
      {id: 174, name: 'Presales', alias: 'Presales Jobs'},
      {id: 175, name: 'Solution Design', alias: 'Solution Design Jobs'},
      {id: 29, name: 'Solution Architect', alias: 'Solution Architect Jobs'},
      {id: 112953, name: 'LCDP', alias: 'LCDP Jobs'},
      {id: 333, name: 'Mainframe', alias: 'Mainframe Jobs'},
      {id: 379, name: 'Informatica', alias: 'Informatica Jobs'},
    ],
  },
  {
    id: 12,
    name: 'Product Management',
    alias: 'Product Management',
    tags: [
      {id: 6046, name: 'Product Strategy', alias: 'Product Strategy Jobs'},
      {id: 2910, name: 'Product Roadmap', alias: 'Product Roadmap Jobs'},
      {
        id: 14892,
        name: 'Chief Product Officer',
        alias: 'Chief Product Officer Jobs',
      },
      {id: 14796, name: 'UX Strategy', alias: 'UX Strategy Jobs'},
      {id: 2933, name: 'User Story', alias: 'User Story Jobs'},
      {id: 1284, name: 'Wireframe', alias: 'Wireframe Jobs'},
      {id: 3339, name: 'Storyboard', alias: 'Storyboard Jobs'},
      {id: 1571, name: 'Jira', alias: 'Jira Jobs'},
    ],
  },
  {
    id: 13,
    name: 'Business Analysis and Project Management',
    alias: 'Business Analysis and Project Management',
    tags: [
      {id: 30, name: 'Project Management', alias: 'Project Management Jobs'},
      {id: 156, name: 'Business Analyst', alias: 'Business Analyst Jobs'},
      {
        id: 2905,
        name: 'Techno-Functional Consultant',
        alias: 'Techno-Functional Consultant Jobs',
      },
      {id: 98, name: 'Program Management', alias: 'Program Management Jobs'},
      {id: 592, name: 'Agile', alias: 'Agile Jobs'},
      {id: 280, name: 'Scrum', alias: 'Scrum Jobs'},
      {id: 24, name: 'PMP', alias: 'PMP Jobs'},
    ],
  },
  {
    id: 10,
    name: 'UI & Design',
    alias: 'UI & Design',
    tags: [
      {id: 49, name: 'UI', alias: 'UI Jobs'},
      {id: 2, name: 'UX', alias: 'UX Jobs'},
      {id: 536, name: 'Photoshop', alias: 'Photoshop Jobs'},
      {id: 863, name: 'Illustrator', alias: 'Illustrator Jobs'},
      {id: 1728, name: 'Infographics', alias: 'Infographics Jobs'},
      {id: 1000, name: 'CorelDRAW', alias: 'CorelDRAW Jobs'},
      {id: 859, name: 'InDesign', alias: 'InDesign Jobs'},
      {id: 2590, name: 'Sketch', alias: 'Sketch Jobs'},
      {id: 4716, name: 'Figma', alias: 'Figma Jobs'},
      {id: 3238, name: 'Interaction Design', alias: 'Interaction Design Jobs'},
    ],
  },
  {
    id: 4,
    name: 'Semiconductor/VLSI/EDA',
    alias: 'Semiconductor/VLSI/EDA',
    tags: [
      {id: 402, name: 'MATLAB', alias: 'MATLAB Jobs'},
      {id: 191, name: 'Verilog', alias: 'Verilog Jobs'},
      {id: 426, name: 'RTL', alias: 'RTL Jobs'},
      {id: 549, name: 'ASIC', alias: 'ASIC Jobs'},
      {id: 116, name: 'Physical Design', alias: 'Physical Design Jobs'},
      {id: 104, name: 'System Verilog', alias: 'System Verilog Jobs'},
      {id: 197, name: 'VHDL', alias: 'VHDL Jobs'},
      {id: 619, name: 'Board Design', alias: 'Board Design Jobs'},
      {id: 100, name: 'VLSI', alias: 'VLSI Jobs'},
    ],
  },
  {
    id: 3,
    name: 'Others',
    alias: 'Others',
    tags: [
      {id: 794, name: 'IT Operations', alias: 'IT Operations Jobs'},
      {id: 530, name: 'Technical Support', alias: 'Technical Support Jobs'},
      {
        id: 90,
        name: 'System Administration',
        alias: 'System Administration Jobs',
      },
      {id: 2831, name: 'DBMS', alias: 'DBMS Jobs'},
      {id: 66, name: 'DBA', alias: 'DBA Jobs'},
      {id: 39, name: 'IT Infrastructure', alias: 'IT Infrastructure Jobs'},
      {id: 417, name: 'Technical Writing', alias: 'Technical Writing Jobs'},
      {id: 177, name: 'SEO', alias: 'SEO Jobs'},
      {id: 6311, name: 'Network Support', alias: 'Network Support Jobs'},
      {id: 547, name: 'ITIL', alias: 'ITIL Jobs'},
      {id: 939, name: 'Incident Management', alias: 'Incident Management Jobs'},
      {id: 1230, name: 'Change Management', alias: 'Change Management Jobs'},
      {id: 2232, name: 'ITSM', alias: 'ITSM Jobs'},
    ],
  },
];
export const jobColors = [
  '#75ce93',
  '#459bd0',
  '#b4b9d8',
  '#f2998f',
  '#a877e8',
  '#4fb6ac',
];

const Upstox = `Upstox-160X35`;
const Paytm = `Paytm-160X35`;
const Policybazaar = `Policybazaar-160X35`;
const Rapido = `Rapido-160X35`;
const Redbus = `Redbus-160X35`;
const Smartcoin = `Smartcoin-160X35`;
const Snapdeal = `Snapdeal-160X35`;
const Swiggy = `Swiggy-160X35`;
const Hike = `Hike-160X35`;
const Lendingkart = `Lendingkart-160X35`;
const Makemytrip = `Makemytrip-160X35`;
const Meesho = `Meesho-160X35`;
const Mobikwik = `Mobikwik-160X35`;
const Myntra = `Myntra-160X35`;
const Ola = `Ola-160X35`;
const Oyo = `Oyo-160X35`;
const Amazon = `Amazon-160X35`;
const Bookmyshow = `Bookmyshow-160X35`;
const Dream11 = `Dream11-160X35`;
const Firstcry = `Firstcry-160X35`;
const Freecharge = `Freecharge-160X35`;
const Flipkart = `Flipkart-160X35`;
const GSNgames = `GSNgames-160X35`;
const Onemg = `1mg-160X35`;

// Tech Drive Logos

// const bosh = "Bosh";
// const makeMyTrip = "Make-My-Trip";
// const americanExpress = "American-Express";
// const ramsoft = "Ramsoft";
// const stateStreet = "State-Street";
// const cashfree = "Cashfree";
// const oracle = "Oracle";
// const titan = "Titan";
// const moengage = "Moengage";
// const powerschool = "Powerschool";
// const haleon = "Haleon";
// const exxonmobil = "Exxonmobil";
// const miqDigital = "MiQ+digital";
// const mphasis = "Mphasis";

// New Tech Drive Logos

const americanExpress = 'American+Express-150X70';
const bosch = 'Bosch-150X70';
const deloitte = 'Deloitte-150X70';
const deltaAirlines = 'Delta+Airlines-150X70';
const exxonMobil = 'Exxon+Mobil-150X70';
const games247 = 'Games+247-150X70';
const haleon = 'Haleon-150X70';
const shareChat = 'ShareChat-150X70';
const tesco = 'Tesco-150X70';
const wiproTechnologies = 'Wipro+Technologies-150X70';

export const IconTag = [
  {
    CompanyIconTag: Flipkart,
  },
  {
    CompanyIconTag: Paytm,
  },
  {
    CompanyIconTag: Amazon,
  },
  {
    CompanyIconTag: Swiggy,
  },
  {
    CompanyIconTag: Ola,
  },
  {
    CompanyIconTag: Oyo,
  },
  {
    CompanyIconTag: Redbus,
  },
  {
    CompanyIconTag: Makemytrip,
  },
  {
    CompanyIconTag: Myntra,
  },
  {
    CompanyIconTag: Snapdeal,
  },
  {
    CompanyIconTag: Mobikwik,
  },
  {
    CompanyIconTag: Hike,
  },
  {
    CompanyIconTag: Policybazaar,
  },
  {
    CompanyIconTag: Freecharge,
  },
  {
    CompanyIconTag: Bookmyshow,
  },
  {
    CompanyIconTag: Firstcry,
  },
  {
    CompanyIconTag: Rapido,
  },
  {
    CompanyIconTag: Meesho,
  },
  {
    CompanyIconTag: Smartcoin,
  },
  {
    CompanyIconTag: Upstox,
  },
  {
    CompanyIconTag: Lendingkart,
  },
  {
    CompanyIconTag: Onemg,
  },
  {
    CompanyIconTag: GSNgames,
  },
  {
    CompanyIconTag: Dream11,
  },
];

export const TechDriveIconTag = [
  {
    CompanyIconTag: americanExpress,
  },
  {
    CompanyIconTag: bosch,
  },
  {
    CompanyIconTag: deloitte,
  },
  {
    CompanyIconTag: deltaAirlines,
  },
  {
    CompanyIconTag: exxonMobil,
  },
  {
    CompanyIconTag: games247,
  },
  {
    CompanyIconTag: haleon,
  },
  {
    CompanyIconTag: shareChat,
  },
  {
    CompanyIconTag: tesco,
  },
  {
    CompanyIconTag: wiproTechnologies,
  },
];
export const words = [
  'Machine Learning',
  'iOS Developer',
  'Android Developer',
  'ReactJS Developer',
  'Data Scientist',
  'AngularJS Developer',
  'AWS Engineer',
  'Python Developer',
  'Blockchain Engineer',
  'DevOps Engineer',
  'Artificial Intelligence',
  'iOT Engineer',
  'UX Designer',
  'Augmented Reality',
  'Java Developer',
  'Virtual Reality',
  'Golang Developer',
  'Ruby on Rails',
  'NodeJS Developer',
  'Python/Django',
  'Data Analytics',
  'Big Data Engineer',
  'NLP',
  'Project Management',
];
export const footerCityJobsData = [
  {
    colCount: 7,
    heading: 'Jobs by location',
    data: [
      {link: `${ABS_URL}/it-jobs-in-bangalore`, text: 'Jobs in Bangalore'},
      {link: `${ABS_URL}/it-jobs-in-delhi-ncr`, text: 'Jobs in Delhi/NCR'},
      {link: `${ABS_URL}/it-jobs-in-noida`, text: 'Jobs in Noida'},
      {
        link: `${ABS_URL}/it-jobs-in-gurgaon-gurugram`,
        text: 'Jobs in Gurgaon/Gurugram',
      },
      {link: `${ABS_URL}/it-jobs-in-mumbai`, text: 'Jobs in Mumbai'},
      {link: `${ABS_URL}/it-jobs-in-pune`, text: 'Jobs in Pune'},
      {link: `${ABS_URL}/it-jobs-in-hyderabad`, text: 'Jobs in Hyderabad'},
      {link: `${ABS_URL}/it-jobs-in-chennai`, text: 'Jobs in Chennai'},
      {
        link: `${ABS_URL}/it-jobs-in-coimbatore`,
        text: 'Jobs in Coimbatore',
      },
      {link: `${ABS_URL}/it-jobs-in-kolkata`, text: 'Jobs in Kolkata'},
      {link: `${ABS_URL}/it-jobs-in-indore`, text: 'Jobs in Indore'},
      {link: `${ABS_URL}/it-jobs-in-jaipur`, text: 'Jobs in Jaipur'},
      {
        link: `${ABS_URL}/it-jobs-in-chandigarh`,
        text: 'Jobs in Chandigarh',
      },
    ],
  },
  {
    colCount: 7,
    heading: 'Jobs by Domain',
    data: [
      {
        link: `${ABS_URL}/product-jobs`,
        text: 'Jobs from Product Companies',
      },
      {
        link: `${ABS_URL}/ecommerce-jobs`,
        text: 'Jobs from E-commerce Companies',
      },
      {
        link: `${ABS_URL}/fintech-edtech-jobs`,
        text: 'Jobs from Fin-tech Companies',
      },
    ],
  },
  {
    colCount: 7,
    heading: 'Jobs by Categories',
    data: [
      {
        link: `${ABS_URL}/c/backend-developer-jobs`,
        text: 'Jobs in Backend Development',
      },
      {
        link: `${ABS_URL}/c/frontend-developer-jobs`,
        text: 'Jobs in Frontend Development',
      },
      {
        link: `${ABS_URL}/c/analytics-data-science-jobs`,
        text: 'Jobs in Analytics & Data Science',
      },
      {
        link: `${ABS_URL}/c/mobile-applications-jobs`,
        text: 'Jobs in Mobile Application',
      },
      {
        link: `${ABS_URL}/c/devops-jobs`,
        text: 'Jobs in Devops Jobs in Emerging tech',
      },
    ],
  },
];

const hiristOldLogoS3Url = `${s3Url}/webp/hirist-tech-logo.webp`;
const hiristNewLogoS3Url =
  'https://hirist-assets.s3.ap-south-1.amazonaws.com/hirist-tech-logo-new.webp';
export const socialData = [
  {
    link: ABS_URL + '/',
    img: {
      src: HiristLogo2,
      alt: 'HIRIST.TECH',
      class: 'logo2-img-list',
      height: 60,
      width: 60,
    },
  },
  {
    link: ABS_URL + '/',
    img: {
      src: hiristNewLogoS3Url,
      alt: 'HIRIST.TECH',
      class: 'logo-img-list',
      height: 35,
      width: 135,
    },
  },
];

export const socialLinks = [
  {
    link: 'https://www.linkedin.com/company/hirist-com/',
    src: LinkedIn,
    alt: 'linkedIn',
  },
  {
    link: 'https://www.facebook.com/hirist.jobs',
    src: Facebook,
    alt: 'facebook',
  },
  {
    link: 'https://www.instagram.com/hirist.tech/',
    src: Instagram,
    alt: 'instagram',
  },
];

export const LOCATIONS = [
  {value: 1, label: 'Ahmedabad'},
  {value: 2, label: 'Bengaluru / Bangalore'},
  {value: 41, label: 'Chandigarh'},
  {value: 3, label: 'Chennai'},
  {value: 221, label: 'Delhi'},
  {value: 5, label: 'Gurgaon / Gurugram'},
  {value: 6, label: 'Hyderabad'},
  {value: 7, label: 'Kolkata'},
  {value: 8, label: 'Mumbai'},
  {value: 9, label: 'Noida'},
  {value: 10, label: 'Pune'},
  {value: 62, label: 'Guntur'},
  {value: 82, label: 'Kakinada'},
  {value: 98, label: 'Kurnool'},
  {value: 113, label: 'Nellore'},
  {value: 114, label: 'Nizamabad'},
  {value: 150, label: 'Tirupati'},
  {value: 160, label: 'Vijayawada'},
  {value: 161, label: 'Visakhapatnam'},
  {value: 162, label: 'Warangal'},
  {value: 222, label: 'Anantapur'},
  {value: 223, label: 'Guntakal'},
  {value: 225, label: 'Rajahmundry'},
  {value: 226, label: 'Secunderabad'},
  {value: 227, label: 'Andhra Pradesh - Other'},
  {value: 72, label: 'Itanagar'},
  {value: 228, label: 'Arunachal Pradesh - Other'},
  {value: 51, label: 'Dispur'},
  {value: 63, label: 'Guwahati'},
  {value: 140, label: 'Silchar'},
  {value: 229, label: 'Assam - Other'},
  {value: 34, label: 'Bhilaigarh'},
  {value: 122, label: 'Patna'},
  {value: 230, label: 'Bihar - Other'},
  {value: 26, label: 'Bhagalpur'},
  {value: 39, label: 'Bilaspur'},
  {value: 128, label: 'Raipur'},
  {value: 231, label: 'Bhillai'},
  {value: 232, label: 'Chhattisgarh - Other'},
  {value: 59, label: 'Goa'},
  {value: 233, label: 'Panaji'},
  {value: 235, label: 'Vasco Da Gama'},
  {value: 236, label: 'Goa - Other'},
  {value: 21, label: 'Anand'},
  {value: 22, label: 'Ankleshwar'},
  {value: 31, label: 'Bharuch'},
  {value: 33, label: 'Bhavnagar'},
  {value: 37, label: 'Bhuj'},
  {value: 56, label: 'Gandhinagar'},
  {value: 79, label: 'Jamnagar'},
  {value: 83, label: 'Kandla'},
  {value: 124, label: 'Porbandar'},
  {value: 130, label: 'Rajkot'},
  {value: 145, label: 'Surat'},
  {value: 155, label: 'Vadodara'},
  {value: 156, label: 'Valsad'},
  {value: 157, label: 'Vapi'},
  {value: 238, label: 'Gir'},
  {value: 239, label: 'Gujarat - Other'},
  {value: 19, label: 'Ambala'},
  {value: 55, label: 'Faridabad'},
  {value: 66, label: 'Hisar'},
  {value: 86, label: 'Karnal'},
  {value: 99, label: 'Kurukshetra'},
  {value: 117, label: 'Panipat'},
  {value: 132, label: 'Rohtak'},
  {value: 143, label: 'Sonipat / Sonepat'},
  {value: 164, label: 'Yamunanagar'},
  {value: 242, label: 'Haryana - Other'},
  {value: 25, label: 'Baddi'},
  {value: 45, label: 'Dalhousie'},
  {value: 49, label: 'Dharamsala'},
  {value: 97, label: 'Kulu/Manali'},
  {value: 137, label: 'Shimla'},
  {value: 244, label: 'Himachal Pradesh - Other'},
  {value: 78, label: 'Jammu'},
  {value: 144, label: 'Srinagar'},
  {value: 245, label: 'Jammu & Kashmir - Other'},
  {value: 40, label: 'Bokaro'},
  {value: 48, label: 'Dhanbad'},
  {value: 80, label: 'Jamshedpur'},
  {value: 131, label: 'Ranchi'},
  {value: 246, label: 'Jharkhand - Other'},
  {value: 29, label: 'Belgaum'},
  {value: 30, label: 'Bellary'},
  {value: 38, label: 'Bidar'},
  {value: 50, label: 'Dharwad'},
  {value: 61, label: 'Gulbarga'},
  {value: 68, label: 'Hubli'},
  {value: 91, label: 'Kolar'},
  {value: 104, label: 'Mangalore'},
  {value: 109, label: 'Mysore'},
  {value: 138, label: 'Shimoga'},
  {value: 248, label: 'Karnataka - Other'},
  {value: 16, label: 'Alappuzha / Alleppey'},
  {value: 42, label: 'Cochin / Kochi / Ernakulam'},
  {value: 69, label: 'Idukki'},
  {value: 84, label: 'Kannur'},
  {value: 87, label: 'Kasargod'},
  {value: 93, label: 'Kollam'},
  {value: 95, label: 'Kottayam'},
  {value: 96, label: 'Kozhikode / Calicut'},
  {value: 103, label: 'Malappuram'},
  {value: 119, label: 'Pathanamthitta'},
  {value: 147, label: 'Thrissur / Trissur'},
  {value: 148, label: 'Thiruvananthapuram / Trivandrum'},
  {value: 163, label: 'Wayanad'},
  {value: 249, label: 'Palakkad'},
  {value: 250, label: 'Palghat'},
  {value: 251, label: 'Kerala - Other'},
  {value: 35, label: 'Bhopal'},
  {value: 64, label: 'Gwalior'},
  {value: 71, label: 'Indore'},
  {value: 73, label: 'Jabalpur'},
  {value: 154, label: 'Ujjain'},
  {value: 252, label: 'Madhya Pradesh - Other'},
  {value: 13, label: 'Ahmednagar'},
  {value: 24, label: 'Aurangabad'},
  {value: 77, label: 'Jalgaon'},
  {value: 92, label: 'Kolhapur'},
  {value: 111, label: 'Nagpur'},
  {value: 112, label: 'Nasik'},
  {value: 254, label: 'Mumbai Suburbs'},
  {value: 255, label: 'Navi Mumbai'},
  {value: 257, label: 'Solapur'},
  {value: 258, label: 'Maharashtra - Other'},
  {value: 70, label: 'Imphal'},
  {value: 259, label: 'Manipur - Other'},
  {value: 136, label: 'Shillong'},
  {value: 260, label: 'Meghalaya - Other'},
  {value: 14, label: 'Aizawal'},
  {value: 261, label: 'Mizoram - Other'},
  {value: 90, label: 'Kohima'},
  {value: 262, label: 'Dimapur'},
  {value: 263, label: 'Nagaland - Other'},
  {value: 36, label: 'Bhubaneshwar'},
  {value: 44, label: 'Cuttack'},
  {value: 118, label: 'Paradeep'},
  {value: 126, label: 'Puri'},
  {value: 134, label: 'Rourkela'},
  {value: 264, label: 'Odisha - Other'},
  {value: 20, label: 'Amritsar'},
  {value: 76, label: 'Jalandhar'},
  {value: 101, label: 'Ludhiana'},
  {value: 107, label: 'Mohali'},
  {value: 120, label: 'Pathankot'},
  {value: 121, label: 'Patiala'},
  {value: 265, label: 'Bathinda'},
  {value: 267, label: 'Punjab - Other'},
  {value: 15, label: 'Ajmer'},
  {value: 74, label: 'Jaipur'},
  {value: 75, label: 'Jaisalmer'},
  {value: 81, label: 'Jodhpur'},
  {value: 94, label: 'Kota'},
  {value: 153, label: 'Udaipur'},
  {value: 268, label: 'Rajasthan - Other'},
  {value: 57, label: 'Gangtok'},
  {value: 269, label: 'Sikkim - Other'},
  {value: 43, label: 'Coimbatore'},
  {value: 53, label: 'Erode'},
  {value: 67, label: 'Hosur'},
  {value: 102, label: 'Madurai'},
  {value: 110, label: 'Nagercoil'},
  {value: 115, label: 'Ooty'},
  {value: 135, label: 'Salem'},
  {value: 146, label: 'Thanjavur'},
  {value: 149, label: 'Tirunalveli'},
  {value: 151, label: 'Trichy'},
  {value: 152, label: 'Tuticorin'},
  {value: 159, label: 'Vellore'},
  {value: 271, label: 'Cuddalore'},
  {value: 272, label: 'Tamil Nadu - Other'},
  {value: 11, label: 'Agartala'},
  {value: 273, label: 'Tripura - Other'},
  {value: 46, label: 'Daman'},
  {value: 88, label: 'Kavaratti'},
  {value: 123, label: 'Pondicherry'},
  {value: 125, label: 'Port Blair'},
  {value: 142, label: 'Silvassa'},
  {value: 275, label: 'Dadra & Nagar Haveli'},
  {value: 12, label: 'Agra'},
  {value: 17, label: 'Aligarh'},
  {value: 18, label: 'Allahabad'},
  {value: 27, label: 'Bareilly'},
  {value: 54, label: 'Faizabad'},
  {value: 58, label: 'Ghaziabad'},
  {value: 60, label: 'Gorakhpur'},
  {value: 85, label: 'Kanpur'},
  {value: 100, label: 'Lucknow'},
  {value: 105, label: 'Mathura'},
  {value: 106, label: 'Meerut'},
  {value: 108, label: 'Moradabad'},
  {value: 158, label: 'Varanasi'},
  {value: 278, label: 'Uttar Pradesh - Other'},
  {value: 47, label: 'Dehradun'},
  {value: 133, label: 'Roorkee'},
  {value: 279, label: 'Uttaranchal - Other'},
  {value: 23, label: 'Asansol'},
  {value: 52, label: 'Durgapur'},
  {value: 65, label: 'Haldia'},
  {value: 89, label: 'Kharagpur'},
  {value: 141, label: 'Siliguri'},
  {value: 281, label: 'West Bengal - Other'},
  {value: 165, label: 'Other India'},
  {value: 127, label: 'Quilon'},
  {value: 166, label: 'Australia'},
  {value: 167, label: 'Bahrain'},
  {value: 168, label: 'Bangladesh'},
  {value: 169, label: 'Belgium'},
  {value: 170, label: 'Canada'},
  {value: 171, label: 'China'},
  {value: 214, label: 'Doha'},
  {value: 215, label: 'Dubai'},
  {value: 172, label: 'Egypt'},
  {value: 173, label: 'France'},
  {value: 174, label: 'Germany'},
  {value: 175, label: 'Gulf'},
  {value: 176, label: 'Hongkong'},
  {value: 177, label: 'Indonesia'},
  {value: 216, label: 'INDIA'},
  {value: 178, label: 'Ireland'},
  {value: 217, label: 'Italy'},
  {value: 179, label: 'Japan'},
  {value: 180, label: 'Jordan'},
  {value: 218, label: 'Kenya'},
  {value: 181, label: 'Kuwait'},
  {value: 182, label: 'Lebanon'},
  {value: 219, label: 'Libya'},
  {value: 183, label: 'Macau'},
  {value: 184, label: 'Malaysia'},
  {value: 185, label: 'Maldives'},
  {value: 186, label: 'Mauritius'},
  {value: 187, label: 'Mexico'},
  {value: 188, label: 'Nepal'},
  {value: 189, label: 'Netherlands'},
  {value: 190, label: 'New Zealand'},
  {value: 220, label: 'Norway'},
  {value: 191, label: 'Oman'},
  {value: 192, label: 'Pakistan'},
  {value: 193, label: 'Philippines'},
  {value: 194, label: 'Qatar'},
  {value: 195, label: 'Russia'},
  {value: 196, label: 'Saudi Arabia'},
  {value: 197, label: 'Singapore'},
  {value: 198, label: 'South Africa'},
  {value: 199, label: 'South Korea'},
  {value: 200, label: 'Spain'},
  {value: 201, label: 'SriLanka'},
  {value: 202, label: 'Sweden'},
  {value: 203, label: 'Switzerland'},
  {value: 204, label: 'Taiwan'},
  {value: 205, label: 'Thailand'},
  {value: 206, label: 'United Kingdom'},
  {value: 207, label: 'United Arab Emirates'},
  {value: 208, label: 'United States'},
  {value: 209, label: 'Vietnam'},
  {value: 210, label: 'Yemen'},
  {value: 211, label: 'Zimbabwe'},
  {value: 282, label: 'Luxembourg'},
  {value: 212, label: 'Other International'},
  {value: 213, label: 'Anywhere'},
];

export const LEARN_GROW_COURSE_ENQUIRY_PROFILE_COMPLETION = 'lng';

export const HIRISTORGANISATION = [
  // {
  //   label: 'N/A',
  //   value: 1,
  // },
  {
    label: 'Infosys',
    value: 2,
  },
  {
    label: 'ICICI Bank',
    value: 3,
  },
  {
    label: 'TCS',
    value: 4,
  },
  {
    label: 'Wipro',
    value: 5,
  },
  {
    label: 'Deloitte',
    value: 6,
  },
  {
    label: 'HDFC Bank',
    value: 7,
  },
  {
    label: 'HCL Technologies',
    value: 8,
  },
  {
    label: 'Cognizant Technology Solutions',
    value: 9,
  },
  {
    label: 'IBM',
    value: 10,
  },
  {
    label: 'Ernst & Young',
    value: 11,
  },
  {
    label: 'HSBC',
    value: 12,
  },
  {
    label: 'Accenture',
    value: 13,
  },
  {
    label: 'KPMG',
    value: 14,
  },
  {
    label: 'Genpact',
    value: 15,
  },
  {
    label: 'Bharti Airtel',
    value: 16,
  },
  {
    label: 'CRISIL',
    value: 17,
  },
  {
    label: 'JP Morgan',
    value: 18,
  },
  {
    label: 'Axis Bank',
    value: 19,
  },
  {
    label: 'PricewaterhouseCoopers',
    value: 20,
  },
  {
    label: 'Capgemini',
    value: 21,
  },
  {
    label: 'Deutsche Bank',
    value: 22,
  },
  {
    label: 'Tata Teleservices',
    value: 23,
  },
  {
    label: 'State Bank of India',
    value: 24,
  },
  {
    label: 'Royal Bank of Scotland',
    value: 25,
  },
  {
    label: 'Kotak Mahindra Bank',
    value: 26,
  },
  {
    label: 'Vodafone',
    value: 27,
  },
  {
    label: 'Citibank',
    value: 28,
  },
  {
    label: 'YES Bank',
    value: 29,
  },
  {
    label: 'Hewlett Packard',
    value: 30,
  },
  {
    label: 'Standard Chartered Bank',
    value: 31,
  },
  {
    label: 'Times Group',
    value: 32,
  },
  {
    label: 'Idea Cellular',
    value: 33,
  },
  {
    label: 'Oracle',
    value: 34,
  },
  {
    label: 'ITC',
    value: 35,
  },
  {
    label: 'Reliance Communications',
    value: 36,
  },
  {
    label: 'Barclays',
    value: 37,
  },
  {
    label: 'Tata Motors',
    value: 38,
  },
  {
    label: 'Evalueserve',
    value: 39,
  },
  {
    label: 'American Express',
    value: 40,
  },
  {
    label: 'Aircel',
    value: 41,
  },
  {
    label: 'ICICI Lombard',
    value: 42,
  },
  {
    label: 'Dell',
    value: 43,
  },
  {
    label: 'Bank of America',
    value: 44,
  },
  {
    label: 'MTS',
    value: 45,
  },
  {
    label: 'L&T',
    value: 46,
  },
  {
    label: 'Aditya Birla Group',
    value: 47,
  },
  {
    label: 'Religare',
    value: 48,
  },
  {
    label: 'Reliance Industries Limited',
    value: 49,
  },
  {
    label: 'Nomura',
    value: 50,
  },
  {
    label: 'Tech Mahindra',
    value: 51,
  },
  {
    label: 'PepsiCo',
    value: 52,
  },
  {
    label: 'Essar Group',
    value: 53,
  },
  {
    label: 'WNS',
    value: 54,
  },
  {
    label: 'Mahindra & Mahindra',
    value: 55,
  },
  {
    label: 'Credit Suisse',
    value: 56,
  },
  {
    label: 'Unilever',
    value: 57,
  },
  {
    label: 'Videocon',
    value: 58,
  },
  {
    label: 'Goldman Sachs',
    value: 59,
  },
  {
    label: 'Tata Group',
    value: 60,
  },
  {
    label: 'ICICI Prudential Life Insurance',
    value: 61,
  },
  {
    label: 'Thomson-Reuters',
    value: 62,
  },
  {
    label: 'IndusInd Bank',
    value: 63,
  },
  {
    label: 'ICICI Securities',
    value: 64,
  },
  {
    label: 'General Electric',
    value: 65,
  },
  {
    label: 'CSC',
    value: 66,
  },
  {
    label: 'Samsung',
    value: 67,
  },
  {
    label: 'India Infoline',
    value: 68,
  },
  {
    label: 'Nokia',
    value: 69,
  },
  {
    label: 'Godrej & Boyce Mfg. Co. Ltd.',
    value: 70,
  },
  {
    label: 'EXL Service',
    value: 71,
  },
  {
    label: 'Reliance',
    value: 72,
  },
  {
    label: 'Flipkart.com',
    value: 73,
  },
  {
    label: 'ICRA',
    value: 74,
  },
  {
    label: 'ING VYSYA Bank',
    value: 75,
  },
  {
    label: 'IDBI Bank',
    value: 76,
  },
  {
    label: 'Mu Sigma',
    value: 77,
  },
  {
    label: 'Financial Inclusion and Network Operations Ltd. (FINO)',
    value: 78,
  },
  {
    label: 'Ericsson',
    value: 79,
  },
  {
    label: 'eClerx',
    value: 80,
  },
  {
    label: 'McKinsey & Company',
    value: 81,
  },
  {
    label: 'Copal Partners',
    value: 82,
  },
  {
    label: 'Johnson & Johnson',
    value: 83,
  },
  {
    label: 'Tata AIA',
    value: 84,
  },
  {
    label: 'iGate',
    value: 85,
  },
  {
    label: 'Mahindra Satyam',
    value: 86,
  },
  {
    label: 'MphasiS',
    value: 87,
  },
  {
    label: 'Procter & Gamble',
    value: 88,
  },
  {
    label: 'Polaris Industries',
    value: 89,
  },
  {
    label: 'Aon Hewitt',
    value: 90,
  },
  {
    label: 'NIIT',
    value: 91,
  },
  {
    label: 'Vedanta Resources',
    value: 92,
  },
  {
    label: 'Fidelity',
    value: 93,
  },
  {
    label: 'Amba Research',
    value: 94,
  },
  {
    label: 'Tata Communications',
    value: 95,
  },
  {
    label: 'Bajaj Allianz',
    value: 96,
  },
  {
    label: 'Tata Steel',
    value: 97,
  },
  {
    label: 'Morgan Stanley',
    value: 98,
  },
  {
    label: 'Hindustan Coca-Cola Beverages',
    value: 99,
  },
  {
    label: 'Futures First',
    value: 100,
  },
  {
    label: 'Nokia Siemens Networks',
    value: 101,
  },
  {
    label: 'Syntel',
    value: 102,
  },
  {
    label: 'Philips Electronics India Ltd',
    value: 103,
  },
  {
    label: 'Confidential',
    value: 104,
  },
  {
    label: 'BA Continuum India Pvt. Ltd.',
    value: 105,
  },
  {
    label: 'Honeywell',
    value: 106,
  },
  {
    label: 'Asian Paints',
    value: 107,
  },
  {
    label: 'SAP',
    value: 108,
  },
  {
    label: 'Future Group',
    value: 109,
  },
  {
    label: 'IMRB',
    value: 110,
  },
  {
    label: 'Karvy',
    value: 111,
  },
  {
    label: 'Aviva Life Insurance',
    value: 112,
  },
  {
    label: 'Self Employed',
    value: 113,
  },
  {
    label: 'Sapient',
    value: 114,
  },
  {
    label: 'Siemens',
    value: 115,
  },
  {
    label: 'Cummins',
    value: 116,
  },
  {
    label: 'Tesco',
    value: 117,
  },
  {
    label: 'LG Electronics',
    value: 118,
  },
  {
    label: 'Citigroup',
    value: 119,
  },
  {
    label: 'Microsoft',
    value: 120,
  },
  {
    label: 'Bharti Walmart',
    value: 121,
  },
  {
    label: 'Tata Capital',
    value: 122,
  },
  {
    label: 'ZS Associates',
    value: 123,
  },
  {
    label: 'Student',
    value: 124,
  },
  {
    label: 'Amazon.com',
    value: 125,
  },
  {
    label: 'Info Edge India Ltd',
    value: 126,
  },
  {
    label: 'Freelance',
    value: 127,
  },
  {
    label: 'Aegis Limited',
    value: 128,
  },
  {
    label: 'Nestle',
    value: 129,
  },
  {
    label: 'Birla Sun Life Insurance',
    value: 130,
  },
  {
    label: 'HT Media',
    value: 131,
  },
  {
    label: 'United Spirits Limited',
    value: 132,
  },
  {
    label: 'FMCG',
    value: 133,
  },
  {
    label: 'Indiabulls',
    value: 134,
  },
  {
    label: 'Mindtree',
    value: 135,
  },
  {
    label: 'Britannia',
    value: 136,
  },
  {
    label: 'Angel Broking',
    value: 137,
  },
  {
    label: 'Frost & Sullivan',
    value: 138,
  },
  {
    label: 'Aranca',
    value: 139,
  },
  {
    label: 'GlaxoSmithKline',
    value: 140,
  },
  {
    label: 'Reliance Capital',
    value: 141,
  },
  {
    label: "Dr. Reddy's Laboratories",
    value: 142,
  },
  {
    label: 'UBS',
    value: 143,
  },
  {
    label: 'TVS',
    value: 144,
  },
  {
    label: 'IT',
    value: 145,
  },
  {
    label: 'Aricent Technologies',
    value: 146,
  },
  {
    label: 'Capital IQ',
    value: 147,
  },
  {
    label: 'Indian Oil Corporation Limited',
    value: 148,
  },
  {
    label: 'Welspun',
    value: 149,
  },
  {
    label: 'AkzoNobel India Ltd',
    value: 150,
  },
  {
    label: 'Maruti Suzuki India Limited',
    value: 151,
  },
  {
    label: 'Reliance Retail',
    value: 152,
  },
  {
    label: 'Lodha Group',
    value: 153,
  },
  {
    label: 'Arshiya International Ltd',
    value: 154,
  },
  {
    label: 'Bharti Axa Life Insurance',
    value: 155,
  },
  {
    label: 'Schneider Electric',
    value: 156,
  },
  {
    label: 'IndiaMart InterMesh Ltd',
    value: 157,
  },
  {
    label: 'Finance',
    value: 158,
  },
  {
    label: 'Ranbaxy',
    value: 159,
  },
  {
    label: 'Beroe Inc',
    value: 160,
  },
  {
    label: 'Bosch',
    value: 161,
  },
  {
    label: 'Reckitt Benckiser',
    value: 162,
  },
  {
    label: 'Uninor',
    value: 163,
  },
  {
    label: 'JSW Steel',
    value: 164,
  },
  {
    label: 'SREI',
    value: 165,
  },
  {
    label: 'Godfrey Phillips India Ltd',
    value: 166,
  },
  {
    label: 'Metlife',
    value: 167,
  },
  {
    label: 'Serco',
    value: 168,
  },
  {
    label: 'Steria',
    value: 169,
  },
  {
    label: 'SKS Microfinance',
    value: 170,
  },
  {
    label: 'Credit Analysis and Research Limited',
    value: 171,
  },
  {
    label: 'Max Life Insurance',
    value: 172,
  },
  {
    label: 'Fractal Analytics',
    value: 173,
  },
  {
    label: 'Suzlon',
    value: 174,
  },
  {
    label: 'GE Capital',
    value: 175,
  },
  {
    label: 'L&T Infotech',
    value: 176,
  },
  {
    label: 'Dabur',
    value: 177,
  },
  {
    label: 'Pidilite Industries',
    value: 178,
  },
  {
    label: 'Reliance Infrastructure',
    value: 179,
  },
  {
    label: 'Shriram Group',
    value: 180,
  },
  {
    label: 'Aegon Religare',
    value: 181,
  },
  {
    label: 'Novartis',
    value: 182,
  },
  {
    label: 'Bank of India',
    value: 183,
  },
  {
    label: 'Reliance Life Insurance',
    value: 184,
  },
  {
    label: 'Motilal Oswal',
    value: 185,
  },
  {
    label: 'Marico',
    value: 186,
  },
  {
    label: 'ANZ',
    value: 187,
  },
  {
    label: 'Educomp',
    value: 188,
  },
  {
    label: 'D. E. Shaw & Co',
    value: 189,
  },
  {
    label: 'BNY Mellon',
    value: 190,
  },
  {
    label: 'Mercer',
    value: 191,
  },
  {
    label: 'Titan Industries',
    value: 192,
  },
  {
    label: 'Jindal Steel and Power Limited',
    value: 193,
  },
  {
    label: 'Hero MotoCorp',
    value: 194,
  },
  {
    label: 'Altisource',
    value: 195,
  },
  {
    label: 'Indian Army',
    value: 196,
  },
  {
    label: 'L&T Finance',
    value: 197,
  },
  {
    label: 'DMV Business and Market Research',
    value: 198,
  },
  {
    label: 'ITC Infotech',
    value: 199,
  },
  {
    label: 'Maersk',
    value: 200,
  },
  {
    label: 'Bajaj Auto Limited',
    value: 201,
  },
  {
    label: 'Shell',
    value: 202,
  },
  {
    label: "L'Oreal",
    value: 203,
  },
  {
    label: 'Sahara',
    value: 204,
  },
  {
    label: 'IL&FS',
    value: 205,
  },
  {
    label: 'MakeMyTrip',
    value: 206,
  },
  {
    label: 'Olam International',
    value: 207,
  },
  {
    label: 'Banking',
    value: 208,
  },
  {
    label: 'ISB Hyderabad',
    value: 209,
  },
  {
    label: 'Union Bank of India',
    value: 210,
  },
  {
    label: 'Ashok Leyland',
    value: 211,
  },
  {
    label: 'Firstsource Solutions',
    value: 212,
  },
  {
    label: 'Moser Baer',
    value: 213,
  },
  {
    label: 'Max New York Life Insurance',
    value: 214,
  },
  {
    label: 'Emami Limited',
    value: 215,
  },
  {
    label: 'Mother Dairy',
    value: 216,
  },
  {
    label: 'Atos',
    value: 217,
  },
  {
    label: 'Lanco Infratech',
    value: 218,
  },
  {
    label: 'The Coca-Cola Company',
    value: 219,
  },
  {
    label: 'Huawei',
    value: 220,
  },
  {
    label: 'Target Corporation',
    value: 221,
  },
  {
    label: 'Bank of Baroda',
    value: 222,
  },
  {
    label: 'Sutherland Global Services',
    value: 223,
  },
  {
    label: 'Indus Towers',
    value: 224,
  },
  {
    label: 'Cisco',
    value: 225,
  },
  {
    label: 'GroupM',
    value: 226,
  },
  {
    label: 'Cadbury',
    value: 227,
  },
  {
    label: 'Northern Trust',
    value: 228,
  },
  {
    label: 'Birlasoft',
    value: 229,
  },
  {
    label: 'Zee',
    value: 230,
  },
  {
    label: 'Gati-Kintetsu Express Private Limited',
    value: 231,
  },
  {
    label: 'Alcatel Lucent',
    value: 232,
  },
  {
    label: 'Cadila',
    value: 233,
  },
  {
    label: 'The Smart Cube',
    value: 234,
  },
  {
    label: 'Grant Thornton',
    value: 235,
  },
  {
    label: 'Bharat Petroleum Corporation Limited',
    value: 236,
  },
  {
    label: 'Google',
    value: 237,
  },
  {
    label: 'Adani Group',
    value: 238,
  },
  {
    label: 'Headstrong',
    value: 239,
  },
  {
    label: 'Hungama Digital Media Entertainment',
    value: 240,
  },
  {
    label: 'JDA Software',
    value: 241,
  },
  {
    label: 'Dhanlaxmi Bank',
    value: 242,
  },
  {
    label: 'AMUL',
    value: 243,
  },
  {
    label: 'KPIT Cummins',
    value: 244,
  },
  {
    label: 'CA Firm',
    value: 245,
  },
  {
    label: 'AbsolutData',
    value: 246,
  },
  {
    label: 'Diageo',
    value: 247,
  },
  {
    label: 'Sterlite',
    value: 248,
  },
  {
    label: 'ING Vysya Life Insurance',
    value: 249,
  },
  {
    label: 'Ogilvy & Mather',
    value: 250,
  },
  {
    label: 'Supermax',
    value: 251,
  },
  {
    label: 'SMC',
    value: 252,
  },
  {
    label: 'Convergys',
    value: 253,
  },
  {
    label: '3i Infotech',
    value: 254,
  },
  {
    label: 'IFCI',
    value: 255,
  },
  {
    label: 'BNP Paribas',
    value: 256,
  },
  {
    label: 'Globeop Financial Services',
    value: 257,
  },
  {
    label: 'N/A',
    value: 258,
  },
  {
    label: 'CARE Ratings',
    value: 259,
  },
  {
    label: 'Abbott India',
    value: 260,
  },
  {
    label: 'Nielsen',
    value: 261,
  },
  {
    label: 'TNS',
    value: 262,
  },
  {
    label: 'Bharat Heavy Electricals Limited',
    value: 263,
  },
  {
    label: 'Jindal Group',
    value: 264,
  },
  {
    label: 'Snapdeal.com',
    value: 265,
  },
  {
    label: '3M India',
    value: 266,
  },
  {
    label: 'Star India Pvt Ltd',
    value: 267,
  },
  {
    label: 'Feedback Infra',
    value: 268,
  },
  {
    label: 'Grail Research',
    value: 269,
  },
  {
    label: 'OnMobile',
    value: 270,
  },
  {
    label: 'Whirlpool',
    value: 271,
  },
  {
    label: 'GMR Group',
    value: 272,
  },
  {
    label: 'Capital One',
    value: 273,
  },
  {
    label: 'Bajaj Finance',
    value: 274,
  },
  {
    label: 'Ramco Systems',
    value: 275,
  },
  {
    label: 'GlobalData',
    value: 276,
  },
  {
    label: 'Anand Rathi Group',
    value: 277,
  },
  {
    label: 'CMC Limited',
    value: 278,
  },
  {
    label: 'Sai Info System',
    value: 279,
  },
  {
    label: 'Punj Lloyd',
    value: 280,
  },
  {
    label: 'METRO Cash & Carry',
    value: 281,
  },
  {
    label: 'Unisys',
    value: 282,
  },
  {
    label: 'Ocwen',
    value: 283,
  },
  {
    label: 'Fresher',
    value: 284,
  },
  {
    label: 'CavinKare',
    value: 285,
  },
  {
    label: 'Verity Knowledge Solutions',
    value: 286,
  },
  {
    label: 'Tulip Telecom',
    value: 287,
  },
  {
    label: 'Marketing',
    value: 288,
  },
  {
    label: 'United Health Group',
    value: 289,
  },
  {
    label: 'Dun & Bradstreet',
    value: 290,
  },
  {
    label: 'Raymond',
    value: 291,
  },
  {
    label: 'Currently Unemployed',
    value: 292,
  },
  {
    label: 'Castrol',
    value: 293,
  },
  {
    label: 'Sony',
    value: 294,
  },
  {
    label: 'Jones Lang LaSalle',
    value: 295,
  },
  {
    label: 'Trident Limited',
    value: 296,
  },
  {
    label: 'Spice Group',
    value: 297,
  },
  {
    label: 'Godrej Consumer Products',
    value: 298,
  },
  {
    label: 'Societe Generale',
    value: 299,
  },
  {
    label: 'Colgate Palmolive',
    value: 300,
  },
  {
    label: 'The Nielsen Company',
    value: 301,
  },
  {
    label: 'Macquarie',
    value: 302,
  },
  {
    label: 'Berger Paints',
    value: 303,
  },
  {
    label: 'Protiviti Consulting',
    value: 304,
  },
  {
    label: 'ABB',
    value: 305,
  },
  {
    label: 'Reliance Broadcast Network Limited',
    value: 306,
  },
  {
    label: 'Future Generali India Life Insurance Company Limited',
    value: 307,
  },
  {
    label: 'Magma Fincorp Limited',
    value: 308,
  },
  {
    label: 'DBS Bank',
    value: 309,
  },
  {
    label: 'Pantaloon Retail',
    value: 310,
  },
  {
    label: 'Amdocs',
    value: 311,
  },
  {
    label: 'ABC Consultants',
    value: 312,
  },
  {
    label: 'self',
    value: 313,
  },
  {
    label: 'Tally Solutions',
    value: 314,
  },
  {
    label: 'Edelweiss Financial Services',
    value: 315,
  },
  {
    label: 'ACC Limited',
    value: 316,
  },
  {
    label: 'Randstad',
    value: 317,
  },
  {
    label: 'Hindustan Zinc Limited',
    value: 318,
  },
  {
    label: 'Technopak Advisors',
    value: 319,
  },
  {
    label: 'Etisalat DB Telecom',
    value: 320,
  },
  {
    label: 'Dalmia Bharat',
    value: 321,
  },
  {
    label: 'IDBI Capital',
    value: 322,
  },
  {
    label: 'Getit Infoservices',
    value: 323,
  },
  {
    label: 'NSE',
    value: 324,
  },
  {
    label: 'Transparent Value',
    value: 325,
  },
  {
    label: 'Scope International',
    value: 326,
  },
  {
    label: 'Hindustan Times',
    value: 327,
  },
  {
    label: 'Datamatics',
    value: 328,
  },
  {
    label: 'Independent',
    value: 329,
  },
  {
    label: 'SABMiller',
    value: 330,
  },
  {
    label: 'General Mills',
    value: 331,
  },
  {
    label: 'Parle Agro',
    value: 332,
  },
  {
    label: 'Motorola Mobility',
    value: 333,
  },
  {
    label: 'Dish TV',
    value: 334,
  },
  {
    label: 'Landmark Group',
    value: 335,
  },
  {
    label: 'Sharekhan',
    value: 336,
  },
  {
    label: 'Biocon',
    value: 337,
  },
  {
    label: 'Fullerton India Credit Company Limited',
    value: 338,
  },
  {
    label: 'Adobe',
    value: 339,
  },
  {
    label: 'Bharti Infratel',
    value: 340,
  },
  {
    label: 'Hutchison Global Services',
    value: 341,
  },
  {
    label: 'CEB',
    value: 342,
  },
  {
    label: 'Daimler India Commercial Vehicles',
    value: 343,
  },
  {
    label: 'SAIL',
    value: 344,
  },
  {
    label: 'DBOI',
    value: 345,
  },
  {
    label: 'Central Bank of India',
    value: 346,
  },
  {
    label: 'Muthoot Fincorp',
    value: 347,
  },
  {
    label: 'Reliance Power',
    value: 348,
  },
  {
    label: 'Cipla',
    value: 349,
  },
  {
    label: 'Fortis Healthcare',
    value: 350,
  },
  {
    label: 'Heinz',
    value: 351,
  },
  {
    label: 'Hinduja Group',
    value: 352,
  },
  {
    label: 'Ballarpur Industries Limited',
    value: 353,
  },
  {
    label: 'Piramal',
    value: 354,
  },
  {
    label: 'Onicra Credit Rating Agency of India',
    value: 355,
  },
  {
    label: 'Ipsos',
    value: 356,
  },
  {
    label: 'One97 Communications',
    value: 357,
  },
  {
    label: 'Ingersoll Rand',
    value: 358,
  },
  {
    label: 'Future Value Retail Limited',
    value: 359,
  },
  {
    label: 'USHA International',
    value: 360,
  },
  {
    label: 'DLF Pramerica Life Insurance',
    value: 361,
  },
  {
    label: 'JM Financial',
    value: 362,
  },
  {
    label: 'Zensar Technologies',
    value: 363,
  },
  {
    label: 'Sify',
    value: 364,
  },
  {
    label: 'Darashaw',
    value: 365,
  },
  {
    label: 'CEAT',
    value: 366,
  },
  {
    label: 'Thomas Cook',
    value: 367,
  },
  {
    label: 'Wipro Consumer Care & Lighting',
    value: 368,
  },
  {
    label: 'Xchanging',
    value: 369,
  },
  {
    label: 'Yahoo',
    value: 370,
  },
  {
    label: 'UltraTech Cement Limited',
    value: 371,
  },
  {
    label: 'Redington',
    value: 372,
  },
  {
    label: 'Jubilant Life Sciences',
    value: 373,
  },
  {
    label: 'Abhijeet Group',
    value: 374,
  },
  {
    label: 'Intel',
    value: 375,
  },
  {
    label: 'Panasonic',
    value: 376,
  },
  {
    label: 'Fashionandyou.com',
    value: 377,
  },
  {
    label: 'Agilent Technologies',
    value: 378,
  },
  {
    label: 'TAJ GROUP',
    value: 379,
  },
  {
    label: 'CGI Group',
    value: 380,
  },
  {
    label: 'Peoplestrong HR',
    value: 381,
  },
  {
    label: 'Adecco',
    value: 382,
  },
  {
    label: 'DLF',
    value: 383,
  },
  {
    label: 'Viom Networks',
    value: 384,
  },
  {
    label: 'Max Bupa Health Insurance',
    value: 385,
  },
  {
    label: 'Ameriprise Financial',
    value: 386,
  },
  {
    label: 'Torrent Group',
    value: 387,
  },
  {
    label: 'Manipal Group',
    value: 388,
  },
  {
    label: 'ONGC',
    value: 389,
  },
  {
    label: 'Edelweiss',
    value: 390,
  },
  {
    label: 'ICAI',
    value: 391,
  },
  {
    label: 'Consulting',
    value: 392,
  },
  {
    label: "Spencer's Retail",
    value: 393,
  },
  {
    label: 'Ford Motor Company',
    value: 394,
  },
  {
    label: 'Volvo Eicher',
    value: 395,
  },
  {
    label: 'Franklin Templeton',
    value: 396,
  },
  {
    label: 'Saint Gobain',
    value: 397,
  },
  {
    label: 'Avendus Capital',
    value: 398,
  },
  {
    label: 'Citicorp Services India Limited',
    value: 399,
  },
  {
    label: 'United Breweries',
    value: 400,
  },
  {
    label: 'Fiserv',
    value: 401,
  },
  {
    label: 'Not Working',
    value: 402,
  },
  {
    label: 'Apollo Hospitals',
    value: 403,
  },
  {
    label:
      'Canara HSBC Oriental Bank of Commerce Life Insurance Company Limited',
    value: 404,
  },
  {
    label: 'IFMR',
    value: 405,
  },
  {
    label: 'Mahindra Holidays & Resorts',
    value: 406,
  },
  {
    label: 'Tata Technologies',
    value: 407,
  },
  {
    label: 'Bain & Company',
    value: 408,
  },
  {
    label: 'BlackRock',
    value: 409,
  },
  {
    label: 'Orange Business Services',
    value: 410,
  },
  {
    label: 'Pfizer',
    value: 411,
  },
  {
    label: 'Henkel',
    value: 412,
  },
  {
    label: 'Bristlecone',
    value: 413,
  },
  {
    label: 'Goodyear',
    value: 414,
  },
  {
    label: 'Ramky Group',
    value: 415,
  },
  {
    label: 'RPG Group',
    value: 416,
  },
  {
    label: 'Cushman & Wakefield',
    value: 417,
  },
  {
    label: 'A.T. Kearney',
    value: 418,
  },
  {
    label: 'IDFC',
    value: 419,
  },
  {
    label: 'Sonata Software',
    value: 420,
  },
  {
    label: 'Capita',
    value: 421,
  },
  {
    label: 'Tata Power',
    value: 422,
  },
  {
    label: 'Emkay Global Financial Services',
    value: 423,
  },
  {
    label: 'Newgen Software',
    value: 424,
  },
  {
    label: 'Virtusa',
    value: 425,
  },
  {
    label: 'HCL Infosystems',
    value: 426,
  },
  {
    label: 'Colt Technologies',
    value: 427,
  },
  {
    label: 'NTPC',
    value: 428,
  },
  {
    label: 'Unicon',
    value: 429,
  },
  {
    label: 'IIT kharagpur',
    value: 430,
  },
  {
    label: 'Verizon',
    value: 431,
  },
  {
    label: 'Infotech Enterprises Limited',
    value: 432,
  },
  {
    label: 'DHL Express',
    value: 433,
  },
  {
    label: 'EMC Corporation',
    value: 434,
  },
  {
    label: 'Fitch Ratings',
    value: 435,
  },
  {
    label: 'Dainik Bhaskar',
    value: 436,
  },
  {
    label: 'MARG Limited',
    value: 437,
  },
  {
    label: 'Kansai Nerolac Paints',
    value: 438,
  },
  {
    label: 'Triton Group',
    value: 439,
  },
  {
    label: 'Alstom',
    value: 440,
  },
  {
    label: 'Everonn Education',
    value: 441,
  },
  {
    label: 'Citicorp Finance (India) Limited (CFIL)',
    value: 442,
  },
  {
    label: 'Indian Air Force',
    value: 443,
  },
  {
    label: 'Fujitsu',
    value: 444,
  },
  {
    label: 'BMR Advisors',
    value: 445,
  },
  {
    label: 'Jubilant Group',
    value: 446,
  },
  {
    label: 'Beetel Teletech',
    value: 447,
  },
  {
    label: 'Havells India',
    value: 448,
  },
  {
    label: 'IMS Learning Resources',
    value: 449,
  },
  {
    label: 'Cypress Semiconductor',
    value: 450,
  },
  {
    label: 'Kraft Foods',
    value: 451,
  },
  {
    label: 'Future Supply Chain Solutions Limited',
    value: 452,
  },
  {
    label: 'Pernod Ricard',
    value: 453,
  },
  {
    label: 'Irevna',
    value: 454,
  },
  {
    label: 'Hexaware Technologies',
    value: 455,
  },
  {
    label: 'Yum Brands',
    value: 456,
  },
  {
    label: 'DuPont',
    value: 457,
  },
  {
    label: 'Avaya GlobalConnect',
    value: 458,
  },
  {
    label: 'Kingfisher Airlines',
    value: 459,
  },
  {
    label: 'TeamLease',
    value: 460,
  },
  {
    label: 'NetAmbit',
    value: 461,
  },
  {
    label: 'Automobile',
    value: 462,
  },
  {
    label: 'Safexpress',
    value: 463,
  },
  {
    label: 'Centum Learning',
    value: 464,
  },
  {
    label: 'InterGlobe Technologies',
    value: 465,
  },
  {
    label: 'Coromandel International Limited',
    value: 466,
  },
  {
    label: 'Eureka Forbes',
    value: 467,
  },
  {
    label: 'Glenmark Pharmaceuticals',
    value: 468,
  },
  {
    label: 'Cheers Interactive',
    value: 469,
  },
  {
    label: 'Cargill India Private Limited',
    value: 470,
  },
  {
    label: 'HR',
    value: 471,
  },
  {
    label: 'Jabong.com',
    value: 472,
  },
  {
    label: 'Franchise India',
    value: 473,
  },
  {
    label: 'iNautix Technologies',
    value: 474,
  },
  {
    label: 'Sasken',
    value: 475,
  },
  {
    label: 'Bata',
    value: 476,
  },
  {
    label: 'Logica',
    value: 477,
  },
  {
    label: 'NTT Data',
    value: 478,
  },
  {
    label: 'VIP Industries',
    value: 479,
  },
  {
    label: 'Sodexo',
    value: 480,
  },
  {
    label: 'Hindware',
    value: 481,
  },
  {
    label: 'MAQ Software',
    value: 482,
  },
  {
    label: 'General Motors',
    value: 483,
  },
  {
    label: 'SunGard',
    value: 484,
  },
  {
    label: 'Comviva Technologies',
    value: 485,
  },
  {
    label: 'Canon',
    value: 486,
  },
  {
    label: 'Perfetti Van Melle',
    value: 487,
  },
  {
    label: 'IIM Indore',
    value: 488,
  },
  {
    label: 'Allahabad Bank',
    value: 489,
  },
  {
    label: 'ZTE',
    value: 490,
  },
  {
    label: 'BCG',
    value: 491,
  },
  {
    label: 'Inductis',
    value: 492,
  },
  {
    label: 'UST Global',
    value: 493,
  },
  {
    label: 'MarketsandMarkets',
    value: 494,
  },
  {
    label: 'Gammon India Limited',
    value: 495,
  },
  {
    label: 'Basix',
    value: 496,
  },
  {
    label: 'AstraZeneca',
    value: 497,
  },
  {
    label: 'Reebok',
    value: 498,
  },
  {
    label: 'The Boston Consulting Group',
    value: 499,
  },
  {
    label: 'Satyam',
    value: 500,
  },
  {
    label: 'HPCL',
    value: 501,
  },
  {
    label: 'Millward Brown',
    value: 502,
  },
  {
    label: 'Spanco',
    value: 503,
  },
  {
    label: 'UTI',
    value: 504,
  },
  {
    label: 'Madison',
    value: 505,
  },
  {
    label: 'Jaypee Group',
    value: 506,
  },
  {
    label: 'IFB Industries Limited',
    value: 507,
  },
  {
    label: 'Honda',
    value: 508,
  },
  {
    label: 'Xerox',
    value: 509,
  },
  {
    label: 'MCX Stock Exchange',
    value: 510,
  },
  {
    label: 'Intelenet Global Services',
    value: 511,
  },
  {
    label: 'Manpower Group',
    value: 512,
  },
  {
    label: 'Modi Group',
    value: 513,
  },
  {
    label: 'Indian Navy',
    value: 514,
  },
  {
    label: 'IDBI Federal Life Insurance Company',
    value: 515,
  },
  {
    label: 'Reliance Brands Limited',
    value: 516,
  },
  {
    label: 'Pitney Bowes Software',
    value: 517,
  },
  {
    label: 'Lenovo',
    value: 518,
  },
  {
    label: 'SBI Capital Markets',
    value: 519,
  },
  {
    label: 'Financial Technologies',
    value: 520,
  },
  {
    label: 'Eaton Corporation',
    value: 521,
  },
  {
    label: 'Bajaj Capital',
    value: 522,
  },
  {
    label: 'QAI',
    value: 523,
  },
  {
    label: 'Sanofi Pasteur',
    value: 524,
  },
  {
    label: 'Nucleus Software Exports',
    value: 525,
  },
  {
    label: 'UCO Bank',
    value: 526,
  },
  {
    label: 'Tecnova',
    value: 527,
  },
  {
    label: 'John Deere',
    value: 528,
  },
  {
    label: 'SS&C GlobeOp',
    value: 529,
  },
  {
    label: 'Wockhardt',
    value: 530,
  },
  {
    label: 'Bayer',
    value: 531,
  },
  {
    label: 'Aptara Corp',
    value: 532,
  },
  {
    label: 'FedEx',
    value: 533,
  },
  {
    label: 'NMIMS',
    value: 534,
  },
  {
    label: 'Avery Dennison',
    value: 535,
  },
  {
    label: 'iCreate Software',
    value: 536,
  },
  {
    label: 'Zycus',
    value: 537,
  },
  {
    label: 'CPA Global',
    value: 538,
  },
  {
    label: 'Flareum Technologies',
    value: 539,
  },
  {
    label: 'Voltas',
    value: 540,
  },
  {
    label: 'Pearson Education',
    value: 541,
  },
  {
    label: 'Manipal Global Education Services',
    value: 542,
  },
  {
    label: 'Indus Valley Partners',
    value: 543,
  },
  {
    label: 'eBay',
    value: 544,
  },
  {
    label: 'BDO Consulting',
    value: 545,
  },
  {
    label: 'Caterpillar',
    value: 546,
  },
  {
    label: 'Capital First Limited',
    value: 547,
  },
  {
    label: 'Bank of Maharashtra',
    value: 548,
  },
  {
    label: 'Mahindra & Mahindra Financial Services',
    value: 549,
  },
  {
    label: 'Telecom',
    value: 550,
  },
  {
    label: 'MSCI',
    value: 551,
  },
  {
    label: 'Photon Infotech',
    value: 552,
  },
  {
    label: 'Infinity Research',
    value: 553,
  },
  {
    label: 'Jaypee Capital',
    value: 554,
  },
  {
    label: 'Factset Research Systems',
    value: 555,
  },
  {
    label: 'ADP',
    value: 556,
  },
  {
    label: 'Lifestyle',
    value: 557,
  },
  {
    label: 'ICFAI',
    value: 558,
  },
  {
    label: 'GEP',
    value: 559,
  },
  {
    label: 'Damco',
    value: 560,
  },
  {
    label: 'LIC',
    value: 561,
  },
  {
    label: 'Quatrro',
    value: 562,
  },
  {
    label: 'Kohler',
    value: 563,
  },
  {
    label: 'Jardine Lloyd Thompson',
    value: 564,
  },
  {
    label: 'Hindustan Petroleum Corporation',
    value: 565,
  },
  {
    label: 'Volkswagen',
    value: 566,
  },
  {
    label: 'Misys',
    value: 567,
  },
  {
    label: 'Blue Star Limited',
    value: 568,
  },
  {
    label: 'Avalon Consulting',
    value: 569,
  },
  {
    label: 'Jaiprakash Associates Limited',
    value: 570,
  },
  {
    label: 'Unemployed',
    value: 571,
  },
  {
    label: 'IIT Roorkee',
    value: 572,
  },
  {
    label: 'Great Lakes Institute of Management',
    value: 573,
  },
  {
    label: 'IndiGo',
    value: 574,
  },
  {
    label: 'MPS Group of Companies',
    value: 575,
  },
  {
    label: 'Schlumberger',
    value: 576,
  },
  {
    label: 'Infiniti Retail - TATA Croma',
    value: 577,
  },
  {
    label: 'NCDEX',
    value: 578,
  },
  {
    label: 'Lafarge',
    value: 579,
  },
  {
    label: 'Directi',
    value: 580,
  },
  {
    label: 'Lupin',
    value: 581,
  },
  {
    label: 'Renault',
    value: 582,
  },
  {
    label: 'TIME',
    value: 583,
  },
  {
    label: 'Reliance Digital',
    value: 584,
  },
  {
    label: 'Dealsandyou.com',
    value: 585,
  },
  {
    label: 'N/A',
    value: 586,
  },
  {
    label: 'Myntra.com',
    value: 587,
  },
  {
    label: 'Edelweiss Capital',
    value: 588,
  },
  {
    label: 'Bloomberg',
    value: 589,
  },
  {
    label: 'Wells Fargo',
    value: 590,
  },
  {
    label: 'Ruchi Soya',
    value: 591,
  },
  {
    label: 'L&T Infrastructure Finance Company',
    value: 592,
  },
  {
    label: 'Symphony Teleca',
    value: 593,
  },
  {
    label: 'Loop Mobile',
    value: 594,
  },
  {
    label: 'Tata Autocomp Systems',
    value: 595,
  },
  {
    label: 'mnc',
    value: 596,
  },
  {
    label: 'Towers Watson',
    value: 597,
  },
  {
    label: 'Matrix Cellular',
    value: 598,
  },
  {
    label: 'Marsh India',
    value: 599,
  },
  {
    label: 'Manufacturing',
    value: 600,
  },
  {
    label: 'Escorts Limited',
    value: 601,
  },
  {
    label: 'Analytics Quotient',
    value: 602,
  },
  {
    label: 'Integreon',
    value: 603,
  },
  {
    label: 'Century Plyboards (India) Ltd',
    value: 604,
  },
  {
    label: 'Boston Analytics',
    value: 605,
  },
  {
    label: 'AGC Networks - Essar Group',
    value: 606,
  },
  {
    label: 'Insync Analytics',
    value: 607,
  },
  {
    label: 'Ness Technologies',
    value: 608,
  },
  {
    label: 'Opera Solutions',
    value: 609,
  },
  {
    label: 'Cease Fire Industries',
    value: 610,
  },
  {
    label: 'Yebhi.com',
    value: 611,
  },
  {
    label: 'Zydus',
    value: 612,
  },
  {
    label: 'Carlsberg',
    value: 613,
  },
  {
    label: 'Broadridge Financial Solution',
    value: 614,
  },
  {
    label: 'A2Z Group',
    value: 615,
  },
  {
    label: 'Fujifilm',
    value: 616,
  },
  {
    label: 'Shapoorji Pallonji',
    value: 617,
  },
  {
    label: 'Mogae Media',
    value: 618,
  },
  {
    label: 'Essel Group',
    value: 619,
  },
  {
    label: 'Tata Interactive Systems',
    value: 620,
  },
  {
    label: 'AVON Beauty Products India',
    value: 621,
  },
  {
    label: 'Yatra.com',
    value: 622,
  },
  {
    label: 'Everest Group',
    value: 623,
  },
  {
    label: 'Percept',
    value: 624,
  },
  {
    label: 'British Telecom',
    value: 625,
  },
  {
    label: 'Energo Engineering Projects',
    value: 626,
  },
  {
    label: 'PNB MetLife',
    value: 627,
  },
  {
    label: 'Tata Strategic Management Group',
    value: 628,
  },
  {
    label: 'IMT Ghaziabad',
    value: 629,
  },
  {
    label: 'Madura Fashion & Lifestyle',
    value: 630,
  },
  {
    label: 'Fullerton Securities & Wealth Advisors Ltd',
    value: 631,
  },
  {
    label: 'Walmart',
    value: 632,
  },
  {
    label: 'Alchemist Group',
    value: 633,
  },
  {
    label: 'ACS - A Xerox Company',
    value: 634,
  },
  {
    label: 'Next Education',
    value: 635,
  },
  {
    label: 'Persistent Systems',
    value: 636,
  },
  {
    label: 'Knight Frank',
    value: 637,
  },
  {
    label: 'Destimoney Enterprises Pvt. Ltd.',
    value: 638,
  },
  {
    label: 'Dunnhumby',
    value: 639,
  },
  {
    label: 'NDTV',
    value: 640,
  },
  {
    label: 'Agro Tech Foods',
    value: 641,
  },
  {
    label: 'Cairn India',
    value: 642,
  },
  {
    label: 'Kellogg',
    value: 643,
  },
  {
    label: 'Edelweiss Securities',
    value: 644,
  },
  {
    label: 'Fair Isaac Corporation (FICO)',
    value: 645,
  },
  {
    label: 'Jumbo Electronics',
    value: 646,
  },
  {
    label: 'Coal India Limited',
    value: 647,
  },
  {
    label: 'Relaxo Footwear',
    value: 648,
  },
  {
    label: 'CSS Corp',
    value: 649,
  },
  {
    label: 'Nirmal Bang',
    value: 650,
  },
  {
    label: 'D B Corp Ltd',
    value: 651,
  },
  {
    label: 'Centrum Capital Limited',
    value: 652,
  },
  {
    label: 'Feedback Business Consulting',
    value: 653,
  },
  {
    label: 'i3 Consulting',
    value: 654,
  },
  {
    label: 'DCM Shriram Consolidated',
    value: 655,
  },
  {
    label: 'IIM Bangalore',
    value: 656,
  },
  {
    label: 'DDB Mudra Group',
    value: 657,
  },
  {
    label: 'Levi Strauss',
    value: 658,
  },
  {
    label: 'Bhushan Power & Steel Ltd',
    value: 659,
  },
  {
    label: 'Emaar MGF',
    value: 660,
  },
  {
    label: 'Crompton Greaves',
    value: 661,
  },
  {
    label: 'Nihilent Technologies',
    value: 662,
  },
  {
    label: 'Tata Chemicals',
    value: 663,
  },
  {
    label: 'Collabera',
    value: 664,
  },
  {
    label: 'Aneja Associates',
    value: 665,
  },
  {
    label: 'Panacea Biotec',
    value: 666,
  },
  {
    label: 'Shoppers Stop',
    value: 667,
  },
  {
    label: 'Groupe Danone',
    value: 668,
  },
  {
    label: 'AC Nielsen',
    value: 669,
  },
  {
    label: 'Lanco Solar Power',
    value: 670,
  },
  {
    label: 'CA Technologies',
    value: 671,
  },
  {
    label: 'Global Talent Track',
    value: 672,
  },
  {
    label: 'Mastek',
    value: 673,
  },
  {
    label: 'Patni Computer Systems',
    value: 674,
  },
  {
    label: 'Network 18',
    value: 675,
  },
  {
    label: 'FIS',
    value: 676,
  },
  {
    label: 'Star Union Dai-ichi Life Insurance',
    value: 677,
  },
  {
    label: 'Cafe Coffee Day',
    value: 678,
  },
  {
    label: 'Sulekha.com',
    value: 679,
  },
  {
    label: 'Bajaj Electricals',
    value: 680,
  },
  {
    label: 'Monster.com',
    value: 681,
  },
  {
    label: 'The Mobile Store',
    value: 682,
  },
  {
    label: 'Onida',
    value: 683,
  },
  {
    label: 'CGN & Associates',
    value: 684,
  },
  {
    label: 'Apollo Tyres Ltd',
    value: 685,
  },
  {
    label: 'Stryker',
    value: 686,
  },
  {
    label: 'Renoir Consulting',
    value: 687,
  },
  {
    label: 'Investors Clinic',
    value: 688,
  },
  {
    label: 'Neuerth Group',
    value: 689,
  },
  {
    label: 'Vistasoft',
    value: 690,
  },
  {
    label: 'Amity University',
    value: 691,
  },
  {
    label: 'CL Educate',
    value: 692,
  },
  {
    label: 'NEC HCL System Technologies',
    value: 693,
  },
  {
    label: 'Michael Page International',
    value: 694,
  },
  {
    label: 'Capillary Technologies',
    value: 695,
  },
  {
    label: 'State Bank of Hyderabad',
    value: 696,
  },
  {
    label: 'Ratnakar Bank',
    value: 697,
  },
  {
    label: 'RateGain',
    value: 698,
  },
  {
    label: 'Vertex',
    value: 699,
  },
  {
    label: 'Confederation of Indian Industry',
    value: 700,
  },
  {
    label: 'PayPal',
    value: 701,
  },
  {
    label: 'CORE Education & Technologies',
    value: 702,
  },
  {
    label: 'Dishnet Wireless Limited',
    value: 703,
  },
  {
    label: 'Mott MacDonald',
    value: 704,
  },
  {
    label: 'Blue Ocean Market Intelligence',
    value: 705,
  },
  {
    label: 'GTL limited',
    value: 706,
  },
  {
    label: 'Haldia Petrochemicals Limited',
    value: 707,
  },
  {
    label: 'iDiscoveri Education',
    value: 708,
  },
  {
    label: 'Corporation Bank',
    value: 709,
  },
  {
    label: 'The Federal Bank',
    value: 710,
  },
  {
    label: 'Education',
    value: 711,
  },
  {
    label: 'iipm',
    value: 712,
  },
  {
    label: 'Ferrero',
    value: 713,
  },
  {
    label: 'Allegro Advisors',
    value: 714,
  },
  {
    label: 'Toyota',
    value: 715,
  },
  {
    label: 'Karur Vyasya Bank',
    value: 716,
  },
  {
    label: 'SG Analytics',
    value: 717,
  },
  {
    label: 'Reval Analytics',
    value: 718,
  },
  {
    label: 'NITIE',
    value: 719,
  },
  {
    label: 'ArcelorMittal',
    value: 720,
  },
  {
    label: 'Brickwork India',
    value: 721,
  },
  {
    label: 'Baxter',
    value: 722,
  },
  {
    label: 'IIT Bombay',
    value: 723,
  },
  {
    label: 'Suntec Business Solutions',
    value: 724,
  },
  {
    label: 'EID Parry',
    value: 725,
  },
  {
    label: 'Sharp Business System',
    value: 726,
  },
  {
    label: 'Hyundai',
    value: 727,
  },
  {
    label: 'Mars',
    value: 728,
  },
  {
    label: 'Ibibo Web Private Limited',
    value: 729,
  },
  {
    label: 'Developement Credit Bank',
    value: 730,
  },
  {
    label: 'CBRE Group',
    value: 731,
  },
  {
    label: 'ANALEC Infotech Private Limited',
    value: 732,
  },
  {
    label: 'Radio Mirchi',
    value: 733,
  },
  {
    label: 'IFFCO',
    value: 734,
  },
  {
    label: 'Tata Business Support Service',
    value: 735,
  },
  {
    label: 'Independent Consultant',
    value: 736,
  },
  {
    label: 'GlobalLogic',
    value: 737,
  },
  {
    label: 'BASF',
    value: 738,
  },
  {
    label: 'Raychem RPG',
    value: 739,
  },
  {
    label: 'Hindalco',
    value: 740,
  },
  {
    label: 'Ford Business Service Center',
    value: 741,
  },
  {
    label: 'Shree Cement',
    value: 742,
  },
  {
    label: 'Draft FCB Ulka',
    value: 743,
  },
  {
    label: 'Parle Products',
    value: 744,
  },
  {
    label: 'Principal',
    value: 745,
  },
  {
    label: 'Omnitech Infosolutions',
    value: 746,
  },
  {
    label: 'Bausch & Lomb',
    value: 747,
  },
  {
    label: 'Hewitt Associates',
    value: 748,
  },
  {
    label: 'BSR & Co.',
    value: 749,
  },
  {
    label: 'LatentView Analytics',
    value: 750,
  },
  {
    label: 'Kuoni India',
    value: 751,
  },
  {
    label: 'Headhonchos',
    value: 752,
  },
  {
    label: 'NetApp',
    value: 753,
  },
  {
    label: 'Bonanza Portfolio Limited',
    value: 754,
  },
  {
    label: 'SNL Financial',
    value: 755,
  },
  {
    label: 'Policybazaar.com',
    value: 756,
  },
  {
    label: 'Retail',
    value: 757,
  },
  {
    label: 'IBEXI Solutions',
    value: 758,
  },
  {
    label: 'Cholamandalam Investment and Finance Company Limited',
    value: 759,
  },
  {
    label: 'AXA Business Services',
    value: 760,
  },
  {
    label: 'Qualcomm',
    value: 761,
  },
  {
    label: 'SC Johnson',
    value: 762,
  },
  {
    label: 'Oriental Bank of Commerce',
    value: 763,
  },
  {
    label: 'Bartronics',
    value: 764,
  },
  {
    label: 'CoCubes Technologies Pvt. Ltd',
    value: 765,
  },
  {
    label: 'Geometric',
    value: 766,
  },
  {
    label: 'Motorola',
    value: 767,
  },
  {
    label: 'DSCL',
    value: 768,
  },
  {
    label: 'Godrej Infotech',
    value: 769,
  },
  {
    label: 'Mahindra Comviva',
    value: 770,
  },
  {
    label: 'Brics Securities',
    value: 771,
  },
  {
    label: 'McAfee',
    value: 772,
  },
  {
    label: 'Datamonitor',
    value: 773,
  },
  {
    label: 'Dion Global Solutions',
    value: 774,
  },
  {
    label: 'Consultant',
    value: 775,
  },
  {
    label: 'Prudential',
    value: 776,
  },
  {
    label: 'Balmer Lawrie & Co Ltd',
    value: 777,
  },
  {
    label: 'Booz & Company',
    value: 778,
  },
  {
    label: 'Encore Capital Group',
    value: 779,
  },
  {
    label: 'TNT',
    value: 780,
  },
  {
    label: 'Grasim Industries Limited',
    value: 781,
  },
  {
    label: 'Zinnov',
    value: 782,
  },
  {
    label: 'Capstone Securities Analysis',
    value: 783,
  },
  {
    label: 'CareerNet',
    value: 784,
  },
  {
    label: 'IMS Health',
    value: 785,
  },
  {
    label: 'CLP India Private Limited',
    value: 786,
  },
  {
    label: 'Monsanto',
    value: 787,
  },
  {
    label: 'Federation of Indian Chambers of Commerce & Industry (FICCI)',
    value: 788,
  },
  {
    label: 'Sitel',
    value: 789,
  },
  {
    label: 'Hughes Communication',
    value: 790,
  },
  {
    label: 'Eveready Indusries India Limited',
    value: 791,
  },
  {
    label: 'Reliance Securities',
    value: 792,
  },
  {
    label: 'Juniper Networks',
    value: 793,
  },
  {
    label: 'Zacks Investment Research',
    value: 794,
  },
  {
    label: 'WeP',
    value: 795,
  },
  {
    label: 'Netscribes',
    value: 796,
  },
  {
    label: 'Transport Corporation of India',
    value: 797,
  },
  {
    label: 'Wrigley',
    value: 798,
  },
  {
    label: 'Prabhudas Liladhar',
    value: 799,
  },
  {
    label: 'Y2CF',
    value: 800,
  },
  {
    label: 'Viacom',
    value: 801,
  },
  {
    label: 'CMS Info Systems',
    value: 802,
  },
  {
    label: 'Ambit Holdings',
    value: 803,
  },
  {
    label: 'Kohinoor Group',
    value: 804,
  },
  {
    label: 'Hitachi',
    value: 805,
  },
  {
    label: 'Symantec',
    value: 806,
  },
  {
    label: 'Daiwa Asset Management',
    value: 807,
  },
  {
    label: 'Hindustan Aeronautics Limited',
    value: 808,
  },
  {
    label: 'RR Donnelley & Sons',
    value: 809,
  },
  {
    label: 'CEVA Logistics',
    value: 810,
  },
  {
    label: 'IndiaHomes',
    value: 811,
  },
  {
    label: 'Happiest Minds',
    value: 812,
  },
  {
    label: 'Caliber Point',
    value: 813,
  },
  {
    label: 'Thermax',
    value: 814,
  },
  {
    label: 'Career Launcher',
    value: 815,
  },
  {
    label: 'Emerson Network Power',
    value: 816,
  },
  {
    label: 'Amway',
    value: 817,
  },
  {
    label: 'RMS',
    value: 818,
  },
  {
    label: 'JWT',
    value: 819,
  },
  {
    label: 'Zenith',
    value: 820,
  },
  {
    label: "McDonald's",
    value: 821,
  },
  {
    label: 'VLCC',
    value: 822,
  },
  {
    label: 'Apple',
    value: 823,
  },
  {
    label: 'Global Analytics',
    value: 824,
  },
  {
    label: 'Entercoms',
    value: 825,
  },
  {
    label: 'MRF',
    value: 826,
  },
  {
    label: 'Lava International',
    value: 827,
  },
  {
    label: 'Suvidhaa Infoserve',
    value: 828,
  },
  {
    label: 'Wizcraft',
    value: 829,
  },
  {
    label: 'Power Finance Corporation',
    value: 830,
  },
  {
    label: 'Carnation Auto India Pvt. Ltd.',
    value: 831,
  },
  {
    label: 'Manappuram',
    value: 832,
  },
  {
    label: 'IFFCO Tokio General Insurance',
    value: 833,
  },
  {
    label: 'MModal Global Services',
    value: 834,
  },
  {
    label: 'Dow Chemical',
    value: 835,
  },
  {
    label: 'IIT kanpur',
    value: 836,
  },
  {
    label: 'Becton, Dickinson and Company',
    value: 837,
  },
  {
    label: 'Alexandria Equities Management',
    value: 838,
  },
  {
    label: 'Infraline Energy',
    value: 839,
  },
  {
    label: 'Orchid Chemicals & Pharmaceuticals',
    value: 840,
  },
  {
    label: 'Guggenheim Transparent Value',
    value: 841,
  },
  {
    label: 'TresVista Financial Services',
    value: 842,
  },
  {
    label: 'IIM Kozhikode',
    value: 843,
  },
  {
    label: 'GMR - Delhi International Airport(P) Limited',
    value: 844,
  },
  {
    label: 'Decathlon',
    value: 845,
  },
  {
    label: 'The World Bank',
    value: 846,
  },
  {
    label: 'Saraswat Co-Operative Bank',
    value: 847,
  },
  {
    label: 'A.P. Moller Maersk',
    value: 848,
  },
  {
    label: 'Magna Infotech',
    value: 849,
  },
  {
    label: 'Godrej Properties',
    value: 850,
  },
  {
    label: 'Cerebrus Consultants',
    value: 851,
  },
  {
    label: 'Unitech',
    value: 852,
  },
  {
    label: 'NISG',
    value: 853,
  },
  {
    label: 'Next Retail',
    value: 854,
  },
  {
    label: 'Planet M Retail',
    value: 855,
  },
  {
    label: 'Leo Burnett',
    value: 856,
  },
  {
    label: 'VFS',
    value: 857,
  },
  {
    label: 'PAYBACK',
    value: 858,
  },
  {
    label: 'Swiss Re',
    value: 859,
  },
  {
    label: 'Freescale Semiconductor',
    value: 860,
  },
  {
    label: 'Power Exchange India Limited',
    value: 861,
  },
  {
    label: 'DHFL',
    value: 862,
  },
  {
    label: 'Delphi',
    value: 863,
  },
  {
    label: 'STAR CJ',
    value: 864,
  },
  {
    label: 'Equirus Capital',
    value: 865,
  },
  {
    label: 'Probe Equity Research',
    value: 866,
  },
  {
    label: 'ValueFirst',
    value: 867,
  },
  {
    label: 'Bacardi India',
    value: 868,
  },
  {
    label: 'Eka Software',
    value: 869,
  },
  {
    label: 'Boehringer Ingelheim',
    value: 870,
  },
  {
    label: 'Yum! Brands',
    value: 871,
  },
  {
    label: 'IndiaCan',
    value: 872,
  },
  {
    label: 'Bisleri International Pvt Ltd',
    value: 873,
  },
  {
    label: 'Jet Airways',
    value: 874,
  },
  {
    label: 'Dimension Data',
    value: 875,
  },
  {
    label: 'Nitco Tiles',
    value: 876,
  },
  {
    label: 'Wunderman',
    value: 877,
  },
  {
    label: 'Groupon India',
    value: 878,
  },
  {
    label: 'MVL Telecom',
    value: 879,
  },
  {
    label: 'Cyber Media Research Limited',
    value: 880,
  },
  {
    label: 'Insurance',
    value: 881,
  },
  {
    label: 'Almondz Global Securities',
    value: 882,
  },
  {
    label: 'DTDC Courier & Cargo Ltd',
    value: 883,
  },
  {
    label: 'Nagarro',
    value: 884,
  },
  {
    label: 'Publicis',
    value: 885,
  },
  {
    label: 'Murugappa Group',
    value: 886,
  },
  {
    label: 'GMR Infrastructure Limited',
    value: 887,
  },
  {
    label: 'Sears Holdings',
    value: 888,
  },
  {
    label: 'Cygnus Business Consulting & Research',
    value: 889,
  },
  {
    label: 'UnitedLex',
    value: 890,
  },
  {
    label: 'Four Soft Ltd.',
    value: 891,
  },
  {
    label: 'IDBI Intech',
    value: 892,
  },
  {
    label: 'Planman HR',
    value: 893,
  },
  {
    label: 'Oberoi Group',
    value: 894,
  },
  {
    label: 'Kirloskar',
    value: 895,
  },
  {
    label: 'Adani Wilmar Limited',
    value: 896,
  },
  {
    label: 'HomeShop18.com',
    value: 897,
  },
  {
    label: 'Hindusthan National Glass & Industries',
    value: 898,
  },
  {
    label: 'Genesis Burson-Marsteller',
    value: 899,
  },
  {
    label: 'Dentsu Inc.',
    value: 900,
  },
  {
    label: 'TransGraph Consulting',
    value: 901,
  },
  {
    label: 'Bombay Stock Exchange',
    value: 902,
  },
  {
    label: 'Temenos India',
    value: 903,
  },
  {
    label: 'Simplilearn',
    value: 904,
  },
  {
    label: 'Oberoi Group of Hotels',
    value: 905,
  },
  {
    label: 'Homeward Residential',
    value: 906,
  },
  {
    label: 'Fulcrum Worldwide',
    value: 907,
  },
  {
    label: 'Canara Robeco',
    value: 908,
  },
  {
    label: 'Loylty Rewardz',
    value: 909,
  },
  {
    label: 'Binani Industries Limited',
    value: 910,
  },
  {
    label: 'Quest Diagnostics',
    value: 911,
  },
  {
    label: 'SIIB',
    value: 912,
  },
  {
    label: 'GMR Energy Limited',
    value: 913,
  },
  {
    label: 'Micromax',
    value: 914,
  },
  {
    label: 'Logistics',
    value: 915,
  },
  {
    label: 'Heritage Foods',
    value: 916,
  },
  {
    label: 'Federal Bank',
    value: 917,
  },
  {
    label: 'Elara Capital',
    value: 918,
  },
  {
    label: 'Edelweiss Tokio Life Insurance',
    value: 919,
  },
  {
    label: 'Monnet Group',
    value: 920,
  },
  {
    label: 'Kony Labs',
    value: 921,
  },
  {
    label: 'Akamai Technologies',
    value: 922,
  },
  {
    label: 'Enzen Global Solutions',
    value: 923,
  },
  {
    label: 'Toshiba',
    value: 924,
  },
  {
    label: 'Starcom',
    value: 925,
  },
  {
    label: 'Softcell',
    value: 926,
  },
  {
    label: 'Geodesic',
    value: 927,
  },
  {
    label: 'Self-employed',
    value: 928,
  },
  {
    label: 'Cox & Kings',
    value: 929,
  },
  {
    label: 'Butterfield Fulcrum',
    value: 930,
  },
  {
    label: 'DCB Bank',
    value: 931,
  },
  {
    label: 'Era Group',
    value: 932,
  },
  {
    label: 'IndiaFirst Life Insurance',
    value: 933,
  },
  {
    label: 'Emergent Ventures',
    value: 934,
  },
  {
    label: 'Philip Morris',
    value: 935,
  },
  {
    label: 'Lucintel',
    value: 936,
  },
  {
    label: 'Real Estate',
    value: 937,
  },
  {
    label: 'Tata International Ltd',
    value: 938,
  },
  {
    label: 'Gerson Lehrman Group',
    value: 939,
  },
  {
    label: 'Exide Industries',
    value: 940,
  },
  {
    label: 'Adhunik Group',
    value: 941,
  },
  {
    label: 'Zylog',
    value: 942,
  },
  {
    label: 'Geojit BNP Paribas Financial Services',
    value: 943,
  },
  {
    label: 'Tyco',
    value: 944,
  },
  {
    label: 'Reserve Bank of India',
    value: 945,
  },
  {
    label: 'Advance Group',
    value: 946,
  },
  {
    label: 'National Instruments',
    value: 947,
  },
  {
    label: 'Big 4 Consulting Firm',
    value: 948,
  },
  {
    label: 'Firepro Systems Private Limited',
    value: 949,
  },
  {
    label: 'Arvind Lifestyle Brands',
    value: 950,
  },
  {
    label: 'ABP Pvt Ltd',
    value: 951,
  },
  {
    label: 'Greenply Industries Limited',
    value: 952,
  },
  {
    label: 'Symphony Services',
    value: 953,
  },
  {
    label: 'Allied Blenders & Distillers Pvt. Ltd',
    value: 954,
  },
  {
    label: 'Keane India',
    value: 955,
  },
  {
    label: 'Heidrick & Struggles',
    value: 956,
  },
  {
    label: 'Proptiger Realty',
    value: 957,
  },
  {
    label: 'IIM Lucknow',
    value: 958,
  },
  {
    label: 'Pulsar Knowledge Centre',
    value: 959,
  },
  {
    label: 'Elixir Web solutions',
    value: 960,
  },
  {
    label: 'HDFC Life',
    value: 961,
  },
  {
    label: 'Fiat India Automobiles Ltd',
    value: 962,
  },
  {
    label: 'Entertainment Network India Limited',
    value: 963,
  },
  {
    label: 'Max Healthcare',
    value: 964,
  },
  {
    label: 'Dewan Housing Finance Corporation Limited',
    value: 965,
  },
  {
    label: 'Apalya Technologies',
    value: 966,
  },
  {
    label: 'Valvoline',
    value: 967,
  },
  {
    label: 'Uflex',
    value: 968,
  },
  {
    label: 'HILTI INDIA',
    value: 969,
  },
  {
    label: 'SAS',
    value: 970,
  },
  {
    label: 'Asit C. Mehta Investment Interrmediates Ltd.',
    value: 971,
  },
  {
    label: 'Syncapse',
    value: 972,
  },
  {
    label: 'Pangea3',
    value: 973,
  },
  {
    label: 'Enam Securities',
    value: 974,
  },
  {
    label: 'Vmware',
    value: 975,
  },
  {
    label: 'PropEquity Analytics',
    value: 976,
  },
  {
    label: 'Turner India',
    value: 977,
  },
  {
    label: 'Anthelio Business Technologies',
    value: 978,
  },
  {
    label: 'Electrosteel Steels Limited',
    value: 979,
  },
  {
    label: 'Cians Analytics',
    value: 980,
  },
  {
    label: 'Ma Foi',
    value: 981,
  },
  {
    label: 'Cybertech Systems & Software',
    value: 982,
  },
  {
    label: 'GVK Biosciences',
    value: 983,
  },
  {
    label: 'Allegis Group',
    value: 984,
  },
  {
    label: 'Fareportal India',
    value: 985,
  },
  {
    label: 'Canara Bank',
    value: 986,
  },
  {
    label: 'Future Capital Holdings Limited',
    value: 987,
  },
  {
    label: 'CB Richard Ellis',
    value: 988,
  },
  {
    label: 'Rio Tinto India',
    value: 989,
  },
  {
    label: 'Roamware',
    value: 990,
  },
  {
    label: 'People Interactive',
    value: 991,
  },
  {
    label: 'Cairn Energy',
    value: 992,
  },
  {
    label: 'Cleartrip.com',
    value: 993,
  },
  {
    label: 'Gitanjali Gems Limited',
    value: 994,
  },
  {
    label: 'BGR Energy Systems',
    value: 995,
  },
  {
    label: 'Fabindia Overseas Pvt Ltd',
    value: 996,
  },
  {
    label: 'Axtria',
    value: 997,
  },
  {
    label: 'Healthcare',
    value: 998,
  },
  {
    label: 'Bharat Aluminium Company Limited',
    value: 999,
  },
  {
    label: 'Cvent',
    value: 1000,
  },
  {
    label: 'HyperCITY Retail',
    value: 1001,
  },
  {
    label: 'City Union Bank',
    value: 1002,
  },
  {
    label: 'CHEP India',
    value: 1003,
  },
  {
    label: 'Asian Institute Of Management',
    value: 1004,
  },
  {
    label: 'Lodha & Co.',
    value: 1005,
  },
  {
    label: 'GAIL',
    value: 1006,
  },
  {
    label: 'Oxigen Services',
    value: 1007,
  },
  {
    label: 'Sobha Developers',
    value: 1008,
  },
  {
    label: 'Luxor',
    value: 1009,
  },
  {
    label: 'Beam Global',
    value: 1010,
  },
  {
    label: 'Essex Lake Group',
    value: 1011,
  },
  {
    label: 'TVC Sky Shop',
    value: 1012,
  },
  {
    label: 'XLRI',
    value: 1013,
  },
  {
    label: 'i-maritime Consultancy',
    value: 1014,
  },
  {
    label: 'Macmillan',
    value: 1015,
  },
  {
    label: 'Rolta India',
    value: 1016,
  },
  {
    label: 'Acer',
    value: 1017,
  },
  {
    label: 'BMA Wealth Creators',
    value: 1018,
  },
  {
    label: 'PE Electronics',
    value: 1019,
  },
  {
    label: 'Drishti Soft',
    value: 1020,
  },
  {
    label: 'Broadcom',
    value: 1021,
  },
  {
    label: 'Extramarks Education',
    value: 1022,
  },
  {
    label: 'BPTP',
    value: 1023,
  },
  {
    label: 'Aon',
    value: 1024,
  },
  {
    label: 'Johnson Controls',
    value: 1025,
  },
  {
    label: 'Ambuja Cements Limited',
    value: 1026,
  },
  {
    label: 'BPO',
    value: 1027,
  },
  {
    label: 'Diebold',
    value: 1028,
  },
  {
    label: 'East India Securities',
    value: 1029,
  },
  {
    label: 'Universal Consulting',
    value: 1030,
  },
  {
    label: 'Infibeam.com',
    value: 1031,
  },
  {
    label: 'Medtronic',
    value: 1032,
  },
  {
    label: 'Grainger India',
    value: 1033,
  },
  {
    label: 'FREECULTR.COM',
    value: 1034,
  },
  {
    label: 'DENSO',
    value: 1035,
  },
  {
    label: 'Madura Coats',
    value: 1036,
  },
  {
    label: 'Batlivala & Karani Securities (India) Pvt. Ltd',
    value: 1037,
  },
  {
    label: 'UB Group',
    value: 1038,
  },
  {
    label: 'Lilliput',
    value: 1039,
  },
  {
    label: 'DS Group',
    value: 1040,
  },
  {
    label: 'CA',
    value: 1041,
  },
  {
    label: 'DenuoSource',
    value: 1042,
  },
  {
    label: 'PKF Sridhar & Santhanam',
    value: 1043,
  },
  {
    label: 'Construction',
    value: 1044,
  },
  {
    label: 'Alembic Pharmaceuticals',
    value: 1045,
  },
  {
    label: 'Mylan',
    value: 1046,
  },
  {
    label: 'Kochar Infotech',
    value: 1047,
  },
  {
    label: 'Rediff.com',
    value: 1048,
  },
  {
    label: 'Arshiya Supply Chain Management',
    value: 1049,
  },
  {
    label: 'Hilton',
    value: 1050,
  },
  {
    label: 'Dolcera',
    value: 1051,
  },
  {
    label: 'Powerwave Technologies',
    value: 1052,
  },
  {
    label: 'BSNL',
    value: 1053,
  },
  {
    label: 'Nivea',
    value: 1054,
  },
  {
    label: 'H & R Johnson',
    value: 1055,
  },
  {
    label: 'ThoughtWorks',
    value: 1056,
  },
  {
    label: 'Marks & Spencer',
    value: 1057,
  },
  {
    label: 'Cybage Software',
    value: 1058,
  },
  {
    label: 'Inkfruit.com',
    value: 1059,
  },
  {
    label: 'Flextronics',
    value: 1060,
  },
  {
    label: 'Alcor',
    value: 1061,
  },
  {
    label: 'EXECUTIVE SEARCH',
    value: 1062,
  },
  {
    label: 'Marwadi Shares & Finance Limited',
    value: 1063,
  },
  {
    label: 'Virgin',
    value: 1064,
  },
  {
    label: 'Legal',
    value: 1065,
  },
  {
    label: 'Network18 Group',
    value: 1066,
  },
  {
    label: 'Expedia',
    value: 1067,
  },
  {
    label: 'Accretive Health',
    value: 1068,
  },
  {
    label: 'Handygo Technologies',
    value: 1069,
  },
  {
    label: 'Endeavor Careers',
    value: 1070,
  },
  {
    label: 'Aspiring Minds Assessment Private Limited',
    value: 1071,
  },
  {
    label: 'GMR Hyderabad International Airport',
    value: 1072,
  },
  {
    label: 'GFK Mode',
    value: 1073,
  },
  {
    label: 'Redwood Associates',
    value: 1074,
  },
  {
    label: 'Justdial',
    value: 1075,
  },
  {
    label: 'GVK Power & Infrastructure Limited',
    value: 1076,
  },
  {
    label: 'Trianz',
    value: 1077,
  },
  {
    label: 'beStylish.com',
    value: 1078,
  },
  {
    label: 'Helios & Matheson',
    value: 1079,
  },
  {
    label: 'Hathway',
    value: 1080,
  },
  {
    label: 'DSP BlackRock Investment Managers',
    value: 1081,
  },
  {
    label: 'Adidas',
    value: 1082,
  },
  {
    label: 'Bajaj Corp',
    value: 1083,
  },
  {
    label: 'CDAC',
    value: 1084,
  },
  {
    label: 'Healthkart.com',
    value: 1085,
  },
  {
    label: 'Jain Group',
    value: 1086,
  },
  {
    label: 'AT & T',
    value: 1087,
  },
  {
    label: 'Reed Elsevier',
    value: 1088,
  },
  {
    label: 'Experian Credit Information Company',
    value: 1089,
  },
  {
    label: 'PVR',
    value: 1090,
  },
  {
    label: 'Air India Limited',
    value: 1091,
  },
  {
    label: 'Motherson Group',
    value: 1092,
  },
  {
    label: 'Yodlee',
    value: 1093,
  },
  {
    label: 'Kodak',
    value: 1094,
  },
  {
    label: 'IIM Calcutta',
    value: 1095,
  },
  {
    label: 'Escorts Agri Machinery',
    value: 1096,
  },
  {
    label: 'Eli Lilly and Company',
    value: 1097,
  },
  {
    label: 'Investment Banking',
    value: 1098,
  },
  {
    label: 'Frankfinn Institute of Air Hostess Training',
    value: 1099,
  },
  {
    label: 'Berkadia Commercial Mortgage',
    value: 1100,
  },
  {
    label: 'Asset Reconstruction Company (India) Limited',
    value: 1101,
  },
  {
    label: 'Others',
    value: 1102,
  },
  {
    label: 'IIM Ahmedabad',
    value: 1103,
  },
  {
    label: 'Komli Media',
    value: 1104,
  },
  {
    label: 'Go Airlines',
    value: 1105,
  },
  {
    label: 'Exevo India',
    value: 1106,
  },
  {
    label: 'Peninsula Land',
    value: 1107,
  },
  {
    label: 'MTR Foods',
    value: 1108,
  },
  {
    label: 'Royal Sundaram',
    value: 1109,
  },
  {
    label: 'Smile Group',
    value: 1110,
  },
  {
    label: 'Globe Capital Market',
    value: 1111,
  },
  {
    label: 'Alok Industries',
    value: 1112,
  },
  {
    label: 'Utsav Fashion',
    value: 1113,
  },
  {
    label: 'BlackBerry',
    value: 1114,
  },
  {
    label: 'DB Schenker',
    value: 1115,
  },
  {
    label: 'Haldiram',
    value: 1116,
  },
  {
    label: 'Tupperware',
    value: 1117,
  },
  {
    label: 'GVK EMRI',
    value: 1118,
  },
  {
    label: 'Elder Health Care Limited',
    value: 1119,
  },
  {
    label: 'UTU',
    value: 1120,
  },
  {
    label: 'Trefis',
    value: 1121,
  },
  {
    label: 'Bharat Forge',
    value: 1122,
  },
  {
    label: 'Khaitan & Co',
    value: 1123,
  },
  {
    label: 'Brightpoint India',
    value: 1124,
  },
  {
    label: 'GTL Infrastructure Limited',
    value: 1125,
  },
  {
    label: 'Harman International',
    value: 1126,
  },
  {
    label: 'CNBC-TV18',
    value: 1127,
  },
  {
    label: 'Government of India',
    value: 1128,
  },
  {
    label: 'IIT Delhi',
    value: 1129,
  },
  {
    label: 'Havas Media',
    value: 1130,
  },
  {
    label: 'HLL Lifecare',
    value: 1131,
  },
  {
    label: 'India Yamaha Motor',
    value: 1132,
  },
  {
    label: 'CK Birla Group',
    value: 1133,
  },
  {
    label: 'PBO Plus Consulting',
    value: 1134,
  },
  {
    label: 'McCann',
    value: 1135,
  },
  {
    label: 'Coffee Day Beverages',
    value: 1136,
  },
  {
    label: 'CitiusTech',
    value: 1137,
  },
  {
    label: 'Amity Business School',
    value: 1138,
  },
  {
    label: 'Emerson',
    value: 1139,
  },
  {
    label: 'British Council',
    value: 1140,
  },
  {
    label: 'Bureau Veritas',
    value: 1141,
  },
  {
    label: 'Decimal Point Analytics',
    value: 1142,
  },
  {
    label: 'Frigoglass Group',
    value: 1143,
  },
  {
    label: 'aurionPro',
    value: 1144,
  },
  {
    label: 'National Payments Corporation of India',
    value: 1145,
  },
  {
    label: 'Bank Muscat',
    value: 1146,
  },
  {
    label: 'Progressive Media Group',
    value: 1147,
  },
  {
    label: 'Rabobank',
    value: 1148,
  },
  {
    label: 'Ingram Micro',
    value: 1149,
  },
  {
    label: 'N/A',
    value: 1150,
  },
  {
    label: 'Amalgamated Bean Coffee Trading Company',
    value: 1151,
  },
  {
    label: 'India Factoring & Finance Solutions Private Limited',
    value: 1152,
  },
  {
    label: 'Capital Fortunes',
    value: 1153,
  },
  {
    label: 'Euronet Services India Private Limited',
    value: 1154,
  },
  {
    label: 'Arcil',
    value: 1155,
  },
  {
    label: 'Adfactors PR',
    value: 1156,
  },
  {
    label: 'Intas Pharmaceuticals',
    value: 1157,
  },
  {
    label: 'Janalakshmi Financial Services',
    value: 1158,
  },
  {
    label: 'AZ Research Partners',
    value: 1159,
  },
  {
    label: 'Dharampal Satyapal Limited',
    value: 1160,
  },
  {
    label: 'Daiwa Capital Market India Pvt.Ltd',
    value: 1161,
  },
  {
    label: 'Cinepolis India Pvt. Ltd.',
    value: 1162,
  },
  {
    label: 'Antique Stock Broking',
    value: 1163,
  },
  {
    label: 'Apollo Health and Lifestyle',
    value: 1164,
  },
  {
    label: 'Western Union',
    value: 1165,
  },
  {
    label: 'Tata Advanced Systems',
    value: 1166,
  },
  {
    label: 'Matrimony.com',
    value: 1167,
  },
  {
    label: 'Stanley Black & Decker',
    value: 1168,
  },
  {
    label: 'Halliburton',
    value: 1169,
  },
  {
    label: 'Hettich',
    value: 1170,
  },
  {
    label: 'Anchor Electricals',
    value: 1171,
  },
  {
    label: 'Meru Cabs',
    value: 1172,
  },
  {
    label: 'Colliers International',
    value: 1173,
  },
  {
    label: 'Amara Raja Batteries Limited',
    value: 1174,
  },
  {
    label: 'INOX Group',
    value: 1175,
  },
  {
    label: 'Capitalvia',
    value: 1176,
  },
  {
    label: 'Acropetal Technologies Limited',
    value: 1177,
  },
  {
    label: 'Nike',
    value: 1178,
  },
  {
    label: 'Annik Technology Services',
    value: 1179,
  },
  {
    label: 'Areva',
    value: 1180,
  },
  {
    label: 'FIITJEE',
    value: 1181,
  },
  {
    label: 'Asahi India',
    value: 1182,
  },
  {
    label: 'IIM Rohtak',
    value: 1183,
  },
  {
    label: 'Vistaar Finance',
    value: 1184,
  },
  {
    label: 'Haribhakti & Co',
    value: 1185,
  },
  {
    label: 'Centrum Broking Pvt Ltd',
    value: 1186,
  },
  {
    label: 'FLSmidth',
    value: 1187,
  },
  {
    label: 'Artech Infosystems',
    value: 1188,
  },
  {
    label: 'Radico Khaitan',
    value: 1189,
  },
  {
    label: 'IREO',
    value: 1190,
  },
  {
    label: 'Economic Times',
    value: 1191,
  },
  {
    label: 'Teach For India',
    value: 1192,
  },
  {
    label: 'AOL',
    value: 1193,
  },
  {
    label: 'Cubastion Consulting',
    value: 1194,
  },
  {
    label: 'Estee Advisors',
    value: 1195,
  },
  {
    label: 'Hansa Research',
    value: 1196,
  },
  {
    label: 'Marriott',
    value: 1197,
  },
  {
    label: 'Drive India Enterprise Solutions Limited',
    value: 1198,
  },
  {
    label: 'Forbes Marshall',
    value: 1199,
  },
  {
    label: 'Alpha Payment Services',
    value: 1200,
  },
  {
    label: 'Right Management',
    value: 1201,
  },
  {
    label: 'FirstRand Bank',
    value: 1202,
  },
  {
    label: 'AMD',
    value: 1203,
  },
  {
    label: 'Gallup',
    value: 1204,
  },
  {
    label: 'Channelplay Limited',
    value: 1205,
  },
  {
    label: 'Alliance University',
    value: 1206,
  },
  {
    label: 'Delhi International Airport',
    value: 1207,
  },
  {
    label: 'Consim Info Pvt Ltd',
    value: 1208,
  },
  {
    label: 'Ester Industries Limited',
    value: 1209,
  },
  {
    label: 'Consultancy',
    value: 1210,
  },
  {
    label: 'DSM India',
    value: 1211,
  },
  {
    label: 'Sales',
    value: 1212,
  },
  {
    label: 'redBus.in',
    value: 1213,
  },
  {
    label: 'VRS Foods',
    value: 1214,
  },
  {
    label: 'Allcargo Logistics',
    value: 1215,
  },
  {
    label: 'Timex Group',
    value: 1216,
  },
  {
    label: 'Derivium Tradition',
    value: 1217,
  },
  {
    label: 'Asian Business Exhibition & Conferences Ltd',
    value: 1218,
  },
  {
    label: 'Family Business',
    value: 1219,
  },
  {
    label: 'Samsonite South Asia Pvt Ltd',
    value: 1220,
  },
  {
    label: 'Actuate Business Consulting',
    value: 1221,
  },
  {
    label: 'D&B TransUnion',
    value: 1222,
  },
  {
    label: 'Apollo Munich Health Insurance',
    value: 1223,
  },
  {
    label: 'CoreEL Technologies',
    value: 1224,
  },
  {
    label: 'ITM',
    value: 1225,
  },
  {
    label: 'Corbus India Limited',
    value: 1226,
  },
  {
    label: 'First American Financial Corporation',
    value: 1227,
  },
  {
    label: 'Lintas',
    value: 1228,
  },
  {
    label: 'Development Bank of Singapore',
    value: 1229,
  },
  {
    label: 'Mercedes Benz',
    value: 1230,
  },
  {
    label: 'Centaurus Financial Services',
    value: 1231,
  },
  {
    label: 'Oriflame',
    value: 1232,
  },
  {
    label: 'Hamdard',
    value: 1233,
  },
  {
    label: 'Tata Administrative Services',
    value: 1234,
  },
  {
    label: 'Butterfly Appliances',
    value: 1235,
  },
  {
    label: 'Bharti Realty',
    value: 1236,
  },
  {
    label: 'CenturyLink',
    value: 1237,
  },
  {
    label: 'Gitanjali Lifestyle',
    value: 1238,
  },
  {
    label: 'BMW India',
    value: 1239,
  },
  {
    label: 'Amadeus',
    value: 1240,
  },
  {
    label: 'Greaves Cotton Limited',
    value: 1241,
  },
  {
    label: 'Bunge India',
    value: 1242,
  },
  {
    label: 'Asia MotorWorks',
    value: 1243,
  },
  {
    label: 'Fluor Daniel India',
    value: 1244,
  },
  {
    label: 'Daikin Airconditioning India Private Limited',
    value: 1245,
  },
  {
    label: 'Defence',
    value: 1246,
  },
  {
    label: 'Devyani International',
    value: 1247,
  },
  {
    label: 'SIDBI',
    value: 1248,
  },
  {
    label: 'National Institute for Smart Government',
    value: 1249,
  },
  {
    label: 'Exilant Technologies',
    value: 1250,
  },
  {
    label: 'Walt Dinsey',
    value: 1251,
  },
  {
    label: 'Delta Power Solutions',
    value: 1252,
  },
  {
    label: 'Dena Bank',
    value: 1253,
  },
  {
    label: 'Assistant Manager',
    value: 1254,
  },
  {
    label: 'Kimberly-Clark',
    value: 1255,
  },
  {
    label: 'Lovely Professional University',
    value: 1256,
  },
  {
    label: 'Rediffusion - Y&R',
    value: 1257,
  },
  {
    label: 'Indian Commodity Exchange Limited',
    value: 1258,
  },
  {
    label: 'SKF India Ltd',
    value: 1259,
  },
  {
    label: 'BMR & Associates',
    value: 1260,
  },
  {
    label: 'Ebusinessware',
    value: 1261,
  },
  {
    label: 'AGS Transact Technologies',
    value: 1262,
  },
  {
    label: 'Strategic Decisions Group',
    value: 1263,
  },
  {
    label: 'Carrefour',
    value: 1264,
  },
  {
    label: 'PTC',
    value: 1265,
  },
  {
    label: 'Carl Zeiss',
    value: 1266,
  },
  {
    label: 'Rocsearch',
    value: 1267,
  },
  {
    label: 'Defiance Technologies',
    value: 1268,
  },
  {
    label: 'Narayana Hrudayalaya',
    value: 1269,
  },
  {
    label: 'Multi Commodity Exchange Of India',
    value: 1270,
  },
  {
    label: 'Ecommerce',
    value: 1271,
  },
  {
    label: 'Electronica Finance Limited',
    value: 1272,
  },
  {
    label: 'Allergan India Private Limited',
    value: 1273,
  },
  {
    label: 'Kotak Life Insurance',
    value: 1274,
  },
  {
    label: 'Amira Group',
    value: 1275,
  },
  {
    label: 'Simplex Infrastructure',
    value: 1276,
  },
  {
    label: 'IE Business School',
    value: 1277,
  },
  {
    label: 'MedPlus',
    value: 1278,
  },
  {
    label: 'Olympus Imaging',
    value: 1279,
  },
  {
    label: 'Crossdomain Solutions Private Limited',
    value: 1280,
  },
  {
    label: 'Elixir Consulting',
    value: 1281,
  },
  {
    label: 'Antal International',
    value: 1282,
  },
  {
    label: 'Global Groupware Solutions',
    value: 1283,
  },
  {
    label: 'Payoda',
    value: 1284,
  },
  {
    label: 'New Holland Fiat India',
    value: 1285,
  },
  {
    label: 'South Indian Bank',
    value: 1286,
  },
  {
    label: 'GE Money',
    value: 1287,
  },
  {
    label: 'Organization',
    value: 1288,
  },
  {
    label: 'GHCL Limited',
    value: 1289,
  },
  {
    label: 'M3M',
    value: 1290,
  },
  {
    label: 'B&K Securities',
    value: 1291,
  },
  {
    label: 'Azure Power',
    value: 1292,
  },
  {
    label: 'Polycab Wires & Cables',
    value: 1293,
  },
  {
    label: 'Pentair',
    value: 1294,
  },
  {
    label: "Standard & Poor's",
    value: 1295,
  },
  {
    label: 'DTZ International',
    value: 1296,
  },
  {
    label: 'AXA Technology Services',
    value: 1297,
  },
  {
    label: 'HIL Ltd.',
    value: 1298,
  },
  {
    label: 'Gartner',
    value: 1299,
  },
  {
    label: 'India Today Group',
    value: 1300,
  },
  {
    label: 'Lumata Digital',
    value: 1301,
  },
  {
    label: 'Haier Appliances',
    value: 1302,
  },
  {
    label: 'PNB Housing Finance Limited',
    value: 1303,
  },
  {
    label: 'Anvil Share & Stock Broking Pvt. Ltd',
    value: 1304,
  },
  {
    label: 'Promed Group',
    value: 1305,
  },
  {
    label: 'Digitas',
    value: 1306,
  },
  {
    label: 'APM Terminals',
    value: 1307,
  },
  {
    label: 'pharma',
    value: 1308,
  },
  {
    label: 'Coastal Projects Limited',
    value: 1309,
  },
  {
    label: 'CreditPointe',
    value: 1310,
  },
  {
    label: 'Microland',
    value: 1311,
  },
  {
    label: 'ESPN Software India Private Limited',
    value: 1312,
  },
  {
    label: 'Hyderabad Industries Limited',
    value: 1313,
  },
  {
    label: 'Capital Square Advisors Pvt Ltd',
    value: 1314,
  },
  {
    label: 'Affine Analytics',
    value: 1315,
  },
  {
    label: 'CommonFloor.com',
    value: 1316,
  },
  {
    label: 'IMT',
    value: 1317,
  },
  {
    label: 'Customer Centria Enterprise Pvt Ltd',
    value: 1318,
  },
  {
    label: 'Nippon Paints',
    value: 1319,
  },
  {
    label: 'The Bombay Dyeing & Mfg Co Ltd',
    value: 1320,
  },
  {
    label: 'Tata Consultancy Services',
    value: 1321,
  },
  {
    label: 'HR Anexi',
    value: 1322,
  },
  {
    label: 'YASH Technologies',
    value: 1323,
  },
  {
    label: 'Manhattan Associates',
    value: 1324,
  },
  {
    label: 'Puma',
    value: 1325,
  },
  {
    label: 'BBC',
    value: 1326,
  },
  {
    label: 'Vijaya Bank',
    value: 1327,
  },
  {
    label: 'no experience',
    value: 1328,
  },
  {
    label: 'Emcure Pharamaceuticals',
    value: 1329,
  },
  {
    label: 'B Braun Medical India Pvt Limited',
    value: 1330,
  },
  {
    label: 'Futurestep',
    value: 1331,
  },
  {
    label: 'Subex Limited',
    value: 1332,
  },
  {
    label: 'Credit Agricole CIB',
    value: 1333,
  },
  {
    label: 'Gateway Rail Freight Limited',
    value: 1334,
  },
  {
    label: 'Gyansys',
    value: 1335,
  },
  {
    label: 'Datawise Consultants',
    value: 1336,
  },
  {
    label: 'Hero Corporate Services',
    value: 1337,
  },
  {
    label: 'Bechtel Corporation',
    value: 1338,
  },
  {
    label: 'Amrop India',
    value: 1339,
  },
  {
    label: 'Phillip Capital',
    value: 1340,
  },
  {
    label: 'AuthBridge Research Services',
    value: 1341,
  },
  {
    label: 'Globacom',
    value: 1342,
  },
  {
    label: 'Fedbank Financial Services Ltd',
    value: 1343,
  },
  {
    label: 'Choice Solutions Limited',
    value: 1345,
  },
  {
    label: 'Aircom International',
    value: 1346,
  },
  {
    label: 'Auctus Advisors',
    value: 1347,
  },
  {
    label: 'iimjobs.com',
    value: 1348,
  },
  {
    label: 'Visteon',
    value: 1349,
  },
  {
    label: 'NCR CORPORATION',
    value: 1350,
  },
  {
    label: 'EICL Limited',
    value: 1351,
  },
  {
    label: 'Quant Capital',
    value: 1352,
  },
  {
    label: 'KSK Energy Ventures Limited',
    value: 1353,
  },
  {
    label: 'McCANN Erickson',
    value: 1354,
  },
  {
    label: 'Government of Gujarat',
    value: 1355,
  },
  {
    label: 'Max Hypermarket',
    value: 1356,
  },
  {
    label: 'Fortune Financial Services',
    value: 1357,
  },
  {
    label: 'Naaptol.com',
    value: 1358,
  },
  {
    label: 'Monitor Group',
    value: 1359,
  },
  {
    label: 'Mirah Group',
    value: 1360,
  },
  {
    label: 'Elecon',
    value: 1361,
  },
  {
    label: 'Lowe Lintas',
    value: 1362,
  },
  {
    label: 'First Flight Couriers Ltd',
    value: 1363,
  },
  {
    label: 'Altruist Technologies',
    value: 1364,
  },
  {
    label: 'Contract Advertising',
    value: 1365,
  },
  {
    label: 'Indian Bank',
    value: 1367,
  },
  {
    label: 'FinIQ Consulting',
    value: 1368,
  },
  {
    label: 'Dexter Consultancy Private Limited',
    value: 1369,
  },
  {
    label: 'Knowledgefaber',
    value: 1370,
  },
  {
    label: 'Hospitality',
    value: 1371,
  },
  {
    label: 'Nimbus',
    value: 1372,
  },
  {
    label: 'United Technologies Corporation',
    value: 1373,
  },
  {
    label: 'Equifax Credit Information Services',
    value: 1374,
  },
  {
    label: 'Kelly Services',
    value: 1375,
  },
  {
    label: 'Flagstone Reinsurance',
    value: 1376,
  },
  {
    label: 'Punjab National Bank',
    value: 1377,
  },
  {
    label: 'PUG Securities',
    value: 1378,
  },
  {
    label: 'Intuit',
    value: 1379,
  },
  {
    label: 'Hays',
    value: 1380,
  },
  {
    label: 'Planman Media',
    value: 1381,
  },
  {
    label: 'Nissan',
    value: 1382,
  },
  {
    label: 'Petrofac',
    value: 1383,
  },
  {
    label: 'Audit',
    value: 1384,
  },
  {
    label: 'Planman Consulting',
    value: 1385,
  },
  {
    label: 'Arval India Private Limited',
    value: 1386,
  },
  {
    label: 'Lohia Group',
    value: 1387,
  },
  {
    label: 'XL India',
    value: 1388,
  },
  {
    label: 'vCustomer',
    value: 1389,
  },
  {
    label: 'GIC Housing Finance',
    value: 1390,
  },
  {
    label: 'Aptech',
    value: 1391,
  },
  {
    label: 'Williams Lea',
    value: 1392,
  },
  {
    label: 'Cross Tab Marketing Services',
    value: 1393,
  },
  {
    label: 'Group Concorde',
    value: 1394,
  },
  {
    label: 'iimjobs',
    value: 1395,
  },
  {
    label: "Sainsbury's",
    value: 1396,
  },
  {
    label: 'DIESL',
    value: 1397,
  },
  {
    label: 'Babyoye.com',
    value: 1398,
  },
  {
    label: 'plugHR',
    value: 1399,
  },
  {
    label: 'Jyothy Laboratories Limited',
    value: 1400,
  },
  {
    label: 'Exemplarr Worldwide',
    value: 1401,
  },
  {
    label: 'SunLife Financial',
    value: 1402,
  },
  {
    label: 'enStage',
    value: 1403,
  },
  {
    label: 'Aditi Technologies',
    value: 1404,
  },
  {
    label: 'Capital Market Publishers',
    value: 1405,
  },
  {
    label: 'ANB Consulting',
    value: 1406,
  },
  {
    label: 'OLA cabs',
    value: 1407,
  },
  {
    label: 'Mawana Sugars',
    value: 1408,
  },
  {
    label: 'N/A',
    value: 1409,
  },
  {
    label: 'Firefly e Ventures',
    value: 1410,
  },
  {
    label: 'Global Innovsource',
    value: 1411,
  },
  {
    label: 'Lotte',
    value: 1412,
  },
  {
    label: 'Edenred',
    value: 1413,
  },
  {
    label: 'ING Investment Management',
    value: 1414,
  },
  {
    label: 'Aspire Systems',
    value: 1415,
  },
  {
    label: 'Earth Infrastructures Ltd.',
    value: 1416,
  },
  {
    label: 'Kantar Operations',
    value: 1417,
  },
  {
    label: 'Not working currently',
    value: 1418,
  },
  {
    label: 'Saregama',
    value: 1419,
  },
  {
    label: 'Emirates NBD',
    value: 1420,
  },
  {
    label: 'Centre for Monitoring Indian Economy Pvt. Ltd.',
    value: 1421,
  },
  {
    label: 'Philips',
    value: 1422,
  },
  {
    label: 'Avnet Technology Solutions',
    value: 1423,
  },
  {
    label: 'Amicorp Advisory Services',
    value: 1424,
  },
  {
    label: 'Flytxt Mobile Solutions',
    value: 1425,
  },
  {
    label: 'Force Motors Limited',
    value: 1426,
  },
  {
    label: 'ICI Paints',
    value: 1427,
  },
  {
    label: 'AF-Mercados EMI',
    value: 1428,
  },
  {
    label: 'Citi Group',
    value: 1429,
  },
  {
    label: 'AllCheckDeals India Private Limited',
    value: 1430,
  },
  {
    label: 'Federal Mogul',
    value: 1431,
  },
  {
    label: 'Blue Dart Express',
    value: 1432,
  },
  {
    label: 'Fedders Lloyd Corporation Limited',
    value: 1433,
  },
  {
    label: 'Manthan Services',
    value: 1434,
  },
  {
    label: 'Indus Business Academy',
    value: 1435,
  },
  {
    label: 'marketRx',
    value: 1436,
  },
  {
    label: 'Invesco',
    value: 1437,
  },
  {
    label: 'PI Industries',
    value: 1438,
  },
  {
    label: 'FMS',
    value: 1439,
  },
  {
    label: 'Forrester Research',
    value: 1440,
  },
  {
    label: 'GVK',
    value: 1441,
  },
  {
    label: 'HEC Paris',
    value: 1442,
  },
  {
    label: 'MDI, Gurgaon',
    value: 1443,
  },
  {
    label: 'Alankit Assignments Ltd',
    value: 1444,
  },
  {
    label: 'Intellecap',
    value: 1445,
  },
  {
    label: 'Amra Renal Care',
    value: 1446,
  },
  {
    label: 'Oyster Learning',
    value: 1447,
  },
  {
    label: 'Unifi Capital',
    value: 1448,
  },
  {
    label: 'Outsource Partners International',
    value: 1449,
  },
  {
    label: 'Hero Mindmine',
    value: 1450,
  },
  {
    label: 'Citrix Systems',
    value: 1451,
  },
  {
    label: 'Fetise Retail Pvt Ltd',
    value: 1452,
  },
  {
    label: 'Future Focus Infotech Pvt Ltd',
    value: 1453,
  },
  {
    label: 'Tetra Pak',
    value: 1454,
  },
  {
    label: 'Compass Group',
    value: 1455,
  },
  {
    label: 'Global eProcure',
    value: 1456,
  },
  {
    label: 'Dassault Systems',
    value: 1457,
  },
  {
    label: 'test',
    value: 1458,
  },
  {
    label: 'Green Infra Limited',
    value: 1459,
  },
  {
    label: 'Equirus Securities',
    value: 1460,
  },
  {
    label: 'Gameshastra',
    value: 1461,
  },
  {
    label: 'Pharmaceutical',
    value: 1462,
  },
  {
    label: 'Firstsource',
    value: 1463,
  },
  {
    label: 'DNA',
    value: 1464,
  },
  {
    label: 'Risk Management Solutions',
    value: 1465,
  },
  {
    label: 'Philips Healthcare',
    value: 1466,
  },
  {
    label: 'University',
    value: 1467,
  },
  {
    label: 'Ashok Piramal Group',
    value: 1468,
  },
  {
    label: 'DFM Foods Limited',
    value: 1469,
  },
  {
    label: 'IBS Hyderabad',
    value: 1470,
  },
  {
    label: 'Progressive Infotech',
    value: 1471,
  },
  {
    label: 'Quintiles',
    value: 1472,
  },
  {
    label: 'Zovi.com',
    value: 1473,
  },
  {
    label: 'CRMIT Solutions',
    value: 1474,
  },
  {
    label: 'Progressive Digital Media',
    value: 1475,
  },
  {
    label: 'Allsec Technologies',
    value: 1476,
  },
  {
    label: 'Practo',
    value: 1477,
  },
  {
    label: 'Diligent Media Corporation',
    value: 1478,
  },
  {
    label: 'Contakt Tech Solutions',
    value: 1479,
  },
  {
    label: 'Mapmyindia',
    value: 1480,
  },
  {
    label: 'Pyramid IT Consulting',
    value: 1481,
  },
  {
    label: 'Grassik Search',
    value: 1482,
  },
  {
    label: 'Kingdom of Dreams',
    value: 1483,
  },
  {
    label: 'MSD Pharmaceuticals',
    value: 1484,
  },
  {
    label: 'MMTC Limited',
    value: 1485,
  },
  {
    label: 'Ansal API',
    value: 1486,
  },
  {
    label: 'SGS',
    value: 1487,
  },
  {
    label: 'Dodsal E&C India Pvt Ltd',
    value: 1488,
  },
  {
    label: 'NSN',
    value: 1489,
  },
  {
    label: 'Centum Workskills India Ltd',
    value: 1490,
  },
  {
    label: 'Hamilton Housewares',
    value: 1491,
  },
  {
    label: 'Gabriel India Limited',
    value: 1492,
  },
  {
    label: 'G4S',
    value: 1493,
  },
  {
    label: 'NEC',
    value: 1494,
  },
  {
    label: 'jk tyre & industries ltd.',
    value: 1495,
  },
  {
    label: 'IKYA Human Capital Solutions',
    value: 1496,
  },
  {
    label: 'Indigo Consulting',
    value: 1497,
  },
  {
    label: 'Fresenius Kabi',
    value: 1498,
  },
  {
    label: 'Markit',
    value: 1499,
  },
  {
    label: 'InterContinental Hotels Group',
    value: 1500,
  },
  {
    label: 'Ricoh India',
    value: 1501,
  },
  {
    label: 'Bharat Electronics',
    value: 1502,
  },
  {
    label: 'Coca Cola',
    value: 1503,
  },
  {
    label: 'Educational Initiatives',
    value: 1504,
  },
  {
    label: 'Leighton Welspun',
    value: 1505,
  },
  {
    label: 'VISA',
    value: 1506,
  },
  {
    label: 'Dainik Jagran',
    value: 1507,
  },
  {
    label: 'Onestopm.com',
    value: 1508,
  },
  {
    label: 'Huntsman International',
    value: 1509,
  },
  {
    label: 'NBFC',
    value: 1510,
  },
  {
    label: 'Credence Analytics',
    value: 1511,
  },
  {
    label: 'Planning Commission',
    value: 1512,
  },
  {
    label: 'SPJIMR',
    value: 1513,
  },
  {
    label: 'Pearson',
    value: 1514,
  },
  {
    label: 'Danfoss Industries',
    value: 1515,
  },
  {
    label: 'Club Mahindra',
    value: 1516,
  },
  {
    label: 'Future Axiom Telecom Limited',
    value: 1517,
  },
  {
    label: 'Credit Pointe Services Private Ltd.',
    value: 1518,
  },
  {
    label: 'Resultrix',
    value: 1519,
  },
  {
    label: 'Bahwan CyberTek Pvt Ltd',
    value: 1520,
  },
  {
    label: 'Obopay Mobile',
    value: 1521,
  },
  {
    label: 'ExxonMobil',
    value: 1522,
  },
  {
    label: 'SP Jain School of Global Management',
    value: 1523,
  },
  {
    label: 'Vishal Retail',
    value: 1524,
  },
  {
    label: 'Blend Financial Services Limited',
    value: 1525,
  },
  {
    label: 'Outlook',
    value: 1526,
  },
  {
    label: 'Mizuho Corporate Bank',
    value: 1527,
  },
  {
    label: 'CustomerXPs Software Pvt Ltd',
    value: 1528,
  },
  {
    label: 'CLSA',
    value: 1529,
  },
  {
    label: 'Liqvid eLearning Services',
    value: 1530,
  },
  {
    label: 'BG Group',
    value: 1531,
  },
  {
    label: 'The Himalaya Drug Company',
    value: 1532,
  },
  {
    label: 'CRY',
    value: 1533,
  },
  {
    label: 'other',
    value: 1534,
  },
  {
    label: 'HFCL',
    value: 1535,
  },
  {
    label: 'Glodyne Technoserve Limited',
    value: 1536,
  },
  {
    label: 'Eko India Financial Services Private Limited',
    value: 1537,
  },
  {
    label: 'Country Club',
    value: 1538,
  },
  {
    label: 'Hindustan Motors',
    value: 1539,
  },
  {
    label: 'GFB Great Foods Ltd.',
    value: 1540,
  },
  {
    label: 'Valyoo Technologies',
    value: 1541,
  },
  {
    label: 'Doshion Private Limited',
    value: 1542,
  },
  {
    label: 'SCMHRD',
    value: 1543,
  },
  {
    label: 'Berkshire India',
    value: 1544,
  },
  {
    label: 'Eicher',
    value: 1545,
  },
  {
    label: 'Suzuki Motorcycle',
    value: 1546,
  },
  {
    label: 'ELitecore Technologies',
    value: 1547,
  },
  {
    label: 'Gensol Consultant Pvt Ltd',
    value: 1548,
  },
  {
    label: 'Zamil Infra',
    value: 1549,
  },
  {
    label: 'Urbantouch.com',
    value: 1550,
  },
  {
    label: 'Food Corporation of India',
    value: 1551,
  },
  {
    label: 'Tecpro Systems Limited',
    value: 1552,
  },
  {
    label: 'WILLIS',
    value: 1553,
  },
  {
    label: 'PNB Gilts Ltd',
    value: 1554,
  },
  {
    label: 'IMT Nagpur',
    value: 1555,
  },
  {
    label: 'Kancor Ingredients LTD',
    value: 1556,
  },
  {
    label: 'IIM Raipur',
    value: 1557,
  },
  {
    label: 'GT Nexus',
    value: 1558,
  },
  {
    label: 'Knowlarirty Communications',
    value: 1559,
  },
  {
    label: 'Facebook',
    value: 1560,
  },
  {
    label: 'Sumitomo Mitsui Banking Corporation',
    value: 1561,
  },
  {
    label: 'PCS Technology',
    value: 1562,
  },
  {
    label: 'Electronic Arts',
    value: 1563,
  },
  {
    label: 'Advertising',
    value: 1564,
  },
  {
    label: 'Auronova Consulting Private Ltd.',
    value: 1565,
  },
  {
    label: 'Fingerprints Fashions Private Limited',
    value: 1566,
  },
  {
    label: 'Perfect Relations',
    value: 1567,
  },
  {
    label: 'HR Consulting',
    value: 1568,
  },
  {
    label: 'Commonwealth Bank of Australia',
    value: 1569,
  },
  {
    label: 'Polycom',
    value: 1570,
  },
  {
    label: 'Carzonrent India Pvt. Ltd.',
    value: 1571,
  },
  {
    label: 'o3 Capital',
    value: 1572,
  },
  {
    label: 'Berggruen Group',
    value: 1573,
  },
  {
    label: 'Hakuhodo Percept',
    value: 1574,
  },
  {
    label: 'Espirito Santo Investment Bank',
    value: 1575,
  },
  {
    label: 'Institute of Chartered accountants of India',
    value: 1576,
  },
  {
    label: 'Cedar Management Consulting',
    value: 1577,
  },
  {
    label: 'Kalpataru Limited',
    value: 1578,
  },
  {
    label: 'KEC International Ltd',
    value: 1579,
  },
  {
    label: 'Airtel',
    value: 1580,
  },
  {
    label: 'Adroit Financial Services',
    value: 1581,
  },
  {
    label: 'Firmenich Aromatics',
    value: 1582,
  },
  {
    label: 'Sabre Holdings',
    value: 1583,
  },
  {
    label: 'First Advantage',
    value: 1584,
  },
  {
    label: 'Dolat Capital Market Pvt. Ltd.',
    value: 1585,
  },
  {
    label: 'Garware Wall Ropes',
    value: 1586,
  },
  {
    label: 'London Business School',
    value: 1587,
  },
  {
    label: 'Yamaha Motor',
    value: 1588,
  },
  {
    label: 'Oliver Wyman',
    value: 1589,
  },
  {
    label: 'DP World',
    value: 1590,
  },
  {
    label: 'LKP Securities Ltd',
    value: 1591,
  },
  {
    label: 'A. T. Kearney',
    value: 1592,
  },
  {
    label: 'EmPower Research',
    value: 1593,
  },
  {
    label: 'nil',
    value: 1594,
  },
  {
    label: 'Violet Arch Capital Advisors',
    value: 1595,
  },
  {
    label: 'SGS India Pvt Ltd',
    value: 1596,
  },
  {
    label: 'Manthan Systems',
    value: 1597,
  },
  {
    label: 'Edusys Services',
    value: 1598,
  },
  {
    label: 'Parsons Brinckerhoff',
    value: 1599,
  },
  {
    label: 'Embitel',
    value: 1600,
  },
  {
    label: 'Dunia Finance LLC',
    value: 1601,
  },
  {
    label: 'Macleods Pharmaceuticals',
    value: 1602,
  },
  {
    label: 'CAE Simulation Technologies',
    value: 1603,
  },
  {
    label: 'STCI',
    value: 1604,
  },
  {
    label: 'Via.com',
    value: 1605,
  },
  {
    label: 'MaxRange Retail Pvt Ltd',
    value: 1606,
  },
  {
    label: 'HighStreetLabels.com',
    value: 1607,
  },
  {
    label: 'Singhi Advisors',
    value: 1608,
  },
  {
    label: 'Own',
    value: 1609,
  },
  {
    label: 'HBL Global',
    value: 1610,
  },
  {
    label: 'Innovative B2B Logistics',
    value: 1611,
  },
  {
    label: 'Actis',
    value: 1612,
  },
  {
    label: 'IMS',
    value: 1613,
  },
  {
    label: 'ShopClues.com',
    value: 1614,
  },
  {
    label: 'Aurobindo Pharma',
    value: 1615,
  },
  {
    label: 'Lakme Lever',
    value: 1616,
  },
  {
    label: 'Rockwell Automation',
    value: 1617,
  },
  {
    label: 'Texas Instruments',
    value: 1618,
  },
  {
    label: 'Fenwal India Pvt Ltd',
    value: 1619,
  },
  {
    label: 'Pratibha Industries',
    value: 1620,
  },
  {
    label: 'Evotec India Private Limited',
    value: 1621,
  },
  {
    label: 'Hyatt',
    value: 1622,
  },
  {
    label: 'The South Indian Bank Ltd.',
    value: 1623,
  },
  {
    label: 'Benchmark Six Sigma',
    value: 1624,
  },
  {
    label: 'XL DYNAMICS',
    value: 1625,
  },
  {
    label: 'Digicall Teleservices',
    value: 1626,
  },
  {
    label: 'Navatar Group',
    value: 1627,
  },
  {
    label: 'CFA',
    value: 1628,
  },
  {
    label: 'SME Rating Agency of India Limited',
    value: 1629,
  },
  {
    label: 'Alghanim Industries',
    value: 1630,
  },
  {
    label: 'Columbia Asia Hospital',
    value: 1631,
  },
  {
    label: 'Arivum Business Solutions',
    value: 1632,
  },
  {
    label: 'Relio Quick',
    value: 1633,
  },
  {
    label: 'Mindfire Solutions',
    value: 1634,
  },
  {
    label: 'ETA Engineering',
    value: 1635,
  },
  {
    label: 'Alkem Laboratories Limited',
    value: 1636,
  },
  {
    label: 'Welingkar',
    value: 1637,
  },
  {
    label: 'Supertech Limited',
    value: 1638,
  },
  {
    label: 'BASES, The Nielsen Company',
    value: 1639,
  },
  {
    label: 'Mary Kay Cosmetics',
    value: 1640,
  },
  {
    label: 'BOC India Limited',
    value: 1641,
  },
  {
    label: 'US MNC',
    value: 1642,
  },
  {
    label: 'State Street Global Advisors',
    value: 1643,
  },
  {
    label: 'IMImobile',
    value: 1644,
  },
  {
    label: 'KEC INTERNATIONAL LIMITED',
    value: 1645,
  },
  {
    label: 'IIMA',
    value: 1646,
  },
  {
    label: 'Wadia Group',
    value: 1647,
  },
  {
    label: 'Valuelabs',
    value: 1648,
  },
  {
    label: 'RS Software',
    value: 1649,
  },
  {
    label: 'LKP Securities',
    value: 1650,
  },
  {
    label: 'Future Human Development Limited',
    value: 1651,
  },
  {
    label: 'S Tel Private Limited',
    value: 1652,
  },
  {
    label: 'AppsDaily Solutions Private Limited',
    value: 1653,
  },
  {
    label: 'Subex',
    value: 1654,
  },
  {
    label: 'Hiranandani Infrastructure and Real Estate Company',
    value: 1655,
  },
  {
    label: 'Twinings',
    value: 1656,
  },
  {
    label: 'IAF',
    value: 1657,
  },
  {
    label: 'Fossil Inc.',
    value: 1658,
  },
  {
    label: 'Greenback Forex',
    value: 1659,
  },
  {
    label: 'Su-Kam Power',
    value: 1660,
  },
  {
    label: 'Entrepreneur',
    value: 1661,
  },
  {
    label: 'Euro Asia Consulting',
    value: 1662,
  },
  {
    label: 'Careerist Management Consultant Pvt. Ltd.',
    value: 1663,
  },
  {
    label: 'MSFL',
    value: 1664,
  },
  {
    label: 'Ruia Group',
    value: 1665,
  },
  {
    label: 'Kotak Securities',
    value: 1666,
  },
  {
    label: 'Galaxy Surfactants',
    value: 1667,
  },
  {
    label: 'First Data',
    value: 1668,
  },
  {
    label: 'nothing',
    value: 1669,
  },
  {
    label: 'Walchandnagar Industries limited',
    value: 1670,
  },
  {
    label: 'Fenesta Building Systems',
    value: 1671,
  },
  {
    label: 'BEML Ltd',
    value: 1672,
  },
  {
    label: 'Net 4 India Limited',
    value: 1673,
  },
  {
    label: 'Asian Market Securities',
    value: 1674,
  },
  {
    label: 'iTrust Financial Advisors',
    value: 1675,
  },
  {
    label: 'AT Kearney',
    value: 1676,
  },
  {
    label: 'Not employed',
    value: 1677,
  },
  {
    label: 'Ariba',
    value: 1678,
  },
  {
    label: 'Luxottica',
    value: 1679,
  },
  {
    label: 'Synergy Consulting Inc.',
    value: 1680,
  },
  {
    label: 'Parag Milk Foods',
    value: 1681,
  },
  {
    label: 'FCS Software Solution Ltd',
    value: 1682,
  },
  {
    label: 'Hay Group',
    value: 1683,
  },
  {
    label: 'Enam Asset Management Company',
    value: 1684,
  },
  {
    label: 'Focus Shares and Securities',
    value: 1685,
  },
  {
    label: 'MINDLANCE',
    value: 1686,
  },
  {
    label: 'Violet Arch',
    value: 1687,
  },
  {
    label: 'BS Limited',
    value: 1688,
  },
  {
    label: 'FieldFresh Foods Pvt Ltd',
    value: 1689,
  },
  {
    label: 'buytheprice.com',
    value: 1690,
  },
  {
    label: 'Rocket Internet',
    value: 1691,
  },
  {
    label: 'Eos Capital Advisors',
    value: 1692,
  },
  {
    label: 'Brand Capital',
    value: 1693,
  },
  {
    label: 'Bristol Myers Squibb',
    value: 1694,
  },
  {
    label: 'Freudenberg',
    value: 1695,
  },
  {
    label: 'AppLabs',
    value: 1696,
  },
  {
    label: 'Hushbabies.com',
    value: 1697,
  },
  {
    label: 'Orbit Corporation Limited',
    value: 1698,
  },
  {
    label: 'Dana Group',
    value: 1699,
  },
  {
    label: 'Quadrangle',
    value: 1700,
  },
  {
    label: 'ADFC Pvt Ltd',
    value: 1701,
  },
  {
    label: 'FORE School of Management',
    value: 1702,
  },
  {
    label: 'Lear Corporation',
    value: 1703,
  },
  {
    label: 'Narang Group',
    value: 1704,
  },
  {
    label: 'PCS Securities',
    value: 1705,
  },
  {
    label: 'Air Liquide',
    value: 1706,
  },
  {
    label: 'Telenor',
    value: 1707,
  },
  {
    label: 'looking for a job',
    value: 1708,
  },
  {
    label: 'HDB Financial services',
    value: 1709,
  },
  {
    label: 'Itz Cash Card Ltd',
    value: 1710,
  },
  {
    label: 'MetricStream',
    value: 1711,
  },
  {
    label: 'giftcart.com',
    value: 1712,
  },
  {
    label: 'German MNC',
    value: 1713,
  },
  {
    label: 'IDC Technologies',
    value: 1714,
  },
  {
    label: 'Goldstone Technologies Limited',
    value: 1715,
  },
  {
    label: 'The Alchemists Ark Pvt. Ltd.',
    value: 1716,
  },
  {
    label: 'Drshti Strategic Research Services Pvt. Ltd',
    value: 1717,
  },
  {
    label: 'KRChoksey Shares & Securities ltd.',
    value: 1718,
  },
  {
    label: 'Pepperfry.com',
    value: 1719,
  },
  {
    label: 'Atlas Copco India Limited',
    value: 1720,
  },
  {
    label: 'C3i Support Services',
    value: 1721,
  },
  {
    label: 'Bertelsmann Marketing Services India',
    value: 1722,
  },
  {
    label: 'Trafigura',
    value: 1723,
  },
  {
    label: 'Cholayil Private Limited',
    value: 1724,
  },
  {
    label: 'GoldenSource',
    value: 1725,
  },
  {
    label: 'Francorp',
    value: 1726,
  },
  {
    label: 'Linc Pen & Plastics',
    value: 1727,
  },
  {
    label: 'CareerNet Technologies Pvt Ltd',
    value: 1728,
  },
  {
    label: 'Nvidia',
    value: 1729,
  },
  {
    label: 'Ess Dee Aluminium',
    value: 1730,
  },
  {
    label: 'Siva Ventures Limited',
    value: 1731,
  },
  {
    label: 'BIRLA TYRES',
    value: 1732,
  },
  {
    label: 'National Securities Depository Ltd',
    value: 1733,
  },
  {
    label: 'Financial Software & Systems',
    value: 1734,
  },
  {
    label: 'ASA & Associates',
    value: 1735,
  },
  {
    label: 'Foodpanda',
    value: 1736,
  },
  {
    label: 'Alibaba.com',
    value: 1737,
  },
  {
    label: 'Denave India Private Ltd',
    value: 1738,
  },
  {
    label: 'Amar Ujala Publications',
    value: 1739,
  },
  {
    label: 'IIMB',
    value: 1740,
  },
  {
    label: 'Bangalore International Airport Limited',
    value: 1741,
  },
  {
    label: 'DEN Networks Limited',
    value: 1742,
  },
  {
    label: 'Zomato',
    value: 1743,
  },
  {
    label: 'Indiaplaza.com',
    value: 1744,
  },
  {
    label: 'Cortaal Global',
    value: 1745,
  },
  {
    label: 'Red Bull',
    value: 1746,
  },
  {
    label: 'Brandscapes Worldwide',
    value: 1747,
  },
  {
    label: 'Applied Research International',
    value: 1748,
  },
  {
    label: 'NASSCOM',
    value: 1749,
  },
  {
    label: 'TRF',
    value: 1750,
  },
  {
    label: 'Systematix Shares & stocks (I) Ltd',
    value: 1751,
  },
  {
    label: 'Brady Corporation',
    value: 1752,
  },
  {
    label: 'Genius Consultant Limited',
    value: 1753,
  },
  {
    label: 'Ascendas',
    value: 1754,
  },
  {
    label: 'Dolphin Group Of Companies',
    value: 1755,
  },
  {
    label: 'U2opia Mobile',
    value: 1756,
  },
  {
    label: 'Dow Corning',
    value: 1757,
  },
  {
    label: 'Wheels India Ltd',
    value: 1758,
  },
  {
    label: 'Sun Life Financial',
    value: 1759,
  },
  {
    label: 'GMJ & Co',
    value: 1760,
  },
  {
    label: 'FranklinCovey',
    value: 1761,
  },
  {
    label: 'KEC International Ltd.',
    value: 1762,
  },
  {
    label: 'Abbott Nutrition International',
    value: 1763,
  },
  {
    label: 'MDI',
    value: 1764,
  },
  {
    label: 'Kitara Capital',
    value: 1765,
  },
  {
    label: 'Infogain',
    value: 1766,
  },
  {
    label: 'IBS Software Services',
    value: 1767,
  },
  {
    label: 'SKF India Limited',
    value: 1768,
  },
  {
    label: 'Sumedha Fiscal Services Ltd',
    value: 1769,
  },
  {
    label: 'Direxions Marketing Solutions',
    value: 1770,
  },
  {
    label: 'Electrotherm',
    value: 1771,
  },
  {
    label: 'Big Bazaar',
    value: 1772,
  },
  {
    label: 'Elephant Design',
    value: 1773,
  },
  {
    label: 'Taurus Mutual Fund',
    value: 1774,
  },
  {
    label: 'Job seeker',
    value: 1775,
  },
  {
    label: 'Cerner Healthcare Solutions',
    value: 1776,
  },
  {
    label: 'Alere',
    value: 1777,
  },
  {
    label: 'Eye Q Vision Pvt Ltd',
    value: 1778,
  },
  {
    label: 'Mindteck',
    value: 1779,
  },
  {
    label: 'Temenos',
    value: 1780,
  },
  {
    label: 'Network 21',
    value: 1781,
  },
  {
    label: 'mjunction services limited',
    value: 1782,
  },
  {
    label: '9.9 Media',
    value: 1783,
  },
  {
    label: 'GupShup Technology',
    value: 1784,
  },
  {
    label: 'Siva Group',
    value: 1785,
  },
  {
    label: 'Worlds Window Group',
    value: 1786,
  },
  {
    label: 'Engineers India LImited',
    value: 1787,
  },
  {
    label: 'Affinity Express',
    value: 1788,
  },
  {
    label: 'Citi Research',
    value: 1789,
  },
  {
    label: 'iFAST Financial India',
    value: 1790,
  },
  {
    label: 'Accel Frontline Limited',
    value: 1791,
  },
  {
    label: 'embryoFund',
    value: 1792,
  },
  {
    label: 'Infinite Computer Solutions',
    value: 1793,
  },
  {
    label: 'ABN AMRO Bank',
    value: 1794,
  },
  {
    label: 'JBM GROUP',
    value: 1795,
  },
  {
    label: 'Dynamic Orbits',
    value: 1796,
  },
  {
    label: 'Birla Tyre',
    value: 1797,
  },
  {
    label: 'Michelin',
    value: 1798,
  },
  {
    label: 'School of Inspired Leadership',
    value: 1799,
  },
  {
    label: 'OfficeYes.com',
    value: 1800,
  },
  {
    label: 'Realization Technologies',
    value: 1801,
  },
  {
    label: 'Edelman',
    value: 1802,
  },
  {
    label: 'London School of Economics',
    value: 1803,
  },
  {
    label: 'Hunt Partners',
    value: 1804,
  },
  {
    label: 'Walt Disney',
    value: 1805,
  },
  {
    label: 'Dinshaws Dairy Foods',
    value: 1806,
  },
  {
    label: 'Foresight Software Solutions',
    value: 1807,
  },
  {
    label: 'Yakult Danone',
    value: 1808,
  },
  {
    label: 'Business Analyst',
    value: 1809,
  },
  {
    label: 'UT Worldwide Inc',
    value: 1810,
  },
  {
    label: 'Enercon India',
    value: 1811,
  },
  {
    label: 'Citigate Dewe Rogerson',
    value: 1812,
  },
  {
    label: 'CSG',
    value: 1813,
  },
  {
    label: 'Indian Petro Group',
    value: 1814,
  },
  {
    label: 'PA Consulting Group',
    value: 1815,
  },
  {
    label: 'The Park Hotels',
    value: 1816,
  },
  {
    label: 'Drewry Maritime Services',
    value: 1817,
  },
  {
    label: 'Bombay Dyeing',
    value: 1818,
  },
  {
    label: 'Bekaert Industries Private Limited',
    value: 1819,
  },
  {
    label: 'Independant',
    value: 1820,
  },
  {
    label: 'XIMB',
    value: 1821,
  },
  {
    label: 'Teleperformance',
    value: 1822,
  },
  {
    label: 'Huntsmen & Barons',
    value: 1823,
  },
  {
    label: 'Miebach Consulting',
    value: 1824,
  },
  {
    label: 'Delhi Stock Exchange',
    value: 1825,
  },
  {
    label: 'Oak Capital Management',
    value: 1826,
  },
  {
    label: 'Kalkitech',
    value: 1827,
  },
  {
    label: 'Cartesian Consultancy',
    value: 1828,
  },
  {
    label: 'SHRM India',
    value: 1829,
  },
  {
    label: 'Entertainment World Developers',
    value: 1830,
  },
  {
    label: 'Cegedim India Pvt Ltd',
    value: 1831,
  },
  {
    label: 'World Bank',
    value: 1832,
  },
  {
    label: 'Royal Orchid',
    value: 1833,
  },
  {
    label: 'Hershey India',
    value: 1834,
  },
  {
    label: 'Empyrean Partners',
    value: 1835,
  },
  {
    label: 'N A',
    value: 1836,
  },
  {
    label: 'Audi',
    value: 1837,
  },
  {
    label: 'Best Engineering Aids & Consultancies Pvt Ltd',
    value: 1838,
  },
  {
    label: 'Indiaproperty.com',
    value: 1839,
  },
  {
    label: 'Sokrati',
    value: 1840,
  },
  {
    label: 'Xebia',
    value: 1841,
  },
  {
    label: 'TransUnion',
    value: 1842,
  },
  {
    label: 'Birla Research & Life Sciences',
    value: 1843,
  },
  {
    label: 'Validor Capital',
    value: 1844,
  },
  {
    label: 'Euronet Worldwide',
    value: 1845,
  },
  {
    label: 'IntraSoft Technologies Limited',
    value: 1846,
  },
  {
    label: 'Devenio Optimus Advisors',
    value: 1847,
  },
  {
    label: 'KPO',
    value: 1848,
  },
  {
    label: 'SourceHov',
    value: 1849,
  },
  {
    label: 'BSES',
    value: 1850,
  },
  {
    label: 'Bluedart Express Ltd',
    value: 1851,
  },
  {
    label: 'SHRM',
    value: 1852,
  },
  {
    label: 'Sutherland',
    value: 1853,
  },
  {
    label: 'Centrum Wealth Management',
    value: 1854,
  },
  {
    label: 'Aetna',
    value: 1855,
  },
  {
    label: 'EROS Group',
    value: 1856,
  },
  {
    label: 'Pylon Management Consulting',
    value: 1857,
  },
  {
    label: 'Eta Ascon',
    value: 1858,
  },
  {
    label: 'Luminous Power Technologies',
    value: 1859,
  },
  {
    label: 'Delta Electronics',
    value: 1860,
  },
  {
    label: 'Private',
    value: 1861,
  },
  {
    label: 'NSDL',
    value: 1862,
  },
  {
    label: 'Infosys BPO',
    value: 1863,
  },
  {
    label: 'IIML',
    value: 1864,
  },
  {
    label: 'Synechron Technologies',
    value: 1865,
  },
  {
    label: 'Surya Pharmaceutical Limited',
    value: 1866,
  },
  {
    label: 'Indian institute of planning and management',
    value: 1867,
  },
  {
    label: 'Hidesign',
    value: 1868,
  },
  {
    label: 'CARE',
    value: 1869,
  },
  {
    label: 'Indraprastha Gas Limited',
    value: 1870,
  },
  {
    label: 'Gemalto Digital Security Private Limited',
    value: 1871,
  },
  {
    label: 'INDIAN OVERSEAS BANK',
    value: 1872,
  },
  {
    label: 'Jaguar Land Rover',
    value: 1873,
  },
  {
    label: 'India Homes',
    value: 1874,
  },
  {
    label: 'allscripts',
    value: 1875,
  },
  {
    label: 'Gkb Rx Lens Pvt Ltd',
    value: 1876,
  },
  {
    label: 'N/A',
    value: 1877,
  },
  {
    label: 'BT',
    value: 1878,
  },
  {
    label: 'InMobi',
    value: 1879,
  },
  {
    label: 'Career Avenues',
    value: 1880,
  },
  {
    label: 'Mansukh Securities & Finance Limited',
    value: 1881,
  },
  {
    label: 'Gokaldas Exports',
    value: 1882,
  },
  {
    label: 'Damodar Valley Corporation',
    value: 1883,
  },
  {
    label: 'Calypso Technologies Limited',
    value: 1884,
  },
  {
    label: 'CoreLogic Global Services',
    value: 1885,
  },
  {
    label: 'Paramount Farms',
    value: 1886,
  },
  {
    label: 'ThinkLink Supply Chain Services',
    value: 1887,
  },
  {
    label: 'Cryobanks International',
    value: 1888,
  },
  {
    label: 'MICA',
    value: 1889,
  },
  {
    label: 'Gameloft',
    value: 1890,
  },
  {
    label: 'CII',
    value: 1891,
  },
  {
    label: 'AXA',
    value: 1892,
  },
  {
    label: 'Cosmos Bank',
    value: 1893,
  },
  {
    label: 'AUM Capital',
    value: 1894,
  },
  {
    label: 'Sundaram Finance LTD',
    value: 1895,
  },
  {
    label: 'Cucine Lube India',
    value: 1896,
  },
  {
    label: 'S.S. Kothari Mehta & Co.',
    value: 1897,
  },
  {
    label: 'LongHouse Consulting',
    value: 1898,
  },
  {
    label: 'The Akshaya Patra Foundation',
    value: 1899,
  },
  {
    label: '20:20 MSL',
    value: 1900,
  },
  {
    label: 'PNB Investment Services Limited',
    value: 1901,
  },
  {
    label: 'Droege Group',
    value: 1902,
  },
  {
    label: 'BigShoeBazaar India Pvt Limited',
    value: 1903,
  },
  {
    label: 'Croma Retail',
    value: 1904,
  },
  {
    label: 'India Power Corporation Limited',
    value: 1905,
  },
  {
    label: 'ngo',
    value: 1906,
  },
  {
    label: 'Ikya Human Capital',
    value: 1907,
  },
  {
    label: 'DY Works',
    value: 1908,
  },
  {
    label: 'Arihant Capital Markets Ltd',
    value: 1909,
  },
  {
    label: 'HNG Float Glass Ltd.',
    value: 1910,
  },
  {
    label: 'Gaursons India Limited',
    value: 1911,
  },
  {
    label: 'Gulf Oil',
    value: 1912,
  },
  {
    label: 'PA Consulting',
    value: 1913,
  },
  {
    label: 'BRITISH HIGH COMMISSION',
    value: 1914,
  },
  {
    label: 'Lakshmi Precision Screws Limited',
    value: 1915,
  },
  {
    label: 'Aqua Logistics',
    value: 1916,
  },
  {
    label: 'Demag Cranes AG',
    value: 1917,
  },
  {
    label: 'GLOPORE IMS',
    value: 1918,
  },
  {
    label: 'Fermenta Biotech Limited',
    value: 1919,
  },
  {
    label: 'SanDisk India',
    value: 1920,
  },
  {
    label: 'N/A',
    value: 1921,
  },
  {
    label: 'CIBER',
    value: 1922,
  },
  {
    label: 'World Gold Council',
    value: 1923,
  },
  {
    label: 'FabFurnish.com',
    value: 1924,
  },
  {
    label: 'Citrus Check Inns',
    value: 1925,
  },
  {
    label: 'jaypee business school',
    value: 1926,
  },
  {
    label: 'Godrej Industries Limited',
    value: 1927,
  },
  {
    label: '[24]7.ai',
    value: 1928,
  },
  {
    label: 'Etoos Academy Private Limted',
    value: 1929,
  },
  {
    label: 'The Manipal group',
    value: 1930,
  },
  {
    label: 'Torus Insurance',
    value: 1931,
  },
  {
    label: 'Shipping Corporation of India',
    value: 1932,
  },
  {
    label: 'BT Global Services',
    value: 1933,
  },
  {
    label: 'Saviance Technologies',
    value: 1934,
  },
  {
    label: 'Letsbuy.com',
    value: 1935,
  },
  {
    label: 'Sandoz Private Limited',
    value: 1936,
  },
  {
    label: 'Ideacts Innovation',
    value: 1937,
  },
  {
    label: 'Baskin Robbins',
    value: 1938,
  },
  {
    label: 'Epitome Global Services',
    value: 1939,
  },
  {
    label: 'Al Futtaim',
    value: 1940,
  },
  {
    label: 'Avika Group',
    value: 1941,
  },
  {
    label: 'Indian Institute of management bangalore',
    value: 1942,
  },
  {
    label: 'Yepme.com',
    value: 1943,
  },
  {
    label: 'India Medtronic Pvt. Ltd.',
    value: 1944,
  },
  {
    label: 'Saxo Bank',
    value: 1945,
  },
  {
    label: 'rei agro limited',
    value: 1946,
  },
  {
    label: 'INDIAN IMMUNOLOGICALS LIMITED',
    value: 1947,
  },
  {
    label: 'Takshashila Consulting',
    value: 1948,
  },
  {
    label: 'STOCK HOLDING CORPORATION OF INDIA LTD',
    value: 1949,
  },
  {
    label: 'Surya Roshni Limited',
    value: 1950,
  },
  {
    label: 'Paul Merchants',
    value: 1951,
  },
  {
    label: 'Pramati Technologies',
    value: 1952,
  },
  {
    label: 'Ashika Stock Broking Ltd',
    value: 1953,
  },
  {
    label: 'Lenskart.com',
    value: 1954,
  },
  {
    label: 'Abercrombie & Fitch',
    value: 1955,
  },
  {
    label: 'eMart solutions',
    value: 1956,
  },
  {
    label: 'Gokhale Institute of Politics & Economics',
    value: 1957,
  },
  {
    label: 'Elixir',
    value: 1958,
  },
  {
    label: 'Gilbert Tweed Associates',
    value: 1959,
  },
  {
    label: 'Merck Limited',
    value: 1960,
  },
  {
    label: 'HTC',
    value: 1961,
  },
  {
    label: 'Hindustan Construction Company',
    value: 1962,
  },
  {
    label: 'ENIL - Radio Mirchi',
    value: 1963,
  },
  {
    label: 'Gujarat Gas Company Limited',
    value: 1964,
  },
  {
    label: 'First Blue Home Finance',
    value: 1965,
  },
  {
    label: 'Hella India Electronics',
    value: 1966,
  },
  {
    label: 'Cura Technologies',
    value: 1967,
  },
  {
    label: 'FIRE Capital Fund',
    value: 1968,
  },
  {
    label: 'High Mark Credit Information Services',
    value: 1969,
  },
  {
    label: 'SIMS',
    value: 1970,
  },
  {
    label: 'Zynga',
    value: 1971,
  },
  {
    label: 'GE Oil & Gas',
    value: 1972,
  },
  {
    label: 'PAREXEL',
    value: 1973,
  },
  {
    label: 'Novozymes',
    value: 1974,
  },
  {
    label: 'Executive Access  India',
    value: 1975,
  },
  {
    label: 'Business Development Bureau (India) Private Limited',
    value: 1976,
  },
  {
    label: 'Broking',
    value: 1977,
  },
  {
    label: 'Spandana Sphoorty Financial Limited',
    value: 1978,
  },
  {
    label: 'Fareast Mercantile Co. Ltd.',
    value: 1979,
  },
  {
    label: 'IIM',
    value: 1980,
  },
  {
    label: 'Royal Dutch Shell',
    value: 1981,
  },
  {
    label: 'Dhanush Infotech',
    value: 1982,
  },
  {
    label: 'SRM University',
    value: 1983,
  },
  {
    label: 'KEC INTERNATIONAL',
    value: 1984,
  },
  {
    label: 'VertX Solutions',
    value: 1985,
  },
  {
    label: "a'XYKno Capital Services",
    value: 1986,
  },
  {
    label: 'Hindustan Copper Limited',
    value: 1987,
  },
  {
    label: 'Louis Dreyfus Commodities India Pvt. Ltd.',
    value: 1988,
  },
  {
    label: 'Kline & Company',
    value: 1989,
  },
  {
    label: 'Cable & Wireless WorldWide',
    value: 1990,
  },
  {
    label: 'Associated Chambers of Commerce & Industry of India',
    value: 1991,
  },
  {
    label: 'National Institute of Smart Government',
    value: 1992,
  },
  {
    label: 'Cinemax India Limited',
    value: 1993,
  },
  {
    label: 'GrapeCity India Private Limited',
    value: 1994,
  },
  {
    label: 'OTIS Elevator',
    value: 1995,
  },
  {
    label: 'Population Services International',
    value: 1996,
  },
  {
    label: 'MART',
    value: 1997,
  },
  {
    label: 'Synechron',
    value: 1998,
  },
  {
    label: 'Anant Raj Group',
    value: 1999,
  },
  {
    label: 'DIAB Core Materials Pvt Ltd',
    value: 2000,
  },
  {
    label: 'Paras Pharmaceuticals',
    value: 2001,
  },
  {
    label: 'Business Standard Ltd',
    value: 2002,
  },
  {
    label: 'TERI University',
    value: 2003,
  },
  {
    label: 'Orbis Financial Corporation Limited',
    value: 2004,
  },
  {
    label: 'TI Cycles of India',
    value: 2005,
  },
  {
    label: 'octamec Group',
    value: 2006,
  },
  {
    label: 'NPTI',
    value: 2007,
  },
  {
    label: 'Dalal Street Investments Ltd.',
    value: 2008,
  },
  {
    label: 'Bikanervala Foods Private Ltd',
    value: 2009,
  },
  {
    label: 'Properji',
    value: 2010,
  },
  {
    label: 'Perfint Healthcare',
    value: 2011,
  },
  {
    label: 'Cryo-Save India Limited',
    value: 2012,
  },
  {
    label: 'Microland Ltd',
    value: 2013,
  },
  {
    label: 'Vizury Interactive',
    value: 2014,
  },
  {
    label: 'Delhivery',
    value: 2015,
  },
  {
    label: 'Avon Beauty Products',
    value: 2016,
  },
  {
    label: 'Carlson Wagonlit Travels',
    value: 2017,
  },
  {
    label: 'Christ University',
    value: 2018,
  },
  {
    label: 'Morarka Organic Foods Ltd',
    value: 2019,
  },
  {
    label: 'Cadence Design Systems',
    value: 2020,
  },
  {
    label: 'Amrapali Group',
    value: 2021,
  },
  {
    label: 'Aris Global',
    value: 2022,
  },
  {
    label: 'ExeLAN Networking Technologies',
    value: 2023,
  },
  {
    label: 'None',
    value: 2024,
  },
  {
    label: 'The Hackett Group',
    value: 2025,
  },
  {
    label: 'Case-Mate',
    value: 2026,
  },
  {
    label: 'Frankfinn Aviation Pvt Ltd',
    value: 2027,
  },
  {
    label: 'Lloyds Banking Group',
    value: 2028,
  },
  {
    label: 'Pathfinder',
    value: 2029,
  },
  {
    label: 'SMALL INDUSTRIES DEVELOPMENT BANK OF INDIA',
    value: 2030,
  },
  {
    label: 'Fiduciary Euromax Capital Markets',
    value: 2031,
  },
  {
    label: 'GlobalScholar',
    value: 2032,
  },
  {
    label: 'SYNDICATE BANK',
    value: 2033,
  },
  {
    label: 'NSI INFINIUM GLOBAL PVT LTD',
    value: 2034,
  },
  {
    label: 'Indofil Industries Limited',
    value: 2035,
  },
  {
    label: 'Penna Cement Industries',
    value: 2036,
  },
  {
    label: 'Interglobe',
    value: 2037,
  },
  {
    label: 'GVK Mumbai International Airport Limited',
    value: 2038,
  },
  {
    label: 'MSL India',
    value: 2039,
  },
  {
    label: 'mba college',
    value: 2040,
  },
  {
    label: 'Central Government',
    value: 2041,
  },
  {
    label: 'Progressive Infotech Pvt Ltd',
    value: 2042,
  },
  {
    label: 'GIM',
    value: 2043,
  },
  {
    label: 'E-Meditek',
    value: 2044,
  },
  {
    label: 'ANI Technologies Pvt Ltd',
    value: 2045,
  },
  {
    label: 'Flair Pens',
    value: 2046,
  },
  {
    label: 'Way2Wealth',
    value: 2047,
  },
  {
    label: 'Hatsun Agro Products Limited',
    value: 2049,
  },
  {
    label: 'MMTC Ltd.',
    value: 2050,
  },
  {
    label: 'Infrasoft Technologies',
    value: 2051,
  },
  {
    label: 'Lawrence & Mayo',
    value: 2052,
  },
  {
    label: 'Carrier',
    value: 2053,
  },
  {
    label: 'Arthur D. Little',
    value: 2054,
  },
  {
    label: 'HLFPPT',
    value: 2055,
  },
  {
    label: 'ABG Cement Ltd',
    value: 2056,
  },
  {
    label: 'CLAAS India Pvt. Ltd.',
    value: 2057,
  },
  {
    label: 'Legrand',
    value: 2058,
  },
  {
    label: 'DSM Sinochem Pharmaceuticals',
    value: 2059,
  },
  {
    label: 'Anmsoft technologies',
    value: 2060,
  },
  {
    label: 'Kent RO Systems Ltd.',
    value: 2061,
  },
  {
    label: 'TE Connectivity',
    value: 2062,
  },
  {
    label: 'Brakes India Ltd',
    value: 2063,
  },
  {
    label: 'IIM Shillong',
    value: 2064,
  },
  {
    label: 'Law Firm',
    value: 2065,
  },
  {
    label: 'KEI Industries Limited',
    value: 2066,
  },
  {
    label: 'Ispat Industries Ltd.',
    value: 2067,
  },
  {
    label: 'Gallagher Offshore Support Services Pvt Ltd',
    value: 2068,
  },
  {
    label: 'ATC India Tower Corporation',
    value: 2069,
  },
  {
    label: 'Det Norske Veritas',
    value: 2070,
  },
  {
    label: 'Own business',
    value: 2071,
  },
  {
    label: 'CMMI 5 Level Company',
    value: 2072,
  },
  {
    label: 'Heidelberg',
    value: 2073,
  },
  {
    label: 'Capital Code India Private Limited',
    value: 2074,
  },
  {
    label: 'Sahyadri Hospitals Ltd',
    value: 2075,
  },
  {
    label: 'Shree Renuka Sugars Limited',
    value: 2076,
  },
  {
    label: 'Tube Investments of India',
    value: 2077,
  },
  {
    label: 'Osram',
    value: 2078,
  },
  {
    label: 'Indian Institute of Foreign Trade',
    value: 2079,
  },
  {
    label: 'MXV Consulting',
    value: 2080,
  },
  {
    label: 'Institute of public enterprise',
    value: 2081,
  },
  {
    label: 'Edwards Lifesciences',
    value: 2082,
  },
  {
    label: 'HDIL',
    value: 2083,
  },
  {
    label: 'Birla Corporation Limited',
    value: 2084,
  },
  {
    label: 'Kelly Services India Pvt. Ltd.',
    value: 2085,
  },
  {
    label: 'MIT',
    value: 2086,
  },
  {
    label: 'SJ Seymour',
    value: 2087,
  },
  {
    label: 'Value and Budget Housing Corporation Pvt Ltd',
    value: 2088,
  },
  {
    label: 'Disney UTV',
    value: 2089,
  },
  {
    label: 'Market Insight Consultants',
    value: 2090,
  },
  {
    label: 'Finalytics Consultancy',
    value: 2091,
  },
  {
    label: 'Fortune 500',
    value: 2092,
  },
  {
    label: 'Bookadda.com',
    value: 2093,
  },
  {
    label: 'Camlin Ltd',
    value: 2094,
  },
  {
    label: 'Citi Financial Consumer Finance India Ltd',
    value: 2095,
  },
  {
    label: 'Catwalk',
    value: 2096,
  },
  {
    label: 'Telco Construction Equipment Co. Ltd.',
    value: 2097,
  },
  {
    label: 'Emkor Solutions',
    value: 2098,
  },
  {
    label: 'Perot Systems',
    value: 2099,
  },
  {
    label: 'Life Technologies',
    value: 2100,
  },
  {
    label: 'Nityo Infotech',
    value: 2101,
  },
  {
    label: 'star news',
    value: 2102,
  },
  {
    label: 'Tecpro Systems Ltd',
    value: 2103,
  },
  {
    label: 'ABECL',
    value: 2104,
  },
  {
    label: 'Kennametal India Limited',
    value: 2105,
  },
  {
    label: 'Manipal Business Solutions',
    value: 2106,
  },
  {
    label: 'Winshuttle',
    value: 2107,
  },
  {
    label: 'engage4more (India) Private Limited',
    value: 2108,
  },
  {
    label: 'Beacon Insurance Brokers Pvt. Ltd',
    value: 2109,
  },
  {
    label: 'SAR Group',
    value: 2110,
  },
  {
    label: 'CarDekho.com',
    value: 2111,
  },
  {
    label: 'Abhishek Industries (Trident Group)',
    value: 2112,
  },
  {
    label: 'Bilcare Ltd',
    value: 2113,
  },
  {
    label: 'Asian Development Bank',
    value: 2114,
  },
  {
    label: 'Vatika Group',
    value: 2115,
  },
  {
    label: 'Park Plaza',
    value: 2116,
  },
  {
    label: 'NMIMS, Mumbai',
    value: 2117,
  },
  {
    label: 'Gunnebo India Private Limited',
    value: 2118,
  },
  {
    label: 'Export Import Bank of India',
    value: 2119,
  },
  {
    label: 'Kokuyo Camlin Ltd',
    value: 2120,
  },
  {
    label: 'The Institute Of Chartered Accountants Of India',
    value: 2121,
  },
  {
    label: 'FamilyCredit Limited',
    value: 2122,
  },
  {
    label: 'KyaZoonga.com',
    value: 2123,
  },
  {
    label: 'Pace Power Systems Pvt Ltd',
    value: 2124,
  },
  {
    label: 'Nagarjuna Oil Corporation Limited',
    value: 2125,
  },
  {
    label: 'Confi',
    value: 2126,
  },
  {
    label: 'meritnation.com',
    value: 2127,
  },
  {
    label: 'IISWBM',
    value: 2128,
  },
  {
    label: 'OFSS',
    value: 2129,
  },
  {
    label: 'Path Infotech',
    value: 2130,
  },
  {
    label: 'JCO GAS PIPE LIMITED',
    value: 2131,
  },
  {
    label: 'Life Insurance',
    value: 2132,
  },
  {
    label: 'Clover Infotech Pvt Ltd',
    value: 2133,
  },
  {
    label: 'Ghalla & Bhansali Chartered Accountants',
    value: 2134,
  },
  {
    label: 'Gini & Jony Ltd',
    value: 2135,
  },
  {
    label: 'SITA',
    value: 2136,
  },
  {
    label: 'Falcon Tyres Limited',
    value: 2137,
  },
  {
    label: 'Nilkamal Limited',
    value: 2138,
  },
  {
    label: 'Allied Digital Services Ltd.',
    value: 2139,
  },
  {
    label: 'WaterHealth India Pvt Ltd',
    value: 2140,
  },
  {
    label: 'Egis India',
    value: 2141,
  },
  {
    label: 'Hanmer MSL',
    value: 2142,
  },
  {
    label: 'SMJ Capital',
    value: 2143,
  },
  {
    label: 'National Securities Depository Limited',
    value: 2144,
  },
  {
    label: 'GEPL CAPITAL',
    value: 2145,
  },
  {
    label: 'NourishCo',
    value: 2146,
  },
  {
    label: 'First Global Securities',
    value: 2147,
  },
  {
    label: 'Danone',
    value: 2148,
  },
  {
    label: 'eBIZ.com',
    value: 2149,
  },
  {
    label: 'Empire Industries Ltd',
    value: 2150,
  },
  {
    label: 'Sherwin Williams Paints',
    value: 2151,
  },
  {
    label: 'ANDHRA BANK',
    value: 2152,
  },
  {
    label: 'Tikona Digital Networks',
    value: 2153,
  },
  {
    label: 'BIMTECH',
    value: 2154,
  },
  {
    label: 'Parry Agro Industries',
    value: 2155,
  },
  {
    label: 'Bombardier Transportation India Limited',
    value: 2156,
  },
  {
    label: 'Spandana Sphoorty Financial Ltd',
    value: 2157,
  },
  {
    label: 'Grameen Financial Services',
    value: 2158,
  },
  {
    label: 'Capital Foods Limited',
    value: 2159,
  },
  {
    label: 'sipl',
    value: 2160,
  },
  {
    label: 'Pubmatic',
    value: 2161,
  },
  {
    label: 'Emerson Process Management',
    value: 2162,
  },
  {
    label: 'Delhi University',
    value: 2163,
  },
  {
    label: 'TAKE SOLUTIONS',
    value: 2164,
  },
  {
    label: 'any organisation',
    value: 2165,
  },
  {
    label: 'Cranes Software',
    value: 2166,
  },
  {
    label: 'Neilsoft',
    value: 2167,
  },
  {
    label: 'Tilaknagar Industries',
    value: 2168,
  },
  {
    label: 'Universal Success Enterprises',
    value: 2169,
  },
  {
    label: 'Engineering',
    value: 2170,
  },
  {
    label: 'Phadnis Infrastructure',
    value: 2171,
  },
  {
    label: 'Axiom Consulting',
    value: 2172,
  },
  {
    label: 'Clifford Chance LLP',
    value: 2173,
  },
  {
    label: 'Oxfam India',
    value: 2174,
  },
  {
    label: 'Torry Harris Business Solutions',
    value: 2175,
  },
  {
    label: 'Athena Demwe Power Limited',
    value: 2176,
  },
  {
    label: 'Quant Broking Private Limited',
    value: 2177,
  },
  {
    label: 'Sunidhi Securities',
    value: 2178,
  },
  {
    label: 'Welingkar Institute',
    value: 2179,
  },
  {
    label: 'ARC Financial Services',
    value: 2180,
  },
  {
    label: 'Capvent India Advisors Private Ltd',
    value: 2181,
  },
  {
    label: 'Granules India limited',
    value: 2182,
  },
  {
    label: 'Lanxess India',
    value: 2183,
  },
  {
    label: 'SRF Limited',
    value: 2184,
  },
  {
    label: 'Rave Technologies',
    value: 2185,
  },
  {
    label: 'Mecon Limited',
    value: 2186,
  },
  {
    label: 'Consumer Goods',
    value: 2187,
  },
  {
    label: 'Global Markets Center',
    value: 2188,
  },
  {
    label: 'Capco Technologies',
    value: 2189,
  },
  {
    label: 'Innoz Technologies',
    value: 2190,
  },
  {
    label: 'Hem Securities Limited',
    value: 2191,
  },
  {
    label: 'Servion Global Solutions',
    value: 2192,
  },
  {
    label: 'Pall Corporation',
    value: 2193,
  },
  {
    label: 'HGS',
    value: 2194,
  },
  {
    label: 'PINC Research',
    value: 2195,
  },
  {
    label: 'Classic Stripes Pvt Ltd',
    value: 2196,
  },
  {
    label: 'Parikar Business and Knowledge Services',
    value: 2197,
  },
  {
    label: 'Hoppr',
    value: 2198,
  },
  {
    label: 'Attero Recycling',
    value: 2199,
  },
  {
    label: 'Altamount Capital Management',
    value: 2200,
  },
  {
    label: 'Hawkins Cookers Limited',
    value: 2201,
  },
  {
    label: 'July Systems',
    value: 2202,
  },
  {
    label: 'Brescon Corporate Advisors (P) Ltd',
    value: 2203,
  },
  {
    label: 'Fitness First India Private Limited',
    value: 2204,
  },
  {
    label: 'ETA General Pvt Ltd',
    value: 2205,
  },
  {
    label: 'Frontier Business Systems',
    value: 2206,
  },
  {
    label: 'SKP Group',
    value: 2207,
  },
  {
    label: 'Trimax IT Infrastructure & Services Ltd',
    value: 2208,
  },
  {
    label: 'Perfect Research',
    value: 2209,
  },
  {
    label: 'The Bank of New York Mellon',
    value: 2210,
  },
  {
    label: 'V2 Solutions',
    value: 2211,
  },
  {
    label: 'EX - Army',
    value: 2212,
  },
  {
    label: 'Rainman Consulting',
    value: 2213,
  },
  {
    label: 'Piaggio',
    value: 2214,
  },
  {
    label: 'Dow Jones Consulting India Private Limited',
    value: 2215,
  },
  {
    label: 'Meritus Analytics',
    value: 2216,
  },
  {
    label: 'Equitas Micro Finance',
    value: 2217,
  },
  {
    label: 'Clickable Inc.',
    value: 2218,
  },
  {
    label: 'IIMnet Ventures',
    value: 2219,
  },
  {
    label: 'RIMS',
    value: 2220,
  },
  {
    label: 'Neilsoft Ltd.',
    value: 2221,
  },
  {
    label: 'TIL Limited',
    value: 2222,
  },
  {
    label: 'universal sompo general insurance',
    value: 2223,
  },
  {
    label: 'ACH Management Consultant Pvt. Ltd.',
    value: 2224,
  },
  {
    label: 'Fios Data Check Asia Pvt Ltd',
    value: 2225,
  },
  {
    label: 'SEBI',
    value: 2226,
  },
  {
    label: 'Cognilytics',
    value: 2227,
  },
  {
    label: 'Cholamandalam Securities',
    value: 2228,
  },
  {
    label: 'Keynote Corporate Services Limited',
    value: 2229,
  },
  {
    label: 'YKK',
    value: 2230,
  },
  {
    label: 'Amazan Agro Products Ltd.',
    value: 2231,
  },
  {
    label: 'Bharat Sanchar Nigam Limited',
    value: 2232,
  },
  {
    label: 'Solutions Middle East',
    value: 2233,
  },
  {
    label: 'Pyro Group',
    value: 2234,
  },
  {
    label: 'Comverse Network Systems',
    value: 2235,
  },
  {
    label: 'sundaram finance limited',
    value: 2236,
  },
  {
    label: 'Callaway Golf Company',
    value: 2237,
  },
  {
    label: 'Indus Balaji Private Equity',
    value: 2238,
  },
  {
    label: 'Syngenta India Limited',
    value: 2239,
  },
  {
    label: 'Greycells18 Media Ltd',
    value: 2240,
  },
  {
    label: 'Not yet',
    value: 2241,
  },
  {
    label: 'Boeing',
    value: 2242,
  },
  {
    label: 'ST Ericsson',
    value: 2243,
  },
  {
    label: 'sportsnlife.com',
    value: 2244,
  },
  {
    label: 'systematix Shares & stocks',
    value: 2245,
  },
  {
    label: 'DRDO',
    value: 2246,
  },
  {
    label: 'Prime Focus Technologies',
    value: 2247,
  },
  {
    label: 'Eduvisors',
    value: 2248,
  },
  {
    label: 'Mitsubishi',
    value: 2249,
  },
  {
    label: 'Gitanjali Group',
    value: 2250,
  },
  {
    label: 'JRG securities',
    value: 2251,
  },
  {
    label: 'LionBridge Technologies',
    value: 2252,
  },
  {
    label: 'Embee Software',
    value: 2253,
  },
  {
    label: 'SYMBIOSIS INSTITUTE OF INTERNATIONAL BUSINESS',
    value: 2254,
  },
  {
    label: 'C&C Constructions Limited',
    value: 2255,
  },
  {
    label: 'International Tractors Limited',
    value: 2256,
  },
  {
    label: 'Microsec Capital Limited',
    value: 2257,
  },
  {
    label: 'Ugam Solutions',
    value: 2258,
  },
  {
    label: 'INDIAN STATISTICAL INSTITUTE',
    value: 2259,
  },
  {
    label: 'Envision Financial Systems',
    value: 2260,
  },
  {
    label: 'PineBridge Investments (formerly AIG Investmenets)',
    value: 2261,
  },
  {
    label: 'Metropolis Healthcare Ltd',
    value: 2262,
  },
  {
    label: 'Global e Procure',
    value: 2263,
  },
  {
    label: 'Bank of Tokyo',
    value: 2264,
  },
  {
    label: 'Auroch Investment Managers',
    value: 2265,
  },
  {
    label: 'CarWale.com',
    value: 2266,
  },
  {
    label: 'LAKSHMI VILAS BANK',
    value: 2267,
  },
  {
    label: 'UPES',
    value: 2268,
  },
  {
    label: 'ITW India Ltd',
    value: 2269,
  },
  {
    label: 'Violet Arch Securities',
    value: 2270,
  },
  {
    label: 'Indian Institute of Management Ahmedabad',
    value: 2271,
  },
  {
    label: 'Chokshi & Chokshi',
    value: 2272,
  },
  {
    label: 'IIM Trichy',
    value: 2273,
  },
  {
    label: 'The South Indian Bank Ltd',
    value: 2274,
  },
  {
    label: 'Husys',
    value: 2275,
  },
  {
    label: 'Concept Management Consulting Limited',
    value: 2276,
  },
  {
    label: 'MDI Gurgaon',
    value: 2277,
  },
  {
    label: 'Indegene Lifesystems',
    value: 2278,
  },
  {
    label: 'HYTHRO POWER CORPORATION LIMITED',
    value: 2279,
  },
  {
    label: 'Vardhman Group',
    value: 2280,
  },
  {
    label: 'AIPL',
    value: 2281,
  },
  {
    label: 'Business Standard',
    value: 2282,
  },
  {
    label: 'National Dairy Development Board',
    value: 2283,
  },
  {
    label: 'RITES Ltd',
    value: 2284,
  },
  {
    label: 'Tejas Networks',
    value: 2285,
  },
  {
    label: 'Ozone group',
    value: 2286,
  },
  {
    label: 'Hindustan Latex Family Planning Promotion Trust',
    value: 2287,
  },
  {
    label: 'Infocom Network Ltd.',
    value: 2288,
  },
  {
    label: 'Vayam Technologies Limited',
    value: 2289,
  },
  {
    label: 'Anlage HRO Services',
    value: 2290,
  },
  {
    label: 'IRIS Business Services Limited',
    value: 2291,
  },
  {
    label: 'ITW Signode',
    value: 2292,
  },
  {
    label: 'HDB Financial services ltd',
    value: 2293,
  },
  {
    label: 'Roubini Global Economics',
    value: 2294,
  },
  {
    label: 'UHG',
    value: 2295,
  },
  {
    label: 'NMIMS University',
    value: 2296,
  },
  {
    label: 'Donear Industries Ltd.',
    value: 2297,
  },
  {
    label: 'Autodesk India Pvt Ltd',
    value: 2298,
  },
  {
    label: 'Torus Business Solutions Pvt Ltd',
    value: 2299,
  },
  {
    label: 'The Shipping Corporation of India Ltd.',
    value: 2300,
  },
  {
    label: 'Anthelio Healthcare Solutions',
    value: 2301,
  },
  {
    label: 'Schindler India Pvt Ltd',
    value: 2302,
  },
  {
    label: 'CARE Hospitals',
    value: 2303,
  },
  {
    label: 'Philips Lighting',
    value: 2304,
  },
  {
    label: 'TRPC',
    value: 2305,
  },
  {
    label: 'Mecklai Financial Services Ltd',
    value: 2306,
  },
  {
    label: 'Boutique Investment bank',
    value: 2307,
  },
  {
    label: 'Orient cement',
    value: 2308,
  },
  {
    label: 'Ajanta Pharma',
    value: 2309,
  },
  {
    label: 'emids Technologies',
    value: 2310,
  },
  {
    label: 'BankMuscat',
    value: 2311,
  },
  {
    label: 'MHRIL',
    value: 2312,
  },
  {
    label: 'Jagran Prakashan Ltd',
    value: 2313,
  },
  {
    label: 'Genesis Luxury',
    value: 2314,
  },
  {
    label: 'Alp COnsulting Ltd',
    value: 2315,
  },
  {
    label: 'Forbes & Company Ltd.',
    value: 2316,
  },
  {
    label: 'N/A',
    value: 2317,
  },
  {
    label: 'synygy',
    value: 2318,
  },
  {
    label: 'Bharat Bijlee',
    value: 2319,
  },
  {
    label: 'Talisma Corporation',
    value: 2320,
  },
  {
    label: 'Spotlight',
    value: 2321,
  },
  {
    label: 'EduKart.com',
    value: 2322,
  },
  {
    label: 'Citrus Payment Solutions',
    value: 2323,
  },
  {
    label: 'ujjivan financial services pvt Ltd',
    value: 2324,
  },
  {
    label: 'Compuware India',
    value: 2325,
  },
  {
    label: 'Focus Comtrade Pvt. Ltd',
    value: 2326,
  },
  {
    label: 'Praxair India Pvt Ltd',
    value: 2327,
  },
  {
    label: 'Intex Technologies India Ltd',
    value: 2328,
  },
  {
    label: 'HBL Power Systems Limited',
    value: 2329,
  },
  {
    label: 'Hanil Automotive India Pvt Ltd',
    value: 2330,
  },
  {
    label: 'Chinatrust Commercial Bank',
    value: 2331,
  },
  {
    label: 'Elsevier',
    value: 2332,
  },
  {
    label: 'Mjunction Services Ltd',
    value: 2333,
  },
  {
    label: 'tradeindia.com',
    value: 2334,
  },
  {
    label: 'ColorPlus Fashions Ltd',
    value: 2335,
  },
  {
    label: 'Bertling Logistics India Pvt Ltd',
    value: 2336,
  },
  {
    label: 'Kiran Energy',
    value: 2337,
  },
  {
    label: 'Nucsoft Ltd.',
    value: 2338,
  },
  {
    label: 'Thyrocare',
    value: 2339,
  },
  {
    label: 'Godrej Hersheys Ltd',
    value: 2340,
  },
  {
    label: 'Artsana India Pvt Ltd',
    value: 2341,
  },
  {
    label: 'Applied Materials',
    value: 2342,
  },
  {
    label: 'ISRO',
    value: 2343,
  },
  {
    label: 'MBA Fresher',
    value: 2344,
  },
  {
    label: 'Chambal Fertilisers and Chemicals Limited',
    value: 2345,
  },
  {
    label: 'Xavient Information Systems',
    value: 2346,
  },
  {
    label: 'Clockwork Business Solutions Pvt. Ltd.',
    value: 2347,
  },
  {
    label: 'ThyssenKrupp',
    value: 2348,
  },
  {
    label: 'SCMLD',
    value: 2349,
  },
  {
    label: 'Global Group',
    value: 2350,
  },
  {
    label: 'Helix Advisors',
    value: 2351,
  },
  {
    label: 'Pharmaceuticals',
    value: 2352,
  },
  {
    label: 'Resurgent India Limited',
    value: 2353,
  },
  {
    label: 'Logitech',
    value: 2354,
  },
  {
    label: 'Mount Talent Consulting',
    value: 2355,
  },
  {
    label: 'idea7 Sewells',
    value: 2356,
  },
  {
    label: 'The Alchemists Ark Pvt Ltd',
    value: 2357,
  },
  {
    label: 'CompuCom CSI Systems',
    value: 2358,
  },
  {
    label: 'First Gulf Bank',
    value: 2359,
  },
  {
    label: 'iQor',
    value: 2360,
  },
  {
    label: 'Masan Group',
    value: 2361,
  },
  {
    label: 'USV Limited',
    value: 2362,
  },
  {
    label: 'Indian Institute of Management, Bangalore',
    value: 2363,
  },
  {
    label: 'Export House',
    value: 2364,
  },
  {
    label: 'Suguna Foods',
    value: 2365,
  },
  {
    label: 'WAY2WEALTH BROKERS PVT LTD',
    value: 2366,
  },
  {
    label: 'iYogi Technical Services Pvt Ltd',
    value: 2367,
  },
  {
    label: 'Techprocess Solutions Ltd',
    value: 2368,
  },
  {
    label: 'RUMI Education',
    value: 2369,
  },
  {
    label: 'Atul Limited',
    value: 2370,
  },
  {
    label: 'Jagran Solutions',
    value: 2371,
  },
  {
    label: 'OPI',
    value: 2372,
  },
  {
    label: 'Columbia University',
    value: 2373,
  },
  {
    label: 'Mattel Toys',
    value: 2374,
  },
  {
    label: 'Zyme Solutions',
    value: 2375,
  },
  {
    label: 'Trimax IT Infrastructure & Services Ltd.',
    value: 2376,
  },
  {
    label: 'Express KCS',
    value: 2377,
  },
  {
    label: 'Dax Networks Limited',
    value: 2378,
  },
  {
    label: 'Technip',
    value: 2379,
  },
  {
    label: 'CNN-IBN',
    value: 2380,
  },
  {
    label: 'Subros Ltd.',
    value: 2381,
  },
  {
    label: 'Looking for job',
    value: 2382,
  },
  {
    label: 'ACG Worldwide',
    value: 2383,
  },
  {
    label: 'Balaji Telefilms Limited',
    value: 2384,
  },
  {
    label: 'Ibibo Group',
    value: 2385,
  },
  {
    label: 'Petroleum and Natural Gas Regulatory Board',
    value: 2386,
  },
  {
    label: 'Solution digitas',
    value: 2387,
  },
  {
    label: 'SPA Merchant Bankers Ltd',
    value: 2388,
  },
  {
    label: 'SAUD BAHWAN AUTOMOTIVE',
    value: 2389,
  },
  {
    label: 'Ministry of Defence',
    value: 2390,
  },
  {
    label: 'NCR Corporation India Pvt Ltd',
    value: 2391,
  },
  {
    label: 'SMARTANALYST',
    value: 2392,
  },
  {
    label: 'Gmmco Limited',
    value: 2393,
  },
  {
    label: 'Army',
    value: 2394,
  },
  {
    label: 'BIBA Apparels',
    value: 2395,
  },
  {
    label: 'Dalal & Broacha Pvt. Ltd.',
    value: 2396,
  },
  {
    label: 'Gandour India Food Processing',
    value: 2397,
  },
  {
    label: 'Isolux Corsan',
    value: 2398,
  },
  {
    label: 'Accountant',
    value: 2399,
  },
  {
    label: 'Praxis Business School',
    value: 2400,
  },
  {
    label: 'C-Quest Capital',
    value: 2401,
  },
  {
    label: 'Dale Carnegie Training',
    value: 2402,
  },
  {
    label: 'Business Octane Solutions Pvt. Ltd.',
    value: 2403,
  },
  {
    label: 'Acme Telepower Ltd',
    value: 2404,
  },
  {
    label: 'IILM',
    value: 2405,
  },
  {
    label: 'Firstcry.com',
    value: 2406,
  },
  {
    label: 'Mobikwik',
    value: 2407,
  },
  {
    label: 'Cube26',
    value: 2408,
  },
  {
    label: 'Kalaari Capital',
    value: 2409,
  },
  {
    label: 'Tracxn',
    value: 2410,
  },
  {
    label: 'LexisNexis&reg;',
    value: 2411,
  },
  {
    label: 'ZS',
    value: 2412,
  },
  {
    label: 'Fuze Care System (Good Methods Global Inc.)',
    value: 2413,
  },
  {
    label: 'goibibo',
    value: 2414,
  },
  {
    label: 'nearbuy',
    value: 2415,
  },
  {
    label: 'OneDirect',
    value: 2416,
  },
  {
    label: 'Tapzo',
    value: 2417,
  },
  {
    label: 'Magicbricks',
    value: 2418,
  },
  {
    label: 'XSEED',
    value: 2419,
  },
  {
    label: 'CMS IT Services',
    value: 2420,
  },
  {
    label: 'hike',
    value: 2421,
  },
  {
    label: 'GAP inc.',
    value: 2422,
  },
  {
    label: 'Cloudtail',
    value: 2423,
  },
  {
    label: 'BRIDGEi2i',
    value: 2424,
  },
  {
    label: 'Brillio',
    value: 2425,
  },
  {
    label: 'NPCI',
    value: 2426,
  },
  {
    label: 'SendinBlue',
    value: 2427,
  },
  {
    label: 'ZestMoney',
    value: 2428,
  },
  {
    label: 'Cameron',
    value: 2429,
  },
  {
    label: 'Xiaomi',
    value: 2430,
  },
  {
    label: 'Head Digital Works',
    value: 2431,
  },
  {
    label: 'Alef Mobitech',
    value: 2432,
  },
  {
    label: 'Xoriant',
    value: 2433,
  },
  {
    label: 'Alef Edge',
    value: 2434,
  },
  {
    label: 'LogMeIn',
    value: 2435,
  },
  {
    label: 'Bewakoof.com',
    value: 2436,
  },
  {
    label: 'Truebil',
    value: 2437,
  },
  {
    label: 'Turvo',
    value: 2438,
  },
  {
    label: 'Elixia',
    value: 2439,
  },
  {
    label: 'Salesforce',
    value: 2440,
  },
  {
    label: 'Rapido',
    value: 2441,
  },
  {
    label: 'RheinBrucke',
    value: 2442,
  },
  {
    label: 'Wenger & Watson Inc.',
    value: 2443,
  },
  {
    label: 'Roljobs Technology Services Private Limited',
    value: 2444,
  },
  {
    label: 'Anzy Careers Pvt. Ltd.',
    value: 2445,
  },
  {
    label: 'skillVentory',
    value: 2446,
  },
  {
    label: 'Think People Solutions Pvt. Ltd.',
    value: 2447,
  },
  {
    label: 'New Era India',
    value: 2448,
  },
  {
    label: 'zyoin',
    value: 2449,
  },
  {
    label: 'SutraHR',
    value: 2450,
  },
  {
    label: 'Best InfoSystems Ltd.',
    value: 2451,
  },
  {
    label: 'Maven Workforce',
    value: 2452,
  },
  {
    label: 'Symmetrical Global Search Pvt Ltd',
    value: 2453,
  },
  {
    label: 'HR Central',
    value: 2454,
  },
  {
    label: 'JoulestoWatts Business Solutions Pvt Ltd',
    value: 2455,
  },
  {
    label: 'Aasaanjobs',
    value: 2456,
  },
  {
    label: 'Live Connections',
    value: 2457,
  },
  {
    label: 'GlobalHunt India Pvt Ltd',
    value: 2458,
  },
  {
    label: 'Negocios IT Solutions',
    value: 2459,
  },
  {
    label: 'TalentFirst',
    value: 2460,
  },
  {
    label: 'Times Internet',
    value: 2461,
  },
  {
    label: 'Next Step Services Private Limited',
    value: 2462,
  },
  {
    label: 'IndiHire HR Consultants Pvt Ltd',
    value: 2463,
  },
  {
    label: 'Mirafra Technologies',
    value: 2464,
  },
  {
    label: 'Resource Weaver HR Consulting Private Limited',
    value: 2465,
  },
  {
    label: 'AVTAR Career Creators',
    value: 2466,
  },
  {
    label: 'Volantis Technologies',
    value: 2467,
  },
  {
    label: 'Empower IT Systems Pvt Ltd',
    value: 2468,
  },
  {
    label: 'PayTM',
    value: 2469,
  },
  {
    label: 'EVC Ventures',
    value: 2470,
  },
  {
    label: 'Black Turtle India Pvt Ltd',
    value: 2471,
  },
  {
    label: 'Carte Blanche IT Solution',
    value: 2472,
  },
  {
    label: 'Orcapod Consulting Services Pvt. Ltd',
    value: 2473,
  },
  {
    label: 'TEKsystems',
    value: 2474,
  },
  {
    label: 'Experis',
    value: 2475,
  },
  {
    label: 'Meesho',
    value: 2476,
  },
  {
    label: "Smith's Detection",
    value: 2477,
  },
  {
    label: 'Swiggy',
    value: 2478,
  },
  {
    label: 'OYO',
    value: 2479,
  },
  {
    label: 'Exotel',
    value: 2480,
  },
  {
    label: 'Sugoi Labs',
    value: 2481,
  },
  {
    label: 'GoScale',
    value: 2482,
  },
  {
    label: 'Forbes',
    value: 2483,
  },
  {
    label: 'Ezetap',
    value: 2484,
  },
  {
    label: 'Haptik',
    value: 2485,
  },
  {
    label: 'Impendi Analytics',
    value: 2486,
  },
  {
    label: 'SmartCoin',
    value: 2487,
  },
  {
    label: 'Freecharge',
    value: 2488,
  },
  {
    label: 'BookMyShow',
    value: 2489,
  },
  {
    label: 'Digibook Technologies Pvt. Ltd. (Kopykitab)',
    value: 2490,
  },
  {
    label: 'LitmusWorld',
    value: 2491,
  },
  {
    label: 'DLT Labs',
    value: 2492,
  },
  {
    label: 'Codalyze Technologies',
    value: 2493,
  },
  {
    label: 'Dimagi',
    value: 2494,
  },
  {
    label: 'Shuttle',
    value: 2495,
  },
  {
    label: 'D Cube Analytics',
    value: 2496,
  },
  {
    label: 'ShaadiSaga',
    value: 2497,
  },
  {
    label: 'BrowserStack',
    value: 2498,
  },
  {
    label: 'IIFL',
    value: 2499,
  },
  {
    label: 'EY',
    value: 2500,
  },
  {
    label: 'Viacom18',
    value: 2501,
  },
  {
    label: 'Vriksha Techno Solutions',
    value: 2502,
  },
  {
    label: 'Upstox',
    value: 2503,
  },
  {
    label: 'Naukri.com',
    value: 2504,
  },
  {
    label: 'CDK Global',
    value: 2505,
  },
  {
    label: 'Focus Management Consultants Pvt Ltd.',
    value: 2506,
  },
  {
    label: 'Infinity HR Consulting',
    value: 2507,
  },
  {
    label: 'Multi Recruit',
    value: 2508,
  },
  {
    label: 'People Gamut',
    value: 2509,
  },
  {
    label: 'ANRI Solutions HR Services',
    value: 2510,
  },
  {
    label: 'Innovacer',
    value: 2511,
  },
  {
    label: 'Radancy',
    value: 2512,
  },
  {
    label: 'DISPRZ',
    value: 2513,
  },
  {
    label: 'Mastree',
    value: 2514,
  },
  {
    label: 'Lavelle Networks',
    value: 2515,
  },
  {
    label: 'Redbytes',
    value: 2516,
  },
  {
    label: 'NetScout IT Technology',
    value: 2517,
  },
  {
    label: 'Techolution',
    value: 2518,
  },
  {
    label: 'Loan Frame',
    value: 2519,
  },
  {
    label: 'Mads Technologies Pvt. Ltd.',
    value: 2520,
  },
  {
    label: 'Iron Systems',
    value: 2521,
  },
  {
    label: 'Technocrats Horizons Compusoft Pvt. Ltd.',
    value: 2522,
  },
  {
    label: 'Transdigital Technology Pvt Ltd',
    value: 2523,
  },
  {
    label: 'Suvichar Technologies Pvt Ltd',
    value: 2524,
  },
  {
    label: 'Technifybiz',
    value: 2525,
  },
  {
    label: 'Banc91',
    value: 2526,
  },
  {
    label: 'NLB Services',
    value: 2527,
  },
  {
    label: 'HP Inc',
    value: 2528,
  },
  {
    label: 'Fabrik Space',
    value: 2529,
  },
  {
    label: 'PSL',
    value: 2530,
  },
  {
    label: 'Stryde Consulting',
    value: 2531,
  },
  {
    label: 'Miko',
    value: 2532,
  },
  {
    label: 'ProdEx Technologies',
    value: 2533,
  },
  {
    label: 'smartData Enterprises',
    value: 2534,
  },
  {
    label: 'Cyphertree Technologies Pvt Ltd',
    value: 2535,
  },
  {
    label: 'Black Tulip Flowers LLC',
    value: 2536,
  },
  {
    label: 'Everymedia',
    value: 2537,
  },
  {
    label: 'Testingxpertes pvt ltd',
    value: 2538,
  },
  {
    label: 'Ori',
    value: 2539,
  },
  {
    label: 'Zinier Technologies',
    value: 2540,
  },
  {
    label: 'Ideas2IT Technology Services',
    value: 2541,
  },
  {
    label: 'Aadya Technobytes Pvt. Ltd.',
    value: 2542,
  },
  {
    label: 'Omic Healthcare',
    value: 2543,
  },
  {
    label: 'Cashfree',
    value: 2544,
  },
  {
    label: 'EncoreSoftSol',
    value: 2545,
  },
  {
    label: 'Fission Labs',
    value: 2546,
  },
  {
    label: 'Codingmart Technologies',
    value: 2547,
  },
  {
    label: 'Cravingcode Technologies Pvt. Ltd.',
    value: 2548,
  },
  {
    label: 'MeshArk Software Technologies Pvt Ltd',
    value: 2549,
  },
  {
    label: 'Refixd.com',
    value: 2550,
  },
  {
    label: 'WinfoGlobal Technologies',
    value: 2551,
  },
  {
    label: 'nuSecond Technologies',
    value: 2552,
  },
  {
    label: 'Clavax Technologies',
    value: 2553,
  },
  {
    label: 'Lumiq',
    value: 2554,
  },
  {
    label: 'Zadok HR',
    value: 2555,
  },
  {
    label: 'SGS Group',
    value: 2556,
  },
  {
    label: 'Oyelabs',
    value: 2557,
  },
  {
    label: 'INSZoom',
    value: 2558,
  },
  {
    label: 'Amlgo Labs',
    value: 2559,
  },
  {
    label: 'TotalityCorp',
    value: 2560,
  },
  {
    label: 'Aligned Automation',
    value: 2561,
  },
  {
    label: 'Cogniter Technologies',
    value: 2562,
  },
  {
    label: 'In-Solution Global Limited',
    value: 2563,
  },
  {
    label: 'Minions Ventures Pvt Ltd',
    value: 2564,
  },
  {
    label: 'Yiron Technologies Pvt Ltd',
    value: 2565,
  },
  {
    label: 'DataGroup Geospatial Technologies Pvt Ltd',
    value: 2566,
  },
  {
    label: 'Blueed Technology',
    value: 2567,
  },
  {
    label: 'Lending Kart',
    value: 2568,
  },
  {
    label: 'Indus Business Systems',
    value: 2569,
  },
  {
    label: 'Oloid AI',
    value: 2570,
  },
  {
    label: 'Taggd',
    value: 2571,
  },
  {
    label: 'Jiva Infotech',
    value: 2572,
  },
  {
    label: 'Eroute Technologies Pvt Ltd',
    value: 2573,
  },
  {
    label: 'Modistabox',
    value: 2574,
  },
  {
    label: 'Forbes (COE)',
    value: 2575,
  },
  {
    label: 'SMARTe Inc.',
    value: 2576,
  },
  {
    label: 'Clevertap',
    value: 2577,
  },
  {
    label: 'Yeag Technology',
    value: 2578,
  },
  {
    label: 'BluOne',
    value: 2579,
  },
  {
    label: '1mg.com',
    value: 2580,
  },
  {
    label: 'Saggezza',
    value: 2581,
  },
  {
    label: 'Incosys',
    value: 2582,
  },
  {
    label: 'Dot Net Tricks',
    value: 2583,
  },
  {
    label: 'Shilpin Corporation',
    value: 2584,
  },
  {
    label: 'Incentius',
    value: 2585,
  },
  {
    label: 'Elucidata Corporation',
    value: 2586,
  },
  {
    label: 'CloudCodes Software Pvt Ltd',
    value: 2587,
  },
  {
    label: 'Jai Kisan',
    value: 2588,
  },
  {
    label: 'Right Head India',
    value: 2589,
  },
  {
    label: 'Ideas2IT Technologies',
    value: 2590,
  },
  {
    label: 'InfoBeans Technologies Ltd.',
    value: 2591,
  },
  {
    label: 'Sagmetic Infotech Pvt. Ltd.',
    value: 2592,
  },
  {
    label: 'TA Digital - TechAspect',
    value: 2593,
  },
  {
    label: 'Indus Os',
    value: 2594,
  },
  {
    label: 'Aadvi Tech Solutions',
    value: 2595,
  },
  {
    label: '6d Technologies',
    value: 2596,
  },
  {
    label: 'Sourcing Solution Technologies',
    value: 2597,
  },
  {
    label: 'Intelliswift',
    value: 2598,
  },
  {
    label: 'Neobric IT Solutions Pvt Ltd',
    value: 2599,
  },
  {
    label: 'Binary Global Limited',
    value: 2600,
  },
  {
    label: 'YNOS Venture Engine CC Ltd.',
    value: 2601,
  },
  {
    label: 'Connect Echo/Artoo',
    value: 2602,
  },
  {
    label: 'Bitstreet Technologies Pvt Ltd',
    value: 2603,
  },
  {
    label: 'Punchh.com',
    value: 2604,
  },
  {
    label: 'Careator Technologies Pvt Ltd',
    value: 2605,
  },
  {
    label: 'Work Companion LLP',
    value: 2606,
  },
  {
    label: 'Vhunt4U',
    value: 2607,
  },
  {
    label: 'Agility Roots',
    value: 2608,
  },
  {
    label: 'Metmox',
    value: 2609,
  },
  {
    label: 'NeoQuant Solutions Pvt Ltd',
    value: 2610,
  },
  {
    label: 'Vocso Technologies Pvt Ltd.',
    value: 2611,
  },
  {
    label: 'Aedifex Labs Private Limited',
    value: 2612,
  },
  {
    label: 'Blue Umbrella India Pvt ltd',
    value: 2613,
  },
  {
    label: 'Blackcoffer (OPC) Private Limited',
    value: 2614,
  },
  {
    label: 'MoonX',
    value: 2615,
  },
  {
    label: 'TransOrg Analytics',
    value: 2616,
  },
  {
    label: 'Moback Technologies India Pvt Ltd',
    value: 2617,
  },
  {
    label: 'Conative IT Solutions Pvt Ltd',
    value: 2618,
  },
  {
    label: 'Jalan Technology Consulting',
    value: 2619,
  },
  {
    label: 'Passion Gaming',
    value: 2620,
  },
  {
    label: 'Proval Tech',
    value: 2621,
  },
  {
    label: 'Splash Math',
    value: 2622,
  },
  {
    label: 'MajorBrains Technologies',
    value: 2623,
  },
  {
    label: 'Flying Penguins',
    value: 2624,
  },
  {
    label: 'Zolo Stays',
    value: 2625,
  },
  {
    label: 'BOP Consultants Pvt Ltd',
    value: 2626,
  },
  {
    label: 'Paragyte Technologies',
    value: 2627,
  },
  {
    label: 'Smarte Inc',
    value: 2628,
  },
  {
    label: 'Kiprosh',
    value: 2629,
  },
  {
    label: 'Globussoft Technologies',
    value: 2630,
  },
  {
    label: 'Mobiquest Mobile Technologies',
    value: 2631,
  },
  {
    label: 'Untrodden Labs',
    value: 2632,
  },
  {
    label: 'Myforexeye',
    value: 2633,
  },
  {
    label: 'Games2win India Pvt. Ltd.',
    value: 2634,
  },
  {
    label: 'Axis My India',
    value: 2635,
  },
  {
    label: 'Ungeek',
    value: 2636,
  },
  {
    label: 'Podium Systems Pvt Ltd',
    value: 2637,
  },
  {
    label: 'DataOne',
    value: 2638,
  },
  {
    label: 'Hashtag Global Solutions',
    value: 2639,
  },
  {
    label: 'Sciative Solution Private Limited',
    value: 2640,
  },
  {
    label: 'Sarvodaya Infotech Private Limited',
    value: 2641,
  },
  {
    label: 'IT Firm',
    value: 2642,
  },
  {
    label: 'MyOperator',
    value: 2643,
  },
  {
    label: 'LimeTray',
    value: 2644,
  },
  {
    label: 'ZOYLO DIGIHEALTH PVT LTD',
    value: 2645,
  },
  {
    label: 'Lightstone Labs',
    value: 2646,
  },
  {
    label: 'Cranberry Analytics Pvt Ltd',
    value: 2647,
  },
  {
    label: 'Edufied',
    value: 2648,
  },
  {
    label: 'Obvious',
    value: 2649,
  },
  {
    label: 'Solvecorp',
    value: 2650,
  },
  {
    label: 'Apidel Technology',
    value: 2651,
  },
  {
    label: 'Vap Technology Pvt ltd',
    value: 2652,
  },
  {
    label: 'Choice TechLab Solutions Pvt. Ltd.',
    value: 2653,
  },
  {
    label: 'SecurEyes',
    value: 2654,
  },
  {
    label: 'MyDesq Technology ',
    value: 2655,
  },
  {
    label: 'Mirraw',
    value: 2656,
  },
  {
    label: 'iOpex Technologies',
    value: 2657,
  },
  {
    label: 'PipeCandy Technologies ',
    value: 2658,
  },
  {
    label: 'Pepper Cloud',
    value: 2659,
  },
  {
    label: 'Esper',
    value: 2660,
  },
  {
    label: 'Digilytics.ai',
    value: 2661,
  },
  {
    label: 'Adecco India',
    value: 2662,
  },
  {
    label: 'Make My Trip',
    value: 2663,
  },
  {
    label: 'Dignitech Media Works Private Limited',
    value: 2664,
  },
  {
    label: 'MJV',
    value: 2665,
  },
  {
    label: 'Vision Vivante',
    value: 2666,
  },
  {
    label: 'Indusos',
    value: 2667,
  },
  {
    label: 'Derivatives Connect Pvt Ltd',
    value: 2668,
  },
  {
    label: 'AarnaIntech solutions pvt ltd',
    value: 2669,
  },
  {
    label: 'Infibeam Avenues Pvt Ltd',
    value: 2670,
  },
  {
    label: 'Grey Orange',
    value: 2671,
  },
  {
    label: 'Infogrex',
    value: 2672,
  },
  {
    label: 'Vervali Systems',
    value: 2673,
  },
  {
    label: 'PharmaAI',
    value: 2674,
  },
  {
    label: 'Salesbee India Pvt Ltd',
    value: 2675,
  },
  {
    label: 'Raps Consultant',
    value: 2676,
  },
  {
    label: 'BrandzGarage',
    value: 2677,
  },
  {
    label: 'Ecowoodies',
    value: 2678,
  },
  {
    label: 'TruSpeQ Consulting Pvt Ltd',
    value: 2679,
  },
  {
    label: 'Thought Frameworks',
    value: 2680,
  },
  {
    label: 'Finioit Technologies Pvt Ltd',
    value: 2681,
  },
  {
    label: 'WheelsEye',
    value: 2682,
  },
  {
    label: 'Enthraling Matrix Pvt. Ltd.',
    value: 2683,
  },
  {
    label: 'Mobile Programming',
    value: 2684,
  },
  {
    label: 'Dignitas Digital Pvt Ltd',
    value: 2685,
  },
  {
    label: 'Appmocx',
    value: 2686,
  },
  {
    label: 'Suma Soft Pvt Ltd',
    value: 2687,
  },
  {
    label: 'ALTEN Calsoft Labs',
    value: 2688,
  },
  {
    label: 'Hexagon Digital Lab',
    value: 2689,
  },
  {
    label: 'OneStop Retail Pvt. Ltd.',
    value: 2690,
  },
  {
    label: 'Vodafone Idea',
    value: 2691,
  },
  {
    label: 'Licious',
    value: 2692,
  },
  {
    label: 'Sunseaz Technologies',
    value: 2693,
  },
  {
    label: 'Innoplexus',
    value: 2694,
  },
  {
    label: 'Appyhigh Technology LLP',
    value: 2695,
  },
  {
    label: 'Iyna.ai',
    value: 2696,
  },
  {
    label: 'Dailymails',
    value: 2697,
  },
  {
    label: 'Analyttica Datalab',
    value: 2698,
  },
  {
    label: 'ePharma',
    value: 2699,
  },
  {
    label: 'RS Gamezone Pvt Ltd',
    value: 2700,
  },
  {
    label: 'BlueStone.com',
    value: 2701,
  },
  {
    label: 'Talon Pvt Ltd',
    value: 2702,
  },
  {
    label: 'Tvaksa Technologies Pvt Ltd',
    value: 2703,
  },
  {
    label: 'Needle Innovision',
    value: 2704,
  },
  {
    label: 'Ambiguous solutions Pvt Ltd',
    value: 2705,
  },
  {
    label: 'Apptunix',
    value: 2706,
  },
  {
    label: 'MozWebMedia Pvt Ltd',
    value: 2707,
  },
  {
    label: 'TekSkills',
    value: 2708,
  },
  {
    label: 'Adept Global',
    value: 2709,
  },
  {
    label: 'Digipropel India Pvt. Ltd.',
    value: 2710,
  },
  {
    label: 'Success Pact Consulting Pvt. Ltd.',
    value: 2711,
  },
  {
    label: 'Elixia Tech Solutions Ltd',
    value: 2712,
  },
  {
    label: 'Meyrahkee Advisors Pvt Ltd',
    value: 2713,
  },
  {
    label: 'LearnApp',
    value: 2714,
  },
  {
    label: 'Innoplexus Consulting services Pvt Ltd',
    value: 2715,
  },
  {
    label: 'Advids',
    value: 2716,
  },
  {
    label: 'K3R Global Solutions Private Limited',
    value: 2717,
  },
  {
    label: 'Coder Talent',
    value: 2718,
  },
  {
    label: 'Blue Umbrella India Private Limited',
    value: 2719,
  },
  {
    label: 'Quantiphi Analytics',
    value: 2720,
  },
  {
    label: 'Sevenstar Websolutions',
    value: 2721,
  },
  {
    label: 'Pattem Digital',
    value: 2722,
  },
  {
    label: 'AMBC Technologies',
    value: 2723,
  },
  {
    label: 'Qdesq Realtech Pvt Ltd',
    value: 2724,
  },
  {
    label: 'Moonshine Technology',
    value: 2725,
  },
  {
    label: 'Techstar Software Development India Pvt. Ltd.',
    value: 2726,
  },
  {
    label: 'VideoTap',
    value: 2727,
  },
  {
    label: 'Codinova Technologies',
    value: 2728,
  },
  {
    label: 'Navtech (Navaratan Technologies Pvt. Ltd)',
    value: 2729,
  },
  {
    label: 'Impactall Solutions Pvt. Ltd.',
    value: 2730,
  },
  {
    label: 'EsoTeky Solutions Private Limited',
    value: 2731,
  },
  {
    label: 'Volody',
    value: 2732,
  },
  {
    label: 'Travel Technology Solution',
    value: 2733,
  },
  {
    label: 'Odysseus Solutions',
    value: 2734,
  },
  {
    label: 'Emblaze Training',
    value: 2735,
  },
  {
    label: 'Thoucentric Technology Private Limited',
    value: 2736,
  },
  {
    label: 'AI Product Based company',
    value: 2737,
  },
  {
    label: 'Intelifai Technologies',
    value: 2738,
  },
  {
    label: 'AirFi',
    value: 2739,
  },
  {
    label: 'Technology Start-up',
    value: 2740,
  },
  {
    label: 'Confidential',
    value: 2741,
  },
  {
    label: 'RawData',
    value: 2742,
  },
  {
    label: 'Technology Frontiers (India) Pvt Ltd',
    value: 2743,
  },
  {
    label: 'TBM Technologies Pvt Ltd',
    value: 2744,
  },
  {
    label: 'Digilantern',
    value: 2745,
  },
  {
    label: 'Acheron Software Consultancy Pvt. Ltd.',
    value: 2746,
  },
  {
    label: 'Convergence IT Services',
    value: 2747,
  },
  {
    label: 'Spinnaker Corporate Advisors',
    value: 2748,
  },
  {
    label: 'Copper Mobile Pvt. Ltd.',
    value: 2749,
  },
  {
    label: 'Cyberindigo Net Pvt. Ltd.',
    value: 2750,
  },
  {
    label: 'Deep LogicTech Pvt. Ltd',
    value: 2751,
  },
  {
    label: 'VersionN Studios',
    value: 2752,
  },
  {
    label: 'Growth360',
    value: 2753,
  },
  {
    label: 'Decision Point',
    value: 2754,
  },
  {
    label: 'Firstventure Corporation Pvt. Ltd.',
    value: 2755,
  },
  {
    label: 'Delta Technology & Management Services Pvt. Ltd',
    value: 2756,
  },
  {
    label: 'Simba Logistics Pvt. Ltd.',
    value: 2757,
  },
  {
    label: 'Ascra Technologies',
    value: 2758,
  },
  {
    label: 'Numetric Technologies Pvt. Ltd.',
    value: 2759,
  },
  {
    label: 'Shras IT Solutions',
    value: 2760,
  },
  {
    label: 'Cybrilla Technologies',
    value: 2761,
  },
  {
    label: 'Qwikcilver',
    value: 2762,
  },
  {
    label: 'OzoneSoft Solutions',
    value: 2763,
  },
  {
    label: 'Gloify',
    value: 2764,
  },
  {
    label: 'Commvault',
    value: 2765,
  },
  {
    label: 'Dynaminds Marketing',
    value: 2766,
  },
  {
    label: 'Symbion Technology Pvt. Ltd.',
    value: 2767,
  },
  {
    label: 'Nimesa',
    value: 2768,
  },
  {
    label: 'Marketonix Services Pvt. Ltd.',
    value: 2769,
  },
  {
    label: 'Bharja Technologies',
    value: 2770,
  },
  {
    label: 'Trueblue ArStudioz LLP',
    value: 2771,
  },
  {
    label: 'Stamurai',
    value: 2772,
  },
  {
    label: 'Mihuru',
    value: 2773,
  },
  {
    label: 'Plunes Technologies Pvt. Ltd.',
    value: 2774,
  },
  {
    label: 'Vymo',
    value: 2775,
  },
  {
    label: 'Brucode Technologies',
    value: 2776,
  },
  {
    label: 'TechAhead',
    value: 2777,
  },
  {
    label: 'Hoonar Tekwurks',
    value: 2778,
  },
  {
    label: 'Memat Digi Pvt. Ltd.',
    value: 2779,
  },
  {
    label: 'Precily AI',
    value: 2780,
  },
  {
    label: 'KnowledgeHut',
    value: 2781,
  },
  {
    label: 'FutureSoft India Pvt Ltd',
    value: 2782,
  },
  {
    label: 'Baysquare Technologies Pvt ltd',
    value: 2783,
  },
  {
    label: 'D4insight Pvt Ltd',
    value: 2784,
  },
  {
    label: 'Career International',
    value: 2785,
  },
  {
    label: 'SVK Global Solutions',
    value: 2786,
  },
  {
    label: 'Intellexa Technologies',
    value: 2787,
  },
  {
    label: 'Information Asset',
    value: 2788,
  },
  {
    label: 'Functionize Software Pvt Ltd',
    value: 2789,
  },
  {
    label: 'GajShield',
    value: 2790,
  },
  {
    label: 'OSAAS',
    value: 2791,
  },
  {
    label: 'YouGov India',
    value: 2792,
  },
  {
    label: 'TechUnity Inc.',
    value: 2793,
  },
  {
    label: 'iLogix Infotech',
    value: 2794,
  },
  {
    label: 'Modaviti eMarketing pvt ltd.',
    value: 2795,
  },
  {
    label: 'Property Solutions (India) Pvt. Ltd. (PSIPL)',
    value: 2796,
  },
  {
    label: 'Stalwart People Company',
    value: 2797,
  },
  {
    label: 'Affle India Ltd.',
    value: 2798,
  },
  {
    label: 'Cliffsoft IT Solutions',
    value: 2799,
  },
  {
    label: 'Edutest Solutions Pvt. Ltd.',
    value: 2800,
  },
  {
    label: 'WAPology India Pvt. Ltd.',
    value: 2801,
  },
  {
    label: 'SFW Technologies India Pvt. Ltd.',
    value: 2802,
  },
  {
    label: 'Recrosoft Technologies',
    value: 2803,
  },
  {
    label: 'Spinco Biotech Pvt. Ltd.',
    value: 2804,
  },
  {
    label: 'SISA Information Security Pvt. Ltd.',
    value: 2805,
  },
  {
    label: 'Anatha',
    value: 2806,
  },
  {
    label: 'MoooFarm',
    value: 2807,
  },
  {
    label: 'Netcracker Technology',
    value: 2808,
  },
  {
    label: 'BMC Group',
    value: 2809,
  },
  {
    label: 'XS Infosol Pvt. Ltd.',
    value: 2810,
  },
  {
    label: 'SVK Global Solutions Pvt Ltd',
    value: 2811,
  },
  {
    label: 'Vertex Plus Technologies Pvt. LTD',
    value: 2812,
  },
  {
    label: 'Neebal Technologies',
    value: 2813,
  },
  {
    label: 'Intangles',
    value: 2814,
  },
  {
    label: 'Koenig Solutions Pvt. Ltd.',
    value: 2815,
  },
  {
    label: 'QSC',
    value: 2816,
  },
  {
    label: 'Equiv.in',
    value: 2817,
  },
  {
    label: 'Alumnus Software Ltd.',
    value: 2818,
  },
  {
    label: 'DMI',
    value: 2819,
  },
  {
    label: 'Launchship IT&Media Service Pvt. Ltd.',
    value: 2820,
  },
  {
    label: 'App Innovative Solutions',
    value: 2821,
  },
  {
    label: 'SGS consulting',
    value: 2822,
  },
  {
    label: 'Export Genius',
    value: 2823,
  },
  {
    label: 'SlingPe Software Private Limited',
    value: 2824,
  },
  {
    label: 'FullCycle Private Limited',
    value: 2825,
  },
  {
    label: 'Milkyway Multidimensional Services',
    value: 2826,
  },
  {
    label: 'Fibre2Fashion Pvt. Ltd',
    value: 2827,
  },
  {
    label: 'Synchrony',
    value: 2828,
  },
  {
    label: 'Capita India',
    value: 2829,
  },
  {
    label: 'Rutek Systems LLC',
    value: 2830,
  },
  {
    label: 'Wattmonk Private Limited',
    value: 2831,
  },
  {
    label: 'Mavenai Technologies Pvt LTD',
    value: 2832,
  },
  {
    label: 'GoPerceptive',
    value: 2833,
  },
  {
    label: 'Agrya Consulting Private Limited',
    value: 2834,
  },
  {
    label: 'ReadyAssist.in',
    value: 2835,
  },
  {
    label: 'Swiflearn',
    value: 2836,
  },
  {
    label: 'Edgistify',
    value: 2837,
  },
  {
    label: 'IQVIA',
    value: 2838,
  },
  {
    label: 'Chakra',
    value: 2839,
  },
  {
    label: 'I Square Soft',
    value: 2840,
  },
  {
    label: 'nthrive Global Solutions',
    value: 2841,
  },
  {
    label: 'Evosys',
    value: 2842,
  },
  {
    label: 'DB Xento Systems',
    value: 2843,
  },
  {
    label: 'Decision Tree Analytics',
    value: 2844,
  },
  {
    label: 'Xento Systems',
    value: 2845,
  },
  {
    label: 'Rishabh Software',
    value: 2846,
  },
  {
    label: 'Volansys Technologies Pvt. Ltd.',
    value: 2847,
  },
  {
    label: 'Lex Carta Private Limited',
    value: 2848,
  },
  {
    label: 'Spectrum Talent Management',
    value: 2849,
  },
  {
    label: 'Mobile Programming LLC',
    value: 2850,
  },
  {
    label: 'Mobile Programming Pvt LTd',
    value: 2851,
  },
  {
    label: 'FABgetaways',
    value: 2852,
  },
  {
    label: 'Sinarmas Digital Pvt Ltd',
    value: 2853,
  },
  {
    label: 'MBR Informatics',
    value: 2854,
  },
  {
    label: 'ElectrifAi',
    value: 2855,
  },
  {
    label: 'Shree AGT Multimedia',
    value: 2856,
  },
  {
    label: 'Kaya Limited',
    value: 2857,
  },
  {
    label: 'FACT Advisory Services',
    value: 2858,
  },
  {
    label: 'Tickled Media',
    value: 2859,
  },
  {
    label: 'True  Fit',
    value: 2860,
  },
  {
    label: 'RAINBOX MEDIA PRIVATE LIMITED',
    value: 2861,
  },
  {
    label: 'Eaton',
    value: 2862,
  },
  {
    label: 'FIGMD',
    value: 2863,
  },
  {
    label: 'HireXtra',
    value: 2864,
  },
  {
    label: 'HireXtra',
    value: 2865,
  },
  {
    label: 'Innova Solutions pvt.Ltd',
    value: 2866,
  },
  {
    label: 'Simpplr',
    value: 2867,
  },
  {
    label: 'Prokarma Technologies',
    value: 2868,
  },
  {
    label: 'ImpactQA',
    value: 2869,
  },
  {
    label: 'TechUnity Software Systems',
    value: 2870,
  },
  {
    label: 'Futuristic Labs',
    value: 2871,
  },
  {
    label: 'Pvot',
    value: 2872,
  },
  {
    label: 'Unicommerce',
    value: 2873,
  },
  {
    label: 'Standav LLP',
    value: 2874,
  },
  {
    label: 'Biocube',
    value: 2875,
  },
  {
    label: 'anantha cyber tech',
    value: 2876,
  },
  {
    label: 'Furtados School Of Music',
    value: 2877,
  },
  {
    label: 'Eduthrill',
    value: 2878,
  },
  {
    label: 'Vivaconnect Pvt Ltd',
    value: 2879,
  },
  {
    label: 'Toppersnotes.com',
    value: 2880,
  },
  {
    label: 'MinersINC(Mangata Technologies Pvt. Ltd.',
    value: 2881,
  },
  {
    label: 'Neologicx',
    value: 2882,
  },
  {
    label: 'MountTalent Consulting',
    value: 2883,
  },
  {
    label: 'Wabtec',
    value: 2884,
  },
  {
    label: 'Coorgle Web Services',
    value: 2885,
  },
  {
    label: 'LucidPlus IT Solutions',
    value: 2886,
  },
  {
    label: 'Sanesquare Technologies',
    value: 2887,
  },
  {
    label: 'Clix Capital',
    value: 2888,
  },
  {
    label: 'SourceMash Technologies',
    value: 2889,
  },
  {
    label: 'AES technology',
    value: 2890,
  },
  {
    label: 'Clairvoyant',
    value: 2891,
  },
  {
    label: 'Baldor Technologies Ltd',
    value: 2892,
  },
  {
    label: 'Uplers',
    value: 2893,
  },
  {
    label: 'Krish Compusoft Services, Pvt Ltd.',
    value: 2894,
  },
  {
    label: 'Credgenics',
    value: 2895,
  },
  {
    label: 'Convosight',
    value: 2896,
  },
  {
    label: 'Eon Technologies Pvt. Ltd.',
    value: 2897,
  },
  {
    label: 'Lyra Infosystems Pvt Ltd',
    value: 2898,
  },
  {
    label: 'Oottru Technlogies',
    value: 2899,
  },
  {
    label: 'Ankercloud',
    value: 2900,
  },
  {
    label: 'Satya Infosys',
    value: 2901,
  },
  {
    label: 'Crescerance',
    value: 2902,
  },
  {
    label: 'Innobuzz Learning Solutions',
    value: 2903,
  },
  {
    label: 'Kyyba India',
    value: 2904,
  },
  {
    label: 'Mobile Programming Pvt Ltd',
    value: 2905,
  },
  {
    label: 'SMD Consultants',
    value: 2906,
  },
  {
    label: 'Thrillophilia.com',
    value: 2907,
  },
  {
    label: 'SmartVizX',
    value: 2908,
  },
  {
    label: 'Katzion Tech',
    value: 2909,
  },
  {
    label: 'Samvadsocial Technologies Pvt. Ltd',
    value: 2910,
  },
  {
    label: 'Certify Global',
    value: 2911,
  },
  {
    label: 'ZEFI',
    value: 2912,
  },
  {
    label: 'Yulu Bike',
    value: 2913,
  },
  {
    label: 'Digiversal',
    value: 2914,
  },
  {
    label: 'Atos Syntel',
    value: 2915,
  },
  {
    label: 'GrowCareer',
    value: 2916,
  },
  {
    label: 'Hailo Interactive Pvt Ltd',
    value: 2917,
  },
  {
    label: 'Slingpe Software Pvt Ltd',
    value: 2918,
  },
  {
    label: 'Innocirc Ventures',
    value: 2919,
  },
  {
    label: 'The Better India',
    value: 2920,
  },
  {
    label: 'SA Technologies Inc.',
    value: 2921,
  },
  {
    label: 'PhiGRC AI',
    value: 2922,
  },
  {
    label: 'IntelliMind LLC',
    value: 2923,
  },
  {
    label: 'Pretlist',
    value: 2924,
  },
  {
    label: 'SUGAR Cosmetics',
    value: 2925,
  },
  {
    label: 'WisdmLabs',
    value: 2926,
  },
  {
    label: 'GHSL Technologies Pvt.Ltd',
    value: 2927,
  },
  {
    label: 'VR | AR |MR',
    value: 2928,
  },
  {
    label: 'Intellect Design Arena',
    value: 2929,
  },
  {
    label: 'TSPL',
    value: 2930,
  },
  {
    label: 'Aapna Infotech Pvt. Ltd.',
    value: 2931,
  },
  {
    label: 'Studio Graphene Private Limited',
    value: 2932,
  },
  {
    label: 'LDS Engineers',
    value: 2933,
  },
  {
    label: 'Wissda.Inc',
    value: 2934,
  },
  {
    label: 'Artefacts',
    value: 2935,
  },
  {
    label: 'Dynamisch IT Pvt ltd.',
    value: 2936,
  },
  {
    label: 'Softility',
    value: 2937,
  },
  {
    label: 'Data Template Infotech Pvt Ltd.',
    value: 2938,
  },
  {
    label: 'Niki',
    value: 2939,
  },
  {
    label: 'MMT - Seventh Dev Pvt Ltd',
    value: 2940,
  },
  {
    label: 'Infosec Ventures',
    value: 2941,
  },
  {
    label: 'Expro Informatics India Private Limited',
    value: 2942,
  },
  {
    label: 'Crescerance India Pvt Ltd',
    value: 2943,
  },
  {
    label: 'Expro Informatics India Private Limited',
    value: 2944,
  },
  {
    label: 'Freestone Infotech',
    value: 2945,
  },
  {
    label: 'IGT Solutions',
    value: 2946,
  },
  {
    label: 'Human Forte',
    value: 2947,
  },
  {
    label: 'Divistha Networks',
    value: 2948,
  },
  {
    label: 'TechVerito Software Solutions LLP',
    value: 2949,
  },
  {
    label: 'Camellia Media & Entertainment Beyond Tech',
    value: 2950,
  },
  {
    label: 'OrangeMantra',
    value: 2951,
  },
  {
    label: 'Knorish',
    value: 2952,
  },
  {
    label: 'Agilisium',
    value: 2953,
  },
  {
    label: 'Megasoft',
    value: 2954,
  },
  {
    label: 'Armour Corporate Services',
    value: 2955,
  },
  {
    label: 'PowerLogix Electro Systems Pvt. Ltd.',
    value: 2956,
  },
  {
    label: 'Impact Guru',
    value: 2957,
  },
  {
    label: 'Elula Tech Pvt. Ltd.',
    value: 2958,
  },
  {
    label: 'Phenom People',
    value: 2959,
  },
  {
    label: 'Mactores',
    value: 2960,
  },
  {
    label: 'InstaReM India Pvt. Ltd.',
    value: 2961,
  },
  {
    label: 'AXS Solutions and Consulting Pvt. Ltd.',
    value: 2962,
  },
  {
    label: 'Nisum Consullting',
    value: 2963,
  },
  {
    label: 'ECHO India',
    value: 2964,
  },
  {
    label: 'Instasolv',
    value: 2965,
  },
  {
    label: 'Luezoid',
    value: 2966,
  },
  {
    label: 'BuildSupply',
    value: 2967,
  },
  {
    label: 'SynRadar',
    value: 2968,
  },
  {
    label: 'GHRS Pvt Ltd',
    value: 2969,
  },
  {
    label: 'Ab InBev',
    value: 2970,
  },
  {
    label: 'Phoenix Human Capital Pvt.Ltd',
    value: 2971,
  },
  {
    label: 'Robosoft Technologies',
    value: 2972,
  },
  {
    label: 'Eunimart Multichannel Pvt Ltd',
    value: 2973,
  },
  {
    label: 'Primefox Infotech',
    value: 2974,
  },
  {
    label: 'SustLabs',
    value: 2975,
  },
  {
    label: 'Infracloud',
    value: 2976,
  },
  {
    label: 'Green Agrevolution Pvt. Ltd.',
    value: 2977,
  },
  {
    label: 'Mobiquity',
    value: 2978,
  },
  {
    label: 'Mindlogicx Infratec Limited',
    value: 2979,
  },
  {
    label: 'Infiniti Research',
    value: 2980,
  },
  {
    label: 'Trigyn Technologies',
    value: 2981,
  },
  {
    label: 'Trent Hypermarket Pvt. Ltd.',
    value: 2982,
  },
  {
    label: 'Xiphias Software Pvt Ltd',
    value: 2983,
  },
  {
    label: 'Primedigital Global',
    value: 2984,
  },
  {
    label: 'Wingify',
    value: 2985,
  },
  {
    label: 'Neurosensum',
    value: 2986,
  },
  {
    label: 'ValueFirst Digital Media Private Limited',
    value: 2987,
  },
  {
    label: 'HUBX',
    value: 2988,
  },
  {
    label: 'Emorphis Software Technologies',
    value: 2989,
  },
  {
    label: 'Corusview',
    value: 2990,
  },
  {
    label: 'Expertrons',
    value: 2991,
  },
  {
    label: 'EagleView',
    value: 2992,
  },
  {
    label: 'myUpchar.com',
    value: 2993,
  },
  {
    label: 'Phenom People',
    value: 2994,
  },
  {
    label: 'Real Time Data Services',
    value: 2995,
  },
  {
    label: 'Fiport Software India Pvt Ltd',
    value: 2996,
  },
  {
    label: 'Postman',
    value: 2997,
  },
  {
    label: 'Transweb Educational services',
    value: 2998,
  },
  {
    label: 'OnPassive',
    value: 2999,
  },
  {
    label: 'AOC Consultants',
    value: 3000,
  },
  {
    label: 'Skool tree Technologies Pvt. Ltd',
    value: 3001,
  },
  {
    label: 'Phoenix Business Consulting',
    value: 3002,
  },
  {
    label: 'ManpraX Software LLP',
    value: 3003,
  },
  {
    label: 'Eximius Design',
    value: 3004,
  },
  {
    label: 'Monkhub Innovations Pvt. Ltd',
    value: 3005,
  },
  {
    label: 'houseoftours.com',
    value: 3006,
  },
  {
    label: 'Kudos India',
    value: 3007,
  },
  {
    label: 'Digileap Global',
    value: 3008,
  },
  {
    label: 'Endeavour Consultancy Services Pvt ltd',
    value: 3009,
  },
  {
    label: 'Insight International',
    value: 3010,
  },
  {
    label: 'Full Contact Technologies Pvt. Ltd.',
    value: 3011,
  },
  {
    label: 'Resource Solutions',
    value: 3012,
  },
  {
    label: 'Eco-Mail Development India Private Limited',
    value: 3013,
  },
  {
    label: 'Incture Technologies',
    value: 3014,
  },
  {
    label: 'Agilisium',
    value: 3015,
  },
  {
    label: 'Agicent',
    value: 3016,
  },
  {
    label: 'Thepeoplespecialists.com',
    value: 3017,
  },
  {
    label: 'Leena AI',
    value: 3018,
  },
  {
    label: 'Notuno Infotech',
    value: 3019,
  },
  {
    label: 'Tessolve Semiconductor',
    value: 3020,
  },
  {
    label: 'Simplified Cloud Solutions by VastEdge',
    value: 3021,
  },
  {
    label: 'Simform',
    value: 3022,
  },
  {
    label: 'Kodelounge India Pvt Ltd',
    value: 3023,
  },
  {
    label: 'SA Technologies',
    value: 3024,
  },
  {
    label: 'SynWin Solutions',
    value: 3025,
  },
  {
    label: 'Book My Vehicle',
    value: 3026,
  },
  {
    label: 'Mobycy-BycyShare Technologies Pvt. Ltd.',
    value: 3027,
  },
  {
    label: 'Fynd',
    value: 3028,
  },
  {
    label: 'Network Techlab (I) Pvt. Ltd.',
    value: 3029,
  },
  {
    label: 'Raitha Agrogator Pvt Ltd',
    value: 3030,
  },
  {
    label: 'Nexgen Consultancy Pvt. Ltd.',
    value: 3031,
  },
  {
    label: 'OTO Capital',
    value: 3032,
  },
  {
    label: 'Minkspay',
    value: 3033,
  },
  {
    label: 'Squareops',
    value: 3034,
  },
  {
    label: 'InfoEdge',
    value: 3035,
  },
  {
    label: 'Tripoto',
    value: 3036,
  },
  {
    label: 'FCI/Smartbox',
    value: 3037,
  },
  {
    label: 'Onefitstop',
    value: 3038,
  },
  {
    label: 'Uloapp',
    value: 3039,
  },
  {
    label: 'Lericon Informatics Pvt. Ltd.',
    value: 3040,
  },
  {
    label: 'Teknuance Info Solutions Pvt.Ltd',
    value: 3041,
  },
  {
    label: 'Secure Meters Ltd.',
    value: 3042,
  },
  {
    label: 'Inhapp Consultancy',
    value: 3043,
  },
  {
    label: 'Rozgarkhoj.com',
    value: 3044,
  },
  {
    label: 'Sourcebits Technologies',
    value: 3045,
  },
  {
    label: 'Kaptura Technologies Pvt Ltd.',
    value: 3046,
  },
  {
    label: 'Fluidscapes Consultants Pvt. Ltd.',
    value: 3047,
  },
  {
    label: 'Boutiqaat',
    value: 3048,
  },
  {
    label: 'Websultanate Software Technologies Pvt Ltd',
    value: 3049,
  },
  {
    label: 'Hagnosoft Technologies',
    value: 3050,
  },
  {
    label: 'Altlifelab Solutions Pvt. Ltd.',
    value: 3051,
  },
  {
    label: 'Analytics Saves At Work India Pvt Ltd.',
    value: 3052,
  },
  {
    label: 'Future Work Technologies',
    value: 3053,
  },
  {
    label: 'DataGyani Consulting',
    value: 3054,
  },
  {
    label: 'OLX India',
    value: 3055,
  },
  {
    label: 'Timesys Technologies',
    value: 3056,
  },
  {
    label: 'SeeWe',
    value: 3057,
  },
  {
    label: 'Xcelpros',
    value: 3058,
  },
  {
    label: 'Thought Focus',
    value: 3059,
  },
  {
    label: 'Vinove Software',
    value: 3060,
  },
  {
    label: 'Keubik Technology',
    value: 3061,
  },
  {
    label: 'TLP Globus Solutions Pvt. Ltd.',
    value: 3062,
  },
  {
    label: 'Hexad Infosoft Pvt Ltd',
    value: 3063,
  },
  {
    label: 'Dow Technologies and Systems',
    value: 3064,
  },
  {
    label: 'Sunera',
    value: 3065,
  },
  {
    label: 'OutdoorMonk',
    value: 3066,
  },
  {
    label: 'Marmeto',
    value: 3067,
  },
  {
    label: 'iGlobe Solutions',
    value: 3068,
  },
  {
    label: 'Rediflex',
    value: 3069,
  },
  {
    label: 'Si2 Technologies',
    value: 3070,
  },
  {
    label: 'Bloom Consulting Services',
    value: 3071,
  },
  {
    label: 'AskSid Technology Solutions Pvt. Ltd.',
    value: 3072,
  },
  {
    label: 'Cardinal Technology Solutions',
    value: 3073,
  },
  {
    label: 'iface LLC',
    value: 3074,
  },
  {
    label: 'Purplle.com',
    value: 3075,
  },
  {
    label: 'WedmeGood',
    value: 3076,
  },
  {
    label: 'NJS InfoTech',
    value: 3077,
  },
  {
    label: 'MintM',
    value: 3078,
  },
  {
    label: 'Alpha Net',
    value: 3079,
  },
  {
    label: 'Intellipaat',
    value: 3080,
  },
  {
    label: 'SpringerNature',
    value: 3081,
  },
  {
    label: '10Times Online Private Limited',
    value: 3082,
  },
  {
    label: 'Finarb Analytics',
    value: 3083,
  },
  {
    label: 'Scalene Works',
    value: 3084,
  },
  {
    label: 'Optimize IT Systems',
    value: 3085,
  },
  {
    label: 'Benefitalign',
    value: 3086,
  },
  {
    label: 'DirecTech Labs',
    value: 3087,
  },
  {
    label: 'TechBrise Solutions Private Limited',
    value: 3088,
  },
  {
    label: 'Crelytics',
    value: 3089,
  },
  {
    label: 'Child Health Imprints',
    value: 3090,
  },
  {
    label: 'WaveMaker Inc',
    value: 3091,
  },
  {
    label: 'Adda247',
    value: 3092,
  },
  {
    label: 'Wizikey',
    value: 3093,
  },
  {
    label: 'Logikle',
    value: 3094,
  },
  {
    label: 'Medha',
    value: 3095,
  },
  {
    label: 'Sizzle',
    value: 3096,
  },
  {
    label: 'Datagain Inc.',
    value: 3097,
  },
  {
    label: 'Ucodice Technologies Private Limited',
    value: 3098,
  },
  {
    label: 'Ebslon Infotech',
    value: 3099,
  },
  {
    label: 'Agara Labs',
    value: 3100,
  },
  {
    label: 'Scrutiny Software Solutions Pvt Ltd',
    value: 3101,
  },
  {
    label: 'Inzerotech India',
    value: 3102,
  },
  {
    label: 'RIMS Bizzserve Pvt Ltd',
    value: 3103,
  },
  {
    label: 'BR Softech Pvt Ltd',
    value: 3104,
  },
  {
    label: 'Finoux Solutions Pvt Ltd',
    value: 3105,
  },
  {
    label: 'Snapwiz Edutec',
    value: 3106,
  },
  {
    label: 'SmartQ - Bottle Lab Technologies Private Limited',
    value: 3107,
  },
  {
    label: 'Spear Talent IT Consulting',
    value: 3108,
  },
  {
    label: 'Tradesocio India Private Limited',
    value: 3109,
  },
  {
    label: 'Innovative Logic Lab',
    value: 3110,
  },
  {
    label: 'Porter',
    value: 3111,
  },
  {
    label: 'Happiest Minds Technologies',
    value: 3112,
  },
  {
    label: 'Web Data Technologies LLP',
    value: 3113,
  },
  {
    label: 'Scientity Design Innovations',
    value: 3114,
  },
  {
    label: 'Sanctum Networks',
    value: 3115,
  },
  {
    label: 'FIS Global',
    value: 3116,
  },
  {
    label: 'Glentec Engineering',
    value: 3117,
  },
  {
    label: 'Apex IT Pvt. Ltd.',
    value: 3118,
  },
  {
    label: 'Livquik Technologies',
    value: 3119,
  },
  {
    label: 'Fidelity National Financial',
    value: 3120,
  },
  {
    label: 'AlefEdge',
    value: 3121,
  },
  {
    label: 'Panaesha Capital Pvt Ltd',
    value: 3122,
  },
  {
    label: 'Zapbuild technologies pvt.ltd.',
    value: 3123,
  },
  {
    label: 'LimpidFrog',
    value: 3124,
  },
  {
    label: 'Enuke Software',
    value: 3125,
  },
  {
    label: 'Pinetech IT Solutions',
    value: 3126,
  },
  {
    label: 'Honeywell Technology Solutions',
    value: 3127,
  },
  {
    label: 'Biz2Credit Inc(Fintech)',
    value: 3128,
  },
  {
    label: 'Gnani.ai',
    value: 3129,
  },
  {
    label: 'Treeni Sustainability Solutions Pvt. Ltd.',
    value: 3130,
  },
  {
    label: 'CRG Solutions Pvt. Ltd.',
    value: 3131,
  },
  {
    label: 'Akira Consultancy Pvt. Ltd.',
    value: 3132,
  },
  {
    label: "J's Business Solutions",
    value: 3133,
  },
  {
    label: 'Softlabs Technologies and Development Pvt. Ltd.',
    value: 3134,
  },
  {
    label: 'Kredent InfoEdge  Private Limited',
    value: 3135,
  },
  {
    label: 'Gemini Solutions Pvt Ltd',
    value: 3136,
  },
  {
    label: 'Sunera Technologies',
    value: 3137,
  },
  {
    label: 'IT By Design',
    value: 3138,
  },
  {
    label: 'Nuclei',
    value: 3139,
  },
  {
    label: 'Unibiztec',
    value: 3140,
  },
  {
    label: 'Tech Ancubate Pvt Ltd',
    value: 3141,
  },
  {
    label: 'Quanteon Solution',
    value: 3142,
  },
  {
    label: 'Infinity Labs',
    value: 3143,
  },
  {
    label: 'CCS-Technologies',
    value: 3144,
  },
  {
    label: 'People10',
    value: 3145,
  },
  {
    label: 'Ceegees',
    value: 3146,
  },
  {
    label: 'StoryXpress',
    value: 3147,
  },
  {
    label: 'PayMe India',
    value: 3148,
  },
  {
    label: 'Cigniti',
    value: 3149,
  },
  {
    label: 'Krify Software Technologies Pvt. Ltd.',
    value: 3150,
  },
  {
    label: 'Qualihires',
    value: 3151,
  },
  {
    label: 'Kreate Global',
    value: 3152,
  },
  {
    label: 'Midland Credit Management',
    value: 3153,
  },
  {
    label: 'Simple Logic IT Pvt. Ltd',
    value: 3154,
  },
  {
    label: 'GoMassive.in',
    value: 3155,
  },
  {
    label: 'Ampere Software Pvt. Ltd.',
    value: 3156,
  },
  {
    label: 'Meditation.live',
    value: 3157,
  },
  {
    label: 'Techzilla India Infotech',
    value: 3158,
  },
  {
    label: 'Benovymed Healthcare Private Ltd',
    value: 3159,
  },
  {
    label: 'Institute of Product Leadership',
    value: 3160,
  },
  {
    label: 'mPokket',
    value: 3161,
  },
  {
    label: 'Dcoder',
    value: 3162,
  },
  {
    label: 'Story Digital',
    value: 3163,
  },
  {
    label: 'Agilisium',
    value: 3164,
  },
  {
    label: 'CyBuzzSC Infotech Pvt. Ltd.',
    value: 3165,
  },
  {
    label: 'Leap Skills',
    value: 3166,
  },
  {
    label: 'Webethics Solutions',
    value: 3167,
  },
  {
    label: 'Effective Digital',
    value: 3168,
  },
  {
    label: 'OML Group',
    value: 3169,
  },
  {
    label: 'Hippo cabs',
    value: 3170,
  },
  {
    label: 'Gemini Consulting Services',
    value: 3171,
  },
  {
    label: 'Tata Elxsi',
    value: 3172,
  },
  {
    label: 'Greenlight Planet',
    value: 3173,
  },
  {
    label: 'DeepR Analytics',
    value: 3174,
  },
  {
    label: 'Galaxy Weblinks Ltd.',
    value: 3175,
  },
  {
    label: 'Quantsapp Pvt. Ltd.',
    value: 3176,
  },
  {
    label: 'Immortal Technologies',
    value: 3177,
  },
  {
    label: 'RecruVia',
    value: 3178,
  },
  {
    label: 'Oye Rickshaw',
    value: 3179,
  },
  {
    label: 'Popocornapps',
    value: 3180,
  },
  {
    label: 'Trunkoz Technologies Pvt Ltd.',
    value: 3181,
  },
  {
    label: 'Tessolve Semiconductor Pvt Ltd',
    value: 3182,
  },
  {
    label: 'Daffodil Software',
    value: 3183,
  },
  {
    label: 'HERE Technologies',
    value: 3184,
  },
  {
    label: 'Kuliza Technologies',
    value: 3185,
  },
  {
    label: 'ProAppTech',
    value: 3186,
  },
  {
    label: 'GiveIndia Foundation',
    value: 3187,
  },
  {
    label: 'Aspiring Minds Assessment Pvt Ltd',
    value: 3188,
  },
  {
    label: 'Leading Startup',
    value: 3189,
  },
  {
    label: 'InfyOm Technologies',
    value: 3190,
  },
  {
    label: 'ZibaCube Technologies',
    value: 3191,
  },
  {
    label: 'Codexfly Technology Pvt. Ltd.',
    value: 3192,
  },
  {
    label: 'KreditPaisa Technology Private Ltd.',
    value: 3193,
  },
  {
    label: 'Intelehealth',
    value: 3194,
  },
  {
    label: 'DawnBIT Technologies LLP',
    value: 3195,
  },
  {
    label: 'Vdart inc.',
    value: 3196,
  },
  {
    label: 'Ninestars',
    value: 3197,
  },
  {
    label: 'Page Potato',
    value: 3198,
  },
  {
    label: 'Spacewell',
    value: 3199,
  },
  {
    label: 'HealthPlix Technologies',
    value: 3200,
  },
  {
    label: 'YES IT Labs',
    value: 3201,
  },
  {
    label: 'WalletHub',
    value: 3202,
  },
  {
    label: 'Fluid AI',
    value: 3203,
  },
  {
    label: 'EinNel Technologies',
    value: 3204,
  },
  {
    label: 'Circuitronix',
    value: 3205,
  },
  {
    label: 'Quarks Technosoft',
    value: 3206,
  },
  {
    label: 'Tricog Health Services',
    value: 3207,
  },
  {
    label: 'exponentia.ai',
    value: 3208,
  },
  {
    label: 'Techindustan Pvt Ltd',
    value: 3209,
  },
  {
    label: 'Landis Gyr',
    value: 3210,
  },
  {
    label: 'BigTapp India Pvt Ltd',
    value: 3211,
  },
  {
    label: 'TravelTriangle',
    value: 3212,
  },
  {
    label: 'KudosIndia',
    value: 3213,
  },
  {
    label: 'Northern Arc',
    value: 3214,
  },
  {
    label: 'Cipher Dynamics',
    value: 3215,
  },
  {
    label: 'InnovationM',
    value: 3216,
  },
  {
    label: 'Servian',
    value: 3217,
  },
  {
    label: 'Quintype Technologies India Pvt Ltd',
    value: 3218,
  },
  {
    label: 'GramFactory',
    value: 3219,
  },
  {
    label: 'Saras Analytics',
    value: 3220,
  },
  {
    label: 'Merck Group',
    value: 3221,
  },
  {
    label: 'Huulke',
    value: 3222,
  },
  {
    label: 'Comnet Innovations Pvt Ltd',
    value: 3223,
  },
  {
    label: 'Algo8',
    value: 3224,
  },
  {
    label: 'Abyeti Technologies Private Limited',
    value: 3225,
  },
  {
    label: 'Asergis',
    value: 3226,
  },
  {
    label: 'Snapwork Technology',
    value: 3227,
  },
  {
    label: 'Leap Skills',
    value: 3228,
  },
  {
    label: 'SteerLean',
    value: 3229,
  },
  {
    label: 'ManpraX Software LLP',
    value: 3230,
  },
  {
    label: 'Cogoport',
    value: 3231,
  },
  {
    label: 'Emproto Technologies',
    value: 3232,
  },
  {
    label: 'Loylogic Technologies India Pvt. Ltd.',
    value: 3233,
  },
  {
    label: 'Vakilsearch',
    value: 3234,
  },
  {
    label: 'TO THE NEW',
    value: 3235,
  },
  {
    label: 'Atechnos',
    value: 3236,
  },
  {
    label: 'Scientific Publishing Services',
    value: 3237,
  },
  {
    label: 'The Khel Group',
    value: 3238,
  },
  {
    label: 'Aptagrim',
    value: 3239,
  },
  {
    label: 'Nextworld Solutions Pvt Ltd',
    value: 3240,
  },
  {
    label: 'Rype',
    value: 3241,
  },
  {
    label: 'Avenue Supermarts',
    value: 3242,
  },
  {
    label: 'Hotstar.com',
    value: 3243,
  },
  {
    label: 'Straviso',
    value: 3244,
  },
  {
    label: 'Synconext',
    value: 3245,
  },
  {
    label: 'Tatvic Analytics',
    value: 3246,
  },
  {
    label: 'Rocket Flyer Technology Private Limited',
    value: 3247,
  },
  {
    label: 'Talent Stock Solution',
    value: 3248,
  },
  {
    label: 'Junglee Games',
    value: 3249,
  },
  {
    label: 'Benepik',
    value: 3250,
  },
  {
    label: 'INK IT Solutions',
    value: 3251,
  },
  {
    label: 'Simpplr',
    value: 3252,
  },
  {
    label: 'Swar Yantra Technologies',
    value: 3253,
  },
  {
    label: 'Sadhan Enterprise (I) Pvt. Ltd.',
    value: 3254,
  },
  {
    label: 'Terminal Contacts',
    value: 3255,
  },
  {
    label: 'Heady Technologies Consultancy Pvt. Ltd.',
    value: 3256,
  },
  {
    label: 'NearGroup',
    value: 3257,
  },
  {
    label: 'Pace Wisdom Solutions Ltd',
    value: 3258,
  },
  {
    label: 'Credenc',
    value: 3259,
  },
  {
    label: 'Jaypore E-commerce Pvt Ltd',
    value: 3260,
  },
  {
    label: 'Innovecture',
    value: 3261,
  },
  {
    label: 'Happay - Expense Management Solution',
    value: 3262,
  },
  {
    label: 'Xotiv Technologies',
    value: 3263,
  },
  {
    label: 'Karomi Technology Pvt Ltd',
    value: 3264,
  },
  {
    label: 'Zorang Technologies',
    value: 3265,
  },
  {
    label: 'HealthReflect',
    value: 3266,
  },
  {
    label: 'Baby Destination',
    value: 3267,
  },
  {
    label: 'Drona HQ',
    value: 3268,
  },
  {
    label: 'Gameberry Labs',
    value: 3269,
  },
  {
    label: 'Inteliheads',
    value: 3270,
  },
  {
    label: 'Gladwin Analytics Pvt Ltd',
    value: 3271,
  },
  {
    label: 'Satva Solutions',
    value: 3272,
  },
  {
    label: 'Starclinch',
    value: 3273,
  },
  {
    label: 'Netomi',
    value: 3274,
  },
  {
    label: 'Viaprom Technologies Pvt Ltd',
    value: 3275,
  },
  {
    label: 'Newton Consulting',
    value: 3276,
  },
  {
    label: 'Satori Group',
    value: 3277,
  },
  {
    label: 'Cobold Digital LLP',
    value: 3278,
  },
  {
    label: 'Invenzo Labs',
    value: 3279,
  },
  {
    label: 'Rolling Arrays Consulting Pvt Ltd',
    value: 3280,
  },
  {
    label: 'Snippt Media Private Limited',
    value: 3281,
  },
  {
    label: 'Talview',
    value: 3282,
  },
  {
    label: 'Golden Hues Consultant',
    value: 3283,
  },
  {
    label: 'Rubico IT Pvt Ltd',
    value: 3284,
  },
  {
    label: 'FIS Payment Solutions and Services India Pvt Ltd',
    value: 3285,
  },
  {
    label: 'DemandMatrix',
    value: 3286,
  },
  {
    label: 'Animaker',
    value: 3287,
  },
  {
    label: 'Hyperbeans Infotech',
    value: 3288,
  },
  {
    label: 'Flexing IT Services Pvt. Ltd.',
    value: 3289,
  },
  {
    label: 'Truebil.com (Paix Technology Pvt Ltd)',
    value: 3290,
  },
  {
    label: 'MatchMove',
    value: 3291,
  },
  {
    label: 'Averiware Inc',
    value: 3292,
  },
  {
    label: 'Pure Knowledge Solutions LLP',
    value: 3293,
  },
  {
    label: 'Webixion Technologies Pvt. Ltd.',
    value: 3294,
  },
  {
    label: 'Mirabel Technologies Pvt. Ltd.',
    value: 3295,
  },
  {
    label: 'Gemini Solutions Pvt Ltd',
    value: 3296,
  },
  {
    label: 'Apex IT',
    value: 3297,
  },
  {
    label: 'LocationGuru Solutions Pvt Ltd',
    value: 3298,
  },
  {
    label: 'SocialPilot',
    value: 3299,
  },
  {
    label: 'AM Infocraft',
    value: 3300,
  },
  {
    label: 'Voxta',
    value: 3301,
  },
  {
    label: 'Optiquall Solutions',
    value: 3302,
  },
  {
    label: 'Kivi Capital',
    value: 3303,
  },
  {
    label: 'Integration Wizards Solutions',
    value: 3304,
  },
  {
    label: 'Propellum',
    value: 3305,
  },
  {
    label: 'Scanova',
    value: 3306,
  },
  {
    label: 'Chapter247',
    value: 3307,
  },
  {
    label: 'Simson Softwares Pvt. Ltd.',
    value: 3308,
  },
  {
    label: 'Odessa Technologies',
    value: 3309,
  },
  {
    label: 'Shopclues',
    value: 3310,
  },
  {
    label: 'Uniterrene Websoft Pvt. Ltd',
    value: 3311,
  },
  {
    label: 'Scienaptic',
    value: 3312,
  },
  {
    label: 'Positive Moves',
    value: 3313,
  },
  {
    label: 'iMarkserv',
    value: 3314,
  },
  {
    label: 'Innovellent',
    value: 3315,
  },
  {
    label: 'Innominds',
    value: 3316,
  },
  {
    label: 'gNxt Systems',
    value: 3317,
  },
  {
    label: 'Onqanet Technologies Pvt Ltd',
    value: 3318,
  },
  {
    label: 'Industry Buying',
    value: 3319,
  },
  {
    label: 'Karza Technologies',
    value: 3320,
  },
  {
    label: 'Misha Infotech Pvt Ltd',
    value: 3321,
  },
  {
    label: 'Visual BI Solutions',
    value: 3322,
  },
  {
    label: 'Xilinx',
    value: 3323,
  },
  {
    label: 'Continental Automotive Components India Pvt Ltd',
    value: 3324,
  },
  {
    label: 'Adevole',
    value: 3325,
  },
  {
    label: 'Collegedunia Web Pvt. Ltd.',
    value: 3326,
  },
  {
    label: 'MyFitFuel',
    value: 3327,
  },
  {
    label: 'Algoscale',
    value: 3328,
  },
  {
    label: 'DSSI Solutions India Pvt Ltd',
    value: 3329,
  },
  {
    label: 'Indianmesh Pvt Ltd',
    value: 3330,
  },
  {
    label: 'Greytrix',
    value: 3331,
  },
  {
    label: 'Etymon Technologies Pvt. Ltd.',
    value: 3332,
  },
  {
    label: 'OnGraph Technologies Pvt Ltd',
    value: 3333,
  },
  {
    label: 'Ecrubit Software Services',
    value: 3334,
  },
  {
    label: 'Qbrik Information Technologies',
    value: 3335,
  },
  {
    label: 'Career Makers',
    value: 3336,
  },
  {
    label: 'KVR Web Tech Pvt Ltd',
    value: 3337,
  },
  {
    label: 'WebInfoMart',
    value: 3338,
  },
  {
    label: 'Cartisan',
    value: 3339,
  },
  {
    label: 'CircuitSutra Technologies Pvt Ltd',
    value: 3340,
  },
  {
    label: 'Techdew',
    value: 3341,
  },
  {
    label: 'Ginger Webs Pvt. Ltd.',
    value: 3342,
  },
  {
    label: 'Big Rattle Technologies',
    value: 3343,
  },
  {
    label: 'PromptCloud',
    value: 3344,
  },
  {
    label: 'Optimus BT Infotech Pvt Ltd',
    value: 3345,
  },
  {
    label: 'Ixigo',
    value: 3346,
  },
  {
    label: 'Chargebee.com',
    value: 3347,
  },
  {
    label: 'hirist.com',
    value: 3348,
  },
  {
    label: 'Uber',
    value: 3349,
  },
  {
    label: 'REBEL Foods',
    value: 3350,
  },
  {
    label: 'GSN Games',
    value: 3351,
  },
  {
    label: 'KreditBee',
    value: 3352,
  },
  {
    label: 'Chegg',
    value: 3353,
  },
  {
    label: 'Cropin Technology Solutions',
    value: 3354,
  },
  {
    label: 'Merilytics',
    value: 3355,
  },
  {
    label: 'YULU',
    value: 3356,
  },
  {
    label: "BYJU'S",
    value: 3357,
  },
  {
    label: 'PayU',
    value: 3358,
  },
  {
    label: 'Tally',
    value: 3359,
  },
  {
    label: 'Cure.Fit',
    value: 3360,
  },
  {
    label: 'Udaan',
    value: 3361,
  },
  {
    label: 'OLX',
    value: 3362,
  },
  {
    label: 'GAP',
    value: 3363,
  },
  {
    label: 'HUL',
    value: 3364,
  },
  {
    label: 'ShadowFax',
    value: 3365,
  },
  {
    label: 'LIVSPACE',
    value: 3366,
  },
  {
    label: 'EPAM',
    value: 3367,
  },
  {
    label: 'Atlassian',
    value: 3368,
  },
  {
    label: '#Covid19',
    value: 3369,
  },
  {
    label: 'IKS Health',
    value: 3370,
  },
  {
    label: 'Naisite',
    value: 3371,
  },
  {
    label: 'Delicon Consulting Services Private Limited',
    value: 3372,
  },
  {
    label: 'PDV Technocrats Pvt Ltd',
    value: 3373,
  },
  {
    label: 'TrueFan',
    value: 3374,
  },
  {
    label: 'Fortanix',
    value: 3375,
  },
  {
    label: 'PatientMD',
    value: 3376,
  },
  {
    label: 'Sunstone Eduversity',
    value: 3377,
  },
  {
    label: 'Nvent.com',
    value: 3378,
  },
  {
    label: 'Jubilant Foodworks',
    value: 3379,
  },
  {
    label: 'Php Expert Technologies Pvt. Ltd.',
    value: 3380,
  },
  {
    label: 'Tachyon Technologies',
    value: 3381,
  },
  {
    label: 'Emerging India Educational Services Pvt Ltd',
    value: 3382,
  },
  {
    label: 'Varutra Consulting Pvt Ltd',
    value: 3383,
  },
  {
    label: 'The Media Ant',
    value: 3384,
  },
  {
    label: 'BOCS',
    value: 3385,
  },
  {
    label: 'Rexperts',
    value: 3386,
  },
  {
    label: 'Arthimpact Finserve Private Limited',
    value: 3387,
  },
  {
    label: 'Talpro',
    value: 3388,
  },
  {
    label: 'Arteria technologies',
    value: 3389,
  },
  {
    label: 'HashBinary',
    value: 3390,
  },
  {
    label: 'Cogniminds',
    value: 3391,
  },
  {
    label: 'Alore Growth OS',
    value: 3392,
  },
  {
    label: 'Darshan Softech Pvt Ltd',
    value: 3393,
  },
  {
    label: 'Media',
    value: 3394,
  },
  {
    label: 'Afour Technologies',
    value: 3395,
  },
  {
    label: 'AsknBid Tech',
    value: 3396,
  },
  {
    label: 'STEFANINI INDIA PRIVATE LIMITED',
    value: 3397,
  },
  {
    label: 'QR Solutions',
    value: 3398,
  },
  {
    label: 'Milliman',
    value: 3399,
  },
  {
    label: 'Furdom',
    value: 3400,
  },
  {
    label: 'Progressive infovision pvt ltd',
    value: 3401,
  },
  {
    label: 'MoreYeahs IT Technologies Private Limited.',
    value: 3402,
  },
  {
    label: 'Intellectyx Data Science Pvt Ltd',
    value: 3403,
  },
  {
    label: 'Mercom',
    value: 3404,
  },
  {
    label: 'Yash Papers Limited',
    value: 3405,
  },
  {
    label: 'Passion Connect',
    value: 3406,
  },
  {
    label: 'Shvintech',
    value: 3407,
  },
  {
    label: 'Skillr',
    value: 3408,
  },
  {
    label: 'Cogniphi Technologies',
    value: 3409,
  },
  {
    label: 'Cogniphi Technologies Pvt Ltd',
    value: 3410,
  },
  {
    label: 'Darshan Softech Pvt Ltd',
    value: 3411,
  },
  {
    label: 'Circular Edge',
    value: 3412,
  },
  {
    label: 'Yethi Consulting Pvt Ltd',
    value: 3413,
  },
  {
    label: 'Addtobuy',
    value: 3414,
  },
  {
    label: 'HMD Global',
    value: 3415,
  },
  {
    label: 'VONG',
    value: 3416,
  },
  {
    label: 'Firstface',
    value: 3417,
  },
  {
    label: 'Jubilant FoodWorks',
    value: 3418,
  },
  {
    label: 'Eightfold AI India Pvt Ltd',
    value: 3419,
  },
  {
    label: 'Torre Capital',
    value: 3420,
  },
  {
    label: 'Career Path HR Services',
    value: 3421,
  },
  {
    label: 'Techno Wise',
    value: 3422,
  },
  {
    label: 'Majoris Technologies',
    value: 3423,
  },
  {
    label: 'Corpstars',
    value: 3424,
  },
  {
    label: 'Cosmic Strands ePublishing Pvt. Ltd.',
    value: 3425,
  },
  {
    label: 'CarbyneTech India Pvt Ltd',
    value: 3426,
  },
  {
    label: 'Digixhub',
    value: 3427,
  },
  {
    label: 'AmpleLogic',
    value: 3428,
  },
  {
    label: 'Brickview Studios',
    value: 3429,
  },
  {
    label: 'ANRI Solutions HR Services Pvt Ltd',
    value: 3430,
  },
  {
    label: 'Recity Network Pvt Ltd',
    value: 3431,
  },
  {
    label: 'Royal Elegance Technologies Private Limited',
    value: 3432,
  },
  {
    label: 'Yoptima Media Solutions Pvt Ltd',
    value: 3433,
  },
  {
    label: 'WebScoot.io',
    value: 3434,
  },
  {
    label: 'Xpressbees',
    value: 3435,
  },
  {
    label: 'Sysgain Information Technology',
    value: 3436,
  },
  {
    label: 'AfourTech',
    value: 3437,
  },
  {
    label: 'Mobileum',
    value: 3438,
  },
  {
    label: 'Hewlett Packard Enterprise',
    value: 3439,
  },
  {
    label: 'Cogniphi',
    value: 3440,
  },
  {
    label: 'Airlearn AI',
    value: 3441,
  },
  {
    label: 'ExcellenceTech',
    value: 3442,
  },
  {
    label: 'BlueAccel',
    value: 3443,
  },
  {
    label: 'Pitstop',
    value: 3444,
  },
  {
    label: 'Tracepaths',
    value: 3445,
  },
  {
    label: 'PCB Apps Global',
    value: 3446,
  },
  {
    label: 'Motherhood',
    value: 3447,
  },
  {
    label: 'AIT Global India Pvt. Ltd.',
    value: 3448,
  },
  {
    label: 'JNIT Technologies',
    value: 3449,
  },
  {
    label: 'SAGA',
    value: 3450,
  },
  {
    label: 'Neosoft Technologies',
    value: 3451,
  },
  {
    label: 'Synophic',
    value: 3452,
  },
  {
    label: 'Cerence',
    value: 3453,
  },
  {
    label: 'NetEnrich Technologies Pvt Ltd',
    value: 3454,
  },
  {
    label: 'Hammurabi Labs',
    value: 3455,
  },
  {
    label: 'NetEnrich',
    value: 3456,
  },
  {
    label: 'Kratin Software Solutions Pvt. Ltd.',
    value: 3457,
  },
  {
    label: 'Techversant Infotech',
    value: 3458,
  },
  {
    label: 'Rapid Value',
    value: 3459,
  },
  {
    label: 'Crimson Interactive',
    value: 3460,
  },
  {
    label: 'Naxbit',
    value: 3461,
  },
  {
    label: 'Incredible Visibility',
    value: 3462,
  },
  {
    label: 'BIPS Systems Limited',
    value: 3463,
  },
  {
    label: 'Synophic Worldwide',
    value: 3464,
  },
  {
    label: 'Web Synergies',
    value: 3465,
  },
  {
    label: 'Avantive Solutions',
    value: 3466,
  },
  {
    label: 'SuccessR Hrtech Pvt Ltd',
    value: 3467,
  },
  {
    label: 'Reopable',
    value: 3468,
  },
  {
    label: 'Tech Democracy',
    value: 3469,
  },
  {
    label: 'Sify Technologies Limited',
    value: 3470,
  },
  {
    label: 'Spacejoy.com',
    value: 3471,
  },
  {
    label: 'CHUBB Business Services',
    value: 3472,
  },
  {
    label: 'Chubb India',
    value: 3473,
  },
  {
    label: 'CHUBB',
    value: 3474,
  },
  {
    label: 'NeoSOFT Technologies',
    value: 3475,
  },
  {
    label: 'HireSure.ai',
    value: 3476,
  },
  {
    label: 'Syntellect Research Europe ltd',
    value: 3477,
  },
  {
    label: 'Instant Systems',
    value: 3478,
  },
  {
    label: 'Lancelottechnology',
    value: 3479,
  },
  {
    label: 'Hewlett Packard Enterprise',
    value: 3480,
  },
  {
    label: 'Chubb',
    value: 3481,
  },
  {
    label: 'Chubb',
    value: 3482,
  },
  {
    label: 'LetsService Automotive Technologies Pvt Ltd',
    value: 3483,
  },
  {
    label: 'Chubb',
    value: 3484,
  },
  {
    label: 'Designcafe',
    value: 3485,
  },
  {
    label: 'Way2news',
    value: 3486,
  },
  {
    label: 'ARTERIA TECHNOLOGIES PVT LTD',
    value: 3487,
  },
  {
    label: 'HackerEarth',
    value: 3488,
  },
  {
    label: 'EXL Services',
    value: 3489,
  },
  {
    label: 'Credit Repair Cloud',
    value: 3490,
  },
  {
    label: 'Urban Commerce',
    value: 3491,
  },
  {
    label: 'AssetSense',
    value: 3492,
  },
  {
    label: 'Cytel Statistical Software & Services PvtLtd.',
    value: 3493,
  },
  {
    label: 'Innnov',
    value: 3494,
  },
  {
    label: 'Enterprise Touch Pvt Ltd',
    value: 3495,
  },
  {
    label: 'o9 Solutions',
    value: 3496,
  },
  {
    label: 'CAMP Systems Pvt Ltd',
    value: 3497,
  },
  {
    label: 'o9 Solutions Inc.,',
    value: 3498,
  },
  {
    label: 'Coding Ninjas',
    value: 3499,
  },
  {
    label: 'XS Worldwide',
    value: 3500,
  },
  {
    label: 'Creativewebo',
    value: 3501,
  },
  {
    label: 'State Street',
    value: 3502,
  },
  {
    label: 'SMK Digital Services',
    value: 3503,
  },
  {
    label: 'Quolam Business Solutions',
    value: 3504,
  },
  {
    label: 'cyfordtechnologies LLC',
    value: 3505,
  },
  {
    label: 'Penthara Technologies Inc.',
    value: 3506,
  },
  {
    label: 'Manupatra Information Solutions Pvt. Ltd.',
    value: 3507,
  },
  {
    label: 'Provance',
    value: 3508,
  },
  {
    label: 'C Square Info Solutions',
    value: 3509,
  },
  {
    label: 'MyGate',
    value: 3510,
  },
  {
    label: 'Omnirio',
    value: 3511,
  },
  {
    label: 'HESPL',
    value: 3512,
  },
  {
    label: 'TechnipFMC',
    value: 3513,
  },
  {
    label: 'US Software Group Inc',
    value: 3514,
  },
  {
    label: 'TechnipFMC',
    value: 3515,
  },
  {
    label: 'SynOption Pte Ltd',
    value: 3516,
  },
  {
    label: 'upSAVE Analytics',
    value: 3517,
  },
  {
    label: 'PillStore',
    value: 3518,
  },
  {
    label: 'NetEnrich',
    value: 3519,
  },
  {
    label: 'TechnipFMC Global Business Services',
    value: 3520,
  },
  {
    label: 'HCode Technologies Pvt Ltd',
    value: 3521,
  },
  {
    label: 'CIED Group',
    value: 3522,
  },
  {
    label: 'The Tech Bridge',
    value: 3523,
  },
  {
    label: 'WonderTech PTE',
    value: 3524,
  },
  {
    label: 'Ad Astra consultants Pvt Ltd',
    value: 3525,
  },
  {
    label: 'Infopie Business Solutions',
    value: 3526,
  },
  {
    label: 'ApnaJob Hiring Solutions',
    value: 3527,
  },
  {
    label: 'Tamil Nadu e-Governance Agency',
    value: 3528,
  },
  {
    label: 'Milestone Ventures',
    value: 3529,
  },
  {
    label: 'Aditron Technologies LLP',
    value: 3530,
  },
  {
    label: 'Brainvire Infotech Pvt.Ltd.',
    value: 3531,
  },
  {
    label: 'Xpressbees Logistics Pvt Ltd',
    value: 3532,
  },
  {
    label: 'HouseJoy',
    value: 3533,
  },
  {
    label: 'AMK Information Systems Pvt. Ltd.(Miraah)',
    value: 3534,
  },
  {
    label: 'Coalshastra Pvt Ltd',
    value: 3535,
  },
  {
    label: 'Ally.io',
    value: 3536,
  },
  {
    label: 'NetEnrich Technologies Pvt. Ltd.',
    value: 3537,
  },
  {
    label: 'Tamil Nadu e-Governance Agency',
    value: 3538,
  },
  {
    label: 'Primesoft',
    value: 3539,
  },
  {
    label: 'Majestic People Infosystems',
    value: 3540,
  },
  {
    label: 'SurePrep India',
    value: 3541,
  },
  {
    label: 'Kairosmagus Private Limited',
    value: 3542,
  },
  {
    label: 'Marmon Foodservice Technologies India Pvt. Ltd',
    value: 3543,
  },
  {
    label: 'Goodwin Systems LLC',
    value: 3544,
  },
  {
    label: 'Indriya Connect Pvt.Ltd',
    value: 3545,
  },
  {
    label: 'String Information Services Pvt Ltd',
    value: 3546,
  },
  {
    label: 'Stratemis HR Technologies',
    value: 3547,
  },
  {
    label: 'ManpowerGroup Services',
    value: 3548,
  },
  {
    label: 'Total IT Global',
    value: 3549,
  },
  {
    label: 'Construction Specialties(C-Group)',
    value: 3550,
  },
  {
    label: 'Agro Star',
    value: 3551,
  },
  {
    label: 'Rovoox',
    value: 3552,
  },
  {
    label: 'Shaw Academy',
    value: 3553,
  },
  {
    label: 'Perfios',
    value: 3554,
  },
  {
    label: 'SharkDreams',
    value: 3555,
  },
  {
    label: 'Starkflow',
    value: 3556,
  },
  {
    label: 'Tetrasoft India Pvt Ltd',
    value: 3557,
  },
  {
    label: 'TNG Innovation Labs',
    value: 3558,
  },
  {
    label: 'Anblick Solutions',
    value: 3559,
  },
  {
    label: 'Webmobril',
    value: 3560,
  },
  {
    label: 'wehireexecutive',
    value: 3561,
  },
  {
    label: 'ScoopWhoop Media Pvt. Ltd.',
    value: 3562,
  },
  {
    label: 'QA InfoTech',
    value: 3563,
  },
  {
    label: 'Softnautics LLP',
    value: 3564,
  },
  {
    label: 'Thorsignia',
    value: 3565,
  },
  {
    label: 'AuthorCafe',
    value: 3566,
  },
  {
    label: 'Cargo Flash Infotech Pvt. Ltd.',
    value: 3567,
  },
  {
    label: 'Vera',
    value: 3568,
  },
  {
    label: 'Aarna Tech Solutions',
    value: 3569,
  },
  {
    label: 'Netanalytiks Technologies',
    value: 3570,
  },
  {
    label: 'Translab',
    value: 3571,
  },
  {
    label: 'Shaw Academy',
    value: 3572,
  },
  {
    label: 'Eka Software Solutions',
    value: 3573,
  },
  {
    label: 'Square Panda',
    value: 3574,
  },
  {
    label: 'Evolute Systems Pvt Ltd',
    value: 3575,
  },
  {
    label: 'Dispatchtrack India Pvt Ltd',
    value: 3576,
  },
  {
    label: 'Red Apple Technologies',
    value: 3577,
  },
  {
    label: 'Singularium Technologies',
    value: 3578,
  },
  {
    label: 'ESAF Small Finance Bank',
    value: 3579,
  },
  {
    label: 'Smarten Spaces',
    value: 3580,
  },
  {
    label: 'Expodian Educational &Welfare Trust',
    value: 3581,
  },
  {
    label: 'Spider',
    value: 3582,
  },
  {
    label: 'Kottaram Agro Foods',
    value: 3583,
  },
  {
    label: 'Kaizen SRA Tech pvt ltd',
    value: 3584,
  },
  {
    label: 'Hakunamatata Solutions Pvt Ltd.',
    value: 3585,
  },
  {
    label: 'ByteDance Company',
    value: 3586,
  },
  {
    label: 'CMI',
    value: 3587,
  },
  {
    label: 'Monarch Capital',
    value: 3588,
  },
  {
    label: 'First Source Engineering India Pvt Ltd',
    value: 3589,
  },
  {
    label: 'Rachna Mehra',
    value: 3590,
  },
  {
    label: 'AIG',
    value: 3591,
  },
  {
    label: 'Ness Digital Engineering',
    value: 3592,
  },
  {
    label: 'Silicon Labs',
    value: 3593,
  },
  {
    label: 'Chemdiqas R & D INC .',
    value: 3594,
  },
  {
    label: 'Qalara (MesIndus Ventures)',
    value: 3595,
  },
  {
    label: 'Nanoprecise Sci Corp',
    value: 3596,
  },
  {
    label: 'SalaryBox',
    value: 3597,
  },
  {
    label: 'NeenOpal Intelligent Solution Pvt. Ltd.',
    value: 3598,
  },
  {
    label: 'SalaryBox',
    value: 3599,
  },
  {
    label: 'Idiosys Technologies',
    value: 3600,
  },
  {
    label: 'Techvaria Solutions Pvt Ltd',
    value: 3601,
  },
  {
    label: 'Ranium Systems Pvt Ltd',
    value: 3602,
  },
  {
    label: 'Bugle Technologies',
    value: 3603,
  },
  {
    label: 'Fintech',
    value: 3604,
  },
  {
    label: 'MindTickle',
    value: 3605,
  },
  {
    label: 'Futurism Technologies',
    value: 3606,
  },
  {
    label: 'WITS Interactive Pvt Ltd',
    value: 3607,
  },
  {
    label: 'XL Recruiters',
    value: 3608,
  },
  {
    label: 'Ruder Finn',
    value: 3609,
  },
  {
    label: 'Horizontal Talent',
    value: 3610,
  },
  {
    label: 'Ayodhya WeboSoft',
    value: 3611,
  },
  {
    label: 'IM',
    value: 3612,
  },
  {
    label: 'Risk Resources India',
    value: 3613,
  },
  {
    label: 'Viva Digital',
    value: 3614,
  },
  {
    label: 'Codilar Technologies Pvt. Ltd.',
    value: 3615,
  },
  {
    label: 'Gi Group (Elixir Consulting)',
    value: 3616,
  },
  {
    label: 'Novelworx Digital Solutions',
    value: 3617,
  },
  {
    label: 'Pantelwar',
    value: 3618,
  },
  {
    label: 'Mainspring Trajecta Global Inc, Singapore',
    value: 3619,
  },
  {
    label: 'Mindbody',
    value: 3620,
  },
  {
    label: 'Appinsight Technologies',
    value: 3621,
  },
  {
    label: 'Ruckus Advertising',
    value: 3622,
  },
  {
    label: 'Varutra Consulting Pvt. Ltd.',
    value: 3623,
  },
  {
    label: 'Zyeta',
    value: 3624,
  },
  {
    label: 'Prorigo Software Pvt Ltd',
    value: 3625,
  },
  {
    label: 'NGA HR',
    value: 3626,
  },
  {
    label: 'IISC',
    value: 3627,
  },
  {
    label: 'Flyhomes',
    value: 3628,
  },
  {
    label: 'City Innovates',
    value: 3629,
  },
  {
    label: 'Emblix Solutions',
    value: 3630,
  },
  {
    label: 'Pentabay Softwares Pvt Ltd',
    value: 3631,
  },
  {
    label: 'Caterpillar India P Ltd',
    value: 3632,
  },
  {
    label: 'HobSpace',
    value: 3633,
  },
  {
    label: 'BasePair',
    value: 3634,
  },
  {
    label: 'Press Fit Pipe and Profile',
    value: 3635,
  },
  {
    label: 'Airo Digital Labs',
    value: 3636,
  },
  {
    label: 'GenySoft',
    value: 3637,
  },
  {
    label: 'PocketAces ( Loco )',
    value: 3638,
  },
  {
    label: 'ATL FOUNDATION',
    value: 3639,
  },
  {
    label: 'higHRise Solutions',
    value: 3640,
  },
  {
    label: 'Cemetrix IT Services Pvt. Ltd.',
    value: 3641,
  },
  {
    label: 'PhiGRC',
    value: 3642,
  },
  {
    label: 'Origami Consulting',
    value: 3643,
  },
  {
    label: 'DrinkPrime',
    value: 3644,
  },
  {
    label: 'Cyzerg',
    value: 3645,
  },
  {
    label: 'Azent',
    value: 3646,
  },
  {
    label: 'iTech India Pvt Ltd',
    value: 3647,
  },
  {
    label: 'AerX Labs India Pvt Ltd',
    value: 3648,
  },
  {
    label: 'Sagarsoft',
    value: 3649,
  },
  {
    label: 'TATA AIG',
    value: 3650,
  },
  {
    label: 'ZenOnco.io',
    value: 3651,
  },
  {
    label: 'Astegic',
    value: 3652,
  },
  {
    label: 'Ingenium Education',
    value: 3653,
  },
  {
    label: 'IT Service',
    value: 3654,
  },
  {
    label: 'Brewhackers Technologies',
    value: 3655,
  },
  {
    label: 'OneData Software Solutions Pvt. Ltd',
    value: 3656,
  },
  {
    label: 'B-Mates Technologies Pvt Ltd',
    value: 3657,
  },
  {
    label: 'BUYEGAMES LLC',
    value: 3658,
  },
  {
    label: 'Codestore Technologies Pvt. Ltd.',
    value: 3659,
  },
  {
    label: 'ARI Networks',
    value: 3660,
  },
  {
    label: 'Dev Technosys Pvt. Ltd.',
    value: 3661,
  },
  {
    label: 'Atidan Technologies',
    value: 3662,
  },
  {
    label: 'Annalect',
    value: 3663,
  },
  {
    label: 'Tekion',
    value: 3664,
  },
  {
    label: 'Toppr',
    value: 3665,
  },
  {
    label: 'HealthCloudAI',
    value: 3666,
  },
  {
    label: 'Toyota Connected',
    value: 3667,
  },
  {
    label: 'Work Better Training Pvt Ltd',
    value: 3668,
  },
  {
    label: 'Ekennis Software Services Pvt Ltd',
    value: 3669,
  },
  {
    label: 'Moodys Analytics',
    value: 3670,
  },
  {
    label: 'From Day One Work',
    value: 3671,
  },
  {
    label: 'LotusPay',
    value: 3672,
  },
  {
    label: 'Sagarsoft',
    value: 3673,
  },
  {
    label: 'Uniphore',
    value: 3674,
  },
  {
    label: 'Acies',
    value: 3675,
  },
  {
    label: 'Tagloy Media Pvt Ltd',
    value: 3676,
  },
  {
    label: 'Talent Anywhere',
    value: 3677,
  },
  {
    label: 'RK Jewellers Ltd',
    value: 3678,
  },
  {
    label: 'KYC Hub',
    value: 3679,
  },
  {
    label: 'Solix Technologies',
    value: 3680,
  },
  {
    label: 'IDEMIA',
    value: 3681,
  },
  {
    label: 'Apptivo',
    value: 3682,
  },
  {
    label: 'Ecolab Digital Centre',
    value: 3683,
  },
  {
    label: 'ESKO',
    value: 3684,
  },
  {
    label: 'CivilCops',
    value: 3685,
  },
  {
    label: 'Softobiz Technologies',
    value: 3686,
  },
  {
    label: 'Yellow Buds',
    value: 3687,
  },
  {
    label: 'ZenOnco.io',
    value: 3688,
  },
  {
    label: 'Lafarge Holcim India',
    value: 3689,
  },
  {
    label: 'Perfios Software Solutions Pvt. Ltd',
    value: 3690,
  },
  {
    label: 'buzzboard.com',
    value: 3691,
  },
  {
    label: 'Squadcast',
    value: 3692,
  },
  {
    label: 'SPX Flow',
    value: 3693,
  },
  {
    label: 'Clari',
    value: 3694,
  },
  {
    label: 'Numen Health',
    value: 3695,
  },
  {
    label: 'Airboxr',
    value: 3696,
  },
  {
    label: 'Dvara Trust',
    value: 3697,
  },
  {
    label: 'Talent Anywhere',
    value: 3698,
  },
  {
    label: 'Ticket N Trips Pvt Ltd',
    value: 3699,
  },
  {
    label: 'AppExert Labs',
    value: 3700,
  },
  {
    label: 'Nighthack',
    value: 3701,
  },
  {
    label: 'Genrobotic Innovations',
    value: 3702,
  },
  {
    label: 'Tinkerly',
    value: 3703,
  },
  {
    label: 'Fyn Tune Solutions Pvt Ltd',
    value: 3704,
  },
  {
    label: 'Ockenden Investments Pte. Ltd.',
    value: 3705,
  },
  {
    label: 'eLogist Solutions',
    value: 3706,
  },
  {
    label: 'Magic Software Pvt. Ltd',
    value: 3707,
  },
  {
    label: 'Touchpoints Communication Pvt. Ltd',
    value: 3708,
  },
  {
    label: 'US Tech Solutions',
    value: 3709,
  },
  {
    label: 'Zaggle Prepaid Ocean Services Pvt. Ltd.',
    value: 3710,
  },
  {
    label: 'indifi Technologies',
    value: 3711,
  },
  {
    label: 'Origa',
    value: 3712,
  },
  {
    label: 'Kratin LLC',
    value: 3713,
  },
  {
    label: 'Outgrow.co',
    value: 3714,
  },
  {
    label: 'Circular Angle Private Limited',
    value: 3715,
  },
  {
    label: 'Cardinality',
    value: 3716,
  },
  {
    label: 'Koinly',
    value: 3717,
  },
  {
    label: 'TED Consulting',
    value: 3718,
  },
  {
    label: 'Veradis Technologies',
    value: 3719,
  },
  {
    label: 'DCirrus',
    value: 3720,
  },
  {
    label: 'Logicize Research',
    value: 3721,
  },
  {
    label: 'Permatech IT Services',
    value: 3722,
  },
  {
    label: 'Apptivo Software',
    value: 3723,
  },
  {
    label: 'Idea Elan',
    value: 3724,
  },
  {
    label: 'Richpanel',
    value: 3725,
  },
  {
    label: 'Bandhan Bank Limited',
    value: 3726,
  },
  {
    label: 'Redquest Technologies',
    value: 3727,
  },
  {
    label: 'IGMI Lead Consultancy Private Limited',
    value: 3728,
  },
  {
    label: 'Wood',
    value: 3729,
  },
  {
    label: 'NewGen IT',
    value: 3730,
  },
  {
    label: 'JK Technosoft',
    value: 3731,
  },
  {
    label: 'Project91 Advance Technologies Private Limited',
    value: 3732,
  },
  {
    label: 'Repos Energy India Pvt Ltd',
    value: 3733,
  },
  {
    label: 'SAIF Partner',
    value: 3734,
  },
  {
    label: 'Kaspon Techworks Pvt Ltd',
    value: 3735,
  },
  {
    label: 'Namaste credit',
    value: 3736,
  },
  {
    label: 'ClearTrail Technologies',
    value: 3737,
  },
  {
    label: 'AIML Data Analytics Solutions Pvt Ltd',
    value: 3738,
  },
  {
    label: 'Aavejak Ventures',
    value: 3739,
  },
  {
    label: 'Diverse Lynx',
    value: 3740,
  },
  {
    label: 'Mirra Healthcare',
    value: 3741,
  },
  {
    label: 'Workomo',
    value: 3742,
  },
  {
    label: 'Hexwhale Technologies Pvt Ltd',
    value: 3743,
  },
  {
    label: 'Kaivalya.me',
    value: 3744,
  },
  {
    label: 'Xoken Labs',
    value: 3745,
  },
  {
    label: 'Dynamsoft',
    value: 3746,
  },
  {
    label: 'EasyRent',
    value: 3747,
  },
  {
    label: 'DEW SOLUTIONS PVT LTD',
    value: 3748,
  },
  {
    label: 'Newpage',
    value: 3749,
  },
  {
    label: 'Syptus',
    value: 3750,
  },
  {
    label: 'Cine Talkies',
    value: 3751,
  },
  {
    label: 'Chalo',
    value: 3752,
  },
  {
    label: 'LKQ Corporation',
    value: 3753,
  },
  {
    label: 'LKQ Corporation',
    value: 3754,
  },
  {
    label: 'Vaco Binary',
    value: 3755,
  },
  {
    label: 'Vaco Binary',
    value: 3756,
  },
  {
    label: 'Scarlet Wireless India Pvt. Ltd.',
    value: 3757,
  },
  {
    label: 'PAW Learning Technologies',
    value: 3758,
  },
  {
    label: 'Deep Minds Business Solutions LLP',
    value: 3759,
  },
  {
    label: 'Cisive India Pvt. Ltd',
    value: 3760,
  },
  {
    label: 'Cashlink global systems pvt ltd',
    value: 3761,
  },
  {
    label: 'Diverselynx',
    value: 3762,
  },
  {
    label: 'The Fast Way',
    value: 3763,
  },
  {
    label: 'McDonalds (Hardcastle Restaurants)',
    value: 3764,
  },
  {
    label: 'Sachetan Knowledge Companions/Kompanions',
    value: 3765,
  },
  {
    label: 'Triad Square Infosec',
    value: 3766,
  },
  {
    label: 'Iserveu',
    value: 3767,
  },
  {
    label: 'Startup Labs Infotech Pvt. Ltd.',
    value: 3768,
  },
  {
    label: 'Varutra Consulting',
    value: 3769,
  },
  {
    label: 'Cosmofilms Ltd',
    value: 3770,
  },
  {
    label: 'Neal Analytics',
    value: 3771,
  },
  {
    label: 'Tecnotree',
    value: 3772,
  },
  {
    label: 'Digital Adverstising',
    value: 3773,
  },
  {
    label: 'Netskope',
    value: 3774,
  },
  {
    label: 'Rovoox Ltd.',
    value: 3775,
  },
  {
    label: 'ScootQ',
    value: 3776,
  },
  {
    label: 'Splurge Productions',
    value: 3777,
  },
  {
    label: 'Pocket FM',
    value: 3778,
  },
  {
    label: 'Studio Netinx Technologies Pvt. Ltd',
    value: 3779,
  },
  {
    label: 'Safaltek Software Pvt. Ltd.',
    value: 3780,
  },
  {
    label: 'PayDeck Technologies Pvt Ltd',
    value: 3781,
  },
  {
    label: 'Diverse Lynx',
    value: 3782,
  },
  {
    label: 'Diverse Lynx India Pvt. Ltd.',
    value: 3783,
  },
  {
    label: 'Global Intelli',
    value: 3784,
  },
  {
    label: 'Avalance Global Solutions',
    value: 3785,
  },
  {
    label: 'Initiate First Information Services',
    value: 3786,
  },
  {
    label: 'PocketPills',
    value: 3787,
  },
  {
    label: 'incRevenue',
    value: 3788,
  },
  {
    label: 'Intelizest Technologies Pvt Ltd',
    value: 3789,
  },
  {
    label: 'Airlearn.ai',
    value: 3790,
  },
  {
    label: 'Workomo',
    value: 3791,
  },
  {
    label: 'Melorra',
    value: 3792,
  },
  {
    label: 'EisnerAmper LLP',
    value: 3793,
  },
  {
    label: 'Caritor Solutions',
    value: 3794,
  },
  {
    label: 'Techs To Suit Inc.',
    value: 3795,
  },
  {
    label: 'Red Event Services',
    value: 3796,
  },
  {
    label: 'Fyn Squad',
    value: 3797,
  },
  {
    label: 'Global Intelli',
    value: 3798,
  },
  {
    label: 'CoffeeBeans.io',
    value: 3799,
  },
  {
    label: 'PAL Software',
    value: 3800,
  },
  {
    label: 'Triad Square Pvt Ltd.,',
    value: 3801,
  },
  {
    label: 'Marks & Spencer Reliance India Pvt Ltd.',
    value: 3802,
  },
  {
    label: 'Hettich India Private Limited',
    value: 3803,
  },
  {
    label: 'Brace Infotech',
    value: 3804,
  },
  {
    label: 'Infoscalze',
    value: 3805,
  },
  {
    label: 'Genrobotic Innovations Pvt. Ltd.',
    value: 3806,
  },
  {
    label: 'Smart Owls',
    value: 3807,
  },
  {
    label: 'Arient Solutions',
    value: 3808,
  },
  {
    label: 'Elevate Services Pvt. Ltd.',
    value: 3809,
  },
  {
    label: 'Star Knowledge Technology Alliance LLC',
    value: 3810,
  },
  {
    label: 'Dew Solutions',
    value: 3811,
  },
  {
    label: 'Screen Magic Mobile Media Pvt Ltd',
    value: 3812,
  },
  {
    label: 'NetEnt',
    value: 3813,
  },
  {
    label: 'Bionworks Technologies',
    value: 3814,
  },
  {
    label: 'Carawin Pvt. Ltd.',
    value: 3815,
  },
  {
    label: 'CovidIndia',
    value: 3816,
  },
  {
    label: 'SLO Technologies (P) Ltd',
    value: 3817,
  },
  {
    label: 'SmartDEN',
    value: 3818,
  },
  {
    label: 'Protiviti',
    value: 3819,
  },
  {
    label: 'Vooth Technologies',
    value: 3820,
  },
  {
    label: 'PepperContent',
    value: 3821,
  },
  {
    label: 'XTEN-AV',
    value: 3822,
  },
  {
    label: 'Stellar Information Technology Pvt Ltd',
    value: 3823,
  },
  {
    label: 'CentryLink Technologies',
    value: 3824,
  },
  {
    label: 'TURING ACADEMY PRIVATE LIMITED',
    value: 3825,
  },
  {
    label: 'Nextgen Invent Corporation',
    value: 3826,
  },
  {
    label: 'RAMS Creative Technologies Pvt Ltd',
    value: 3827,
  },
  {
    label: 'Lera',
    value: 3828,
  },
  {
    label: 'IDFC First Bank Ltd',
    value: 3829,
  },
  {
    label: 'Affordplan',
    value: 3830,
  },
  {
    label: 'DVG Tech Solutions',
    value: 3831,
  },
  {
    label: 'Ketto Online Venture pvt ltd',
    value: 3832,
  },
  {
    label: 'MindTickle',
    value: 3833,
  },
  {
    label: 'Basidia Learning Pvt Ltd.',
    value: 3834,
  },
  {
    label: 'Vam Infosys Pvt. Ltd.',
    value: 3835,
  },
  {
    label: 'SiCureMi Healthcare Technologies Pvt Ltd.',
    value: 3836,
  },
  {
    label: 'SNAK India Consultancy Services',
    value: 3837,
  },
  {
    label: 'Qualitas Global Services LLP',
    value: 3838,
  },
  {
    label: 'VeCrear Technologies',
    value: 3839,
  },
  {
    label: 'Cyware Labs',
    value: 3840,
  },
  {
    label: 'Utthunga Technologies',
    value: 3841,
  },
  {
    label: 'NewGen IT',
    value: 3842,
  },
  {
    label: 'Pinnacle Digital',
    value: 3843,
  },
  {
    label: 'Clover Ventures Pvt Ltd',
    value: 3844,
  },
  {
    label: 'QuillBot Inc.',
    value: 3845,
  },
  {
    label: 'Cummins India',
    value: 3846,
  },
  {
    label: 'Meru Mobility Tech Pvt Ltd',
    value: 3847,
  },
  {
    label: 'Rapyuta Robotics',
    value: 3848,
  },
  {
    label: 'Parantapa Sciences Pvt. Ltd.',
    value: 3849,
  },
  {
    label: 'Meru Mobility Tech Pvt Ltd',
    value: 3850,
  },
  {
    label: 'Mylo Family',
    value: 3851,
  },
  {
    label: 'Hashchain',
    value: 3852,
  },
  {
    label: 'MX Player',
    value: 3853,
  },
  {
    label: 'Think Real Technologies',
    value: 3854,
  },
  {
    label: 'GO MO Group Digital Business Solutions',
    value: 3855,
  },
  {
    label: 'Big Little Innovations (BLI)',
    value: 3856,
  },
  {
    label: 'Verzeo',
    value: 3857,
  },
  {
    label: "Gold's Gym",
    value: 3858,
  },
  {
    label: 'Uniphore',
    value: 3859,
  },
  {
    label: 'CoStrategix',
    value: 3860,
  },
  {
    label: 'Nspira Management Services (P) Ltd',
    value: 3861,
  },
  {
    label: 'C-Square Info solutions Pvt Ltd',
    value: 3862,
  },
  {
    label: 'Vadera & Co',
    value: 3863,
  },
  {
    label: 'Nykaa Fashion',
    value: 3864,
  },
  {
    label: 'Automation Laboratories',
    value: 3865,
  },
  {
    label: 'Riversys',
    value: 3866,
  },
  {
    label: 'Gaian Solutions',
    value: 3867,
  },
  {
    label: 'Yogin',
    value: 3868,
  },
  {
    label: 'Truminds',
    value: 3869,
  },
  {
    label: 'GSE Red',
    value: 3870,
  },
  {
    label: 'Synapse Solution',
    value: 3871,
  },
  {
    label: 'SpryBit',
    value: 3872,
  },
  {
    label: 'Kaira SPM &Automation  Pvt. Ltd',
    value: 3873,
  },
  {
    label: 'MetaMorphoSys Technologies Pvt. Ltd',
    value: 3874,
  },
  {
    label: 'Canara HSBC OBC Life Insurance',
    value: 3875,
  },
  {
    label: 'FitPage',
    value: 3876,
  },
  {
    label: 'Citustech',
    value: 3877,
  },
  {
    label: 'Klozet',
    value: 3878,
  },
  {
    label: 'Refreshmint',
    value: 3879,
  },
  {
    label: 'TIARA',
    value: 3880,
  },
  {
    label: 'SCA Technology',
    value: 3881,
  },
  {
    label: 'Raidenbit',
    value: 3882,
  },
  {
    label: 'Fintech Startup',
    value: 3883,
  },
  {
    label: 'ShopSe',
    value: 3884,
  },
  {
    label: 'Pursuit Software',
    value: 3885,
  },
  {
    label: 'Kyzer Software India Pvt. Ltd',
    value: 3886,
  },
  {
    label: 'Uniphore Software Systems',
    value: 3887,
  },
  {
    label: 'miBiome Therapeutics',
    value: 3888,
  },
  {
    label: 'Algebra Technologies Pvt Ltd',
    value: 3889,
  },
  {
    label: 'Hireportals HR Consulting',
    value: 3890,
  },
  {
    label: 'Photon Interactive',
    value: 3891,
  },
  {
    label: 'Aditi Staffing India Pvt Ltd',
    value: 3892,
  },
  {
    label: 'Winfort',
    value: 3893,
  },
  {
    label: 'C-Square Info Solutions',
    value: 3894,
  },
  {
    label: 'Utthunga Technologies Pvt Ltd',
    value: 3895,
  },
  {
    label: 'Margo Networks Private Limited',
    value: 3896,
  },
  {
    label: 'LandmarkIT',
    value: 3897,
  },
  {
    label: 'Vedantu',
    value: 3898,
  },
  {
    label: 'Dappros Pvt Ltd',
    value: 3899,
  },
  {
    label: 'Resemble Systems India Pvt Ltd',
    value: 3900,
  },
  {
    label: 'Maropost',
    value: 3901,
  },
  {
    label: 'Sipfund.com',
    value: 3902,
  },
  {
    label: 'Crownstack',
    value: 3903,
  },
  {
    label: 'Workonomix',
    value: 3904,
  },
  {
    label: 'Prognosys Marcom Services Private Limited',
    value: 3905,
  },
  {
    label: 'Cornertree Consulting',
    value: 3906,
  },
  {
    label: 'Ads & URL',
    value: 3907,
  },
  {
    label: 'wibmo',
    value: 3908,
  },
  {
    label: 'Tedroox Technologies Pvt.ltd',
    value: 3909,
  },
  {
    label: 'SpectraMedix',
    value: 3910,
  },
  {
    label: 'Rajasthan Studio (Slo Mo Experiences Private Limited)',
    value: 3911,
  },
  {
    label: 'CarrefourUAE - Majid Al futtaim Hypermarkets',
    value: 3912,
  },
  {
    label: 'Plixto',
    value: 3913,
  },
  {
    label: 'Embibe',
    value: 3914,
  },
  {
    label: 'Samporna People Network',
    value: 3915,
  },
  {
    label: 'Interview Mocha',
    value: 3916,
  },
  {
    label: 'Emxcel Solutions Private Limited',
    value: 3917,
  },
  {
    label: 'Ezeiatech Systems Pvt Ltd',
    value: 3918,
  },
  {
    label: 'Elpis IT',
    value: 3919,
  },
  {
    label: 'Biotenico R & D Inc.',
    value: 3920,
  },
  {
    label: 'Prospecta Soft Pvt Ltd',
    value: 3921,
  },
  {
    label: 'Goods and Services Tax Network',
    value: 3922,
  },
  {
    label: 'Taliun',
    value: 3923,
  },
  {
    label: 'Skillo',
    value: 3924,
  },
  {
    label: 'Greyamp',
    value: 3925,
  },
  {
    label: 'Aegonlife',
    value: 3926,
  },
  {
    label: 'SpectraMedix India Pvt. Ltd.',
    value: 3927,
  },
  {
    label: 'T',
    value: 3928,
  },
  {
    label: 'EyDream Pvt. Ltd.',
    value: 3929,
  },
  {
    label: 'Gathi Analytics',
    value: 3930,
  },
  {
    label: 'Pegasus Info Corp',
    value: 3931,
  },
  {
    label: 'Intelizest Consulting Pvt Ltd',
    value: 3932,
  },
  {
    label: 'Magic Software',
    value: 3933,
  },
  {
    label: 'Engagedly',
    value: 3934,
  },
  {
    label: 'Carmatec IT Solutions Pvt Ltd',
    value: 3935,
  },
  {
    label: 'Amtex Systems',
    value: 3936,
  },
  {
    label: 'InnoEye Technologies',
    value: 3937,
  },
  {
    label: 'IINL',
    value: 3938,
  },
  {
    label: 'Agile One Consulting',
    value: 3939,
  },
  {
    label: 'iLabs Capital',
    value: 3940,
  },
  {
    label: 'Bank Bazaar',
    value: 3941,
  },
  {
    label: 'ICHAPPS Private Limited',
    value: 3942,
  },
  {
    label: 'iLabs Group',
    value: 3943,
  },
  {
    label: 'Netlabs Global',
    value: 3944,
  },
  {
    label: 'Klaus IT Solutions Pvt Ltd',
    value: 3945,
  },
  {
    label: 'AQM Technologies Pvt Ltd',
    value: 3946,
  },
  {
    label: 'Atom',
    value: 3947,
  },
  {
    label: 'Interactive Brokers',
    value: 3948,
  },
  {
    label: 'MoreYeahs Inc',
    value: 3949,
  },
  {
    label: 'Blackmilk Media Pvt. Ltd.',
    value: 3950,
  },
  {
    label: 'Breaktalks Innovation Pvt Ltd',
    value: 3951,
  },
  {
    label: 'F5',
    value: 3952,
  },
  {
    label: 'Delta Corp',
    value: 3953,
  },
  {
    label: 'Excitel Broadband Pvt;. Ltd.',
    value: 3954,
  },
  {
    label: 'Meritnation',
    value: 3955,
  },
  {
    label: 'UniversityAssingment',
    value: 3956,
  },
  {
    label: 'Wasserstoff Private Limited',
    value: 3957,
  },
  {
    label: 'Excitel Broadband',
    value: 3958,
  },
  {
    label: 'Campus Management International',
    value: 3959,
  },
  {
    label: 'Sevitech systems India Pvt Ltd',
    value: 3960,
  },
  {
    label: 'Managed Connect IT Services Pvt Ltd',
    value: 3961,
  },
  {
    label: 'Kimberly Clark',
    value: 3962,
  },
  {
    label: 'insightGURU',
    value: 3963,
  },
  {
    label: 'People Resources',
    value: 3964,
  },
  {
    label: 'WeDig Techsolutions Pvt. Ltd',
    value: 3965,
  },
  {
    label: 'Mount Wilder',
    value: 3966,
  },
  {
    label: 'Kofluence',
    value: 3967,
  },
  {
    label: 'Softuvo Solutions Pvt. Ltd',
    value: 3968,
  },
  {
    label: 'Tripta Innovations Pvt. Ltd.',
    value: 3969,
  },
  {
    label: 'FoxyMoron',
    value: 3970,
  },
  {
    label: 'SP Staffing Services',
    value: 3971,
  },
  {
    label: 'Tetrasoft India Pvt. Ltd.',
    value: 3972,
  },
  {
    label: 'HireStaar.com',
    value: 3973,
  },
  {
    label: 'Geeky Bee AI Pvt. Ltd.',
    value: 3974,
  },
  {
    label: 'goDutch',
    value: 3975,
  },
  {
    label: 'Grownmind Educational Services Pvt Ltd',
    value: 3976,
  },
  {
    label: 'Strategic Resources',
    value: 3977,
  },
  {
    label: 'Tetrasoft Inc',
    value: 3978,
  },
  {
    label: 'Tetrasoft',
    value: 3979,
  },
  {
    label: 'Black and White Business Solutions Pvt ltd',
    value: 3980,
  },
  {
    label: 'Appitsimple Infotek',
    value: 3981,
  },
  {
    label: 'GGK Tech',
    value: 3982,
  },
  {
    label: 'Kayr Technologies Pvt Ltd',
    value: 3983,
  },
  {
    label: 'Brand Moustache',
    value: 3984,
  },
  {
    label: 'Market Cube',
    value: 3985,
  },
  {
    label: 'Obbserv',
    value: 3986,
  },
  {
    label: 'PayJoy India',
    value: 3987,
  },
  {
    label: 'Olyk',
    value: 3988,
  },
  {
    label: 'Sophos',
    value: 3989,
  },
  {
    label: 'Hogarth Worldwide',
    value: 3990,
  },
  {
    label: 'Acuver Consulting Pvt Ltd',
    value: 3991,
  },
  {
    label: 'Selec Controls Pvt Ltd',
    value: 3992,
  },
  {
    label: 'Cinta Medtech Pvt Ltd',
    value: 3993,
  },
  {
    label: 'Artha Energy Resources',
    value: 3994,
  },
  {
    label: 'Wobot Intelligence Pvt. Ltd.',
    value: 3995,
  },
  {
    label: 'Cogent Integrated Business Solutions pvt. Ltd',
    value: 3996,
  },
  {
    label: 'Medi Assist',
    value: 3997,
  },
  {
    label: 'Bettr',
    value: 3998,
  },
  {
    label: 'WeDig Techsolutions Pvt.Ltd.',
    value: 3999,
  },
  {
    label: 'Kiwi Miles limited',
    value: 4000,
  },
  {
    label: 'Partity Cube Pvt Ltd',
    value: 4001,
  },
  {
    label: 'Dream11',
    value: 4002,
  },
  {
    label: 'Sifars',
    value: 4003,
  },
  {
    label: 'Verificient Technologies,Pune',
    value: 4004,
  },
  {
    label: '10xbiz',
    value: 4005,
  },
  {
    label: 'Inyt Technologies Pvt. Ltd.',
    value: 4006,
  },
  {
    label: 'Hotfoot Technology Solutions',
    value: 4007,
  },
  {
    label: 'Vertafore',
    value: 4008,
  },
  {
    label: 'Luxoft',
    value: 4009,
  },
  {
    label: 'RESure',
    value: 4010,
  },
  {
    label: 'IoT Research Labs',
    value: 4011,
  },
  {
    label: 'Jubna',
    value: 4012,
  },
  {
    label: 'HyperTest',
    value: 4013,
  },
  {
    label: 'Sage Innovation Services Private Ltd',
    value: 4014,
  },
  {
    label: 'iPredict.io',
    value: 4015,
  },
  {
    label: 'Zipgrid',
    value: 4016,
  },
  {
    label: 'BookMane Labs',
    value: 4017,
  },
  {
    label: 'Transport Simple',
    value: 4018,
  },
  {
    label: 'Wealth42',
    value: 4019,
  },
  {
    label: 'Sonet MicroSystems',
    value: 4020,
  },
  {
    label: 'Avataar.me',
    value: 4021,
  },
  {
    label: 'Sulekha',
    value: 4022,
  },
  {
    label: 'Gempundit.com',
    value: 4023,
  },
  {
    label: 'Gyanmatrix',
    value: 4024,
  },
  {
    label: 'iPRIMED Education Solutions Pvt Ltd',
    value: 4025,
  },
  {
    label: 'Whizzystack Solutions',
    value: 4026,
  },
  {
    label: 'Venera Technologies',
    value: 4027,
  },
  {
    label: 'Tuple Technologies',
    value: 4028,
  },
  {
    label: 'Uncap Research Labs',
    value: 4029,
  },
  {
    label: 'Acyut Consulting',
    value: 4030,
  },
  {
    label: 'Avenues Payments India Pvt Ltd',
    value: 4031,
  },
  {
    label: 'RCK Techiees',
    value: 4032,
  },
  {
    label: 'Acuity Knowledge Partners',
    value: 4033,
  },
  {
    label: 'Netway India Pvt. Ltd.',
    value: 4034,
  },
  {
    label: 'Zentechinfo Solution',
    value: 4035,
  },
  {
    label: 'Xpetize Technology Solution',
    value: 4036,
  },
  {
    label: 'Croton',
    value: 4037,
  },
  {
    label: 'App Incubator Inc',
    value: 4038,
  },
  {
    label: 'CustomerXps',
    value: 4039,
  },
  {
    label: 'Focus Consult Ltd. Company',
    value: 4040,
  },
  {
    label: 'Shop101',
    value: 4041,
  },
  {
    label: 'Sulekha',
    value: 4042,
  },
  {
    label: 'Finwego',
    value: 4043,
  },
  {
    label: 'Trademo',
    value: 4044,
  },
  {
    label: 'ABNO Softwares International Pvt. Ltd',
    value: 4045,
  },
  {
    label: 'Qubit AI',
    value: 4046,
  },
  {
    label: 'Kidstella',
    value: 4047,
  },
  {
    label: 'Solytics partners',
    value: 4048,
  },
  {
    label: 'Bonanza Group',
    value: 4049,
  },
  {
    label: 'Falconnect Technologies Pvt Ltd',
    value: 4050,
  },
  {
    label: 'Mindcraft Technologies pvt ltd',
    value: 4051,
  },
  {
    label: 'Bitblue Technology',
    value: 4052,
  },
  {
    label: 'Resource Corner',
    value: 4053,
  },
  {
    label: 'DataWeave',
    value: 4054,
  },
  {
    label: 'Mounty',
    value: 4055,
  },
  {
    label: 'Netism Soft Private Limited',
    value: 4056,
  },
  {
    label: 'Excelra Knowledge Solutions',
    value: 4057,
  },
  {
    label: 'Carmatec IT Solutions Pvt Ltd',
    value: 4058,
  },
  {
    label: 'Infoxen Technologies',
    value: 4059,
  },
  {
    label: 'Impulsive Web Pvt. Ltd.',
    value: 4060,
  },
  {
    label: 'Jazeera Technologies.Pvt.Ltd',
    value: 4061,
  },
  {
    label: 'Mainstream Technologies',
    value: 4062,
  },
  {
    label: 'Gradeup',
    value: 4063,
  },
  {
    label: 'DiGiSPICE',
    value: 4064,
  },
  {
    label: 'Loumus Data services',
    value: 4065,
  },
  {
    label: 'Osmosys Software Solutions',
    value: 4066,
  },
  {
    label: 'NeoKred',
    value: 4067,
  },
  {
    label: 'vSplash',
    value: 4068,
  },
  {
    label: 'Fashion TV',
    value: 4069,
  },
  {
    label: 'TaskUs',
    value: 4070,
  },
  {
    label: 'Startup CA',
    value: 4071,
  },
  {
    label: 'Arista Networks',
    value: 4072,
  },
  {
    label: 'Paytm Payments Bank',
    value: 4073,
  },
  {
    label: 'DOWC',
    value: 4074,
  },
  {
    label: 'TCNS Clothing Co. Ltd.',
    value: 4075,
  },
  {
    label: 'Core Techies India Pvt. Ltd.',
    value: 4076,
  },
  {
    label: 'Alterest India Pvt.Ltd',
    value: 4077,
  },
  {
    label: 'Aeries Technology Group',
    value: 4078,
  },
  {
    label: 'OpsRamp',
    value: 4079,
  },
  {
    label: 'Mount Wilder',
    value: 4080,
  },
  {
    label: 'Net2source Consulting LLC',
    value: 4081,
  },
  {
    label: 'Ticketmaster',
    value: 4082,
  },
  {
    label: 'Growth Falcons',
    value: 4083,
  },
  {
    label: 'Business intelli',
    value: 4084,
  },
  {
    label: 'Aptus',
    value: 4085,
  },
  {
    label: 'Raplev',
    value: 4086,
  },
  {
    label: 'iXoop Technologies Pvt Ltd',
    value: 4087,
  },
  {
    label: 'Gatitaa Technology',
    value: 4088,
  },
  {
    label: 'Iffort',
    value: 4089,
  },
  {
    label: 'Solcen Technologies Pvt. Ltd',
    value: 4090,
  },
  {
    label: 'Pankhuri',
    value: 4091,
  },
  {
    label: 'NoBroker',
    value: 4092,
  },
  {
    label: 'TwoDotSeven',
    value: 4093,
  },
  {
    label: 'Wisetr Technology Pvt Ltd',
    value: 4094,
  },
  {
    label: 'Metadesign Solutions',
    value: 4095,
  },
  {
    label: 'Money Guru',
    value: 4096,
  },
  {
    label: 'Lastbyte Solutions Pvt. Ltd.',
    value: 4097,
  },
  {
    label: 'Carmatec It solution',
    value: 4098,
  },
  {
    label: 'Xangars Solutions',
    value: 4099,
  },
  {
    label: 'ByteDance',
    value: 4100,
  },
  {
    label: 'Mahindra First Choice Wheels Ltd',
    value: 4101,
  },
  {
    label: 'Freshworks',
    value: 4102,
  },
  {
    label: 'Radix Health',
    value: 4103,
  },
  {
    label: 'StackNexus Technologies India Pvt. Ltd.',
    value: 4104,
  },
  {
    label: 'CASHe',
    value: 4105,
  },
  {
    label: 'AssessHub',
    value: 4106,
  },
  {
    label: 'QSS Technosoft Pvt. Ltd.',
    value: 4107,
  },
  {
    label: 'KR Consultant',
    value: 4108,
  },
  {
    label: 'AQM Technologies',
    value: 4109,
  },
  {
    label: 'Kliff Technologies',
    value: 4110,
  },
  {
    label: 'Whizzystack Solutions',
    value: 4111,
  },
  {
    label: 'Whizzystack Solutions',
    value: 4112,
  },
  {
    label: 'Kidens',
    value: 4113,
  },
  {
    label: 'Aviabird',
    value: 4114,
  },
  {
    label: 'MFD Healthcare',
    value: 4115,
  },
  {
    label: 'ZoomRx',
    value: 4116,
  },
  {
    label: 'IHB Technology',
    value: 4117,
  },
  {
    label: 'MaxInfo.Tech',
    value: 4118,
  },
  {
    label: 'IT software',
    value: 4119,
  },
  {
    label: 'ABBIE IT MART PVT. LTD.',
    value: 4120,
  },
  {
    label: 'Epsilon',
    value: 4121,
  },
  {
    label: 'Bada Business Pvt. Ltd',
    value: 4122,
  },
  {
    label: 'Adomita',
    value: 4123,
  },
  {
    label: 'AlphaGrep Pte Ltd',
    value: 4124,
  },
  {
    label: 'Pioneer E Solutions',
    value: 4125,
  },
  {
    label: '40K Plus Education Pvt Ltd',
    value: 4126,
  },
  {
    label: 'Livo.ai',
    value: 4127,
  },
  {
    label: 'Kingfish Group',
    value: 4128,
  },
  {
    label: 'Hakuna Matata Solutions Pvt ltd',
    value: 4129,
  },
  {
    label: 'V3Staffing',
    value: 4130,
  },
  {
    label: 'Plutus Research Private Limited',
    value: 4131,
  },
  {
    label: 'Ketsaal Retail LLP-Noida',
    value: 4132,
  },
  {
    label: 'Techsophy',
    value: 4133,
  },
  {
    label: 'T&VS',
    value: 4134,
  },
  {
    label: 'Coral Knowledge Services',
    value: 4135,
  },
  {
    label: 'Prevalent.ai',
    value: 4136,
  },
  {
    label: 'India Formation',
    value: 4137,
  },
  {
    label: 'Hirex.ai Pvt Ltd',
    value: 4138,
  },
  {
    label: 'Cue Three',
    value: 4139,
  },
  {
    label: 'Netaxis IT Solution',
    value: 4140,
  },
  {
    label: 'VVDN Technologies Pvt Ltd',
    value: 4141,
  },
  {
    label: 'Smart Connect Technologies',
    value: 4142,
  },
  {
    label: 'Adreno Technologies',
    value: 4143,
  },
  {
    label: 'Rams Creative Technologies Pvt. Ltd.',
    value: 4144,
  },
  {
    label: 'Factspan',
    value: 4145,
  },
  {
    label: 'Tao Automation',
    value: 4146,
  },
  {
    label: 'GBIM Technologies Pvt Ltd',
    value: 4147,
  },
  {
    label: 'Invensis Technologies',
    value: 4148,
  },
  {
    label: 'SleepyCat',
    value: 4149,
  },
  {
    label: 'Inventive Global Solutions',
    value: 4150,
  },
  {
    label: 'MoreYeahs IT Technologies',
    value: 4151,
  },
  {
    label: 'Royal Technocrats Inc',
    value: 4152,
  },
  {
    label: 'Cormorant Engineering India Private Limited',
    value: 4153,
  },
  {
    label: 'DeBox Global IT Solution Pvt. Ltd',
    value: 4154,
  },
  {
    label: 'Inventive Global Solutions',
    value: 4155,
  },
  {
    label: 'Wibmo',
    value: 4156,
  },
  {
    label: 'Sarga',
    value: 4157,
  },
  {
    label: 'Tide',
    value: 4158,
  },
  {
    label: 'Lido Learning',
    value: 4159,
  },
  {
    label: 'Arya.ai',
    value: 4160,
  },
  {
    label: 'Fintech Company',
    value: 4161,
  },
  {
    label: 'Glocalsense Business Solutions LLP',
    value: 4162,
  },
  {
    label: 'Hurain Infotech LLP',
    value: 4163,
  },
  {
    label: 'Zuci Systems',
    value: 4164,
  },
  {
    label: 'MicroWorld Software Services Pvt. Ltd.',
    value: 4165,
  },
  {
    label: 'OpsMx',
    value: 4166,
  },
  {
    label: 'J-PAL South Aisa',
    value: 4167,
  },
  {
    label: 'Kadbits',
    value: 4168,
  },
  {
    label: 'ThinkJS',
    value: 4169,
  },
  {
    label: 'TAO Automation',
    value: 4170,
  },
  {
    label: 'www.krawlnet.com',
    value: 4171,
  },
  {
    label: 'Xangars Solutions',
    value: 4172,
  },
  {
    label: 'Tenovia',
    value: 4173,
  },
  {
    label: 'NuPhi',
    value: 4174,
  },
  {
    label: 'Loadshare Network',
    value: 4175,
  },
  {
    label: 'EIDK',
    value: 4176,
  },
  {
    label: 'Oorwin Labs India Pvt Ltd',
    value: 4177,
  },
  {
    label: 'Pixelo Digital',
    value: 4178,
  },
  {
    label: 'Acrux IT Services Private Limited',
    value: 4179,
  },
  {
    label: 'HyTechPro',
    value: 4180,
  },
  {
    label: 'Goalteller',
    value: 4181,
  },
  {
    label: 'Prokarma',
    value: 4182,
  },
  {
    label: 'Care Labs',
    value: 4183,
  },
  {
    label: 'High Peak Software',
    value: 4184,
  },
  {
    label: 'VSplash Techlabs Pvt Ltd',
    value: 4185,
  },
  {
    label: 'Orbis Protect',
    value: 4186,
  },
  {
    label: 'EXL',
    value: 4187,
  },
  {
    label: 'Vumonic Datalabs',
    value: 4188,
  },
  {
    label: '360 degree cloud technologies',
    value: 4189,
  },
  {
    label: 'Splenta Systems Pvt Ltd.',
    value: 4190,
  },
  {
    label: 'ADI backoffice',
    value: 4191,
  },
  {
    label: 'NoBroker',
    value: 4192,
  },
  {
    label: 'RDFlex',
    value: 4193,
  },
  {
    label: 'Tata AIG General Insurance Company Limited',
    value: 4194,
  },
  {
    label: 'Pemimpin Technologies Pvt Ltd',
    value: 4195,
  },
  {
    label: 'TomTom',
    value: 4196,
  },
  {
    label: 'Zebu Animation',
    value: 4197,
  },
  {
    label: 'VSPLASH TECH LABS PVT.LTD',
    value: 4198,
  },
  {
    label: 'Precise Testing Solution Pvt Ltd.',
    value: 4199,
  },
  {
    label: 'Issquared India',
    value: 4200,
  },
  {
    label: 'Automatic Infotech',
    value: 4201,
  },
  {
    label: 'QA Mentor Testing Services Pvt ltd',
    value: 4202,
  },
  {
    label: 'Starline Solutions Pvt Ltd',
    value: 4203,
  },
  {
    label: 'Apar Peopleworld Software',
    value: 4204,
  },
  {
    label: 'Indecomm Digital Services',
    value: 4205,
  },
  {
    label: 'Quovantis Technologies',
    value: 4206,
  },
  {
    label: 'Lidolearning.com',
    value: 4207,
  },
  {
    label: 'Platon Services Pvt. Ltd.',
    value: 4208,
  },
  {
    label: 'SimplePlan Media',
    value: 4209,
  },
  {
    label: 'Technumen INC',
    value: 4210,
  },
  {
    label: 'Technumen Inc',
    value: 4211,
  },
  {
    label: 'Rovi91 Innovation Pvt. Ltd.',
    value: 4212,
  },
  {
    label: 'LambdaTest',
    value: 4213,
  },
  {
    label: 'XLNC Technologies',
    value: 4214,
  },
  {
    label: 'Velankani Software Pvt. Ltd',
    value: 4215,
  },
  {
    label: 'Umz Technologies',
    value: 4216,
  },
  {
    label: 'Blenheim Chalcot',
    value: 4217,
  },
  {
    label: 'Moengage',
    value: 4218,
  },
  {
    label: 'Moolya',
    value: 4219,
  },
  {
    label: 'TaskUs',
    value: 4220,
  },
  {
    label: 'Williams Lea Tag',
    value: 4221,
  },
  {
    label: 'Blenheim Chalcot',
    value: 4222,
  },
  {
    label: 'Gstar Info E-solutions Pvt. Ltd.',
    value: 4223,
  },
  {
    label: 'TaskUs India Private Limited',
    value: 4224,
  },
  {
    label: 'WEN',
    value: 4225,
  },
  {
    label: 'Park+',
    value: 4226,
  },
  {
    label: 'Studio Netinx',
    value: 4227,
  },
  {
    label: 'TaskUs',
    value: 4228,
  },
  {
    label: 'Mantra Technologies Private Limited',
    value: 4229,
  },
  {
    label: 'Vaya Group',
    value: 4230,
  },
  {
    label: 'People-Prime World Wide PVT LTD',
    value: 4231,
  },
  {
    label: 'Inventive Global solutions',
    value: 4232,
  },
  {
    label: 'YFret Inc',
    value: 4233,
  },
  {
    label: 'Myraa Technologies',
    value: 4234,
  },
  {
    label: 'Adrixus',
    value: 4235,
  },
  {
    label: 'The Learners Camp',
    value: 4236,
  },
  {
    label: 'Hansa Cequity',
    value: 4237,
  },
  {
    label: 'Blu Smart Mobility Private Limited',
    value: 4238,
  },
  {
    label: 'NSEIT',
    value: 4239,
  },
  {
    label: '18th Digitech Pvt ltd',
    value: 4240,
  },
  {
    label: 'T&VS',
    value: 4241,
  },
  {
    label: 'Listen2It',
    value: 4242,
  },
  {
    label: 'Eli Lilly',
    value: 4243,
  },
  {
    label: 'SolCen Technologies Pvt.  Ltd.',
    value: 4244,
  },
  {
    label: 'Blurbpoint Media Pvt Ltd',
    value: 4245,
  },
  {
    label: 'Jodo',
    value: 4246,
  },
  {
    label: 'VTS Technology Private Limited',
    value: 4247,
  },
  {
    label: 'IT Company',
    value: 4248,
  },
  {
    label: 'SIB Infotech',
    value: 4249,
  },
  {
    label: 'ZYLA Healthcare Pvt. Ltd.',
    value: 4250,
  },
  {
    label: 'SysArc Infomatix Pvt Ltd',
    value: 4251,
  },
  {
    label: 'Vipany Management Consulting India Pvt Ltd',
    value: 4252,
  },
  {
    label: 'NicheTech Computer Solutions Pvt ltd',
    value: 4253,
  },
  {
    label: 'McKinley & Rice Creativity Pvt. Ltd',
    value: 4254,
  },
  {
    label: 'Adsmn',
    value: 4255,
  },
  {
    label: 'Vouchagram',
    value: 4256,
  },
  {
    label: 'Vahdam Teas',
    value: 4257,
  },
  {
    label: 'E2open Software',
    value: 4258,
  },
  {
    label: 'Fanbuff Esports India Private Limited',
    value: 4259,
  },
  {
    label: 'Chrisel Technolab Pvt Ltd',
    value: 4260,
  },
  {
    label: 'Education First',
    value: 4261,
  },
  {
    label: 'Pearson India Education Services Pvt Ltd',
    value: 4262,
  },
  {
    label: 'Spective Technologies Pvt Ltd',
    value: 4263,
  },
  {
    label: 'Novopay Solutions Private Limited',
    value: 4264,
  },
  {
    label: 'SplashLearn',
    value: 4265,
  },
  {
    label: 'Nyusoft Solutions LLP',
    value: 4266,
  },
  {
    label: 'WEKANCODE TECHNOLOGIES PRIVATE LIMITED',
    value: 4267,
  },
  {
    label: 'Forsignerds Inc',
    value: 4268,
  },
  {
    label: 'SIDSSOL Technologies Pvt.Ltd.',
    value: 4269,
  },
  {
    label: 'lantern Digital services pvt ltd',
    value: 4270,
  },
  {
    label: 'Internshala',
    value: 4271,
  },
  {
    label: 'IAST Software Solution Pvt Ltd',
    value: 4272,
  },
  {
    label: 'Amulya Infotech India Pvt Ltd',
    value: 4273,
  },
  {
    label: 'SmartSoC Solutions Pvt Ltd',
    value: 4274,
  },
  {
    label: 'Frapp',
    value: 4275,
  },
  {
    label: 'Ezops Inc',
    value: 4276,
  },
  {
    label: 'SUN Mobility',
    value: 4277,
  },
  {
    label: 'FrontM',
    value: 4278,
  },
  {
    label: 'Wibmo',
    value: 4279,
  },
  {
    label: 'The Electron',
    value: 4280,
  },
  {
    label: 'Aiolos Solutions Pvt. Ltd.',
    value: 4281,
  },
  {
    label: 'Wirecard India Private Limited',
    value: 4282,
  },
  {
    label: 'Quantum BSO and Tech',
    value: 4283,
  },
  {
    label: 'EC Group',
    value: 4284,
  },
  {
    label: 'SNT Infotech Pvt Ltd',
    value: 4285,
  },
  {
    label: 'Veritas',
    value: 4286,
  },
  {
    label: 'Altiux Innovations',
    value: 4287,
  },
  {
    label: 'Sopra Steria',
    value: 4288,
  },
  {
    label: 'Sopra Steria',
    value: 4289,
  },
  {
    label: 'Global Market Insights Research Pvt Ltd.',
    value: 4290,
  },
  {
    label: 'LoanSimple',
    value: 4291,
  },
  {
    label: 'My Apps Solutions',
    value: 4292,
  },
  {
    label: 'Raj Softech Solutions India Private Limited',
    value: 4293,
  },
  {
    label: 'Truminds Software Systems Pvt. Ltd.',
    value: 4294,
  },
  {
    label: 'WittyPen',
    value: 4295,
  },
  {
    label: 'Central Chinmaya Mission Trust',
    value: 4296,
  },
  {
    label: 'Alterest',
    value: 4297,
  },
  {
    label: 'Techniclabs',
    value: 4298,
  },
  {
    label: 'KVP Business Solutions Pvt. Ltd.',
    value: 4299,
  },
  {
    label: 'Shipmart Tech Pvt Ltd',
    value: 4300,
  },
  {
    label: 'Datacore technologies',
    value: 4301,
  },
  {
    label: 'Netrovert',
    value: 4302,
  },
  {
    label: 'Ramsol',
    value: 4303,
  },
  {
    label: 'Verve Square Technologies',
    value: 4304,
  },
  {
    label: 'Sparx IT Solution',
    value: 4305,
  },
  {
    label: 'NearPe',
    value: 4306,
  },
  {
    label: 'D&D Solutions',
    value: 4307,
  },
  {
    label: 'Gaussian Networks Pvt. Ltd.',
    value: 4308,
  },
  {
    label: 'Glimpse Analytics',
    value: 4309,
  },
  {
    label: 'Nova Capital',
    value: 4310,
  },
  {
    label: 'Comely Enterprises Private Limited',
    value: 4311,
  },
  {
    label: 'Aryaka',
    value: 4312,
  },
  {
    label: 'Wafer Space',
    value: 4313,
  },
  {
    label: 'Areya Technologies',
    value: 4314,
  },
  {
    label: 'PowerUpcloud Technologies',
    value: 4315,
  },
  {
    label: 'RecoSense Infosolutions Pvt Ltd',
    value: 4316,
  },
  {
    label: 'Numberz',
    value: 4317,
  },
  {
    label: 'Minebrat',
    value: 4318,
  },
  {
    label: 'Emitrr',
    value: 4319,
  },
  {
    label: 'Getinz',
    value: 4320,
  },
  {
    label: 'CR Group',
    value: 4321,
  },
  {
    label: 'Xactly Technologies Pvt Ltd',
    value: 4322,
  },
  {
    label: 'Watch Your Health',
    value: 4323,
  },
  {
    label: 'Emporis Academy Pvt Ltd',
    value: 4324,
  },
  {
    label: 'E-shop Consultants Private Limited',
    value: 4325,
  },
  {
    label: 'Sameeksha Capital Pvt Ltd',
    value: 4326,
  },
  {
    label: 'SourceCode Labs',
    value: 4327,
  },
  {
    label: 'business intelli solution',
    value: 4328,
  },
  {
    label: 'oogram technologies Pvt Ltd',
    value: 4329,
  },
  {
    label: 'nVent',
    value: 4330,
  },
  {
    label: 'Geektrust',
    value: 4331,
  },
  {
    label: 'OnceHub Technologies Pvt. Ltd.',
    value: 4332,
  },
  {
    label: 'Knoldus',
    value: 4333,
  },
  {
    label: 'Curigence Technology Inc.',
    value: 4334,
  },
  {
    label: 'Scorpiosys Consulting (An Ayurmegha Inc. Company)',
    value: 4335,
  },
  {
    label: 'Wibmo',
    value: 4336,
  },
  {
    label: 'Techwave',
    value: 4337,
  },
  {
    label: 'Ishttaa TechCraft',
    value: 4338,
  },
  {
    label: 'Ishttaa TechCraft',
    value: 4339,
  },
  {
    label: 'Voxvalley',
    value: 4340,
  },
  {
    label: 'Relfor Labs Pvt Ltd',
    value: 4341,
  },
  {
    label: 'Satyam Software Solutions Pvt.Ltd.',
    value: 4342,
  },
  {
    label: 'Vedant TV',
    value: 4343,
  },
  {
    label: 'Novel Medicare Solutions Pvt Ltd',
    value: 4344,
  },
  {
    label: "Design'N'Buy Web To Print Pvt. Ltd.",
    value: 4345,
  },
  {
    label: 'Jewel alliance.com',
    value: 4346,
  },
  {
    label: 'Ecomsolver Private Limited',
    value: 4347,
  },
  {
    label: 'Bank Bazaar',
    value: 4348,
  },
  {
    label: 'PolicyX.com',
    value: 4349,
  },
  {
    label: 'Sunovatech India Pvt Ltd',
    value: 4350,
  },
  {
    label: 'Aditya Birla Fashion and Retail',
    value: 4351,
  },
  {
    label: 'Xtreme Media',
    value: 4352,
  },
  {
    label: 'Firefly Technologies',
    value: 4353,
  },
  {
    label: 'Yolobus Travel Tech Pvt Ltd',
    value: 4354,
  },
  {
    label: 'Markivis Pvt Ltd',
    value: 4355,
  },
  {
    label: 'Dropsuite',
    value: 4356,
  },
  {
    label: 'getmerank',
    value: 4357,
  },
  {
    label: 'iQuanti',
    value: 4358,
  },
  {
    label: 'Datamatics Global Service Ltd',
    value: 4359,
  },
  {
    label: 'MySchoolPage',
    value: 4360,
  },
  {
    label: 'Indianet Consultants',
    value: 4361,
  },
  {
    label: 'Datanetiix',
    value: 4362,
  },
  {
    label: 'CashRich',
    value: 4363,
  },
  {
    label: 'BoughtByMany',
    value: 4364,
  },
  {
    label: 'Cylsys Software',
    value: 4365,
  },
  {
    label: 'Impetus Technologies',
    value: 4366,
  },
  {
    label: 'Brenolabs',
    value: 4367,
  },
  {
    label: 'HaikuJAM Technologies Private Limited',
    value: 4368,
  },
  {
    label: 'Fidelitus Corp',
    value: 4369,
  },
  {
    label: 'Local ramu online services private limited',
    value: 4370,
  },
  {
    label: 'ASM Technologies',
    value: 4371,
  },
  {
    label: 'Indium Software',
    value: 4372,
  },
  {
    label: 'Workindia',
    value: 4373,
  },
  {
    label: 'JSW Global Business Solutions',
    value: 4374,
  },
  {
    label: 'Apar People World',
    value: 4375,
  },
  {
    label: 'Cuelogic',
    value: 4376,
  },
  {
    label: 'Cuelogic Technologies',
    value: 4377,
  },
  {
    label: 'Tredence Analytics',
    value: 4378,
  },
  {
    label: 'enAct eServices',
    value: 4379,
  },
  {
    label: 'Officepulse Technology',
    value: 4380,
  },
  {
    label: 'Quadratyx',
    value: 4381,
  },
  {
    label: 'Lera Technologies Pvt. Ltd',
    value: 4382,
  },
  {
    label: 'Arete Software Pvt Ltd',
    value: 4383,
  },
  {
    label: 'DealShare',
    value: 4384,
  },
  {
    label: 'K12 Techno Services Pvt. Ltd',
    value: 4385,
  },
  {
    label: 'Stylfixx Innovations Pvt. Ltd.',
    value: 4386,
  },
  {
    label: 'Ampere Computing',
    value: 4387,
  },
  {
    label: 'DotSquares Technologies India Pvt Ltd',
    value: 4388,
  },
  {
    label: 'DataGenic India (Enverus)',
    value: 4389,
  },
  {
    label: 'Entrepreneur First',
    value: 4390,
  },
  {
    label: 'Veritas Infosolutions',
    value: 4391,
  },
  {
    label: 'Commdel Consulting Services Ltd',
    value: 4392,
  },
  {
    label: 'Evergent Technologies',
    value: 4393,
  },
  {
    label: 'Econote',
    value: 4394,
  },
  {
    label: 'Crave Infotech',
    value: 4395,
  },
  {
    label: 'PM AM IT Service',
    value: 4396,
  },
  {
    label: 'StartBit IT Solutions Pvt. Ltd.',
    value: 4397,
  },
  {
    label: 'AngelTech Logistic Solutions Pvt Ltd',
    value: 4398,
  },
  {
    label: 'XpertDox India Pvt Ltd',
    value: 4399,
  },
  {
    label: 'Ocrolus',
    value: 4400,
  },
  {
    label: 'Rooman Technologies',
    value: 4401,
  },
  {
    label: 'Gaana.com',
    value: 4402,
  },
  {
    label: 'Ari Solutions',
    value: 4403,
  },
  {
    label: 'Algowire Trading Technologies',
    value: 4404,
  },
  {
    label: 'Crayon Infotech Pvt Ltd',
    value: 4405,
  },
  {
    label: 'Aira Matrix',
    value: 4406,
  },
  {
    label: 'Unique Mercantile India Ltd.',
    value: 4407,
  },
  {
    label: 'Softnautics',
    value: 4408,
  },
  {
    label: '99Games Online Pvt. Ltd.',
    value: 4409,
  },
  {
    label: 'Nunceyali Private Limited',
    value: 4410,
  },
  {
    label: 'CRB Tech Pvt Ltd',
    value: 4411,
  },
  {
    label: 'Dai Software Solutions Pvt Ltd',
    value: 4412,
  },
  {
    label: 'Socure',
    value: 4413,
  },
  {
    label: 'CrownStack Technologies Pvt. Ltd.',
    value: 4414,
  },
  {
    label: 'Aequor',
    value: 4415,
  },
  {
    label: 'Webtech Solution Net',
    value: 4416,
  },
  {
    label: 'DSRC',
    value: 4417,
  },
  {
    label: 'Myndtree Business Services Pvt. Ltd',
    value: 4418,
  },
  {
    label: 'Golpokotha (Cloudcraftz Solutions Pvt Ltd)',
    value: 4419,
  },
  {
    label: 'Sungard Availability Services',
    value: 4420,
  },
  {
    label: 'BrandMuscle India Pvt Ltd',
    value: 4421,
  },
  {
    label: 'Games91',
    value: 4422,
  },
  {
    label: 'Ezeiatech Systems Private Limited',
    value: 4423,
  },
  {
    label: 'AGILETECH INFO SOLUTIONS PRIVATE LIMITED',
    value: 4424,
  },
  {
    label: 'Niphal Infotech',
    value: 4425,
  },
  {
    label: 'Ecom Express',
    value: 4426,
  },
  {
    label: 'Stagebit eCommerce Development Company',
    value: 4427,
  },
  {
    label: 'Techmatrix Consulting',
    value: 4428,
  },
  {
    label: 'Shiplyst Systems Private Limited',
    value: 4429,
  },
  {
    label: 'Wonderpoint Software Private Limited',
    value: 4430,
  },
  {
    label: 'Adomita Technology',
    value: 4431,
  },
  {
    label: 'Iotomation Ecotech Pvt. Ltd.',
    value: 4432,
  },
  {
    label: 'Easy Rewardz',
    value: 4433,
  },
  {
    label: 'Emerging Five',
    value: 4434,
  },
  {
    label: 'Docquity Services Pvt Ltd',
    value: 4435,
  },
  {
    label: 'SignEasy',
    value: 4436,
  },
  {
    label: 'Ardentisys Ltd.',
    value: 4437,
  },
  {
    label: 'EACIIT Vyasa',
    value: 4438,
  },
  {
    label: 'smartShift Technologies',
    value: 4439,
  },
  {
    label: 'The April.iO',
    value: 4440,
  },
  {
    label: 'Snapper IT',
    value: 4441,
  },
  {
    label: 'AppsTec Technology',
    value: 4442,
  },
  {
    label: 'Transcend360Llabs',
    value: 4443,
  },
  {
    label: 'Blueboat Advisors',
    value: 4444,
  },
  {
    label: '5i5j',
    value: 4445,
  },
  {
    label: 'SecureNow Insurance Broker Pvt Ltd.',
    value: 4446,
  },
  {
    label: 'GNFC Ltd.',
    value: 4447,
  },
  {
    label: 'Roinet Solution',
    value: 4448,
  },
  {
    label: 'Eigen Technologies Pvt. Ltd.',
    value: 4449,
  },
  {
    label: 'iTech India Pvt. Ltd.',
    value: 4450,
  },
  {
    label: 'Truckola Technologies Pvt ltd',
    value: 4451,
  },
  {
    label: 'Canada Computers Inc.',
    value: 4452,
  },
  {
    label: 'Anandorja',
    value: 4453,
  },
  {
    label: 'DigitalTrons Techno LLP',
    value: 4454,
  },
  {
    label: 'StepSetGo by Pepkit Media Pvt. Ltd.',
    value: 4455,
  },
  {
    label: 'Simplior',
    value: 4456,
  },
  {
    label: 'H&H Infotech',
    value: 4457,
  },
  {
    label: 'SWAN',
    value: 4458,
  },
  {
    label: 'Elpha Global Services',
    value: 4459,
  },
  {
    label: 'Wolkus Technology Solutions Pvt Ltd',
    value: 4460,
  },
  {
    label: 'Revolt Motors',
    value: 4461,
  },
  {
    label: 'SBS Global',
    value: 4462,
  },
  {
    label: 'YUJ Designs',
    value: 4463,
  },
  {
    label: 'Smerkato',
    value: 4464,
  },
  {
    label: 'Vinclo System',
    value: 4465,
  },
  {
    label: 'Crowdville',
    value: 4466,
  },
  {
    label: 'Launch IT Enterprise Development (P) Ltd',
    value: 4467,
  },
  {
    label: 'American Epay Systems private Limited',
    value: 4468,
  },
  {
    label: 'Ramer Software Solutions',
    value: 4469,
  },
  {
    label: 'Truminds Software Systems Pvt Ltd',
    value: 4470,
  },
  {
    label: 'SugarBox Networks Pvt Ltd',
    value: 4471,
  },
  {
    label: 'TripMagus',
    value: 4472,
  },
  {
    label: 'Cityflo',
    value: 4473,
  },
  {
    label: 'PUMA Sports India Pvt Ltd',
    value: 4474,
  },
  {
    label: 'The Scalers',
    value: 4475,
  },
  {
    label: 'W3 Villa Technologies Pvt Ltd',
    value: 4476,
  },
  {
    label: 'Vienna Advantage',
    value: 4477,
  },
  {
    label: 'Think Future Tech',
    value: 4478,
  },
  {
    label: 'Infosolz Consultancy Services Pvt. Ltd.',
    value: 4479,
  },
  {
    label: 'PureSoftware Pvt. Ltd.',
    value: 4480,
  },
  {
    label: 'InterSources Inc',
    value: 4481,
  },
  {
    label: 'Utvyakta Solutions Pvt. Ltd.',
    value: 4482,
  },
  {
    label: 'Red Events Service LLC',
    value: 4483,
  },
  {
    label: 'LimeRoad',
    value: 4484,
  },
  {
    label: 'Root Info Solutions',
    value: 4485,
  },
  {
    label: 'AppViewX',
    value: 4486,
  },
  {
    label: 'Hemista',
    value: 4487,
  },
  {
    label: 'Auxesis Infotech Pvt. Ltd',
    value: 4488,
  },
  {
    label: 'Active.ai',
    value: 4489,
  },
  {
    label: 'Medcords',
    value: 4490,
  },
  {
    label: 'Bar & Bench',
    value: 4491,
  },
  {
    label: 'OnsiteGo',
    value: 4492,
  },
  {
    label: 'Rheo TV',
    value: 4493,
  },
  {
    label: 'Eduncle India Pvt. Ltd.',
    value: 4494,
  },
  {
    label: 'Bijak',
    value: 4495,
  },
  {
    label: 'ATOM Systems Pvt Ltd',
    value: 4496,
  },
  {
    label: 'Acesoftlabs.com',
    value: 4497,
  },
  {
    label: 'AthenasOwl',
    value: 4498,
  },
  {
    label: 'Strauss Sport',
    value: 4499,
  },
  {
    label: 'Deevita Technologies',
    value: 4500,
  },
  {
    label: 'WM Logistics',
    value: 4501,
  },
  {
    label: 'Alliance Data',
    value: 4502,
  },
  {
    label: 'AG Tech Pro',
    value: 4503,
  },
  {
    label: 'Tecknotrove System',
    value: 4504,
  },
  {
    label: 'Mytrah Mobility (Mozev)',
    value: 4505,
  },
  {
    label: '200OK Solutions',
    value: 4506,
  },
  {
    label: 'Course5i',
    value: 4507,
  },
  {
    label: 'Cygnus Technologies',
    value: 4508,
  },
  {
    label: 'Bajaj Finance Ltd.',
    value: 4509,
  },
  {
    label: 'Ather Energy',
    value: 4510,
  },
  {
    label: 'Teqfocus',
    value: 4511,
  },
  {
    label: 'Stay Vista Pvt. Ltd.',
    value: 4512,
  },
  {
    label: 'Snapper IT',
    value: 4513,
  },
  {
    label: 'Ginete Technologies',
    value: 4514,
  },
  {
    label: 'PharmEasy',
    value: 4515,
  },
  {
    label: 'Hotelogix India Pvt. Ltd',
    value: 4516,
  },
  {
    label: 'LSTM',
    value: 4517,
  },
  {
    label: 'Ola Electric',
    value: 4518,
  },
  {
    label: 'Saaki Argus & Averil Consulting',
    value: 4519,
  },
  {
    label: 'WonDRx',
    value: 4520,
  },
  {
    label: 'Aurora Health Innovations',
    value: 4521,
  },
  {
    label: 'Meru Mobility Tech Pvt. Ltd.',
    value: 4522,
  },
  {
    label: 'Shortcode Technologies',
    value: 4523,
  },
  {
    label: 'Sort String Solutions LLP',
    value: 4524,
  },
  {
    label: 'CAW Studios Pvt Ltd',
    value: 4525,
  },
  {
    label: 'BITSILICA',
    value: 4526,
  },
  {
    label: 'BillionByte IT Solutions Pvt. Ltd.',
    value: 4527,
  },
  {
    label: 'Zaid Infotech',
    value: 4528,
  },
  {
    label: 'Idolize Business Solutions',
    value: 4529,
  },
  {
    label: 'TutorBin',
    value: 4530,
  },
  {
    label: 'SuperHumans',
    value: 4531,
  },
  {
    label: 'Gametion Technologies',
    value: 4532,
  },
  {
    label: 'CreateBytes',
    value: 4533,
  },
  {
    label: 'Advent Biztech Solution Pvt ltd',
    value: 4534,
  },
  {
    label: 'UITOUX Solutions',
    value: 4535,
  },
  {
    label: 'AppFoster Innovations Pvt. Ltd.',
    value: 4536,
  },
  {
    label: 'Vardaam Web Solutions Pvt. Ltd',
    value: 4537,
  },
  {
    label: 'DoSelect',
    value: 4538,
  },
  {
    label: 'Dynamics Square',
    value: 4539,
  },
  {
    label: 'Hcode.tech',
    value: 4540,
  },
  {
    label: 'Randstad India',
    value: 4541,
  },
  {
    label: 'Clove Technologies Pvt ltd',
    value: 4542,
  },
  {
    label: 'Armentum',
    value: 4543,
  },
  {
    label: 'CyberBoxer',
    value: 4544,
  },
  {
    label: 'Itvedant Education Pvt. Ltd.',
    value: 4545,
  },
  {
    label: 'Cogknit Semantics pvt ltd',
    value: 4546,
  },
  {
    label: 'Edgile HR Services',
    value: 4547,
  },
  {
    label: 'PC Financial Services Pvt. Ltd.',
    value: 4548,
  },
  {
    label: 'ViPrak Web Solutions',
    value: 4549,
  },
  {
    label: 'TalenForge Business Solutions (OPC) Pvt ltd',
    value: 4550,
  },
  {
    label: 'Tekki Web Solutions',
    value: 4551,
  },
  {
    label: 'Acknown Technologies.com',
    value: 4552,
  },
  {
    label: 'Wallstreet Finance Limited',
    value: 4553,
  },
  {
    label: 'Softoboz Technologies Pvt. Ltd',
    value: 4554,
  },
  {
    label: 'Idyllic Services Private Limited',
    value: 4555,
  },
  {
    label: 'Kaleyra',
    value: 4556,
  },
  {
    label: 'ADF Data Science',
    value: 4557,
  },
  {
    label: 'HeyHub Ltd',
    value: 4558,
  },
  {
    label: 'Telebu Communications',
    value: 4559,
  },
  {
    label: 'Entrust Global Group LLC',
    value: 4560,
  },
  {
    label: 'Kaleyra',
    value: 4561,
  },
  {
    label: 'GoBOLT',
    value: 4562,
  },
  {
    label: 'Infoane',
    value: 4563,
  },
  {
    label: 'Exponentia',
    value: 4564,
  },
  {
    label: 'OnUs Payment Systems India Pvt Ltd',
    value: 4565,
  },
  {
    label: 'Phronesis Partners',
    value: 4566,
  },
  {
    label: 'Kriscent Techno Hub Pvt. Ltd.',
    value: 4567,
  },
  {
    label: 'Navisite India',
    value: 4568,
  },
  {
    label: 'TechLearning Solution',
    value: 4569,
  },
  {
    label: 'Course5i',
    value: 4570,
  },
  {
    label: 'Claritus',
    value: 4571,
  },
  {
    label: 'Espressif Systems',
    value: 4572,
  },
  {
    label: 'Course5i',
    value: 4573,
  },
  {
    label: 'TradeCred',
    value: 4574,
  },
  {
    label: 'The Healthy Cravings Co',
    value: 4575,
  },
  {
    label: 'Sparx IT Solutions Pvt. Ltd.',
    value: 4576,
  },
  {
    label: 'thinkStart Pvt. Ltd.',
    value: 4577,
  },
  {
    label: 'Mobineers InfoSystems Pvt. Ltd.',
    value: 4578,
  },
  {
    label: 'Pankhuri.co',
    value: 4579,
  },
  {
    label: 'Swaniti Initiative',
    value: 4580,
  },
  {
    label: 'lk',
    value: 4581,
  },
  {
    label: 'P C Financial',
    value: 4582,
  },
  {
    label: 'Mosaic Media Ventures Pvt. Ltd.',
    value: 4583,
  },
  {
    label: '4Bell Technology',
    value: 4584,
  },
  {
    label: 'Sun Dew Solutions Pvt Ltd',
    value: 4585,
  },
  {
    label: '1Tab',
    value: 4586,
  },
  {
    label: 'Vadict Innovations Pvt. Ltd.',
    value: 4587,
  },
  {
    label: 'QCHECK',
    value: 4588,
  },
  {
    label: 'Algo One A.I. Private Limited',
    value: 4589,
  },
  {
    label: 'X-byte Enterprise Solutions Pvt. Ltd.',
    value: 4590,
  },
  {
    label: 'Sloki Technologies Pvt Ltd',
    value: 4591,
  },
  {
    label: 'Trendspace Business Solutions Pvt. Ltd.',
    value: 4592,
  },
  {
    label: 'Eidiko Systems Integrators',
    value: 4593,
  },
  {
    label: 'BricknBolt',
    value: 4594,
  },
  {
    label: 'Brick N Bolt',
    value: 4595,
  },
  {
    label: 'Course 5i',
    value: 4596,
  },
  {
    label: 'Snap2Insight India Private Limited',
    value: 4597,
  },
  {
    label: '911 Fintech Solutions',
    value: 4598,
  },
  {
    label: 'Navya Technologies Private limited',
    value: 4599,
  },
  {
    label: 'Enquero Global',
    value: 4600,
  },
  {
    label: 'Bukukas',
    value: 4601,
  },
  {
    label: 'Sukshi Technology Innovation Pvt.Ltd',
    value: 4602,
  },
  {
    label: 'Delaplex',
    value: 4603,
  },
  {
    label: 'PHISTREAM COSNULTING PVT LTD',
    value: 4604,
  },
  {
    label: 'Mobile Tornado',
    value: 4605,
  },
  {
    label: 'Huvi Digi Life',
    value: 4606,
  },
  {
    label: '1Tab',
    value: 4607,
  },
  {
    label: 'EPC Group',
    value: 4608,
  },
  {
    label: 'Sath Infotech pvt. ltd.',
    value: 4609,
  },
  {
    label: 'KVP Business Solutions Pvt Ltd',
    value: 4610,
  },
  {
    label: 'MAG Studios',
    value: 4611,
  },
  {
    label: 'ITSPE',
    value: 4612,
  },
  {
    label: 'Viaan  Technologies',
    value: 4613,
  },
  {
    label: 'Contus',
    value: 4614,
  },
  {
    label: 'Contus Support Interactive Pvt Ltd',
    value: 4615,
  },
  {
    label: 'Web Synergies India Pvt Ltd',
    value: 4616,
  },
  {
    label: 'Z1 Media',
    value: 4617,
  },
  {
    label: 'Strata',
    value: 4618,
  },
  {
    label: 'Blue Tokai Coffee Roasters',
    value: 4619,
  },
  {
    label: 'Codeferry Technologies',
    value: 4620,
  },
  {
    label: 'mPhase technologies',
    value: 4621,
  },
  {
    label: 'Regalix India Pvt',
    value: 4622,
  },
  {
    label: 'Maven Technosoft Pvt. Ltd.',
    value: 4623,
  },
  {
    label: 'PIXACORE India LLP',
    value: 4624,
  },
  {
    label: 'NoBroker.in',
    value: 4625,
  },
  {
    label: 'Awdiz Pvt Ltd',
    value: 4626,
  },
  {
    label: 'Claritus Management Consulting Pvt Ltd',
    value: 4627,
  },
  {
    label: 'Staycay Abode Solutions Pvt Ltd/HooLiv',
    value: 4628,
  },
  {
    label: 'Talent500 by ANSR',
    value: 4629,
  },
  {
    label: 'Mediamint',
    value: 4630,
  },
  {
    label: 'Bahwan CyberTek',
    value: 4631,
  },
  {
    label: 'Petasense',
    value: 4632,
  },
  {
    label: 'Scholar Space',
    value: 4633,
  },
  {
    label: 'Advent Biztech Solutions Pvt Ltd',
    value: 4634,
  },
  {
    label: 'Net Solutions',
    value: 4635,
  },
  {
    label: 'reach52',
    value: 4636,
  },
  {
    label: 'CONTUS',
    value: 4637,
  },
  {
    label: 'Cube Reach Technologies',
    value: 4638,
  },
  {
    label: 'Udayy',
    value: 4639,
  },
  {
    label: 'VHIRON',
    value: 4640,
  },
  {
    label: 'Course 5 Intelligence',
    value: 4641,
  },
  {
    label: 'Softobiz',
    value: 4642,
  },
  {
    label: 'Crescendo Global',
    value: 4643,
  },
  {
    label: 'Covenant Consultants',
    value: 4644,
  },
  {
    label: 'Croyton Solution',
    value: 4645,
  },
  {
    label: 'Gaussian Networks',
    value: 4646,
  },
  {
    label: 'Bradsol',
    value: 4647,
  },
  {
    label: 'Smile India',
    value: 4648,
  },
  {
    label: 'SingularityAIX',
    value: 4649,
  },
  {
    label: 'eFleet Systems Pvt. Ltd',
    value: 4650,
  },
  {
    label: 'iTalent India',
    value: 4651,
  },
  {
    label: 'Chhoriya Realty',
    value: 4652,
  },
  {
    label: 'Raphe mPhibr Pvt Ltd',
    value: 4653,
  },
  {
    label: 'FlytBase',
    value: 4654,
  },
  {
    label: 'BlueBerry IT Solutions Pvt Ltd',
    value: 4655,
  },
  {
    label: 'Global Options HR Consultants',
    value: 4656,
  },
  {
    label: 'Opteamix LLC',
    value: 4657,
  },
  {
    label: 'Aliens Group',
    value: 4658,
  },
  {
    label: 'Touch2Success Software Solutions',
    value: 4659,
  },
  {
    label: 'Huawei Telecommunication India',
    value: 4660,
  },
  {
    label: 'VComply Technologies India Pvt. Ltd.',
    value: 4661,
  },
  {
    label: 'Fiverivers IT Solutions Pvt. Ltd.',
    value: 4662,
  },
  {
    label: 'Advantmed India LLP',
    value: 4663,
  },
  {
    label: 'Neosoft',
    value: 4664,
  },
  {
    label: 'Mercados Energy Markets India Pvt Ltd',
    value: 4665,
  },
  {
    label: 'Thinkify Labs',
    value: 4666,
  },
  {
    label: 'Bimo',
    value: 4667,
  },
  {
    label: 'Easy Solutions',
    value: 4668,
  },
  {
    label: 'Sysintegra',
    value: 4669,
  },
  {
    label: 'Doyen System',
    value: 4670,
  },
  {
    label: 'Specbee',
    value: 4671,
  },
  {
    label: 'Born Techies Solutions',
    value: 4672,
  },
  {
    label: 'Aryan Tech Solutions',
    value: 4673,
  },
  {
    label: 'Net Solutions',
    value: 4674,
  },
  {
    label: 'Net Solutions',
    value: 4675,
  },
  {
    label: 'Syscom Softech Pvt. Ltd.',
    value: 4676,
  },
  {
    label: 'Urbanic',
    value: 4677,
  },
  {
    label: 'Zebra Technologies',
    value: 4678,
  },
  {
    label: 'ITCAN Digital',
    value: 4679,
  },
  {
    label: 'Extramarks Education India Pvt. Ltd.',
    value: 4680,
  },
  {
    label: 'Opshub Technologies pvt ltd',
    value: 4681,
  },
  {
    label: 'Zen & Art',
    value: 4682,
  },
  {
    label: 'Adroit Infosystem',
    value: 4683,
  },
  {
    label: 'Comnet Development India',
    value: 4684,
  },
  {
    label: 'BulbulTv',
    value: 4685,
  },
  {
    label: 'Annet Technologies',
    value: 4686,
  },
  {
    label: 'Pramata Corporation',
    value: 4687,
  },
  {
    label: 'Praxis Global Alliance',
    value: 4688,
  },
  {
    label: 'Arvind Internet',
    value: 4689,
  },
  {
    label: 'CodeFront Technologies',
    value: 4690,
  },
  {
    label: 'Euro Med Associations Pvt. Ltd.',
    value: 4691,
  },
  {
    label: 'IdeaSailor technologies Pvt Ltd',
    value: 4692,
  },
  {
    label: 'Katam Technology Solutions Pvt Ltd',
    value: 4693,
  },
  {
    label: 'SFW Technologies India Pvt Ltd',
    value: 4694,
  },
  {
    label: 'Blackmelon Advance Technology Co. Pvt. Ltd.',
    value: 4695,
  },
  {
    label: 'LR Jobs Search',
    value: 4696,
  },
  {
    label: 'SBL Knowledge Services Ltd.',
    value: 4697,
  },
  {
    label: 'Rainbox Media Pvt Ltd(One Play)',
    value: 4698,
  },
  {
    label: 'Tertium Technology Pvt Ltd',
    value: 4699,
  },
  {
    label: 'Great Learning',
    value: 4700,
  },
  {
    label: 'Fingent Global Solution Pvt Ltd.',
    value: 4701,
  },
  {
    label: 'Yantriks India Pvt Ltd',
    value: 4702,
  },
  {
    label: 'DiTech Process Solutions Pvt Ltd',
    value: 4703,
  },
  {
    label: 'Internet Mango Solutions',
    value: 4704,
  },
  {
    label: 'Engage Digital Partners Pvt Ltd',
    value: 4705,
  },
  {
    label: 'Blue Aves E-health Pvt. Ltd',
    value: 4706,
  },
  {
    label: 'Techies India Inc',
    value: 4707,
  },
  {
    label: 'TechRAQ Info Solutions Pvt Ltd',
    value: 4708,
  },
  {
    label: 'Zagaz Private Limited',
    value: 4709,
  },
  {
    label: 'InTouchApp',
    value: 4710,
  },
  {
    label: 'Moglix',
    value: 4711,
  },
  {
    label: 'Atrity Info Solutions Private Limited',
    value: 4712,
  },
  {
    label: 'Vernost Marketing  Technology Solutions Pvt Ltd',
    value: 4713,
  },
  {
    label: 'Hello Parent- Paniya Technologies',
    value: 4714,
  },
  {
    label: 'Bassam InfoTech',
    value: 4715,
  },
  {
    label: 'Innovalus',
    value: 4716,
  },
  {
    label: 'Fabit Corp',
    value: 4717,
  },
  {
    label: 'Ashoka University',
    value: 4718,
  },
  {
    label: 'SofSter',
    value: 4719,
  },
  {
    label: 'Avows Technologies',
    value: 4720,
  },
  {
    label: 'NIIT Technologies',
    value: 4721,
  },
  {
    label: 'Lee & Nee Softwares (Exports) Limited',
    value: 4722,
  },
  {
    label: 'Quantela',
    value: 4723,
  },
  {
    label: 'PureSoftware Pvt Ltd',
    value: 4724,
  },
  {
    label: 'JRA Analytics',
    value: 4725,
  },
  {
    label: '6Sense Insights Pvt. Ltd.',
    value: 4726,
  },
  {
    label: 'Ashoka University',
    value: 4727,
  },
  {
    label: 'ArowlogiQ Infotech Pvt Ltd',
    value: 4728,
  },
  {
    label: 'GNEC Media Pvt. Ltd',
    value: 4729,
  },
  {
    label: 'TestVagrant',
    value: 4730,
  },
  {
    label: 'CollegeBatch.com',
    value: 4731,
  },
  {
    label: 'Delivery Solutions',
    value: 4732,
  },
  {
    label: 'Penguin CRM Pvt. ltd.',
    value: 4733,
  },
  {
    label: 'Intense Intellect Pvt. Ltd.',
    value: 4734,
  },
  {
    label: 'CRB Tech',
    value: 4735,
  },
  {
    label: 'Job Vision Consulting Outsourcing',
    value: 4736,
  },
  {
    label: 'The Dollar Business',
    value: 4737,
  },
  {
    label: 'Decorpot',
    value: 4738,
  },
  {
    label: 'Update Advertising & Marketing Pvt. Ltd.',
    value: 4739,
  },
  {
    label: 'ISchoolConnect Technologies Pvt. Ltd.',
    value: 4740,
  },
  {
    label: '3C Technologies',
    value: 4741,
  },
  {
    label: 'Docsvault (Shiv Software Solution)',
    value: 4742,
  },
  {
    label: 'K12 Techno Services Pvt. Ltd.',
    value: 4743,
  },
  {
    label: 'Ameriprise',
    value: 4744,
  },
  {
    label: 'Emagine People Technologies Pvt. Ltd.',
    value: 4745,
  },
  {
    label: 'REXCEL IT SERVICES PVT. LTD',
    value: 4746,
  },
  {
    label: 'Evergent',
    value: 4747,
  },
  {
    label: 'Cloutics Pvt Ltd',
    value: 4748,
  },
  {
    label: 'Synergos Tech Pvt Ltd',
    value: 4749,
  },
  {
    label: 'Cybernetyx Technik',
    value: 4750,
  },
  {
    label: 'Lentra.AI',
    value: 4751,
  },
  {
    label: 'Coincode Technosoft Pvt Ltd',
    value: 4752,
  },
  {
    label: 'Talent Socio',
    value: 4753,
  },
  {
    label: 'Uneecops Technologies',
    value: 4754,
  },
  {
    label: 'EntNetwrk',
    value: 4755,
  },
  {
    label: 'Fleet Studio Technology',
    value: 4756,
  },
  {
    label: 'Docon',
    value: 4757,
  },
  {
    label: 'Inventsoftlabs',
    value: 4758,
  },
  {
    label: 'TEOCO Software',
    value: 4759,
  },
  {
    label: 'Elpis IT Solutions Pvt Ltd',
    value: 4760,
  },
  {
    label: 'Kloutix Solutions',
    value: 4761,
  },
  {
    label: 'Domino Data Lab',
    value: 4762,
  },
  {
    label: 'Tekhsol',
    value: 4763,
  },
  {
    label: 'Kairali Ayurvedic Group',
    value: 4764,
  },
  {
    label: 'Senja technology pvt ltd',
    value: 4765,
  },
  {
    label: 'Sigmoss Systems',
    value: 4766,
  },
  {
    label: 'Visible Box',
    value: 4767,
  },
  {
    label: 'IDOS India Private Limited',
    value: 4768,
  },
  {
    label: 'Global Grovernance Advisors',
    value: 4769,
  },
  {
    label: 'Snapper IT',
    value: 4770,
  },
  {
    label: 'Accunity Services',
    value: 4771,
  },
  {
    label: 'Chalo.com',
    value: 4772,
  },
  {
    label: 'Chatpay Commerce Pvt Ltd',
    value: 4773,
  },
  {
    label: 'Saraswati Printers',
    value: 4774,
  },
  {
    label: 'Finvestfx.com',
    value: 4775,
  },
  {
    label: 'ICICI',
    value: 4776,
  },
  {
    label: 'Copieux Techknowledge Analytics LLP',
    value: 4777,
  },
  {
    label: 'TogetherV',
    value: 4778,
  },
  {
    label: 'Perspectico Learning Private Limited',
    value: 4779,
  },
  {
    label: 'Mistical Minds Solutions Pvt Ltd',
    value: 4780,
  },
  {
    label: 'Xerago',
    value: 4781,
  },
  {
    label: 'Telliant Systems',
    value: 4782,
  },
  {
    label: 'zekeLabs',
    value: 4783,
  },
  {
    label: 'Trident Techlabs Pvt ltd',
    value: 4784,
  },
  {
    label: 'Opteamix',
    value: 4785,
  },
  {
    label: 'Accedo',
    value: 4786,
  },
  {
    label: 'Smart Owl Education Private Limited',
    value: 4787,
  },
  {
    label: 'Ocrex',
    value: 4788,
  },
  {
    label: 'Wadhwani AI',
    value: 4789,
  },
  {
    label: 'Saintgeeks Techlabs LLP',
    value: 4790,
  },
  {
    label: 'Balancehero India Pvt. Ltd.',
    value: 4791,
  },
  {
    label: 'MymobiForce',
    value: 4792,
  },
  {
    label: 'Hiver',
    value: 4793,
  },
  {
    label: 'Intandemly',
    value: 4794,
  },
  {
    label: 'U GRO Capital Ltd.',
    value: 4795,
  },
  {
    label: 'Impact Research and Measurement Pvt Ltd',
    value: 4796,
  },
  {
    label: 'Ather Energy',
    value: 4797,
  },
  {
    label: 'Sobha Limited',
    value: 4798,
  },
  {
    label: 'Wafer Electronics',
    value: 4799,
  },
  {
    label: 'Cygnius Consulting Pvt. Ltd.',
    value: 4800,
  },
  {
    label: 'Indiannica Learning Pvt. Ltd.',
    value: 4801,
  },
  {
    label: 'Varite India',
    value: 4802,
  },
  {
    label: 'Fujitsu Technology',
    value: 4803,
  },
  {
    label: 'TotalCloud Inc',
    value: 4804,
  },
  {
    label: 'WorkLLama',
    value: 4805,
  },
  {
    label: 'Codebox',
    value: 4806,
  },
  {
    label: 'Prabhudas Lilladher Pvt Ltd',
    value: 4807,
  },
  {
    label: 'Eko India Financial Services Pvt. Ltd.',
    value: 4808,
  },
  {
    label: 'RateGain Travel Technology Pvt.Ltd',
    value: 4809,
  },
  {
    label: 'AP Techpins',
    value: 4810,
  },
  {
    label: 'Rimini Street',
    value: 4811,
  },
  {
    label: 'BizLence',
    value: 4812,
  },
  {
    label: 'Pure Software',
    value: 4813,
  },
  {
    label: 'Chargebee',
    value: 4814,
  },
  {
    label: 'Myglamm',
    value: 4815,
  },
  {
    label: 'Kennametal',
    value: 4816,
  },
  {
    label: 'Z1 Media',
    value: 4817,
  },
  {
    label: 'Huptech Web Pvt Ltd',
    value: 4818,
  },
  {
    label: 'Centre for Wildlife Studies',
    value: 4819,
  },
  {
    label: 'HR Department',
    value: 4820,
  },
  {
    label: 'Grow Career',
    value: 4821,
  },
  {
    label: 'Codingzen',
    value: 4822,
  },
  {
    label: 'Mogli labs India Pvt. Ltd.',
    value: 4823,
  },
  {
    label: 'HAS Technosys PVT. LTD',
    value: 4824,
  },
  {
    label: 'Adglobal360',
    value: 4825,
  },
  {
    label: 'ezTruck - Zippco Logistics Pvt. Ltd.',
    value: 4826,
  },
  {
    label: 'Fpl technologies',
    value: 4827,
  },
  {
    label: 'Passwork Technologies',
    value: 4828,
  },
  {
    label: 'Beiing Corporate Pvt Ltd',
    value: 4829,
  },
  {
    label: 'Velan Info Services India Pvt Ltd',
    value: 4830,
  },
  {
    label: 'Algo Legal',
    value: 4831,
  },
  {
    label: 'Virtual Shield',
    value: 4832,
  },
  {
    label: 'Shaping Career',
    value: 4833,
  },
  {
    label: 'Vadsoft Pvt Ltd',
    value: 4834,
  },
  {
    label: 'Koru UX Design LLP',
    value: 4835,
  },
  {
    label: 'Enayble',
    value: 4836,
  },
  {
    label: 'IFA Global',
    value: 4837,
  },
  {
    label: 'Netrix Worldwide Pvt Ltd',
    value: 4838,
  },
  {
    label: 'Netradyne Technologies India Pvt Ltd',
    value: 4839,
  },
  {
    label: 'Dolat Capital Pvt Ltd',
    value: 4840,
  },
  {
    label: 'Tradologie.com',
    value: 4841,
  },
  {
    label: 'Harbour and Hills',
    value: 4842,
  },
  {
    label: 'GFC Education Ventures LLP',
    value: 4843,
  },
  {
    label: 'Jobgaga',
    value: 4844,
  },
  {
    label: '2Soft Solutions Pvt Ltd',
    value: 4845,
  },
  {
    label: '314e Corporation',
    value: 4846,
  },
  {
    label: '3Brain Technologies',
    value: 4847,
  },
  {
    label: '3 Pillar Global',
    value: 4848,
  },
  {
    label: '3S Solution',
    value: 4849,
  },
  {
    label: '6i InfoTech',
    value: 4850,
  },
  {
    label: '91Social',
    value: 4851,
  },
  {
    label: 'Noble House',
    value: 4852,
  },
  {
    label: 'Aarrrmor Digital',
    value: 4853,
  },
  {
    label: 'Aavas Financiers Ltd',
    value: 4854,
  },
  {
    label: 'Aaxis Nano Technologies Pvt Ltd.',
    value: 4855,
  },
  {
    label: 'AB2 Consulting Inc',
    value: 4856,
  },
  {
    label: 'AB Innovative Software Pvt.Ltd.',
    value: 4857,
  },
  {
    label: 'Ably Soft Pvt. Ltd.',
    value: 4858,
  },
  {
    label: 'ABM Knowledgeware Ltd',
    value: 4859,
  },
  {
    label: 'Abzer Technology Solutions',
    value: 4860,
  },
  {
    label: 'Abzooba India Infotech Pvt Ltd',
    value: 4861,
  },
  {
    label: 'Accelya Kale Solutions Ltd.',
    value: 4862,
  },
  {
    label: 'Access Design Solutions',
    value: 4863,
  },
  {
    label: 'Access Infotech Pvt. Ltd',
    value: 4864,
  },
  {
    label: 'Accops Systems',
    value: 4865,
  },
  {
    label: 'Accubits Technologies',
    value: 4866,
  },
  {
    label: 'Acelr Tech Labs',
    value: 4867,
  },
  {
    label: 'Acesoft Labs (India) Pvt. Ltd.',
    value: 4868,
  },
  {
    label: 'Achala IT Solutions',
    value: 4869,
  },
  {
    label: 'Acko General Insurance',
    value: 4870,
  },
  {
    label: 'ACS Limited',
    value: 4871,
  },
  {
    label: 'Atria Convergence Technologies Ltd',
    value: 4872,
  },
  {
    label: 'Actonate IT Solutions Private Limited',
    value: 4873,
  },
  {
    label: 'Ad Astra Consultants Pvt. Ltd.',
    value: 4874,
  },
  {
    label: 'Adeptia',
    value: 4875,
  },
  {
    label: 'Admedia',
    value: 4876,
  },
  {
    label: 'Adroit Corporate Services Pvt. Ltd.',
    value: 4877,
  },
  {
    label: 'Adstacks Media',
    value: 4878,
  },
  {
    label: 'Aelfric Solutions',
    value: 4879,
  },
  {
    label: 'Aertrip',
    value: 4880,
  },
  {
    label: 'Aexonic Technologies Private Limited',
    value: 4881,
  },
  {
    label: 'Agami Tech',
    value: 4882,
  },
  {
    label: 'AGC Networks',
    value: 4883,
  },
  {
    label: 'AgileOne',
    value: 4884,
  },
  {
    label: 'Agile Cockpit Software Development',
    value: 4885,
  },
  {
    label: 'Agile Health Technology',
    value: 4886,
  },
  {
    label: 'Killy Travel Technology Limited',
    value: 4887,
  },
  {
    label: 'Agnext Technologies',
    value: 4888,
  },
  {
    label: 'Agrilinks Technologies LLP',
    value: 4889,
  },
  {
    label: 'AgroStar',
    value: 4890,
  },
  {
    label: 'AIMDek Technologies Pvt. Ltd.',
    value: 4891,
  },
  {
    label: 'AIT Global India Pvt. Ltd',
    value: 4892,
  },
  {
    label: 'aiTouch',
    value: 4893,
  },
  {
    label: 'Aizant Global Analytics Pvt Ltd',
    value: 4894,
  },
  {
    label: 'Ajackus',
    value: 4895,
  },
  {
    label: 'Ajath Infotech',
    value: 4896,
  },
  {
    label: 'AJ DEVTECH PVT LTD',
    value: 4897,
  },
  {
    label: 'AKS Interactive Solutions PVt Ltd',
    value: 4898,
  },
  {
    label: 'AlgonoX Technologies',
    value: 4899,
  },
  {
    label: 'Alien Technology Transfer',
    value: 4900,
  },
  {
    label: 'Alin Technologies',
    value: 4901,
  },
  {
    label: 'Alliancedata',
    value: 4902,
  },
  {
    label: 'All Spark Health',
    value: 4903,
  },
  {
    label: 'AlphaGrep Commodities Pvt. Ltd.',
    value: 4904,
  },
  {
    label: 'AlphaSense',
    value: 4905,
  },
  {
    label: 'Alpha Alternatives',
    value: 4906,
  },
  {
    label: 'AltBird Robotics Pvt Ltd',
    value: 4907,
  },
  {
    label: 'AltraDimension Technologies Private Limited',
    value: 4908,
  },
  {
    label: 'ARP Investments',
    value: 4909,
  },
  {
    label: 'Amantya Technologies',
    value: 4910,
  },
  {
    label: 'Amar Cars Pvt Ltd',
    value: 4911,
  },
  {
    label: 'Ambiot Infotech Pvt Ltd',
    value: 4912,
  },
  {
    label: 'Ameri100',
    value: 4913,
  },
  {
    label: 'AmyGB.ai',
    value: 4914,
  },
  {
    label: 'Anarock',
    value: 4915,
  },
  {
    label: 'Anbiya Technologies Pvt. Ltd',
    value: 4916,
  },
  {
    label: 'Anchanto Services Pvt.Ltd',
    value: 4917,
  },
  {
    label: 'Angara Ecommerce Pvt. Ltd.',
    value: 4918,
  },
  {
    label: 'Ways',
    value: 4919,
  },
  {
    label: 'ANS Commerce',
    value: 4920,
  },
  {
    label: 'Ansha Software',
    value: 4921,
  },
  {
    label: 'ANSR',
    value: 4922,
  },
  {
    label: 'Antino Labs',
    value: 4923,
  },
  {
    label: 'Antly',
    value: 4924,
  },
  {
    label: 'Antuit',
    value: 4925,
  },
  {
    label: 'Anubavam LLC',
    value: 4926,
  },
  {
    label: 'FULL Creative Pvt Ltd',
    value: 4927,
  },
  {
    label: 'Linedata',
    value: 4928,
  },
  {
    label: 'Apparrant Technologies (P) Ltd.',
    value: 4929,
  },
  {
    label: 'Appcino Technology Pvt Ltd',
    value: 4930,
  },
  {
    label: 'Appening Infotech Private Limited',
    value: 4931,
  },
  {
    label: 'Appinventiv Technologies',
    value: 4932,
  },
  {
    label: 'Appluent Business Solutions',
    value: 4933,
  },
  {
    label: 'Appmajix Technologies Pvt Ltd',
    value: 4934,
  },
  {
    label: 'Appnomic Systems Pvt Ltd',
    value: 4935,
  },
  {
    label: 'App & Web',
    value: 4936,
  },
  {
    label: 'Appscrip',
    value: 4937,
  },
  {
    label: 'Appsuccessor',
    value: 4938,
  },
  {
    label: 'AppsWise Technologies Pvt. Ltd',
    value: 4939,
  },
  {
    label: 'AppYogi Software',
    value: 4940,
  },
  {
    label: 'Aptivaa',
    value: 4941,
  },
  {
    label: 'AquGen Technologies Pvt Ltd',
    value: 4942,
  },
  {
    label: 'Aristocrat Technologies',
    value: 4943,
  },
  {
    label: 'NTT Ltd',
    value: 4944,
  },
  {
    label: 'Armantec Systems',
    value: 4945,
  },
  {
    label: 'Arrow Transit Technology',
    value: 4946,
  },
  {
    label: 'Artivatic.ai',
    value: 4947,
  },
  {
    label: 'Artsana India',
    value: 4948,
  },
  {
    label: 'Aryupay Technologies Private Ltd',
    value: 4949,
  },
  {
    label: 'Ashbee Systems Limited',
    value: 4950,
  },
  {
    label: 'Ashley Technologies Pvt. Ltd.',
    value: 4951,
  },
  {
    label: 'AskSpoke',
    value: 4952,
  },
  {
    label: 'ASPAGTEQ Private Limited Noida',
    value: 4953,
  },
  {
    label: 'Aspiring Minds Assessments Ltd.',
    value: 4954,
  },
  {
    label: 'Addon Solutions',
    value: 4955,
  },
  {
    label: 'Assetsoft Consulting Pvt Ltd',
    value: 4956,
  },
  {
    label: 'Shiksha Infotech',
    value: 4957,
  },
  {
    label: 'AthanSys HealthCare Solution Private Limited',
    value: 4958,
  },
  {
    label: 'Aticara Technologies',
    value: 4959,
  },
  {
    label: 'Atlantic Data Bureau Services Pvt. Ltd',
    value: 4960,
  },
  {
    label: 'Attra Infotech Pvt Ltd',
    value: 4961,
  },
  {
    label: 'AU Small Finance Bank Limited',
    value: 4962,
  },
  {
    label: 'Audatex Solutions Pvt. Ltd.',
    value: 4963,
  },
  {
    label: 'Augray Pvt Ltd',
    value: 4964,
  },
  {
    label: 'Augusta Infotech',
    value: 4965,
  },
  {
    label: 'Aureate Labs',
    value: 4966,
  },
  {
    label: 'Auriga IT Consulting (P) Ltd',
    value: 4967,
  },
  {
    label: 'Aussizz India Pvt. Ltd',
    value: 4968,
  },
  {
    label: 'Amar Ujala Web Services',
    value: 4969,
  },
  {
    label: 'Avaal Technologies India Pvt. Ltd.',
    value: 4970,
  },
  {
    label: 'Aveva',
    value: 4971,
  },
  {
    label: 'Avizva Solutions',
    value: 4972,
  },
  {
    label: 'Alta Vista Business Solution',
    value: 4973,
  },
  {
    label: 'Awign',
    value: 4974,
  },
  {
    label: 'Axat Technologies Pvt Ltd',
    value: 4975,
  },
  {
    label: 'Axestrack',
    value: 4976,
  },
  {
    label: 'Aza Fashions Pvt Ltd',
    value: 4977,
  },
  {
    label: 'Azcom',
    value: 4978,
  },
  {
    label: 'Azgo',
    value: 4979,
  },
  {
    label: 'BabyChakra',
    value: 4980,
  },
  {
    label: 'Babysoft Software',
    value: 4981,
  },
  {
    label: 'Bajaj Finserv',
    value: 4982,
  },
  {
    label: 'Balaji Telefilms',
    value: 4983,
  },
  {
    label: 'Balbix',
    value: 4984,
  },
  {
    label: 'Open Financial Technologies Pvt. Ltd',
    value: 4985,
  },
  {
    label: 'Bash.ai',
    value: 4986,
  },
  {
    label: 'Bharti Soft Tech Pvt Ltd',
    value: 4987,
  },
  {
    label: 'BCT',
    value: 4988,
  },
  {
    label: 'BizViz Technologies Pvt Ltd',
    value: 4989,
  },
  {
    label: 'BDO India LLP',
    value: 4990,
  },
  {
    label: 'Beauto System Pvt ltd',
    value: 4991,
  },
  {
    label: 'Beehive Software Services Pvt Ltd',
    value: 4992,
  },
  {
    label: 'Beepntell',
    value: 4993,
  },
  {
    label: 'Bellurbis Technologies Pvt Ltd',
    value: 4994,
  },
  {
    label: 'BelWo Services (India) Pvt. Ltd.',
    value: 4995,
  },
  {
    label: 'Belzabar Software Design India Pvt. Ltd.',
    value: 4996,
  },
  {
    label: 'Bennett University',
    value: 4997,
  },
  {
    label: 'Betamonks',
    value: 4998,
  },
  {
    label: 'Beyond Root Technology Services',
    value: 4999,
  },
  {
    label: 'BeyondSquare',
    value: 5000,
  },
  {
    label: 'Bhash Software Labs',
    value: 5001,
  },
  {
    label: 'BOH(Bid On Homes)',
    value: 5002,
  },
  {
    label: 'BigApp Technologies LLP',
    value: 5003,
  },
  {
    label: 'BigHaat',
    value: 5004,
  },
  {
    label: 'Billennium India Pvt.Ltd',
    value: 5005,
  },
  {
    label: 'BinaryBoot',
    value: 5006,
  },
  {
    label: 'BirdRes Technologies Pvt Ltd',
    value: 5007,
  },
  {
    label: 'Biz4Group',
    value: 5008,
  },
  {
    label: 'BizBrolly Solutions',
    value: 5009,
  },
  {
    label: 'Bizongo',
    value: 5010,
  },
  {
    label: 'Blackbuck',
    value: 5011,
  },
  {
    label: 'Blacklight Studio Works',
    value: 5012,
  },
  {
    label: 'Black Turtle Diginovation Pvt Ltd',
    value: 5013,
  },
  {
    label: 'Blaze web Services',
    value: 5014,
  },
  {
    label: 'BluSmart Mobility',
    value: 5015,
  },
  {
    label: 'Blubirch Pvt. Ltd.',
    value: 5016,
  },
  {
    label: 'BlueJeans Network Private Limited',
    value: 5017,
  },
  {
    label: 'BlueSapling',
    value: 5018,
  },
  {
    label: 'Bluetown (India) Pvt. Ltd.',
    value: 5019,
  },
  {
    label: 'Bluewebspark Technologies',
    value: 5020,
  },
  {
    label: 'ConstellationBlu',
    value: 5021,
  },
  {
    label: 'Sculptsoft',
    value: 5022,
  },
  {
    label: 'BMC Software',
    value: 5023,
  },
  {
    label: 'Bobble.Ai',
    value: 5024,
  },
  {
    label: 'BOB Financial Solutions Ltd',
    value: 5025,
  },
  {
    label: 'Bolt-on Global Solutions Pvt Ltd.',
    value: 5026,
  },
  {
    label: 'Bonito Designs',
    value: 5027,
  },
  {
    label: "Bonker's Art",
    value: 5028,
  },
  {
    label: 'Nunceyali',
    value: 5029,
  },
  {
    label: 'Brenolabs Pvt Ltd',
    value: 5030,
  },
  {
    label: 'Bridge International Academies',
    value: 5031,
  },
  {
    label: 'Bridging Technologies',
    value: 5032,
  },
  {
    label: 'Healthkart',
    value: 5033,
  },
  {
    label: 'BrightSword IT Services Pvt. Ltd.',
    value: 5034,
  },
  {
    label: 'BR Softech',
    value: 5035,
  },
  {
    label: 'Bursys Infotech India Pvt Ltd',
    value: 5036,
  },
  {
    label: 'Business Bashi',
    value: 5037,
  },
  {
    label: 'Business Doctors',
    value: 5038,
  },
  {
    label: 'Byte Web IT Solutions Pvt Ltd',
    value: 5039,
  },
  {
    label: 'Cactus Communications',
    value: 5040,
  },
  {
    label: 'Candela Labs',
    value: 5041,
  },
  {
    label: 'Canvas Craft Media',
    value: 5042,
  },
  {
    label: 'Fincity',
    value: 5043,
  },
  {
    label: 'Career Guideline',
    value: 5044,
  },
  {
    label: 'Cargill Business Services',
    value: 5045,
  },
  {
    label: 'Carpathy',
    value: 5046,
  },
  {
    label: 'CARQS Consulting',
    value: 5047,
  },
  {
    label: 'Cartesian Consulting',
    value: 5048,
  },
  {
    label: 'Cashapona Technologies Pvt Ltd',
    value: 5049,
  },
  {
    label: 'CashKaro.com',
    value: 5050,
  },
  {
    label: 'Caspian Impact',
    value: 5051,
  },
  {
    label: 'Castleton Technology India Private Limited',
    value: 5052,
  },
  {
    label: 'Cateina Technologies',
    value: 5053,
  },
  {
    label: 'Cbetter Consultancy',
    value: 5054,
  },
  {
    label: 'NAT IT Solved Pvt Ltd',
    value: 5055,
  },
  {
    label: 'CBSL Group',
    value: 5056,
  },
  {
    label: 'CCS Computers Private Limited',
    value: 5057,
  },
  {
    label: 'Centre for Digital Financial Inclusion(CDFI)',
    value: 5058,
  },
  {
    label: 'CentraLogic Consultancy Pvt. Ltd.',
    value: 5059,
  },
  {
    label: 'Chaitanya India Fin Credit Pvt Ltd',
    value: 5060,
  },
  {
    label: 'ChampionsIT',
    value: 5061,
  },
  {
    label: 'Champs Tech Solutions',
    value: 5062,
  },
  {
    label: 'CherishX',
    value: 5063,
  },
  {
    label: 'C.H. Robinson Worldwide Freight India Private Limited',
    value: 5064,
  },
  {
    label: 'ChromeInfo Technologies Pvt. Ltd.',
    value: 5065,
  },
  {
    label: 'Circle Internet Tech Pvt.Ltd',
    value: 5066,
  },
  {
    label: 'Cirtru',
    value: 5067,
  },
  {
    label: 'Shoppist Innovations Private Limited',
    value: 5068,
  },
  {
    label: 'Civil Maps',
    value: 5069,
  },
  {
    label: 'Coditation Systems',
    value: 5070,
  },
  {
    label: 'Coffeebeans Consulting',
    value: 5071,
  },
  {
    label: 'CoffeeBeans Technologies',
    value: 5072,
  },
  {
    label: 'CogniTensor',
    value: 5073,
  },
  {
    label: 'Cognitive Clouds Software Pvt Ltd',
    value: 5074,
  },
  {
    label: 'Cohesity India',
    value: 5075,
  },
  {
    label: 'Coindcx',
    value: 5076,
  },
  {
    label: 'CollegeDekho',
    value: 5077,
  },
  {
    label: 'CollegeStop Ventures',
    value: 5078,
  },
  {
    label: 'Communication Crafts',
    value: 5079,
  },
  {
    label: 'Comorin Consulting Services India Pvt. Ltd.',
    value: 5080,
  },
  {
    label: 'CompuGain Solutions',
    value: 5081,
  },
  {
    label: 'Computer Ware India Pvt Ltd',
    value: 5082,
  },
  {
    label: 'ComUnus Technologies Pvt Ltd',
    value: 5083,
  },
  {
    label: 'Concerto Software and Systems',
    value: 5084,
  },
  {
    label: 'Conde Nast',
    value: 5085,
  },
  {
    label: 'Conscious Foundation',
    value: 5086,
  },
  {
    label: 'Contec Global',
    value: 5087,
  },
  {
    label: 'Contemporary Connect',
    value: 5088,
  },
  {
    label: 'Contify',
    value: 5089,
  },
  {
    label: 'Coozmoo',
    value: 5090,
  },
  {
    label: 'Adnaks Marketing Solutions Pvt Ltd',
    value: 5091,
  },
  {
    label: 'Corporate Coders',
    value: 5092,
  },
  {
    label: 'Costrategix Technologies',
    value: 5093,
  },
  {
    label: 'COUTLOOT',
    value: 5094,
  },
  {
    label: 'Clarigo Infotech Private Limited',
    value: 5095,
  },
  {
    label: 'classEngage',
    value: 5096,
  },
  {
    label: 'Classpro',
    value: 5097,
  },
  {
    label: 'Cleartax',
    value: 5098,
  },
  {
    label: 'Clematis Software Technologies Pvt. Ltd',
    value: 5099,
  },
  {
    label: 'Clickscient',
    value: 5100,
  },
  {
    label: 'Client Associates',
    value: 5101,
  },
  {
    label: 'Clinton Health Access',
    value: 5102,
  },
  {
    label: 'clockwork',
    value: 5103,
  },
  {
    label: 'CloudConnect Communications Pvt. Ltd.',
    value: 5104,
  },
  {
    label: 'Icon Technocluoud Pvt. Ltd.',
    value: 5105,
  },
  {
    label: 'Cloudblocks',
    value: 5106,
  },
  {
    label: 'Cloudera',
    value: 5107,
  },
  {
    label: 'Cloudesign Technology',
    value: 5108,
  },
  {
    label: 'Cloudester Software LLP',
    value: 5109,
  },
  {
    label: 'Cloudgenix',
    value: 5110,
  },
  {
    label: 'CloudThing',
    value: 5111,
  },
  {
    label: 'Cloudwick',
    value: 5112,
  },
  {
    label: 'Clover It Services',
    value: 5113,
  },
  {
    label: 'Codalien Technologies Pvt. Ltd.',
    value: 5114,
  },
  {
    label: 'Code Brew Labs',
    value: 5115,
  },
  {
    label: 'Code Corners',
    value: 5116,
  },
  {
    label: 'CodeGama',
    value: 5117,
  },
  {
    label: 'Codilar Technologies',
    value: 5118,
  },
  {
    label: 'Coditas technology pvt.ltd.',
    value: 5119,
  },
  {
    label: 'Coviam Technologies Pvt. Ltd',
    value: 5120,
  },
  {
    label: 'Cratas Techno Solutions Pvt Ltd',
    value: 5121,
  },
  {
    label: 'Credit Fair',
    value: 5122,
  },
  {
    label: 'CredRight',
    value: 5123,
  },
  {
    label: 'Creospan Solutions Pvt Ltd',
    value: 5124,
  },
  {
    label: 'Cricbuzz',
    value: 5125,
  },
  {
    label: 'Crimson Interactive Pvt Ltd',
    value: 5126,
  },
  {
    label: 'CRMNEXT',
    value: 5127,
  },
  {
    label: 'Crowd Analytix',
    value: 5128,
  },
  {
    label: 'Curxoid IT Solutions',
    value: 5129,
  },
  {
    label: 'Madhatters Infocom Pvt. Ltd.',
    value: 5130,
  },
  {
    label: 'Cornerstone On Demand',
    value: 5131,
  },
  {
    label: 'CS Tech Infosolutions Private Limited',
    value: 5132,
  },
  {
    label: 'Cubedots Pvt Ltd',
    value: 5133,
  },
  {
    label: 'Parity Cube Pvt. Ltd.',
    value: 5134,
  },
  {
    label: 'Cuelearn Private Limited',
    value: 5135,
  },
  {
    label: 'CuneSoft',
    value: 5136,
  },
  {
    label: 'CUNIX Infotech',
    value: 5137,
  },
  {
    label: 'CWS',
    value: 5138,
  },
  {
    label: 'Cybage',
    value: 5139,
  },
  {
    label: 'Cyberdesign India Pvt Ltd',
    value: 5140,
  },
  {
    label: 'Cyber Matrix Solutions Pvt Ltd',
    value: 5141,
  },
  {
    label: 'Cybernext Private Limited',
    value: 5142,
  },
  {
    label: 'Cymetrix Software',
    value: 5143,
  },
  {
    label: 'Cynapto Technologies Pvt. Ltd.',
    value: 5144,
  },
  {
    label: 'Devoint IT Solutions',
    value: 5145,
  },
  {
    label: 'Dev Accelarator LLP',
    value: 5146,
  },
  {
    label: 'Deshpande Foundation',
    value: 5147,
  },
  {
    label: 'Dgraph',
    value: 5148,
  },
  {
    label: 'Digital Harbor Pvt Ltd',
    value: 5149,
  },
  {
    label: 'Dhwani Rural Information Systems',
    value: 5150,
  },
  {
    label: 'Digital Impressions',
    value: 5151,
  },
  {
    label: 'DianApps',
    value: 5152,
  },
  {
    label: 'Diatoz Solutions Private Limited',
    value: 5153,
  },
  {
    label: 'Digicorp Information Systems Pvt.Ltd',
    value: 5154,
  },
  {
    label: 'Lantern Digital Services Pvt. Ltd.',
    value: 5155,
  },
  {
    label: 'Digital Horizons',
    value: 5156,
  },
  {
    label: 'DigiValet',
    value: 5157,
  },
  {
    label: 'Dirtcube Interactive',
    value: 5158,
  },
  {
    label: 'NLB Services Pvt.Ltd',
    value: 5159,
  },
  {
    label: 'Dynamic Netsoft Technologies',
    value: 5160,
  },
  {
    label: 'Epic Television',
    value: 5161,
  },
  {
    label: 'Dolat Capital Market Pvt Ltd',
    value: 5162,
  },
  {
    label: 'Donatekart',
    value: 5163,
  },
  {
    label: 'Dot1 Solutions',
    value: 5164,
  },
  {
    label: 'Dotsquares Technologies',
    value: 5165,
  },
  {
    label: 'DOT Technologies',
    value: 5166,
  },
  {
    label: 'Dongre Technoquip',
    value: 5167,
  },
  {
    label: 'Dr. Agarwal Group of Eye Hospitals',
    value: 5168,
  },
  {
    label: 'DreamSol TeleSolutions Pvt. Ltd.',
    value: 5169,
  },
  {
    label: 'Cyphware Infotech Private Limited',
    value: 5170,
  },
  {
    label: 'Daphnis Labs',
    value: 5171,
  },
  {
    label: 'Darwinbox Digital Solutions Pvt Ltd',
    value: 5172,
  },
  {
    label: 'Datacomp Web Technologies Pvt Ltd',
    value: 5173,
  },
  {
    label: 'Datanetiix Solutions Inc',
    value: 5174,
  },
  {
    label: 'DataToBiz',
    value: 5175,
  },
  {
    label: 'DatAvail Infotech',
    value: 5176,
  },
  {
    label: 'Dataweave Software',
    value: 5177,
  },
  {
    label: 'Datazymes',
    value: 5178,
  },
  {
    label: 'DDN Storage',
    value: 5179,
  },
  {
    label: 'Dealersocket Inc',
    value: 5180,
  },
  {
    label: 'Debut Infotech',
    value: 5181,
  },
  {
    label: 'Debut Infotech Pvt. Ltd.',
    value: 5182,
  },
  {
    label: 'Decathlon UK',
    value: 5183,
  },
  {
    label: 'Deccan Herald',
    value: 5184,
  },
  {
    label: 'Decimal Technologies Pvt. Ltd.',
    value: 5185,
  },
  {
    label: 'Decisionattic',
    value: 5186,
  },
  {
    label: 'Deck Rooster',
    value: 5187,
  },
  {
    label: 'CI Infotech pvt ltd',
    value: 5188,
  },
  {
    label: 'Delta Step Learning (P) Ltd',
    value: 5189,
  },
  {
    label: 'Delta Tech Pvt. Ltd.',
    value: 5190,
  },
  {
    label: 'Denave',
    value: 5191,
  },
  {
    label: 'Dentsu Aegis Network India Pvt Ltd',
    value: 5192,
  },
  {
    label: 'Devin Labs',
    value: 5193,
  },
  {
    label: 'Devkraft Technologies',
    value: 5194,
  },
  {
    label: 'DronaMaps Pvt. Ltd.',
    value: 5195,
  },
  {
    label: 'Dron Study Pvt. Ltd.',
    value: 5196,
  },
  {
    label: 'Droom Technology (P) Ltd',
    value: 5197,
  },
  {
    label: 'Dr. Reddys Foundation',
    value: 5198,
  },
  {
    label: 'Travel Khana',
    value: 5199,
  },
  {
    label: 'Dvara Solutions Pvt Ltd',
    value: 5200,
  },
  {
    label: 'dWise Solutions & Services Pvt Ltd',
    value: 5201,
  },
  {
    label: 'DxMinds Innovation Labs Pvt Ltd',
    value: 5202,
  },
  {
    label: 'Surajya Services Pvt. Ltd. (EasyGov)',
    value: 5203,
  },
  {
    label: 'Easypolicy.com',
    value: 5204,
  },
  {
    label: 'EazyDiner Pvt. Ltd.',
    value: 5205,
  },
  {
    label: 'Ebix Software India Pvt Ltd',
    value: 5206,
  },
  {
    label: 'ecoRise Software Solutions',
    value: 5207,
  },
  {
    label: 'EdgeVerve',
    value: 5208,
  },
  {
    label: 'Eduonix Learning Solutions Pvt Ltd',
    value: 5209,
  },
  {
    label: 'Edureify',
    value: 5210,
  },
  {
    label: 'Edureka',
    value: 5211,
  },
  {
    label: 'edWisor.com',
    value: 5212,
  },
  {
    label: 'Egon Zehnder - Knowledge Center India',
    value: 5213,
  },
  {
    label: 'Enable Healthcare Inc.',
    value: 5214,
  },
  {
    label: 'Einfach Business Analytics Pvt. Ltd',
    value: 5215,
  },
  {
    label: 'Eli India',
    value: 5216,
  },
  {
    label: 'EliteSigma Infotech',
    value: 5217,
  },
  {
    label: 'Emagine People Solution',
    value: 5218,
  },
  {
    label: 'Emgage Inc',
    value: 5219,
  },
  {
    label: 'EMIAC Technologies',
    value: 5220,
  },
  {
    label: 'Emipro Technologies',
    value: 5221,
  },
  {
    label: 'Emplay',
    value: 5222,
  },
  {
    label: 'Employee Experts Solutions Pvt Ltd',
    value: 5223,
  },
  {
    label: 'Endurance International Group',
    value: 5224,
  },
  {
    label: 'Energos Technologies Pvt Ltd',
    value: 5225,
  },
  {
    label: 'Energytech Global',
    value: 5226,
  },
  {
    label: 'Enfusion',
    value: 5227,
  },
  {
    label: 'Engenia Technologies',
    value: 5228,
  },
  {
    label: 'EnKash (Nehat Tech Solutions Pvt. Ltd.)',
    value: 5229,
  },
  {
    label: 'Enqos Software Technologies Pvt Ltd',
    value: 5230,
  },
  {
    label: 'Enter Pi',
    value: 5231,
  },
  {
    label: 'Enterprise Bot Private Limited',
    value: 5232,
  },
  {
    label: 'Enthralltech',
    value: 5233,
  },
  {
    label: 'Enthuons',
    value: 5234,
  },
  {
    label: 'Enwidth Technologies',
    value: 5235,
  },
  {
    label: 'Enzen',
    value: 5236,
  },
  {
    label: 'Erginous',
    value: 5237,
  },
  {
    label: 'Eros International Media Ltd.',
    value: 5238,
  },
  {
    label: 'Eruvaka Technologies',
    value: 5239,
  },
  {
    label: 'ESKO Graphics India Pvt Ltd',
    value: 5240,
  },
  {
    label: 'eStomi Technologies',
    value: 5241,
  },
  {
    label: 'Esythink Solutions Pvt Ltd',
    value: 5242,
  },
  {
    label: 'eTeam info services',
    value: 5243,
  },
  {
    label: 'Etech Global Services',
    value: 5244,
  },
  {
    label: 'eVidyaloka',
    value: 5245,
  },
  {
    label: 'Information Technology and Services',
    value: 5246,
  },
  {
    label: 'La Exactlly Software Pvt Ltd',
    value: 5247,
  },
  {
    label: 'Examly Inc',
    value: 5248,
  },
  {
    label: 'Excel Soft Services (I) Pvt. Ltd.',
    value: 5249,
  },
  {
    label: 'Exeter Premedia Services Private Limtied',
    value: 5250,
  },
  {
    label: 'Expedien',
    value: 5251,
  },
  {
    label: 'Experion Technologies',
    value: 5252,
  },
  {
    label: 'Religare Health Insurance Company',
    value: 5253,
  },
  {
    label: 'ezDI LLP',
    value: 5254,
  },
  {
    label: 'FabHotels',
    value: 5255,
  },
  {
    label: "Women's Apparel eCommerce startup",
    value: 5256,
  },
  {
    label: 'Fabric Monde',
    value: 5257,
  },
  {
    label: 'Facile Consulting Pvt Ltd',
    value: 5258,
  },
  {
    label: 'Falabella',
    value: 5259,
  },
  {
    label: 'Fame Technologies',
    value: 5260,
  },
  {
    label: 'FanCode (Dream11)',
    value: 5261,
  },
  {
    label: 'Farida Gupta Retails Pvt. Ltd.',
    value: 5262,
  },
  {
    label: 'Fi Ellements',
    value: 5263,
  },
  {
    label: 'Filmboard Movies Pvt. Ltd.',
    value: 5264,
  },
  {
    label: 'FININ',
    value: 5265,
  },
  {
    label: 'Finly',
    value: 5266,
  },
  {
    label: 'Fino Payments Bank Ltd',
    value: 5267,
  },
  {
    label: 'Finshots',
    value: 5268,
  },
  {
    label: 'FinvestFx Pvt. Ltd.',
    value: 5269,
  },
  {
    label: 'Finxera',
    value: 5270,
  },
  {
    label: 'FirstForce Technologies Pvt Ltd',
    value: 5271,
  },
  {
    label: 'Finwizard Technology Pvt. Ltd.',
    value: 5272,
  },
  {
    label: 'Grip Technologies Pvt Ltd',
    value: 5273,
  },
  {
    label: 'Fitternity',
    value: 5274,
  },
  {
    label: 'Flendzz Technologies (P) Ltd',
    value: 5275,
  },
  {
    label: 'Flexiloans Pvt. Ltd.',
    value: 5276,
  },
  {
    label: 'Flexsin Technology',
    value: 5277,
  },
  {
    label: 'Fliplearn Education Pvt Ltd',
    value: 5278,
  },
  {
    label: 'FlixStock',
    value: 5279,
  },
  {
    label: 'Zupe Technology',
    value: 5280,
  },
  {
    label: 'Flock',
    value: 5281,
  },
  {
    label: 'Flymedia Technology',
    value: 5282,
  },
  {
    label: 'Ferns n Petals',
    value: 5283,
  },
  {
    label: 'Fork Media Pvt Ltd',
    value: 5284,
  },
  {
    label: 'Fork Media Group',
    value: 5285,
  },
  {
    label: 'Fracsn Inc',
    value: 5286,
  },
  {
    label: 'FranConnect Software',
    value: 5287,
  },
  {
    label: 'Franolaxy Consulting Pvt Ltd',
    value: 5288,
  },
  {
    label: 'FRETRON',
    value: 5289,
  },
  {
    label: 'Froiden Technologies Pvt Ltd',
    value: 5290,
  },
  {
    label: 'Fruitfal',
    value: 5291,
  },
  {
    label: 'Nomisma Mobile Solutions',
    value: 5292,
  },
  {
    label: 'Friend Sourcing Pvt Ltd',
    value: 5293,
  },
  {
    label: 'Times Internet - Gaana',
    value: 5294,
  },
  {
    label: 'Galentic Technologies Private Limited',
    value: 5295,
  },
  {
    label: 'Galo.io',
    value: 5296,
  },
  {
    label: 'GamingMonk Entertainment Pvt Ltd.',
    value: 5297,
  },
  {
    label: 'Gamooga',
    value: 5298,
  },
  {
    label: 'Ganit Business Solutions',
    value: 5299,
  },
  {
    label: 'Gazity',
    value: 5300,
  },
  {
    label: 'GCR Cloud',
    value: 5301,
  },
  {
    label: 'GDI',
    value: 5302,
  },
  {
    label: 'GeekyWorks IT Solutions',
    value: 5303,
  },
  {
    label: 'Golden Eagle IT Technologies Pvt Ltd.',
    value: 5304,
  },
  {
    label: 'Government e Marketplace',
    value: 5305,
  },
  {
    label: 'GeniusU Web Services Pvt Ltd',
    value: 5306,
  },
  {
    label: 'GenY Medium',
    value: 5307,
  },
  {
    label: 'GeoIQ',
    value: 5308,
  },
  {
    label: 'Astra',
    value: 5309,
  },
  {
    label: 'FarEye',
    value: 5310,
  },
  {
    label: 'Instacash',
    value: 5311,
  },
  {
    label: 'Get My Parking',
    value: 5312,
  },
  {
    label: 'GetMyuni',
    value: 5313,
  },
  {
    label: 'Geton Infotech Pvt Ltd',
    value: 5314,
  },
  {
    label: 'Get Your Solutions',
    value: 5315,
  },
  {
    label: 'Giftiicon',
    value: 5316,
  },
  {
    label: 'Gilbarco Veeder Root',
    value: 5317,
  },
  {
    label: 'DEWI',
    value: 5318,
  },
  {
    label: 'Glam Studios',
    value: 5319,
  },
  {
    label: 'Glaucus Supply Chain Solutions',
    value: 5320,
  },
  {
    label: 'GLEAC',
    value: 5321,
  },
  {
    label: 'Global Best HR Consulting',
    value: 5322,
  },
  {
    label: 'Global Energy Pvt. Ltd.',
    value: 5323,
  },
  {
    label: 'Global Gene Corp Pvt. Ltd.',
    value: 5324,
  },
  {
    label: 'GlobalGyan Academy of Management Education',
    value: 5325,
  },
  {
    label: 'G N Solutions Pvt. Ltd.',
    value: 5326,
  },
  {
    label: 'Global Talent Corner',
    value: 5327,
  },
  {
    label: 'GlobalXperts Technology Pvt. Ltd.',
    value: 5328,
  },
  {
    label: 'Globocom',
    value: 5329,
  },
  {
    label: 'Glocify Technologies Pvt Ltd',
    value: 5330,
  },
  {
    label: 'Glossaread',
    value: 5331,
  },
  {
    label: 'Global Market Insights',
    value: 5332,
  },
  {
    label: 'GM WARE',
    value: 5333,
  },
  {
    label: 'Goals101 Data Solutions Pvt Ltd',
    value: 5334,
  },
  {
    label: 'Gocloudz',
    value: 5335,
  },
  {
    label: 'GG Online Pvt Ltd',
    value: 5336,
  },
  {
    label: 'Gogo India LLP',
    value: 5337,
  },
  {
    label: 'Golden Hills Capital',
    value: 5338,
  },
  {
    label: 'GoldUno',
    value: 5339,
  },
  {
    label: 'GoldVIP Technology Solutions Pvt. Ltd.',
    value: 5340,
  },
  {
    label: 'GOLS',
    value: 5341,
  },
  {
    label: 'GO MO Group',
    value: 5342,
  },
  {
    label: 'Goodera',
    value: 5343,
  },
  {
    label: 'GoPaisa Netventures Pvt Ltd',
    value: 5344,
  },
  {
    label: 'Goteso',
    value: 5345,
  },
  {
    label: 'Grab a Grub Services Pvt. Ltd',
    value: 5346,
  },
  {
    label: 'Graffersid',
    value: 5347,
  },
  {
    label: 'Gram Power',
    value: 5348,
  },
  {
    label: 'Gramtarang Technologies',
    value: 5349,
  },
  {
    label: 'Gray Routes',
    value: 5350,
  },
  {
    label: 'Greentech ITS',
    value: 5351,
  },
  {
    label: 'Grexter Living',
    value: 5352,
  },
  {
    label: 'Greyflex HR Consulting Services Private Limited',
    value: 5353,
  },
  {
    label: 'Grofers',
    value: 5354,
  },
  {
    label: 'Growisto',
    value: 5355,
  },
  {
    label: 'My Phygital Cafe Pvt. Ltd.',
    value: 5356,
  },
  {
    label: 'GSA Techworld',
    value: 5357,
  },
  {
    label: 'Ginesys',
    value: 5358,
  },
  {
    label: 'GSPANN Technologies',
    value: 5359,
  },
  {
    label: 'Gunaatita Technology',
    value: 5360,
  },
  {
    label: 'GyanMatrix Technologies Pvt. Ltd.',
    value: 5361,
  },
  {
    label: 'Hamon Technologies',
    value: 5362,
  },
  {
    label: 'Happily Unmarried',
    value: 5363,
  },
  {
    label: 'Hari Om Web Pvt Ltd',
    value: 5364,
  },
  {
    label: 'Harmony Data Integration Technologies Pvt. Ltd.',
    value: 5365,
  },
  {
    label: 'HashStudioz Technologies Private Limited',
    value: 5366,
  },
  {
    label: 'Headout',
    value: 5367,
  },
  {
    label: 'Headstream Technologies Pvt Ltd',
    value: 5368,
  },
  {
    label: 'Headway.ai - Altruistik Consulting Pvt Ltd',
    value: 5369,
  },
  {
    label: 'Healofy',
    value: 5370,
  },
  {
    label: 'Healthgenie India Pvt Ltd',
    value: 5371,
  },
  {
    label: 'Healthians',
    value: 5372,
  },
  {
    label: 'HealthifyMe',
    value: 5373,
  },
  {
    label: 'Herman Miller',
    value: 5374,
  },
  {
    label: 'Hevo Data',
    value: 5375,
  },
  {
    label: 'Stack Network Ltd.',
    value: 5376,
  },
  {
    label: 'High Digital Limited',
    value: 5377,
  },
  {
    label: 'High Finch Global',
    value: 5378,
  },
  {
    label: 'HireaJackal',
    value: 5379,
  },
  {
    label: 'Hitachi MGRM Net Ltd.',
    value: 5380,
  },
  {
    label: 'Hitch Biker',
    value: 5381,
  },
  {
    label: 'Hitwicket Digital',
    value: 5382,
  },
  {
    label: 'Arque Tech',
    value: 5383,
  },
  {
    label: 'HnS Technologies Pvt Ltd',
    value: 5384,
  },
  {
    label: 'Home Capital',
    value: 5385,
  },
  {
    label: 'Home Credit',
    value: 5386,
  },
  {
    label: 'Honeycomb Creative Support Pvt Ltd',
    value: 5387,
  },
  {
    label: 'Hopscotch Health',
    value: 5388,
  },
  {
    label: 'Hossip',
    value: 5389,
  },
  {
    label: 'HotWax Systems Pvt. Ltd',
    value: 5390,
  },
  {
    label: 'HPS Lab Designs',
    value: 5391,
  },
  {
    label: 'Hope Research Group',
    value: 5392,
  },
  {
    label: 'Hughes Systique Corporation',
    value: 5393,
  },
  {
    label: 'Hard Shell Technologies Pvt. Ltd.',
    value: 5394,
  },
  {
    label: 'HTC Global Services',
    value: 5395,
  },
  {
    label: 'Hubilo',
    value: 5396,
  },
  {
    label: 'Humana Financial Services Pvt Ltd',
    value: 5397,
  },
  {
    label: 'HummingWave Technologies',
    value: 5398,
  },
  {
    label: 'Hunt&Badge',
    value: 5399,
  },
  {
    label: 'Darts India Pvt Ltd',
    value: 5400,
  },
  {
    label: 'iweb Services',
    value: 5401,
  },
  {
    label: 'i2e Consulting Pvt Ltd',
    value: 5402,
  },
  {
    label: 'i3systems Pvt Ltd',
    value: 5403,
  },
  {
    label: 'iAastha',
    value: 5404,
  },
  {
    label: 'IBI Group',
    value: 5405,
  },
  {
    label: 'Ice Cream Labs',
    value: 5406,
  },
  {
    label: 'iSec Services Pvt Ltd',
    value: 5407,
  },
  {
    label: 'Icicle Technologies',
    value: 5408,
  },
  {
    label: 'Intech Creative Services Pvt. Ltd.',
    value: 5409,
  },
  {
    label: 'iCubes',
    value: 5410,
  },
  {
    label: 'Ideadunes',
    value: 5411,
  },
  {
    label: 'Ideapoke',
    value: 5412,
  },
  {
    label: 'IDeepeners Pvt Ltd',
    value: 5413,
  },
  {
    label: 'Ideus Concepts',
    value: 5414,
  },
  {
    label: 'Institute of Informatics and Communication(IIC)',
    value: 5415,
  },
  {
    label: 'iii Consulting Pvt. Ltd.',
    value: 5416,
  },
  {
    label: 'ONN Bikes',
    value: 5417,
  },
  {
    label: 'iKart Solutions LLP',
    value: 5418,
  },
  {
    label: 'iLeaf Technology Solutions',
    value: 5419,
  },
  {
    label: 'Illumine',
    value: 5420,
  },
  {
    label: 'ILM UX Pvt Ltd',
    value: 5421,
  },
  {
    label: 'IMMO Technologies UK',
    value: 5422,
  },
  {
    label: 'Imobigeeks Software Technologies Pvt Ltd.',
    value: 5423,
  },
  {
    label: 'Impact Analytics',
    value: 5424,
  },
  {
    label: 'SMBC',
    value: 5425,
  },
  {
    label: 'Incedo Technology',
    value: 5426,
  },
  {
    label: 'Incrementors Web Solutions Pvt. Ltd.',
    value: 5427,
  },
  {
    label: 'Indegene',
    value: 5428,
  },
  {
    label: 'Indepay Networks',
    value: 5429,
  },
  {
    label: 'Indi.com',
    value: 5430,
  },
  {
    label: 'IndiaLends',
    value: 5431,
  },
  {
    label: 'Indian PAC Consulting Pvt Ltd',
    value: 5432,
  },
  {
    label: 'IndiHire',
    value: 5433,
  },
  {
    label: 'Indo Sakura Software Pvt Ltd',
    value: 5434,
  },
  {
    label: 'Indutech',
    value: 5435,
  },
  {
    label: 'iNest Web Pvt. Ltd',
    value: 5436,
  },
  {
    label: 'Infilect',
    value: 5437,
  },
  {
    label: 'Infinite Computing Systems Pvt Ltd',
    value: 5438,
  },
  {
    label: 'Infisuite Technologies LLP',
    value: 5439,
  },
  {
    label: 'Infobip',
    value: 5440,
  },
  {
    label: 'Infochola Solutions India Pvt Ltd',
    value: 5441,
  },
  {
    label: 'Infodesk India Pvt Ltd',
    value: 5442,
  },
  {
    label: 'Infoobjects',
    value: 5443,
  },
  {
    label: 'InfoSmart Systems Inc',
    value: 5444,
  },
  {
    label: 'Infospoke Technologies',
    value: 5445,
  },
  {
    label: 'Noesys Software Pvt. Ltd',
    value: 5446,
  },
  {
    label: 'Infoverb',
    value: 5447,
  },
  {
    label: 'Infratab Bangalore Pvt Ltd',
    value: 5448,
  },
  {
    label: 'Ingenuity Gaming',
    value: 5449,
  },
  {
    label: 'InnData Analytics Pvt Ltd',
    value: 5450,
  },
  {
    label: 'Innefu Labs Pvt. Ltd.',
    value: 5451,
  },
  {
    label: 'Innobox Systems Pvt Ltd',
    value: 5452,
  },
  {
    label: 'Open Play',
    value: 5453,
  },
  {
    label: 'innoviti',
    value: 5454,
  },
  {
    label: 'INSAID | FullStack Education Pvt. Ltd.',
    value: 5455,
  },
  {
    label: 'Paytm Insider',
    value: 5456,
  },
  {
    label: 'InsightCrew Technologies',
    value: 5457,
  },
  {
    label: 'Insight Business Machines Pvt.',
    value: 5458,
  },
  {
    label: 'Inspeero Technologies',
    value: 5459,
  },
  {
    label: 'Intain Technologies',
    value: 5460,
  },
  {
    label: 'integrichain',
    value: 5461,
  },
  {
    label: 'Intellectyx',
    value: 5462,
  },
  {
    label: 'Intello Labs Private Limited',
    value: 5463,
  },
  {
    label: 'Intentico',
    value: 5464,
  },
  {
    label: 'Interactive Brokers INDIA',
    value: 5465,
  },
  {
    label: 'Interbind Technologies Pvt Ltd',
    value: 5466,
  },
  {
    label: 'interface.ai',
    value: 5467,
  },
  {
    label: 'Intigate Technology Pvt. Ltd.',
    value: 5468,
  },
  {
    label: 'Mount Talent Consulting Pvt Ltd.',
    value: 5469,
  },
  {
    label: 'Intone Networks',
    value: 5470,
  },
  {
    label: 'Intugine Technologies',
    value: 5471,
  },
  {
    label: 'IMC Group',
    value: 5472,
  },
  {
    label: 'Invensis Technologies (P) Ltd',
    value: 5473,
  },
  {
    label: 'Inventec Systems Pvt Ltd',
    value: 5474,
  },
  {
    label: 'Invent Softlabs',
    value: 5475,
  },
  {
    label: 'Kristal.AI',
    value: 5476,
  },
  {
    label: 'Excel Net Solutions Pvt. Ltd.',
    value: 5477,
  },
  {
    label: 'Invictus DigiSoft Pvt. Ltd.',
    value: 5478,
  },
  {
    label: 'IoTian Technologies Pvt. Ltd.',
    value: 5479,
  },
  {
    label: 'iPrism Technologies',
    value: 5480,
  },
  {
    label: 'Iquanti Pvt. Ltd.',
    value: 5481,
  },
  {
    label: 'iRageCapital Advisory Pvt. Ltd.',
    value: 5482,
  },
  {
    label: 'Iris Software',
    value: 5483,
  },
  {
    label: 'ISHIR',
    value: 5484,
  },
  {
    label: 'ISITCA',
    value: 5485,
  },
  {
    label: 'Isprava Hospitality Pvt. Ltd.',
    value: 5486,
  },
  {
    label: 'ITechServ',
    value: 5487,
  },
  {
    label: 'Data Labs',
    value: 5488,
  },
  {
    label: 'ITH Technologies pvt.ltd',
    value: 5489,
  },
  {
    label: 'Itilite',
    value: 5490,
  },
  {
    label: 'IT Mantra TechIntellect Pvt.Ltd.',
    value: 5491,
  },
  {
    label: 'iTransparity Online LLP',
    value: 5492,
  },
  {
    label: 'IVY Comptech',
    value: 5493,
  },
  {
    label: 'Jana Care',
    value: 5494,
  },
  {
    label: 'Janaspandana Software Solutions Pvt Ltd',
    value: 5495,
  },
  {
    label: 'Janya IT Technologies',
    value: 5496,
  },
  {
    label: 'JB Solutions',
    value: 5497,
  },
  {
    label: 'Jhatkaa.org',
    value: 5498,
  },
  {
    label:
      'Daboya Technologies Pvt Ltd (Formerly known as Jiffy Software Solutions)',
    value: 5499,
  },
  {
    label: 'Jini.guru',
    value: 5500,
  },
  {
    label: 'Jobsforher',
    value: 5501,
  },
  {
    label: 'JoinEight',
    value: 5502,
  },
  {
    label: 'JoshTalks',
    value: 5503,
  },
  {
    label: 'Josh Technology Group',
    value: 5504,
  },
  {
    label: 'Jungleworks',
    value: 5505,
  },
  {
    label: 'Justaddwater',
    value: 5506,
  },
  {
    label: 'Kaarya Consultancy',
    value: 5507,
  },
  {
    label: 'Kabra Logitech Pvt. Ltd',
    value: 5508,
  },
  {
    label: 'Kalajitha',
    value: 5509,
  },
  {
    label: 'Kale Logistics Solutions Pvt. Ltd.',
    value: 5510,
  },
  {
    label: 'Kalyx Infotech  Pvt Ltd',
    value: 5511,
  },
  {
    label: 'Kamikaze',
    value: 5512,
  },
  {
    label: 'Kantar',
    value: 5513,
  },
  {
    label: 'Karpaga ITech',
    value: 5514,
  },
  {
    label: 'Kartrocket',
    value: 5515,
  },
  {
    label: 'Kaspon Techworks Private Limited',
    value: 5516,
  },
  {
    label: 'Kastech Software Solutions',
    value: 5517,
  },
  {
    label: 'Katalyst Business Solution Pvt Ltd',
    value: 5518,
  },
  {
    label: 'Keenheads Technologies Pvt. Ltd.',
    value: 5519,
  },
  {
    label: 'Keka',
    value: 5520,
  },
  {
    label: 'Kenyt.AI',
    value: 5521,
  },
  {
    label: 'Kestone IMS Pvt Ltd',
    value: 5522,
  },
  {
    label: 'KiE Square Analytics',
    value: 5523,
  },
  {
    label: 'Founding Years Learning Solutions',
    value: 5524,
  },
  {
    label: 'KlearNow',
    value: 5525,
  },
  {
    label: 'Shobha Cards',
    value: 5526,
  },
  {
    label: 'Knight Fintech',
    value: 5527,
  },
  {
    label: 'Knowlarity Communications',
    value: 5528,
  },
  {
    label: 'Knowledge Foundry',
    value: 5529,
  },
  {
    label: 'Kompanions',
    value: 5530,
  },
  {
    label: 'Stockedge.com',
    value: 5531,
  },
  {
    label: 'Krinotek',
    value: 5532,
  },
  {
    label: 'Kritikal Solutions',
    value: 5533,
  },
  {
    label: 'Kvantum Marketing Insights Privated Limited',
    value: 5534,
  },
  {
    label: 'Kwanzoo Inc',
    value: 5535,
  },
  {
    label: 'Ladybird Web Solution Pvt Ltd',
    value: 5536,
  },
  {
    label: 'Language Curry',
    value: 5537,
  },
  {
    label: 'Launchpad App Development',
    value: 5538,
  },
  {
    label: 'Lawnics Technologies Pvt. Ltd',
    value: 5539,
  },
  {
    label: 'Leadics',
    value: 5540,
  },
  {
    label: 'Leaf Studios & Leaf Wearables',
    value: 5541,
  },
  {
    label: 'Lean Station',
    value: 5542,
  },
  {
    label: 'Learningmate Solutions Pvt LTD',
    value: 5543,
  },
  {
    label: 'LearnMall',
    value: 5544,
  },
  {
    label: 'Legistify',
    value: 5545,
  },
  {
    label: 'Leher.ai',
    value: 5546,
  },
  {
    label: 'Lepide Software',
    value: 5547,
  },
  {
    label: 'LetMeCall',
    value: 5548,
  },
  {
    label: 'Lets Service',
    value: 5549,
  },
  {
    label: 'Leuwint Technologies',
    value: 5550,
  },
  {
    label: 'Leverage Edu',
    value: 5551,
  },
  {
    label: 'Liberin Technologies',
    value: 5552,
  },
  {
    label: 'Liberty General Insurance',
    value: 5553,
  },
  {
    label: 'LinkEZ Technologies',
    value: 5554,
  },
  {
    label: 'Lirik Infotech',
    value: 5555,
  },
  {
    label: 'Lithion Power',
    value: 5556,
  },
  {
    label: 'Little Yellow Beetle Media Pvt. Ltd.',
    value: 5557,
  },
  {
    label: 'Lockated',
    value: 5558,
  },
  {
    label: 'Locofast',
    value: 5559,
  },
  {
    label: 'Logicode Inc.',
    value: 5560,
  },
  {
    label: 'Logicspice softwares',
    value: 5561,
  },
  {
    label: 'LogiNext',
    value: 5562,
  },
  {
    label: 'Lordshire',
    value: 5563,
  },
  {
    label: 'Losung E-Services Pvt. Ltd.',
    value: 5564,
  },
  {
    label: 'LotVue India LLP',
    value: 5565,
  },
  {
    label: 'Loyalty Prime',
    value: 5566,
  },
  {
    label: 'LUCID',
    value: 5567,
  },
  {
    label: 'Lucideus Technologies',
    value: 5568,
  },
  {
    label: 'Lumenci',
    value: 5569,
  },
  {
    label: 'Luutaa Technologies Pvt Ltd',
    value: 5570,
  },
  {
    label: 'Lyfboat Technologies Pvt Ltd',
    value: 5571,
  },
  {
    label: 'LYNK logistics',
    value: 5572,
  },
  {
    label: 'machwan',
    value: 5573,
  },
  {
    label: 'Assemblage Entertainment Pvt. Ltd.',
    value: 5574,
  },
  {
    label: 'Magic FinServ',
    value: 5575,
  },
  {
    label: 'Magicpin',
    value: 5576,
  },
  {
    label: 'Magus',
    value: 5577,
  },
  {
    label: 'Mamaearth',
    value: 5578,
  },
  {
    label: 'Manatec Electronics Pvt Ltd',
    value: 5579,
  },
  {
    label: 'Mansa Infotech Pvt Ltd',
    value: 5580,
  },
  {
    label: 'Manthan',
    value: 5581,
  },
  {
    label: 'Manya Education Pvt Ltd',
    value: 5582,
  },
  {
    label: 'TagTaste Foods Pvt. Limited',
    value: 5583,
  },
  {
    label: 'Marax AI',
    value: 5584,
  },
  {
    label: 'MARS Telecom Systems',
    value: 5585,
  },
  {
    label: 'Master Card',
    value: 5586,
  },
  {
    label: 'Masters India',
    value: 5587,
  },
  {
    label: 'Maxdigi Solutions',
    value: 5588,
  },
  {
    label: 'Mbsit Software Pvt Ltd',
    value: 5589,
  },
  {
    label: 'Meaww',
    value: 5590,
  },
  {
    label: 'Matrid Technologies',
    value: 5591,
  },
  {
    label: 'MediaAgility',
    value: 5592,
  },
  {
    label: 'Media Magic Technologies Pvt Ltd',
    value: 5593,
  },
  {
    label: 'Medinin Health Tech Pvt Ltd',
    value: 5594,
  },
  {
    label: 'Medlife',
    value: 5595,
  },
  {
    label: 'Medline India',
    value: 5596,
  },
  {
    label: 'Medocity',
    value: 5597,
  },
  {
    label: 'Meegaan Technologies',
    value: 5598,
  },
  {
    label: 'Meganexus India Pvt Ltd',
    value: 5599,
  },
  {
    label: 'Menlo Technologies',
    value: 5600,
  },
  {
    label: 'Mercados',
    value: 5601,
  },
  {
    label: 'Mercury Solutions Limited',
    value: 5602,
  },
  {
    label: 'Manipal Global Education Services Pvt Ltd',
    value: 5603,
  },
  {
    label: 'Meru Consultants and Technologies Private Limited',
    value: 5604,
  },
  {
    label: 'Mettl',
    value: 5605,
  },
  {
    label: 'Microware Computing & Consulting',
    value: 5606,
  },
  {
    label: 'Migoi Studios',
    value: 5607,
  },
  {
    label: 'Migrations World Pty Ltd',
    value: 5608,
  },
  {
    label: 'Milagrow HumanTech',
    value: 5609,
  },
  {
    label: 'Millipixels Interactive LLP',
    value: 5610,
  },
  {
    label: 'Mindbogglr',
    value: 5611,
  },
  {
    label: 'Mindcube Solutions',
    value: 5612,
  },
  {
    label: 'Mind Digital Group',
    value: 5613,
  },
  {
    label: 'Mindler Education Private Limited',
    value: 5614,
  },
  {
    label: 'Mindlinks Solutions',
    value: 5615,
  },
  {
    label: 'Mintex Technologies',
    value: 5616,
  },
  {
    label: 'Mintlogix',
    value: 5617,
  },
  {
    label: 'Miracle Software Systems',
    value: 5618,
  },
  {
    label: 'Mirasys India Pvt Ltd',
    value: 5619,
  },
  {
    label: 'Mirror Review Media and Tech',
    value: 5620,
  },
  {
    label: 'Miscos Technologies Pvt. Ltd.',
    value: 5621,
  },
  {
    label: 'Mithya Labs',
    value: 5622,
  },
  {
    label: 'MJB technologies LLP',
    value: 5623,
  },
  {
    label: 'JLT Group',
    value: 5624,
  },
  {
    label: 'MobCast Innovations Pvt Ltd',
    value: 5625,
  },
  {
    label: 'MoBiCo Comodo',
    value: 5626,
  },
  {
    label: 'Mobikasa Pvt Ltd',
    value: 5627,
  },
  {
    label: 'Mobikon',
    value: 5628,
  },
  {
    label: 'Mobisofttechnology India Pvt Ltd',
    value: 5629,
  },
  {
    label: 'Mobisy Technologies Pvt Ltd',
    value: 5630,
  },
  {
    label: 'Mobo Media',
    value: 5631,
  },
  {
    label: 'Mobolutions India Pvt Ltd',
    value: 5632,
  },
  {
    label: 'Modgen Solutions Pvt Ltd',
    value: 5633,
  },
  {
    label: 'Molecular Connections Pvt Ltd',
    value: 5634,
  },
  {
    label: 'MomentSnap',
    value: 5635,
  },
  {
    label: 'MondayMorning',
    value: 5636,
  },
  {
    label: 'Monotype Solutions India Pvt Ltd',
    value: 5637,
  },
  {
    label: 'Mozilor Technologies',
    value: 5638,
  },
  {
    label: 'Mobile Premier League',
    value: 5639,
  },
  {
    label: 'Mplussoft Technologies',
    value: 5640,
  },
  {
    label: 'MudraCircle.com',
    value: 5641,
  },
  {
    label: 'Qkopy Online Services Private Limited',
    value: 5642,
  },
  {
    label: 'Mvalu Technology Services Private Limited',
    value: 5643,
  },
  {
    label: 'Datawise',
    value: 5644,
  },
  {
    label: 'eWards',
    value: 5645,
  },
  {
    label: 'IDOS',
    value: 5646,
  },
  {
    label: 'Mylas Technology',
    value: 5647,
  },
  {
    label: 'My Finance Care Advisors Pvt. Ltd./ MyLoanCare',
    value: 5648,
  },
  {
    label: 'Mylo',
    value: 5649,
  },
  {
    label: 'MyOperator.co',
    value: 5650,
  },
  {
    label: 'MYSTIFLY',
    value: 5651,
  },
  {
    label: 'Nadsoft',
    value: 5652,
  },
  {
    label: 'Nalli Corporate',
    value: 5653,
  },
  {
    label: 'Naman Trading Company',
    value: 5654,
  },
  {
    label: 'HFN IT Services Pvt Ltd',
    value: 5655,
  },
  {
    label: 'Narvar',
    value: 5656,
  },
  {
    label: 'Nasdaq',
    value: 5657,
  },
  {
    label: 'Naskay Technology Pvt Ltd',
    value: 5658,
  },
  {
    label: 'Nation With Namo',
    value: 5659,
  },
  {
    label: 'Navia Life Care',
    value: 5660,
  },
  {
    label: 'NCrypted Technologies Pvt. Ltd',
    value: 5661,
  },
  {
    label: 'Cadentic',
    value: 5662,
  },
  {
    label: 'Near India',
    value: 5663,
  },
  {
    label: 'Neetable Technologies',
    value: 5664,
  },
  {
    label: 'Nerd Geek Lab',
    value: 5665,
  },
  {
    label: 'NetCom Learning',
    value: 5666,
  },
  {
    label: 'Nethues Technologies Pvt Ltd',
    value: 5667,
  },
  {
    label: 'Netlink Software Pvt td',
    value: 5668,
  },
  {
    label: 'Netmeds.com',
    value: 5669,
  },
  {
    label: 'Netoyed',
    value: 5670,
  },
  {
    label: 'Netrix LLC',
    value: 5671,
  },
  {
    label: 'Netsmartz Infotech',
    value: 5672,
  },
  {
    label: 'Network REDUX',
    value: 5673,
  },
  {
    label: 'Neutrinos',
    value: 5674,
  },
  {
    label: 'Neutrino Tech Systems',
    value: 5675,
  },
  {
    label: 'Asianet Digital',
    value: 5676,
  },
  {
    label: 'NewsBytes',
    value: 5677,
  },
  {
    label: 'NewsBytes App',
    value: 5678,
  },
  {
    label: 'Newt Global Consulting',
    value: 5679,
  },
  {
    label: 'Nexion Pro',
    value: 5680,
  },
  {
    label: 'NextGen Invent Corp',
    value: 5681,
  },
  {
    label: 'Increff',
    value: 5682,
  },
  {
    label: 'Nexgen Corporation',
    value: 5683,
  },
  {
    label: 'Noise',
    value: 5684,
  },
  {
    label: 'Nference.AI',
    value: 5685,
  },
  {
    label: 'Niksun India Pvt. Ltd',
    value: 5686,
  },
  {
    label: 'Nisa Global',
    value: 5687,
  },
  {
    label: 'NITS Solutions',
    value: 5688,
  },
  {
    label: 'Niyuj enterprise Software Solutions Pvt. Ltd.',
    value: 5689,
  },
  {
    label: 'Noduco',
    value: 5690,
  },
  {
    label: 'Noisy Lion',
    value: 5691,
  },
  {
    label: 'Nomadslab',
    value: 5692,
  },
  {
    label: 'Noon Academy',
    value: 5693,
  },
  {
    label: 'Noodle.ai',
    value: 5694,
  },
  {
    label: 'noon',
    value: 5695,
  },
  {
    label: 'NoPaperForms',
    value: 5696,
  },
  {
    label: 'Novateur Technologies',
    value: 5697,
  },
  {
    label: 'Novopay',
    value: 5698,
  },
  {
    label: 'Novopay Solutions',
    value: 5699,
  },
  {
    label: 'novotreeminds',
    value: 5700,
  },
  {
    label: 'NSEIT Ltd',
    value: 5701,
  },
  {
    label: 'Nuchange Informatics',
    value: 5702,
  },
  {
    label: 'NucleusTeq Consulting Pvt. Ltd.',
    value: 5703,
  },
  {
    label: 'Number Theory Software Pvt Ltd',
    value: 5704,
  },
  {
    label: 'Numino Labs',
    value: 5705,
  },
  {
    label: 'Imbuo Explorations Pvt. Ltd.',
    value: 5706,
  },
  {
    label: 'Nurtr',
    value: 5707,
  },
  {
    label: 'NutriTap Technologies Private Limited',
    value: 5708,
  },
  {
    label: 'Nuveda Learning',
    value: 5709,
  },
  {
    label: 'Nvest Solution',
    value: 5710,
  },
  {
    label: 'NymbleUp Solutions Pvt. Ltd.',
    value: 5711,
  },
  {
    label: 'O2one Labs',
    value: 5712,
  },
  {
    label: 'Oaknorth',
    value: 5713,
  },
  {
    label: 'Ocean Eagle Eye',
    value: 5714,
  },
  {
    label: 'oCode Technologies',
    value: 5715,
  },
  {
    label: 'Celliber Technologies Pvt Ltd (Octasic)',
    value: 5716,
  },
  {
    label: 'Octet Design Studio',
    value: 5717,
  },
  {
    label: 'Octro Inc',
    value: 5718,
  },
  {
    label: 'Odelite Solutions',
    value: 5719,
  },
  {
    label: 'Ojas Innovative Technologies Pvt Ltd',
    value: 5720,
  },
  {
    label: 'OMG Labs',
    value: 5721,
  },
  {
    label: 'Omnicuris',
    value: 5722,
  },
  {
    label: 'Ondot Systems',
    value: 5723,
  },
  {
    label: 'One Media InfoCreation Pvt Ltd',
    value: 5724,
  },
  {
    label: 'Rainbox Media',
    value: 5725,
  },
  {
    label: 'Oneture Technologies Private Limited',
    value: 5726,
  },
  {
    label: 'OnlineSales.ai',
    value: 5727,
  },
  {
    label: 'ODD',
    value: 5728,
  },
  {
    label: 'Open Futures',
    value: 5729,
  },
  {
    label: 'OpenSense Labs',
    value: 5730,
  },
  {
    label: 'OpenSource Technologies Pvt. Ltd.',
    value: 5731,
  },
  {
    label: 'OpsVeda Asia Private Limited',
    value: 5732,
  },
  {
    label: 'k12 Techno Service Pvt Lts',
    value: 5733,
  },
  {
    label: 'Origin Interactive',
    value: 5734,
  },
  {
    label: 'Orzota',
    value: 5735,
  },
  {
    label: 'Osmosys Software Solutions Pvt. Ltd.',
    value: 5736,
  },
  {
    label: 'Osource India pvt ltd',
    value: 5737,
  },
  {
    label: 'OSP Labs Pvt. Ltd',
    value: 5738,
  },
  {
    label: 'Osvin Web Solution',
    value: 5739,
  },
  {
    label: 'Otis',
    value: 5740,
  },
  {
    label: 'OTS Solutions',
    value: 5741,
  },
  {
    label: 'OurDesignz',
    value: 5742,
  },
  {
    label: 'Outdo Inc',
    value: 5743,
  },
  {
    label: 'Outline India',
    value: 5744,
  },
  {
    label: 'Outsized',
    value: 5745,
  },
  {
    label: 'Outworx Solutions Pvt. Ltd.',
    value: 5746,
  },
  {
    label: 'Pacific IT Consultant Pvt Ltd',
    value: 5747,
  },
  {
    label: 'Packshot India Pvt Ltd',
    value: 5748,
  },
  {
    label: 'Pairroxz Technology Pvt Ltd',
    value: 5749,
  },
  {
    label: 'Palpx Technologies Pvt Ltd',
    value: 5750,
  },
  {
    label: 'PanOrbit Services LLP',
    value: 5751,
  },
  {
    label: 'PaperPlane Design Solutions',
    value: 5752,
  },
  {
    label: 'Parakh Online Pvt. Ltd.',
    value: 5753,
  },
  {
    label: 'Paratus Systems',
    value: 5754,
  },
  {
    label: 'Shri Harini Media Ltd',
    value: 5755,
  },
  {
    label: 'Parkar Consulting',
    value: 5756,
  },
  {
    label: 'Part Analytics',
    value: 5757,
  },
  {
    label: 'Paststat',
    value: 5758,
  },
  {
    label: 'Pattem Foundation',
    value: 5759,
  },
  {
    label: 'Virob E-Commerce India Pvt. Ltd.',
    value: 5760,
  },
  {
    label: 'PayMate India',
    value: 5761,
  },
  {
    label: 'Nearby Technologies Pvt Ltd',
    value: 5762,
  },
  {
    label: 'PBO Plus Consulting Pvt Ltd',
    value: 5763,
  },
  {
    label: 'PCM',
    value: 5764,
  },
  {
    label: 'PcsInfinity',
    value: 5765,
  },
  {
    label: 'Sangam Smesco Pvt Ltd',
    value: 5766,
  },
  {
    label: 'Pearl Global Solutions',
    value: 5767,
  },
  {
    label: 'Pelatro Solutions',
    value: 5768,
  },
  {
    label: 'PeopleLink Unified Communications Pvt Ltd',
    value: 5769,
  },
  {
    label: 'PeopleOCity LLP',
    value: 5770,
  },
  {
    label: 'PeopleOne Technology',
    value: 5771,
  },
  {
    label: 'Perpule',
    value: 5772,
  },
  {
    label: 'Perspectico',
    value: 5773,
  },
  {
    label: 'PharmaACE Analytics',
    value: 5774,
  },
  {
    label: 'PhaseZero Ventures',
    value: 5775,
  },
  {
    label: 'Phi GRC AI',
    value: 5776,
  },
  {
    label: 'Phonon Communications Pvt. Ltd.',
    value: 5777,
  },
  {
    label: 'Pickright',
    value: 5778,
  },
  {
    label: 'pickrr.com',
    value: 5779,
  },
  {
    label: 'Pickyourtrail.com',
    value: 5780,
  },
  {
    label: 'PickZy Software Pvt. Ltd',
    value: 5781,
  },
  {
    label: 'Pi DATACENTERS',
    value: 5782,
  },
  {
    label: 'Pine Labs',
    value: 5783,
  },
  {
    label: 'PineSucceed',
    value: 5784,
  },
  {
    label: 'Pinkvilla Media Pvt Ltd',
    value: 5785,
  },
  {
    label: 'Pinnium',
    value: 5786,
  },
  {
    label: 'Pinstorm Technologies',
    value: 5787,
  },
  {
    label: 'Pixelvide',
    value: 5788,
  },
  {
    label: 'PixFirst',
    value: 5789,
  },
  {
    label: 'Planify',
    value: 5790,
  },
  {
    label: 'Playin App Technologies',
    value: 5791,
  },
  {
    label: 'Plot Labs Technologies Pvt Ltd',
    value: 5792,
  },
  {
    label: 'Plus91 Technologies Pvt Ltd',
    value: 5793,
  },
  {
    label: 'POPxo',
    value: 5794,
  },
  {
    label: 'Posidex',
    value: 5795,
  },
  {
    label: 'Posist Technologies Pvt. Ltd.',
    value: 5796,
  },
  {
    label: 'Skillizen Learning Solution Pvt. Ltd.',
    value: 5797,
  },
  {
    label: 'Power2SME Pvt. Ltd.',
    value: 5798,
  },
  {
    label: 'Powerweave Software Services',
    value: 5799,
  },
  {
    label: 'Prakat Solutions',
    value: 5800,
  },
  {
    label: 'Prasarnet Technologies',
    value: 5801,
  },
  {
    label: 'Prasarnet Consulting Services Pvt. Ltd.',
    value: 5802,
  },
  {
    label: 'PRDXN',
    value: 5803,
  },
  {
    label: 'Prime Edge',
    value: 5804,
  },
  {
    label: 'Primus',
    value: 5805,
  },
  {
    label: 'Pristyn Care',
    value: 5806,
  },
  {
    label: 'Procol',
    value: 5807,
  },
  {
    label: 'Prometteur Solutions Pvt. Ltd.',
    value: 5808,
  },
  {
    label: 'Proprofs',
    value: 5809,
  },
  {
    label: 'Protegrity',
    value: 5810,
  },
  {
    label: 'ScreenRoot',
    value: 5811,
  },
  {
    label: 'Prowess Enterprise India Pvt Ltd',
    value: 5812,
  },
  {
    label: 'PurpleMonks Technology Pvt Ltd',
    value: 5813,
  },
  {
    label: 'Pype',
    value: 5814,
  },
  {
    label: 'Qentelli Solutions',
    value: 5815,
  },
  {
    label: 'QFund',
    value: 5816,
  },
  {
    label: 'QS (Quacquarelli Symonds) India Pvt Ltd',
    value: 5817,
  },
  {
    label: 'Quadratic Insights Pvt.Ltd',
    value: 5818,
  },
  {
    label: 'Qualitykiosk',
    value: 5819,
  },
  {
    label: 'Quantinsti Quantitative Learning Pvt Ltd',
    value: 5820,
  },
  {
    label: 'Quantum Phinance Pvt. Ltd',
    value: 5821,
  },
  {
    label: 'Quick Ride',
    value: 5822,
  },
  {
    label: 'QuickSell',
    value: 5823,
  },
  {
    label: 'QuillHash Technologies Pvt. Ltd',
    value: 5824,
  },
  {
    label: 'Quotientica',
    value: 5825,
  },
  {
    label: 'Radisys India Pvt Ltd',
    value: 5826,
  },
  {
    label: 'RaiFox IT Consultancy Pvt. Ltd.',
    value: 5827,
  },
  {
    label: 'Railyatri.in',
    value: 5828,
  },
  {
    label: 'Raj Khanna Pty Ltd',
    value: 5829,
  },
  {
    label: 'Rakshan',
    value: 5830,
  },
  {
    label: 'Rakuten',
    value: 5831,
  },
  {
    label: 'RakVin Technologies Pvt.Ltd.',
    value: 5832,
  },
  {
    label: 'Raminfo Ltd',
    value: 5833,
  },
  {
    label: 'Rankz',
    value: 5834,
  },
  {
    label: 'Ratna Sagar Publications',
    value: 5835,
  },
  {
    label: 'Ratna Sagar Pvt Ltd',
    value: 5836,
  },
  {
    label: 'RAVSoft Solutions',
    value: 5837,
  },
  {
    label: 'Raxa Health Information Services Pvt Ltd',
    value: 5838,
  },
  {
    label: 'Raytex IT Services',
    value: 5839,
  },
  {
    label: 'Razorpay',
    value: 5840,
  },
  {
    label: 'Razorthink',
    value: 5841,
  },
  {
    label: 'ReachIvy (Reach Education Pvt. Ltd.)',
    value: 5842,
  },
  {
    label: 'Alliance Tech',
    value: 5843,
  },
  {
    label: 'Recenturesoft Infotech Pvt Ltd',
    value: 5844,
  },
  {
    label: 'Recruise India Consulting',
    value: 5845,
  },
  {
    label: 'Redef9Skills',
    value: 5846,
  },
  {
    label: 'Refrens.com',
    value: 5847,
  },
  {
    label: 'Reliance Games',
    value: 5848,
  },
  {
    label: 'Reltio',
    value: 5849,
  },
  {
    label: 'Remah IT',
    value: 5850,
  },
  {
    label: 'Rentomojo',
    value: 5851,
  },
  {
    label: 'Republic World',
    value: 5852,
  },
  {
    label: 'Reputation.com',
    value: 5853,
  },
  {
    label: 'Resource Yantra',
    value: 5854,
  },
  {
    label: 'Retranz Infolabs Pvt Ltd (SuperZop)',
    value: 5855,
  },
  {
    label: 'Revalsys Technologies',
    value: 5856,
  },
  {
    label: 'Revolux Solutions Pvt. Ltd.',
    value: 5857,
  },
  {
    label: 'Reward360',
    value: 5858,
  },
  {
    label: 'Ria Insurance',
    value: 5859,
  },
  {
    label: 'RIA',
    value: 5860,
  },
  {
    label: 'RIG Enterprise Applications (OnBlick)',
    value: 5861,
  },
  {
    label: 'Right Human Skills Pvt Ltd',
    value: 5862,
  },
  {
    label: 'Rite Infotech Pvt. Ltd.',
    value: 5863,
  },
  {
    label: 'Rivet Labs',
    value: 5864,
  },
  {
    label: 'RLogical Techsoft Pvt. Ltd.',
    value: 5865,
  },
  {
    label: 'RMgX',
    value: 5866,
  },
  {
    label: 'RnF Technologies',
    value: 5867,
  },
  {
    label: 'RNGplay',
    value: 5868,
  },
  {
    label: 'Rojgar Lab',
    value: 5869,
  },
  {
    label: 'Roviri Innovations Pvt Ltd (money91.com)',
    value: 5870,
  },
  {
    label: 'Rupeeredee',
    value: 5871,
  },
  {
    label: 'RV Matrix Software Technologies Pvt Ltd',
    value: 5872,
  },
  {
    label: 'Reed and Willow',
    value: 5873,
  },
  {
    label: 'RxAdvance PBM',
    value: 5874,
  },
  {
    label: 'Sabse Sasta Dukaan',
    value: 5875,
  },
  {
    label: 'Safexpay',
    value: 5876,
  },
  {
    label: 'Sagacito Technologies Private Limited',
    value: 5877,
  },
  {
    label: 'Sagarsoft India',
    value: 5878,
  },
  {
    label: 'SAGE Publication',
    value: 5879,
  },
  {
    label: 'EBSC Technologies',
    value: 5880,
  },
  {
    label: 'SalesHandy',
    value: 5881,
  },
  {
    label: 'Salt Side Technologies',
    value: 5882,
  },
  {
    label: 'Sampark Softwares',
    value: 5883,
  },
  {
    label: 'Sankey Solutions',
    value: 5884,
  },
  {
    label: 'Savaari Car Rentals',
    value: 5885,
  },
  {
    label: 'Savage & Palmer',
    value: 5886,
  },
  {
    label: 'SBI',
    value: 5887,
  },
  {
    label: 'Scalability Experts Solutions Pvt Ltd',
    value: 5888,
  },
  {
    label: 'Scaledesk Web Studio Pvt Ltd',
    value: 5889,
  },
  {
    label: 'Scandid',
    value: 5890,
  },
  {
    label: 'Schbang Digital Solutions',
    value: 5891,
  },
  {
    label: 'Schoolybooks.com',
    value: 5892,
  },
  {
    label: 'SIT Pvt. Ltd.',
    value: 5893,
  },
  {
    label: 'Scoutnex',
    value: 5894,
  },
  {
    label: 'Scry Analytics',
    value: 5895,
  },
  {
    label: 'Secret Technologies India',
    value: 5896,
  },
  {
    label: 'SecureNow Insurance Broker Pvt. Ltd.',
    value: 5897,
  },
  {
    label: 'Security Brigade InfoSec Pvt Ltd',
    value: 5898,
  },
  {
    label: 'Seehash Softwares Pvt. Ltd.',
    value: 5899,
  },
  {
    label: 'Seken Information Systems',
    value: 5900,
  },
  {
    label: 'SelectHub',
    value: 5901,
  },
  {
    label: 'Selekt.in',
    value: 5902,
  },
  {
    label: 'Selfhacked',
    value: 5903,
  },
  {
    label: 'Seniority',
    value: 5904,
  },
  {
    label: 'Sentieo',
    value: 5905,
  },
  {
    label: 'Service Lee Technologies Pvt Ltd',
    value: 5906,
  },
  {
    label: 'Servosys Solutions Pvt Ltd',
    value: 5907,
  },
  {
    label: 'Setlmint.Com',
    value: 5908,
  },
  {
    label: 'Seven Lakes Technologies',
    value: 5909,
  },
  {
    label: 'Sevenmentor pvt ltd',
    value: 5910,
  },
  {
    label: 'Shark Dreams',
    value: 5911,
  },
  {
    label: 'Shine Web Services',
    value: 5912,
  },
  {
    label: 'Shipgig Ventures Private Limited',
    value: 5913,
  },
  {
    label: 'SHL.com',
    value: 5914,
  },
  {
    label: 'Bijnis',
    value: 5915,
  },
  {
    label: 'Shopalyst Technologies',
    value: 5916,
  },
  {
    label: 'ShowMeLeads',
    value: 5917,
  },
  {
    label: 'Shraddha Enterprises',
    value: 5918,
  },
  {
    label: 'Blue Tie Global Pvt Ltd',
    value: 5919,
  },
  {
    label: 'Sigmoid Analytics',
    value: 5920,
  },
  {
    label: 'Signzy',
    value: 5921,
  },
  {
    label: 'Silvernox Tech Ventures',
    value: 5922,
  },
  {
    label: 'SimbaQuartz',
    value: 5923,
  },
  {
    label: 'Simpliance Technologies',
    value: 5924,
  },
  {
    label: 'Simplotel Technologies Pvt Ltd',
    value: 5925,
  },
  {
    label: 'Simply People',
    value: 5926,
  },
  {
    label: 'SixtyFour Data Intelligence LLP',
    value: 5927,
  },
  {
    label: 'Skugal Technologies Private Limited',
    value: 5928,
  },
  {
    label: 'Arrezzo Sky',
    value: 5929,
  },
  {
    label: 'SkyQuest Technology Consulting Pvt Ltd',
    value: 5930,
  },
  {
    label: 'SLAY Coffee',
    value: 5931,
  },
  {
    label: 'SmartConnect Technologies',
    value: 5932,
  },
  {
    label: 'Smart Cricket',
    value: 5933,
  },
  {
    label: 'SmartServ',
    value: 5934,
  },
  {
    label: 'smartShift Tech',
    value: 5935,
  },
  {
    label: 'SM Global',
    value: 5936,
  },
  {
    label: 'SoDelhi',
    value: 5937,
  },
  {
    label: 'Softcrylic',
    value: 5938,
  },
  {
    label: 'Softobiz Technologies Pvt. Ltd.',
    value: 5939,
  },
  {
    label: 'Soft One Global',
    value: 5940,
  },
  {
    label: 'Softuvo Solutions Pvt. Ltd.',
    value: 5941,
  },
  {
    label: 'Software AG',
    value: 5942,
  },
  {
    label: 'Solugenix',
    value: 5943,
  },
  {
    label: 'Solute TechnoLabs',
    value: 5944,
  },
  {
    label: 'Sophy Technologies',
    value: 5945,
  },
  {
    label: 'SOTI',
    value: 5946,
  },
  {
    label: 'SourceFuse Technologies',
    value: 5947,
  },
  {
    label: 'Spak Engineering',
    value: 5948,
  },
  {
    label: 'Sparecode Consulting LLP',
    value: 5949,
  },
  {
    label: 'Specialised IT Squad Pvt. Ltd.',
    value: 5950,
  },
  {
    label: 'Specloid Solutions Pvt Ltd',
    value: 5951,
  },
  {
    label: 'SphareGen',
    value: 5952,
  },
  {
    label: 'Sphere Soft Solutions India Pvt Ltd',
    value: 5953,
  },
  {
    label: 'Spigot Software',
    value: 5954,
  },
  {
    label: 'Spine Software Systems Pvt Ltd.',
    value: 5955,
  },
  {
    label: 'Splenta System Private Limited',
    value: 5956,
  },
  {
    label: 'Spork Labs Solutions Pvt Ltd',
    value: 5957,
  },
  {
    label: 'SportsCafe',
    value: 5958,
  },
  {
    label: 'Sportskeeda',
    value: 5959,
  },
  {
    label: 'Sportz Interactive',
    value: 5960,
  },
  {
    label: 'Springworks',
    value: 5961,
  },
  {
    label: 'Sprinkle Data',
    value: 5962,
  },
  {
    label: 'Sprite Health',
    value: 5963,
  },
  {
    label: 'SP Software Pvt. Ltd.',
    value: 5964,
  },
  {
    label: 'Atzos Ventures P L',
    value: 5965,
  },
  {
    label: 'Squadx',
    value: 5966,
  },
  {
    label: 'SabPaisa',
    value: 5967,
  },
  {
    label: 'NIIT - Stackroute',
    value: 5968,
  },
  {
    label: 'StapleLogic',
    value: 5969,
  },
  {
    label: 'Staqu Technologies Private Limited',
    value: 5970,
  },
  {
    label: 'Star Knowledge',
    value: 5971,
  },
  {
    label: 'Starllly Solutions',
    value: 5972,
  },
  {
    label: 'Startxlabs Technologies OPC Pvt',
    value: 5973,
  },
  {
    label: 'StashFin',
    value: 5974,
  },
  {
    label: 'StayinFront',
    value: 5975,
  },
  {
    label: 'Story Tech',
    value: 5976,
  },
  {
    label: 'StraitsBridge Analytics',
    value: 5977,
  },
  {
    label: 'Stratacent',
    value: 5978,
  },
  {
    label: 'Strategic HR Solutions',
    value: 5979,
  },
  {
    label: 'Streak AI Technologies',
    value: 5980,
  },
  {
    label: 'Kreon Finnancial Services Limited',
    value: 5981,
  },
  {
    label: 'Stylabs Technologies Pvt. Ltd.',
    value: 5982,
  },
  {
    label: 'Margo Networks',
    value: 5983,
  },
  {
    label: 'SuperProcure',
    value: 5984,
  },
  {
    label: 'SupplyCopia',
    value: 5985,
  },
  {
    label: 'Supr Daily',
    value: 5986,
  },
  {
    label: 'SureIT Solutions Pvt. Ltd',
    value: 5987,
  },
  {
    label: 'Swedium Global Services Pvt. Ltd',
    value: 5988,
  },
  {
    label: 'Swift Technocrafts Pvt. Ltd.',
    value: 5989,
  },
  {
    label: 'Sygitech Solutions Pvt Ltd',
    value: 5990,
  },
  {
    label: 'SYMB Technologies',
    value: 5991,
  },
  {
    label: 'Synapse techno design',
    value: 5992,
  },
  {
    label: 'Synergeo One',
    value: 5993,
  },
  {
    label: 'Synoriq R&D (OPC) Pvt. Ltd.',
    value: 5994,
  },
  {
    label: 'Syook',
    value: 5995,
  },
  {
    label: 'Tache Technologies',
    value: 5996,
  },
  {
    label: 'TAG Assessors Guild Pvt. Ltd.',
    value: 5997,
  },
  {
    label: 'TagMango',
    value: 5998,
  },
  {
    label: 'Tailwebs Technology Pvt Ltd',
    value: 5999,
  },
  {
    label: 'Talent Litmus',
    value: 6000,
  },
  {
    label: 'Talentoj',
    value: 6001,
  },
  {
    label: 'TalkCharge',
    value: 6002,
  },
  {
    label: 'DigiSmart Digital Media Pvt Ltd',
    value: 6003,
  },
  {
    label: 'TAILORED SOLUTIONS PVT LTD',
    value: 6004,
  },
  {
    label: 'Tathastu',
    value: 6005,
  },
  {
    label: 'Tavant Technologies',
    value: 6006,
  },
  {
    label: 'Taxmann Publications Pvt. Ltd.',
    value: 6007,
  },
  {
    label: 'Techno-Comp Computer Services Pvt Ltd',
    value: 6008,
  },
  {
    label: 'TDG Labs',
    value: 6009,
  },
  {
    label: 'TDG Partner',
    value: 6010,
  },
  {
    label: 'Team Ideal Private Limited',
    value: 6011,
  },
  {
    label: 'Team Pumpkin',
    value: 6012,
  },
  {
    label: 'TeamsWork',
    value: 6013,
  },
  {
    label: 'Tech Fortune Technologies',
    value: 6014,
  },
  {
    label: 'Tech2Globe Web Solutions LLP',
    value: 6015,
  },
  {
    label: 'Tech4Planet Solutions Pvt. Ltd.',
    value: 6016,
  },
  {
    label: 'Techcushy Software Solutions Pvt Ltd',
    value: 6017,
  },
  {
    label: 'Techmind Softwares',
    value: 6018,
  },
  {
    label: 'Technia',
    value: 6019,
  },
  {
    label: 'Techno Companion',
    value: 6020,
  },
  {
    label: 'Techno Exponent Services Pvt Ltd',
    value: 6021,
  },
  {
    label: 'Technosoft Global Services Pvt Ltd',
    value: 6022,
  },
  {
    label: 'Techsaga',
    value: 6023,
  },
  {
    label: 'TechVaraha Solutions Private Limited',
    value: 6024,
  },
  {
    label: 'Techwero Systems',
    value: 6025,
  },
  {
    label: 'TEG Analytics',
    value: 6026,
  },
  {
    label: 'Tejas Softech (India) Pvt Ltd',
    value: 6027,
  },
  {
    label: 'Tekgrid Consulting Services Pvt Ltd',
    value: 6028,
  },
  {
    label: 'Tekizma India Solutions Private Limited',
    value: 6029,
  },
  {
    label: 'Televisory (India) Pvt. Ltd.',
    value: 6030,
  },
  {
    label: 'Tendernews.com',
    value: 6031,
  },
  {
    label: 'AIRCOM International (A TEOCO Company)',
    value: 6032,
  },
  {
    label: 'Test and Verification Solutions',
    value: 6033,
  },
  {
    label: 'Testbook.com',
    value: 6034,
  },
  {
    label: 'Test Yantra software Solutions',
    value: 6035,
  },
  {
    label: 'Tetra Information Services Pvt Ltd',
    value: 6036,
  },
  {
    label: 'TexaTrove Mumbai',
    value: 6037,
  },
  {
    label: 'Blufig',
    value: 6038,
  },
  {
    label: 'The Chitrakars',
    value: 6039,
  },
  {
    label: 'The Contrast',
    value: 6040,
  },
  {
    label: 'Digital Group Infotech Pvt Ltd',
    value: 6041,
  },
  {
    label: 'The Great Startups',
    value: 6042,
  },
  {
    label: 'The Hirepro',
    value: 6043,
  },
  {
    label: 'The HRism',
    value: 6044,
  },
  {
    label: 'Human Experience Design',
    value: 6045,
  },
  {
    label: 'Infoz Software Solution',
    value: 6046,
  },
  {
    label: 'InnerHour',
    value: 6047,
  },
  {
    label: 'Kite',
    value: 6048,
  },
  {
    label: 'The Minimalist',
    value: 6049,
  },
  {
    label: 'Thence',
    value: 6050,
  },
  {
    label: 'NEWJ',
    value: 6051,
  },
  {
    label: 'The Night Marketer',
    value: 6052,
  },
  {
    label: 'The Quartile Company',
    value: 6053,
  },
  {
    label: 'Syndicate Tech LLP',
    value: 6054,
  },
  {
    label: 'thinkAPPS Solutions Pvt Ltd',
    value: 6055,
  },
  {
    label: 'Think Design',
    value: 6056,
  },
  {
    label: 'Think42Labs',
    value: 6057,
  },
  {
    label: 'Thinkbumblebee Analytics Pvt Ltd',
    value: 6058,
  },
  {
    label: 'This For That',
    value: 6059,
  },
  {
    label: 'ThomasMount',
    value: 6060,
  },
  {
    label: 'Thulir Software Technologies Pvt Ltd',
    value: 6061,
  },
  {
    label: 'Thumbmunkeys Pvt. Ltd.',
    value: 6062,
  },
  {
    label: 'Tiger Analytics',
    value: 6063,
  },
  {
    label: 'Tikshark Solutions Pvt Ltd',
    value: 6064,
  },
  {
    label: 'Tmcards Dot Com',
    value: 6065,
  },
  {
    label: 'TheModernDimension',
    value: 6066,
  },
  {
    label: 'Todsys Technologies',
    value: 6067,
  },
  {
    label: 'Toffee Insurance',
    value: 6068,
  },
  {
    label: 'Toppersedge.com',
    value: 6069,
  },
  {
    label: 'Toppr Technologies Pvt. Ltd.',
    value: 6070,
  },
  {
    label: 'Tops Infosolutions Pvt Ltd',
    value: 6071,
  },
  {
    label: 'Total Environment Building Systems Pvt Ltd',
    value: 6072,
  },
  {
    label: 'ToXSL Technologies Pvt Ltd',
    value: 6073,
  },
  {
    label: 'TPF Software',
    value: 6074,
  },
  {
    label: 'Triple Point Technology (ION Group company)',
    value: 6075,
  },
  {
    label: 'Trapeze Software',
    value: 6076,
  },
  {
    label: 'Stealth Model Travel',
    value: 6077,
  },
  {
    label: 'Binz Holidays Pvt. Ltd.',
    value: 6078,
  },
  {
    label: "Travel d'globe",
    value: 6079,
  },
  {
    label: 'Travel Unravel Holidays Pvt. Ltd.',
    value: 6080,
  },
  {
    label: 'Travelxp',
    value: 6081,
  },
  {
    label: 'Tredence Analytics Pvt Ltd',
    value: 6082,
  },
  {
    label: 'Trendlyne',
    value: 6083,
  },
  {
    label: 'Leading Financial Services Provider',
    value: 6084,
  },
  {
    label: 'Tretail',
    value: 6085,
  },
  {
    label: 'Trignodev Software Pvt Ltd.',
    value: 6086,
  },
  {
    label: 'Trillbit Technologies Pvt Ltd',
    value: 6087,
  },
  {
    label: 'Trisys IT Services',
    value: 6088,
  },
  {
    label: 'Triumph Ladders',
    value: 6089,
  },
  {
    label: 'Truckhall Pvt. Ltd',
    value: 6090,
  },
  {
    label: 'Trux App Pvt Ltd',
    value: 6091,
  },
  {
    label: 'TTEC',
    value: 6092,
  },
  {
    label: 'TunerLabs',
    value: 6093,
  },
  {
    label: 'Turbizo',
    value: 6094,
  },
  {
    label: 'Turbot HQ India Pvt Ltd (Turbot)',
    value: 6095,
  },
  {
    label: 'TAV SUD South Asia',
    value: 6096,
  },
  {
    label: 'Tv2z',
    value: 6097,
  },
  {
    label: 'TVS Next',
    value: 6098,
  },
  {
    label: 'TwigHop Realty Services Pvt. Ltd.',
    value: 6099,
  },
  {
    label: 'Tyfone Communications Development (India) Pvt. Ltd',
    value: 6100,
  },
  {
    label: 'UCLID Edu Labs Pvt Ltd',
    value: 6101,
  },
  {
    label: 'UcodeSoft Solutions Pvt. Ltd.',
    value: 6102,
  },
  {
    label: 'Universal Electronics India Pvt. Ltd.',
    value: 6103,
  },
  {
    label: 'UIPEP Technologies',
    value: 6104,
  },
  {
    label: 'Ultria Software Private Limited',
    value: 6105,
  },
  {
    label: 'Unacademy',
    value: 6106,
  },
  {
    label: 'UnDosTres',
    value: 6107,
  },
  {
    label: 'Unico Connect LLP',
    value: 6108,
  },
  {
    label: 'Unifynd Technologies',
    value: 6109,
  },
  {
    label: 'Unilog Content Solutions',
    value: 6110,
  },
  {
    label: 'Uniqolabel',
    value: 6111,
  },
  {
    label: 'TSG Global Services Pvt Ltd',
    value: 6112,
  },
  {
    label: 'Unistanz Software Pvt Ltd',
    value: 6113,
  },
  {
    label: 'Unyscape',
    value: 6114,
  },
  {
    label: 'upGrad',
    value: 6115,
  },
  {
    label: 'UrbanClap',
    value: 6116,
  },
  {
    label: 'Urban Piper Technologies Pvt. Ltd.',
    value: 6117,
  },
  {
    label: 'Urban Restro',
    value: 6118,
  },
  {
    label: 'Urjasoft Enterprises Pvt. Ltd.',
    value: 6119,
  },
  {
    label: 'UserExperior Technologies Pvt Ltd',
    value: 6120,
  },
  {
    label: 'Usha Martin Technologies',
    value: 6121,
  },
  {
    label: 'uSthaan Integrated Solutions Pvt. Ltd.',
    value: 6122,
  },
  {
    label: 'Utvyakta Solutions',
    value: 6123,
  },
  {
    label: 'Uzio Technology India Pvt. Ltd.',
    value: 6124,
  },
  {
    label: 'Viaan Industries Ltd',
    value: 6125,
  },
  {
    label: 'V2Infotech',
    value: 6126,
  },
  {
    label: 'Vahak Transport Community',
    value: 6127,
  },
  {
    label: 'Valiance Solutions Pvt. Ltd.',
    value: 6128,
  },
  {
    label: 'Valutek',
    value: 6129,
  },
  {
    label: 'Valuefy Solutions Pvt Ltd',
    value: 6130,
  },
  {
    label: 'Value Research',
    value: 6131,
  },
  {
    label: 'Valuestream Business Solutions Pvt ltd',
    value: 6132,
  },
  {
    label: 'TalentFirst HR Consulting Private Limited',
    value: 6133,
  },
  {
    label: 'Vision and Magic Consulting',
    value: 6134,
  },
  {
    label: 'Vbeyond Corportions',
    value: 6135,
  },
  {
    label: 'VBRI',
    value: 6136,
  },
  {
    label: 'VdoCipher Media Solutions',
    value: 6137,
  },
  {
    label: 'Vicenza Software Solutions Pvt Ltd',
    value: 6138,
  },
  {
    label: 'Velocitai Digital',
    value: 6139,
  },
  {
    label: 'Velotio',
    value: 6140,
  },
  {
    label: 'Veom Infotech Private Limited.',
    value: 6141,
  },
  {
    label: 'Vera Solutions',
    value: 6142,
  },
  {
    label: 'Verchaska Infotech Private Limited',
    value: 6143,
  },
  {
    label: 'Cogneau Systems Pvt. Ltd.',
    value: 6144,
  },
  {
    label: 'Verve Media',
    value: 6145,
  },
  {
    label: 'Veryx Technologies',
    value: 6146,
  },
  {
    label: 'Vetri Tech',
    value: 6147,
  },
  {
    label: 'Vexma Technologies Pvt Ltd',
    value: 6148,
  },
  {
    label: 'Vidooly',
    value: 6149,
  },
  {
    label: 'VinSol',
    value: 6150,
  },
  {
    label: 'Virasat Solutions',
    value: 6151,
  },
  {
    label: 'Virohan Pvt. Ltd.',
    value: 6152,
  },
  {
    label: 'Virtual Xcellence',
    value: 6153,
  },
  {
    label: 'Virtue Analytics',
    value: 6154,
  },
  {
    label: 'Virtuos Digital Limited',
    value: 6155,
  },
  {
    label: 'Visible Alpha Solutions India Pvt. Ltd.',
    value: 6156,
  },
  {
    label: 'Visionet Systems Pvt Ltd',
    value: 6157,
  },
  {
    label: 'VitWit Technologies',
    value: 6158,
  },
  {
    label: 'Vitwit',
    value: 6159,
  },
  {
    label: 'VMock',
    value: 6160,
  },
  {
    label: 'Aptlyf',
    value: 6161,
  },
  {
    label: 'Voolsy Networks Pvt. Ltd.',
    value: 6162,
  },
  {
    label: 'Voxtrail',
    value: 6163,
  },
  {
    label: 'vPhrase',
    value: 6164,
  },
  {
    label: 'Vrinsoft Technology Pvt. Ltd.',
    value: 6165,
  },
  {
    label: 'VT Netzwelt Pvt Ltd',
    value: 6166,
  },
  {
    label: 'W3global',
    value: 6167,
  },
  {
    label: 'Wafer Space Semiconductor',
    value: 6168,
  },
  {
    label: 'MobiusWorks Pvt Ltd',
    value: 6169,
  },
  {
    label: 'WarpDrive Tech Works',
    value: 6170,
  },
  {
    label: 'Warpdrive Tech',
    value: 6171,
  },
  {
    label: 'Waycool Foods and Products Pvt Ltd',
    value: 6172,
  },
  {
    label: 'Ways And Means Technology Pvt Ltd',
    value: 6173,
  },
  {
    label: 'Wealden HR Solutions (India) LLP',
    value: 6174,
  },
  {
    label: 'Wealthyfox',
    value: 6175,
  },
  {
    label: 'Wealthzi Ltd',
    value: 6176,
  },
  {
    label: 'Flamingo Digital/Lyxel labs',
    value: 6177,
  },
  {
    label: 'Webappmate',
    value: 6178,
  },
  {
    label: 'Webcontxt India Pvt. Ltd.',
    value: 6179,
  },
  {
    label: 'WebHopers Infotech Pvt Ltd',
    value: 6180,
  },
  {
    label: 'Web India Solutions',
    value: 6181,
  },
  {
    label: 'Weblieu Technologies Pvt. Ltd.',
    value: 6182,
  },
  {
    label: 'Webmaffia',
    value: 6183,
  },
  {
    label: 'Webspero Solutions',
    value: 6184,
  },
  {
    label: 'Adreno Technologies pvt ltd',
    value: 6185,
  },
  {
    label: 'Weddings Only',
    value: 6186,
  },
  {
    label: 'WeeBuy Technologies Private Limited',
    value: 6187,
  },
  {
    label: 'We Secure App',
    value: 6188,
  },
  {
    label: 'Wadhwani Foundation',
    value: 6189,
  },
  {
    label: 'WhiteBird Technology',
    value: 6190,
  },
  {
    label: 'Whitehat Education Technology Private Limited',
    value: 6191,
  },
  {
    label: 'Whitepanda',
    value: 6192,
  },
  {
    label: 'Whizlabs',
    value: 6193,
  },
  {
    label: 'Wigzo',
    value: 6194,
  },
  {
    label: 'Wildnet Technologies',
    value: 6195,
  },
  {
    label: 'Winit',
    value: 6196,
  },
  {
    label: 'Winning Edge India',
    value: 6197,
  },
  {
    label: 'wishfin',
    value: 6198,
  },
  {
    label: 'Wissen Technology',
    value: 6199,
  },
  {
    label: 'WITS Interactive Pvt Ltd.',
    value: 6200,
  },
  {
    label: 'Wolken Software Private Ltd',
    value: 6201,
  },
  {
    label: 'Wolters Kluwer',
    value: 6202,
  },
  {
    label: 'Wonderment Apps',
    value: 6203,
  },
  {
    label: 'Wooqer',
    value: 6204,
  },
  {
    label: 'Work Advantage Pvt. Ltd.',
    value: 6205,
  },
  {
    label: 'Workex',
    value: 6206,
  },
  {
    label: 'WorkforceValley.com',
    value: 6207,
  },
  {
    label: 'Work India',
    value: 6208,
  },
  {
    label: 'Worklooper',
    value: 6209,
  },
  {
    label: 'Workplace Fabric India Pvt Ltd',
    value: 6210,
  },
  {
    label: 'Worley',
    value: 6211,
  },
  {
    label: 'Wozo Gaming Pvt. Ltd',
    value: 6212,
  },
  {
    label: 'Weather Risk Management Services Pvt. Ltd',
    value: 6213,
  },
  {
    label: 'wServe Technology Private Limited',
    value: 6214,
  },
  {
    label: 'Wunerman Thompson Commerce',
    value: 6215,
  },
  {
    label: 'Wynomy Infotech Pvt Ltd',
    value: 6216,
  },
  {
    label: 'Xeeva India Pvt Ltd',
    value: 6217,
  },
  {
    label: 'Xeno Private Limited',
    value: 6218,
  },
  {
    label: 'XenonStack Pvt Ltd',
    value: 6219,
  },
  {
    label: 'Xicom Technologies Ltd',
    value: 6220,
  },
  {
    label: 'Xoxoday',
    value: 6221,
  },
  {
    label: 'Xpanxion International Pvt. Ltd.',
    value: 6222,
  },
  {
    label: 'Xpedize Ventures Pvt Ltd',
    value: 6223,
  },
  {
    label: 'Xtranet Technologies Pvt lmt',
    value: 6224,
  },
  {
    label: 'Yantriks',
    value: 6225,
  },
  {
    label: 'Yapsody India Pvt Ltd',
    value: 6226,
  },
  {
    label: 'Yellowpedal',
    value: 6227,
  },
  {
    label: 'YourOwnRoom Pvt. Ltd.',
    value: 6228,
  },
  {
    label: 'Yugasa Software Labs Pvt.Ltd',
    value: 6229,
  },
  {
    label: 'Zagaz',
    value: 6230,
  },
  {
    label: 'Zaggle',
    value: 6231,
  },
  {
    label: 'Zalaris India',
    value: 6232,
  },
  {
    label: 'Zed Eye Labs',
    value: 6233,
  },
  {
    label: 'ZEE Entertainment',
    value: 6234,
  },
  {
    label: 'Zekardo Automotive Solutions',
    value: 6235,
  },
  {
    label: 'Zeliant Infoserve Pvt. Ltd.',
    value: 6236,
  },
  {
    label: 'Zelish',
    value: 6237,
  },
  {
    label: 'Zelus India',
    value: 6238,
  },
  {
    label: 'Zen3',
    value: 6239,
  },
  {
    label: 'Zen Cloud Technologies',
    value: 6240,
  },
  {
    label: 'Zenon Analytics',
    value: 6241,
  },
  {
    label: 'Zenoti',
    value: 6242,
  },
  {
    label: 'Zestgeek Solutions Pvt Ltd',
    value: 6243,
  },
  {
    label: 'Zimozi Solutions Pvt. Ltd.',
    value: 6244,
  },
  {
    label: 'ZipLoan',
    value: 6245,
  },
  {
    label: 'Zivame',
    value: 6246,
  },
  {
    label: 'Zooneto',
    value: 6247,
  },
  {
    label: 'Zuan Technologies Pvt Ltd',
    value: 6248,
  },
  {
    label: 'Zunroof Tech Private Limited',
    value: 6249,
  },
  {
    label: 'Indipepper Media Pvt. Ltd.',
    value: 6250,
  },
  {
    label: 'Zwayam',
    value: 6251,
  },
  {
    label: 'Zykoon Technologies Pvt Ltd',
    value: 6252,
  },
  {
    label: 'o9 Solutions Inc.',
    value: 6253,
  },
  {
    label: 'Mainspring Trajecta Global Inc',
    value: 6254,
  },
  {
    label: 'Reliant Tech Inc',
    value: 6255,
  },
  {
    label: 'SkillSanta',
    value: 6256,
  },
  {
    label: 'Firework India',
    value: 6257,
  },
  {
    label: 'Crowd Source Technologies Pvt Ltd',
    value: 6258,
  },
  {
    label: 'Lead School',
    value: 6259,
  },
  {
    label: 'Navriti Technologies PVT LTD',
    value: 6260,
  },
  {
    label: 'A5E Consulting Pvt Ltd',
    value: 6261,
  },
  {
    label: 'MIT Group of Institutions',
    value: 6262,
  },
  {
    label: 'Cypherock',
    value: 6263,
  },
  {
    label: 'Techbrawn IT solutions',
    value: 6264,
  },
  {
    label: 'Wisestep',
    value: 6265,
  },
  {
    label: 'Gateway Group',
    value: 6266,
  },
  {
    label: 'Splash Business Intelligence Private Limited',
    value: 6267,
  },
  {
    label: 'KnowDis Data Science',
    value: 6268,
  },
  {
    label: 'loadtap',
    value: 6269,
  },
  {
    label: 'Cypress Semiconductor Corporation',
    value: 6270,
  },
  {
    label: 'Catalyst IQ',
    value: 6271,
  },
  {
    label: 'Innow8 Apps',
    value: 6272,
  },
  {
    label: 'Stack Finance',
    value: 6273,
  },
  {
    label: 'Dropkaffe Food and Beverages Pvt Ltd',
    value: 6274,
  },
  {
    label: 'LeadSquared',
    value: 6275,
  },
  {
    label: 'Irys India Pvt. Ltd.',
    value: 6276,
  },
  {
    label: 'Emorphis Technology',
    value: 6277,
  },
  {
    label: 'Kizora Software Pvt. Ltd.',
    value: 6278,
  },
  {
    label: 'Stealth Mode',
    value: 6279,
  },
  {
    label: 'Pelican.ai',
    value: 6280,
  },
  {
    label: 'Shristi Learning Services',
    value: 6281,
  },
  {
    label: 'Maxim Instruments Corporation',
    value: 6282,
  },
  {
    label: 'DCKAP',
    value: 6283,
  },
  {
    label: 'Finxera India Pvt. Ltd.',
    value: 6284,
  },
  {
    label: 'NH HEARING AID SERVICES PRIVATE LIMITED',
    value: 6285,
  },
  {
    label: 'Rigel Networks Pv Ltd',
    value: 6286,
  },
  {
    label: 'Solutionec',
    value: 6287,
  },
  {
    label: 'Artificial Learning Systems India Pvt Ltd',
    value: 6288,
  },
  {
    label: 'R Systems',
    value: 6289,
  },
  {
    label: 'Emuron',
    value: 6290,
  },
  {
    label: 'Daydoc',
    value: 6291,
  },
  {
    label: 'Draup',
    value: 6292,
  },
  {
    label: 'Best Digital Marketing',
    value: 6293,
  },
  {
    label: 'Silversparro Technologies',
    value: 6294,
  },
  {
    label: 'Paisa Bazaar',
    value: 6295,
  },
  {
    label: 'Taxmann',
    value: 6296,
  },
  {
    label: 'Vimarsa Consulting LLP',
    value: 6297,
  },
  {
    label: 'Vendiman',
    value: 6298,
  },
  {
    label: 'Akal information system',
    value: 6299,
  },
  {
    label: 'BUDDI.Ai',
    value: 6300,
  },
  {
    label: 'AARWII TECHSOLUTIONS PRIVATE LIMITED',
    value: 6301,
  },
  {
    label: 'MasterCard',
    value: 6302,
  },
  {
    label: 'Triadss',
    value: 6303,
  },
  {
    label: 'Yartha Engineering Pvt Ltd',
    value: 6304,
  },
  {
    label: 'Gemini Corp',
    value: 6305,
  },
  {
    label: 'HorseTech Analytics',
    value: 6306,
  },
  {
    label: 'Qentelli',
    value: 6307,
  },
  {
    label: 'Gray Ripples',
    value: 6308,
  },
  {
    label: 'Recordent Pvt Ltd',
    value: 6309,
  },
  {
    label: 'BlinkIn',
    value: 6310,
  },
  {
    label: 'Traffords India Pvt Ltd',
    value: 6311,
  },
  {
    label: 'Saleslift Technologies Private Limited',
    value: 6312,
  },
  {
    label: 'Shiksha Infotech pvt ltd',
    value: 6313,
  },
  {
    label: 'KoiReader Technologies',
    value: 6314,
  },
  {
    label: 'Affluent Global Service',
    value: 6315,
  },
  {
    label: 'Wesource Business Solutions Pvt Ltd',
    value: 6316,
  },
  {
    label: 'DigiMantra Labs',
    value: 6317,
  },
  {
    label: 'Matrix Shell Technologies Pvt Ltd',
    value: 6318,
  },
  {
    label: 'Vantage Circle',
    value: 6319,
  },
  {
    label: 'iProtechs',
    value: 6320,
  },
  {
    label: 'SuprStart Ventures',
    value: 6321,
  },
  {
    label: 'IPexcel',
    value: 6322,
  },
  {
    label: 'PeopleGamt HR Solutions',
    value: 6323,
  },
  {
    label: 'Quess Corp Ltd',
    value: 6324,
  },
  {
    label: 'Code Blend Labs',
    value: 6325,
  },
  {
    label: 'OTP Xpress',
    value: 6326,
  },
  {
    label: 'Pocket52',
    value: 6327,
  },
  {
    label: 'QuillHash Technologies',
    value: 6328,
  },
  {
    label: 'Finoit Technology',
    value: 6329,
  },
  {
    label: 'Cympl Studios Private Limited',
    value: 6330,
  },
  {
    label: 'Multi-Living',
    value: 6331,
  },
  {
    label: 'Ideas World',
    value: 6332,
  },
  {
    label: 'WIFT CAP SOLUTIONS PVT. LTD.',
    value: 6333,
  },
  {
    label: 'United For Her',
    value: 6334,
  },
  {
    label: 'SOTI Inc.',
    value: 6335,
  },
  {
    label: 'Sumasoft',
    value: 6336,
  },
  {
    label: 'Goldcast',
    value: 6337,
  },
  {
    label: 'Credit Saison Finance Pvt Ltd',
    value: 6338,
  },
  {
    label: 'InVideo',
    value: 6339,
  },
  {
    label: 'Nalsoft Pvt. Ltd',
    value: 6340,
  },
  {
    label: 'Hucon Solutions',
    value: 6341,
  },
  {
    label: 'Saint-Gobain',
    value: 6342,
  },
  {
    label: 'Fairpockets',
    value: 6343,
  },
  {
    label: 'DIVIDEITE',
    value: 6344,
  },
  {
    label: 'pwctech technologies private limited',
    value: 6345,
  },
  {
    label: 'Ciferon',
    value: 6346,
  },
  {
    label: 'Infrrd Pvt Ltd',
    value: 6347,
  },
  {
    label: 'Amiure International Pvt Ltd',
    value: 6348,
  },
  {
    label: 'Umedex',
    value: 6349,
  },
  {
    label: 'Spyne',
    value: 6350,
  },
  {
    label: 'DigiMoksha',
    value: 6351,
  },
  {
    label: 'Kosha Technohub',
    value: 6352,
  },
  {
    label: 'Augray',
    value: 6353,
  },
  {
    label: 'Lafz International Pte.',
    value: 6354,
  },
  {
    label: 'Better Mortgage',
    value: 6355,
  },
  {
    label: 'Unistory',
    value: 6356,
  },
  {
    label: 'Spectra Technovision (India) Pvt. Ltd.',
    value: 6357,
  },
  {
    label: 'Mobicip Technologies Pvt Ltd',
    value: 6358,
  },
  {
    label: 'CloudSEK',
    value: 6359,
  },
  {
    label: 'WebMob Technologies',
    value: 6360,
  },
  {
    label: 'WonderBiz Technologies',
    value: 6361,
  },
  {
    label: 'Aranaya Systems Pvt Ltd',
    value: 6362,
  },
  {
    label: 'Early Salary',
    value: 6363,
  },
  {
    label: 'DSMATICS',
    value: 6364,
  },
  {
    label: 'StrikarTech Enterprise Solutions LLP',
    value: 6365,
  },
  {
    label: 'nlite',
    value: 6366,
  },
  {
    label: 'Treehouse Highschool',
    value: 6367,
  },
  {
    label: 'Vruksham Talent Group',
    value: 6368,
  },
  {
    label: 'Prop Guide',
    value: 6369,
  },
  {
    label: 'ToneTag',
    value: 6370,
  },
  {
    label: 'Vivriti Capital',
    value: 6371,
  },
  {
    label: 'NISA SOLUTIONS PVT LTD',
    value: 6372,
  },
  {
    label: 'Webengage',
    value: 6373,
  },
  {
    label: 'm h mortgage services pvt ltd',
    value: 6374,
  },
  {
    label: 'I AM IN',
    value: 6375,
  },
  {
    label: 'RJS Tech Solutions LLP',
    value: 6376,
  },
  {
    label: 'Rinlit LLC',
    value: 6377,
  },
  {
    label: 'Lovin Digital',
    value: 6378,
  },
  {
    label: 'Innovapptive',
    value: 6379,
  },
  {
    label: 'fintrakk.com',
    value: 6380,
  },
  {
    label: 'badgefree',
    value: 6381,
  },
  {
    label: 'Toddle - Your Teaching Partner',
    value: 6382,
  },
  {
    label: 'Duckcreek Technologies',
    value: 6383,
  },
  {
    label: 'Kushal Technologies',
    value: 6384,
  },
  {
    label: 'WoodFlake Business Solutions and Retail Pvt. Ltd.',
    value: 6385,
  },
  {
    label: 'Dotsquares Technologies India Pvt. Ltd.',
    value: 6386,
  },
  {
    label: 'Getafix Technologies',
    value: 6387,
  },
  {
    label: 'Divami Design Labs',
    value: 6388,
  },
  {
    label: 'Cloud Kinetics',
    value: 6389,
  },
  {
    label: 'Code Astra',
    value: 6390,
  },
  {
    label: 'Visual Juju',
    value: 6391,
  },
  {
    label: 'Essenvia',
    value: 6392,
  },
  {
    label: 'Artoon Solutions Pvt',
    value: 6393,
  },
  {
    label: 'TestVagrant Technologies',
    value: 6394,
  },
  {
    label: 'Juntrax Solutions',
    value: 6395,
  },
  {
    label: 'Square Yards',
    value: 6396,
  },
  {
    label: 'OC',
    value: 6397,
  },
  {
    label: 'Gingerpan Swapcart India Pvt Ltd',
    value: 6398,
  },
  {
    label: 'Tiatech',
    value: 6399,
  },
  {
    label: 'Cloudely Inc.',
    value: 6400,
  },
  {
    label: 'MLAI Digital',
    value: 6401,
  },
  {
    label: 'BizBuzzs.com',
    value: 6402,
  },
  {
    label: 'Moxie',
    value: 6403,
  },
  {
    label: 'Techved Consulting India Pvt. Ltd.',
    value: 6404,
  },
  {
    label: 'Washh',
    value: 6405,
  },
  {
    label: 'Kinara Capital',
    value: 6406,
  },
  {
    label: 'Toppr.com',
    value: 6407,
  },
  {
    label: 'Generic Exchange',
    value: 6408,
  },
  {
    label: 'RWN Digitech',
    value: 6409,
  },
  {
    label: 'Naraci (A Decorpot Company)',
    value: 6410,
  },
  {
    label: 'Codersbrain India Private Limited',
    value: 6411,
  },
  {
    label: 'Tunnel for web services',
    value: 6412,
  },
  {
    label: 'Avishkaar',
    value: 6413,
  },
  {
    label: 'Unilog',
    value: 6414,
  },
  {
    label: 'Cloudmynds',
    value: 6415,
  },
  {
    label: 'ASP Global Works',
    value: 6416,
  },
  {
    label: 'Orion eSolutions Pvt. Ltd.',
    value: 6417,
  },
  {
    label: 'Teamarcs',
    value: 6418,
  },
  {
    label: 'Citrix R & D',
    value: 6419,
  },
  {
    label: 'Hypersonix',
    value: 6420,
  },
  {
    label: 'CashXL Fintech Private Limited',
    value: 6421,
  },
  {
    label: 'Emoha Eldercare',
    value: 6422,
  },
  {
    label: 'Vertipride Solutions Pvt. Ltd',
    value: 6423,
  },
  {
    label: 'mfine',
    value: 6424,
  },
  {
    label: 'TekEinstein Pvt Ltd.',
    value: 6425,
  },
  {
    label: 'Avianco Technologies P Ltd',
    value: 6426,
  },
  {
    label: 'Origin Business Solutions',
    value: 6427,
  },
  {
    label: 'Genesiscircle',
    value: 6428,
  },
  {
    label: 'Akzonobel',
    value: 6429,
  },
  {
    label: 'Orion India Systems Pvt Ltd',
    value: 6430,
  },
  {
    label: 'CrackVerbal Edutech Pvt Ltd',
    value: 6431,
  },
  {
    label: 'Ramsoft',
    value: 6432,
  },
  {
    label: 'CERP Software Solutions Pvt Ltd',
    value: 6433,
  },
  {
    label: 'ALX',
    value: 6434,
  },
  {
    label: 'Qualitykiosk Technology',
    value: 6435,
  },
  {
    label: 'Northout Solutions',
    value: 6436,
  },
  {
    label: 'Shiprocket',
    value: 6437,
  },
  {
    label: 'Taazaa',
    value: 6438,
  },
  {
    label: 'Wisdom Tree Ventures',
    value: 6439,
  },
  {
    label: 'ALLEN',
    value: 6440,
  },
  {
    label: 'Silicon Valley Bank (SVB Financial Group)',
    value: 6441,
  },
  {
    label: 'Webspin Technologies',
    value: 6442,
  },
  {
    label: 'QUANTUM AI SYSTEMS',
    value: 6443,
  },
  {
    label: 'Coodzy',
    value: 6444,
  },
  {
    label: 'Datamatics Digital',
    value: 6445,
  },
  {
    label: 'Peel Works',
    value: 6446,
  },
  {
    label: 'Excellon Software',
    value: 6447,
  },
  {
    label: 'Arista Pictures',
    value: 6448,
  },
  {
    label: 'Atlogys',
    value: 6449,
  },
  {
    label: 'The Retail Insights',
    value: 6450,
  },
  {
    label: 'Enzen Global Solutions Pvt. Ltd.',
    value: 6451,
  },
  {
    label: 'Twine Digital',
    value: 6452,
  },
  {
    label: 'RAW ENGINEERING INDIA PVT LTD',
    value: 6453,
  },
  {
    label: 'Colgate',
    value: 6454,
  },
  {
    label: 'Quidich',
    value: 6455,
  },
  {
    label: 'AppSierra Solutions Pvt Ltd',
    value: 6456,
  },
  {
    label: 'Bigbasket',
    value: 6457,
  },
  {
    label: 'Plastic Printers',
    value: 6458,
  },
  {
    label: 'Wisflux Private Limuted',
    value: 6459,
  },
  {
    label: 'Auxesis Infotech',
    value: 6460,
  },
  {
    label: 'PowerServ Technologies',
    value: 6461,
  },
  {
    label: 'NMIMS Global Access School of Continuing Education',
    value: 6462,
  },
  {
    label: 'Broadway Web Services',
    value: 6463,
  },
  {
    label: 'SuprTeam',
    value: 6464,
  },
  {
    label: 'Rishiraj Media',
    value: 6465,
  },
  {
    label: 'ETP International Pvt.Ltd.',
    value: 6466,
  },
  {
    label: 'Mobil80 Solutions and Services Pvt. Ltd.',
    value: 6467,
  },
  {
    label: 'Aicumen Technologies Inc',
    value: 6468,
  },
  {
    label: 'John Meridian',
    value: 6469,
  },
  {
    label: 'KRISIN',
    value: 6470,
  },
  {
    label: 'Certum Ventures Pvt Ltd',
    value: 6471,
  },
  {
    label: 'Cultor',
    value: 6472,
  },
  {
    label: 'MeetApp',
    value: 6473,
  },
  {
    label: 'Open Financial Technologies Pvt Ltd',
    value: 6474,
  },
  {
    label: 'Allure Software Pvt Ltd',
    value: 6475,
  },
  {
    label: 'LenDenClub',
    value: 6476,
  },
  {
    label: 'Regalix',
    value: 6477,
  },
  {
    label: 'ON Semiconductor Technology Pvt Ltd',
    value: 6478,
  },
  {
    label: 'Forsys Software India Pvt Lts',
    value: 6479,
  },
  {
    label: 'Bold Technology Systems Pvt Ltd',
    value: 6480,
  },
  {
    label: 'Aidbees',
    value: 6481,
  },
  {
    label: 'Code Matrix Software Pvt Ltd',
    value: 6482,
  },
  {
    label: 'Proventeq',
    value: 6483,
  },
  {
    label: 'Gary Global Solutions',
    value: 6484,
  },
  {
    label: 'RapidAI Vision Technologies Pvt Ltd',
    value: 6485,
  },
  {
    label: 'Channelplay',
    value: 6486,
  },
  {
    label: 'Beyondscale Technologies Private Limited',
    value: 6487,
  },
  {
    label: 'Simplify Healthcare',
    value: 6488,
  },
  {
    label: 'Jarvis Technology And Strategy Consulting Private Limited',
    value: 6489,
  },
  {
    label: 'WhiteHatjr',
    value: 6490,
  },
  {
    label: 'iManiac Technologies Pvt. Ltd.',
    value: 6491,
  },
  {
    label: 'Solvencia Technologies Pvt Ltd',
    value: 6492,
  },
  {
    label: 'StudyIQ.com',
    value: 6493,
  },
  {
    label: 'Carl Zeiss India ( Bangalore ) Pvt Ltd',
    value: 6494,
  },
  {
    label: 'Binge N Chill',
    value: 6495,
  },
  {
    label: 'COSYN LIMITED',
    value: 6496,
  },
  {
    label: 'Flatworld Solutions',
    value: 6497,
  },
  {
    label: 'Altran Technology',
    value: 6498,
  },
  {
    label: 'Rock Technolabs',
    value: 6499,
  },
  {
    label: 'Increasingly',
    value: 6500,
  },
  {
    label: 'BVC eServices Pvt Ltd',
    value: 6501,
  },
  {
    label: 'Exemplar Corporate services',
    value: 6502,
  },
  {
    label: 'Ansh Technovision',
    value: 6503,
  },
  {
    label: 'Innovatia Inc',
    value: 6504,
  },
  {
    label: 'Prashaste',
    value: 6505,
  },
  {
    label: 'PushOwl',
    value: 6506,
  },
  {
    label: 'Jean Martin Inc',
    value: 6507,
  },
  {
    label: 'Matrix Partners India',
    value: 6508,
  },
  {
    label: 'DPSGS',
    value: 6509,
  },
  {
    label: 'Flyonit Solutions Pvt. Ltd.',
    value: 6510,
  },
  {
    label: 'Bada Business Pvt Ltd',
    value: 6511,
  },
  {
    label: 'Satvat Infosol Pvt Ltd.',
    value: 6512,
  },
  {
    label: 'DelPay',
    value: 6513,
  },
  {
    label: 'Yechte.com',
    value: 6514,
  },
  {
    label: 'MITS',
    value: 6515,
  },
  {
    label: 'UniHyr',
    value: 6516,
  },
  {
    label: 'Real Page',
    value: 6517,
  },
  {
    label: 'Offshore Software Solutions',
    value: 6518,
  },
  {
    label: 'WorldFashionExchange',
    value: 6519,
  },
  {
    label: 'Evince Development',
    value: 6520,
  },
  {
    label: 'Apurva Natvar Parikh Group',
    value: 6521,
  },
  {
    label: 'Lirik Inc',
    value: 6522,
  },
  {
    label: 'Digital Refresh Networks',
    value: 6523,
  },
  {
    label: 'Play Games24x7 Private Limited',
    value: 6524,
  },
  {
    label: 'Innovatily',
    value: 6525,
  },
  {
    label: 'Altimetrik',
    value: 6526,
  },
  {
    label: 'KyePot',
    value: 6527,
  },
  {
    label: 'alation india',
    value: 6528,
  },
  {
    label: 'Talent thrill consultancy',
    value: 6529,
  },
  {
    label: 'Gamechange.com',
    value: 6530,
  },
  {
    label: 'EIS technologies',
    value: 6531,
  },
  {
    label: 'Lunavo Labs',
    value: 6532,
  },
  {
    label: 'Barbeque Nation Hospitality Pvt Ltd',
    value: 6533,
  },
  {
    label: 'General Mills India',
    value: 6534,
  },
  {
    label: 'Dymerse',
    value: 6535,
  },
  {
    label: 'Coherent lab LLP',
    value: 6536,
  },
  {
    label: 'Anyone Home INC',
    value: 6537,
  },
  {
    label: 'Investianz Group',
    value: 6538,
  },
  {
    label: 'mStack Innovation Labs',
    value: 6539,
  },
  {
    label: 'EZ Technologies',
    value: 6540,
  },
  {
    label: 'Truckbook',
    value: 6541,
  },
  {
    label: 'TechVerito',
    value: 6542,
  },
  {
    label: 'TechMojo',
    value: 6543,
  },
  {
    label: 'Bitmetric Solutions',
    value: 6544,
  },
  {
    label: 'Cohesity',
    value: 6545,
  },
  {
    label: 'Verbose Techlabs LLP',
    value: 6546,
  },
  {
    label: 'Sociopool India Pvt Ltd',
    value: 6547,
  },
  {
    label: 'Amipiya Techosoft',
    value: 6548,
  },
  {
    label: 'Samatrix Consulting Private Limited',
    value: 6549,
  },
  {
    label: 'GSVlabs',
    value: 6550,
  },
  {
    label: 'Fueb Labs Automations Pvt. Ltd.',
    value: 6551,
  },
  {
    label: 'COSGrid Networks',
    value: 6552,
  },
  {
    label: 'Neominds Software Pvt.Ltd',
    value: 6553,
  },
  {
    label: 'SmartDocs Business Solutions Private Limited',
    value: 6554,
  },
  {
    label: 'People Staffing Solutions',
    value: 6555,
  },
  {
    label: 'Neuron Internet Services & Technologies Pvt. Ltd',
    value: 6556,
  },
  {
    label: 'Skuad Lab India Pvt. Ltd.',
    value: 6557,
  },
  {
    label: 'TesTHING Technologies',
    value: 6558,
  },
  {
    label: 'Servify',
    value: 6559,
  },
  {
    label: 'RSBPL',
    value: 6560,
  },
  {
    label: 'Tekgente Solutions Inc',
    value: 6561,
  },
  {
    label: 'StartUp65',
    value: 6562,
  },
  {
    label: 'Arete IT Private Limited',
    value: 6563,
  },
  {
    label: 'Blueberry Digital Labs',
    value: 6564,
  },
  {
    label: 'NVS Analytics',
    value: 6565,
  },
  {
    label: 'Suim',
    value: 6566,
  },
  {
    label: 'NextGenAPI',
    value: 6567,
  },
  {
    label: 'Trusting Social Pvt Ltd',
    value: 6568,
  },
  {
    label: 'Datalligence AI Private limited',
    value: 6569,
  },
  {
    label: 'Toothsi',
    value: 6570,
  },
  {
    label: 'Prodapt',
    value: 6571,
  },
  {
    label: 'HCCB',
    value: 6572,
  },
  {
    label: 'Hirist',
    value: 6573,
  },
  {
    label: 'EA India',
    value: 6574,
  },
  {
    label: 'P&G',
    value: 6575,
  },
  {
    label: 'Rupeek',
    value: 6576,
  },
  {
    label: 'GSK',
    value: 6577,
  },
  {
    label: 'Mondelez',
    value: 6578,
  },
  {
    label: 'DHL SmarTrucking',
    value: 6579,
  },
  {
    label: 'BIBA',
    value: 6580,
  },
  {
    label: 'Info Egde',
    value: 6581,
  },
  {
    label: 'Club Factory',
    value: 6582,
  },
  {
    label: 'LT Food',
    value: 6583,
  },
  {
    label: 'PhillipCapital',
    value: 6584,
  },
  {
    label: 'BRIDGE I2I',
    value: 6585,
  },
  {
    label: 'LexInnova',
    value: 6586,
  },
  {
    label: 'Purnartha',
    value: 6587,
  },
  {
    label: 'Sarva',
    value: 6588,
  },
  {
    label: 'MSE',
    value: 6589,
  },
  {
    label: 'Acko Insurance',
    value: 6590,
  },
  {
    label: 'Newscorp VCCircle',
    value: 6591,
  },
  {
    label: 'Embassy',
    value: 6592,
  },
  {
    label: 'ABInbev',
    value: 6593,
  },
  {
    label: 'Cognizant',
    value: 6594,
  },
  {
    label: 'Egon Zehnder',
    value: 6595,
  },
  {
    label: 'Avail Finance',
    value: 6596,
  },
  {
    label: 'MYK Laticrete',
    value: 6597,
  },
  {
    label: 'Publicis Sapient',
    value: 6598,
  },
  {
    label: 'Cred',
    value: 6599,
  },
  {
    label: 'Dunzo',
    value: 6600,
  },
  {
    label: 'JP Morgan Chase',
    value: 6601,
  },
  {
    label: 'Citrix',
    value: 6602,
  },
  {
    label: 'Healthpole',
    value: 6603,
  },
  {
    label: 'PFS Global',
    value: 6604,
  },
  {
    label: 'Nicobar',
    value: 6605,
  },
  {
    label: 'DXC.technology',
    value: 6606,
  },
  {
    label: 'Urban Company',
    value: 6607,
  },
  {
    label: 'Diversity@Work',
    value: 6608,
  },
  {
    label: '#Diversity',
    value: 6609,
  },
  {
    label: 'KGSIL',
    value: 6610,
  },
  {
    label: 'Zoomcar',
    value: 6611,
  },
  {
    label: 'RailRestro',
    value: 6612,
  },
  {
    label: 'Successive Technologies',
    value: 6613,
  },
  {
    label: 'HireXtra TGC',
    value: 6614,
  },
  {
    label: 'Defi Blockchain Labs Pvt. Ltd.',
    value: 6615,
  },
  {
    label: 'Antra Info Solutions Pvt. Ltd',
    value: 6616,
  },
  {
    label: 'Climate Corporation',
    value: 6617,
  },
  {
    label: 'Quilin Advisors',
    value: 6618,
  },
  {
    label: 'iConnect Info Solutions Pvt. Ltd',
    value: 6619,
  },
  {
    label: 'Stratlantis',
    value: 6620,
  },
  {
    label: 'SynapseIndia',
    value: 6621,
  },
  {
    label: 'Mint International',
    value: 6622,
  },
  {
    label: 'HelixSmartLabs Pvt.Ltd',
    value: 6623,
  },
  {
    label: '361Analytica Pvt Ltd',
    value: 6624,
  },
  {
    label: 'Myfitsoul Technologies Private Limited',
    value: 6625,
  },
  {
    label: 'Splash Business Intelligence',
    value: 6626,
  },
  {
    label: 'ITSAD Technologies Pvt. Ltd.',
    value: 6627,
  },
  {
    label: 'Data-Aces',
    value: 6628,
  },
  {
    label: 'Jaipur Rugs',
    value: 6629,
  },
  {
    label: 'Podium',
    value: 6630,
  },
  {
    label: 'Smarter Biz Technologies Private Limited',
    value: 6631,
  },
  {
    label: 'Raju Tech Pvt Ltd',
    value: 6632,
  },
  {
    label: 'Webiators',
    value: 6633,
  },
  {
    label: 'Machani Group',
    value: 6634,
  },
  {
    label: 'EduSpace Technologies Pvt Ltd',
    value: 6635,
  },
  {
    label: 'Hundred Eyes Educational Services Pvt. Ltd.',
    value: 6636,
  },
  {
    label: 'Oxcytech System',
    value: 6637,
  },
  {
    label: '4G Information Technologies',
    value: 6638,
  },
  {
    label: 'PurpleTalk India Pvt Ltd',
    value: 6639,
  },
  {
    label: 'Meet University',
    value: 6640,
  },
  {
    label: 'SIXT Research & Development India',
    value: 6641,
  },
  {
    label: 'Pjsoft Ventures',
    value: 6642,
  },
  {
    label: 'Tafe',
    value: 6643,
  },
  {
    label: 'PlanQube',
    value: 6644,
  },
  {
    label: 'MyU App - Gymhop Technology Pvt Ltd',
    value: 6645,
  },
  {
    label: 'Learnnovators Private Limited',
    value: 6646,
  },
  {
    label: 'Stocks Fantasy Pvt Ltd',
    value: 6647,
  },
  {
    label: 'Shipco IT Pvt. Ltd.',
    value: 6648,
  },
  {
    label: 'Hereafter',
    value: 6649,
  },
  {
    label: 'DEEESHA Edu and Fin Technologies',
    value: 6650,
  },
  {
    label: 'Foresight Systems Ltd.',
    value: 6651,
  },
  {
    label: 'Bitmetric Technologies Pvt. Ltd.',
    value: 6652,
  },
  {
    label: 'coMakeIT',
    value: 6653,
  },
  {
    label: 'Kalolytic',
    value: 6654,
  },
  {
    label: 'S G Analytics',
    value: 6655,
  },
  {
    label: 'Bitryt Solutions Pvt Ltd',
    value: 6656,
  },
  {
    label: 'DutchView IT',
    value: 6657,
  },
  {
    label: 'FieldAssist',
    value: 6658,
  },
  {
    label: 'Softtek',
    value: 6659,
  },
  {
    label: 'CISPL',
    value: 6660,
  },
  {
    label: 'myntra',
    value: 6661,
  },
  {
    label: 'SGOC Global',
    value: 6662,
  },
  {
    label: 'Victrix Systems and Labs Pvt. Ltd.',
    value: 6663,
  },
  {
    label: 'Eagle Information Systems',
    value: 6664,
  },
  {
    label: 'Ceipal Solutions Pvt Ltd',
    value: 6665,
  },
  {
    label: 'Neovatic Technologies Pvt Ltd',
    value: 6666,
  },
  {
    label: 'AppGambit',
    value: 6667,
  },
  {
    label: 'Adpello Technology Tvt. Ltd.',
    value: 6668,
  },
  {
    label: 'Indian Television Dot Com',
    value: 6669,
  },
  {
    label: 'Kastech',
    value: 6670,
  },
  {
    label: 'Rjuhasta - Digital Marketing Agency',
    value: 6671,
  },
  {
    label: 'Appradius',
    value: 6672,
  },
  {
    label: 'BDI Plus Labs',
    value: 6673,
  },
  {
    label: 'Ecoprosus India Private Limited',
    value: 6674,
  },
  {
    label: 'Yoda Technologies Pty Ltd',
    value: 6675,
  },
  {
    label: '91mobiles',
    value: 6676,
  },
  {
    label: 'FirstRand Services Pvt Ltd',
    value: 6677,
  },
  {
    label: 'KCS Technologies',
    value: 6678,
  },
  {
    label: 'The Glove',
    value: 6679,
  },
  {
    label: 'Gestell Technologies',
    value: 6680,
  },
  {
    label: 'Leadersource Consulting LLP',
    value: 6681,
  },
  {
    label: 'Vaibhav Global Limited',
    value: 6682,
  },
  {
    label: 'Kuling Technologies Pvt Ltd',
    value: 6683,
  },
  {
    label: 'Nupeak IT Solutions LLP',
    value: 6684,
  },
  {
    label: 'Chai Point',
    value: 6685,
  },
  {
    label: 'Lazot Technologies Pvt Ltd',
    value: 6686,
  },
  {
    label: 'Franchise India Holdings Limited',
    value: 6687,
  },
  {
    label: 'Job Guardians',
    value: 6688,
  },
  {
    label: 'Poorvika Mobiles',
    value: 6689,
  },
  {
    label: 'Empliance Information',
    value: 6690,
  },
  {
    label: 'Sapphire Info Solutions (P) Ltd.',
    value: 6691,
  },
  {
    label: 'Paper Boat Apps Pvt Ltd',
    value: 6692,
  },
  {
    label: 'Camp K12',
    value: 6693,
  },
  {
    label: 'Leviar technologies',
    value: 6694,
  },
  {
    label: 'EC Council',
    value: 6695,
  },
  {
    label: 'Global Edge Software Ltd',
    value: 6696,
  },
  {
    label: 'Groots Technology',
    value: 6697,
  },
  {
    label: 'RehabPath',
    value: 6698,
  },
  {
    label: 'Kapture CRM',
    value: 6699,
  },
  {
    label: 'Deskfactors',
    value: 6700,
  },
  {
    label: 'CreditMantri Finserve Pvt Ltd',
    value: 6701,
  },
  {
    label: 'Kongsberg Digital',
    value: 6702,
  },
  {
    label: 'PMR Softtech Pvt. Ltd (Innovative Infotech )',
    value: 6703,
  },
  {
    label: 'Pesto.tech',
    value: 6704,
  },
  {
    label: 'Drivedge',
    value: 6705,
  },
  {
    label: 'SaaS Labs Inc.',
    value: 6706,
  },
  {
    label: 'Vmoksha Technologies',
    value: 6707,
  },
  {
    label: 'Carbazr',
    value: 6708,
  },
  {
    label: 'Tarento Technologies',
    value: 6709,
  },
  {
    label: 'ITMATIC',
    value: 6710,
  },
  {
    label: 'droom.in',
    value: 6711,
  },
  {
    label: 'Sandvine',
    value: 6712,
  },
  {
    label: 'Attra',
    value: 6713,
  },
  {
    label: 'GainInsights',
    value: 6714,
  },
  {
    label: 'IHS Markit',
    value: 6715,
  },
  {
    label: 'Lenskart',
    value: 6716,
  },
  {
    label: 'Telstra',
    value: 6717,
  },
  {
    label: 'Tech Connect',
    value: 6718,
  },
  {
    label: 'CMS',
    value: 6719,
  },
  {
    label: 'Nagaro',
    value: 6720,
  },
  {
    label: 'Marsh & McLennan',
    value: 6721,
  },
  {
    label: 'Blewminds',
    value: 6722,
  },
  {
    label: 'RaRa Delivery',
    value: 6723,
  },
  {
    label: 'TIBCO',
    value: 6724,
  },
  {
    label: 'ACT',
    value: 6725,
  },
  {
    label: 'Orion',
    value: 6726,
  },
  {
    label: 'Elucidata',
    value: 6727,
  },
  {
    label: 'Treebo',
    value: 6728,
  },
  {
    label: 'Info Edge',
    value: 6729,
  },
  {
    label: 'Joinyfy Placement',
    value: 6730,
  },
  {
    label: 'MPL Gaming',
    value: 6731,
  },
  {
    label: 'Kronos',
    value: 6732,
  },
  {
    label: 'iTelligence',
    value: 6733,
  },
  {
    label: 'Aequs',
    value: 6734,
  },
  {
    label: 'guidehouse.com',
    value: 6735,
  },
  {
    label: 'Tieto',
    value: 6736,
  },
  {
    label: '1RIVET INDIA LLP',
    value: 6737,
  },
  {
    label: 'Aaviyo Consulting Services',
    value: 6738,
  },
  {
    label: 'Accural Solution',
    value: 6739,
  },
  {
    label: 'Achievex Solutions Pvt Ltd',
    value: 6740,
  },
  {
    label: 'Anantara Solutions Pvt Ltd',
    value: 6741,
  },
  {
    label: 'Artisans Soft',
    value: 6742,
  },
  {
    label: 'Azul Systems India Pvt Ltd',
    value: 6743,
  },
  {
    label: 'Behavox',
    value: 6744,
  },
  {
    label: 'Branch',
    value: 6745,
  },
  {
    label: 'Cerebra IT Services Private Limited',
    value: 6746,
  },
  {
    label: 'Commscope',
    value: 6747,
  },
  {
    label: 'e-con Systems',
    value: 6748,
  },
  {
    label: 'EM Integra',
    value: 6749,
  },
  {
    label: 'Eshopbox',
    value: 6750,
  },
  {
    label: 'Flutura Business Solutions',
    value: 6751,
  },
  {
    label: 'Acube Business AND Technologies Solutions Private',
    value: 6752,
  },
  {
    label: 'HASHMAP TECH INDIA PVT. LTD.',
    value: 6753,
  },
  {
    label: 'Intelliquity Consulting',
    value: 6754,
  },
  {
    label: 'InTimeTec VisionSoft Pvt Ltd',
    value: 6755,
  },
  {
    label: 'itelligence India Software Solutions Pvt. Ltd.',
    value: 6756,
  },
  {
    label: 'Josh Software Pvt. Ltd.',
    value: 6757,
  },
  {
    label: 'Just Career Management Pvt.Ltd',
    value: 6758,
  },
  {
    label: 'Knowledgetics',
    value: 6759,
  },
  {
    label: 'Krazy Mantra HR Solutions Pvt. Ltd.',
    value: 6760,
  },
  {
    label: 'Kwalee',
    value: 6761,
  },
  {
    label: 'LiveMindz Services Private Limited',
    value: 6762,
  },
  {
    label: 'Marktine',
    value: 6763,
  },
  {
    label: 'MUBY TECHNOLOGIES',
    value: 6764,
  },
  {
    label: 'AFFIXIOUS CONSULTING PRIVATE LIMITED',
    value: 6765,
  },
  {
    label: 'Provakil',
    value: 6766,
  },
  {
    label: 'XAVICA SOFTWARE SOLUTIONS PRIVATE LIMITED',
    value: 6767,
  },
  {
    label: 'Raincode Labs India Pvt Limited',
    value: 6768,
  },
  {
    label: 'Skillmine Technology Consulting',
    value: 6769,
  },
  {
    label: 'SOZO Design Ltd',
    value: 6770,
  },
  {
    label: 'SVSJOBS',
    value: 6771,
  },
  {
    label: 'Synergics Solutions Pvt. Ltd',
    value: 6772,
  },
  {
    label: 'The CareerLabs',
    value: 6773,
  },
  {
    label: 'Carousell',
    value: 6774,
  },
  {
    label: 'V Group Consultancy Services Pvt Ltd',
    value: 6775,
  },
  {
    label: 'Vsquare Systems Pvt. Ltd.',
    value: 6776,
  },
  {
    label: 'Aeron Systems',
    value: 6777,
  },
  {
    label: 'My Placement Management Consultants',
    value: 6778,
  },
  {
    label: 'Jobs Expert Pvt. Ltd.',
    value: 6779,
  },
  {
    label: 'Bytecode Technologies',
    value: 6780,
  },
  {
    label: 'Cult HR',
    value: 6781,
  },
  {
    label: 'Cars24',
    value: 6782,
  },
  {
    label: 'INTEGRITY RESOURCE MANAGEMENT',
    value: 6783,
  },
  {
    label: 'Amicon Hub Services',
    value: 6784,
  },
  {
    label: 'Tambora Systems',
    value: 6785,
  },
  {
    label: 'Go Group (Braincurry Technologies Private Limited)',
    value: 6786,
  },
  {
    label: 'Revelin7 Technology Private Limited',
    value: 6787,
  },
  {
    label: '#Pride',
    value: 6788,
  },
  {
    label: 'Turing Labs Inc',
    value: 6789,
  },
  {
    label: 'Golden Red',
    value: 6790,
  },
  {
    label: 'Micron Technology India',
    value: 6791,
  },
  {
    label: 'Olive Group',
    value: 6792,
  },
  {
    label: 'Taylor and Francis',
    value: 6793,
  },
  {
    label: 'Oceaneering',
    value: 6794,
  },
  {
    label: 'Devon',
    value: 6795,
  },
  {
    label: 'Amagi',
    value: 6796,
  },
  {
    label: 'Scaler Academy',
    value: 6797,
  },
  {
    label: 'Backbase',
    value: 6798,
  },
  {
    label: 'IDeaS',
    value: 6799,
  },
  {
    label: 'TranZact',
    value: 6800,
  },
  {
    label: 'wfglobal.org',
    value: 6801,
  },
  {
    label: 'The Climber Knowledge and Careers Pvt Ltd',
    value: 6802,
  },
  {
    label: 'EDIIIE',
    value: 6803,
  },
  {
    label: 'Thrasio',
    value: 6804,
  },
  {
    label: 'STP',
    value: 6805,
  },
  {
    label: 'SentinelOne',
    value: 6806,
  },
  {
    label: 'Grappus Technologies Pvt. Ltd.',
    value: 6807,
  },
  {
    label: 'Resilient Tech',
    value: 6808,
  },
  {
    label: 'Vamstar',
    value: 6809,
  },
  {
    label: 'Tyler Petroleum Inc',
    value: 6810,
  },
  {
    label: 'Coinswitch Kuber',
    value: 6811,
  },
  {
    label: 'smallcase',
    value: 6812,
  },
  {
    label: 'Jupiter Money',
    value: 6813,
  },
  {
    label: 'phonepe',
    value: 6814,
  },
  {
    label: 'Groww',
    value: 6815,
  },
  {
    label: 'Khatabook',
    value: 6816,
  },
  {
    label: 'Bytelearn Edtech',
    value: 6817,
  },
  {
    label: 'Magic EdTech',
    value: 6818,
  },
  {
    label: 'Baazi Games',
    value: 6819,
  },
  {
    label: 'AB Inbev GCC',
    value: 6820,
  },
  {
    label: 'Peloton Group',
    value: 6821,
  },
  {
    label: 'OpenText',
    value: 6822,
  },
  {
    label: 'Zolve',
    value: 6823,
  },
  {
    label: 'MOURI Tech',
    value: 6824,
  },
  {
    label: 'Arcesium',
    value: 6825,
  },
  {
    label: 'Zeta Global',
    value: 6826,
  },
  {
    label: 'Netflix',
    value: 6827,
  },
  {
    label: 'Spinny',
    value: 6828,
  },
  {
    label: 'Slice',
    value: 6829,
  },
  {
    label: 'Digit Insurance',
    value: 6830,
  },
  {
    label: 'Rivigo',
    value: 6831,
  },
  {
    label: 'CarTrade',
    value: 6832,
  },
  {
    label: 'Housing.com',
    value: 6833,
  },
  {
    label: 'Amazon Seller Services',
    value: 6834,
  },
  {
    label: 'quikr.com',
    value: 6835,
  },
  {
    label: 'urbanladder.com',
    value: 6836,
  },
  {
    label: 'boAt',
    value: 6837,
  },
  {
    label: 'Navi Technologies',
    value: 6838,
  },
  {
    label: 'Zepto',
    value: 6839,
  },
  {
    label: 'Bharatpe',
    value: 6840,
  },
  {
    label: 'Teachmint',
    value: 6841,
  },
  {
    label: 'Mensa Brands',
    value: 6842,
  },
  {
    label: 'Global Bees',
    value: 6843,
  },
  {
    label: 'Zetwerk',
    value: 6844,
  },
  {
    label: 'Uni Cards',
    value: 6845,
  },
  {
    label: 'Getsimpl Technologies',
    value: 6846,
  },
  {
    label: 'Chingari',
    value: 6847,
  },
  {
    label: 'Livingfood.co',
    value: 6848,
  },
  {
    label: 'Trell',
    value: 6849,
  },
  {
    label: 'Geniemode',
    value: 6850,
  },
  {
    label: 'Nazara Technologies',
    value: 6851,
  },
  {
    label: 'Druva Software',
    value: 6852,
  },
  {
    label: 'Icertis',
    value: 6853,
  },
  {
    label: 'Ofbusiness',
    value: 6854,
  },
  {
    label: 'Aye Finance',
    value: 6855,
  },
  {
    label: 'Shipsy',
    value: 6856,
  },
  {
    label: 'OkCredit',
    value: 6857,
  },
  {
    label: 'GoKwik',
    value: 6858,
  },
  {
    label: 'ShareChat',
    value: 6859,
  },
  {
    label: 'Dailyhunt',
    value: 6860,
  },
  {
    label: 'Furlenco',
    value: 6861,
  },
  {
    label: 'Scripbox',
    value: 6862,
  },
  {
    label: 'NODWIN Gaming',
    value: 6863,
  },
  {
    label: 'NiYO Solutions',
    value: 6864,
  },
  {
    label: 'Instamojo',
    value: 6865,
  },
  {
    label: 'Cashify',
    value: 6866,
  },
  {
    label: 'Wow Momo',
    value: 6867,
  },
  {
    label: 'INDwealth',
    value: 6868,
  },
  {
    label: 'Curefoods',
    value: 6869,
  },
  {
    label: 'JioSaavn',
    value: 6870,
  },
  {
    label: 'Ninjacart',
    value: 6871,
  },
  {
    label: 'Glance',
    value: 6872,
  },
  {
    label: 'Infra.Market',
    value: 6873,
  },
  {
    label: 'Chaayos',
    value: 6874,
  },
  {
    label: 'Bounce',
    value: 6875,
  },
  {
    label: 'SHEROES',
    value: 6876,
  },
  {
    label: 'BookMyForex.com',
    value: 6877,
  },
  {
    label: 'Sapphire Foods',
    value: 6878,
  },
  {
    label: 'Voonik',
    value: 6879,
  },
  {
    label: 'Lybrate',
    value: 6880,
  },
  {
    label: 'Inshorts',
    value: 6881,
  },
  {
    label: 'Country Delight',
    value: 6882,
  },
  {
    label: 'Billdesk',
    value: 6883,
  },
  {
    label: 'Ola Money',
    value: 6884,
  },
  {
    label: 'ApnaPaisa',
    value: 6885,
  },
  {
    label: 'nurture.farm',
    value: 6886,
  },
  {
    label: 'Kuku FM',
    value: 6887,
  },
  {
    label: 'Amazon Wholesale India',
    value: 6888,
  },
  {
    label: 'Five Star Business Finance',
    value: 6889,
  },
  {
    label: 'Zostel',
    value: 6890,
  },
  {
    label: 'Milkbasket',
    value: 6891,
  },
  {
    label: 'RBL Bank',
    value: 6892,
  },
  {
    label: 'GoMechanic',
    value: 6893,
  },
  {
    label: 'HungerBox',
    value: 6894,
  },
  {
    label: 'Smartworks',
    value: 6895,
  },
  {
    label: 'mydukaan.io',
    value: 6896,
  },
  {
    label: 'Roposo',
    value: 6897,
  },
  {
    label: 'SBI Card',
    value: 6898,
  },
  {
    label: 'Jumbotail',
    value: 6899,
  },
  {
    label: 'JUSPAY',
    value: 6900,
  },
  {
    label: 'Captain Fresh',
    value: 6901,
  },
  {
    label: 'Classplus',
    value: 6902,
  },
  {
    label: 'Masai School',
    value: 6903,
  },
  {
    label: 'PlanetSpark',
    value: 6904,
  },
  {
    label: 'InterviewBit',
    value: 6905,
  },
  {
    label: 'PhableCare',
    value: 6906,
  },
  {
    label: 'Turtlemint',
    value: 6907,
  },
  {
    label: 'Ripplr',
    value: 6908,
  },
  {
    label: 'Freshtohome',
    value: 6909,
  },
  {
    label: 'YourStory',
    value: 6910,
  },
  {
    label: 'Stanza Living',
    value: 6911,
  },
  {
    label: 'Atomberg Technology',
    value: 6912,
  },
  {
    label: 'Leap',
    value: 6913,
  },
  {
    label: 'Airmeet',
    value: 6914,
  },
  {
    label: 'Eruditus Executive Education',
    value: 6915,
  },
  {
    label: 'Eggoz',
    value: 6916,
  },
  {
    label: 'ShopX',
    value: 6917,
  },
  {
    label: 'Locus.sh',
    value: 6918,
  },
  {
    label: 'HomeLane',
    value: 6919,
  },
  {
    label: 'Hero Electric',
    value: 6920,
  },
  {
    label: 'Gramophone',
    value: 6921,
  },
  {
    label: 'M2P Fintech',
    value: 6922,
  },
  {
    label: 'Momspresso',
    value: 6923,
  },
  {
    label: 'Route Mobile',
    value: 6924,
  },
  {
    label: 'Onsurity',
    value: 6925,
  },
  {
    label: 'Wakefit',
    value: 6926,
  },
  {
    label: 'Shopkirana',
    value: 6927,
  },
  {
    label: 'PagarBook',
    value: 6928,
  },
  {
    label: 'NestAway',
    value: 6929,
  },
  {
    label: 'Bira 91',
    value: 6930,
  },
  {
    label: 'Pee Safe',
    value: 6931,
  },
  {
    label: 'Biryani By Kilo',
    value: 6932,
  },
  {
    label: 'DocsApp',
    value: 6933,
  },
  {
    label: 'Neogrowth',
    value: 6934,
  },
  {
    label: 'The Man Company',
    value: 6935,
  },
  {
    label: 'Vistara',
    value: 6936,
  },
  {
    label: 'InsuranceDekho',
    value: 6937,
  },
  {
    label: 'Sleepy Owl Coffee',
    value: 6938,
  },
  {
    label: 'Guardian Link',
    value: 6939,
  },
  {
    label: 'KrazyBee',
    value: 6940,
  },
  {
    label: 'Indiabulls Housing Finance Limited',
    value: 6941,
  },
  {
    label: 'FreshMenu',
    value: 6942,
  },
  {
    label: 'Hopscotch',
    value: 6943,
  },
  {
    label: 'LoanTap',
    value: 6944,
  },
  {
    label: 'Eupheus Learning',
    value: 6945,
  },
  {
    label: 'M1xchange',
    value: 6946,
  },
  {
    label: 'Little Black Book',
    value: 6947,
  },
  {
    label: 'Zopper',
    value: 6948,
  },
  {
    label: 'SigTuple',
    value: 6949,
  },
  {
    label: 'Unbxd',
    value: 6950,
  },
  {
    label: 'SOLV',
    value: 6951,
  },
  {
    label: 'inFeedo',
    value: 6952,
  },
  {
    label: 'Jugnoo',
    value: 6953,
  },
  {
    label: 'TATA Projects',
    value: 6954,
  },
  {
    label: 'Awfis Space Solution',
    value: 6955,
  },
  {
    label: 'PlaySimple Games',
    value: 6956,
  },
  {
    label: 'Craftsvilla',
    value: 6957,
  },
  {
    label: 'PayMate',
    value: 6958,
  },
  {
    label: 'Hero Future Energies',
    value: 6959,
  },
  {
    label: 'Utkarsh Small Finance Bank',
    value: 6960,
  },
  {
    label: 'airpay',
    value: 6961,
  },
  {
    label: 'Fitterfly',
    value: 6962,
  },
  {
    label: 'Nayara Energy',
    value: 6963,
  },
  {
    label: 'Msupply.com',
    value: 6964,
  },
  {
    label: 'FundsIndia',
    value: 6965,
  },
  {
    label: 'Grow Fit',
    value: 6966,
  },
  {
    label: 'Appario Retail',
    value: 6967,
  },
  {
    label: 'SuperProfs',
    value: 6968,
  },
  {
    label: 'Fintellix Solutions',
    value: 6969,
  },
  {
    label: 'Printvenue',
    value: 6970,
  },
  {
    label: 'TheMathCompany',
    value: 6971,
  },
  {
    label: 'Autoninja',
    value: 6972,
  },
  {
    label: 'Mindgate',
    value: 6973,
  },
  {
    label: 'Tyroo',
    value: 6974,
  },
  {
    label: 'Flochat',
    value: 6975,
  },
  {
    label: 'Zipdial',
    value: 6976,
  },
  {
    label: 'Grip Invest',
    value: 6977,
  },
  {
    label: 'TenderCuts',
    value: 6978,
  },
  {
    label: 'WinZO',
    value: 6979,
  },
  {
    label: 'ReNew Power',
    value: 6980,
  },
  {
    label: 'Ultraviolette Automotive',
    value: 6981,
  },
  {
    label: 'Quizizz',
    value: 6982,
  },
  {
    label: 'SK Finance',
    value: 6983,
  },
  {
    label: 'MyMoneyMantra',
    value: 6984,
  },
  {
    label: 'Velocity',
    value: 6985,
  },
  {
    label: 'ElasticRun',
    value: 6986,
  },
  {
    label: 'Frnd',
    value: 6987,
  },
  {
    label: 'Rooter',
    value: 6988,
  },
  {
    label: 'Skill Lync',
    value: 6989,
  },
  {
    label: 'NephroPlus',
    value: 6990,
  },
  {
    label: 'Unbox Robotics',
    value: 6991,
  },
  {
    label: 'Skit',
    value: 6992,
  },
  {
    label: 'Fi.Money',
    value: 6993,
  },
  {
    label: 'Practically',
    value: 6994,
  },
  {
    label: 'Clensta',
    value: 6995,
  },
  {
    label: 'Animall',
    value: 6996,
  },
  {
    label: 'CredAvenue',
    value: 6997,
  },
  {
    label: 'Euler Motors',
    value: 6998,
  },
  {
    label: 'Koo App',
    value: 6999,
  },
  {
    label: 'RenewBuy',
    value: 7000,
  },
  {
    label: 'Fashinza',
    value: 7001,
  },
  {
    label: 'FrontRow',
    value: 7002,
  },
  {
    label: 'Plum',
    value: 7003,
  },
  {
    label: 'CHARGE+ZONE',
    value: 7004,
  },
  {
    label: 'Zypp Electric',
    value: 7005,
  },
  {
    label: 'FloBiz',
    value: 7006,
  },
  {
    label: 'GetMega',
    value: 7007,
  },
  {
    label: 'DMI Finance Private Limited',
    value: 7008,
  },
  {
    label: 'Medikabazaar',
    value: 7009,
  },
  {
    label: 'GlowRoad',
    value: 7010,
  },
  {
    label: 'NowFloats',
    value: 7011,
  },
  {
    label: 'Eduvanz',
    value: 7012,
  },
  {
    label: 'Play Shifu',
    value: 7013,
  },
  {
    label: 'Setu',
    value: 7014,
  },
  {
    label: 'Mswipe Technologies',
    value: 7015,
  },
  {
    label: 'LoveLocal (formerly m.Paani)',
    value: 7016,
  },
  {
    label: 'Arzooo.com',
    value: 7017,
  },
  {
    label: 'Fraazo',
    value: 7018,
  },
  {
    label: 'BeatO',
    value: 7019,
  },
  {
    label: 'VVDN Technologies',
    value: 7020,
  },
  {
    label: 'CredAble',
    value: 7021,
  },
  {
    label: 'Unocoin',
    value: 7022,
  },
  {
    label: 'Coverfox Insurance',
    value: 7023,
  },
  {
    label: 'Go Colors',
    value: 7024,
  },
  {
    label: 'CredR',
    value: 7025,
  },
  {
    label: 'Entri',
    value: 7026,
  },
  {
    label: 'Riskcovry',
    value: 7027,
  },
  {
    label: 'Samunnati',
    value: 7028,
  },
  {
    label: 'Veritas Finance',
    value: 7029,
  },
  {
    label: 'Nua',
    value: 7030,
  },
  {
    label: 'ePaylater',
    value: 7031,
  },
  {
    label: 'Newgen Software Technologies',
    value: 7032,
  },
  {
    label: 'Pando',
    value: 7033,
  },
  {
    label: 'O4S',
    value: 7034,
  },
  {
    label: 'Chqbook',
    value: 7035,
  },
  {
    label: 'Kaleidofin',
    value: 7036,
  },
  {
    label: 'Questt',
    value: 7037,
  },
  {
    label: 'fleetx.io',
    value: 7038,
  },
  {
    label: 'TVF',
    value: 7039,
  },
  {
    label: 'Synapsica Healthcare Inc.',
    value: 7040,
  },
  {
    label: 'Stellar Value Chain Solutions',
    value: 7041,
  },
  {
    label: 'Propelld',
    value: 7042,
  },
  {
    label: 'Stellapps',
    value: 7043,
  },
  {
    label: 'Recko',
    value: 7044,
  },
  {
    label: 'eBikeGo',
    value: 7045,
  },
  {
    label: 'Sanfe',
    value: 7046,
  },
  {
    label: 'Detect Technologies',
    value: 7047,
  },
  {
    label: 'Revv',
    value: 7048,
  },
  {
    label: 'Drivezy',
    value: 7049,
  },
  {
    label: 'Industrybuying',
    value: 7050,
  },
  {
    label: 'FabAlley',
    value: 7051,
  },
  {
    label: 'Rocketium',
    value: 7052,
  },
  {
    label: 'Blowhorn',
    value: 7053,
  },
  {
    label: 'Fittr',
    value: 7054,
  },
  {
    label: 'Medusind Solutions',
    value: 7055,
  },
  {
    label: 'Lendbox',
    value: 7056,
  },
  {
    label: 'AppsForBharat',
    value: 7057,
  },
  {
    label: 'Kuvera.in',
    value: 7058,
  },
  {
    label: 'ekincare',
    value: 7059,
  },
  {
    label: 'Crofarm',
    value: 7060,
  },
  {
    label: 'Wildcraft India Pvt Ltd',
    value: 7061,
  },
  {
    label: 'Visit',
    value: 7062,
  },
  {
    label: 'Chumbak',
    value: 7063,
  },
  {
    label: 'WMall (Blitzscale Technologies)',
    value: 7064,
  },
  {
    label: 'InnerChef',
    value: 7065,
  },
  {
    label: 'IndianMoney',
    value: 7066,
  },
  {
    label: 'DRIVEU',
    value: 7067,
  },
  {
    label: 'AdPushup',
    value: 7068,
  },
  {
    label: 'Duroflex',
    value: 7069,
  },
  {
    label: 'Dhurina',
    value: 7070,
  },
  {
    label: 'Dr Lal PathLabs',
    value: 7071,
  },
  {
    label: 'StoreKing',
    value: 7072,
  },
  {
    label: 'MoveInSync',
    value: 7073,
  },
  {
    label: 'Vayana Network Services Pvt Ltd.',
    value: 7074,
  },
  {
    label: 'Banyan Nation',
    value: 7075,
  },
  {
    label: 'iNurture',
    value: 7076,
  },
  {
    label: 'ZappFresh',
    value: 7077,
  },
  {
    label: 'Bombay Shirt Company',
    value: 7078,
  },
  {
    label: 'Browntape',
    value: 7079,
  },
  {
    label: 'DailyNinja',
    value: 7080,
  },
  {
    label: 'EkAnek Networks',
    value: 7081,
  },
  {
    label: 'Teabox',
    value: 7082,
  },
  {
    label: 'Senseforth',
    value: 7083,
  },
  {
    label: 'Vahan',
    value: 7084,
  },
  {
    label: 'Rubique',
    value: 7085,
  },
  {
    label: 'RedCarpetUp',
    value: 7086,
  },
  {
    label: 'Crediwatch',
    value: 7087,
  },
  {
    label: 'CRON Systems',
    value: 7088,
  },
  {
    label: 'Canvera Digital Technologies',
    value: 7089,
  },
  {
    label: 'Faircent',
    value: 7090,
  },
  {
    label: 'Intelligence Node',
    value: 7091,
  },
  {
    label: 'Vokal',
    value: 7092,
  },
  {
    label: 'Ecozen',
    value: 7093,
  },
  {
    label: 'Wooden Street',
    value: 7094,
  },
  {
    label: 'HealthAssure',
    value: 7095,
  },
  {
    label: 'SparesHub',
    value: 7096,
  },
  {
    label: 'Shoptimize India',
    value: 7097,
  },
  {
    label: 'Rentickle',
    value: 7098,
  },
  {
    label: 'Myra',
    value: 7099,
  },
  {
    label: 'Wishberry',
    value: 7100,
  },
  {
    label: 'TurboHire Technologies',
    value: 7101,
  },
  {
    label: 'Wholesalebox',
    value: 7102,
  },
  {
    label: 'Avanti Learning Centres',
    value: 7103,
  },
  {
    label: 'The Label Life',
    value: 7104,
  },
  {
    label: 'Qbera',
    value: 7105,
  },
  {
    label: 'Shortlist',
    value: 7106,
  },
  {
    label: 'Haber',
    value: 7107,
  },
  {
    label: 'Property Share Online Platform',
    value: 7108,
  },
  {
    label: 'Computer Age Management Services',
    value: 7109,
  },
  {
    label: 'The American Swan Lifestyle Company',
    value: 7110,
  },
  {
    label: 'Goomo.com',
    value: 7111,
  },
  {
    label: 'DotPe',
    value: 7112,
  },
  {
    label: 'MySmartPrice',
    value: 7113,
  },
  {
    label: 'HolidayIQ',
    value: 7114,
  },
  {
    label: 'MoneyTap',
    value: 7115,
  },
  {
    label: 'Broex.in',
    value: 7116,
  },
  {
    label: 'Generico',
    value: 7117,
  },
  {
    label: 'Unotech Software',
    value: 7118,
  },
  {
    label: 'CreditVidya',
    value: 7119,
  },
  {
    label: 'Autosys',
    value: 7120,
  },
  {
    label: 'RezNext',
    value: 7121,
  },
  {
    label: 'Vinculum Group',
    value: 7122,
  },
  {
    label: 'Buddy4Study.com',
    value: 7123,
  },
  {
    label: 'Winjit Technologies',
    value: 7124,
  },
  {
    label: 'Asteria Aerospace',
    value: 7125,
  },
  {
    label: 'DeltaX',
    value: 7126,
  },
  {
    label: 'AXISCADES',
    value: 7127,
  },
  {
    label: 'Careers360',
    value: 7128,
  },
  {
    label: 'Bitla Software Pvt Ltd',
    value: 7129,
  },
  {
    label: 'PressPlay',
    value: 7130,
  },
  {
    label: 'MyAdvo',
    value: 7131,
  },
  {
    label: 'Vastu Housing Finance',
    value: 7132,
  },
  {
    label: 'Rupifi',
    value: 7133,
  },
  {
    label: 'UpScalio',
    value: 7134,
  },
  {
    label: 'Financepeer',
    value: 7135,
  },
  {
    label: 'Neuphony',
    value: 7136,
  },
  {
    label: 'NirogStreet',
    value: 7137,
  },
  {
    label: 'StockGro',
    value: 7138,
  },
  {
    label: 'Salesken',
    value: 7139,
  },
  {
    label: '1K Kirana Bazaar',
    value: 7140,
  },
  {
    label: 'Bureau',
    value: 7141,
  },
  {
    label: 'Log 9 Materials',
    value: 7142,
  },
  {
    label: 'InCred',
    value: 7143,
  },
  {
    label: 'Taskmo',
    value: 7144,
  },
  {
    label: 'ReshaMandi',
    value: 7145,
  },
  {
    label: 'Rusk Media',
    value: 7146,
  },
  {
    label: 'Annapurna Finance',
    value: 7147,
  },
  {
    label: 'Star Health and Allied Insurance',
    value: 7148,
  },
  {
    label: 'indiagold',
    value: 7149,
  },
  {
    label: 'Pratilipi',
    value: 7150,
  },
  {
    label: 'Satya MicroCapital',
    value: 7151,
  },
  {
    label: 'Progcap',
    value: 7152,
  },
  {
    label: 'Wysa',
    value: 7153,
  },
  {
    label: 'Freight Tiger',
    value: 7154,
  },
  {
    label: 'BetterPlace Safety Solutions',
    value: 7155,
  },
  {
    label: 'FlipItNews',
    value: 7156,
  },
  {
    label: 'Clovia',
    value: 7157,
  },
  {
    label: 'LivFin',
    value: 7158,
  },
  {
    label: 'Virohan',
    value: 7159,
  },
  {
    label: 'Nova Benefits',
    value: 7160,
  },
  {
    label: 'Holisol logistics',
    value: 7161,
  },
  {
    label: 'Arrivae',
    value: 7162,
  },
  {
    label: 'Otipy',
    value: 7163,
  },
  {
    label: 'CleanMax',
    value: 7164,
  },
  {
    label: 'NanoNets',
    value: 7165,
  },
  {
    label: 'Fyle',
    value: 7166,
  },
  {
    label: 'Newton School',
    value: 7167,
  },
  {
    label: 'value Fresh Food',
    value: 7168,
  },
  {
    label: 'Yellow Class',
    value: 7169,
  },
  {
    label: 'Kutumb',
    value: 7170,
  },
  {
    label: 'Public App',
    value: 7171,
  },
  {
    label: 'Entropik Technology',
    value: 7172,
  },
  {
    label: 'Vegrow',
    value: 7173,
  },
  {
    label: 'Agnikul',
    value: 7174,
  },
  {
    label: 'MedGenome',
    value: 7175,
  },
  {
    label: 'FarMart',
    value: 7176,
  },
  {
    label: 'Travelurcity',
    value: 7177,
  },
  {
    label: 'Money View',
    value: 7178,
  },
  {
    label: 'BangDB',
    value: 7179,
  },
  {
    label: 'Lokal',
    value: 7180,
  },
  {
    label: 'Fusion Microfinance',
    value: 7181,
  },
  {
    label: 'Skillmatics',
    value: 7182,
  },
  {
    label: 'goStops',
    value: 7183,
  },
  {
    label: 'WeRize',
    value: 7184,
  },
  {
    label: 'Revos',
    value: 7185,
  },
  {
    label: 'Even',
    value: 7186,
  },
  {
    label: 'Airblack',
    value: 7187,
  },
  {
    label: 'StackBOX',
    value: 7188,
  },
  {
    label: 'Wefast',
    value: 7189,
  },
  {
    label: 'Home First Finance Company',
    value: 7190,
  },
  {
    label: 'Unnati',
    value: 7191,
  },
  {
    label: 'Easebuzz',
    value: 7192,
  },
  {
    label: 'Toch',
    value: 7193,
  },
  {
    label: 'Pharmarack',
    value: 7194,
  },
  {
    label: 'Loop Health',
    value: 7195,
  },
  {
    label: 'Ergos',
    value: 7196,
  },
  {
    label: 'Verloop.io',
    value: 7197,
  },
  {
    label: 'SMECorner',
    value: 7198,
  },
  {
    label: 'Mintifi',
    value: 7199,
  },
  {
    label: 'Plix Life',
    value: 7200,
  },
  {
    label: 'Themomsco',
    value: 7201,
  },
  {
    label: 'Epigamia',
    value: 7202,
  },
  {
    label: 'HalaPlay Technologies',
    value: 7203,
  },
  {
    label: 'Veefin',
    value: 7204,
  },
  {
    label: 'Muthoot Microfin',
    value: 7205,
  },
  {
    label: 'True Elements',
    value: 7206,
  },
  {
    label: 'Flexmoney',
    value: 7207,
  },
  {
    label: 'Breathe Well-being',
    value: 7208,
  },
  {
    label: 'Happyeasygo Group',
    value: 7209,
  },
  {
    label: 'Editorji',
    value: 7210,
  },
  {
    label: 'Smart Joules',
    value: 7211,
  },
  {
    label: '9stacks',
    value: 7212,
  },
  {
    label: 'Shipway Technology',
    value: 7213,
  },
  {
    label: 'boodmo',
    value: 7214,
  },
  {
    label: 'Nestasia',
    value: 7215,
  },
  {
    label: 'Pure EV',
    value: 7216,
  },
  {
    label: 'Light Microfinance',
    value: 7217,
  },
  {
    label: 'Headfone',
    value: 7218,
  },
  {
    label: 'pumpumpum',
    value: 7219,
  },
  {
    label: 'ABL Workspaces',
    value: 7220,
  },
  {
    label: 'Magenta',
    value: 7221,
  },
  {
    label: 'Doxper',
    value: 7222,
  },
  {
    label: 'Jindal Stainless',
    value: 7223,
  },
  {
    label: 'Manipal Hospitals',
    value: 7224,
  },
  {
    label: 'Infinite Uptime',
    value: 7225,
  },
  {
    label: 'Moneyboxx Finance',
    value: 7226,
  },
  {
    label: 'Truemeds',
    value: 7227,
  },
  {
    label: 'Instoried',
    value: 7228,
  },
  {
    label: 'PaySense',
    value: 7229,
  },
  {
    label: 'SuperZop',
    value: 7230,
  },
  {
    label: 'GramCover',
    value: 7231,
  },
  {
    label: 'Tring',
    value: 7232,
  },
  {
    label: 'JSW Cement',
    value: 7233,
  },
  {
    label: 'UrbanKisaan',
    value: 7234,
  },
  {
    label: 'Easy Home Finance',
    value: 7235,
  },
  {
    label: 'NIRAMAI Health Analytix',
    value: 7236,
  },
  {
    label: 'Koovs',
    value: 7237,
  },
  {
    label: 'Ascent Health & Wellness Solutions',
    value: 7238,
  },
  {
    label: 'NxtGen Data Center & Cloud Services',
    value: 7239,
  },
  {
    label: 'Hashtag Loyalty',
    value: 7240,
  },
  {
    label: 'Ayu Health',
    value: 7241,
  },
  {
    label: '90+ My Tuition App',
    value: 7242,
  },
  {
    label: 'Glamyo Health',
    value: 7243,
  },
  {
    label: 'Gourmet Garden',
    value: 7244,
  },
  {
    label: 'Muthoot Finance',
    value: 7245,
  },
  {
    label: 'Aptus Value Housing Finance India',
    value: 7246,
  },
  {
    label: 'Payswiff',
    value: 7247,
  },
  {
    label: 'Basic Home Loan',
    value: 7248,
  },
  {
    label: 'Boonbox',
    value: 7249,
  },
  {
    label: 'Aknamed',
    value: 7250,
  },
  {
    label: 'Fingerlix',
    value: 7251,
  },
  {
    label: 'Avaada Energy',
    value: 7252,
  },
  {
    label: 'Finova Capital',
    value: 7253,
  },
  {
    label: 'Fincare Small Finance Bank',
    value: 7254,
  },
  {
    label: 'Cell Propulsion',
    value: 7255,
  },
  {
    label: 'YPay Card',
    value: 7256,
  },
  {
    label: 'Arcana Network',
    value: 7257,
  },
  {
    label: 'Good Dot',
    value: 7258,
  },
  {
    label: 'Ameyo',
    value: 7259,
  },
  {
    label: 'Text Mercato',
    value: 7260,
  },
  {
    label: 'MyClassboard',
    value: 7261,
  },
  {
    label: 'Ampere Vehicles',
    value: 7262,
  },
  {
    label: 'PayGlocal Technologies',
    value: 7263,
  },
  {
    label: 'Cube',
    value: 7264,
  },
  {
    label: 'Cashflo',
    value: 7265,
  },
  {
    label: 'Abhibus',
    value: 7266,
  },
  {
    label: 'Tjori',
    value: 7267,
  },
  {
    label: 'Genworks Health',
    value: 7268,
  },
  {
    label: 'Pandorum Technologies',
    value: 7269,
  },
  {
    label: 'MyShubhLife',
    value: 7270,
  },
  {
    label: 'Ayana Renewable Power',
    value: 7271,
  },
  {
    label: 'FamPay',
    value: 7272,
  },
  {
    label: 'Svasti Microfinance',
    value: 7273,
  },
  {
    label: 'Bharat Biotech',
    value: 7274,
  },
  {
    label: 'Sanctum Wealth Management',
    value: 7275,
  },
  {
    label: 'Open App',
    value: 7276,
  },
  {
    label: 'Etrio',
    value: 7277,
  },
  {
    label: 'CreditMate',
    value: 7278,
  },
  {
    label: 'Zvolv',
    value: 7279,
  },
  {
    label: 'CiSApp',
    value: 7280,
  },
  {
    label: 'Freightwalla',
    value: 7281,
  },
  {
    label: 'TVS Automobile Solutions',
    value: 7282,
  },
  {
    label: 'IntrCity',
    value: 7283,
  },
  {
    label: 'Capital Float',
    value: 7284,
  },
  {
    label: 'Medkart Pharmacy',
    value: 7285,
  },
  {
    label: 'Niyogin Fintech Ltd.',
    value: 7286,
  },
  {
    label: 'Kisan Network',
    value: 7287,
  },
  {
    label: '1 India Family Mart',
    value: 7288,
  },
  {
    label: 'Yaantra',
    value: 7289,
  },
  {
    label: 'Fingpay',
    value: 7290,
  },
  {
    label: 'LockTheDeal',
    value: 7291,
  },
  {
    label: 'Renee Cosmetics',
    value: 7292,
  },
  {
    label: 'GUSEC',
    value: 7293,
  },
  {
    label: 'FanFight',
    value: 7294,
  },
  {
    label: 'CMR',
    value: 7295,
  },
  {
    label: 'ERPNext',
    value: 7296,
  },
  {
    label: 'Piggy',
    value: 7297,
  },
  {
    label: 'APAC Financial Services',
    value: 7298,
  },
  {
    label: 'ChainSwap',
    value: 7299,
  },
  {
    label: 'Kaar Technologies',
    value: 7300,
  },
  {
    label: 'LifCare',
    value: 7301,
  },
  {
    label: 'Gegadyne Energy',
    value: 7302,
  },
  {
    label: 'Yapan Bio',
    value: 7303,
  },
  {
    label: 'Curatio Healthcare',
    value: 7304,
  },
  {
    label: 'TartanSense',
    value: 7305,
  },
  {
    label: 'MaxWholesale',
    value: 7306,
  },
  {
    label: 'Cron AI',
    value: 7307,
  },
  {
    label: 'Utter',
    value: 7308,
  },
  {
    label: 'Upwards Fintech',
    value: 7309,
  },
  {
    label: 'Greenjoules',
    value: 7310,
  },
  {
    label: 'FanPlay Technologies',
    value: 7311,
  },
  {
    label: 'Goals101',
    value: 7312,
  },
  {
    label: 'MoneyOnMobile',
    value: 7313,
  },
  {
    label: 'Colive.in',
    value: 7314,
  },
  {
    label: 'PublicVibe',
    value: 7315,
  },
  {
    label: 'IndoStar Capital',
    value: 7316,
  },
  {
    label: 'PlayerzPot',
    value: 7317,
  },
  {
    label: 'Kyte',
    value: 7318,
  },
  {
    label: 'Trinkerr',
    value: 7319,
  },
  {
    label: 'Hansel.io',
    value: 7320,
  },
  {
    label: 'ZO Rooms',
    value: 7321,
  },
  {
    label: 'Hasura',
    value: 7322,
  },
  {
    label: 'Altizon Systems',
    value: 7323,
  },
  {
    label: 'Finzy',
    value: 7324,
  },
  {
    label: 'Jigsaw Academy',
    value: 7325,
  },
  {
    label: 'Burger Singh',
    value: 7326,
  },
  {
    label: 'Vidyakul',
    value: 7327,
  },
  {
    label: 'CoinTribe Technologies',
    value: 7328,
  },
  {
    label: 'Setu Nutrition',
    value: 7329,
  },
  {
    label: 'DanaMojo',
    value: 7330,
  },
  {
    label: 'StalkBuyLove',
    value: 7331,
  },
  {
    label: 'Phi Commerce Pvt Ltd',
    value: 7332,
  },
  {
    label: 'Univariety',
    value: 7333,
  },
  {
    label: 'BalleBaazi',
    value: 7334,
  },
  {
    label: '6Degree',
    value: 7335,
  },
  {
    label: 'Ultrahuman',
    value: 7336,
  },
  {
    label: 'Mynvax',
    value: 7337,
  },
  {
    label: 'IncNut Digital',
    value: 7338,
  },
  {
    label: 'Arvind Internet Limited',
    value: 7339,
  },
  {
    label: 'Doubtnut',
    value: 7340,
  },
  {
    label: 'Titan',
    value: 7341,
  },
  {
    label: 'Core Diagnostics',
    value: 7342,
  },
  {
    label: 'TyresNmore.com',
    value: 7343,
  },
  {
    label: 'KOOH Sports',
    value: 7344,
  },
  {
    label: 'EduBridge',
    value: 7345,
  },
  {
    label: 'Online PSB Loans',
    value: 7346,
  },
  {
    label: 'Gully Network Retail',
    value: 7347,
  },
  {
    label: 'Transaction Solutions International (India) Pvt Ltd',
    value: 7348,
  },
  {
    label: 'Wysh',
    value: 7349,
  },
  {
    label: 'FastFox',
    value: 7350,
  },
  {
    label: 'LOGOS India',
    value: 7351,
  },
  {
    label: 'i2ifunding',
    value: 7352,
  },
  {
    label: 'New Street Technologies',
    value: 7353,
  },
  {
    label: 'HealWell24',
    value: 7354,
  },
  {
    label: 'Bert Labs',
    value: 7355,
  },
  {
    label: 'simsim',
    value: 7356,
  },
  {
    label: 'OnlineTyari',
    value: 7357,
  },
  {
    label: 'TagBox',
    value: 7358,
  },
  {
    label: 'Astrome Technologies Private Limited',
    value: 7359,
  },
  {
    label: 'GameEon Studios',
    value: 7360,
  },
  {
    label: 'Glint',
    value: 7361,
  },
  {
    label: 'Asirvad Microfinance',
    value: 7362,
  },
  {
    label: 'LegalWiz.in',
    value: 7363,
  },
  {
    label: 'Slang Labs',
    value: 7364,
  },
  {
    label: 'Paytm Insurance',
    value: 7365,
  },
  {
    label: 'CureSkin',
    value: 7366,
  },
  {
    label: 'Toolsvilla',
    value: 7367,
  },
  {
    label: '3rdFlix',
    value: 7368,
  },
  {
    label: 'Enparadigm',
    value: 7369,
  },
  {
    label: 'Crowdfire Inc',
    value: 7370,
  },
  {
    label: 'Tripeur',
    value: 7371,
  },
  {
    label: 'Haus and Kinder',
    value: 7372,
  },
  {
    label: 'Qure AI',
    value: 7373,
  },
  {
    label: 'Helloworld Technologies India',
    value: 7374,
  },
  {
    label: 'Armoney.com',
    value: 7375,
  },
  {
    label: 'Pi Green Innovations',
    value: 7376,
  },
  {
    label: 'Ambr',
    value: 7377,
  },
  {
    label: 'ABSENTIA',
    value: 7378,
  },
  {
    label: 'Spark.Live',
    value: 7379,
  },
  {
    label: 'NSE Data & Analytics',
    value: 7380,
  },
  {
    label: 'Parentune',
    value: 7381,
  },
  {
    label: 'Arcatron Mobility',
    value: 7382,
  },
  {
    label: 'Cash Suvidha',
    value: 7383,
  },
  {
    label: 'Leap India Food Logistics',
    value: 7384,
  },
  {
    label: 'GoApptiv',
    value: 7385,
  },
  {
    label: 'iValue InfoSolutions',
    value: 7386,
  },
  {
    label: 'BharatRohan',
    value: 7387,
  },
  {
    label: 'Digiperform',
    value: 7388,
  },
  {
    label: 'UzhavarBumi',
    value: 7389,
  },
  {
    label: 'Chillr',
    value: 7390,
  },
  {
    label: 'LegalRaasta',
    value: 7391,
  },
  {
    label: 'Vserv',
    value: 7392,
  },
  {
    label: 'IDinsight',
    value: 7393,
  },
  {
    label: 'Amazon Web Services',
    value: 7394,
  },
  {
    label: 'Edelweiss Global Investment Advisors',
    value: 7395,
  },
  {
    label: 'Hospals',
    value: 7396,
  },
  {
    label: 'Basil Systems',
    value: 7397,
  },
  {
    label: 'Ask Group',
    value: 7398,
  },
  {
    label: 'Primacy Industries',
    value: 7399,
  },
  {
    label: 'Polestar Solutions',
    value: 7400,
  },
  {
    label: 'Hypermine',
    value: 7401,
  },
  {
    label: 'LT Foods',
    value: 7402,
  },
  {
    label: 'Freshworld',
    value: 7403,
  },
  {
    label: 'Sascan Meditech',
    value: 7404,
  },
  {
    label: 'QuaQua Experiences Private Limited',
    value: 7405,
  },
  {
    label: 'AEON Learning',
    value: 7406,
  },
  {
    label: 'Tractor Junction',
    value: 7407,
  },
  {
    label: 'Dineout',
    value: 7408,
  },
  {
    label: 'DoorMint',
    value: 7409,
  },
  {
    label: 'Mobileware Technologies',
    value: 7410,
  },
  {
    label: 'Propstack',
    value: 7411,
  },
  {
    label: 'Electronic Payment and Services',
    value: 7412,
  },
  {
    label: 'HealthSignz',
    value: 7413,
  },
  {
    label: 'Genext Students Limited',
    value: 7414,
  },
  {
    label: 'DogSpot',
    value: 7415,
  },
  {
    label: 'Robo Bionics',
    value: 7416,
  },
  {
    label: 'Gurusiksha',
    value: 7417,
  },
  {
    label: 'School of Accelerated Learning',
    value: 7418,
  },
  {
    label: 'myCFO',
    value: 7419,
  },
  {
    label: 'Ace Turtle',
    value: 7420,
  },
  {
    label: 'KrishiHub',
    value: 7421,
  },
  {
    label: 'Refyne',
    value: 7422,
  },
  {
    label: 'Makers Hive Innovations',
    value: 7423,
  },
  {
    label: 'Cyclops Medtech',
    value: 7424,
  },
  {
    label: 'WitBlox',
    value: 7425,
  },
  {
    label: 'NOOS Technologies',
    value: 7426,
  },
  {
    label: 'VAAN Mobility',
    value: 7427,
  },
  {
    label: 'Bikayi',
    value: 7428,
  },
  {
    label: 'CultYvate',
    value: 7429,
  },
  {
    label: 'DRIVO',
    value: 7430,
  },
  {
    label: 'KarmaLifeAI',
    value: 7431,
  },
  {
    label: 'Placio',
    value: 7432,
  },
  {
    label: 'PGO',
    value: 7433,
  },
  {
    label: 'Cellfish',
    value: 7434,
  },
  {
    label: 'The Souled Store',
    value: 7435,
  },
  {
    label: 'GoWork India',
    value: 7436,
  },
  {
    label: 'MultiLiving',
    value: 7437,
  },
  {
    label: 'CBREX',
    value: 7438,
  },
  {
    label: 'Zvesta',
    value: 7439,
  },
  {
    label: 'GreenPod Labs',
    value: 7440,
  },
  {
    label: 'Lazy Co.',
    value: 7441,
  },
  {
    label: 'Bootstart',
    value: 7442,
  },
  {
    label: 'United Bank',
    value: 7443,
  },
  {
    label: 'Ridlr',
    value: 7444,
  },
  {
    label: 'Buildpan',
    value: 7445,
  },
  {
    label: 'Auxesis Group',
    value: 7446,
  },
  {
    label: 'GoFro',
    value: 7447,
  },
  {
    label: 'Digital Green',
    value: 7448,
  },
  {
    label: 'Vyapar App',
    value: 7449,
  },
  {
    label: 'Crossroads',
    value: 7450,
  },
  {
    label: 'Kheyti',
    value: 7451,
  },
  {
    label: 'Netafim Agricultural Financing Agency',
    value: 7452,
  },
  {
    label: 'nTalents.ai',
    value: 7453,
  },
  {
    label: 'Pennar Engineered Building Systems',
    value: 7454,
  },
  {
    label: 'Customfurnish.com',
    value: 7455,
  },
  {
    label: 'Frrole',
    value: 7456,
  },
  {
    label: 'MoNeed',
    value: 7457,
  },
  {
    label: 'MITASHI',
    value: 7458,
  },
  {
    label: 'Probus Smart Things',
    value: 7459,
  },
  {
    label: 'AUTOLY',
    value: 7460,
  },
  {
    label: 'Karadi Path',
    value: 7461,
  },
  {
    label: 'AutoNxt Automation',
    value: 7462,
  },
  {
    label: 'VMate',
    value: 7463,
  },
  {
    label: 'IVF Access',
    value: 7464,
  },
  {
    label: 'OLX Group',
    value: 7465,
  },
  {
    label: 'Radio One',
    value: 7466,
  },
  {
    label: 'NEERX',
    value: 7467,
  },
  {
    label: 'JR Compliance and Testing Labs',
    value: 7468,
  },
  {
    label: 'Footprints Childcare',
    value: 7469,
  },
  {
    label: 'MotoFlux',
    value: 7470,
  },
  {
    label: 'payAgri',
    value: 7471,
  },
  {
    label: 'Veri5Digital',
    value: 7472,
  },
  {
    label: 'Max Financial Services',
    value: 7473,
  },
  {
    label: 'Keyboor',
    value: 7474,
  },
  {
    label: 'ArtyOwl.com',
    value: 7475,
  },
  {
    label: 'NatureDots',
    value: 7476,
  },
  {
    label: 'Soolegal',
    value: 7477,
  },
  {
    label: 'MyNewCar.in',
    value: 7478,
  },
  {
    label: 'Firescore Interactive',
    value: 7479,
  },
  {
    label: 'Bitcoin India',
    value: 7480,
  },
  {
    label: 'Limevilla',
    value: 7481,
  },
  {
    label: 'Geo Climate Risk Solutions',
    value: 7482,
  },
  {
    label: 'funtoot',
    value: 7483,
  },
  {
    label: 'DangalGames',
    value: 7484,
  },
  {
    label: 'ALMAMATER',
    value: 7485,
  },
  {
    label: 'Cleanz24',
    value: 7486,
  },
  {
    label: 'Bookmycab',
    value: 7487,
  },
  {
    label: 'Gamezop',
    value: 7488,
  },
  {
    label: 'PayWush',
    value: 7489,
  },
  {
    label: 'Indian Railway Station Development Corp. Ltd.',
    value: 7490,
  },
  {
    label: 'TheTeacherApp',
    value: 7491,
  },
  {
    label: 'Recipebook',
    value: 7492,
  },
  {
    label: 'TravelZeg',
    value: 7493,
  },
  {
    label: 'Ducere',
    value: 7494,
  },
  {
    label: 'Online RTI',
    value: 7495,
  },
  {
    label: 'Garaaz',
    value: 7496,
  },
  {
    label: 'SMEClabs',
    value: 7497,
  },
  {
    label: 'Weirdass Comedy',
    value: 7498,
  },
  {
    label: 'mPedigree Network',
    value: 7499,
  },
  {
    label: 'AutoMony',
    value: 7500,
  },
  {
    label: 'BluKhet',
    value: 7501,
  },
  {
    label: 'Atsuya Technologies',
    value: 7502,
  },
  {
    label: 'Room Soom Technologies',
    value: 7503,
  },
  {
    label: 'Taksh it solutions pvt ltd',
    value: 7504,
  },
  {
    label: 'DigitalZeg',
    value: 7505,
  },
  {
    label: 'Fable Fintech',
    value: 7506,
  },
  {
    label: 'metalpace',
    value: 7507,
  },
  {
    label: 'Antariksh Waste Ventures Pvt ltd',
    value: 7508,
  },
  {
    label: 'PlaySpots',
    value: 7509,
  },
  {
    label: 'Printland',
    value: 7510,
  },
  {
    label: 'LatestOne',
    value: 7511,
  },
  {
    label: 'Falcon Autotech',
    value: 7512,
  },
  {
    label: 'DeeDee Labs Pvt Ltd',
    value: 7513,
  },
  {
    label: 'Nexart',
    value: 7514,
  },
  {
    label: 'eDabba',
    value: 7515,
  },
  {
    label: 'Phocus Travel',
    value: 7516,
  },
  {
    label: 'Inc42',
    value: 7517,
  },
  {
    label: 'Upside Down Labs',
    value: 7518,
  },
  {
    label: 'Rajmall Inventives (Xenxo)',
    value: 7519,
  },
  {
    label: 'Indian League Gaming',
    value: 7520,
  },
  {
    label: 'TheCollegeFever',
    value: 7521,
  },
  {
    label: 'Mauj Mobile',
    value: 7522,
  },
  {
    label: 'Docsumo',
    value: 7523,
  },
  {
    label: 'Fudr',
    value: 7524,
  },
  {
    label: 'SoulFlower',
    value: 7525,
  },
  {
    label: 'Mr. Cabie',
    value: 7526,
  },
  {
    label: 'Webchutney',
    value: 7527,
  },
  {
    label: 'Mother Sparsh Baby Care',
    value: 7528,
  },
  {
    label: 'Milo Doctor',
    value: 7529,
  },
  {
    label: 'Circles India',
    value: 7530,
  },
  {
    label: 'Bharat Matrimony',
    value: 7531,
  },
  {
    label: 'RapidBox',
    value: 7532,
  },
  {
    label: 'IndyFint',
    value: 7533,
  },
  {
    label: 'HotelnStudio',
    value: 7534,
  },
  {
    label: 'Factoreal',
    value: 7535,
  },
  {
    label: 'Vicara',
    value: 7536,
  },
  {
    label: 'Dextroware Device',
    value: 7537,
  },
  {
    label: 'Fabindia',
    value: 7538,
  },
  {
    label: 'CAPHIQ',
    value: 7539,
  },
  {
    label: 'DaveAI',
    value: 7540,
  },
  {
    label: 'Vizitor',
    value: 7541,
  },
  {
    label: 'TNQ InGage',
    value: 7542,
  },
  {
    label: 'CoRover',
    value: 7543,
  },
  {
    label: 'Hubhopper',
    value: 7544,
  },
  {
    label: 'Rightbot',
    value: 7545,
  },
  {
    label: 'Scholr',
    value: 7546,
  },
  {
    label: 'Parentlane',
    value: 7547,
  },
  {
    label: 'NeuraTech Innovations',
    value: 7548,
  },
  {
    label: 'ProcMart',
    value: 7549,
  },
  {
    label: 'Genius Box',
    value: 7550,
  },
  {
    label: 'Juego Studio',
    value: 7551,
  },
  {
    label: 'Xfinito Biodesigns',
    value: 7552,
  },
  {
    label: 'Uno Finance',
    value: 7553,
  },
  {
    label: 'Wydr',
    value: 7554,
  },
  {
    label: 'Genomics AI',
    value: 7555,
  },
  {
    label: 'Trinity Mobility',
    value: 7556,
  },
  {
    label: 'Gozocabs (Gozo technologies Pvt Ltd)',
    value: 7557,
  },
  {
    label: 'PurpleDocs',
    value: 7558,
  },
  {
    label: 'Rupyo',
    value: 7559,
  },
  {
    label: 'BYG - BookYourGame',
    value: 7560,
  },
  {
    label: 'Mtar Technologies',
    value: 7561,
  },
  {
    label: 'Favcy',
    value: 7562,
  },
  {
    label: 'Cricheroes',
    value: 7563,
  },
  {
    label: 'EasyFix',
    value: 7564,
  },
  {
    label: 'Stellariz Edtech Solutions',
    value: 7565,
  },
  {
    label: 'SpiceJet Limited',
    value: 7566,
  },
  {
    label: 'CoHo.in',
    value: 7567,
  },
  {
    label: 'Baazar Kolkata',
    value: 7568,
  },
  {
    label: 'Infovys',
    value: 7569,
  },
  {
    label: 'Cbazaar.com',
    value: 7570,
  },
  {
    label: 'Navana Tech',
    value: 7571,
  },
  {
    label: 'Instio',
    value: 7572,
  },
  {
    label: 'Woo',
    value: 7573,
  },
  {
    label: '9X Media Pvt. Ltd.',
    value: 7574,
  },
  {
    label: 'LegalDesk',
    value: 7575,
  },
  {
    label: 'Rockmetric',
    value: 7576,
  },
  {
    label: 'Bakbuck',
    value: 7577,
  },
  {
    label: 'Fluid Robotics',
    value: 7578,
  },
  {
    label: 'mydala.com',
    value: 7579,
  },
  {
    label: 'SureClaim',
    value: 7580,
  },
  {
    label: 'HOSH',
    value: 7581,
  },
  {
    label: 'Eder Labs',
    value: 7582,
  },
  {
    label: 'FarmERP',
    value: 7583,
  },
  {
    label: 'HealthSense',
    value: 7584,
  },
  {
    label: 'Com Olho',
    value: 7585,
  },
  {
    label: 'Lattu kids',
    value: 7586,
  },
  {
    label: 'EnCloudEn',
    value: 7587,
  },
  {
    label: 'SatSure',
    value: 7588,
  },
  {
    label: 'Sandoras',
    value: 7589,
  },
  {
    label: 'Knudge.me',
    value: 7590,
  },
  {
    label: 'TrailingCrypto',
    value: 7591,
  },
  {
    label: 'DriverShaab',
    value: 7592,
  },
  {
    label: 'InfraBeat Technologies',
    value: 7593,
  },
  {
    label: 'Sara Plast',
    value: 7594,
  },
  {
    label: 'SchoolMitra',
    value: 7595,
  },
  {
    label: 'SoftTech Engineers Limited',
    value: 7596,
  },
  {
    label: 'PaperVC',
    value: 7597,
  },
  {
    label: 'Egnify Technologies',
    value: 7598,
  },
  {
    label: 'beING Karwarian',
    value: 7599,
  },
  {
    label: 'FLEECA',
    value: 7600,
  },
  {
    label: 'HealthScion Technologies',
    value: 7601,
  },
  {
    label: 'Collective Artists Network',
    value: 7602,
  },
  {
    label: 'Elofic Industries Limited',
    value: 7603,
  },
  {
    label: 'Wylo',
    value: 7604,
  },
  {
    label: 'Sahara One Media And Entertainment',
    value: 7605,
  },
  {
    label: 'Classteacher Learning Systems',
    value: 7606,
  },
  {
    label: 'Krishiyog',
    value: 7607,
  },
  {
    label: 'Appsfly.io',
    value: 7608,
  },
  {
    label: 'YOU Broadband India',
    value: 7609,
  },
  {
    label: 'Drones Tech Lab',
    value: 7610,
  },
  {
    label: 'Loanzen',
    value: 7611,
  },
  {
    label: 'Muthoot Capital',
    value: 7612,
  },
  {
    label: 'Vortex Engineering',
    value: 7613,
  },
  {
    label: 'Loanadda',
    value: 7614,
  },
  {
    label: 'Megdap',
    value: 7615,
  },
  {
    label: 'Pretr Online Services Pvt. Ltd.',
    value: 7616,
  },
  {
    label: 'Techfino Capital',
    value: 7617,
  },
  {
    label: 'Curefy',
    value: 7618,
  },
  {
    label: 'I Love 9 Months',
    value: 7619,
  },
  {
    label: 'Capital Quant',
    value: 7620,
  },
  {
    label: 'Up Money',
    value: 7621,
  },
  {
    label: 'Luxury Ride',
    value: 7622,
  },
  {
    label: 'Splashgain Technology Solutions',
    value: 7623,
  },
  {
    label: 'BigFday',
    value: 7624,
  },
  {
    label: 'Etechies.in',
    value: 7625,
  },
  {
    label: 'Zee News',
    value: 7626,
  },
  {
    label: 'Proof-of-Performance',
    value: 7627,
  },
  {
    label: 'Zoapi',
    value: 7628,
  },
  {
    label: 'Quickli',
    value: 7629,
  },
  {
    label: 'Multiply My Leads',
    value: 7630,
  },
  {
    label: 'EduSports',
    value: 7631,
  },
  {
    label: 'Cloudchip',
    value: 7632,
  },
  {
    label: 'TongueStun',
    value: 7633,
  },
  {
    label: 'NavStik Autonomous Systems',
    value: 7634,
  },
  {
    label: 'Machstatz',
    value: 7635,
  },
  {
    label: 'TailsLife',
    value: 7636,
  },
  {
    label: 'ThingsCloud',
    value: 7637,
  },
  {
    label: 'SportsSeam',
    value: 7638,
  },
  {
    label: 'Playlyfe',
    value: 7639,
  },
  {
    label: 'Codemojo',
    value: 7640,
  },
  {
    label: 'Plowns',
    value: 7641,
  },
  {
    label: 'RUPBIT',
    value: 7642,
  },
  {
    label: 'Infino',
    value: 7643,
  },
  {
    label: 'MediSys EduTech',
    value: 7644,
  },
  {
    label: 'Marketics Technologies',
    value: 7645,
  },
  {
    label: 'YoRide',
    value: 7646,
  },
  {
    label: 'MassBlurb',
    value: 7647,
  },
  {
    label: 'CamfyVision Innovations',
    value: 7648,
  },
  {
    label: 'Krishworks',
    value: 7649,
  },
  {
    label: 'Mashinga',
    value: 7650,
  },
  {
    label: 'Connect2MyDoctor',
    value: 7651,
  },
  {
    label: 'Skipy',
    value: 7652,
  },
  {
    label: 'Direct Create',
    value: 7653,
  },
  {
    label: 'Numero Uno',
    value: 7654,
  },
  {
    label: 'Seventymm',
    value: 7655,
  },
  {
    label: 'Razorfish Technologies India',
    value: 7656,
  },
  {
    label: 'Avench systems',
    value: 7657,
  },
  {
    label: 'Akasa Labs',
    value: 7658,
  },
  {
    label: 'iCouchApp',
    value: 7659,
  },
  {
    label: 'Studyplaces',
    value: 7660,
  },
  {
    label: 'Kenome',
    value: 7661,
  },
  {
    label: 'Hyrelabs',
    value: 7662,
  },
  {
    label: 'Samudai',
    value: 7663,
  },
  {
    label: 'Platify',
    value: 7664,
  },
  {
    label: 'NIRUTHI',
    value: 7665,
  },
  {
    label: 'Sympill',
    value: 7666,
  },
  {
    label: 'Moodboard Analytics',
    value: 7667,
  },
  {
    label: 'AIGROEDGE Technologies',
    value: 7668,
  },
  {
    label: 'HX Technologies',
    value: 7669,
  },
  {
    label: 'Monosha-Biotech',
    value: 7670,
  },
  {
    label: 'SKaaS',
    value: 7671,
  },
  {
    label: 'Point105-AR',
    value: 7672,
  },
  {
    label: 'CheckGaadi.com',
    value: 7673,
  },
  {
    label: 'Magasool Agro',
    value: 7674,
  },
  {
    label: 'Byte House Digital',
    value: 7675,
  },
  {
    label: 'Evoride motors',
    value: 7676,
  },
  {
    label: 'Webshastra',
    value: 7677,
  },
  {
    label: 'SenseDose Technologies',
    value: 7678,
  },
  {
    label: 'Fiticket',
    value: 7679,
  },
  {
    label: 'EroNkan',
    value: 7680,
  },
  {
    label: 'EUOR Tech',
    value: 7681,
  },
  {
    label: 'PiplSay',
    value: 7682,
  },
  {
    label: 'Brelo',
    value: 7683,
  },
  {
    label: 'Yoghurt.io',
    value: 7684,
  },
  {
    label: 'Sportelos',
    value: 7685,
  },
  {
    label: 'Kitbag',
    value: 7686,
  },
  {
    label: 'Quahog Life',
    value: 7687,
  },
  {
    label: 'Ferbine',
    value: 7688,
  },
  {
    label: 'SponsorChampz',
    value: 7689,
  },
  {
    label: 'The? ?Moms? ?Co.',
    value: 7690,
  },
  {
    label: 'Kohler Communication',
    value: 7691,
  },
  {
    label: 'Synchrony International Services Private Limited',
    value: 7692,
  },
  {
    label: 'Pricewaterhouse Coopers Private Limited',
    value: 7693,
  },
  {
    label: 'Fiverr',
    value: 7694,
  },
  {
    label: 'Intel Technology India Pvt Ltd',
    value: 7695,
  },
  {
    label: 'V-Find Business',
    value: 7696,
  },
  {
    label: 'Accolite Digital',
    value: 7697,
  },
  {
    label: 'RENAULT NISSAN TECHNOLOGY BUSINESS CENTRE INDIA',
    value: 7698,
  },
  {
    label: 'Batch Service',
    value: 7699,
  },
  {
    label: 'HighRadius Technologies Pvt Ltd',
    value: 7700,
  },
  {
    label: 'TLG INDIA PRIVATE LIMITED',
    value: 7701,
  },
  {
    label: 'Makro Pro',
    value: 7702,
  },
  {
    label: 'Zerodha',
    value: 7703,
  },
  {
    label: 'Physics Wallah',
    value: 7704,
  },
  {
    label: 'Oxyzo',
    value: 7705,
  },
  {
    label: 'CommerceIQ',
    value: 7706,
  },
  {
    label: 'Polygon',
    value: 7707,
  },
  {
    label: '5ire',
    value: 7708,
  },
  {
    label: 'OneCard',
    value: 7709,
  },
  {
    label: 'NetCracker',
    value: 7710,
  },
  {
    label: 'Oportun',
    value: 7711,
  },
  {
    label: 'BuildingBlocks',
    value: 7712,
  },
  {
    label: 'ICE',
    value: 7713,
  },
  {
    label: 'Goldman Sachs India',
    value: 7714,
  },
  {
    label: 'DST Worldwide Services India Pvt. Ltd',
    value: 7715,
  },
  {
    label: 'RAIN Industries Limited',
    value: 7716,
  },
  {
    label: 'Impelsys India Pvt Ltd',
    value: 7717,
  },
  {
    label: 'KARYA Technologies',
    value: 7718,
  },
  {
    label: 'CES Ltd.',
    value: 7719,
  },
  {
    label: 'Relevel by Unacademy',
    value: 7720,
  },
  {
    label: 'Cyient',
    value: 7721,
  },
  {
    label: 'Value Momentum Software Services Pvt. Ltd.',
    value: 7722,
  },
  {
    label: 'Quality Matrix',
    value: 7723,
  },
  {
    label: 'GHX India',
    value: 7724,
  },
  {
    label: 'Endpoint Clinical',
    value: 7725,
  },
  {
    label: 'Coffeee.io',
    value: 7726,
  },
  {
    label: 'INNOMINDS SOFTWARE SEZ INDIA PRIVATE LIMITED',
    value: 7727,
  },
  {
    label: 'QENTELLI SOLUTIONS PRIVATE LIMITED',
    value: 7728,
  },
  {
    label: 'ABSYZ',
    value: 7729,
  },
  {
    label: 'Ignitarium',
    value: 7730,
  },
  {
    label: 'Mastech InfoTrellis',
    value: 7731,
  },
  {
    label: 'Excellarate',
    value: 7732,
  },
  {
    label: 'Sierra-Cedar',
    value: 7733,
  },
  {
    label: 'RAKUTEN INDIA ENTERPRISE PVT LTD',
    value: 7734,
  },
  {
    label: 'KORE.AI SOFTWARE INDIA PVT LTD',
    value: 7735,
  },
  {
    label: 'Euclid Innovations',
    value: 7736,
  },
  {
    label: 'Spotify',
    value: 7737,
  },
  {
    label: 'Techmango',
    value: 7738,
  },
  {
    label: 'MongoDB',
    value: 7739,
  },
  {
    label: 'MUSARUBRA SOFTWARE INDIA PRIVATE LIMITED',
    value: 7740,
  },
  {
    label: 'hexaware',
    value: 7741,
  },
  {
    label: 'hexaware technology',
    value: 7742,
  },
  {
    label: 'MongoDB Software India Private Limited',
    value: 7743,
  },
  {
    label: 'Genesys Telecom Labs India Pvt. Ltd.',
    value: 7744,
  },
  {
    label: 'Redington (INDIA) Limited',
    value: 7745,
  },
  {
    label: 'TVS MOTOR COMPANY LTD',
    value: 7746,
  },
  {
    label: 'Techmango Technology Services Private Limited',
    value: 7747,
  },
  {
    label: 'Numeric Technologies',
    value: 7748,
  },
  {
    label: 'Aeries Technology',
    value: 7749,
  },
  {
    label: 'Cyient Limited',
    value: 7750,
  },
  {
    label: 'Unirac',
    value: 7751,
  },
  {
    label: 'BriskWinIT',
    value: 7752,
  },
  {
    label: 'ignitarium technology solutions private limited',
    value: 7753,
  },
  {
    label: 'KEYLOOP INDIA PRIVATE LIMITED',
    value: 7754,
  },
  {
    label: 'Winfo Solutions',
    value: 7755,
  },
  {
    label: 'Aveva Solutions India LLP\t',
    value: 7756,
  },
  {
    label: 'Osiz Technologies',
    value: 7757,
  },
  {
    label: 'Giant Eagle GCC',
    value: 7758,
  },
  {
    label: 'CapitalOne',
    value: 7759,
  },
  {
    label: ' Wissen Infotech Pvt. Ltd',
    value: 7760,
  },
  {
    label: 'wissen',
    value: 7761,
  },
  {
    label: 'Hitachi Vantara',
    value: 7762,
  },
  {
    label: 'Kyndryl',
    value: 7763,
  },
  {
    label: 'sscinc',
    value: 7764,
  },
  {
    label: 'F5 NETWORKS INNOVATION PRIVATE LIMITED',
    value: 7765,
  },
  {
    label: 'Clean Harbours',
    value: 7766,
  },
  {
    label: 'Abott',
    value: 7767,
  },
  {
    label: 'Abbott Healthcare Pvt. Ltd.',
    value: 7768,
  },
  {
    label: 'SUNERA TECHNOLOGIES PVT LTD',
    value: 7769,
  },
  {
    label: 'Ellucian Higher Education Systems India Pvt. Ltd.',
    value: 7770,
  },
  {
    label: 'Nutanix',
    value: 7771,
  },
  {
    label: 'Unirac Solar India LLP',
    value: 7772,
  },
  {
    label: 'AWIGN ENTERPRISES PRIVATE LIMITED',
    value: 7773,
  },
  {
    label: 'UL India',
    value: 7774,
  },
  {
    label: 'High radius ',
    value: 7775,
  },
  {
    label: 'cleanharbors',
    value: 7776,
  },
  {
    label: 'Alpha XDR\t',
    value: 7777,
  },
  {
    label: 'Hexaware Technologies Ltd.',
    value: 7778,
  },
  {
    label: 'Esolutionsfirst',
    value: 7779,
  },
  {
    label: 'Larsen & Toubro',
    value: 7780,
  },
  {
    label: 'Ramanathan',
    value: 7781,
  },
  {
    label: 'revolutiones',
    value: 7782,
  },
  {
    label: 'Innovaccer',
    value: 7783,
  },
  {
    label: 'euclid innovations private limited',
    value: 7784,
  },
  {
    label: 'Amazon Developement Center',
    value: 7785,
  },
  {
    label: 'Avalara',
    value: 7786,
  },
  {
    label: 'progress software development',
    value: 7787,
  },
  {
    label: 'ICE MT INDIA PRIVATE LIMITED',
    value: 7788,
  },
  {
    label: 'Opentext Technologies India Pvt. Ltd',
    value: 7789,
  },
  {
    label: 'oneplus',
    value: 7790,
  },
  {
    label: 'Celon Laboratories Pvt Ltd',
    value: 7791,
  },
  {
    label: 'ABSYZ SOFTWARE CONSULTING PRIVATE LIMITED',
    value: 7792,
  },
  {
    label: 'TA Digital (TechAspect Solutions Pvt Ltd)',
    value: 7793,
  },
  {
    label: 'alight',
    value: 7794,
  },
  {
    label: 'ACCOLITE DIGITAL INDIA PRIVATE LIMITED',
    value: 7795,
  },
  {
    label: 'Kotak Mahindra Bank Limited',
    value: 7796,
  },
  {
    label: 'IVYCAP VENTURES ADVISORS PRIVATE LIMITED',
    value: 7797,
  },
  {
    label: 'BDO India',
    value: 7798,
  },
  {
    label: 'PROZO DISTRIBUTION PRIVATE LIMITED',
    value: 7799,
  },
  {
    label: 'TATA STEEL LIMITED',
    value: 7800,
  },
  {
    label: 'Cotiviti',
    value: 7801,
  },
  {
    label: 'Jindal Steel and Power',
    value: 7802,
  },
  {
    label: 'Guardian',
    value: 7803,
  },
  {
    value: 7804,
    label: 'Ecolab',
  },
  {
    value: 7805,
    label: 'Atomberg technologies Pvt Ltd',
  },
  {
    value: 7806,
    label: 'Lloyds Bank',
  },
  {
    value: 7807,
    label: 'DEUTSCHE BANK AG',
  },
  {
    value: 7808,
    label: 'AstraZeneca India Pvt Ltd',
  },
  {
    value: 7809,
    label: 'Markets and Markets Research Pvt Ltd',
  },
  {
    value: 7810,
    label: 'TIGER ANALYTICS INDIA CONSULTING PRIVATE LIMITED',
  },
  {
    value: 7811,
    label: 'Boult Audio',
  },
  {
    value: 7812,
    label: 'SGP - Analyst',
  },
  {
    value: 7813,
    label: 'Robosoft Technologies Pvt.Ltd',
  },
  {
    value: 7814,
    label: 'KredX',
  },
  {
    value: 7815,
    label: 'BNB Groupe',
  },
  {
    value: 7816,
    label: 'Mohalla Tech Pvt Ltd',
  },
  {
    value: 7817,
    label: 'Sathguru',
  },
  {
    value: 7818,
    label: 'NEOZOOM TECHNOLOGIES PRIVATE LIMITED',
  },
  {
    value: 7819,
    label: 'Matrimony.com Limited',
  },
  {
    value: 7820,
    label: 'Century Real Estate Holdings Pvt. Ltd',
  },
  {
    value: 7821,
    label: 'Nomura Services India Pvt. Ltd',
  },
  {
    value: 7822,
    label: 'ADITYA BIRLA FINANCIAL SHARED SERVICES LIMITED',
  },
  {
    value: 7823,
    label: 'WISHUP TECHNOLOGY PRIVATE LIMITED',
  },
  {
    value: 7824,
    label: 'CARS24 SERVICES PRIVATE LIMITED',
  },
  {
    value: 7825,
    label: 'Speriti',
  },
  {
    value: 7826,
    label: '1Lattice',
  },
  {
    value: 7827,
    label: 'Freyr',
  },
  {
    value: 7828,
    label: 'White Panda',
  },
  {
    value: 7829,
    label: 'Bharti Airtel Limited',
  },
  {
    value: 7830,
    label: 'Linc Pen',
  },
  {
    value: 7831,
    label: 'HuQuo Consulting Pvt. Ltd',
  },
  {
    value: 7832,
    label: 'Extramarks Education India Pvt Ltd',
  },
  {
    value: 7833,
    label: 'Wheelseye Technology India Private Limited',
  },
  {
    value: 7834,
    label: 'UFO Moviez India Ltd',
  },
  {
    value: 7835,
    label: 'UNITED BREWERIES LIMITED',
  },
  {
    value: 7836,
    label: 'Magnequest',
  },
  {
    value: 7837,
    label: 'Magnaquest',
  },
  {
    value: 7838,
    label: 'LARSEN & TOUBRO INFOTECH LIMITED',
  },
  {
    value: 7839,
    label: 'Motilal Oswal Fin Ser Limited',
  },
  {
    value: 7840,
    label: 'Coverfox Insurance Broking Pvt. Ltd',
  },
  {
    value: 7841,
    label: 'Meta',
  },
  {
    value: 7842,
    label: 'Right Brain',
  },
  {
    value: 7843,
    label: 'Somani Group',
  },
  {
    value: 7844,
    label: 'MINDTICKLE INTERACTIVE MEDIA PRIVATE LIMITED',
  },
  {
    value: 7845,
    label: 'CarDekho',
  },
  {
    value: 7846,
    label: 'Wobot AI',
  },
  {
    value: 7847,
    label: 'B9 Beverages Private Limited',
  },
  {
    value: 7848,
    label: 'RAPIDAI SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED',
  },
  {
    value: 7849,
    label: 'Syngene International Limited',
  },
  {
    value: 7850,
    label: 'AVENDUS CAPITAL PVT LTD',
  },
  {
    value: 7851,
    label: 'CURIA INDIA PRIVATE LIMITED',
  },
  {
    value: 7852,
    label: 'BMTG Advisors India Private Limited',
  },
  {
    value: 7853,
    label: 'Exxon Mobil',
  },
  {
    value: 7854,
    label: 'Exxon Mobi',
  },
  {
    value: 7855,
    label: 'Everest Engineering',
  },
  {
    value: 7856,
    label: 'Embassy Group',
  },
  {
    value: 7857,
    label: 'Proplled',
  },
  {
    value: 7858,
    label: 'Adani Enterprises Limited',
  },
  {
    value: 7859,
    label: 'Deloitte Consulting India',
  },
  {
    value: 7860,
    label: 'blackline.com',
  },
  {
    value: 7861,
    label: 'Carrier Technologies India',
  },
  {
    value: 7862,
    label: 'providence.org',
  },
  {
    value: 7863,
    label: 'ServiceNow Software Development India Private Ltd',
  },
  {
    value: 7864,
    label: 'NetScore Technologies Pvt. Ltd',
  },
  {
    value: 7865,
    label: 'BILVANTIS TECHNOLOGIES PRIVATE LIMITED',
  },
  {
    value: 7866,
    label: 'Kensium Solutions Private Limited',
  },
  {
    value: 7867,
    label: 'Focus Softnet Pvt. Ltd',
  },
  {
    value: 7868,
    label: 'Ficosa India Engineering Center Pvt Ltd',
  },
  {
    value: 7869,
    label: 'ingrain',
  },
  {
    value: 7870,
    label: 'MarketStar',
  },
  {
    value: 7871,
    label: 'Modak Analytics LLP',
  },
  {
    value: 7872,
    label: 'Haleon',
  },
  {
    value: 7873,
    label: 'Outscal Technologies Pvt Ltd',
  },
  {
    value: 7874,
    label: 'dazn',
  },
  {
    value: 7875,
    label: 'cardinalhealth',
  },
  {
    value: 7876,
    label: 'enhisecure',
  },
  {
    value: 7877,
    label: 'brillio.com',
  },
  {
    value: 7878,
    label: 'COGNITIVZEN TECHNOLOGIES PRIVATE LIMITED',
  },
  {
    value: 7879,
    label: 'SENWELL EXPORTS PRIVATE LIMITED',
  },
  {
    value: 7880,
    label: 'TIAA GLOBAL CAPABILITIES PRIVATE LIMITED',
  },
  {
    value: 7881,
    label: 'Comefforts',
  },
  {
    value: 7882,
    label: 'Guardian India',
  },
  {
    value: 7883,
    label: 'ELECTRONICS MART INDIA LIMITED',
  },
  {
    value: 7884,
    label: 'Envoy',
  },
  {
    value: 7885,
    label: 'CALLAWAY DIGITAL TECHNOLOGIES PRIVATE LIMITED',
  },
  {
    value: 7886,
    label: 'Avalara Technologies Pvt Ltd',
  },
  {
    value: 7887,
    label: 'Energeia Microgrid',
  },
  {
    value: 7888,
    label: 'Vellore Institute of Technology',
  },
  {
    value: 7889,
    label: 'publicissapient',
  },
  {
    value: 7890,
    label: 'Truecaller',
  },
  {
    value: 7891,
    label: 'SWISS GARNIER GENEXIAA SCIENCES PRIVATE LIMITED',
  },
  {
    value: 7892,
    label: 'matilda',
  },
  {
    value: 7893,
    label: 'JGC INDIA EPC PRIVATE LIMITED',
  },
  {
    value: 7894,
    label: 'eInfochips',
  },
  {
    value: 7895,
    label: 'E Infochips',
  },
  {
    value: 7896,
    label: 'V-Guard Industries Ltd',
  },
  {
    value: 7897,
    label: 'Medline Industries India Private Limited',
  },
  {
    value: 7898,
    label: 'BHR Code Pvt Ltd',
  },
  {
    value: 7899,
    label: 'Integrity Technologies and Services',
  },
  {
    value: 7900,
    label: 'numerictech',
  },
  {
    value: 7901,
    label: 'nextgenprosinc',
  },
  {
    value: 7902,
    label: 'Arete Consultants Private Limited',
  },
  {
    value: 7903,
    label: 'RAKUTEN SYMPHONY INDIA PRIVATE LIMITED',
  },
  {
    value: 7904,
    label: 'Excelencia I-Tech Consulting Pvt Ltd',
  },
  {
    value: 7905,
    label: 'E2open Software India Private Limited',
  },
  {
    value: 7906,
    label: 'Alten',
  },
  {
    value: 7907,
    label: 'Aita',
  },
  {
    value: 7908,
    label: 'Novulis',
  },
  {
    value: 7909,
    label: 'Cotelligent',
  },
  {
    value: 7910,
    label: 'Kisetsu',
  },
  {
    value: 7911,
    label: 'TCP WAVE PRIVATE LIMITED',
  },
  {
    value: 7912,
    label: 'GRAVITY CYBERTECH PVT LTD',
  },
  {
    value: 7913,
    label: 'qualminds',
  },
  {
    value: 7914,
    label: 'Gnostic',
  },
  {
    value: 7915,
    label: 'Freecharge Payment Technologies Pvt Ltd',
  },
  {
    value: 7916,
    label: 'OLA',
  },
  {
    value: 7917,
    label: 'STL Digital',
  },
  {
    value: 7918,
    label: 'ELFONZE TECHNOLOGIES PRIVATE LIMITED',
  },
  {
    value: 7919,
    label: 'Ipca Laboratories Ltd',
  },
  {
    value: 7920,
    label: 'Sqaureshift',
  },
  {
    value: 7921,
    label: 'VIAI SOLUTIONS PRIVATE LIMITED',
  },
  {
    value: 7922,
    label: 'Rational Edge',
  },
  {
    value: 7923,
    label: 'Intuit Global',
  },
  {
    value: 7924,
    label: 'Qvantel Software solutions Ltd',
  },
  {
    value: 7925,
    label: 'Atmecs',
  },
  {
    value: 7926,
    label: 'FactSet Systems India Private Limited',
  },
  {
    value: 7927,
    label: 'NTT India Private Limited',
  },
  {
    value: 7928,
    label: 'REBEL FOODS PRIVATE LIMITED',
  },
  {
    value: 7929,
    label: 'Pure Storage',
  },
  {
    value: 7930,
    label: 'COHESIVE DIGITAL',
  },
  {
    value: 7931,
    label: 'MINDSPRINT',
  },
  {
    value: 7932,
    label: 'Soliton Technologies Private Limited',
  },
  {
    value: 7933,
    label: 'OSP India',
  },
  {
    value: 7934,
    label: 'Kloud Portal',
  },
  {
    value: 7935,
    label: 'Oasis India',
  },
  {
    value: 7936,
    label: 'MwebWare',
  },
  {
    value: 7937,
    label: '5Y Business Solutions Pvt. Ltd',
  },
  {
    value: 7938,
    label: 'Genzeon Technology Solutions Pvt. Ltd',
  },
  {
    value: 7939,
    label: 'Comcast India Engineering Center',
  },
  {
    value: 7940,
    label: 'Numeric Technologies (India) Private Limited',
  },
  {
    value: 7941,
    label: 'TESTPERFORM TECHNOLOGIES PRIVATE LIMITED',
  },
  {
    value: 7942,
    label: 'Synopsys India Pvt. Ltd',
  },
  {
    value: 7943,
    label: 'TVM Infotech',
  },
  {
    value: 7944,
    label: 'Verve',
  },
  {
    value: 7945,
    label: 'OSP INDIA - HYDERABAD PRIVATE LIMITED',
  },
  {
    value: 7946,
    label: 'BMW TechWorks India',
  },
  {
    value: 7947,
    label: 'BMW Techworks India Private Limited',
  },
  {
    value: 7948,
    label: 'Cybage Software Pvt. Ltd',
  },
  {
    value: 7949,
    label: 'Hashedin',
  },
  {
    value: 7950,
    label: 'Nibav Home Lifts',
  },
  {
    value: 7951,
    label: 'Nike India technology center private ltd',
  },
  {
    value: 7952,
    label: 'HIGHSPOT INDIA PRIVATE LIMITED',
  },
  {
    value: 7953,
    label: 'CLONUT SOLUTIONS PRIVATE LIMITED',
  },
  {
    value: 7954,
    label: 'skellam.ai',
  },
  {
    value: 7955,
    label: 'Apple Inc',
  },
  {
    value: 7956,
    label: 'Celigo',
  },
  {
    value: 7957,
    label: 'Tietoevry',
  },
  {
    value: 7958,
    label: 'AT&T',
  },
  {
    value: 7959,
    label: 'Lumen Global',
  },
  {
    value: 7960,
    label: 'Comcast Business Global WAN Services',
  },
  {
    value: 7961,
    label: 'Colt Global WAN Services',
  },
  {
    value: 7962,
    label: 'GTT Global WAN Services',
  },
  {
    value: 7963,
    label: 'Reliance Jio',
  },
];

export const ORGANISATION = [
  {
    value: '3101',
    label: '1Lattice',
  },
  {
    value: '2941',
    label: '1RIVET INDIA LLP',
  },
  {
    value: '2983',
    label: '3F Oil Palm',
  },
  {
    value: '254',
    label: '3i Infotech',
  },
  {
    value: '266',
    label: '3M India',
  },
  {
    value: '1783',
    label: '9.9 Media',
  },
  {
    value: '2489',
    label: '20:20 MSL',
  },
  {
    value: '1986',
    label: "a'XYKno Capital Services",
  },
  {
    value: '848',
    label: 'A.P. Moller Maersk',
  },
  {
    value: '418',
    label: 'A.T. Kearney',
  },
  {
    value: '1592',
    label: 'A. T. Kearney',
  },
  {
    value: '615',
    label: 'A2Z Group',
  },
  {
    value: '305',
    label: 'ABB',
  },
  {
    value: '2878',
    label: 'Abbott Healthcare',
  },
  {
    value: '260',
    label: 'Abbott India',
  },
  {
    value: '1763',
    label: 'Abbott Nutrition International',
  },
  {
    value: '312',
    label: 'ABC Consultants',
  },
  {
    value: '2104',
    label: 'ABECL',
  },
  {
    value: '1955',
    label: 'Abercrombie & Fitch',
  },
  {
    value: '2056',
    label: 'ABG Cement Ltd',
  },
  {
    value: '374',
    label: 'Abhijeet Group',
  },
  {
    value: '2112',
    label: 'Abhishek Industries (Trident Group)',
  },
  {
    value: '2447',
    label: 'AB InBev',
  },
  {
    value: '2556',
    label: 'ABInbev',
  },
  {
    value: '2901',
    label: 'AB Inbev (GCC)',
  },
  {
    value: '1794',
    label: 'ABN AMRO Bank',
  },
  {
    value: '951',
    label: 'ABP Pvt Ltd',
  },
  {
    value: '2817',
    label: 'Abridge Consulting Services',
  },
  {
    value: '246',
    label: 'AbsolutData',
  },
  {
    value: '2745',
    label: 'ABS Professional Services',
  },
  {
    value: '3044',
    label: 'ABSYZ SOFTWARE CONSULTING PRIVATE LIMITED',
  },
  {
    value: '1791',
    label: 'Accel Frontline Limited',
  },
  {
    value: '13',
    label: 'Accenture',
  },
  {
    value: '316',
    label: 'ACC Limited',
  },
  {
    value: '3063',
    label: 'ACCOLITE DIGITAL INDIA PRIVATE LIMITED',
  },
  {
    value: '2867',
    label: 'Accord Global Technology Solutions',
  },
  {
    value: '2399',
    label: 'Accountant',
  },
  {
    value: '1068',
    label: 'Accretive Health',
  },
  {
    value: '2703',
    label: 'Accural Solution',
  },
  {
    value: '1017',
    label: 'Acer',
  },
  {
    value: '2383',
    label: 'ACG Worldwide',
  },
  {
    value: '2224',
    label: 'ACH Management Consultant Pvt. Ltd.',
  },
  {
    value: '2480',
    label: 'Acko Insurance',
  },
  {
    value: '2404',
    label: 'Acme Telepower Ltd',
  },
  {
    value: '669',
    label: 'AC Nielsen',
  },
  {
    value: '1177',
    label: 'Acropetal Technologies Limited',
  },
  {
    value: '634',
    label: 'ACS - A Xerox Company',
  },
  {
    value: '2585',
    label: 'ACT',
  },
  {
    value: '1612',
    label: 'Actis',
  },
  {
    value: '1221',
    label: 'Actuate Business Consulting',
  },
  {
    value: '2581',
    label: 'Acuity Knowledge Partners',
  },
  {
    value: '2973',
    label: 'Acuity Knowledge Services (India) Private Limited',
  },
  {
    value: '3142',
    label: 'Adani Enterprises Limited',
  },
  {
    value: '238',
    label: 'Adani Group',
  },
  {
    value: '896',
    label: 'Adani Wilmar Limited',
  },
  {
    value: '2715',
    label: 'Adaps IT',
  },
  {
    value: '2823',
    label: 'Ad Astra Consultants',
  },
  {
    value: '2920',
    label: 'Adda247',
  },
  {
    value: '382',
    label: 'Adecco',
  },
  {
    value: '2831',
    label: 'Adeptpros IT Solutions',
  },
  {
    value: '1156',
    label: 'Adfactors PR',
  },
  {
    value: '1701',
    label: 'ADFC Pvt Ltd',
  },
  {
    value: '941',
    label: 'Adhunik Group',
  },
  {
    value: '1082',
    label: 'Adidas',
  },
  {
    value: '1404',
    label: 'Aditi Technologies',
  },
  {
    value: '3094',
    label: 'ADITYA BIRLA FINANCIAL SHARED SERVICES LIMITED',
  },
  {
    value: '47',
    label: 'Aditya Birla Group',
  },
  {
    value: '2701',
    label: 'Adlent Consulting',
  },
  {
    value: '339',
    label: 'Adobe',
  },
  {
    value: '556',
    label: 'ADP',
  },
  {
    value: '3056',
    label: 'adpushup',
  },
  {
    value: '1581',
    label: 'Adroit Financial Services',
  },
  {
    value: '2605',
    label: 'Adtech Systems Ltd',
  },
  {
    value: '946',
    label: 'Advance Group',
  },
  {
    value: '1564',
    label: 'Advertising',
  },
  {
    value: '128',
    label: 'Aegis Limited',
  },
  {
    value: '181',
    label: 'Aegon Religare',
  },
  {
    value: '2994',
    label: 'Aeries Technology',
  },
  {
    value: '1855',
    label: 'Aetna',
  },
  {
    value: '2844',
    label: 'Aetos Design And Engineering',
  },
  {
    value: '1428',
    label: 'AF-Mercados EMI',
  },
  {
    value: '1315',
    label: 'Affine Analytics',
  },
  {
    value: '1788',
    label: 'Affinity Express',
  },
  {
    value: '606',
    label: 'AGC Networks - Essar Group',
  },
  {
    value: '2621',
    label: 'Aggreko Energy Rental India Private Limited',
  },
  {
    value: '378',
    label: 'Agilent Technologies',
  },
  {
    value: '1900',
    label: 'AgroStar',
  },
  {
    value: '641',
    label: 'Agro Tech Foods',
  },
  {
    value: '1262',
    label: 'AGS Transact Technologies',
  },
  {
    value: '2716',
    label: 'Aidoings Research',
  },
  {
    value: '2281',
    label: 'AIPL',
  },
  {
    value: '2414',
    label: 'Airbnb',
  },
  {
    value: '41',
    label: 'Aircel',
  },
  {
    value: '1346',
    label: 'Aircom International',
  },
  {
    value: '1091',
    label: 'Air India Limited',
  },
  {
    value: '1706',
    label: 'Air Liquide',
  },
  {
    value: '1580',
    label: 'Airtel',
  },
  {
    value: '2713',
    label: 'AIT Resource India',
  },
  {
    value: '2309',
    label: 'Ajanta Pharma',
  },
  {
    value: '922',
    label: 'Akamai Technologies',
  },
  {
    value: '2821',
    label: 'Akin Marketing',
  },
  {
    value: '150',
    label: 'AkzoNobel India Ltd',
  },
  {
    value: '1444',
    label: 'Alankit Assignments Ltd',
  },
  {
    value: '232',
    label: 'Alcatel Lucent',
  },
  {
    value: '633',
    label: 'Alchemist Group',
  },
  {
    value: '1061',
    label: 'Alcor',
  },
  {
    value: '2496',
    label: 'Alef Edge',
  },
  {
    value: '2478',
    label: 'Alef Mobitech',
  },
  {
    value: '1045',
    label: 'Alembic Pharmaceuticals',
  },
  {
    value: '1777',
    label: 'Alere',
  },
  {
    value: '838',
    label: 'Alexandria Equities Management',
  },
  {
    value: '2634',
    label: 'ALFA BIOMED INDIA PRIVATE LIMITED',
  },
  {
    value: '1940',
    label: 'Al Futtaim',
  },
  {
    value: '1630',
    label: 'Alghanim Industries',
  },
  {
    value: '2692',
    label: 'Algorithms Software',
  },
  {
    value: '1737',
    label: 'Alibaba.com',
  },
  {
    value: '2825',
    label: 'Alice Blue Financial Services',
  },
  {
    value: '2792',
    label: 'Aliens Art',
  },
  {
    value: '1636',
    label: 'Alkem Laboratories Limited',
  },
  {
    value: '489',
    label: 'Allahabad Bank',
  },
  {
    value: '1215',
    label: 'Allcargo Logistics',
  },
  {
    value: '1430',
    label: 'AllCheckDeals India Private Limited',
  },
  {
    value: '2930',
    label: 'Allegis Global Solutions',
  },
  {
    value: '984',
    label: 'Allegis Group',
  },
  {
    value: '714',
    label: 'Allegro Advisors',
  },
  {
    value: '1273',
    label: 'Allergan India Private Limited',
  },
  {
    value: '1206',
    label: 'Alliance University',
  },
  {
    value: '954',
    label: 'Allied Blenders & Distillers Pvt. Ltd',
  },
  {
    value: '2139',
    label: 'Allied Digital Services Ltd.',
  },
  {
    value: '1875',
    label: 'allscripts',
  },
  {
    value: '1476',
    label: 'Allsec Technologies',
  },
  {
    value: '882',
    label: 'Almondz Global Securities',
  },
  {
    value: '1112',
    label: 'Alok Industries',
  },
  {
    value: '3093',
    label: 'Alorica',
  },
  {
    value: '2315',
    label: 'Alp COnsulting Ltd',
  },
  {
    value: '1200',
    label: 'Alpha Payment Services',
  },
  {
    value: '2667',
    label: 'Alpine Placement Consultant',
  },
  {
    value: '440',
    label: 'Alstom',
  },
  {
    value: '2200',
    label: 'Altamount Capital Management',
  },
  {
    value: '195',
    label: 'Altisource',
  },
  {
    value: '1364',
    label: 'Altruist Technologies',
  },
  {
    value: '1240',
    label: 'Amadeus',
  },
  {
    value: '2913',
    label: 'Amagi',
  },
  {
    value: '1151',
    label: 'Amalgamated Bean Coffee Trading Company',
  },
  {
    value: '1174',
    label: 'Amara Raja Batteries Limited',
  },
  {
    value: '1739',
    label: 'Amar Ujala Publications',
  },
  {
    value: '2231',
    label: 'Amazan Agro Products Ltd.',
  },
  {
    value: '125',
    label: 'Amazon.com',
  },
  {
    value: '2409',
    label: 'Amazon India',
  },
  {
    value: '94',
    label: 'Amba Research',
  },
  {
    value: '2771',
    label: 'Ambica Steels',
  },
  {
    value: '803',
    label: 'Ambit Holdings',
  },
  {
    value: '1026',
    label: 'Ambuja Cements Limited',
  },
  {
    value: '1203',
    label: 'AMD',
  },
  {
    value: '311',
    label: 'Amdocs',
  },
  {
    value: '40',
    label: 'American Express',
  },
  {
    value: '386',
    label: 'Ameriprise Financial',
  },
  {
    value: '2852',
    label: 'Amicon Hub Services',
  },
  {
    value: '1424',
    label: 'Amicorp Advisory Services',
  },
  {
    value: '1275',
    label: 'Amira Group',
  },
  {
    value: '1138',
    label: 'Amity Business School',
  },
  {
    value: '691',
    label: 'Amity University',
  },
  {
    value: '2637',
    label: 'Ampler Technologies',
  },
  {
    value: '2021',
    label: 'Amrapali Group',
  },
  {
    value: '1446',
    label: 'Amra Renal Care',
  },
  {
    value: '1339',
    label: 'Amrop India',
  },
  {
    value: '243',
    label: 'AMUL',
  },
  {
    value: '817',
    label: 'Amway',
  },
  {
    value: '732',
    label: 'ANALEC Infotech Private Limited',
  },
  {
    value: '602',
    label: 'Analytics Quotient',
  },
  {
    value: '277',
    label: 'Anand Rathi Group',
  },
  {
    value: '1999',
    label: 'Anant Raj Group',
  },
  {
    value: '1406',
    label: 'ANB Consulting',
  },
  {
    value: '1171',
    label: 'Anchor Electricals',
  },
  {
    value: '2152',
    label: 'ANDHRA BANK',
  },
  {
    value: '665',
    label: 'Aneja Associates',
  },
  {
    value: '137',
    label: 'Angel Broking',
  },
  {
    value: '2045',
    label: 'ANI Technologies Pvt Ltd',
  },
  {
    value: '2290',
    label: 'Anlage HRO Services',
  },
  {
    value: '2060',
    label: 'Anmsoft technologies',
  },
  {
    value: '1179',
    label: 'Annik Technology Services',
  },
  {
    value: '1486',
    label: 'Ansal API',
  },
  {
    value: '1282',
    label: 'Antal International',
  },
  {
    value: '978',
    label: 'Anthelio Business Technologies',
  },
  {
    value: '2301',
    label: 'Anthelio Healthcare Solutions',
  },
  {
    value: '2639',
    label: 'Anthem Biosciences Private Limited',
  },
  {
    value: '1163',
    label: 'Antique Stock Broking',
  },
  {
    value: '1304',
    label: 'Anvil Share & Stock Broking Pvt. Ltd',
  },
  {
    value: '2165',
    label: 'any organisation',
  },
  {
    value: '187',
    label: 'ANZ',
  },
  {
    value: '1193',
    label: 'AOL',
  },
  {
    value: '1024',
    label: 'Aon',
  },
  {
    value: '90',
    label: 'Aon Hewitt',
  },
  {
    value: '966',
    label: 'Apalya Technologies',
  },
  {
    value: '2622',
    label: 'APL Logistics (India) Pvt. Ltd',
  },
  {
    value: '1307',
    label: 'APM Terminals',
  },
  {
    value: '1164',
    label: 'Apollo Health and Lifestyle',
  },
  {
    value: '403',
    label: 'Apollo Hospitals',
  },
  {
    value: '1223',
    label: 'Apollo Munich Health Insurance',
  },
  {
    value: '685',
    label: 'Apollo Tyres Ltd',
  },
  {
    value: '2803',
    label: 'Appetals Solutions',
  },
  {
    value: '2808',
    label: 'Appinfoinc Traffic India',
  },
  {
    value: '1696',
    label: 'AppLabs',
  },
  {
    value: '823',
    label: 'Apple',
  },
  {
    value: '2342',
    label: 'Applied Materials',
  },
  {
    value: '1748',
    label: 'Applied Research International',
  },
  {
    value: '1653',
    label: 'AppsDaily Solutions Private Limited',
  },
  {
    value: '532',
    label: 'Aptara Corp',
  },
  {
    value: '1391',
    label: 'Aptech',
  },
  {
    value: '1916',
    label: 'Aqua Logistics',
  },
  {
    value: '139',
    label: 'Aranca',
  },
  {
    value: '2743',
    label: 'Araymond',
  },
  {
    value: '720',
    label: 'ArcelorMittal',
  },
  {
    value: '2180',
    label: 'ARC Financial Services',
  },
  {
    value: '1155',
    label: 'Arcil',
  },
  {
    value: '3171',
    label: 'Arete Consultants Private Limited',
  },
  {
    value: '1180',
    label: 'Areva',
  },
  {
    value: '2804',
    label: 'Areya Technologies',
  },
  {
    value: '1678',
    label: 'Ariba',
  },
  {
    value: '146',
    label: 'Aricent Technologies',
  },
  {
    value: '1909',
    label: 'Arihant Capital Markets Ltd',
  },
  {
    value: '2022',
    label: 'Aris Global',
  },
  {
    value: '1632',
    label: 'Arivum Business Solutions',
  },
  {
    value: '2394',
    label: 'Army',
  },
  {
    value: '154',
    label: 'Arshiya International Ltd',
  },
  {
    value: '1049',
    label: 'Arshiya Supply Chain Management',
  },
  {
    value: '1188',
    label: 'Artech Infosystems',
  },
  {
    value: '2054',
    label: 'Arthur D. Little',
  },
  {
    value: '2341',
    label: 'Artsana India Pvt Ltd',
  },
  {
    value: '1386',
    label: 'Arval India Private Limited',
  },
  {
    value: '950',
    label: 'Arvind Lifestyle Brands',
  },
  {
    value: '2479',
    label: 'Arvind Limited',
  },
  {
    value: '1735',
    label: 'ASA & Associates',
  },
  {
    value: '1182',
    label: 'Asahi India',
  },
  {
    value: '1754',
    label: 'Ascendas',
  },
  {
    value: '2847',
    label: 'Ascensia Diabetes Care',
  },
  {
    value: '2702',
    label: 'ASCP GPUONCLOUD',
  },
  {
    value: '1953',
    label: 'Ashika Stock Broking Ltd',
  },
  {
    value: '2742',
    label: 'Ashik KC',
  },
  {
    value: '2813',
    label: 'Ashnaa Placement Services',
  },
  {
    value: '211',
    label: 'Ashok Leyland',
  },
  {
    value: '1468',
    label: 'Ashok Piramal Group',
  },
  {
    value: '1243',
    label: 'Asia MotorWorks',
  },
  {
    value: '1218',
    label: 'Asian Business Exhibition & Conferences Ltd',
  },
  {
    value: '2114',
    label: 'Asian Development Bank',
  },
  {
    value: '1004',
    label: 'Asian Institute Of Management',
  },
  {
    value: '2788',
    label: 'Asian Institute Of Medical Sciences',
  },
  {
    value: '2748',
    label: 'Asian Lifts & Escalator',
  },
  {
    value: '1674',
    label: 'Asian Market Securities',
  },
  {
    value: '107',
    label: 'Asian Paints',
  },
  {
    value: '971',
    label: 'Asit C. Mehta Investment Interrmediates Ltd.',
  },
  {
    value: '2778',
    label: 'Asmaitha Wireless Technologies',
  },
  {
    value: '1415',
    label: 'Aspire Systems',
  },
  {
    value: '1071',
    label: 'Aspiring Minds Assessment Private Limited',
  },
  {
    value: '1101',
    label: 'Asset Reconstruction Company (India) Limited',
  },
  {
    value: '1254',
    label: 'Assistant Manager',
  },
  {
    value: '1991',
    label: 'Associated Chambers of Commerce & Industry of India',
  },
  {
    value: '497',
    label: 'AstraZeneca',
  },
  {
    value: '3077',
    label: 'AstraZeneca India Pvt Ltd',
  },
  {
    value: '1087',
    label: 'AT & T',
  },
  {
    value: '2069',
    label: 'ATC India Tower Corporation',
  },
  {
    value: '2176',
    label: 'Athena Demwe Power Limited',
  },
  {
    value: '1676',
    label: 'AT Kearney',
  },
  {
    value: '2953',
    label: 'Atlas Copco Group',
  },
  {
    value: '1720',
    label: 'Atlas Copco India Limited',
  },
  {
    value: '3074',
    label: 'Atomberg technologies Pvt Ltd',
  },
  {
    value: '217',
    label: 'Atos',
  },
  {
    value: '2199',
    label: 'Attero Recycling',
  },
  {
    value: '2571',
    label: 'Attra',
  },
  {
    value: '2370',
    label: 'Atul Limited',
  },
  {
    value: '1347',
    label: 'Auctus Advisors',
  },
  {
    value: '1837',
    label: 'Audi',
  },
  {
    value: '3166',
    label: 'AUDINTEL INDIA PRIVATE LIMITED',
  },
  {
    value: '1384',
    label: 'Audit',
  },
  {
    value: '1894',
    label: 'AUM Capital',
  },
  {
    value: '1144',
    label: 'aurionPro',
  },
  {
    value: '1615',
    label: 'Aurobindo Pharma',
  },
  {
    value: '2265',
    label: 'Auroch Investment Managers',
  },
  {
    value: '1565',
    label: 'Auronova Consulting Private Ltd.',
  },
  {
    value: '2711',
    label: 'Auta Associates',
  },
  {
    value: '1341',
    label: 'AuthBridge Research Services',
  },
  {
    value: '2298',
    label: 'Autodesk India Pvt Ltd',
  },
  {
    value: '462',
    label: 'Automobile',
  },
  {
    value: '2421',
    label: 'Autoportal',
  },
  {
    value: '2518',
    label: 'Avail Finance',
  },
  {
    value: '3036',
    label: 'Avalara Technologies Pvt ltd',
  },
  {
    value: '569',
    label: 'Avalon Consulting',
  },
  {
    value: '2790',
    label: 'Avance Consultant',
  },
  {
    value: '2830',
    label: 'Avantika Medex',
  },
  {
    value: '2905',
    label: 'Avataar.me',
  },
  {
    value: '458',
    label: 'Avaya GlobalConnect',
  },
  {
    value: '398',
    label: 'Avendus Capital',
  },
  {
    value: '3134',
    label: 'AVENDUS CAPITAL PVT LTD',
  },
  {
    value: '535',
    label: 'Avery Dennison',
  },
  {
    value: '1941',
    label: 'Avika Group',
  },
  {
    value: '112',
    label: 'Aviva Life Insurance',
  },
  {
    value: '1423',
    label: 'Avnet Technology Solutions',
  },
  {
    value: '2016',
    label: 'Avon Beauty Products',
  },
  {
    value: '621',
    label: 'AVON Beauty Products India',
  },
  {
    value: '1892',
    label: 'AXA',
  },
  {
    value: '760',
    label: 'AXA Business Services',
  },
  {
    value: '1297',
    label: 'AXA Technology Services',
  },
  {
    value: '2172',
    label: 'Axiom Consulting',
  },
  {
    value: '19',
    label: 'Axis Bank',
  },
  {
    value: '997',
    label: 'Axtria',
  },
  {
    value: '1159',
    label: 'AZ Research Partners',
  },
  {
    value: '3000',
    label: 'Azul Systems India Pvt Ltd',
  },
  {
    value: '1292',
    label: 'Azure Power',
  },
  {
    value: '1291',
    label: 'B&K Securities',
  },
  {
    value: '3129',
    label: 'B9 Beverages Private Limited',
  },
  {
    value: '1398',
    label: 'Babyoye.com',
  },
  {
    value: '868',
    label: 'Bacardi India',
  },
  {
    value: '105',
    label: 'BA Continuum India Pvt. Ltd.',
  },
  {
    value: '1520',
    label: 'Bahwan CyberTek Pvt Ltd',
  },
  {
    value: '408',
    label: 'Bain & Company',
  },
  {
    value: '96',
    label: 'Bajaj Allianz',
  },
  {
    value: '201',
    label: 'Bajaj Auto Limited',
  },
  {
    value: '522',
    label: 'Bajaj Capital',
  },
  {
    value: '1083',
    label: 'Bajaj Corp',
  },
  {
    value: '680',
    label: 'Bajaj Electricals',
  },
  {
    value: '274',
    label: 'Bajaj Finance',
  },
  {
    value: '2552',
    label: 'Bajaj Finserv',
  },
  {
    value: '2384',
    label: 'Balaji Telefilms Limited',
  },
  {
    value: '353',
    label: 'Ballarpur Industries Limited',
  },
  {
    value: '777',
    label: 'Balmer Lawrie & Co Ltd',
  },
  {
    value: '1741',
    label: 'Bangalore International Airport Limited',
  },
  {
    value: '2436',
    label: 'BankBazaar',
  },
  {
    value: '208',
    label: 'Banking',
  },
  {
    value: '2311',
    label: 'BankMuscat',
  },
  {
    value: '1146',
    label: 'Bank Muscat',
  },
  {
    value: '44',
    label: 'Bank of America',
  },
  {
    value: '222',
    label: 'Bank of Baroda',
  },
  {
    value: '183',
    label: 'Bank of India',
  },
  {
    value: '548',
    label: 'Bank of Maharashtra',
  },
  {
    value: '2264',
    label: 'Bank of Tokyo',
  },
  {
    value: '37',
    label: 'Barclays',
  },
  {
    value: '764',
    label: 'Bartronics',
  },
  {
    value: '1639',
    label: 'BASES, The Nielsen Company',
  },
  {
    value: '738',
    label: 'BASF',
  },
  {
    value: '496',
    label: 'Basix',
  },
  {
    value: '1938',
    label: 'Baskin Robbins',
  },
  {
    value: '476',
    label: 'Bata',
  },
  {
    value: '1037',
    label: 'Batlivala & Karani Securities (India) Pvt. Ltd',
  },
  {
    value: '747',
    label: 'Bausch & Lomb',
  },
  {
    value: '722',
    label: 'Baxter',
  },
  {
    value: '531',
    label: 'Bayer',
  },
  {
    value: '1326',
    label: 'BBC',
  },
  {
    value: '1330',
    label: 'B Braun Medical India Pvt Limited',
  },
  {
    value: '491',
    label: 'BCG',
  },
  {
    value: '545',
    label: 'BDO Consulting',
  },
  {
    value: '3069',
    label: 'BDO India',
  },
  {
    value: '2109',
    label: 'Beacon Insurance Brokers Pvt. Ltd',
  },
  {
    value: '1010',
    label: 'Beam Global',
  },
  {
    value: '1338',
    label: 'Bechtel Corporation',
  },
  {
    value: '837',
    label: 'Becton, Dickinson and Company',
  },
  {
    value: '447',
    label: 'Beetel Teletech',
  },
  {
    value: '1819',
    label: 'Bekaert Industries Private Limited',
  },
  {
    value: '1672',
    label: 'BEML Ltd',
  },
  {
    value: '1624',
    label: 'Benchmark Six Sigma',
  },
  {
    value: '303',
    label: 'Berger Paints',
  },
  {
    value: '1573',
    label: 'Berggruen Group',
  },
  {
    value: '1100',
    label: 'Berkadia Commercial Mortgage',
  },
  {
    value: '1544',
    label: 'Berkshire India',
  },
  {
    value: '160',
    label: 'Beroe Inc',
  },
  {
    value: '1722',
    label: 'Bertelsmann Marketing Services India',
  },
  {
    value: '2336',
    label: 'Bertling Logistics India Pvt Ltd',
  },
  {
    value: '1838',
    label: 'Best Engineering Aids & Consultancies Pvt Ltd',
  },
  {
    value: '1078',
    label: 'beStylish.com',
  },
  {
    value: '2891',
    label: 'BetterPlace',
  },
  {
    value: '2492',
    label: 'Bewakoof.com',
  },
  {
    value: '2668',
    label: 'Beyond Key Systems',
  },
  {
    value: '1531',
    label: 'BG Group',
  },
  {
    value: '995',
    label: 'BGR Energy Systems',
  },
  {
    value: '999',
    label: 'Bharat Aluminium Company Limited',
  },
  {
    value: '2319',
    label: 'Bharat Bijlee',
  },
  {
    value: '1502',
    label: 'Bharat Electronics',
  },
  {
    value: '1122',
    label: 'Bharat Forge',
  },
  {
    value: '263',
    label: 'Bharat Heavy Electricals Limited',
  },
  {
    value: '2631',
    label: 'Bharathire.com Private Limited',
  },
  {
    value: '236',
    label: 'Bharat Petroleum Corporation Limited',
  },
  {
    value: '2232',
    label: 'Bharat Sanchar Nigam Limited',
  },
  {
    value: '2697',
    label: 'Bhargava Phytolab',
  },
  {
    value: '16',
    label: 'Bharti Airtel',
  },
  {
    value: '3106',
    label: 'Bharti Airtel Limited',
  },
  {
    value: '155',
    label: 'Bharti Axa Life Insurance',
  },
  {
    value: '340',
    label: 'Bharti Infratel',
  },
  {
    value: '1236',
    label: 'Bharti Realty',
  },
  {
    value: '121',
    label: 'Bharti Walmart',
  },
  {
    value: '659',
    label: 'Bhushan Power & Steel Ltd',
  },
  {
    value: '2551',
    label: 'BIBA',
  },
  {
    value: '2395',
    label: 'BIBA Apparels',
  },
  {
    value: '948',
    label: 'Big 4 Consulting Firm',
  },
  {
    value: '1772',
    label: 'Big Bazaar',
  },
  {
    value: '2600',
    label: 'Bigsea Marcom (I) Pvt. Ltd',
  },
  {
    value: '1903',
    label: 'BigShoeBazaar India Pvt Limited',
  },
  {
    value: '2009',
    label: 'Bikanervala Foods Private Ltd',
  },
  {
    value: '2113',
    label: 'Bilcare Ltd',
  },
  {
    value: '3146',
    label: 'BILVANTIS TECHNOLOGIES PRIVATE LIMITED',
  },
  {
    value: '2154',
    label: 'BIMTECH',
  },
  {
    value: '910',
    label: 'Binani Industries Limited',
  },
  {
    value: '337',
    label: 'Biocon',
  },
  {
    value: '2474',
    label: 'biojoby.com',
  },
  {
    value: '2084',
    label: 'Birla Corporation Limited',
  },
  {
    value: '1843',
    label: 'Birla Research & Life Sciences',
  },
  {
    value: '229',
    label: 'Birlasoft',
  },
  {
    value: '130',
    label: 'Birla Sun Life Insurance',
  },
  {
    value: '1797',
    label: 'Birla Tyre',
  },
  {
    value: '1732',
    label: 'BIRLA TYRES',
  },
  {
    value: '873',
    label: 'Bisleri International Pvt Ltd',
  },
  {
    value: '1114',
    label: 'BlackBerry',
  },
  {
    value: '2935',
    label: 'BlackBuck',
  },
  {
    value: '409',
    label: 'BlackRock',
  },
  {
    value: '1525',
    label: 'Blend Financial Services Limited',
  },
  {
    value: '2591',
    label: 'Blewminds',
  },
  {
    value: '589',
    label: 'Bloomberg',
  },
  {
    value: '1432',
    label: 'Blue Dart Express',
  },
  {
    value: '1851',
    label: 'Bluedart Express Ltd',
  },
  {
    value: '705',
    label: 'Blue Ocean Market Intelligence',
  },
  {
    value: '568',
    label: 'Blue Star Limited',
  },
  {
    value: '2718',
    label: 'Blum India',
  },
  {
    value: '1018',
    label: 'BMA Wealth Creators',
  },
  {
    value: '2887',
    label: 'BMC Software',
  },
  {
    value: '1260',
    label: 'BMR & Associates',
  },
  {
    value: '445',
    label: 'BMR Advisors',
  },
  {
    value: '3136',
    label: 'BMTG Advisors India Private Limited',
  },
  {
    value: '1239',
    label: 'BMW India',
  },
  {
    value: '3086',
    label: 'BNB Groupe',
  },
  {
    value: '256',
    label: 'BNP Paribas',
  },
  {
    value: '190',
    label: 'BNY Mellon',
  },
  {
    value: '1641',
    label: 'BOC India Limited',
  },
  {
    value: '870',
    label: 'Boehringer Ingelheim',
  },
  {
    value: '2242',
    label: 'Boeing',
  },
  {
    value: '2156',
    label: 'Bombardier Transportation India Limited',
  },
  {
    value: '1818',
    label: 'Bombay Dyeing',
  },
  {
    value: '902',
    label: 'Bombay Stock Exchange',
  },
  {
    value: '754',
    label: 'Bonanza Portfolio Limited',
  },
  {
    value: '2093',
    label: 'Bookadda.com',
  },
  {
    value: '778',
    label: 'Booz & Company',
  },
  {
    value: '161',
    label: 'Bosch',
  },
  {
    value: '2793',
    label: 'Bostik India',
  },
  {
    value: '605',
    label: 'Boston Analytics',
  },
  {
    value: '3080',
    label: 'Boult Audio',
  },
  {
    value: '2307',
    label: 'Boutique Investment bank',
  },
  {
    value: '1027',
    label: 'BPO',
  },
  {
    value: '1023',
    label: 'BPTP',
  },
  {
    value: '2988',
    label: 'BRADKEN',
  },
  {
    value: '1752',
    label: 'Brady Corporation',
  },
  {
    value: '2063',
    label: 'Brakes India Ltd',
  },
  {
    value: '2714',
    label: 'BramhaCorp',
  },
  {
    value: '1693',
    label: 'Brand Capital',
  },
  {
    value: '1747',
    label: 'Brandscapes Worldwide',
  },
  {
    value: '2203',
    label: 'Brescon Corporate Advisors (P) Ltd',
  },
  {
    value: '721',
    label: 'Brickwork India',
  },
  {
    value: '771',
    label: 'Brics Securities',
  },
  {
    value: '2459',
    label: 'BRIDGE I2I',
  },
  {
    value: '2471',
    label: 'Brigade Group',
  },
  {
    value: '1124',
    label: 'Brightpoint India',
  },
  {
    value: '2461',
    label: 'Brillio',
  },
  {
    value: '413',
    label: 'Bristlecone',
  },
  {
    value: '1694',
    label: 'Bristol Myers Squibb',
  },
  {
    value: '136',
    label: 'Britannia',
  },
  {
    value: '1140',
    label: 'British Council',
  },
  {
    value: '1914',
    label: 'BRITISH HIGH COMMISSION',
  },
  {
    value: '625',
    label: 'British Telecom',
  },
  {
    value: '1021',
    label: 'Broadcom',
  },
  {
    value: '2499',
    label: 'Broadridge',
  },
  {
    value: '614',
    label: 'Broadridge Financial Solution',
  },
  {
    value: '1977',
    label: 'Broking',
  },
  {
    value: '2541',
    label: 'BrowserStack',
  },
  {
    value: '1850',
    label: 'BSES',
  },
  {
    value: '1688',
    label: 'BS Limited',
  },
  {
    value: '1053',
    label: 'BSNL',
  },
  {
    value: '749',
    label: 'BSR & Co.',
  },
  {
    value: '1878',
    label: 'BT',
  },
  {
    value: '1933',
    label: 'BT Global Services',
  },
  {
    value: '3143',
    label: 'Bundl Technologies',
  },
  {
    value: '1242',
    label: 'Bunge India',
  },
  {
    value: '1141',
    label: 'Bureau Veritas',
  },
  {
    value: '2832',
    label: 'Burgeon IT Services',
  },
  {
    value: '2493',
    label: 'Burger Singh',
  },
  {
    value: '1809',
    label: 'Business Analyst',
  },
  {
    value: '1976',
    label: 'Business Development Bureau (India) Private Limited',
  },
  {
    value: '2403',
    label: 'Business Octane Solutions Pvt. Ltd.',
  },
  {
    value: '2282',
    label: 'Business Standard',
  },
  {
    value: '2002',
    label: 'Business Standard Ltd',
  },
  {
    value: '930',
    label: 'Butterfield Fulcrum',
  },
  {
    value: '1235',
    label: 'Butterfly Appliances',
  },
  {
    value: '1690',
    label: 'buytheprice.com',
  },
  {
    value: '2538',
    label: "BYJU'S",
  },
  {
    value: '2553',
    label: 'ByteDance',
  },
  {
    value: '2255',
    label: 'C&C Constructions Limited',
  },
  {
    value: '2401',
    label: 'C-Quest Capital',
  },
  {
    value: '1721',
    label: 'C3i Support Services',
  },
  {
    value: '1041',
    label: 'CA',
  },
  {
    value: '1990',
    label: 'Cable & Wireless WorldWide',
  },
  {
    value: '227',
    label: 'Cadbury',
  },
  {
    value: '2020',
    label: 'Cadence Design Systems',
  },
  {
    value: '233',
    label: 'Cadila',
  },
  {
    value: '1603',
    label: 'CAE Simulation Technologies',
  },
  {
    value: '245',
    label: 'CA Firm',
  },
  {
    value: '992',
    label: 'Cairn Energy',
  },
  {
    value: '642',
    label: 'Cairn India',
  },
  {
    value: '813',
    label: 'Caliber Point',
  },
  {
    value: '3163',
    label: 'CALLAWAY DIGITAL TECHNOLOGIES PRIVATE LIMITED',
  },
  {
    value: '2237',
    label: 'Callaway Golf Company',
  },
  {
    value: '1884',
    label: 'Calypso Technologies Limited',
  },
  {
    value: '2463',
    label: 'Cameron',
  },
  {
    value: '2094',
    label: 'Camlin Ltd',
  },
  {
    value: '986',
    label: 'Canara Bank',
  },
  {
    value: '404',
    label:
      'Canara HSBC Oriental Bank of Commerce Life Insurance Company Limited',
  },
  {
    value: '908',
    label: 'Canara Robeco',
  },
  {
    value: '486',
    label: 'Canon',
  },
  {
    value: '2189',
    label: 'Capco Technologies',
  },
  {
    value: '21',
    label: 'Capgemini',
  },
  {
    value: '2481',
    label: 'capillary',
  },
  {
    value: '695',
    label: 'Capillary Technologies',
  },
  {
    value: '421',
    label: 'Capita',
  },
  {
    value: '2883',
    label: 'Capita India Pvt. Ltd',
  },
  {
    value: '2074',
    label: 'Capital Code India Private Limited',
  },
  {
    value: '547',
    label: 'Capital First Limited',
  },
  {
    value: '2159',
    label: 'Capital Foods Limited',
  },
  {
    value: '1153',
    label: 'Capital Fortunes',
  },
  {
    value: '147',
    label: 'Capital IQ',
  },
  {
    value: '1405',
    label: 'Capital Market Publishers',
  },
  {
    value: '273',
    label: 'Capital One',
  },
  {
    value: '1314',
    label: 'Capital Square Advisors Pvt Ltd',
  },
  {
    value: '2427',
    label: 'Capital Trust',
  },
  {
    value: '1176',
    label: 'Capitalvia',
  },
  {
    value: '2757',
    label: 'Capp Systems India',
  },
  {
    value: '783',
    label: 'Capstone Securities Analysis',
  },
  {
    value: '2181',
    label: 'Capvent India Advisors Private Ltd',
  },
  {
    value: '2418',
    label: 'Caravan LLP',
  },
  {
    value: '3126',
    label: 'CarDekho',
  },
  {
    value: '2111',
    label: 'CarDekho.com',
  },
  {
    value: '3156',
    label: 'cardinalhealth',
  },
  {
    value: '1869',
    label: 'CARE',
  },
  {
    value: '1880',
    label: 'Career Avenues',
  },
  {
    value: '1663',
    label: 'Careerist Management Consultant Pvt. Ltd.',
  },
  {
    value: '815',
    label: 'Career Launcher',
  },
  {
    value: '784',
    label: 'CareerNet',
  },
  {
    value: '1728',
    label: 'CareerNet Technologies Pvt Ltd',
  },
  {
    value: '2303',
    label: 'CARE Hospitals',
  },
  {
    value: '259',
    label: 'CARE Ratings',
  },
  {
    value: '470',
    label: 'Cargill India Private Limited',
  },
  {
    value: '613',
    label: 'Carlsberg',
  },
  {
    value: '2017',
    label: 'Carlson Wagonlit Travels',
  },
  {
    value: '1266',
    label: 'Carl Zeiss',
  },
  {
    value: '2979',
    label: 'Carl Zeiss India ( Bangalore ) Pvt Ltd',
  },
  {
    value: '831',
    label: 'Carnation Auto India Pvt. Ltd.',
  },
  {
    value: '2630',
    label: 'CARNATION INFOTECH PRIVATE LIMITED',
  },
  {
    value: '1264',
    label: 'Carrefour',
  },
  {
    value: '2053',
    label: 'Carrier',
  },
  {
    value: '2422',
    label: 'Cars24',
  },
  {
    value: '3099',
    label: 'CARS24 SERVICES PRIVATE LIMITED',
  },
  {
    value: '1828',
    label: 'Cartesian Consultancy',
  },
  {
    value: '2266',
    label: 'CarWale.com',
  },
  {
    value: '1571',
    label: 'Carzonrent India Pvt. Ltd.',
  },
  {
    value: '3151',
    label: 'casagrand',
  },
  {
    value: '2026',
    label: 'Case-Mate',
  },
  {
    value: '3102',
    label: 'cashify',
  },
  {
    value: '293',
    label: 'Castrol',
  },
  {
    value: '2958',
    label: 'Catalent, Inc.',
  },
  {
    value: '671',
    label: 'CA Technologies',
  },
  {
    value: '546',
    label: 'Caterpillar',
  },
  {
    value: '2096',
    label: 'Catwalk',
  },
  {
    value: '285',
    label: 'CavinKare',
  },
  {
    value: '731',
    label: 'CBRE Group',
  },
  {
    value: '988',
    label: 'CB Richard Ellis',
  },
  {
    value: '2740',
    label: 'CBT Infotech',
  },
  {
    value: '1084',
    label: 'CDAC',
  },
  {
    value: '2525',
    label: 'CDK Global',
  },
  {
    value: '610',
    label: 'Cease Fire Industries',
  },
  {
    value: '366',
    label: 'CEAT',
  },
  {
    value: '342',
    label: 'CEB',
  },
  {
    value: '1577',
    label: 'Cedar Management Consulting',
  },
  {
    value: '1831',
    label: 'Cegedim India Pvt Ltd',
  },
  {
    value: '3043',
    label: 'Celon Laboratories Pvt Ltd',
  },
  {
    value: '1231',
    label: 'Centaurus Financial Services',
  },
  {
    value: '346',
    label: 'Central Bank of India',
  },
  {
    value: '2041',
    label: 'Central Government',
  },
  {
    value: '1421',
    label: 'Centre for Monitoring Indian Economy Pvt. Ltd.',
  },
  {
    value: '1186',
    label: 'Centrum Broking Pvt Ltd',
  },
  {
    value: '652',
    label: 'Centrum Capital Limited',
  },
  {
    value: '1854',
    label: 'Centrum Wealth Management',
  },
  {
    value: '464',
    label: 'Centum Learning',
  },
  {
    value: '1490',
    label: 'Centum Workskills India Ltd',
  },
  {
    value: '1237',
    label: 'CenturyLink',
  },
  {
    value: '604',
    label: 'Century Plyboards (India) Ltd',
  },
  {
    value: '3091',
    label: 'Century Real Estate Holdings Pvt. Ltd',
  },
  {
    value: '851',
    label: 'Cerebrus Consultants',
  },
  {
    value: '2842',
    label: 'Cereiv Advisory LLP',
  },
  {
    value: '1776',
    label: 'Cerner Healthcare Solutions',
  },
  {
    value: '810',
    label: 'CEVA Logistics',
  },
  {
    value: '1628',
    label: 'CFA',
  },
  {
    value: '380',
    label: 'CGI Group',
  },
  {
    value: '684',
    label: 'CGN & Associates',
  },
  {
    value: '2612',
    label: 'CGRA Private Limited',
  },
  {
    value: '2345',
    label: 'Chambal Fertilisers and Chemicals Limited',
  },
  {
    value: '2819',
    label: 'Chandigarh University',
  },
  {
    value: '1205',
    label: 'Channelplay Limited',
  },
  {
    value: '469',
    label: 'Cheers Interactive',
  },
  {
    value: '2512',
    label: 'Chegg',
  },
  {
    value: '1003',
    label: 'CHEP India',
  },
  {
    value: '2708',
    label: 'Cherry Pick Talents',
  },
  {
    value: '2331',
    label: 'Chinatrust Commercial Bank',
  },
  {
    value: '1345',
    label: 'Choice Solutions Limited',
  },
  {
    value: '2272',
    label: 'Chokshi & Chokshi',
  },
  {
    value: '759',
    label: 'Cholamandalam Investment and Finance Company Limited',
  },
  {
    value: '2228',
    label: 'Cholamandalam Securities',
  },
  {
    value: '1724',
    label: 'Cholayil Private Limited',
  },
  {
    value: '2018',
    label: 'Christ University',
  },
  {
    value: '2737',
    label: 'Chubb Business Services',
  },
  {
    value: '980',
    label: 'Cians Analytics',
  },
  {
    value: '1922',
    label: 'CIBER',
  },
  {
    value: '2955',
    label: 'Ciena India Private Ltd.',
  },
  {
    value: '1891',
    label: 'CII',
  },
  {
    value: '2839',
    label: 'Cimpress India',
  },
  {
    value: '1993',
    label: 'Cinemax India Limited',
  },
  {
    value: '1162',
    label: 'Cinepolis India Pvt. Ltd.',
  },
  {
    value: '349',
    label: 'Cipla',
  },
  {
    value: '225',
    label: 'Cisco',
  },
  {
    value: '2965',
    label: 'Citi',
  },
  {
    value: '28',
    label: 'Citibank',
  },
  {
    value: '442',
    label: 'Citicorp Finance (India) Limited (CFIL)',
  },
  {
    value: '399',
    label: 'Citicorp Services India Limited',
  },
  {
    value: '2095',
    label: 'Citi Financial Consumer Finance India Ltd',
  },
  {
    value: '1812',
    label: 'Citigate Dewe Rogerson',
  },
  {
    value: '119',
    label: 'Citigroup',
  },
  {
    value: '1429',
    label: 'Citi Group',
  },
  {
    value: '1789',
    label: 'Citi Research',
  },
  {
    value: '1137',
    label: 'CitiusTech',
  },
  {
    value: '2964',
    label: 'Citrix',
  },
  {
    value: '1451',
    label: 'Citrix Systems',
  },
  {
    value: '1925',
    label: 'Citrus Check Inns',
  },
  {
    value: '2323',
    label: 'Citrus Payment Solutions',
  },
  {
    value: '1002',
    label: 'City Union Bank',
  },
  {
    value: '1133',
    label: 'CK Birla Group',
  },
  {
    value: '2057',
    label: 'CLAAS India Pvt. Ltd.',
  },
  {
    value: '2196',
    label: 'Classic Stripes Pvt Ltd',
  },
  {
    value: '993',
    label: 'Cleartrip.com',
  },
  {
    value: '692',
    label: 'CL Educate',
  },
  {
    value: '2218',
    label: 'Clickable Inc.',
  },
  {
    value: '2173',
    label: 'Clifford Chance LLP',
  },
  {
    value: '2347',
    label: 'Clockwork Business Solutions Pvt. Ltd.',
  },
  {
    value: '2855',
    label: 'Cloudalyze Services LLP',
  },
  {
    value: '2858',
    label: 'Cloudely India',
  },
  {
    value: '2449',
    label: 'Cloudtail',
  },
  {
    value: '2133',
    label: 'Clover Infotech Pvt Ltd',
  },
  {
    value: '786',
    label: 'CLP India Private Limited',
  },
  {
    value: '1529',
    label: 'CLSA',
  },
  {
    value: '2537',
    label: 'Club Factory',
  },
  {
    value: '1516',
    label: 'Club Mahindra',
  },
  {
    value: '278',
    label: 'CMC Limited',
  },
  {
    value: '2072',
    label: 'CMMI 5 Level Company',
  },
  {
    value: '802',
    label: 'CMS Info Systems',
  },
  {
    value: '2432',
    label: 'CMS IT Services',
  },
  {
    value: '1127',
    label: 'CNBC-TV18',
  },
  {
    value: '2380',
    label: 'CNN-IBN',
  },
  {
    value: '647',
    label: 'Coal India Limited',
  },
  {
    value: '1309',
    label: 'Coastal Projects Limited',
  },
  {
    value: '1503',
    label: 'Coca Cola',
  },
  {
    value: '765',
    label: 'CoCubes Technologies Pvt. Ltd',
  },
  {
    value: '1136',
    label: 'Coffee Day Beverages',
  },
  {
    value: '678',
    label: 'Coffee Day Global',
  },
  {
    value: '2435',
    label: 'Cogencis',
  },
  {
    value: '2227',
    label: 'Cognilytics',
  },
  {
    value: '3157',
    label: 'COGNITIVZEN TECHNOLOGIES PRIVATE LIMITED',
  },
  {
    value: '3065',
    label: 'Cognizant',
  },
  {
    value: '9',
    label: 'Cognizant Technology Solutions',
  },
  {
    value: '2938',
    label: 'Cognizant Technology Solutions India Pvt Ltd',
  },
  {
    value: '2962',
    label: 'Coindcx',
  },
  {
    value: '300',
    label: 'Colgate Palmolive',
  },
  {
    value: '664',
    label: 'Collabera',
  },
  {
    value: '2586',
    label: 'Collegedunia',
  },
  {
    value: '1173',
    label: 'Colliers International',
  },
  {
    value: '2335',
    label: 'ColorPlus Fashions Ltd',
  },
  {
    value: '427',
    label: 'Colt Technologies',
  },
  {
    value: '1631',
    label: 'Columbia Asia Hospital',
  },
  {
    value: '2373',
    label: 'Columbia University',
  },
  {
    value: '2516',
    label: 'Comcast',
  },
  {
    value: '3160',
    label: 'Comefforts',
  },
  {
    value: '1316',
    label: 'CommonFloor.com',
  },
  {
    value: '1569',
    label: 'Commonwealth Bank of Australia',
  },
  {
    value: '2484',
    label: 'Commscope',
  },
  {
    value: '1455',
    label: 'Compass Group',
  },
  {
    value: '2358',
    label: 'CompuCom CSI Systems',
  },
  {
    value: '2727',
    label: 'Computer Task Information Technology Services',
  },
  {
    value: '2325',
    label: 'Compuware India',
  },
  {
    value: '2235',
    label: 'Comverse Network Systems',
  },
  {
    value: '485',
    label: 'Comviva Technologies',
  },
  {
    value: '2276',
    label: 'Concept Management Consulting Limited',
  },
  {
    value: '2652',
    label: 'Concourse Consultancy Services P Ltd',
  },
  {
    value: '700',
    label: 'Confederation of Indian Industry',
  },
  {
    value: '2126',
    label: 'Confi',
  },
  {
    value: '104',
    label: 'Confidential',
  },
  {
    value: '2573',
    label: 'Connexions Company',
  },
  {
    value: '1208',
    label: 'Consim Info Pvt Ltd',
  },
  {
    value: '1044',
    label: 'Construction',
  },
  {
    value: '1210',
    label: 'Consultancy',
  },
  {
    value: '775',
    label: 'Consultant',
  },
  {
    value: '392',
    label: 'Consulting',
  },
  {
    value: '2838',
    label: 'Consumer Cloud Technology Services',
  },
  {
    value: '2187',
    label: 'Consumer Goods',
  },
  {
    value: '2818',
    label: 'Consummate Technologies',
  },
  {
    value: '1479',
    label: 'Contakt Tech Solutions',
  },
  {
    value: '1365',
    label: 'Contract Advertising',
  },
  {
    value: '3045',
    label: 'CONVERGINT INDIA PRIVATE LIMITED',
  },
  {
    value: '253',
    label: 'Convergys',
  },
  {
    value: '82',
    label: 'Copal Partners',
  },
  {
    value: '1226',
    label: 'Corbus India Limited',
  },
  {
    value: '702',
    label: 'CORE Education & Technologies',
  },
  {
    value: '1224',
    label: 'CoreEL Technologies',
  },
  {
    value: '1885',
    label: 'CoreLogic Global Services',
  },
  {
    value: '466',
    label: 'Coromandel International Limited',
  },
  {
    value: '709',
    label: 'Corporation Bank',
  },
  {
    value: '1745',
    label: 'Cortaal Global',
  },
  {
    value: '2853',
    label: 'Corteva Agriscience India',
  },
  {
    value: '1893',
    label: 'Cosmos Bank',
  },
  {
    value: '1538',
    label: 'Country Club',
  },
  {
    value: '3109',
    label: 'COUTLOOT',
  },
  {
    value: '3037',
    label: 'covalensedigital',
  },
  {
    value: '3121',
    label: 'Coverfox Insurance Broking Pvt. Ltd.',
  },
  {
    value: '929',
    label: 'Cox & Kings',
  },
  {
    value: '538',
    label: 'CPA Global',
  },
  {
    value: '2166',
    label: 'Cranes Software',
  },
  {
    value: '2424',
    label: 'CreamBell',
  },
  {
    value: '2620',
    label: 'Creative Info-Link Pvt. Ltd',
  },
  {
    value: '2572',
    label: 'Cred',
  },
  {
    value: '3170',
    label: 'Credavenue',
  },
  {
    value: '1511',
    label: 'Credence Analytics',
  },
  {
    value: '1333',
    label: 'Credit Agricole CIB',
  },
  {
    value: '171',
    label: 'Credit Analysis and Research Limited',
  },
  {
    value: '1310',
    label: 'CreditPointe',
  },
  {
    value: '1518',
    label: 'Credit Pointe Services Private Ltd.',
  },
  {
    value: '56',
    label: 'Credit Suisse',
  },
  {
    value: '17',
    label: 'CRISIL',
  },
  {
    value: '2738',
    label: 'CriticalRiver Technologies Private Limited',
  },
  {
    value: '1474',
    label: 'CRMIT Solutions',
  },
  {
    value: '1904',
    label: 'Croma Retail',
  },
  {
    value: '661',
    label: 'Crompton Greaves',
  },
  {
    value: '2410',
    label: 'Cropin Technology Solutions',
  },
  {
    value: '1280',
    label: 'Crossdomain Solutions Private Limited',
  },
  {
    value: '1393',
    label: 'Cross Tab Marketing Services',
  },
  {
    value: '2824',
    label: 'CRRC India',
  },
  {
    value: '1533',
    label: 'CRY',
  },
  {
    value: '2012',
    label: 'Cryo-Save India Limited',
  },
  {
    value: '1888',
    label: 'Cryobanks International',
  },
  {
    value: '66',
    label: 'CSC',
  },
  {
    value: '1813',
    label: 'CSG',
  },
  {
    value: '649',
    label: 'CSS Corp',
  },
  {
    value: '1194',
    label: 'Cubastion Consulting',
  },
  {
    value: '2411',
    label: 'Cube26',
  },
  {
    value: '1896',
    label: 'Cucine Lube India',
  },
  {
    value: '116',
    label: 'Cummins',
  },
  {
    value: '1967',
    label: 'Cura Technologies',
  },
  {
    value: '2529',
    label: 'Cure.Fit',
  },
  {
    value: '3135',
    label: 'CURIA INDIA PRIVATE LIMITED',
  },
  {
    value: '292',
    label: 'Currently Unemployed',
  },
  {
    value: '417',
    label: 'Cushman & Wakefield',
  },
  {
    value: '1318',
    label: 'Customer Centria Enterprise Pvt Ltd',
  },
  {
    value: '1528',
    label: 'CustomerXPs Software Pvt Ltd',
  },
  {
    value: '1000',
    label: 'Cvent',
  },
  {
    value: '1058',
    label: 'Cybage Software',
  },
  {
    value: '880',
    label: 'Cyber Media Research Limited',
  },
  {
    value: '982',
    label: 'Cybertech Systems & Software',
  },
  {
    value: '889',
    label: 'Cygnus Business Consulting & Research',
  },
  {
    value: '2998',
    label: 'Cyient',
  },
  {
    value: '2997',
    label: 'Cyient Limited',
  },
  {
    value: '450',
    label: 'Cypress Semiconductor',
  },
  {
    value: '1222',
    label: 'D&B TransUnion',
  },
  {
    value: '189',
    label: 'D. E. Shaw & Co',
  },
  {
    value: '177',
    label: 'Dabur',
  },
  {
    value: '2640',
    label: 'Daffodils Management Consultancy',
  },
  {
    value: '1245',
    label: 'Daikin Airconditioning India Private Limited',
  },
  {
    value: '343',
    label: 'Daimler India Commercial Vehicles',
  },
  {
    value: '436',
    label: 'Dainik Bhaskar',
  },
  {
    value: '1507',
    label: 'Dainik Jagran',
  },
  {
    value: '807',
    label: 'Daiwa Asset Management',
  },
  {
    value: '1161',
    label: 'Daiwa Capital Market India Pvt.Ltd',
  },
  {
    value: '2396',
    label: 'Dalal & Broacha Pvt. Ltd.',
  },
  {
    value: '2008',
    label: 'Dalal Street Investments Ltd.',
  },
  {
    value: '2402',
    label: 'Dale Carnegie Training',
  },
  {
    value: '321',
    label: 'Dalmia Bharat',
  },
  {
    value: '560',
    label: 'Damco',
  },
  {
    value: '1883',
    label: 'Damodar Valley Corporation',
  },
  {
    value: '1699',
    label: 'Dana Group',
  },
  {
    value: '1515',
    label: 'Danfoss Industries',
  },
  {
    value: '2148',
    label: 'Danone',
  },
  {
    value: '365',
    label: 'Darashaw',
  },
  {
    value: '2957',
    label: 'Darwinbox Digital Solutions Pvt Ltd',
  },
  {
    value: '1457',
    label: 'Dassault Systems',
  },
  {
    value: '328',
    label: 'Datamatics',
  },
  {
    value: '773',
    label: 'Datamonitor',
  },
  {
    value: '2746',
    label: 'Dataspark Technologies',
  },
  {
    value: '1336',
    label: 'Datawise Consultants',
  },
  {
    value: '2378',
    label: 'Dax Networks Limited',
  },
  {
    value: '651',
    label: 'D B Corp Ltd',
  },
  {
    value: '345',
    label: 'DBOI',
  },
  {
    value: '309',
    label: 'DBS Bank',
  },
  {
    value: '1115',
    label: 'DB Schenker',
  },
  {
    value: '931',
    label: 'DCB Bank',
  },
  {
    value: '655',
    label: 'DCM Shriram Consolidated',
  },
  {
    value: '657',
    label: 'DDB Mudra Group',
  },
  {
    value: '585',
    label: 'Dealsandyou.com',
  },
  {
    value: '845',
    label: 'Decathlon',
  },
  {
    value: '1142',
    label: 'Decimal Point Analytics',
  },
  {
    value: '3008',
    label: 'Deckrooster',
  },
  {
    value: '1246',
    label: 'Defence',
  },
  {
    value: '1268',
    label: 'Defiance Technologies',
  },
  {
    value: '1207',
    label: 'Delhi International Airport',
  },
  {
    value: '1825',
    label: 'Delhi Stock Exchange',
  },
  {
    value: '2163',
    label: 'Delhi University',
  },
  {
    value: '2015',
    label: 'Delhivery',
  },
  {
    value: '43',
    label: 'Dell',
  },
  {
    value: '6',
    label: 'Deloitte',
  },
  {
    value: '863',
    label: 'Delphi',
  },
  {
    value: '1860',
    label: 'Delta Electronics',
  },
  {
    value: '1252',
    label: 'Delta Power Solutions',
  },
  {
    value: '1917',
    label: 'Demag Cranes AG',
  },
  {
    value: '1253',
    label: 'Dena Bank',
  },
  {
    value: '1738',
    label: 'Denave India Private Ltd',
  },
  {
    value: '1742',
    label: 'DEN Networks Limited',
  },
  {
    value: '1035',
    label: 'DENSO',
  },
  {
    value: '900',
    label: 'Dentsu Inc.',
  },
  {
    value: '1042',
    label: 'DenuoSource',
  },
  {
    value: '1217',
    label: 'Derivium Tradition',
  },
  {
    value: '2739',
    label: 'Derric Wood',
  },
  {
    value: '2761',
    label: 'Desai Construction',
  },
  {
    value: '638',
    label: 'Destimoney Enterprises Pvt. Ltd.',
  },
  {
    value: '2070',
    label: 'Det Norske Veritas',
  },
  {
    value: '2644',
    label: 'Deuex Solutions',
  },
  {
    value: '22',
    label: 'Deutsche Bank',
  },
  {
    value: '3076',
    label: 'DEUTSCHE BANK AG',
  },
  {
    value: '730',
    label: 'Developement Credit Bank',
  },
  {
    value: '1229',
    label: 'Development Bank of Singapore',
  },
  {
    value: '1847',
    label: 'Devenio Optimus Advisors',
  },
  {
    value: '2977',
    label: 'Devon',
  },
  {
    value: '1247',
    label: 'Devyani International',
  },
  {
    value: '965',
    label: 'Dewan Housing Finance Corporation Limited',
  },
  {
    value: '1369',
    label: 'Dexter Consultancy Private Limited',
  },
  {
    value: '1469',
    label: 'DFM Foods Limited',
  },
  {
    value: '242',
    label: 'Dhanlaxmi Bank',
  },
  {
    value: '1982',
    label: 'Dhanush Infotech',
  },
  {
    value: '1160',
    label: 'Dharampal Satyapal Limited',
  },
  {
    value: '2725',
    label: 'Dheer Infocom Services',
  },
  {
    value: '862',
    label: 'DHFL',
  },
  {
    value: '433',
    label: 'DHL Express',
  },
  {
    value: '2491',
    label: 'DHL SmarTrucking',
  },
  {
    value: '2000',
    label: 'DIAB Core Materials Pvt Ltd',
  },
  {
    value: '247',
    label: 'Diageo',
  },
  {
    value: '2833',
    label: 'Dickinson Technology Consulting Services',
  },
  {
    value: '1028',
    label: 'Diebold',
  },
  {
    value: '1397',
    label: 'DIESL',
  },
  {
    value: '1626',
    label: 'Digicall Teleservices',
  },
  {
    value: '2776',
    label: 'Digital Infobytes',
  },
  {
    value: '1306',
    label: 'Digitas',
  },
  {
    value: '2779',
    label: 'DigiTech Insights',
  },
  {
    value: '2763',
    label: 'Digit Secure India',
  },
  {
    value: '1478',
    label: 'Diligent Media Corporation',
  },
  {
    value: '2626',
    label: 'Dilip Oak',
  },
  {
    value: '875',
    label: 'Dimension Data',
  },
  {
    value: '2721',
    label: 'Dinesmart Hospitality Services',
  },
  {
    value: '1806',
    label: 'Dinshaws Dairy Foods',
  },
  {
    value: '774',
    label: 'Dion Global Solutions',
  },
  {
    value: '580',
    label: 'Directi',
  },
  {
    value: '1770',
    label: 'Direxions Marketing Solutions',
  },
  {
    value: '703',
    label: 'Dishnet Wireless Limited',
  },
  {
    value: '334',
    label: 'Dish TV',
  },
  {
    value: '2089',
    label: 'Disney UTV',
  },
  {
    value: '2561',
    label: 'Diversity@Work',
  },
  {
    value: '2500',
    label: 'Dixcy Textiles',
  },
  {
    value: '383',
    label: 'DLF',
  },
  {
    value: '361',
    label: 'DLF Pramerica Life Insurance',
  },
  {
    value: '198',
    label: 'DMV Business and Market Research',
  },
  {
    value: '1464',
    label: 'DNA',
  },
  {
    value: '1488',
    label: 'Dodsal E&C India Pvt Ltd',
  },
  {
    value: '1585',
    label: 'Dolat Capital Market Pvt. Ltd.',
  },
  {
    value: '1051',
    label: 'Dolcera',
  },
  {
    value: '1755',
    label: 'Dolphin Group Of Companies',
  },
  {
    value: '2297',
    label: 'Donear Industries Ltd.',
  },
  {
    value: '3057',
    label: 'DoSelect',
  },
  {
    value: '1542',
    label: 'Doshion Private Limited',
  },
  {
    value: '2851',
    label: 'Dotpe',
  },
  {
    value: '835',
    label: 'Dow Chemical',
  },
  {
    value: '1757',
    label: 'Dow Corning',
  },
  {
    value: '2215',
    label: 'Dow Jones Consulting India Private Limited',
  },
  {
    value: '1590',
    label: 'DP World',
  },
  {
    value: '142',
    label: "Dr. Reddy's Laboratories",
  },
  {
    value: '743',
    label: 'Draft FCB Ulka',
  },
  {
    value: '2246',
    label: 'DRDO',
  },
  {
    value: '1817',
    label: 'Drewry Maritime Services',
  },
  {
    value: '1020',
    label: 'Drishti Soft',
  },
  {
    value: '1198',
    label: 'Drive India Enterprise Solutions Limited',
  },
  {
    value: '1902',
    label: 'Droege Group',
  },
  {
    value: '2568',
    label: 'droom.in',
  },
  {
    value: '1717',
    label: 'Drshti Strategic Research Services Pvt. Ltd',
  },
  {
    value: '768',
    label: 'DSCL',
  },
  {
    value: '1040',
    label: 'DS Group',
  },
  {
    value: '1211',
    label: 'DSM India',
  },
  {
    value: '2059',
    label: 'DSM Sinochem Pharmaceuticals',
  },
  {
    value: '1081',
    label: 'DSP BlackRock Investment Managers',
  },
  {
    value: '883',
    label: 'DTDC Courier & Cargo Ltd',
  },
  {
    value: '1296',
    label: 'DTZ International',
  },
  {
    value: '290',
    label: 'Dun & Bradstreet',
  },
  {
    value: '1601',
    label: 'Dunia Finance LLC',
  },
  {
    value: '639',
    label: 'Dunnhumby',
  },
  {
    value: '457',
    label: 'DuPont',
  },
  {
    value: '2614',
    label: 'Durocrete Engineering Services',
  },
  {
    value: '2560',
    label: 'DXC Technology',
  },
  {
    value: '1796',
    label: 'Dynamic Orbits',
  },
  {
    value: '1908',
    label: 'DY Works',
  },
  {
    value: '2044',
    label: 'E-Meditek',
  },
  {
    value: '3027',
    label: 'Eaglex Technology',
  },
  {
    value: '2514',
    label: 'EA India',
  },
  {
    value: '1416',
    label: 'Earth Infrastructures Ltd.',
  },
  {
    value: '1029',
    label: 'East India Securities',
  },
  {
    value: '2741',
    label: 'Easyrewardz',
  },
  {
    value: '521',
    label: 'Eaton Corporation',
  },
  {
    value: '544',
    label: 'eBay',
  },
  {
    value: '2149',
    label: 'eBIZ.com',
  },
  {
    value: '1261',
    label: 'Ebusinessware',
  },
  {
    value: '80',
    label: 'eClerx',
  },
  {
    value: '1271',
    label: 'Ecommerce',
  },
  {
    value: '2679',
    label: 'Ecom Shipping Solutions',
  },
  {
    value: '1191',
    label: 'Economic Times',
  },
  {
    value: '1802',
    label: 'Edelman',
  },
  {
    value: '390',
    label: 'Edelweiss',
  },
  {
    value: '588',
    label: 'Edelweiss Capital',
  },
  {
    value: '315',
    label: 'Edelweiss Financial Services',
  },
  {
    value: '644',
    label: 'Edelweiss Securities',
  },
  {
    value: '919',
    label: 'Edelweiss Tokio Life Insurance',
  },
  {
    value: '1413',
    label: 'Edenred',
  },
  {
    value: '711',
    label: 'Education',
  },
  {
    value: '1504',
    label: 'Educational Initiatives',
  },
  {
    value: '188',
    label: 'Educomp',
  },
  {
    value: '2322',
    label: 'EduKart.com',
  },
  {
    value: '1598',
    label: 'Edusys Services',
  },
  {
    value: '2248',
    label: 'Eduvisors',
  },
  {
    value: '2082',
    label: 'Edwards Lifesciences',
  },
  {
    value: '2141',
    label: 'Egis India',
  },
  {
    value: '2505',
    label: 'Egon Zehnder',
  },
  {
    value: '1545',
    label: 'Eicher',
  },
  {
    value: '1351',
    label: 'EICL Limited',
  },
  {
    value: '725',
    label: 'EID Parry',
  },
  {
    value: '869',
    label: 'Eka Software',
  },
  {
    value: '1537',
    label: 'Eko India Financial Services Private Limited',
  },
  {
    value: '2749',
    label: 'Ekta Cosmetics',
  },
  {
    value: '918',
    label: 'Elara Capital',
  },
  {
    value: '1119',
    label: 'Elder Health Care Limited',
  },
  {
    value: '1361',
    label: 'Elecon',
  },
  {
    value: '1272',
    label: 'Electronica Finance Limited',
  },
  {
    value: '1563',
    label: 'Electronic Arts',
  },
  {
    value: '3161',
    label: 'ELECTRONICS MART INDIA LIMITED',
  },
  {
    value: '979',
    label: 'Electrosteel Steels Limited',
  },
  {
    value: '1771',
    label: 'Electrotherm',
  },
  {
    value: '1773',
    label: 'Elephant Design',
  },
  {
    value: '1097',
    label: 'Eli Lilly and Company',
  },
  {
    value: '1547',
    label: 'ELitecore Technologies',
  },
  {
    value: '2510',
    label: 'Elixia',
  },
  {
    value: '1958',
    label: 'Elixir',
  },
  {
    value: '1281',
    label: 'Elixir Consulting',
  },
  {
    value: '960',
    label: 'Elixir Web solutions',
  },
  {
    value: '2880',
    label: 'Elliot Ebara Turbo Machinery India',
  },
  {
    value: '2332',
    label: 'Elsevier',
  },
  {
    value: '660',
    label: 'Emaar MGF',
  },
  {
    value: '215',
    label: 'Emami Limited',
  },
  {
    value: '1956',
    label: 'eMart solutions',
  },
  {
    value: '2445',
    label: 'Embassy',
  },
  {
    value: '3140',
    label: 'Embassy Group',
  },
  {
    value: '2253',
    label: 'Embee Software',
  },
  {
    value: '1600',
    label: 'Embitel',
  },
  {
    value: '1792',
    label: 'embryoFund',
  },
  {
    value: '434',
    label: 'EMC Corporation',
  },
  {
    value: '2579',
    label: 'EMCURE',
  },
  {
    value: '1329',
    label: 'Emcure Pharamaceuticals',
  },
  {
    value: '2772',
    label: 'em electronix',
  },
  {
    value: '934',
    label: 'Emergent Ventures',
  },
  {
    value: '1139',
    label: 'Emerson',
  },
  {
    value: '816',
    label: 'Emerson Network Power',
  },
  {
    value: '2162',
    label: 'Emerson Process Management',
  },
  {
    value: '2310',
    label: 'emids Technologies',
  },
  {
    value: '1420',
    label: 'Emirates NBD',
  },
  {
    value: '423',
    label: 'Emkay Global Financial Services',
  },
  {
    value: '2098',
    label: 'Emkor Solutions',
  },
  {
    value: '2915',
    label: 'Emoha Eldercare',
  },
  {
    value: '2150',
    label: 'Empire Industries Ltd',
  },
  {
    value: '1593',
    label: 'EmPower Research',
  },
  {
    value: '1835',
    label: 'Empyrean Partners',
  },
  {
    value: '1684',
    label: 'Enam Asset Management Company',
  },
  {
    value: '974',
    label: 'Enam Securities',
  },
  {
    value: '779',
    label: 'Encore Capital Group',
  },
  {
    value: '1070',
    label: 'Endeavor Careers',
  },
  {
    value: '1811',
    label: 'Enercon India',
  },
  {
    value: '626',
    label: 'Energo Engineering Projects',
  },
  {
    value: '2108',
    label: 'engage4more (India) Private Limited',
  },
  {
    value: '2170',
    label: 'Engineering',
  },
  {
    value: '2476',
    label: 'engineeristic.com',
  },
  {
    value: '1787',
    label: 'Engineers India LImited',
  },
  {
    value: '1963',
    label: 'ENIL - Radio Mirchi',
  },
  {
    value: '1403',
    label: 'enStage',
  },
  {
    value: '825',
    label: 'Entercoms',
  },
  {
    value: '963',
    label: 'Entertainment Network India Limited',
  },
  {
    value: '1830',
    label: 'Entertainment World Developers',
  },
  {
    value: '1661',
    label: 'Entrepreneur',
  },
  {
    value: '2260',
    label: 'Envision Financial Systems',
  },
  {
    value: '3032',
    label: 'ENVOY',
  },
  {
    value: '2989',
    label: 'Envoy Global',
  },
  {
    value: '923',
    label: 'Enzen Global Solutions',
  },
  {
    value: '1692',
    label: 'Eos Capital Advisors',
  },
  {
    value: '2498',
    label: 'EPAM',
  },
  {
    value: '1939',
    label: 'Epitome Global Services',
  },
  {
    value: '2509',
    label: 'Epsilon',
  },
  {
    value: '1374',
    label: 'Equifax Credit Information Services',
  },
  {
    value: '865',
    label: 'Equirus Capital',
  },
  {
    value: '1460',
    label: 'Equirus Securities',
  },
  {
    value: '2217',
    label: 'Equitas Micro Finance',
  },
  {
    value: '932',
    label: 'Era Group',
  },
  {
    value: '79',
    label: 'Ericsson',
  },
  {
    value: '11',
    label: 'Ernst & Young',
  },
  {
    value: '1856',
    label: 'EROS Group',
  },
  {
    value: '1096',
    label: 'Escorts Agri Machinery',
  },
  {
    value: '601',
    label: 'Escorts Limited',
  },
  {
    value: '2769',
    label: 'Esolvit India private limited',
  },
  {
    value: '1575',
    label: 'Espirito Santo Investment Bank',
  },
  {
    value: '1312',
    label: 'ESPN Software India Private Limited',
  },
  {
    value: '53',
    label: 'Essar Group',
  },
  {
    value: '1730',
    label: 'Ess Dee Aluminium',
  },
  {
    value: '619',
    label: 'Essel Group',
  },
  {
    value: '1011',
    label: 'Essex Lake Group',
  },
  {
    value: '1195',
    label: 'Estee Advisors',
  },
  {
    value: '1209',
    label: 'Ester Industries Limited',
  },
  {
    value: '1858',
    label: 'Eta Ascon',
  },
  {
    value: '1635',
    label: 'ETA Engineering',
  },
  {
    value: '2205',
    label: 'ETA General Pvt Ltd',
  },
  {
    value: '2760',
    label: 'Ethnus Consultancy Services',
  },
  {
    value: '320',
    label: 'Etisalat DB Telecom',
  },
  {
    value: '1929',
    label: 'Etoos Academy Private Limted',
  },
  {
    value: '3035',
    label: 'euclid innovations private limited',
  },
  {
    value: '3060',
    label: 'Eucloid Data Solutions Pvt Ltd',
  },
  {
    value: '467',
    label: 'Eureka Forbes',
  },
  {
    value: '1662',
    label: 'Euro Asia Consulting',
  },
  {
    value: '1154',
    label: 'Euronet Services India Private Limited',
  },
  {
    value: '1845',
    label: 'Euronet Worldwide',
  },
  {
    value: '39',
    label: 'Evalueserve',
  },
  {
    value: '791',
    label: 'Eveready Indusries India Limited',
  },
  {
    value: '3139',
    label: 'Everest Engineering',
  },
  {
    value: '623',
    label: 'Everest Group',
  },
  {
    value: '441',
    label: 'Everonn Education',
  },
  {
    value: '2709',
    label: 'Evonsys',
  },
  {
    value: '1621',
    label: 'Evotec India Private Limited',
  },
  {
    value: '2689',
    label: 'EWG IT Consultancy Services',
  },
  {
    value: '2674',
    label: 'EWYN Services Private Limited',
  },
  {
    value: '2212',
    label: 'EX - Army',
  },
  {
    value: '1975',
    label: 'Executive Access  India',
  },
  {
    value: '1062',
    label: 'EXECUTIVE SEARCH',
  },
  {
    value: '2023',
    label: 'ExeLAN Networking Technologies',
  },
  {
    value: '1401',
    label: 'Exemplarr Worldwide',
  },
  {
    value: '1106',
    label: 'Exevo India',
  },
  {
    value: '940',
    label: 'Exide Industries',
  },
  {
    value: '3062',
    label: 'EXIDE INDUSTRIES LTD',
  },
  {
    value: '1250',
    label: 'Exilant Technologies',
  },
  {
    value: '71',
    label: 'EXL Service',
  },
  {
    value: '2535',
    label: 'Exotel',
  },
  {
    value: '1067',
    label: 'Expedia',
  },
  {
    value: '1089',
    label: 'Experian Credit Information Company',
  },
  {
    value: '2364',
    label: 'Export House',
  },
  {
    value: '2119',
    label: 'Export Import Bank of India',
  },
  {
    value: '2377',
    label: 'Express KCS',
  },
  {
    value: '1022',
    label: 'Extramarks Education',
  },
  {
    value: '3110',
    label: 'Extramarks Education India Pvt Ltd',
  },
  {
    value: '3138',
    label: 'Exxon Mobi',
  },
  {
    value: '3137',
    label: 'Exxon Mobil',
  },
  {
    value: '1522',
    label: 'ExxonMobil',
  },
  {
    value: '1778',
    label: 'Eye Q Vision Pvt Ltd',
  },
  {
    value: '2898',
    label: 'EY GDS',
  },
  {
    value: '2506',
    label: 'Ezetap',
  },
  {
    value: '1924',
    label: 'FabFurnish.com',
  },
  {
    value: '996',
    label: 'Fabindia Overseas Pvt Ltd',
  },
  {
    value: '1560',
    label: 'Facebook',
  },
  {
    value: '555',
    label: 'Factset Research Systems',
  },
  {
    value: '645',
    label: 'Fair Isaac Corporation (FICO)',
  },
  {
    value: '2908',
    label: 'Fairmoney',
  },
  {
    value: '2137',
    label: 'Falcon Tyres Limited',
  },
  {
    value: '1219',
    label: 'Family Business',
  },
  {
    value: '2122',
    label: 'FamilyCredit Limited',
  },
  {
    value: '1979',
    label: 'Fareast Mercantile Co. Ltd.',
  },
  {
    value: '985',
    label: 'Fareportal India',
  },
  {
    value: '377',
    label: 'Fashionandyou.com',
  },
  {
    value: '2942',
    label: 'FAURECIA INDIA PRIVATE LIMITED',
  },
  {
    value: '1682',
    label: 'FCS Software Solution Ltd',
  },
  {
    value: '1343',
    label: 'Fedbank Financial Services Ltd',
  },
  {
    value: '1433',
    label: 'Fedders Lloyd Corporation Limited',
  },
  {
    value: '917',
    label: 'Federal Bank',
  },
  {
    value: '1431',
    label: 'Federal Mogul',
  },
  {
    value: '788',
    label: 'Federation of Indian Chambers of Commerce & Industry (FICCI)',
  },
  {
    value: '533',
    label: 'FedEx',
  },
  {
    value: '653',
    label: 'Feedback Business Consulting',
  },
  {
    value: '268',
    label: 'Feedback Infra',
  },
  {
    value: '1671',
    label: 'Fenesta Building Systems',
  },
  {
    value: '1619',
    label: 'Fenwal India Pvt Ltd',
  },
  {
    value: '1919',
    label: 'Fermenta Biotech Limited',
  },
  {
    value: '713',
    label: 'Ferrero',
  },
  {
    value: '1452',
    label: 'Fetise Retail Pvt Ltd',
  },
  {
    value: '962',
    label: 'Fiat India Automobiles Ltd',
  },
  {
    value: '3149',
    label: 'Ficosa India Engineering Center Pvt Ltd',
  },
  {
    value: '93',
    label: 'Fidelity',
  },
  {
    value: '2888',
    label: 'Fidelity Investments',
  },
  {
    value: '2031',
    label: 'Fiduciary Euromax Capital Markets',
  },
  {
    value: '1689',
    label: 'FieldFresh Foods Pvt Ltd',
  },
  {
    value: '1181',
    label: 'FIITJEE',
  },
  {
    value: '2091',
    label: 'Finalytics Consultancy',
  },
  {
    value: '158',
    label: 'Finance',
  },
  {
    value: '78',
    label: 'Financial Inclusion and Network Operations Ltd. (FINO)',
  },
  {
    value: '1734',
    label: 'Financial Software & Systems',
  },
  {
    value: '520',
    label: 'Financial Technologies',
  },
  {
    value: '1566',
    label: 'Fingerprints Fashions Private Limited',
  },
  {
    value: '1368',
    label: 'FinIQ Consulting',
  },
  {
    value: '2225',
    label: 'Fios Data Check Asia Pvt Ltd',
  },
  {
    value: '1968',
    label: 'FIRE Capital Fund',
  },
  {
    value: '1410',
    label: 'Firefly e Ventures',
  },
  {
    value: '949',
    label: 'Firepro Systems Private Limited',
  },
  {
    value: '1582',
    label: 'Firmenich Aromatics',
  },
  {
    value: '1584',
    label: 'First Advantage',
  },
  {
    value: '1227',
    label: 'First American Financial Corporation',
  },
  {
    value: '1965',
    label: 'First Blue Home Finance',
  },
  {
    value: '2406',
    label: 'Firstcry.com',
  },
  {
    value: '1668',
    label: 'First Data',
  },
  {
    value: '1363',
    label: 'First Flight Couriers Ltd',
  },
  {
    value: '2147',
    label: 'First Global Securities',
  },
  {
    value: '2359',
    label: 'First Gulf Bank',
  },
  {
    value: '1202',
    label: 'FirstRand Bank',
  },
  {
    value: '1463',
    label: 'Firstsource',
  },
  {
    value: '212',
    label: 'Firstsource Solutions',
  },
  {
    value: '676',
    label: 'FIS',
  },
  {
    value: '401',
    label: 'Fiserv',
  },
  {
    value: '435',
    label: 'Fitch Ratings',
  },
  {
    value: '2204',
    label: 'Fitness First India Private Limited',
  },
  {
    value: '2943',
    label: 'Fiverr',
  },
  {
    value: '1376',
    label: 'Flagstone Reinsurance',
  },
  {
    value: '2046',
    label: 'Flair Pens',
  },
  {
    value: '539',
    label: 'Flareum Technologies',
  },
  {
    value: '2889',
    label: 'Flatworld Solutions',
  },
  {
    value: '2890',
    label: 'Flatworld Solutions',
  },
  {
    value: '1060',
    label: 'Flextronics',
  },
  {
    value: '2565',
    label: 'flipkart',
  },
  {
    value: '73',
    label: 'Flipkart.com',
  },
  {
    value: '2931',
    label: 'Flipkart Internet Private Limited',
  },
  {
    value: '2597',
    label: 'Floating Numbers Digital Solutions Pvt. Ltd',
  },
  {
    value: '1187',
    label: 'FLSmidth',
  },
  {
    value: '3023',
    label: 'Fluence Bess',
  },
  {
    value: '3024',
    label: 'Fluence Bess',
  },
  {
    value: '1244',
    label: 'Fluor Daniel India',
  },
  {
    value: '2700',
    label: 'Flutura Business Solutions',
  },
  {
    value: '1425',
    label: 'Flytxt Mobile Solutions',
  },
  {
    value: '133',
    label: 'FMCG',
  },
  {
    value: '1439',
    label: 'FMS',
  },
  {
    value: '2326',
    label: 'Focus Comtrade Pvt. Ltd',
  },
  {
    value: '1685',
    label: 'Focus Shares and Securities',
  },
  {
    value: '3148',
    label: 'Focus Softnet Pvt. Ltd.',
  },
  {
    value: '1551',
    label: 'Food Corporation of India',
  },
  {
    value: '1736',
    label: 'Foodpanda',
  },
  {
    value: '2316',
    label: 'Forbes & Company Ltd.',
  },
  {
    value: '1199',
    label: 'Forbes Marshall',
  },
  {
    value: '1426',
    label: 'Force Motors Limited',
  },
  {
    value: '741',
    label: 'Ford Business Service Center',
  },
  {
    value: '394',
    label: 'Ford Motor Company',
  },
  {
    value: '1702',
    label: 'FORE School of Management',
  },
  {
    value: '1807',
    label: 'Foresight Software Solutions',
  },
  {
    value: '1440',
    label: 'Forrester Research',
  },
  {
    value: '350',
    label: 'Fortis Healthcare',
  },
  {
    value: '2092',
    label: 'Fortune 500',
  },
  {
    value: '1357',
    label: 'Fortune Financial Services',
  },
  {
    value: '2604',
    label: 'Fortune Infra Developers Private Limited',
  },
  {
    value: '1658',
    label: 'Fossil Inc.',
  },
  {
    value: '3150',
    label: 'Founding Years Learning Solutions',
  },
  {
    value: '891',
    label: 'Four Soft Ltd.',
  },
  {
    value: '2777',
    label: 'Foxlink India Electric',
  },
  {
    value: '3179',
    label: 'Foxtale',
  },
  {
    value: '2836',
    label: 'FPT INDIA',
  },
  {
    value: '173',
    label: 'Fractal Analytics',
  },
  {
    value: '473',
    label: 'Franchise India',
  },
  {
    value: '1726',
    label: 'Francorp',
  },
  {
    value: '2027',
    label: 'Frankfinn Aviation Pvt Ltd',
  },
  {
    value: '1099',
    label: 'Frankfinn Institute of Air Hostess Training',
  },
  {
    value: '1761',
    label: 'FranklinCovey',
  },
  {
    value: '396',
    label: 'Franklin Templeton',
  },
  {
    value: '1034',
    label: 'FREECULTR.COM',
  },
  {
    value: '127',
    label: 'Freelance',
  },
  {
    value: '860',
    label: 'Freescale Semiconductor',
  },
  {
    value: '3054',
    label: 'Freight Tiger',
  },
  {
    value: '1498',
    label: 'Fresenius Kabi',
  },
  {
    value: '284',
    label: 'Fresher',
  },
  {
    value: '1695',
    label: 'Freudenberg',
  },
  {
    value: '1143',
    label: 'Frigoglass Group',
  },
  {
    value: '2665',
    label: 'FRONTDOOR INDIA PRIVATE LIMITED',
  },
  {
    value: '2206',
    label: 'Frontier Business Systems',
  },
  {
    value: '138',
    label: 'Frost & Sullivan',
  },
  {
    value: '616',
    label: 'Fujifilm',
  },
  {
    value: '444',
    label: 'Fujitsu',
  },
  {
    value: '907',
    label: 'Fulcrum Worldwide',
  },
  {
    value: '338',
    label: 'Fullerton India Credit Company Limited',
  },
  {
    value: '631',
    label: 'Fullerton Securities & Wealth Advisors Ltd',
  },
  {
    value: '1517',
    label: 'Future Axiom Telecom Limited',
  },
  {
    value: '987',
    label: 'Future Capital Holdings Limited',
  },
  {
    value: '1453',
    label: 'Future Focus Infotech Pvt Ltd',
  },
  {
    value: '307',
    label: 'Future Generali India Life Insurance Company Limited',
  },
  {
    value: '109',
    label: 'Future Group',
  },
  {
    value: '1651',
    label: 'Future Human Development Limited',
  },
  {
    value: '100',
    label: 'Futures First',
  },
  {
    value: '1331',
    label: 'Futurestep',
  },
  {
    value: '452',
    label: 'Future Supply Chain Solutions Limited',
  },
  {
    value: '359',
    label: 'Future Value Retail Limited',
  },
  {
    value: '2441',
    label: 'Fuze Care System',
  },
  {
    value: '1493',
    label: 'G4S',
  },
  {
    value: '1492',
    label: 'Gabriel India Limited',
  },
  {
    value: '1006',
    label: 'GAIL',
  },
  {
    value: '1667',
    label: 'Galaxy Surfactants',
  },
  {
    value: '2068',
    label: 'Gallagher Offshore Support Services Pvt Ltd',
  },
  {
    value: '1204',
    label: 'Gallup',
  },
  {
    value: '1890',
    label: 'Gameloft',
  },
  {
    value: '1461',
    label: 'Gameshastra',
  },
  {
    value: '495',
    label: 'Gammon India Limited',
  },
  {
    value: '2397',
    label: 'Gandour India Food Processing',
  },
  {
    value: '2455',
    label: 'GAP',
  },
  {
    value: '1299',
    label: 'Gartner',
  },
  {
    value: '1586',
    label: 'Garware Wall Ropes',
  },
  {
    value: '1334',
    label: 'Gateway Rail Freight Limited',
  },
  {
    value: '231',
    label: 'Gati-Kintetsu Express Private Limited',
  },
  {
    value: '1911',
    label: 'Gaursons India Limited',
  },
  {
    value: '65',
    label: 'GE',
  },
  {
    value: '175',
    label: 'GE Capital',
  },
  {
    value: '1871',
    label: 'Gemalto Digital Security Private Limited',
  },
  {
    value: '1287',
    label: 'GE Money',
  },
  {
    value: '331',
    label: 'General Mills',
  },
  {
    value: '483',
    label: 'General Motors',
  },
  {
    value: '899',
    label: 'Genesis Burson-Marsteller',
  },
  {
    value: '2314',
    label: 'Genesis Luxury',
  },
  {
    value: '2991',
    label: 'Genesys Telecom Labs India Pvt. Ltd.',
  },
  {
    value: '1753',
    label: 'Genius Consultant Limited',
  },
  {
    value: '15',
    label: 'Genpact',
  },
  {
    value: '1548',
    label: 'Gensol Consultant Pvt Ltd',
  },
  {
    value: '927',
    label: 'Geodesic',
  },
  {
    value: '1972',
    label: 'GE Oil & Gas',
  },
  {
    value: '943',
    label: 'Geojit BNP Paribas Financial Services',
  },
  {
    value: '766',
    label: 'Geometric',
  },
  {
    value: '559',
    label: 'GEP',
  },
  {
    value: '2145',
    label: 'GEPL CAPITAL',
  },
  {
    value: '1713',
    label: 'German MNC',
  },
  {
    value: '939',
    label: 'Gerson Lehrman Group',
  },
  {
    value: '323',
    label: 'Getit Infoservices',
  },
  {
    value: '1540',
    label: 'GFB Great Foods Ltd.',
  },
  {
    value: '1073',
    label: 'GFK Mode',
  },
  {
    value: '2134',
    label: 'Ghalla & Bhansali Chartered Accountants',
  },
  {
    value: '1289',
    label: 'GHCL Limited',
  },
  {
    value: '3053',
    label: 'GHX India',
  },
  {
    value: '1390',
    label: 'GIC Housing Finance',
  },
  {
    value: '1712',
    label: 'giftcart.com',
  },
  {
    value: '2766',
    label: 'GILBARCO VEEDER ROOT INDIA PRIVATE LIMITED',
  },
  {
    value: '1959',
    label: 'Gilbert Tweed Associates',
  },
  {
    value: '2043',
    label: 'GIM',
  },
  {
    value: '2135',
    label: 'Gini & Jony Ltd',
  },
  {
    value: '994',
    label: 'Gitanjali Gems Limited',
  },
  {
    value: '2250',
    label: 'Gitanjali Group',
  },
  {
    value: '1238',
    label: 'Gitanjali Lifestyle',
  },
  {
    value: '2986',
    label: 'GiveIndia',
  },
  {
    value: '1876',
    label: 'Gkb Rx Lens Pvt Ltd',
  },
  {
    value: '140',
    label: 'GlaxoSmithKline',
  },
  {
    value: '468',
    label: 'Glenmark Pharmaceuticals',
  },
  {
    value: '1342',
    label: 'Globacom',
  },
  {
    value: '824',
    label: 'Global Analytics',
  },
  {
    value: '276',
    label: 'GlobalData',
  },
  {
    value: '2263',
    label: 'Global e Procure',
  },
  {
    value: '1456',
    label: 'Global eProcure',
  },
  {
    value: '2350',
    label: 'Global Group',
  },
  {
    value: '1283',
    label: 'Global Groupware Solutions',
  },
  {
    value: '1411',
    label: 'Global Innovsource',
  },
  {
    value: '737',
    label: 'GlobalLogic',
  },
  {
    value: '2188',
    label: 'Global Markets Center',
  },
  {
    value: '2032',
    label: 'GlobalScholar',
  },
  {
    value: '672',
    label: 'Global Talent Track',
  },
  {
    value: '1111',
    label: 'Globe Capital Market',
  },
  {
    value: '257',
    label: 'Globeop Financial Services',
  },
  {
    value: '1536',
    label: 'Glodyne Technoserve Limited',
  },
  {
    value: '1918',
    label: 'GLOPORE IMS',
  },
  {
    value: '1760',
    label: 'GMJ & Co',
  },
  {
    value: '2393',
    label: 'Gmmco Limited',
  },
  {
    value: '2691',
    label: 'GMO Globalsign Certificate Services',
  },
  {
    value: '844',
    label: 'GMR - Delhi International Airport(P) Limited',
  },
  {
    value: '913',
    label: 'GMR Energy Limited',
  },
  {
    value: '272',
    label: 'GMR Group',
  },
  {
    value: '1072',
    label: 'GMR Hyderabad International Airport',
  },
  {
    value: '887',
    label: 'GMR Infrastructure Limited',
  },
  {
    value: '2874',
    label: 'Gnana Analytics',
  },
  {
    value: '2613',
    label: 'G N Solutions Private Limited',
  },
  {
    value: '1105',
    label: 'Go Airlines',
  },
  {
    value: '166',
    label: 'Godfrey Phillips India Ltd',
  },
  {
    value: '70',
    label: 'Godrej & Boyce Mfg. Co. Ltd.',
  },
  {
    value: '298',
    label: 'Godrej Consumer Products',
  },
  {
    value: '2340',
    label: 'Godrej Hersheys Ltd',
  },
  {
    value: '1927',
    label: 'Godrej Industries Limited',
  },
  {
    value: '769',
    label: 'Godrej Infotech',
  },
  {
    value: '850',
    label: 'Godrej Properties',
  },
  {
    value: '2443',
    label: 'goibibo',
  },
  {
    value: '1882',
    label: 'Gokaldas Exports',
  },
  {
    value: '1957',
    label: 'Gokhale Institute of Politics & Economics',
  },
  {
    value: '1725',
    label: 'GoldenSource',
  },
  {
    value: '59',
    label: 'Goldman Sachs',
  },
  {
    value: '2967',
    label: 'Goldman Sachs India',
  },
  {
    value: '1715',
    label: 'Goldstone Technologies Limited',
  },
  {
    value: '2442',
    label: 'GOMMT',
  },
  {
    value: '3177',
    label: 'Good Glamm Group',
  },
  {
    value: '414',
    label: 'Goodyear',
  },
  {
    value: '237',
    label: 'Google',
  },
  {
    value: '1355',
    label: 'Government of Gujarat',
  },
  {
    value: '1128',
    label: 'Government of India',
  },
  {
    value: '269',
    label: 'Grail Research',
  },
  {
    value: '1033',
    label: 'Grainger India',
  },
  {
    value: '2158',
    label: 'Grameen Financial Services',
  },
  {
    value: '235',
    label: 'Grant Thornton',
  },
  {
    value: '2182',
    label: 'Granules India limited',
  },
  {
    value: '3040',
    label: 'Granules India Ltd',
  },
  {
    value: '1994',
    label: 'GrapeCity India Private Limited',
  },
  {
    value: '781',
    label: 'Grasim Industries Limited',
  },
  {
    value: '1482',
    label: 'Grassik Search',
  },
  {
    value: '2420',
    label: 'Graviton Research Capital',
  },
  {
    value: '573',
    label: 'Great Lakes Institute of Management',
  },
  {
    value: '1241',
    label: 'Greaves Cotton Limited',
  },
  {
    value: '1659',
    label: 'Greenback Forex',
  },
  {
    value: '1459',
    label: 'Green Infra Limited',
  },
  {
    value: '952',
    label: 'Greenply Industries Limited',
  },
  {
    value: '2240',
    label: 'Greycells18 Media Ltd',
  },
  {
    value: '2698',
    label: 'GreyDot Consulting',
  },
  {
    value: '2923',
    label: 'Grey Orange',
  },
  {
    value: '1394',
    label: 'Group Concorde',
  },
  {
    value: '668',
    label: 'Groupe Danone',
  },
  {
    value: '226',
    label: 'GroupM',
  },
  {
    value: '878',
    label: 'Groupon India',
  },
  {
    value: '2688',
    label: 'Growth Gardeners',
  },
  {
    value: '2446',
    label: 'GSK',
  },
  {
    value: '2902',
    label: 'GSK Consumer Healthcare',
  },
  {
    value: '1125',
    label: 'GTL Infrastructure Limited',
  },
  {
    value: '706',
    label: 'GTL limited',
  },
  {
    value: '1558',
    label: 'GT Nexus',
  },
  {
    value: '841',
    label: 'Guggenheim Transparent Value',
  },
  {
    value: '2866',
    label: 'guidehouse.com',
  },
  {
    value: '1964',
    label: 'Gujarat Gas Company Limited',
  },
  {
    value: '1912',
    label: 'Gulf Oil',
  },
  {
    value: '2118',
    label: 'Gunnebo India Private Limited',
  },
  {
    value: '1784',
    label: 'GupShup Technology',
  },
  {
    value: '1441',
    label: 'GVK',
  },
  {
    value: '983',
    label: 'GVK Biosciences',
  },
  {
    value: '1118',
    label: 'GVK EMRI',
  },
  {
    value: '2038',
    label: 'GVK Mumbai International Airport Limited',
  },
  {
    value: '1076',
    label: 'GVK Power & Infrastructure Limited',
  },
  {
    value: '1335',
    label: 'Gyansys',
  },
  {
    value: '2947',
    label: 'H&M',
  },
  {
    value: '1055',
    label: 'H & R Johnson',
  },
  {
    value: '2910',
    label: 'HackerEarth',
  },
  {
    value: '3034',
    label: 'HACKETT',
  },
  {
    value: '2980',
    label: 'Hackett Group (India) Limited',
  },
  {
    value: '1302',
    label: 'Haier Appliances',
  },
  {
    value: '1574',
    label: 'Hakuhodo Percept',
  },
  {
    value: '707',
    label: 'Haldia Petrochemicals Limited',
  },
  {
    value: '1116',
    label: 'Haldiram',
  },
  {
    value: '2972',
    label: 'Haleon',
  },
  {
    value: '1169',
    label: 'Halliburton',
  },
  {
    value: '1233',
    label: 'Hamdard',
  },
  {
    value: '1491',
    label: 'Hamilton Housewares',
  },
  {
    value: '1069',
    label: 'Handygo Technologies',
  },
  {
    value: '2330',
    label: 'Hanil Automotive India Pvt Ltd',
  },
  {
    value: '2142',
    label: 'Hanmer MSL',
  },
  {
    value: '1196',
    label: 'Hansa Research',
  },
  {
    value: '812',
    label: 'Happiest Minds',
  },
  {
    value: '2981',
    label: 'Haptik',
  },
  {
    value: '1185',
    label: 'Haribhakti & Co',
  },
  {
    value: '1126',
    label: 'Harman International',
  },
  {
    value: '2783',
    label: 'Harvee Corporate Services',
  },
  {
    value: '2950',
    label: 'Hashedin by Deloitte',
  },
  {
    value: '1080',
    label: 'Hathway',
  },
  {
    value: '2049',
    label: 'Hatsun Agro Products Limited',
  },
  {
    value: '1130',
    label: 'Havas Media',
  },
  {
    value: '448',
    label: 'Havells India',
  },
  {
    value: '2796',
    label: 'Havmor Ice Cream',
  },
  {
    value: '2201',
    label: 'Hawkins Cookers Limited',
  },
  {
    value: '1683',
    label: 'Hay Group',
  },
  {
    value: '1380',
    label: 'Hays',
  },
  {
    value: '1610',
    label: 'HBL Global',
  },
  {
    value: '2329',
    label: 'HBL Power Systems Limited',
  },
  {
    value: '2545',
    label: 'HCCB',
  },
  {
    value: '426',
    label: 'HCL Infosystems',
  },
  {
    value: '8',
    label: 'HCL Technologies',
  },
  {
    value: '1709',
    label: 'HDB Financial services',
  },
  {
    value: '2293',
    label: 'HDB Financial services ltd',
  },
  {
    value: '7',
    label: 'HDFC Bank',
  },
  {
    value: '961',
    label: 'HDFC Life',
  },
  {
    value: '2083',
    label: 'HDIL',
  },
  {
    value: '752',
    label: 'Headhonchos',
  },
  {
    value: '2468',
    label: 'Head Infotech',
  },
  {
    value: '239',
    label: 'Headstrong',
  },
  {
    value: '998',
    label: 'Healthcare',
  },
  {
    value: '2756',
    label: 'HealthCon India',
  },
  {
    value: '1085',
    label: 'Healthkart.com',
  },
  {
    value: '1442',
    label: 'HEC Paris',
  },
  {
    value: '2073',
    label: 'Heidelberg',
  },
  {
    value: '956',
    label: 'Heidrick & Struggles',
  },
  {
    value: '2975',
    label: 'Heineken Holdings',
  },
  {
    value: '351',
    label: 'Heinz',
  },
  {
    value: '1079',
    label: 'Helios & Matheson',
  },
  {
    value: '2351',
    label: 'Helix Advisors',
  },
  {
    value: '1966',
    label: 'Hella India Electronics',
  },
  {
    value: '2191',
    label: 'Hem Securities Limited',
  },
  {
    value: '412',
    label: 'Henkel Adhesive Technologies',
  },
  {
    value: '2966',
    label: 'Hennes & Mauritz',
  },
  {
    value: '2558',
    label: 'Herbalife',
  },
  {
    value: '916',
    label: 'Heritage Foods',
  },
  {
    value: '1337',
    label: 'Hero Corporate Services',
  },
  {
    value: '1450',
    label: 'Hero Mindmine',
  },
  {
    value: '194',
    label: 'Hero MotoCorp',
  },
  {
    value: '1834',
    label: 'Hershey India',
  },
  {
    value: '3089',
    label: 'Hetero Drugs',
  },
  {
    value: '2970',
    label: 'Hetero Drugs Limited',
  },
  {
    value: '1170',
    label: 'Hettich',
  },
  {
    value: '748',
    label: 'Hewitt Associates',
  },
  {
    value: '30',
    label: 'Hewlett Packard',
  },
  {
    value: '3052',
    label: 'Hexagon Capability Center India Pvt. Ltd.',
  },
  {
    value: '455',
    label: 'Hexaware Technologies',
  },
  {
    value: '3026',
    label: 'Hexaware Technologies Ltd.',
  },
  {
    value: '1535',
    label: 'HFCL',
  },
  {
    value: '2194',
    label: 'HGS',
  },
  {
    value: '1868',
    label: 'Hidesign',
  },
  {
    value: '1969',
    label: 'High Mark Credit Information Services',
  },
  {
    value: '3020',
    label: 'highradius',
  },
  {
    value: '1607',
    label: 'HighStreetLabels.com',
  },
  {
    value: '2454',
    label: 'Hike',
  },
  {
    value: '1298',
    label: 'HIL Ltd.',
  },
  {
    value: '969',
    label: 'HILTI INDIA',
  },
  {
    value: '2944',
    label: 'Hilti India Pvt. Ltd.',
  },
  {
    value: '1050',
    label: 'Hilton',
  },
  {
    value: '3015',
    label: 'Himalaya Wellness Company',
  },
  {
    value: '740',
    label: 'Hindalco',
  },
  {
    value: '352',
    label: 'Hinduja Group',
  },
  {
    value: '2859',
    label: 'Hinduja Healthcare',
  },
  {
    value: '808',
    label: 'Hindustan Aeronautics Limited',
  },
  {
    value: '99',
    label: 'Hindustan Coca-Cola Beverages',
  },
  {
    value: '1962',
    label: 'Hindustan Construction Company',
  },
  {
    value: '1987',
    label: 'Hindustan Copper Limited',
  },
  {
    value: '2287',
    label: 'Hindustan Latex Family Planning Promotion Trust',
  },
  {
    value: '1539',
    label: 'Hindustan Motors',
  },
  {
    value: '565',
    label: 'Hindustan Petroleum Corporation',
  },
  {
    value: '2869',
    label: 'Hindustan Ports',
  },
  {
    value: '327',
    label: 'Hindustan Times',
  },
  {
    value: '2433',
    label: 'Hindustan Unilever Limited',
  },
  {
    value: '318',
    label: 'Hindustan Zinc Limited',
  },
  {
    value: '898',
    label: 'Hindusthan National Glass & Industries',
  },
  {
    value: '481',
    label: 'Hindware',
  },
  {
    value: '1655',
    label: 'Hiranandani Infrastructure and Real Estate Company',
  },
  {
    value: '2732',
    label: 'Hirekaro Global Services',
  },
  {
    value: '2473',
    label: 'hirist.com',
  },
  {
    value: '805',
    label: 'Hitachi',
  },
  {
    value: '3097',
    label: 'Hitachi Digital Services',
  },
  {
    value: '2904',
    label: 'Hitachi Vantara',
  },
  {
    value: '2055',
    label: 'HLFPPT',
  },
  {
    value: '1131',
    label: 'HLL Lifecare',
  },
  {
    value: '3155',
    label: 'hmclause',
  },
  {
    value: '1910',
    label: 'HNG Float Glass Ltd.',
  },
  {
    value: '2453',
    label: 'HOME CREDIT',
  },
  {
    value: '897',
    label: 'HomeShop18.com',
  },
  {
    value: '906',
    label: 'Homeward Residential',
  },
  {
    value: '3176',
    label: 'Honasa Consumer Limited',
  },
  {
    value: '508',
    label: 'Honda',
  },
  {
    value: '106',
    label: 'Honeywell',
  },
  {
    value: '2198',
    label: 'Hoppr',
  },
  {
    value: '1371',
    label: 'Hospitality',
  },
  {
    value: '2845',
    label: 'Hotcourses India',
  },
  {
    value: '501',
    label: 'HPCL',
  },
  {
    value: '471',
    label: 'HR',
  },
  {
    value: '1322',
    label: 'HR Anexi',
  },
  {
    value: '1568',
    label: 'HR Consulting',
  },
  {
    value: '2837',
    label: 'HRemedies',
  },
  {
    value: '12',
    label: 'HSBC',
  },
  {
    value: '1961',
    label: 'HTC',
  },
  {
    value: '131',
    label: 'HT Media',
  },
  {
    value: '220',
    label: 'Huawei',
  },
  {
    value: '2978',
    label: 'Huawei Telecommunications India Company Pvt Ltd',
  },
  {
    value: '790',
    label: 'Hughes Communication',
  },
  {
    value: '2550',
    label: 'HUL',
  },
  {
    value: '2577',
    label: 'Human Forte',
  },
  {
    value: '240',
    label: 'Hungama Digital Media Entertainment',
  },
  {
    value: '1804',
    label: 'Hunt Partners',
  },
  {
    value: '1509',
    label: 'Huntsman International',
  },
  {
    value: '1823',
    label: 'Huntsmen & Barons',
  },
  {
    value: '3108',
    label: 'HuQuo Consulting Pvt. Ltd.',
  },
  {
    value: '1697',
    label: 'Hushbabies.com',
  },
  {
    value: '2275',
    label: 'Husys',
  },
  {
    value: '341',
    label: 'Hutchison Global Services',
  },
  {
    value: '1622',
    label: 'Hyatt',
  },
  {
    value: '2812',
    label: 'Hyde Engineering & Consulting India',
  },
  {
    value: '1313',
    label: 'Hyderabad Industries Limited',
  },
  {
    value: '1001',
    label: 'HyperCITY Retail',
  },
  {
    value: '2279',
    label: 'HYTHRO POWER CORPORATION LIMITED',
  },
  {
    value: '727',
    label: 'Hyundai',
  },
  {
    value: '1014',
    label: 'i-maritime Consultancy',
  },
  {
    value: '654',
    label: 'i3 Consulting',
  },
  {
    value: '2843',
    label: 'i28 Technologies India',
  },
  {
    value: '1657',
    label: 'IAF',
  },
  {
    value: '2623',
    label: 'iBASEt India Software Private Limited',
  },
  {
    value: '758',
    label: 'IBEXI Solutions',
  },
  {
    value: '2385',
    label: 'Ibibo Group',
  },
  {
    value: '729',
    label: 'Ibibo Web Private Limited',
  },
  {
    value: '10',
    label: 'IBM',
  },
  {
    value: '1470',
    label: 'IBS Hyderabad',
  },
  {
    value: '1767',
    label: 'IBS Software Services',
  },
  {
    value: '391',
    label: 'ICAI',
  },
  {
    value: '558',
    label: 'ICFAI',
  },
  {
    value: '3',
    label: 'ICICI Bank',
  },
  {
    value: '42',
    label: 'ICICI Lombard',
  },
  {
    value: '61',
    label: 'ICICI Prudential Life Insurance',
  },
  {
    value: '64',
    label: 'ICICI Securities',
  },
  {
    value: '1427',
    label: 'ICI Paints',
  },
  {
    value: '2877',
    label: 'ICP SOLUTIONS',
  },
  {
    value: '74',
    label: 'ICRA',
  },
  {
    value: '536',
    label: 'iCreate Software',
  },
  {
    value: '76',
    label: 'IDBI Bank',
  },
  {
    value: '322',
    label: 'IDBI Capital',
  },
  {
    value: '515',
    label: 'IDBI Federal Life Insurance Company',
  },
  {
    value: '892',
    label: 'IDBI Intech',
  },
  {
    value: '1714',
    label: 'IDC',
  },
  {
    value: '2356',
    label: 'idea7 Sewells',
  },
  {
    value: '33',
    label: 'Idea Cellular',
  },
  {
    value: '1937',
    label: 'Ideacts Innovation',
  },
  {
    value: '2635',
    label: 'Ideaforge Technology Pvt. Ltd.',
  },
  {
    value: '419',
    label: 'IDFC',
  },
  {
    value: '708',
    label: 'iDiscoveri Education',
  },
  {
    value: '2863',
    label: 'IDZ Digital',
  },
  {
    value: '1277',
    label: 'IE Business School',
  },
  {
    value: '1790',
    label: 'iFAST Financial India',
  },
  {
    value: '507',
    label: 'IFB Industries Limited',
  },
  {
    value: '255',
    label: 'IFCI',
  },
  {
    value: '734',
    label: 'IFFCO',
  },
  {
    value: '833',
    label: 'IFFCO Tokio General Insurance',
  },
  {
    value: '405',
    label: 'IFMR',
  },
  {
    value: '2611',
    label: 'IFP Petro Products',
  },
  {
    value: '85',
    label: 'iGate',
  },
  {
    value: '3004',
    label: 'ignitarium',
  },
  {
    value: '3003',
    label: 'ignitarium technology solutions private limited',
  },
  {
    value: '2405',
    label: 'IILM',
  },
  {
    value: '1980',
    label: 'IIM',
  },
  {
    value: '1646',
    label: 'IIMA',
  },
  {
    value: '1103',
    label: 'IIM Ahmedabad',
  },
  {
    value: '1740',
    label: 'IIMB',
  },
  {
    value: '656',
    label: 'IIM Bangalore',
  },
  {
    value: '1095',
    label: 'IIM Calcutta',
  },
  {
    value: '488',
    label: 'IIM Indore',
  },
  {
    value: '1395',
    label: 'iimjobs',
  },
  {
    value: '1348',
    label: 'iimjobs.com',
  },
  {
    value: '843',
    label: 'IIM Kozhikode',
  },
  {
    value: '1864',
    label: 'IIML',
  },
  {
    value: '958',
    label: 'IIM Lucknow',
  },
  {
    value: '2219',
    label: 'IIMnet Ventures',
  },
  {
    value: '1557',
    label: 'IIM Raipur',
  },
  {
    value: '1183',
    label: 'IIM Rohtak',
  },
  {
    value: '2064',
    label: 'IIM Shillong',
  },
  {
    value: '2273',
    label: 'IIM Trichy',
  },
  {
    value: '712',
    label: 'iipm',
  },
  {
    value: '2128',
    label: 'IISWBM',
  },
  {
    value: '723',
    label: 'IIT Bombay',
  },
  {
    value: '1129',
    label: 'IIT Delhi',
  },
  {
    value: '836',
    label: 'IIT kanpur',
  },
  {
    value: '430',
    label: 'IIT kharagpur',
  },
  {
    value: '572',
    label: 'IIT Roorkee',
  },
  {
    value: '2555',
    label: 'IKS Health',
  },
  {
    value: '1907',
    label: 'Ikya Human Capital',
  },
  {
    value: '1496',
    label: 'IKYA Human Capital Solutions',
  },
  {
    value: '205',
    label: 'IL&FS',
  },
  {
    value: '2594',
    label: 'Imerys Minerals (India) Pvt. Ltd.',
  },
  {
    value: '1644',
    label: 'IMImobile',
  },
  {
    value: '2816',
    label: 'Immunoshop India',
  },
  {
    value: '2557',
    label: 'Impact Analytics',
  },
  {
    value: '110',
    label: 'IMRB',
  },
  {
    value: '1613',
    label: 'IMS',
  },
  {
    value: '785',
    label: 'IMS Health',
  },
  {
    value: '449',
    label: 'IMS Learning Resources',
  },
  {
    value: '1317',
    label: 'IMT',
  },
  {
    value: '629',
    label: 'IMT Ghaziabad',
  },
  {
    value: '1555',
    label: 'IMT Nagpur',
  },
  {
    value: '474',
    label: 'iNautix Technologies',
  },
  {
    value: '2662',
    label: 'Inc42',
  },
  {
    value: '2663',
    label: 'Inc42 Media',
  },
  {
    value: '2870',
    label: 'IncNut',
  },
  {
    value: '2671',
    label: 'InCred Financial Services',
  },
  {
    value: '2278',
    label: 'Indegene Lifesystems',
  },
  {
    value: '1820',
    label: 'Independant',
  },
  {
    value: '329',
    label: 'Independent',
  },
  {
    value: '736',
    label: 'Independent Consultant',
  },
  {
    value: '134',
    label: 'Indiabulls',
  },
  {
    value: '872',
    label: 'IndiaCan',
  },
  {
    value: '1152',
    label: 'India Factoring & Finance Solutions Private Limited',
  },
  {
    value: '933',
    label: 'IndiaFirst Life Insurance',
  },
  {
    value: '811',
    label: 'IndiaHomes',
  },
  {
    value: '1874',
    label: 'India Homes',
  },
  {
    value: '68',
    label: 'India Infoline',
  },
  {
    value: '157',
    label: 'IndiaMart InterMesh Ltd',
  },
  {
    value: '1944',
    label: 'India Medtronic Pvt. Ltd.',
  },
  {
    value: '443',
    label: 'Indian Air Force',
  },
  {
    value: '196',
    label: 'Indian Army',
  },
  {
    value: '1367',
    label: 'Indian Bank',
  },
  {
    value: '1258',
    label: 'Indian Commodity Exchange Limited',
  },
  {
    value: '1947',
    label: 'INDIAN IMMUNOLOGICALS LIMITED',
  },
  {
    value: '2079',
    label: 'Indian Institute of Foreign Trade',
  },
  {
    value: '2363',
    label: 'Indian Institute of Management, Bangalore',
  },
  {
    value: '2271',
    label: 'Indian Institute of Management Ahmedabad',
  },
  {
    value: '1942',
    label: 'Indian Institute of management bangalore',
  },
  {
    value: '1867',
    label: 'Indian institute of planning and management',
  },
  {
    value: '514',
    label: 'Indian Navy',
  },
  {
    value: '2744',
    label: 'Indian Oil Corporation',
  },
  {
    value: '148',
    label: 'Indian Oil Corporation Limited',
  },
  {
    value: '1872',
    label: 'INDIAN OVERSEAS BANK',
  },
  {
    value: '1814',
    label: 'Indian Petro Group',
  },
  {
    value: '2259',
    label: 'INDIAN STATISTICAL INSTITUTE',
  },
  {
    value: '2806',
    label: 'Indian Television Dot Com',
  },
  {
    value: '1744',
    label: 'Indiaplaza.com',
  },
  {
    value: '1905',
    label: 'India Power Corporation Limited',
  },
  {
    value: '1839',
    label: 'Indiaproperty.com',
  },
  {
    value: '1300',
    label: 'India Today Group',
  },
  {
    value: '3031',
    label: 'india tv',
  },
  {
    value: '1132',
    label: 'India Yamaha Motor',
  },
  {
    value: '574',
    label: 'IndiGo',
  },
  {
    value: '1497',
    label: 'Indigo Consulting',
  },
  {
    value: '2747',
    label: 'Indigo Paints',
  },
  {
    value: '2035',
    label: 'Indofil Industries Limited',
  },
  {
    value: '1870',
    label: 'Indraprastha Gas Limited',
  },
  {
    value: '492',
    label: 'Inductis',
  },
  {
    value: '2238',
    label: 'Indus Balaji Private Equity',
  },
  {
    value: '1435',
    label: 'Indus Business Academy',
  },
  {
    value: '63',
    label: 'IndusInd Bank',
  },
  {
    value: '224',
    label: 'Indus Towers',
  },
  {
    value: '543',
    label: 'Indus Valley Partners',
  },
  {
    value: '1031',
    label: 'Infibeam.com',
  },
  {
    value: '1793',
    label: 'Infinite Computer Solutions',
  },
  {
    value: '577',
    label: 'Infiniti Retail - TATA Croma',
  },
  {
    value: '553',
    label: 'Infinity Research',
  },
  {
    value: '2288',
    label: 'Infocom Network Ltd.',
  },
  {
    value: '126',
    label: 'Info Edge',
  },
  {
    value: '2531',
    label: 'InfoEdge',
  },
  {
    value: '1766',
    label: 'Infogain',
  },
  {
    value: '2',
    label: 'Infosys',
  },
  {
    value: '3162',
    label: 'Infosys BPM',
  },
  {
    value: '1863',
    label: 'Infosys BPO',
  },
  {
    value: '432',
    label: 'Infotech Enterprises Limited',
  },
  {
    value: '839',
    label: 'Infraline Energy',
  },
  {
    value: '2051',
    label: 'Infrasoft Technologies',
  },
  {
    value: '358',
    label: 'Ingersoll Rand',
  },
  {
    value: '1414',
    label: 'ING Investment Management',
  },
  {
    value: '1149',
    label: 'Ingram Micro',
  },
  {
    value: '75',
    label: 'ING VYSYA Bank',
  },
  {
    value: '249',
    label: 'ING Vysya Life Insurance',
  },
  {
    value: '1059',
    label: 'Inkfruit.com',
  },
  {
    value: '1879',
    label: 'InMobi',
  },
  {
    value: '3030',
    label: 'INNOMINDS SOFTWARE SEZ INDIA PRIVATE LIMITED',
  },
  {
    value: '2655',
    label: 'Innospire Systems',
  },
  {
    value: '1611',
    label: 'Innovative B2B Logistics',
  },
  {
    value: '2486',
    label: 'Innoviti',
  },
  {
    value: '2190',
    label: 'Innoz Technologies',
  },
  {
    value: '1175',
    label: 'INOX Group',
  },
  {
    value: '1576',
    label: 'Institute of Chartered accountants of India',
  },
  {
    value: '2081',
    label: 'Institute of public enterprise',
  },
  {
    value: '881',
    label: 'Insurance',
  },
  {
    value: '607',
    label: 'Insync Analytics',
  },
  {
    value: '1157',
    label: 'Intas Pharmaceuticals',
  },
  {
    value: '603',
    label: 'Integreon',
  },
  {
    value: '375',
    label: 'Intel',
  },
  {
    value: '511',
    label: 'Intelenet Global Services',
  },
  {
    value: '1445',
    label: 'Intellecap',
  },
  {
    value: '2675',
    label: 'Intelli AI Trillion Technologies',
  },
  {
    value: '2728',
    label: 'Intellipursuit Consulting',
  },
  {
    value: '2961',
    label: 'Intel Technology India Pvt Ltd',
  },
  {
    value: '1500',
    label: 'InterContinental Hotels Group',
  },
  {
    value: '2676',
    label: 'Intercontinental Hotels Group India Pvt. Ltd',
  },
  {
    value: '2037',
    label: 'Interglobe',
  },
  {
    value: '465',
    label: 'InterGlobe Technologies',
  },
  {
    value: '2256',
    label: 'International Tractors Limited',
  },
  {
    value: '2960',
    label: 'Internshala',
  },
  {
    value: '2328',
    label: 'Intex Technologies India Ltd',
  },
  {
    value: '3067',
    label: 'Intouch',
  },
  {
    value: '3068',
    label: 'Intouch CX',
  },
  {
    value: '1846',
    label: 'IntraSoft Technologies Limited',
  },
  {
    value: '1379',
    label: 'Intuit',
  },
  {
    value: '1437',
    label: 'Invesco',
  },
  {
    value: '1098',
    label: 'Investment Banking',
  },
  {
    value: '688',
    label: 'Investors Clinic',
  },
  {
    value: '356',
    label: 'Ipsos',
  },
  {
    value: '2360',
    label: 'iQor',
  },
  {
    value: '2625',
    label: 'iQuants Engineering Solutions Pvt Ltd',
  },
  {
    value: '2969',
    label: 'IQVIA',
  },
  {
    value: '1190',
    label: 'IREO',
  },
  {
    value: '454',
    label: 'Irevna',
  },
  {
    value: '2291',
    label: 'IRIS Business Services Limited',
  },
  {
    value: '2670',
    label: 'iRIS Super Speciality Eye Care Centre',
  },
  {
    value: '2683',
    label: 'Iron Systems India Pvt. Ltd.',
  },
  {
    value: '209',
    label: 'ISB Hyderabad',
  },
  {
    value: '2398',
    label: 'Isolux Corsan',
  },
  {
    value: '2067',
    label: 'Ispat Industries Ltd.',
  },
  {
    value: '2343',
    label: 'ISRO',
  },
  {
    value: '145',
    label: 'IT',
  },
  {
    value: '35',
    label: 'ITC',
  },
  {
    value: '199',
    label: 'ITC Infotech',
  },
  {
    value: '2929',
    label: 'Itilite Technologies',
  },
  {
    value: '1225',
    label: 'ITM',
  },
  {
    value: '1675',
    label: 'iTrust Financial Advisors',
  },
  {
    value: '2269',
    label: 'ITW India Ltd',
  },
  {
    value: '2292',
    label: 'ITW Signode',
  },
  {
    value: '1710',
    label: 'Itz Cash Card Ltd',
  },
  {
    value: '3066',
    label: 'IVYCAP VENTURES ADVISORS PRIVATE LIMITED',
  },
  {
    value: '2912',
    label: 'iXceed',
  },
  {
    value: '2564',
    label: 'Ixigo',
  },
  {
    value: '2367',
    label: 'iYogi Technical Services Pvt Ltd',
  },
  {
    value: '472',
    label: 'Jabong.com',
  },
  {
    value: '2770',
    label: 'Jacobs Engineering India Pvt Ltd',
  },
  {
    value: '2313',
    label: 'Jagran Prakashan Ltd',
  },
  {
    value: '2371',
    label: 'Jagran Solutions',
  },
  {
    value: '1873',
    label: 'Jaguar Land Rover',
  },
  {
    value: '1086',
    label: 'Jain Group',
  },
  {
    value: '570',
    label: 'Jaiprakash Associates Limited',
  },
  {
    value: '2696',
    label: 'Jai Sai Recruiters',
  },
  {
    value: '1158',
    label: 'Janalakshmi Financial Services',
  },
  {
    value: '564',
    label: 'Jardine Lloyd Thompson',
  },
  {
    value: '1926',
    label: 'jaypee business school',
  },
  {
    value: '554',
    label: 'Jaypee Capital',
  },
  {
    value: '506',
    label: 'Jaypee Group',
  },
  {
    value: '1795',
    label: 'JBM GROUP',
  },
  {
    value: '2131',
    label: 'JCO GAS PIPE LIMITED',
  },
  {
    value: '241',
    label: 'JDA Software',
  },
  {
    value: '874',
    label: 'Jet Airways',
  },
  {
    value: '3038',
    label: 'jgc',
  },
  {
    value: '3013',
    label: 'JGC India EPC',
  },
  {
    value: '3039',
    label: 'JGC INDIA EPC PRIVATE LIMITED',
  },
  {
    value: '264',
    label: 'Jindal Group',
  },
  {
    value: '3073',
    label: 'Jindal Steel and Power',
  },
  {
    value: '193',
    label: 'Jindal Steel and Power Limited',
  },
  {
    value: '1495',
    label: 'jk tyre & industries ltd.',
  },
  {
    value: '362',
    label: 'JM Financial',
  },
  {
    value: '2828',
    label: 'Job Cookies India',
  },
  {
    value: '1775',
    label: 'Job seeker',
  },
  {
    value: '528',
    label: 'John Deere',
  },
  {
    value: '2918',
    label: 'John Jacobs',
  },
  {
    value: '83',
    label: 'Johnson & Johnson',
  },
  {
    value: '1025',
    label: 'Johnson Controls',
  },
  {
    value: '2598',
    label: 'Joinyfy Placement',
  },
  {
    value: '295',
    label: 'Jones Lang LaSalle',
  },
  {
    value: '2731',
    label: 'Jotun India Private Limited',
  },
  {
    value: '2899',
    label: 'JPMC',
  },
  {
    value: '18',
    label: 'JP Morgan',
  },
  {
    value: '2587',
    label: 'JP Morgan Chase',
  },
  {
    value: '2251',
    label: 'JRG securities',
  },
  {
    value: '164',
    label: 'JSW Steel',
  },
  {
    value: '446',
    label: 'Jubilant Group',
  },
  {
    value: '373',
    label: 'Jubilant Life Sciences',
  },
  {
    value: '3021',
    label: 'Jubilant Pharmova Limited',
  },
  {
    value: '2202',
    label: 'July Systems',
  },
  {
    value: '646',
    label: 'Jumbo Electronics',
  },
  {
    value: '793',
    label: 'Juniper Networks',
  },
  {
    value: '1075',
    label: 'Justdial',
  },
  {
    value: '819',
    label: 'JWT',
  },
  {
    value: '1400',
    label: 'Jyothy Laboratories Limited',
  },
  {
    value: '2932',
    label: 'K12',
  },
  {
    value: '2469',
    label: 'kabbage',
  },
  {
    value: '2428',
    label: 'Kalaari Capital',
  },
  {
    value: '1827',
    label: 'Kalkitech',
  },
  {
    value: '1578',
    label: 'Kalpataru Limited',
  },
  {
    value: '1556',
    label: 'Kancor Ingredients LTD',
  },
  {
    value: '438',
    label: 'Kansai Nerolac Paints',
  },
  {
    value: '1417',
    label: 'Kantar Operations',
  },
  {
    value: '716',
    label: 'Karur Vyasya Bank',
  },
  {
    value: '111',
    label: 'Karvy',
  },
  {
    value: '2526',
    label: 'Karza Technologies',
  },
  {
    value: '955',
    label: 'Keane India',
  },
  {
    value: '1984',
    label: 'KEC INTERNATIONAL',
  },
  {
    value: '1645',
    label: 'KEC INTERNATIONAL LIMITED',
  },
  {
    value: '1579',
    label: 'KEC International Ltd',
  },
  {
    value: '1762',
    label: 'KEC International Ltd.',
  },
  {
    value: '2617',
    label: 'Keihin India Manufacturing Pvt Ltd',
  },
  {
    value: '2066',
    label: 'KEI Industries Limited',
  },
  {
    value: '643',
    label: 'Kellogg',
  },
  {
    value: '2782',
    label: 'KellyOCG',
  },
  {
    value: '1375',
    label: 'Kelly Services',
  },
  {
    value: '2085',
    label: 'Kelly Services India Pvt. Ltd.',
  },
  {
    value: '2105',
    label: 'Kennametal India Limited',
  },
  {
    value: '3147',
    label: 'Kensium Solutions Private Limited',
  },
  {
    value: '2061',
    label: 'Kent RO Systems Ltd.',
  },
  {
    value: '2705',
    label: 'Keventer Agro Limited',
  },
  {
    value: '3006',
    label: 'Keyloop',
  },
  {
    value: '3005',
    label: 'KEYLOOP INDIA PRIVATE LIMITED',
  },
  {
    value: '2229',
    label: 'Keynote Corporate Services Limited',
  },
  {
    value: '2753',
    label: 'Keyquest Technologies',
  },
  {
    value: '2860',
    label: 'Keyur Chittaranjan Mehta',
  },
  {
    value: '2563',
    label: 'KGISL',
  },
  {
    value: '1123',
    label: 'Khaitan & Co',
  },
  {
    value: '2872',
    label: 'KhataBook',
  },
  {
    value: '1255',
    label: 'Kimberly-Clark',
  },
  {
    value: '2559',
    label: 'Kinara Capital',
  },
  {
    value: '1483',
    label: 'Kingdom of Dreams',
  },
  {
    value: '459',
    label: 'Kingfisher Airlines',
  },
  {
    value: '2765',
    label: 'Kion India',
  },
  {
    value: '2337',
    label: 'Kiran Energy',
  },
  {
    value: '895',
    label: 'Kirloskar',
  },
  {
    value: '1765',
    label: 'Kitara Capital',
  },
  {
    value: '1989',
    label: 'Kline & Company',
  },
  {
    value: '2658',
    label: 'KMG Infotech Ltd',
  },
  {
    value: '637',
    label: 'Knight Frank',
  },
  {
    value: '1559',
    label: 'Knowlarirty Communications',
  },
  {
    value: '1370',
    label: 'Knowledgefaber',
  },
  {
    value: '1047',
    label: 'Kochar Infotech',
  },
  {
    value: '1094',
    label: 'Kodak',
  },
  {
    value: '804',
    label: 'Kohinoor Group',
  },
  {
    value: '563',
    label: 'Kohler',
  },
  {
    value: '2120',
    label: 'Kokuyo Camlin Ltd',
  },
  {
    value: '1104',
    label: 'Komli Media',
  },
  {
    value: '3072',
    label: 'Kone',
  },
  {
    value: '3112',
    label: 'Kone Elevators',
  },
  {
    value: '921',
    label: 'Kony Labs',
  },
  {
    value: '2685',
    label: 'Kore1 Manpower Solution',
  },
  {
    value: '1274',
    label: 'Kotak Life Insurance',
  },
  {
    value: '26',
    label: 'Kotak Mahindra Bank',
  },
  {
    value: '3064',
    label: 'Kotak Mahindra Bank Limited',
  },
  {
    value: '1666',
    label: 'Kotak Securities',
  },
  {
    value: '2873',
    label: 'KPI Partners India Private Limited',
  },
  {
    value: '244',
    label: 'KPIT Cummins',
  },
  {
    value: '14',
    label: 'KPMG',
  },
  {
    value: '1848',
    label: 'KPO',
  },
  {
    value: '451',
    label: 'Kraft Foods',
  },
  {
    value: '1718',
    label: 'KRChoksey Shares & Securities ltd.',
  },
  {
    value: '2470',
    label: 'Kreate Global',
  },
  {
    value: '2528',
    label: 'KreditBee',
  },
  {
    value: '3085',
    label: 'KredX',
  },
  {
    value: '2412',
    label: 'Kronos',
  },
  {
    value: '1353',
    label: 'KSK Energy Ventures Limited',
  },
  {
    value: '2629',
    label: 'Kunal Structures India Pvt. Ltd',
  },
  {
    value: '751',
    label: 'Kuoni India',
  },
  {
    value: '2618',
    label: 'Kusters Engineering',
  },
  {
    value: '2906',
    label: 'Kwalee',
  },
  {
    value: '2123',
    label: 'KyaZoonga.com',
  },
  {
    value: '46',
    label: 'L&T',
  },
  {
    value: '197',
    label: 'L&T Finance',
  },
  {
    value: '176',
    label: 'L&T Infotech',
  },
  {
    value: '592',
    label: 'L&T Infrastructure Finance Company',
  },
  {
    value: '203',
    label: "L'Oreal",
  },
  {
    value: '579',
    label: 'Lafarge',
  },
  {
    value: '1616',
    label: 'Lakme Lever',
  },
  {
    value: '2699',
    label: 'Laksh Human Resource',
  },
  {
    value: '1915',
    label: 'Lakshmi Precision Screws Limited',
  },
  {
    value: '2267',
    label: 'LAKSHMI VILAS BANK',
  },
  {
    value: '2754',
    label: 'Laksh Source Business Solutions',
  },
  {
    value: '2650',
    label: 'LAKSHYA POWERTECH PRIVATE LIMITED',
  },
  {
    value: '218',
    label: 'Lanco Infratech',
  },
  {
    value: '670',
    label: 'Lanco Solar Power',
  },
  {
    value: '335',
    label: 'Landmark Group',
  },
  {
    value: '2693',
    label: 'Landmark IT Solutions',
  },
  {
    value: '2488',
    label: 'Landmark Online',
  },
  {
    value: '2183',
    label: 'Lanxess India',
  },
  {
    value: '3028',
    label: 'Larsen & Toubro',
  },
  {
    value: '3119',
    label: 'LARSEN & TOUBRO INFOTECH LIMITED',
  },
  {
    value: '750',
    label: 'LatentView Analytics',
  },
  {
    value: '827',
    label: 'Lava International',
  },
  {
    value: '2065',
    label: 'Law Firm',
  },
  {
    value: '2052',
    label: 'Lawrence & Mayo',
  },
  {
    value: '2712',
    label: 'Leadbxd Technologies',
  },
  {
    value: '1703',
    label: 'Lear Corporation',
  },
  {
    value: '1065',
    label: 'Legal',
  },
  {
    value: '2058',
    label: 'Legrand',
  },
  {
    value: '1505',
    label: 'Leighton Welspun',
  },
  {
    value: '3104',
    label: 'LenDenClub',
  },
  {
    value: '518',
    label: 'Lenovo',
  },
  {
    value: '1954',
    label: 'Lenskart.com',
  },
  {
    value: '856',
    label: 'Leo Burnett',
  },
  {
    value: '1935',
    label: 'Letsbuy.com',
  },
  {
    value: '658',
    label: 'Levi Strauss',
  },
  {
    value: '2897',
    label: 'Lexil',
  },
  {
    value: '2494',
    label: 'LexInnova',
  },
  {
    value: '2429',
    label: 'Lexis Nexis',
  },
  {
    value: '118',
    label: 'LG Electronics',
  },
  {
    value: '561',
    label: 'LIC',
  },
  {
    value: '2527',
    label: 'licious',
  },
  {
    value: '2132',
    label: 'Life Insurance',
  },
  {
    value: '557',
    label: 'Lifestyle',
  },
  {
    value: '2100',
    label: 'Life Technologies',
  },
  {
    value: '1039',
    label: 'Lilliput',
  },
  {
    value: '2419',
    label: 'Limeroad',
  },
  {
    value: '3107',
    label: 'Linc Pen',
  },
  {
    value: '1727',
    label: 'Linc Pen & Plastics',
  },
  {
    value: '2490',
    label: 'LinkedIn',
  },
  {
    value: '1228',
    label: 'Lintas',
  },
  {
    value: '2252',
    label: 'LionBridge Technologies',
  },
  {
    value: '1530',
    label: 'Liqvid eLearning Services',
  },
  {
    value: '2439',
    label: 'LIVSPACE',
  },
  {
    value: '1650',
    label: 'LKP Securities',
  },
  {
    value: '1591',
    label: 'LKP Securities Ltd',
  },
  {
    value: '3075',
    label: 'Lloyds Bank',
  },
  {
    value: '2028',
    label: 'Lloyds Banking Group',
  },
  {
    value: '2841',
    label: 'LM Technology',
  },
  {
    value: '1005',
    label: 'Lodha & Co.',
  },
  {
    value: '153',
    label: 'Lodha Group',
  },
  {
    value: '477',
    label: 'Logica',
  },
  {
    value: '3117',
    label: 'LogiNext',
  },
  {
    value: '915',
    label: 'Logistics',
  },
  {
    value: '2354',
    label: 'Logitech',
  },
  {
    value: '2502',
    label: 'LogMeIn',
  },
  {
    value: '1387',
    label: 'Lohia Group',
  },
  {
    value: '1587',
    label: 'London Business School',
  },
  {
    value: '1803',
    label: 'London School of Economics',
  },
  {
    value: '1898',
    label: 'LongHouse Consulting',
  },
  {
    value: '1708',
    label: 'looking for a job',
  },
  {
    value: '2382',
    label: 'Looking for job',
  },
  {
    value: '594',
    label: 'Loop Mobile',
  },
  {
    value: '1412',
    label: 'Lotte',
  },
  {
    value: '3181',
    label: 'Lotus Herbals',
  },
  {
    value: '1988',
    label: 'Louis Dreyfus Commodities India Pvt. Ltd.',
  },
  {
    value: '1256',
    label: 'Lovely Professional University',
  },
  {
    value: '3007',
    label: "Lowe's Services India Private limited",
  },
  {
    value: '1362',
    label: 'Lowe Lintas',
  },
  {
    value: '909',
    label: 'Loylty Rewardz',
  },
  {
    value: '2452',
    label: 'LT Foods',
  },
  {
    value: '936',
    label: 'Lucintel',
  },
  {
    value: '1301',
    label: 'Lumata Digital',
  },
  {
    value: '1859',
    label: 'Luminous Power Technologies',
  },
  {
    value: '581',
    label: 'Lupin',
  },
  {
    value: '1009',
    label: 'Luxor',
  },
  {
    value: '1679',
    label: 'Luxottica',
  },
  {
    value: '2752',
    label: 'Lykora Consulting Services',
  },
  {
    value: '1290',
    label: 'M3M',
  },
  {
    value: '1602',
    label: 'Macleods Pharmaceuticals',
  },
  {
    value: '1015',
    label: 'Macmillan',
  },
  {
    value: '302',
    label: 'Macquarie',
  },
  {
    value: '505',
    label: 'Madison',
  },
  {
    value: '1036',
    label: 'Madura Coats',
  },
  {
    value: '630',
    label: 'Madura Fashion & Lifestyle',
  },
  {
    value: '200',
    label: 'Maersk',
  },
  {
    value: '2457',
    label: 'maerskline',
  },
  {
    value: '981',
    label: 'Ma Foi',
  },
  {
    value: '2907',
    label: 'magic',
  },
  {
    value: '2444',
    label: 'Magicbricks',
  },
  {
    value: '308',
    label: 'Magma Fincorp Limited',
  },
  {
    value: '849',
    label: 'Magna Infotech',
  },
  {
    value: '55',
    label: 'Mahindra & Mahindra',
  },
  {
    value: '549',
    label: 'Mahindra & Mahindra Financial Services',
  },
  {
    value: '770',
    label: 'Mahindra Comviva',
  },
  {
    value: '406',
    label: 'Mahindra Holidays & Resorts',
  },
  {
    value: '86',
    label: 'Mahindra Satyam',
  },
  {
    value: '2811',
    label: 'Mainstreet',
  },
  {
    value: '2895',
    label: 'Majorel',
  },
  {
    value: '206',
    label: 'MakeMyTrip',
  },
  {
    value: '3175',
    label: 'Mamaearth',
  },
  {
    value: '832',
    label: 'Manappuram',
  },
  {
    value: '1324',
    label: 'Manhattan Associates',
  },
  {
    value: '2106',
    label: 'Manipal Business Solutions',
  },
  {
    value: '542',
    label: 'Manipal Global Education Services',
  },
  {
    value: '388',
    label: 'Manipal Group',
  },
  {
    value: '512',
    label: 'Manpower Group',
  },
  {
    value: '1881',
    label: 'Mansukh Securities & Finance Limited',
  },
  {
    value: '1434',
    label: 'Manthan Services',
  },
  {
    value: '1597',
    label: 'Manthan Systems',
  },
  {
    value: '600',
    label: 'Manufacturing',
  },
  {
    value: '1480',
    label: 'Mapmyindia',
  },
  {
    value: '482',
    label: 'MAQ Software',
  },
  {
    value: '2678',
    label: 'Marathon Electric India Pvt Ltd',
  },
  {
    value: '437',
    label: 'MARG Limited',
  },
  {
    value: '186',
    label: 'Marico',
  },
  {
    value: '288',
    label: 'Marketing',
  },
  {
    value: '2090',
    label: 'Market Insight Consultants',
  },
  {
    value: '1436',
    label: 'marketRx',
  },
  {
    value: '494',
    label: 'MarketsandMarkets',
  },
  {
    value: '3078',
    label: 'Markets and Markets Research Pvt Ltd',
  },
  {
    value: '3152',
    label: 'MarketStar',
  },
  {
    value: '1499',
    label: 'Markit',
  },
  {
    value: '1057',
    label: 'Marks & Spencer',
  },
  {
    value: '1197',
    label: 'Marriott',
  },
  {
    value: '728',
    label: 'Mars',
  },
  {
    value: '2584',
    label: 'Marsh & McLennan',
  },
  {
    value: '599',
    label: 'Marsh India',
  },
  {
    value: '1997',
    label: 'MART',
  },
  {
    value: '151',
    label: 'Maruti Suzuki India Limited',
  },
  {
    value: '1063',
    label: 'Marwadi Shares & Finance Limited',
  },
  {
    value: '1640',
    label: 'Mary Kay Cosmetics',
  },
  {
    value: '2361',
    label: 'Masan Group',
  },
  {
    value: '2588',
    label: 'MASCHIO GASPARDO INDIA PVT LTD',
  },
  {
    value: '2885',
    label: 'Mashreq Global Services',
  },
  {
    value: '3033',
    label: 'Mastech InfoTrellis',
  },
  {
    value: '673',
    label: 'Mastek',
  },
  {
    value: '2948',
    label: 'MasterCard',
  },
  {
    value: '2624',
    label: 'MASTER MANAGEMENT SERVICES',
  },
  {
    value: '1167',
    label: 'Matrimony.com',
  },
  {
    value: '3090',
    label: 'Matrimony.com Limited',
  },
  {
    value: '2774',
    label: 'Matrix Business Machines',
  },
  {
    value: '598',
    label: 'Matrix Cellular',
  },
  {
    value: '2374',
    label: 'Mattel Toys',
  },
  {
    value: '2574',
    label: 'Maven',
  },
  {
    value: '1408',
    label: 'Mawana Sugars',
  },
  {
    value: '2448',
    label: 'Max',
  },
  {
    value: '385',
    label: 'Max Bupa Health Insurance',
  },
  {
    value: '964',
    label: 'Max Healthcare',
  },
  {
    value: '1356',
    label: 'Max Hypermarket',
  },
  {
    value: '172',
    label: 'Max Life Insurance',
  },
  {
    value: '214',
    label: 'Max New York Life Insurance',
  },
  {
    value: '1606',
    label: 'MaxRange Retail Pvt Ltd',
  },
  {
    value: '2040',
    label: 'mba college',
  },
  {
    value: '2344',
    label: 'MBA Fresher',
  },
  {
    value: '772',
    label: 'McAfee',
  },
  {
    value: '3174',
    label: 'MCaffeine',
  },
  {
    value: '1135',
    label: 'McCann',
  },
  {
    value: '1354',
    label: 'McCANN Erickson',
  },
  {
    value: '821',
    label: "McDonald's",
  },
  {
    value: '2730',
    label: 'McHoovers Consulting',
  },
  {
    value: '81',
    label: 'McKinsey & Company',
  },
  {
    value: '510',
    label: 'MCX Stock Exchange',
  },
  {
    value: '1764',
    label: 'MDI',
  },
  {
    value: '1443',
    label: 'MDI, Gurgaon',
  },
  {
    value: '2277',
    label: 'MDI Gurgaon',
  },
  {
    value: '2306',
    label: 'Mecklai Financial Services Ltd',
  },
  {
    value: '2186',
    label: 'Mecon Limited',
  },
  {
    value: '2840',
    label: 'Mediscribes Infotech',
  },
  {
    value: '2735',
    label: 'Mediwave Digital',
  },
  {
    value: '3168',
    label: 'Medline Industries India Private Limited',
  },
  {
    value: '1278',
    label: 'MedPlus',
  },
  {
    value: '1032',
    label: 'Medtronic',
  },
  {
    value: '2805',
    label: 'Meegen Solutions',
  },
  {
    value: '2501',
    label: 'Meesho',
  },
  {
    value: '2608',
    label: 'Megawide Construction DMCC',
  },
  {
    value: '1230',
    label: 'Mercedes Benz',
  },
  {
    value: '191',
    label: 'Mercer',
  },
  {
    value: '1960',
    label: 'Merck Limited',
  },
  {
    value: '2483',
    label: 'Merilytics',
  },
  {
    value: '2127',
    label: 'meritnation.com',
  },
  {
    value: '2216',
    label: 'Meritus Analytics',
  },
  {
    value: '1172',
    label: 'Meru Cabs',
  },
  {
    value: '3122',
    label: 'Meta',
  },
  {
    value: '2759',
    label: 'Metier Virtuoso India  LLP',
  },
  {
    value: '167',
    label: 'Metlife',
  },
  {
    value: '1711',
    label: 'MetricStream',
  },
  {
    value: '281',
    label: 'METRO Cash & Carry',
  },
  {
    value: '2262',
    label: 'Metropolis Healthcare Ltd',
  },
  {
    value: '2312',
    label: 'MHRIL',
  },
  {
    value: '1889',
    label: 'MICA',
  },
  {
    value: '2687',
    label: "Michael's Hoizon",
  },
  {
    value: '694',
    label: 'Michael Page',
  },
  {
    value: '3048',
    label: 'Michael Page',
  },
  {
    value: '1798',
    label: 'Michelin',
  },
  {
    value: '1311',
    label: 'Microland',
  },
  {
    value: '3169',
    label: 'microland.com',
  },
  {
    value: '2013',
    label: 'Microland Ltd',
  },
  {
    value: '914',
    label: 'Micromax',
  },
  {
    value: '2900',
    label: 'Micron Technology India',
  },
  {
    value: '2257',
    label: 'Microsec Capital Limited',
  },
  {
    value: '120',
    label: 'Microsoft',
  },
  {
    value: '1824',
    label: 'Miebach Consulting',
  },
  {
    value: '2726',
    label: 'Millennium IMS',
  },
  {
    value: '502',
    label: 'Millward Brown',
  },
  {
    value: '1634',
    label: 'Mindfire Solutions',
  },
  {
    value: '2827',
    label: 'Mindiii Systems',
  },
  {
    value: '1686',
    label: 'MINDLANCE',
  },
  {
    value: '1779',
    label: 'Mindteck',
  },
  {
    value: '3125',
    label: 'MINDTICKLE INTERACTIVE MEDIA PRIVATE LIMITED',
  },
  {
    value: '135',
    label: 'Mindtree',
  },
  {
    value: '3172',
    label: 'Minimalist',
  },
  {
    value: '2390',
    label: 'Ministry of Defence',
  },
  {
    value: '2909',
    label: 'MiqDigital',
  },
  {
    value: '1360',
    label: 'Mirah Group',
  },
  {
    value: '567',
    label: 'Misys',
  },
  {
    value: '2086',
    label: 'MIT',
  },
  {
    value: '2646',
    label: 'Mitratech India LLP',
  },
  {
    value: '2249',
    label: 'Mitsubishi',
  },
  {
    value: '1527',
    label: 'Mizuho Corporate Bank',
  },
  {
    value: '1782',
    label: 'mjunction services limited',
  },
  {
    value: '2333',
    label: 'Mjunction Services Ltd',
  },
  {
    value: '834',
    label: 'MModal Global Services',
  },
  {
    value: '1485',
    label: 'MMTC Limited',
  },
  {
    value: '2050',
    label: 'MMTC Ltd.',
  },
  {
    value: '596',
    label: 'mnc',
  },
  {
    value: '2548',
    label: 'Mobikwik',
  },
  {
    value: '2810',
    label: 'Mobis India Module',
  },
  {
    value: '3154',
    label: 'Modak Analytics LLP',
  },
  {
    value: '513',
    label: 'Modi Group',
  },
  {
    value: '618',
    label: 'Mogae Media',
  },
  {
    value: '2460',
    label: 'Mondelez',
  },
  {
    value: '2963',
    label: 'MongoDB Software India Private Limited',
  },
  {
    value: '1359',
    label: 'Monitor Group',
  },
  {
    value: '920',
    label: 'Monnet Group',
  },
  {
    value: '787',
    label: 'Monsanto',
  },
  {
    value: '681',
    label: 'Monster.com',
  },
  {
    value: '2019',
    label: 'Morarka Organic Foods Ltd',
  },
  {
    value: '2599',
    label: 'Moreish Foods Limited',
  },
  {
    value: '98',
    label: 'Morgan Stanley',
  },
  {
    value: '2802',
    label: 'Moringo Organics',
  },
  {
    value: '2896',
    label: 'Morningstar',
  },
  {
    value: '213',
    label: 'Moser Baer',
  },
  {
    value: '216',
    label: 'Mother Dairy',
  },
  {
    value: '1092',
    label: 'Motherson Group',
  },
  {
    value: '185',
    label: 'Motilal Oswal',
  },
  {
    value: '3120',
    label: 'Motilal Oswal Fin Ser Limited',
  },
  {
    value: '767',
    label: 'Motorola',
  },
  {
    value: '333',
    label: 'Motorola Mobility',
  },
  {
    value: '704',
    label: 'Mott MacDonald',
  },
  {
    value: '2355',
    label: 'Mount Talent Consulting',
  },
  {
    value: '87',
    label: 'MphasiS',
  },
  {
    value: '2633',
    label: 'MPL Gaming',
  },
  {
    value: '575',
    label: 'MPS Group of Companies',
  },
  {
    value: '826',
    label: 'MRF',
  },
  {
    value: '551',
    label: 'MSCI',
  },
  {
    value: '1484',
    label: 'MSD Pharmaceuticals',
  },
  {
    value: '2467',
    label: 'MSE',
  },
  {
    value: '1664',
    label: 'MSFL',
  },
  {
    value: '2881',
    label: 'MSI Services Private Limited',
  },
  {
    value: '2039',
    label: 'MSL India',
  },
  {
    value: '1108',
    label: 'MTR Foods',
  },
  {
    value: '45',
    label: 'MTS',
  },
  {
    value: '1270',
    label: 'Multi Commodity Exchange Of India',
  },
  {
    value: '886',
    label: 'Murugappa Group',
  },
  {
    value: '2990',
    label: 'MUSARUBRA SOFTWARE INDIA PRIVATE LIMITED',
  },
  {
    value: '77',
    label: 'Mu Sigma',
  },
  {
    value: '347',
    label: 'Muthoot Fincorp',
  },
  {
    value: '879',
    label: 'MVL Telecom',
  },
  {
    value: '2080',
    label: 'MXV Consulting',
  },
  {
    value: '3178',
    label: 'My Glamm',
  },
  {
    value: '2508',
    label: 'MYK LATICRETE',
  },
  {
    value: '1046',
    label: 'Mylan',
  },
  {
    value: '587',
    label: 'Myntra.com',
  },
  {
    value: '1877',
    label: 'N/A',
  },
  {
    value: '258',
    label: 'N/A',
  },
  {
    value: '1150',
    label: 'N/A',
  },
  {
    value: '586',
    label: 'N/A',
  },
  {
    value: '1409',
    label: 'N/A',
  },
  {
    value: '1921',
    label: 'N/A',
  },
  {
    value: '2317',
    label: 'N/A',
  },
  {
    value: '1',
    label: 'N/A',
  },
  {
    value: '1836',
    label: 'N A',
  },
  {
    value: '1358',
    label: 'Naaptol.com',
  },
  {
    value: '2125',
    label: 'Nagarjuna Oil Corporation Limited',
  },
  {
    value: '884',
    label: 'Nagarro',
  },
  {
    value: '1704',
    label: 'Narang Group',
  },
  {
    value: '1269',
    label: 'Narayana Hrudayalaya',
  },
  {
    value: '2750',
    label: 'Narne Constructions',
  },
  {
    value: '1749',
    label: 'NASSCOM',
  },
  {
    value: '2283',
    label: 'National Dairy Development Board',
  },
  {
    value: '1249',
    label: 'National Institute for Smart Government',
  },
  {
    value: '1992',
    label: 'National Institute of Smart Government',
  },
  {
    value: '947',
    label: 'National Instruments',
  },
  {
    value: '1145',
    label: 'National Payments Corporation of India',
  },
  {
    value: '2144',
    label: 'National Securities Depository Limited',
  },
  {
    value: '1733',
    label: 'National Securities Depository Ltd',
  },
  {
    value: '2524',
    label: 'Naukri.com',
  },
  {
    value: '1627',
    label: 'Navatar Group',
  },
  {
    value: '1510',
    label: 'NBFC',
  },
  {
    value: '578',
    label: 'NCDEX',
  },
  {
    value: '1350',
    label: 'NCR CORPORATION',
  },
  {
    value: '2391',
    label: 'NCR Corporation India Pvt Ltd',
  },
  {
    value: '640',
    label: 'NDTV',
  },
  {
    value: '2438',
    label: 'nearbuy',
  },
  {
    value: '1494',
    label: 'NEC',
  },
  {
    value: '693',
    label: 'NEC HCL System Technologies',
  },
  {
    value: '2167',
    label: 'Neilsoft',
  },
  {
    value: '2221',
    label: 'Neilsoft Ltd.',
  },
  {
    value: '3088',
    label: 'NEOZOOM TECHNOLOGIES PRIVATE LIMITED',
  },
  {
    value: '608',
    label: 'Ness Technologies',
  },
  {
    value: '129',
    label: 'Nestle',
  },
  {
    value: '1673',
    label: 'Net 4 India Limited',
  },
  {
    value: '461',
    label: 'NetAmbit',
  },
  {
    value: '753',
    label: 'NetApp',
  },
  {
    value: '2945',
    label: 'Netflix',
  },
  {
    value: '2940',
    label: 'Netlink Software Pvt td',
  },
  {
    value: '2606',
    label: 'Netpulse Services India Pvt. Ltd',
  },
  {
    value: '2706',
    label: 'NetScore Technologies',
  },
  {
    value: '3153',
    label: 'NetScore Technologies Pvt. Ltd.',
  },
  {
    value: '796',
    label: 'Netscribes',
  },
  {
    value: '675',
    label: 'Network 18',
  },
  {
    value: '1066',
    label: 'Network18 Group',
  },
  {
    value: '1781',
    label: 'Network 21',
  },
  {
    value: '689',
    label: 'Neuerth Group',
  },
  {
    value: '424',
    label: 'Newgen Software',
  },
  {
    value: '3118',
    label: 'Newgen Software Technologies',
  },
  {
    value: '1285',
    label: 'New Holland Fiat India',
  },
  {
    value: '2466',
    label: 'Newscorp VCCircle',
  },
  {
    value: '2875',
    label: 'Nexii IT Labs',
  },
  {
    value: '635',
    label: 'Next Education',
  },
  {
    value: '2815',
    label: 'Next Leap Career Solutions',
  },
  {
    value: '854',
    label: 'Next Retail',
  },
  {
    value: '2645',
    label: 'Neyyar Learning P LTD',
  },
  {
    value: '2848',
    label: 'Nfolks Software Technologies',
  },
  {
    value: '1906',
    label: 'ngo',
  },
  {
    value: '2628',
    label: 'NICHE CONSULTING SERVICES',
  },
  {
    value: '261',
    label: 'Nielsen',
  },
  {
    value: '662',
    label: 'Nihilent Technologies',
  },
  {
    value: '91',
    label: 'NIIT',
  },
  {
    value: '1178',
    label: 'Nike',
  },
  {
    value: '1594',
    label: 'nil',
  },
  {
    value: '2138',
    label: 'Nilkamal Limited',
  },
  {
    value: '1372',
    label: 'Nimbus',
  },
  {
    value: '3055',
    label: 'Ninjacart',
  },
  {
    value: '1319',
    label: 'Nippon Paints',
  },
  {
    value: '650',
    label: 'Nirmal Bang',
  },
  {
    value: '853',
    label: 'NISG',
  },
  {
    value: '1382',
    label: 'Nissan',
  },
  {
    value: '876',
    label: 'Nitco Tiles',
  },
  {
    value: '719',
    label: 'NITIE',
  },
  {
    value: '2101',
    label: 'Nityo Infotech',
  },
  {
    value: '2656',
    label: 'NIVA NUTRIFOODS LLP',
  },
  {
    value: '1054',
    label: 'Nivea',
  },
  {
    value: '2651',
    label: 'NKP Salve Institute Of Medical Sciences',
  },
  {
    value: '534',
    label: 'NMIMS',
  },
  {
    value: '2117',
    label: 'NMIMS, Mumbai',
  },
  {
    value: '2296',
    label: 'NMIMS University',
  },
  {
    value: '1328',
    label: 'no experience',
  },
  {
    value: '69',
    label: 'Nokia',
  },
  {
    value: '101',
    label: 'Nokia Siemens Networks',
  },
  {
    value: '50',
    label: 'Nomura',
  },
  {
    value: '3092',
    label: 'Nomura Services India Pvt. Ltd',
  },
  {
    value: '2024',
    label: 'None',
  },
  {
    value: '2517',
    label: 'Northern Arc',
  },
  {
    value: '228',
    label: 'Northern Trust',
  },
  {
    value: '1677',
    label: 'Not employed',
  },
  {
    value: '1669',
    label: 'nothing',
  },
  {
    value: '402',
    label: 'Not Working',
  },
  {
    value: '1418',
    label: 'Not working currently',
  },
  {
    value: '2241',
    label: 'Not yet',
  },
  {
    value: '2146',
    label: 'NourishCo',
  },
  {
    value: '182',
    label: 'Novartis',
  },
  {
    value: '1974',
    label: 'Novozymes',
  },
  {
    value: '2007',
    label: 'NPTI',
  },
  {
    value: '1862',
    label: 'NSDL',
  },
  {
    value: '324',
    label: 'NSE',
  },
  {
    value: '2034',
    label: 'NSI INFINIUM GLOBAL PVT LTD',
  },
  {
    value: '1489',
    label: 'NSN',
  },
  {
    value: '428',
    label: 'NTPC',
  },
  {
    value: '478',
    label: 'NTT Data',
  },
  {
    value: '2864',
    label: 'Nuance Transcription Services India',
  },
  {
    value: '525',
    label: 'Nucleus Software Exports',
  },
  {
    value: '2338',
    label: 'Nucsoft Ltd.',
  },
  {
    value: '3051',
    label: 'Nutanix',
  },
  {
    value: '3061',
    label: 'Nutanix Technologies India Private Limited',
  },
  {
    value: '2540',
    label: 'nVent',
  },
  {
    value: '1729',
    label: 'Nvidia',
  },
  {
    value: '2569',
    label: 'Nykaa Fashion',
  },
  {
    value: '1572',
    label: 'o3 Capital',
  },
  {
    value: '1826',
    label: 'Oak Capital Management',
  },
  {
    value: '2515',
    label: 'OakNorth',
  },
  {
    value: '894',
    label: 'Oberoi Group',
  },
  {
    value: '905',
    label: 'Oberoi Group of Hotels',
  },
  {
    value: '1521',
    label: 'Obopay Mobile',
  },
  {
    value: '3022',
    label: 'OCEANEERING',
  },
  {
    value: '2006',
    label: 'octamec Group',
  },
  {
    value: '283',
    label: 'Ocwen',
  },
  {
    value: '2762',
    label: 'Odisha Television',
  },
  {
    value: '2798',
    label: 'Offchip Technologies',
  },
  {
    value: '1800',
    label: 'OfficeYes.com',
  },
  {
    value: '2129',
    label: 'OFSS',
  },
  {
    value: '250',
    label: 'Ogilvy & Mather',
  },
  {
    value: '1407',
    label: 'OLA cabs',
  },
  {
    value: '207',
    label: 'Olam International',
  },
  {
    value: '2425',
    label: 'Ole',
  },
  {
    value: '1589',
    label: 'Oliver Wyman',
  },
  {
    value: '2426',
    label: 'OLX',
  },
  {
    value: '1279',
    label: 'Olympus Imaging',
  },
  {
    value: '746',
    label: 'Omnitech Infosolutions',
  },
  {
    value: '357',
    label: 'One97 Communications',
  },
  {
    value: '2451',
    label: 'OneDirect',
  },
  {
    value: '2513',
    label: 'OnePlus',
  },
  {
    value: '1508',
    label: 'Onestopm.com',
  },
  {
    value: '389',
    label: 'ONGC',
  },
  {
    value: '355',
    label: 'Onicra Credit Rating Agency of India',
  },
  {
    value: '683',
    label: 'Onida',
  },
  {
    value: '270',
    label: 'OnMobile',
  },
  {
    value: '3012',
    label: 'Opentext Technologies India Pvt. Ltd',
  },
  {
    value: '609',
    label: 'Opera Solutions',
  },
  {
    value: '2372',
    label: 'OPI',
  },
  {
    value: '2601',
    label: 'Optimize IT Systems Private Limited',
  },
  {
    value: '34',
    label: 'Oracle',
  },
  {
    value: '410',
    label: 'Orange Business Services',
  },
  {
    value: '3084',
    label: 'OrangeHealth',
  },
  {
    value: '3083',
    label: 'Orange Health',
  },
  {
    value: '2800',
    label: 'Oratiohrm Consultancy',
  },
  {
    value: '2004',
    label: 'Orbis Financial Corporation Limited',
  },
  {
    value: '1698',
    label: 'Orbit Corporation Limited',
  },
  {
    value: '2799',
    label: 'Orbit technical Solutions',
  },
  {
    value: '840',
    label: 'Orchid Chemicals & Pharmaceuticals',
  },
  {
    value: '1288',
    label: 'Organization',
  },
  {
    value: '763',
    label: 'Oriental Bank of Commerce',
  },
  {
    value: '3059',
    label: 'Orient Bell Limited',
  },
  {
    value: '2308',
    label: 'Orient cement',
  },
  {
    value: '1232',
    label: 'Oriflame',
  },
  {
    value: '2580',
    label: 'Orion',
  },
  {
    value: '2078',
    label: 'Osram',
  },
  {
    value: '1534',
    label: 'other',
  },
  {
    value: '1102',
    label: 'Others',
  },
  {
    value: '1995',
    label: 'OTIS Elevator',
  },
  {
    value: '2814',
    label: 'Outleap Technologies',
  },
  {
    value: '1526',
    label: 'Outlook',
  },
  {
    value: '1449',
    label: 'Outsource Partners International',
  },
  {
    value: '1609',
    label: 'Own',
  },
  {
    value: '2071',
    label: 'Own business',
  },
  {
    value: '2174',
    label: 'Oxfam India',
  },
  {
    value: '1007',
    label: 'Oxigen Services',
  },
  {
    value: '2472',
    label: 'oyo',
  },
  {
    value: '1447',
    label: 'Oyster Learning',
  },
  {
    value: '2286',
    label: 'Ozone group',
  },
  {
    value: '2458',
    label: 'P&G',
  },
  {
    value: '2124',
    label: 'Pace Power Systems Pvt Ltd',
  },
  {
    value: '1913',
    label: 'PA Consulting',
  },
  {
    value: '1815',
    label: 'PA Consulting Group',
  },
  {
    value: '2193',
    label: 'Pall Corporation',
  },
  {
    value: '666',
    label: 'Panacea Biotec',
  },
  {
    value: '376',
    label: 'Panasonic',
  },
  {
    value: '973',
    label: 'Pangea3',
  },
  {
    value: '310',
    label: 'Pantaloon Retail',
  },
  {
    value: '2927',
    label: 'PaperTrue',
  },
  {
    value: '1681',
    label: 'Parag Milk Foods',
  },
  {
    value: '1886',
    label: 'Paramount Farms',
  },
  {
    value: '2001',
    label: 'Paras Pharmaceuticals',
  },
  {
    value: '1973',
    label: 'PAREXEL',
  },
  {
    value: '2197',
    label: 'Parikar Business and Knowledge Services',
  },
  {
    value: '2116',
    label: 'Park Plaza',
  },
  {
    value: '332',
    label: 'Parle Agro',
  },
  {
    value: '744',
    label: 'Parle Products',
  },
  {
    value: '2155',
    label: 'Parry Agro Industries',
  },
  {
    value: '1599',
    label: 'Parsons Brinckerhoff',
  },
  {
    value: '2654',
    label: 'Pathcare Labs Pvt Ltd',
  },
  {
    value: '2029',
    label: 'Pathfinder',
  },
  {
    value: '2130',
    label: 'Path Infotech',
  },
  {
    value: '674',
    label: 'Patni Computer Systems',
  },
  {
    value: '1951',
    label: 'Paul Merchants',
  },
  {
    value: '858',
    label: 'PAYBACK',
  },
  {
    value: '1284',
    label: 'Payoda',
  },
  {
    value: '701',
    label: 'PayPal',
  },
  {
    value: '2547',
    label: 'PayU',
  },
  {
    value: '1134',
    label: 'PBO Plus Consulting',
  },
  {
    value: '1705',
    label: 'PCS Securities',
  },
  {
    value: '1562',
    label: 'PCS Technology',
  },
  {
    value: '1514',
    label: 'Pearson',
  },
  {
    value: '541',
    label: 'Pearson Education',
  },
  {
    value: '1019',
    label: 'PE Electronics',
  },
  {
    value: '1107',
    label: 'Peninsula Land',
  },
  {
    value: '2036',
    label: 'Penna Cement Industries',
  },
  {
    value: '2801',
    label: 'Pentacle Designing Solutions',
  },
  {
    value: '1294',
    label: 'Pentair',
  },
  {
    value: '2576',
    label: 'Peoplefy Infosolutions Pvt. Ltd',
  },
  {
    value: '991',
    label: 'People Interactive',
  },
  {
    value: '381',
    label: 'Peoplestrong HR',
  },
  {
    value: '2734',
    label: 'People Tech Enterprises Private Limited',
  },
  {
    value: '1719',
    label: 'Pepperfry.com',
  },
  {
    value: '52',
    label: 'PepsiCo',
  },
  {
    value: '624',
    label: 'Percept',
  },
  {
    value: '1567',
    label: 'Perfect Relations',
  },
  {
    value: '2209',
    label: 'Perfect Research',
  },
  {
    value: '487',
    label: 'Perfetti Van Melle',
  },
  {
    value: '2011',
    label: 'Perfint Healthcare',
  },
  {
    value: '453',
    label: 'Pernod Ricard',
  },
  {
    value: '2099',
    label: 'Perot Systems',
  },
  {
    value: '636',
    label: 'Persistent Systems',
  },
  {
    value: '1383',
    label: 'Petrofac',
  },
  {
    value: '2386',
    label: 'Petroleum and Natural Gas Regulatory Board',
  },
  {
    value: '411',
    label: 'Pfizer',
  },
  {
    value: '2171',
    label: 'Phadnis Infrastructure',
  },
  {
    value: '1308',
    label: 'pharma',
  },
  {
    value: '1462',
    label: 'Pharmaceutical',
  },
  {
    value: '2352',
    label: 'Pharmaceuticals',
  },
  {
    value: '935',
    label: 'Philip Morris',
  },
  {
    value: '1422',
    label: 'Philips',
  },
  {
    value: '103',
    label: 'Philips Electronics India Ltd',
  },
  {
    value: '1466',
    label: 'Philips Healthcare',
  },
  {
    value: '2304',
    label: 'Philips Lighting',
  },
  {
    value: '1340',
    label: 'PhillipCapital',
  },
  {
    value: '2807',
    label: 'PhonePe',
  },
  {
    value: '2976',
    label: 'PhonePe Private Limited',
  },
  {
    value: '552',
    label: 'Photon Infotech',
  },
  {
    value: '2214',
    label: 'Piaggio',
  },
  {
    value: '178',
    label: 'Pidilite Industries',
  },
  {
    value: '1438',
    label: 'PI Industries',
  },
  {
    value: '2195',
    label: 'PINC Research',
  },
  {
    value: '2261',
    label: 'PineBridge Investments (formerly AIG Investmenets)',
  },
  {
    value: '354',
    label: 'Piramal',
  },
  {
    value: '517',
    label: 'Pitney Bowes Software',
  },
  {
    value: '1043',
    label: 'PKF Sridhar & Santhanam',
  },
  {
    value: '855',
    label: 'Planet M Retail',
  },
  {
    value: '1385',
    label: 'Planman Consulting',
  },
  {
    value: '893',
    label: 'Planman HR',
  },
  {
    value: '1381',
    label: 'Planman Media',
  },
  {
    value: '1512',
    label: 'Planning Commission',
  },
  {
    value: '3009',
    label: 'PlanSource',
  },
  {
    value: '2416',
    label: 'Plivo',
  },
  {
    value: '1399',
    label: 'plugHR',
  },
  {
    value: '1554',
    label: 'PNB Gilts Ltd',
  },
  {
    value: '1303',
    label: 'PNB Housing Finance Limited',
  },
  {
    value: '1901',
    label: 'PNB Investment Services Limited',
  },
  {
    value: '627',
    label: 'PNB MetLife',
  },
  {
    value: '89',
    label: 'Polaris Industries',
  },
  {
    value: '756',
    label: 'Policybazaar.com',
  },
  {
    value: '1293',
    label: 'Polycab Wires & Cables',
  },
  {
    value: '1570',
    label: 'Polycom',
  },
  {
    value: '3058',
    label: 'Poonawalla Fincorp',
  },
  {
    value: '1996',
    label: 'Population Services International',
  },
  {
    value: '2521',
    label: 'Porter',
  },
  {
    value: '2876',
    label: 'Postman',
  },
  {
    value: '861',
    label: 'Power Exchange India Limited',
  },
  {
    value: '830',
    label: 'Power Finance Corporation',
  },
  {
    value: '1052',
    label: 'Powerwave Technologies',
  },
  {
    value: '2647',
    label: 'PPD Pharmaceutical Development India Private ltd',
  },
  {
    value: '799',
    label: 'Prabhudas Liladhar',
  },
  {
    value: '1477',
    label: 'Practo',
  },
  {
    value: '1952',
    label: 'Pramati Technologies',
  },
  {
    value: '1620',
    label: 'Pratibha Industries',
  },
  {
    value: '2327',
    label: 'Praxair India Pvt Ltd',
  },
  {
    value: '2400',
    label: 'Praxis Business School',
  },
  {
    value: '20',
    label: 'PricewaterhouseCoopers',
  },
  {
    value: '2247',
    label: 'Prime Focus Limited',
  },
  {
    value: '745',
    label: 'Principal',
  },
  {
    value: '2672',
    label: 'Prio Consulting',
  },
  {
    value: '1861',
    label: 'Private',
  },
  {
    value: '866',
    label: 'Probe Equity Research',
  },
  {
    value: '88',
    label: 'Procter & Gamble',
  },
  {
    value: '1475',
    label: 'Progressive Digital Media',
  },
  {
    value: '1471',
    label: 'Progressive Infotech',
  },
  {
    value: '2042',
    label: 'Progressive Infotech Pvt Ltd',
  },
  {
    value: '1147',
    label: 'Progressive Media Group',
  },
  {
    value: '1305',
    label: 'Promed Group',
  },
  {
    value: '976',
    label: 'PropEquity Analytics',
  },
  {
    value: '2010',
    label: 'Properji',
  },
  {
    value: '3016',
    label: 'Property Share',
  },
  {
    value: '3141',
    label: 'Proplled',
  },
  {
    value: '957',
    label: 'Proptiger Realty',
  },
  {
    value: '304',
    label: 'Protiviti Consulting',
  },
  {
    value: '3144',
    label: 'providence.org',
  },
  {
    value: '2751',
    label: 'Prov Labs India',
  },
  {
    value: '3070',
    label: 'PROZO DISTRIBUTION PRIVATE LIMITED',
  },
  {
    value: '776',
    label: 'Prudential',
  },
  {
    value: '1265',
    label: 'PTC',
  },
  {
    value: '885',
    label: 'Publicis',
  },
  {
    value: '3100',
    label: 'Publicis Sapient',
  },
  {
    value: '2161',
    label: 'Pubmatic',
  },
  {
    value: '1378',
    label: 'PUG Securities',
  },
  {
    value: '959',
    label: 'Pulsar Knowledge Centre',
  },
  {
    value: '1325',
    label: 'Puma',
  },
  {
    value: '1377',
    label: 'Punjab National Bank',
  },
  {
    value: '280',
    label: 'Punj Lloyd',
  },
  {
    value: '2820',
    label: 'Puravankara',
  },
  {
    value: '2495',
    label: 'Purnartha',
  },
  {
    value: '3180',
    label: 'Purplle',
  },
  {
    value: '1090',
    label: 'PVR',
  },
  {
    value: '1857',
    label: 'Pylon Management Consulting',
  },
  {
    value: '1481',
    label: 'Pyramid IT Consulting',
  },
  {
    value: '2234',
    label: 'Pyro Group',
  },
  {
    value: '523',
    label: 'QAI',
  },
  {
    value: '2826',
    label: 'QI Group',
  },
  {
    value: '2924',
    label: 'QSC',
  },
  {
    value: '2616',
    label: 'Quacquarelli Symonds India Private Limited',
  },
  {
    value: '1700',
    label: 'Quadrangle',
  },
  {
    value: '2686',
    label: 'Quadratic Software Systems Pvt Ltd',
  },
  {
    value: '761',
    label: 'Qualcomm',
  },
  {
    value: '2177',
    label: 'Quant Broking Private Limited',
  },
  {
    value: '1352',
    label: 'Quant Capital',
  },
  {
    value: '2884',
    label: 'Quantum Business Advisory',
  },
  {
    value: '562',
    label: 'Quatrro',
  },
  {
    value: '911',
    label: 'Quest Diagnostics',
  },
  {
    value: '3029',
    label: 'QUEST DIAGNOSTICS HTAS INDIA',
  },
  {
    value: '1472',
    label: 'Quintiles',
  },
  {
    value: '2780',
    label: 'Qwazent Health Search',
  },
  {
    value: '2690',
    label: 'Raavela Interiors',
  },
  {
    value: '1148',
    label: 'Rabobank',
  },
  {
    value: '2835',
    label: 'Radiance',
  },
  {
    value: '1189',
    label: 'Radico Khaitan',
  },
  {
    value: '733',
    label: 'Radio Mirchi',
  },
  {
    value: '2729',
    label: 'Rahi Systems',
  },
  {
    value: '2982',
    label: 'Rain Carbon Inc',
  },
  {
    value: '2968',
    label: 'RAIN Industries Limited',
  },
  {
    value: '2213',
    label: 'Rainman Consulting',
  },
  {
    value: '2589',
    label: 'Rakuten',
  },
  {
    value: '2677',
    label: 'Ramalingam Construction Company Pvt Ltd',
  },
  {
    value: '275',
    label: 'Ramco Systems',
  },
  {
    value: '415',
    label: 'Ramky Group',
  },
  {
    value: '2694',
    label: 'Ram Sneh Jankalyan Sewa Trust',
  },
  {
    value: '3041',
    label: 'ramsoft',
  },
  {
    value: '3042',
    label: 'RamSoft Pvt Ltd',
  },
  {
    value: '159',
    label: 'Ranbaxy',
  },
  {
    value: '317',
    label: 'Randstad',
  },
  {
    value: '3130',
    label: 'RAPIDAI SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED',
  },
  {
    value: '3002',
    label: 'RAPIDO',
  },
  {
    value: '2592',
    label: 'RaRa Delivery',
  },
  {
    value: '698',
    label: 'RateGain',
  },
  {
    value: '697',
    label: 'Ratnakar Bank',
  },
  {
    value: '2185',
    label: 'Rave Technologies',
  },
  {
    value: '739',
    label: 'Raychem RPG',
  },
  {
    value: '291',
    label: 'Raymond',
  },
  {
    value: '2566',
    label: 'Razorpay',
  },
  {
    value: '2954',
    label: 'RBC',
  },
  {
    value: '2440',
    label: 'RBL Bank',
  },
  {
    value: '2595',
    label: 'Realcoderz technologies pvt ltd',
  },
  {
    value: '937',
    label: 'Real Estate',
  },
  {
    value: '1801',
    label: 'Realization Technologies',
  },
  {
    value: '2542',
    label: 'REBEL Foods',
  },
  {
    value: '2724',
    label: 'RecHom',
  },
  {
    value: '162',
    label: 'Reckitt Benckiser',
  },
  {
    value: '1746',
    label: 'Red Bull',
  },
  {
    value: '1213',
    label: 'redBus.in',
  },
  {
    value: '1048',
    label: 'Rediff.com',
  },
  {
    value: '1257',
    label: 'Rediffusion - Y&R',
  },
  {
    value: '372',
    label: 'Redington',
  },
  {
    value: '2992',
    label: 'Redington (INDIA) Limited',
  },
  {
    value: '1074',
    label: 'Redwood Associates',
  },
  {
    value: '498',
    label: 'Reebok',
  },
  {
    value: '1088',
    label: 'Reed Elsevier',
  },
  {
    value: '1946',
    label: 'rei agro limited',
  },
  {
    value: '648',
    label: 'Relaxo Footwear',
  },
  {
    value: '72',
    label: 'Reliance',
  },
  {
    value: '516',
    label: 'Reliance Brands Limited',
  },
  {
    value: '306',
    label: 'Reliance Broadcast Network Limited',
  },
  {
    value: '141',
    label: 'Reliance Capital',
  },
  {
    value: '36',
    label: 'Reliance Communications',
  },
  {
    value: '584',
    label: 'Reliance Digital',
  },
  {
    value: '49',
    label: 'Reliance Industries Limited',
  },
  {
    value: '179',
    label: 'Reliance Infrastructure',
  },
  {
    value: '184',
    label: 'Reliance Life Insurance',
  },
  {
    value: '348',
    label: 'Reliance Power',
  },
  {
    value: '152',
    label: 'Reliance Retail',
  },
  {
    value: '2921',
    label: 'RELIANCE RETAIL LIMITED',
  },
  {
    value: '792',
    label: 'Reliance Securities',
  },
  {
    value: '48',
    label: 'Religare',
  },
  {
    value: '1633',
    label: 'Relio Quick',
  },
  {
    value: '2704',
    label: 'Renascence Talent Solutions',
  },
  {
    value: '582',
    label: 'Renault',
  },
  {
    value: '687',
    label: 'Renoir Consulting',
  },
  {
    value: '945',
    label: 'Reserve Bank of India',
  },
  {
    value: '2785',
    label: 'Resmera Solutions',
  },
  {
    value: '1519',
    label: 'Resultrix',
  },
  {
    value: '2660',
    label: 'Resume Management Consultants',
  },
  {
    value: '2353',
    label: 'Resurgent India Limited',
  },
  {
    value: '757',
    label: 'Retail',
  },
  {
    value: '718',
    label: 'Reval Analytics',
  },
  {
    value: '1501',
    label: 'Ricoh India',
  },
  {
    value: '3123',
    label: 'Right Brain',
  },
  {
    value: '1201',
    label: 'Right Management',
  },
  {
    value: '2220',
    label: 'RIMS',
  },
  {
    value: '989',
    label: 'Rio Tinto India',
  },
  {
    value: '1465',
    label: 'Risk Management Solutions',
  },
  {
    value: '2284',
    label: 'RITES Ltd',
  },
  {
    value: '2755',
    label: 'Rite Software Solutions And Services',
  },
  {
    value: '2956',
    label: 'Rituals',
  },
  {
    value: '3132',
    label: 'Rivigo',
  },
  {
    value: '2684',
    label: 'RKBS ITERIA-IN CONSULTING AND SERVICES',
  },
  {
    value: '818',
    label: 'RMS',
  },
  {
    value: '990',
    label: 'Roamware',
  },
  {
    value: '3082',
    label: 'Robosoft Technologies Pvt.Ltd',
  },
  {
    value: '2865',
    label: 'RoboticWares',
  },
  {
    value: '1691',
    label: 'Rocket Internet',
  },
  {
    value: '1617',
    label: 'Rockwell Automation',
  },
  {
    value: '1267',
    label: 'Rocsearch',
  },
  {
    value: '1016',
    label: 'Rolta India',
  },
  {
    value: '2849',
    label: 'Roppen Transportation Services',
  },
  {
    value: '2797',
    label: 'Ross process equipment',
  },
  {
    value: '2294',
    label: 'Roubini Global Economics',
  },
  {
    value: '25',
    label: 'Royal Bank of Scotland',
  },
  {
    value: '1981',
    label: 'Royal Dutch Shell',
  },
  {
    value: '2519',
    label: 'Royal Enfield',
  },
  {
    value: '1833',
    label: 'Royal Orchid',
  },
  {
    value: '1109',
    label: 'Royal Sundaram',
  },
  {
    value: '416',
    label: 'RPG Group',
  },
  {
    value: '809',
    label: 'RR Donnelley & Sons',
  },
  {
    value: '2784',
    label: 'R R Sen & Brothers',
  },
  {
    value: '2868',
    label: 'RSG Media',
  },
  {
    value: '1649',
    label: 'RS Software',
  },
  {
    value: '2707',
    label: 'Rubico IT Private Limited',
  },
  {
    value: '591',
    label: 'Ruchi Soya',
  },
  {
    value: '1665',
    label: 'Ruia Group',
  },
  {
    value: '2369',
    label: 'RUMI Education',
  },
  {
    value: '2602',
    label: 'RUMUFHAS CONSULTANCY PRIVATE LIMITED',
  },
  {
    value: '2532',
    label: 'Rupeek',
  },
  {
    value: '1897',
    label: 'S.S. Kothari Mehta & Co.',
  },
  {
    value: '2773',
    label: 'Saas factors LLP',
  },
  {
    value: '330',
    label: 'SABMiller',
  },
  {
    value: '1583',
    label: 'Sabre Holdings',
  },
  {
    value: '463',
    label: 'Safexpress',
  },
  {
    value: '204',
    label: 'Sahara',
  },
  {
    value: '2075',
    label: 'Sahyadri Hospitals Ltd',
  },
  {
    value: '279',
    label: 'Sai Info System',
  },
  {
    value: '344',
    label: 'SAIL',
  },
  {
    value: '1396',
    label: "Sainsbury's",
  },
  {
    value: '397',
    label: 'Saint Gobain',
  },
  {
    value: '1212',
    label: 'Sales',
  },
  {
    value: '2511',
    label: 'Salesforce',
  },
  {
    value: '2530',
    label: 'Saltside Technologies',
  },
  {
    value: '1220',
    label: 'Samsonite South Asia Pvt Ltd',
  },
  {
    value: '67',
    label: 'Samsung',
  },
  {
    value: '1920',
    label: 'SanDisk India',
  },
  {
    value: '1936',
    label: 'Sandoz Private Limited',
  },
  {
    value: '524',
    label: 'Sanofi Pasteur',
  },
  {
    value: '2610',
    label: 'SANOTI SOLUTIONS',
  },
  {
    value: '2809',
    label: 'Santo Systems',
  },
  {
    value: '108',
    label: 'SAP',
  },
  {
    value: '114',
    label: 'Sapient',
  },
  {
    value: '3049',
    label: 'Saras Analytics',
  },
  {
    value: '847',
    label: 'Saraswat Co-Operative Bank',
  },
  {
    value: '1419',
    label: 'Saregama',
  },
  {
    value: '2110',
    label: 'SAR Group',
  },
  {
    value: '2497',
    label: 'Sarva',
  },
  {
    value: '970',
    label: 'SAS',
  },
  {
    value: '475',
    label: 'Sasken',
  },
  {
    value: '2911',
    label: 'Sathguru',
  },
  {
    value: '500',
    label: 'Satyam',
  },
  {
    value: '2389',
    label: 'SAUD BAHWAN AUTOMOTIVE',
  },
  {
    value: '1934',
    label: 'Saviance Technologies',
  },
  {
    value: '1945',
    label: 'Saxo Bank',
  },
  {
    value: '519',
    label: 'SBI Capital Markets',
  },
  {
    value: '2914',
    label: 'Scaler Academy',
  },
  {
    value: '2302',
    label: 'Schindler India Pvt Ltd',
  },
  {
    value: '576',
    label: 'Schlumberger',
  },
  {
    value: '156',
    label: 'Schneider Electric',
  },
  {
    value: '1799',
    label: 'School of Inspired Leadership',
  },
  {
    value: '762',
    label: 'SC Johnson',
  },
  {
    value: '1543',
    label: 'SCMHRD',
  },
  {
    value: '2349',
    label: 'SCMLD',
  },
  {
    value: '326',
    label: 'Scope International',
  },
  {
    value: '2520',
    label: 'Scopely India',
  },
  {
    value: '2781',
    label: 'SDNA Global',
  },
  {
    value: '888',
    label: 'Sears Holdings',
  },
  {
    value: '2226',
    label: 'SEBI',
  },
  {
    value: '2768',
    label: 'Sebone Technologies',
  },
  {
    value: '313',
    label: 'self',
  },
  {
    value: '928',
    label: 'Self-employed',
  },
  {
    value: '113',
    label: 'Self Employed',
  },
  {
    value: '2482',
    label: 'SendinBlue',
  },
  {
    value: '3158',
    label: 'SENWELL EXPORTS PRIVATE LIMITED',
  },
  {
    value: '168',
    label: 'Serco',
  },
  {
    value: '3046',
    label: 'servicenow',
  },
  {
    value: '3145',
    label: 'ServiceNow Software Development India Private Ltd.',
  },
  {
    value: '2192',
    label: 'Servion Global Solutions',
  },
  {
    value: '717',
    label: 'SG Analytics',
  },
  {
    value: '3081',
    label: 'SGP - Analyst',
  },
  {
    value: '1487',
    label: 'SGS',
  },
  {
    value: '1596',
    label: 'SGS India Pvt Ltd',
  },
  {
    value: '2534',
    label: 'ShadowFax',
  },
  {
    value: '617',
    label: 'Shapoorji Pallonji',
  },
  {
    value: '3095',
    label: 'ShareChat',
  },
  {
    value: '336',
    label: 'Sharekhan',
  },
  {
    value: '726',
    label: 'Sharp Business System',
  },
  {
    value: '202',
    label: 'Shell',
  },
  {
    value: '2936',
    label: 'Shell India Markets Private Limited',
  },
  {
    value: '2151',
    label: 'Sherwin Williams Paints',
  },
  {
    value: '1932',
    label: 'Shipping Corporation of India',
  },
  {
    value: '3105',
    label: 'Shiprocket',
  },
  {
    value: '1614',
    label: 'ShopClues.com',
  },
  {
    value: '667',
    label: 'Shoppers Stop',
  },
  {
    value: '742',
    label: 'Shree Cement',
  },
  {
    value: '2076',
    label: 'Shree Renuka Sugars Limited',
  },
  {
    value: '180',
    label: 'Shriram Group',
  },
  {
    value: '1852',
    label: 'SHRM',
  },
  {
    value: '1829',
    label: 'SHRM India',
  },
  {
    value: '1248',
    label: 'SIDBI',
  },
  {
    value: '2642',
    label: 'Siddhivinayak Employment Services',
  },
  {
    value: '115',
    label: 'Siemens',
  },
  {
    value: '2861',
    label: 'Sierra Infosys',
  },
  {
    value: '364',
    label: 'Sify',
  },
  {
    value: '2952',
    label: 'Signify',
  },
  {
    value: '912',
    label: 'SIIB',
  },
  {
    value: '1276',
    label: 'Simplex Infrastructure',
  },
  {
    value: '904',
    label: 'Simplilearn',
  },
  {
    value: '1970',
    label: 'SIMS',
  },
  {
    value: '2609',
    label: 'SIM Solution Private Limited',
  },
  {
    value: '1608',
    label: 'Singhi Advisors',
  },
  {
    value: '2160',
    label: 'sipl',
  },
  {
    value: '2136',
    label: 'SITA',
  },
  {
    value: '789',
    label: 'Sitel',
  },
  {
    value: '1785',
    label: 'Siva Group',
  },
  {
    value: '1731',
    label: 'Siva Ventures Limited',
  },
  {
    value: '2087',
    label: 'SJ Seymour',
  },
  {
    value: '1768',
    label: 'SKF India Limited',
  },
  {
    value: '1259',
    label: 'SKF India Ltd',
  },
  {
    value: '2207',
    label: 'SKP Group',
  },
  {
    value: '170',
    label: 'SKS Microfinance',
  },
  {
    value: '2862',
    label: 'SK VedaInfo Universal Technologies',
  },
  {
    value: '2928',
    label: 'Sleepiz',
  },
  {
    value: '2030',
    label: 'SMALL INDUSTRIES DEVELOPMENT BANK OF INDIA',
  },
  {
    value: '2392',
    label: 'SMARTANALYST',
  },
  {
    value: '2720',
    label: 'Smart Joules',
  },
  {
    value: '2487',
    label: 'SmartOwner',
  },
  {
    value: '2722',
    label: 'Smartstream Technologies',
  },
  {
    value: '252',
    label: 'SMC',
  },
  {
    value: '1629',
    label: 'SME Rating Agency of India Limited',
  },
  {
    value: '1110',
    label: 'Smile Group',
  },
  {
    value: '2522',
    label: "Smith's Detection",
  },
  {
    value: '2143',
    label: 'SMJ Capital',
  },
  {
    value: '265',
    label: 'Snapdeal.com',
  },
  {
    value: '755',
    label: 'SNL Financial',
  },
  {
    value: '1008',
    label: 'Sobha Developers',
  },
  {
    value: '299',
    label: 'Societe Generale',
  },
  {
    value: '480',
    label: 'Sodexo',
  },
  {
    value: '926',
    label: 'Softcell',
  },
  {
    value: '1840',
    label: 'Sokrati',
  },
  {
    value: '2387',
    label: 'Solution digitas',
  },
  {
    value: '2233',
    label: 'Solutions Middle East',
  },
  {
    value: '3124',
    label: 'Somani Group',
  },
  {
    value: '420',
    label: 'Sonata Software',
  },
  {
    value: '294',
    label: 'Sony',
  },
  {
    value: '1849',
    label: 'SourceHov',
  },
  {
    value: '1286',
    label: 'South Indian Bank',
  },
  {
    value: '2388',
    label: 'SPA Merchant Bankers Ltd',
  },
  {
    value: '503',
    label: 'Spanco',
  },
  {
    value: '1978',
    label: 'Spandana Sphoorty Financial Limited',
  },
  {
    value: '2157',
    label: 'Spandana Sphoorty Financial Ltd',
  },
  {
    value: '2834',
    label: 'Spectraforce Technologies',
  },
  {
    value: '393',
    label: "Spencer's Retail",
  },
  {
    value: '2787',
    label: 'Spencer Stuart India',
  },
  {
    value: '297',
    label: 'Spice Group',
  },
  {
    value: '1523',
    label: 'SP Jain School of Global Management',
  },
  {
    value: '1513',
    label: 'SPJIMR',
  },
  {
    value: '2244',
    label: 'sportsnlife.com',
  },
  {
    value: '2987',
    label: 'Spotify',
  },
  {
    value: '2539',
    label: 'Spotlight',
  },
  {
    value: '2886',
    label: 'Squadrun Solutions',
  },
  {
    value: '165',
    label: 'SREI',
  },
  {
    value: '2184',
    label: 'SRF Limited',
  },
  {
    value: '2619',
    label: 'Sri Laxmi Ganapathy Trading Private Limited',
  },
  {
    value: '1983',
    label: 'SRM University',
  },
  {
    value: '529',
    label: 'SS&C GlobeOp',
  },
  {
    value: '3001',
    label: 'Staff Ship Services and IT Solutions',
  },
  {
    value: '1295',
    label: "Standard & Poor's",
  },
  {
    value: '31',
    label: 'Standard Chartered Bank',
  },
  {
    value: '1168',
    label: 'Stanley Black & Decker',
  },
  {
    value: '3133',
    label: 'Stanza Living',
  },
  {
    value: '2894',
    label: 'Starbucks',
  },
  {
    value: '864',
    label: 'STAR CJ',
  },
  {
    value: '925',
    label: 'Starcom',
  },
  {
    value: '267',
    label: 'Star India Pvt Ltd',
  },
  {
    value: '2736',
    label: 'Star Lead Services',
  },
  {
    value: '2102',
    label: 'star news',
  },
  {
    value: '677',
    label: 'Star Union Dai-ichi Life Insurance',
  },
  {
    value: '696',
    label: 'State Bank of Hyderabad',
  },
  {
    value: '24',
    label: 'State Bank of India',
  },
  {
    value: '1643',
    label: 'State Street Global Advisors',
  },
  {
    value: '1604',
    label: 'STCI',
  },
  {
    value: '1652',
    label: 'S Tel Private Limited',
  },
  {
    value: '169',
    label: 'Steria',
  },
  {
    value: '2243',
    label: 'ST Ericsson',
  },
  {
    value: '248',
    label: 'Sterlite',
  },
  {
    value: '2710',
    label: 'Stic Travels',
  },
  {
    value: '1949',
    label: 'STOCK HOLDING CORPORATION OF INDIA LTD',
  },
  {
    value: '1263',
    label: 'Strategic Decisions Group',
  },
  {
    value: '686',
    label: 'Stryker',
  },
  {
    value: '124',
    label: 'Student',
  },
  {
    value: '1660',
    label: 'Su-Kam Power',
  },
  {
    value: '1654',
    label: 'Subex',
  },
  {
    value: '1332',
    label: 'Subex Limited',
  },
  {
    value: '2381',
    label: 'Subros Ltd.',
  },
  {
    value: '2680',
    label: 'Suchirindia Developers',
  },
  {
    value: '2365',
    label: 'Suguna Foods',
  },
  {
    value: '679',
    label: 'Sulekha.com',
  },
  {
    value: '2664',
    label: 'Sulekha.com New Media Private Limited',
  },
  {
    value: '1769',
    label: 'Sumedha Fiscal Services Ltd',
  },
  {
    value: '2850',
    label: 'Sumeru Global Technologies',
  },
  {
    value: '1561',
    label: 'Sumitomo Mitsui Banking Corporation',
  },
  {
    value: '2590',
    label: 'Sun Chemical',
  },
  {
    value: '2236',
    label: 'sundaram finance limited',
  },
  {
    value: '1895',
    label: 'Sundaram Finance LTD',
  },
  {
    value: '2758',
    label: 'Sundaravijayam Automobile Services',
  },
  {
    value: '2413',
    label: 'SunEdison',
  },
  {
    value: '484',
    label: 'SunGard Availability Services',
  },
  {
    value: '2178',
    label: 'Sunidhi Securities',
  },
  {
    value: '1759',
    label: 'Sun Life Financial',
  },
  {
    value: '1402',
    label: 'SunLife Financial',
  },
  {
    value: '2653',
    label: 'Sunselect',
  },
  {
    value: '724',
    label: 'Suntec Business Solutions',
  },
  {
    value: '251',
    label: 'Supermax',
  },
  {
    value: '1638',
    label: 'Supertech Limited',
  },
  {
    value: '1866',
    label: 'Surya Pharmaceutical Limited',
  },
  {
    value: '1950',
    label: 'Surya Roshni Limited',
  },
  {
    value: '1853',
    label: 'Sutherland',
  },
  {
    value: '223',
    label: 'Sutherland Global Services',
  },
  {
    value: '828',
    label: 'Suvidhaa Infoserve',
  },
  {
    value: '174',
    label: 'Suzlon',
  },
  {
    value: '1546',
    label: 'Suzuki Motorcycle',
  },
  {
    value: '2673',
    label: 'Swastika Investmart',
  },
  {
    value: '2408',
    label: 'Swiggy',
  },
  {
    value: '3165',
    label: 'SWISS GARNIER GENEXIAA SCIENCES PRIVATE LIMITED',
  },
  {
    value: '859',
    label: 'Swiss Re',
  },
  {
    value: '806',
    label: 'Symantec',
  },
  {
    value: '2254',
    label: 'SYMBIOSIS INSTITUTE OF INTERNATIONAL BUSINESS',
  },
  {
    value: '2533',
    label: 'Symphony HR',
  },
  {
    value: '953',
    label: 'Symphony Services',
  },
  {
    value: '593',
    label: 'Symphony Teleca',
  },
  {
    value: '972',
    label: 'Syncapse',
  },
  {
    value: '2462',
    label: 'synchrony',
  },
  {
    value: '2937',
    label: 'Synchrony International Services Private Limited',
  },
  {
    value: '2033',
    label: 'SYNDICATE BANK',
  },
  {
    value: '1998',
    label: 'Synechron',
  },
  {
    value: '1865',
    label: 'Synechron Technologies',
  },
  {
    value: '1680',
    label: 'Synergy Consulting Inc.',
  },
  {
    value: '3131',
    label: 'Syngene International Limited',
  },
  {
    value: '2554',
    label: 'Syngenta',
  },
  {
    value: '2239',
    label: 'Syngenta India Limited',
  },
  {
    value: '102',
    label: 'Syntel',
  },
  {
    value: '2318',
    label: 'synygy',
  },
  {
    value: '2245',
    label: 'systematix Shares & stocks',
  },
  {
    value: '1751',
    label: 'Systematix Shares & stocks (I) Ltd',
  },
  {
    value: '3050',
    label: 'TA Digital (TechAspect Solutions Pvt Ltd)',
  },
  {
    value: '3096',
    label: 'Taggd',
  },
  {
    value: '379',
    label: 'TAJ GROUP',
  },
  {
    value: '2164',
    label: 'TAKE SOLUTIONS',
  },
  {
    value: '1948',
    label: 'Takshashila Consulting',
  },
  {
    value: '2933',
    label: 'Talent Corner HR Servicses Pvt Ltd',
  },
  {
    value: '2733',
    label: 'Talents Creed Solutions',
  },
  {
    value: '2320',
    label: 'Talisma Corporation',
  },
  {
    value: '2549',
    label: 'Tally',
  },
  {
    value: '314',
    label: 'Tally Solutions',
  },
  {
    value: '2450',
    label: 'Tapzo',
  },
  {
    value: '221',
    label: 'Target Corporation',
  },
  {
    value: '1234',
    label: 'Tata Administrative Services',
  },
  {
    value: '1166',
    label: 'Tata Advanced Systems',
  },
  {
    value: '84',
    label: 'Tata AIA',
  },
  {
    value: '595',
    label: 'Tata Autocomp Systems',
  },
  {
    value: '735',
    label: 'Tata Business Support Service',
  },
  {
    value: '122',
    label: 'Tata Capital',
  },
  {
    value: '663',
    label: 'Tata Chemicals',
  },
  {
    value: '95',
    label: 'Tata Communications',
  },
  {
    value: '1321',
    label: 'Tata Consultancy Services',
  },
  {
    value: '2999',
    label: 'Tata Consumer Products',
  },
  {
    value: '2995',
    label: 'Tata Consumer Products Limited',
  },
  {
    value: '2996',
    label: ' Tata Consumer Products Limited',
  },
  {
    value: '60',
    label: 'Tata Group',
  },
  {
    value: '620',
    label: 'Tata Interactive Systems',
  },
  {
    value: '938',
    label: 'Tata International Ltd',
  },
  {
    value: '38',
    label: 'Tata Motors',
  },
  {
    value: '422',
    label: 'Tata Power',
  },
  {
    value: '97',
    label: 'Tata Steel',
  },
  {
    value: '3071',
    label: 'TATA STEEL LIMITED',
  },
  {
    value: '628',
    label: 'Tata Strategic Management Group',
  },
  {
    value: '407',
    label: 'Tata Technologies',
  },
  {
    value: '23',
    label: 'Tata Teleservices',
  },
  {
    value: '1774',
    label: 'Taurus Mutual Fund',
  },
  {
    value: '2795',
    label: 'Taurus Powertronics',
  },
  {
    value: '4',
    label: 'TCS',
  },
  {
    value: '1192',
    label: 'Teach For India',
  },
  {
    value: '460',
    label: 'TeamLease',
  },
  {
    value: '2719',
    label: 'TeamRoll INC',
  },
  {
    value: '2607',
    label: 'TechBulls SoftTech Pvt Ltd',
  },
  {
    value: '2578',
    label: 'Tech Connect',
  },
  {
    value: '51',
    label: 'Tech Mahindra',
  },
  {
    value: '2993',
    label: 'Techmango Technology Services Private Limited',
  },
  {
    value: '2659',
    label: 'TECH MANTRAMINDS INDIA PRIVATE LIMITED',
  },
  {
    value: '2379',
    label: 'Technip',
  },
  {
    value: '319',
    label: 'Technopak Advisors',
  },
  {
    value: '2368',
    label: 'Techprocess Solutions Ltd',
  },
  {
    value: '2682',
    label: 'TechRAQ Info solutions Pvt Ltd',
  },
  {
    value: '2649',
    label: 'Tecknack Technologies',
  },
  {
    value: '527',
    label: 'Tecnova',
  },
  {
    value: '2062',
    label: 'TE Connectivity',
  },
  {
    value: '1552',
    label: 'Tecpro Systems Limited',
  },
  {
    value: '2103',
    label: 'Tecpro Systems Ltd',
  },
  {
    value: '2285',
    label: 'Tejas Networks',
  },
  {
    value: '2648',
    label: 'Tekwissen Software',
  },
  {
    value: '2097',
    label: 'Telco Construction Equipment Co. Ltd.',
  },
  {
    value: '550',
    label: 'Telecom',
  },
  {
    value: '1707',
    label: 'Telenor',
  },
  {
    value: '1822',
    label: 'Teleperformance',
  },
  {
    value: '1780',
    label: 'Temenos',
  },
  {
    value: '903',
    label: 'Temenos India',
  },
  {
    value: '2003',
    label: 'TERI University',
  },
  {
    value: '117',
    label: 'Tesco',
  },
  {
    value: '1458',
    label: 'test',
  },
  {
    value: '2882',
    label: 'test-1',
  },
  {
    value: '2985',
    label: 'test-2',
  },
  {
    value: '2321',
    label: 'testing',
  },
  {
    value: '1454',
    label: 'Tetra Pak',
  },
  {
    value: '1618',
    label: 'Texas Instruments',
  },
  {
    value: '1899',
    label: 'The Akshaya Patra Foundation',
  },
  {
    value: '1716',
    label: 'The Alchemists Ark Pvt. Ltd.',
  },
  {
    value: '2357',
    label: 'The Alchemists Ark Pvt Ltd',
  },
  {
    value: '2210',
    label: 'The Bank of New York Mellon',
  },
  {
    value: '1320',
    label: 'The Bombay Dyeing & Mfg Co Ltd',
  },
  {
    value: '499',
    label: 'The Boston Consulting Group',
  },
  {
    value: '2636',
    label: 'The Career Coach',
  },
  {
    value: '219',
    label: 'The Coca-Cola Company',
  },
  {
    value: '710',
    label: 'The Federal Bank',
  },
  {
    value: '2025',
    label: 'The Hackett Group',
  },
  {
    value: '1532',
    label: 'The Himalaya Drug Company',
  },
  {
    value: '2121',
    label: 'The Institute Of Chartered Accountants Of India',
  },
  {
    value: '1930',
    label: 'The Manipal group',
  },
  {
    value: '2922',
    label: 'The Math Company',
  },
  {
    value: '682',
    label: 'The Mobile Store',
  },
  {
    value: '2638',
    label: 'The New Horizon',
  },
  {
    value: '301',
    label: 'The Nielsen Company',
  },
  {
    value: '1816',
    label: 'The Park Hotels',
  },
  {
    value: '814',
    label: 'Thermax',
  },
  {
    value: '2300',
    label: 'The Shipping Corporation of India Ltd.',
  },
  {
    value: '234',
    label: 'The Smart Cube',
  },
  {
    value: '2274',
    label: 'The South Indian Bank Ltd',
  },
  {
    value: '1623',
    label: 'The South Indian Bank Ltd.',
  },
  {
    value: '846',
    label: 'The World Bank',
  },
  {
    value: '1887',
    label: 'ThinkLink Supply Chain Services',
  },
  {
    value: '367',
    label: 'Thomas Cook',
  },
  {
    value: '62',
    label: 'Thomson-Reuters',
  },
  {
    value: '1056',
    label: 'ThoughtWorks',
  },
  {
    value: '2339',
    label: 'Thyrocare',
  },
  {
    value: '2348',
    label: 'ThyssenKrupp System Engineering',
  },
  {
    value: '3159',
    label: 'TIAA GLOBAL CAPABILITIES PRIVATE LIMITED',
  },
  {
    value: '2005',
    label: 'TI Cycles of India',
  },
  {
    value: '2984',
    label: 'Tiger Analytics',
  },
  {
    value: '3079',
    label: 'TIGER ANALYTICS INDIA CONSULTING PRIVATE LIMITED',
  },
  {
    value: '2153',
    label: 'Tikona Digital Networks',
  },
  {
    value: '2168',
    label: 'Tilaknagar Industries',
  },
  {
    value: '2222',
    label: 'TIL Limited',
  },
  {
    value: '583',
    label: 'TIME',
  },
  {
    value: '32',
    label: 'Times Group',
  },
  {
    value: '1216',
    label: 'Timex Group',
  },
  {
    value: '192',
    label: 'Titan Company Limited',
  },
  {
    value: '2951',
    label: 'TLG INDIA PRIVATE LIMITED',
  },
  {
    value: '2536',
    label: 'TMP',
  },
  {
    value: '262',
    label: 'TNS',
  },
  {
    value: '780',
    label: 'TNT',
  },
  {
    value: '2879',
    label: 'TomTom',
  },
  {
    value: '2503',
    label: 'ToneTag',
  },
  {
    value: '2583',
    label: 'Toppr',
  },
  {
    value: '387',
    label: 'Torrent Group',
  },
  {
    value: '2175',
    label: 'Torry Harris Business Solutions',
  },
  {
    value: '2299',
    label: 'Torus Business Solutions Pvt Ltd',
  },
  {
    value: '1931',
    label: 'Torus Insurance',
  },
  {
    value: '924',
    label: 'Toshiba',
  },
  {
    value: '597',
    label: 'Towers Watson',
  },
  {
    value: '715',
    label: 'Toyota',
  },
  {
    value: '2430',
    label: 'Tracxn',
  },
  {
    value: '2334',
    label: 'tradeindia.com',
  },
  {
    value: '1723',
    label: 'Trafigura',
  },
  {
    value: '901',
    label: 'TransGraph Consulting',
  },
  {
    value: '325',
    label: 'Transparent Value',
  },
  {
    value: '797',
    label: 'Transport Corporation of India',
  },
  {
    value: '1842',
    label: 'TransUnion',
  },
  {
    value: '2916',
    label: 'TranZact',
  },
  {
    value: '2504',
    label: 'Tredence',
  },
  {
    value: '2593',
    label: 'Treebo',
  },
  {
    value: '1121',
    label: 'Trefis',
  },
  {
    value: '3087',
    label: 'Trendlyne',
  },
  {
    value: '842',
    label: 'TresVista Financial Services',
  },
  {
    value: '1750',
    label: 'TRF',
  },
  {
    value: '1077',
    label: 'Trianz',
  },
  {
    value: '296',
    label: 'Trident Limited',
  },
  {
    value: '2208',
    label: 'Trimax IT Infrastructure & Services Ltd',
  },
  {
    value: '2376',
    label: 'Trimax IT Infrastructure & Services Ltd.',
  },
  {
    value: '439',
    label: 'Triton Group',
  },
  {
    value: '2305',
    label: 'TRPC',
  },
  {
    value: '2507',
    label: 'Truebil',
  },
  {
    value: '2786',
    label: 'Trustline Securities',
  },
  {
    value: '2666',
    label: 'Truweight',
  },
  {
    value: '2077',
    label: 'Tube Investments of India',
  },
  {
    value: '287',
    label: 'Tulip Telecom',
  },
  {
    value: '1117',
    label: 'Tupperware',
  },
  {
    value: '977',
    label: 'Turner India',
  },
  {
    value: '2846',
    label: 'Turvo India Private Limited',
  },
  {
    value: '1012',
    label: 'TVC Sky Shop',
  },
  {
    value: '144',
    label: 'TVS',
  },
  {
    value: '2974',
    label: 'TVS MOTOR COMPANY LTD',
  },
  {
    value: '1656',
    label: 'Twinings',
  },
  {
    value: '944',
    label: 'Tyco',
  },
  {
    value: '2925',
    label: 'Tyler Petroleum Inc',
  },
  {
    value: '1756',
    label: 'U2opia Mobile',
  },
  {
    value: '2485',
    label: 'Uber',
  },
  {
    value: '1038',
    label: 'UB Group',
  },
  {
    value: '143',
    label: 'UBS',
  },
  {
    value: '526',
    label: 'UCO Bank',
  },
  {
    value: '2464',
    label: 'Udaan',
  },
  {
    value: '968',
    label: 'Uflex',
  },
  {
    value: '3114',
    label: 'UFO Moviez India Ltd',
  },
  {
    value: '2258',
    label: 'Ugam Solutions',
  },
  {
    value: '2295',
    label: 'UHG',
  },
  {
    value: '2324',
    label: 'ujjivan financial services pvt Ltd',
  },
  {
    value: '3019',
    label: 'UL India',
  },
  {
    value: '3011',
    label: 'UL India Private Limited',
  },
  {
    value: '371',
    label: 'UltraTech Cement Limited',
  },
  {
    value: '2871',
    label: 'Unacademy',
  },
  {
    value: '571',
    label: 'Unemployed',
  },
  {
    value: '429',
    label: 'Unicon',
  },
  {
    value: '1448',
    label: 'Unifi Capital',
  },
  {
    value: '57',
    label: 'Unilever',
  },
  {
    value: '163',
    label: 'Uninor',
  },
  {
    value: '210',
    label: 'Union Bank of India',
  },
  {
    value: '3014',
    label: 'Unirac Solar India LLP',
  },
  {
    value: '282',
    label: 'Unisys',
  },
  {
    value: '852',
    label: 'Unitech',
  },
  {
    value: '400',
    label: 'United Breweries',
  },
  {
    value: '3115',
    label: 'UNITED BREWERIES LIMITED',
  },
  {
    value: '289',
    label: 'United Health Group',
  },
  {
    value: '890',
    label: 'UnitedLex',
  },
  {
    value: '132',
    label: 'United Spirits Limited',
  },
  {
    value: '2903',
    label: 'United States Pharmacopeia',
  },
  {
    value: '1373',
    label: 'United Technologies Corporation',
  },
  {
    value: '1030',
    label: 'Universal Consulting',
  },
  {
    value: '2223',
    label: 'universal sompo general insurance',
  },
  {
    value: '2169',
    label: 'Universal Success Enterprises',
  },
  {
    value: '1467',
    label: 'University',
  },
  {
    value: '2893',
    label: 'Uno Minda',
  },
  {
    value: '2475',
    label: 'updazz.com',
  },
  {
    value: '2268',
    label: 'UPES',
  },
  {
    value: '2582',
    label: 'Upgrad',
  },
  {
    value: '1550',
    label: 'Urbantouch.com',
  },
  {
    value: '360',
    label: 'USHA International',
  },
  {
    value: '1642',
    label: 'US MNC',
  },
  {
    value: '493',
    label: 'UST Global',
  },
  {
    value: '2362',
    label: 'USV Limited',
  },
  {
    value: '504',
    label: 'UTI',
  },
  {
    value: '1113',
    label: 'Utsav Fashion',
  },
  {
    value: '2829',
    label: 'Utthunga Technologies',
  },
  {
    value: '1120',
    label: 'UTU',
  },
  {
    value: '1810',
    label: 'UT Worldwide Inc',
  },
  {
    value: '3167',
    label: 'V-Guard Industries Ltd',
  },
  {
    value: '2661',
    label: 'V-Guard Industries Ltd.',
  },
  {
    value: '2211',
    label: 'V2 Solutions',
  },
  {
    value: '2791',
    label: 'V4 Info',
  },
  {
    value: '2596',
    label: 'Vagaro Technologies Private Limited',
  },
  {
    value: '1844',
    label: 'Validor Capital',
  },
  {
    value: '2088',
    label: 'Value and Budget Housing Corporation Pvt Ltd',
  },
  {
    value: '867',
    label: 'ValueFirst',
  },
  {
    value: '1648',
    label: 'Valuelabs',
  },
  {
    value: '2971',
    label: 'Value Momentum Software Services Pvt. Ltd.',
  },
  {
    value: '2669',
    label: 'Valueonshore Advisory Services',
  },
  {
    value: '967',
    label: 'Valvoline',
  },
  {
    value: '1541',
    label: 'Valyoo Technologies',
  },
  {
    value: '2926',
    label: 'Vamstar',
  },
  {
    value: '2627',
    label: 'VANDERLANDE INDUSTRIES PRIVATE LIMITED',
  },
  {
    value: '2280',
    label: 'Vardhman Group',
  },
  {
    value: '2695',
    label: 'Varsity Education Management',
  },
  {
    value: '2115',
    label: 'Vatika Group',
  },
  {
    value: '2289',
    label: 'Vayam Technologies Limited',
  },
  {
    value: '1389',
    label: 'vCustomer',
  },
  {
    value: '92',
    label: 'Vedanta Resources',
  },
  {
    value: '3164',
    label: 'Vellore Institute of Technology',
  },
  {
    value: '2681',
    label: 'Velocix Solutions India LLP',
  },
  {
    value: '2575',
    label: 'Verisk',
  },
  {
    value: '2641',
    label: 'Veritis Solutions',
  },
  {
    value: '286',
    label: 'Verity Knowledge Solutions',
  },
  {
    value: '431',
    label: 'Verizon',
  },
  {
    value: '699',
    label: 'Vertex',
  },
  {
    value: '1985',
    label: 'VertX Solutions',
  },
  {
    value: '2946',
    label: 'Vestas',
  },
  {
    value: '857',
    label: 'VFS',
  },
  {
    value: '3127',
    label: 'V Guard',
  },
  {
    value: '1605',
    label: 'Via.com',
  },
  {
    value: '801',
    label: 'Viacom',
  },
  {
    value: '2857',
    label: 'Victory Ceratech',
  },
  {
    value: '58',
    label: 'Videocon',
  },
  {
    value: '2632',
    label: 'VIGGO MEDICAL DEVICES INDIA PRIVATE LIMITED',
  },
  {
    value: '1327',
    label: 'Vijaya Bank',
  },
  {
    value: '2822',
    label: "Vinayaka Mission's Research Foundation",
  },
  {
    value: '1687',
    label: 'Violet Arch',
  },
  {
    value: '1595',
    label: 'Violet Arch Capital Advisors',
  },
  {
    value: '2270',
    label: 'Violet Arch Securities',
  },
  {
    value: '384',
    label: 'Viom Networks',
  },
  {
    value: '479',
    label: 'VIP Industries',
  },
  {
    value: '1064',
    label: 'Virgin',
  },
  {
    value: '2949',
    label: 'Virtusa',
  },
  {
    value: '425',
    label: 'Virtusa Consulting',
  },
  {
    value: '1506',
    label: 'VISA',
  },
  {
    value: '1524',
    label: 'Vishal Retail',
  },
  {
    value: '1184',
    label: 'Vistaar Finance',
  },
  {
    value: '2434',
    label: 'Vistaprint',
  },
  {
    value: '690',
    label: 'Vistasoft',
  },
  {
    value: '1349',
    label: 'Visteon',
  },
  {
    value: '2407',
    label: 'Viteos',
  },
  {
    value: '2014',
    label: 'Vizury Interactive',
  },
  {
    value: '822',
    label: 'VLCC',
  },
  {
    value: '3111',
    label: 'VMock',
  },
  {
    value: '975',
    label: 'Vmware',
  },
  {
    value: '27',
    label: 'Vodafone',
  },
  {
    value: '2523',
    label: 'Vodafone Idea',
  },
  {
    value: '566',
    label: 'Volkswagen',
  },
  {
    value: '540',
    label: 'Voltas',
  },
  {
    value: '395',
    label: 'Volvo Eicher',
  },
  {
    value: '1214',
    label: 'VRS Foods',
  },
  {
    value: '2767',
    label: 'VRX SPORTS PRIVATE LIMITED',
  },
  {
    value: '2854',
    label: 'VSV WINS',
  },
  {
    value: '2959',
    label: 'Vuram',
  },
  {
    value: '1647',
    label: 'Wadia Group',
  },
  {
    value: '1670',
    label: 'Walchandnagar Industries limited',
  },
  {
    value: '2643',
    label: 'Wallero Technologies',
  },
  {
    value: '632',
    label: 'Walmart',
  },
  {
    value: '2764',
    label: 'Walsh Patel Group (WPG) Technologies',
  },
  {
    value: '1251',
    label: 'Walt Dinsey',
  },
  {
    value: '1805',
    label: 'Walt Disney',
  },
  {
    value: '2140',
    label: 'WaterHealth India Pvt Ltd',
  },
  {
    value: '2047',
    label: 'Way2Wealth',
  },
  {
    value: '2366',
    label: 'WAY2WEALTH BROKERS PVT LTD',
  },
  {
    value: '1637',
    label: 'Welingkar',
  },
  {
    value: '2179',
    label: 'Welingkar Institute',
  },
  {
    value: '590',
    label: 'Wells Fargo',
  },
  {
    value: '149',
    label: 'Welspun',
  },
  {
    value: '795',
    label: 'WeP',
  },
  {
    value: '1165',
    label: 'Western Union',
  },
  {
    value: '2543',
    label: 'WeWork',
  },
  {
    value: '2917',
    label: 'wfglobal.org',
  },
  {
    value: '3113',
    label: 'Wheelseye Technology India Private Limited',
  },
  {
    value: '1758',
    label: 'Wheels India Ltd',
  },
  {
    value: '271',
    label: 'Whirlpool',
  },
  {
    value: '3103',
    label: 'White Panda',
  },
  {
    value: '1392',
    label: 'Williams Lea',
  },
  {
    value: '1553',
    label: 'WILLIS',
  },
  {
    value: '2794',
    label: 'Winezee',
  },
  {
    value: '3025',
    label: 'Winfo Solutions',
  },
  {
    value: '2107',
    label: 'Winshuttle',
  },
  {
    value: '5',
    label: 'Wipro',
  },
  {
    value: '368',
    label: 'Wipro Consumer Care & Lighting',
  },
  {
    value: '3098',
    label: 'WISHUP TECHNOLOGY PRIVATE LIMITED',
  },
  {
    value: '3017',
    label: 'Wissen ',
  },
  {
    value: '3010',
    label: 'Wissen Infotech Pvt. Ltd.',
  },
  {
    value: '2919',
    label: 'Wission',
  },
  {
    value: '3018',
    label: 'wisson',
  },
  {
    value: '829',
    label: 'Wizcraft',
  },
  {
    value: '2723',
    label: 'Wiz Digital Services',
  },
  {
    value: '2939',
    label: 'WM Global Technology Services India Pvt.Ltd Limite',
  },
  {
    value: '54',
    label: 'WNS',
  },
  {
    value: '3128',
    label: 'Wobot AI',
  },
  {
    value: '530',
    label: 'Wockhardt',
  },
  {
    value: '2570',
    label: 'Wooqer',
  },
  {
    value: '1832',
    label: 'World Bank',
  },
  {
    value: '1923',
    label: 'World Gold Council',
  },
  {
    value: '1786',
    label: 'Worlds Window Group',
  },
  {
    value: '3173',
    label: 'WOW Skin Science',
  },
  {
    value: '2615',
    label: 'WPP MARKETING COMMUNICATIONS INDIA PRIVATE LIMITED',
  },
  {
    value: '798',
    label: 'Wrigley',
  },
  {
    value: '2437',
    label: 'wsp',
  },
  {
    value: '877',
    label: 'Wunderman',
  },
  {
    value: '2603',
    label: 'XAL TOOL INDIA PVT. LTD',
  },
  {
    value: '2346',
    label: 'Xavient Information Systems',
  },
  {
    value: '369',
    label: 'Xchanging',
  },
  {
    value: '1841',
    label: 'Xebia',
  },
  {
    value: '2775',
    label: 'XEL IT Services',
  },
  {
    value: '509',
    label: 'Xerox',
  },
  {
    value: '2465',
    label: 'Xiaomi',
  },
  {
    value: '1821',
    label: 'XIMB',
  },
  {
    value: '2423',
    label: 'XL Catlin',
  },
  {
    value: '1625',
    label: 'XL DYNAMICS',
  },
  {
    value: '1388',
    label: 'XL India',
  },
  {
    value: '1013',
    label: 'XLRI',
  },
  {
    value: '2477',
    label: 'Xoriant',
  },
  {
    value: '3116',
    label: 'XPO India',
  },
  {
    value: '2789',
    label: 'XS CAD India',
  },
  {
    value: '2417',
    label: 'XSeed',
  },
  {
    value: '800',
    label: 'Y2CF',
  },
  {
    value: '370',
    label: 'Yahoo',
  },
  {
    value: '1808',
    label: 'Yakult Danone',
  },
  {
    value: '1588',
    label: 'Yamaha Motor',
  },
  {
    value: '1323',
    label: 'YASH Technologies',
  },
  {
    value: '622',
    label: 'Yatra.com',
  },
  {
    value: '611',
    label: 'Yebhi.com',
  },
  {
    value: '1943',
    label: 'Yepme.com',
  },
  {
    value: '29',
    label: 'YES Bank',
  },
  {
    value: '2230',
    label: 'YKK',
  },
  {
    value: '1093',
    label: 'Yodlee',
  },
  {
    value: '2657',
    label: 'Yug Online Services',
  },
  {
    value: '2544',
    label: 'YULU',
  },
  {
    value: '871',
    label: 'Yum! Brands',
  },
  {
    value: '456',
    label: 'Yum Brands',
  },
  {
    value: '794',
    label: 'Zacks Investment Research',
  },
  {
    value: '1549',
    label: 'Zamil Infra',
  },
  {
    value: '230',
    label: 'Zee',
  },
  {
    value: '820',
    label: 'Zenith',
  },
  {
    value: '363',
    label: 'Zensar Technologies',
  },
  {
    value: '2717',
    label: 'Zeppelin Systems',
  },
  {
    value: '3047',
    label: 'zepto',
  },
  {
    value: '2856',
    label: 'Zerofox India',
  },
  {
    value: '2456',
    label: 'zestmoney',
  },
  {
    value: '2934',
    label: 'Zeta Global',
  },
  {
    value: '782',
    label: 'Zinnov',
  },
  {
    value: '2431',
    label: 'zivame',
  },
  {
    value: '1743',
    label: 'Zomato',
  },
  {
    value: '2567',
    label: 'Zoomcar',
  },
  {
    value: '2415',
    label: 'ZoomRx',
  },
  {
    value: '1473',
    label: 'Zovi.com',
  },
  {
    value: '123',
    label: 'ZS',
  },
  {
    value: '490',
    label: 'ZTE',
  },
  {
    value: '537',
    label: 'Zycus',
  },
  {
    value: '612',
    label: 'Zydus',
  },
  {
    value: '942',
    label: 'Zylog',
  },
  {
    value: '2375',
    label: 'Zyme Solutions',
  },
  {
    value: '1971',
    label: 'Zynga',
  },
  {
    value: '1928',
    label: '[24]7.ai',
  },
  {
    value: '2546',
    label: '#Covid19',
  },
  {
    value: '2562',
    label: '#Diversity',
  },
  {
    value: '2892',
    label: '#Pride',
  },
];
